webpackJsonp([4],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(602)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(573),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cc0229ac",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\HeaderComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HeaderComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cc0229ac", Component.options)
  } else {
    hotAPI.reload("data-v-cc0229ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(594)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(496),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\FooterComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FooterComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ec4fedc", Component.options)
  } else {
    hotAPI.reload("data-v-2ec4fedc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(476),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\PageLoader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PageLoader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-097d9790", Component.options)
  } else {
    hotAPI.reload("data-v-097d9790", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(533),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\LoadingComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoadingComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-63b63452", Component.options)
  } else {
    hotAPI.reload("data-v-63b63452", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.af71cfd.gif";

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(554),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\HelpForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9cb56b4a", Component.options)
  } else {
    hotAPI.reload("data-v-9cb56b4a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_11_0.275dca7.eot";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_6_0.bf7b7ce.eot";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_F_0.5de86e3.eot";

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(601)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\JotformModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JotformModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b61c92e0", Component.options)
  } else {
    hotAPI.reload("data-v-b61c92e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(557),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Demo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Demo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a1b8271c", Component.options)
  } else {
    hotAPI.reload("data-v-a1b8271c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\JotformEmbed.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JotformEmbed.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60bbd688", Component.options)
  } else {
    hotAPI.reload("data-v-60bbd688", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(509),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\HelpInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42a8abd4", Component.options)
  } else {
    hotAPI.reload("data-v-42a8abd4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAoCAYAAACIC2hQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAHpSURBVHja1NnNTsJAEAfw2XHbRD4sAcSoQbkYL8bEl/DIk/hEPoY3fQNPRsNFbwaDIbEIgk2gC+uBhEBLy0JnSuxxu01+2cx2558VWmv4D48EADi/qoPKl7py0HFUrtiTfbewLdCoePSmssWbTLPx8Pp0NxtHAIBh+eRR9l0HtAbZdx2VcbxtILW0JnandZZpNu696sX1/DsEABhnC/WFZfZ6u2ljtbQmQvliZhi4tyFo5v2l7RcOWtvCBpFaWtr+/qyFoAAAVrd9vA3sMqRQPgbnLQykjTVFhqCx2GzBo0Xaxsil0Ejsb5cMO0WOjJGRUE5sGGmvRMZCY7Eb1uy0JoPIEZp8u3IS1QYLbxxzpBGUArt8d5sjjaFJsOv8gkigm2CpkGtD18FSIjeCmmCpkRtD47AcyETQKCwHMjE0CkuNJIFOm9zOYXBMKF9Qdl2JocGa5GoRkRKppaW5+lmkRArlI1fzjZRIzqSA1EguLHIgObDIhaTOYGiGtBMdixSxBs2Qo8THYlIscgQxjgyGHEGMIykgRxDjwCJHEOPAImd8oMTOEHonXeRKbL7UDUF9p9IW4/SRsdhBxwlBrZ+vytzKpoqMwqpcsbdsRT9AIPh7+64Yp4+cx3qnl7VhufocvPAQ/+X65m8AQQQ3OQ8D9ZYAAAAASUVORK5CYII="

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_11_0.72eda73.ttf";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_11_0.122240d.woff";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_11_0.1310e7b.woff2";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_6_0.a23eb0f.ttf";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_6_0.89e793e.woff";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_6_0.5f05456.woff2";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_F_0.4e29d00.ttf";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_F_0.c91c700.woff";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/342F4F_F_0.98d1b7e.woff2";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(527),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\CovidRelief.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CovidRelief.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c78d360", Component.options)
  } else {
    hotAPI.reload("data-v-5c78d360", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(577),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\home\\listData\\ResetPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResetPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dfa88842", Component.options)
  } else {
    hotAPI.reload("data-v-dfa88842", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\AnnualForcasting.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AnnualForcasting.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-388f7ba8", Component.options)
  } else {
    hotAPI.reload("data-v-388f7ba8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(522),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Help.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Help.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d01ded0", Component.options)
  } else {
    hotAPI.reload("data-v-4d01ded0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\ParticipantAccountInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ParticipantAccountInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-739a27fc", Component.options)
  } else {
    hotAPI.reload("data-v-739a27fc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(597)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\RxInput.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RxInput.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42db20d4", Component.options)
  } else {
    hotAPI.reload("data-v-42db20d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(538),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Resource.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Resource.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c3e119d", Component.options)
  } else {
    hotAPI.reload("data-v-6c3e119d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(502),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\frameComponents\\FrameShippingBilling.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameShippingBilling.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-39df4564", Component.options)
  } else {
    hotAPI.reload("data-v-39df4564", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(591)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0279f276",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\UserAccount.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserAccount.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0279f276", Component.options)
  } else {
    hotAPI.reload("data-v-0279f276", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(547),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\registration\\Activation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Activation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-795b65f8", Component.options)
  } else {
    hotAPI.reload("data-v-795b65f8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\registration\\Pledge.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Pledge.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ec2ba3ca", Component.options)
  } else {
    hotAPI.reload("data-v-ec2ba3ca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(568),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\registration\\Registration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Registration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c2a7ccca", Component.options)
  } else {
    hotAPI.reload("data-v-c2a7ccca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(600)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a68a028a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\registration\\RegistrationSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RegistrationSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a68a028a", Component.options)
  } else {
    hotAPI.reload("data-v-a68a028a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(479),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\PromptComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PromptComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b62ec9a", Component.options)
  } else {
    hotAPI.reload("data-v-0b62ec9a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(556),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\ServicePayment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ServicePayment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a0f48872", Component.options)
  } else {
    hotAPI.reload("data-v-a0f48872", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            elementConfig: {
                inviteColleagueShow: window.elemement_Config.inviteColleagueShow,
                frameResourceShow: window.elemement_Config.frameResourceShow,
                orderTrackingStatusShow: window.elemement_Config.orderTrackingStatusShow
            }
        };
    },
    created: function created() {}
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _NonProfit;

    return {
      FieldFlags: {
        Individual: {
          AccountAccountType: true,
          AccountAccountStatus: true,
          AccountEmailAddress: true,
          AccountEmailAddressConfirm: true,
          AccountPassword: true,
          AccountPasswordConfirm: true,
          AccountHasNpiNumber: true,
          AccountNpiNumber: true,
          AccountLicenseNumber: true,
          AccountState: true,
          AccountPrimaryContact: true,
          AccountEyeDoctors: true,
          AccountId: true,
          AccountValidationResult: true,
          ContactFirstName: true,
          ContactLastName: true,
          ContactSuffix: true,
          ContactPhoneNumber: true,
          ContactYearsInPractice: true,
          ContactLegalName: false,
          ContactBusinessType: true,
          ContactIsMultiLocation: false,
          ContactRole: false,
          ContactOfficeLocation: true,
          ContactAccountType: true,
          ContactId: true,
          ContactValidationResult: true,
          EyeDoctorInformation: false,
          InviteDoctor: false,
          NonProfitOrganizationDetails: false,
          OfficeLocationName: false,
          OfficeLocationStreetAddress: true,
          OfficeLocationSuite: true,
          OfficeLocationCity: true,
          OfficeLocationState: true,
          OfficeLocationZip: true,
          OfficeLocationPhoneNumber: false,
          OfficeLocationEmailAddress: false,
          OfficeLocationContactFirstName: false,
          OfficeLocationContactLastName: false,
          OfficeLocationContactRole: false,
          OfficeLocationNumberOfJobs: true,
          OfficeLocationAccountType: true,
          OfficeLocationIsMultiLocation: true,
          OfficeLocationId: true,
          OfficeLocationValidationResult: true,
          EyeDoctorNpiNumber: false,
          EyeDoctorUseLicenseNumber: false,
          EyeDoctorLicenseNumber: false,
          EyeDoctorState: false,
          EyeDoctorFirstName: false,
          EyeDoctorLastName: false,
          EyeDoctorSuffix: false,
          EyeDoctorEmailAddress: false,
          EyeDoctorYearsInPractice: false,
          EyeDoctorAccountType: true,
          EyeDoctorId: true,
          EyeDoctorValidationResult: true,
          IndividualLabels: true,
          BusinessLabels: false,
          NonProfitLabels: false,
          IndividualOrganization: true,
          BusinessOrganization: false,
          NonProfitOrganization: false,
          BusinessTypeIndividual: true,
          BusinessTypeBusiness: false,
          BusinessTypeNonProfit: false,
          RoleBusiness: false,
          RoleNonProfit: false,
          OfficeLocationContact: false,
          EyeDoctorName: false,
          EyeDoctorEmail: false,
          AddEyeDoctor: false,
          MultipleDoctor: false,
          Associations: false,
          ProfessionalInfo: true,
          BusinessPrimaryContact: false,
          NonprofitPrimaryContact: false,
          IndividualNpiNumber: false,
          IndividualNpiNumberField: false,
          ParticipantAccountNpiNumber: false,
          BusinessNonProfitFormGroup: true,
          PrimaryContactChecked: false,
          LicenseNumber: false
        },
        Business: {
          AccountAccountType: true,
          AccountAccountStatus: true,
          AccountEmailAddress: true,
          AccountEmailAddressConfirm: true,
          AccountPassword: true,
          AccountPasswordConfirm: true,
          AccountHasNpiNumber: false,
          AccountNpiNumber: false,
          AccountLicenseNumber: false,
          AccountState: false,
          AccountPrimaryContact: true,
          AccountEyeDoctors: true,
          AccountId: true,
          AccountValidationResult: true,
          ContactFirstName: true,
          ContactLastName: true,
          ContactSuffix: true,
          ContactPhoneNumber: true,
          ContactYearsInPractice: false,
          ContactLegalName: true,
          ContactBusinessType: true,
          ContactIsMultiLocation: true,
          ContactRole: true,
          ContactOfficeLocation: true,
          ContactAccountType: true,
          ContactId: true,
          ContactValidationResult: true,
          EyeDoctorInformation: true,
          InviteDoctor: true,
          NonProfitOrganizationDetails: false,
          OfficeLocationName: true,
          OfficeLocationStreetAddress: true,
          OfficeLocationSuite: true,
          OfficeLocationCity: true,
          OfficeLocationState: true,
          OfficeLocationZip: true,
          OfficeLocationPhoneNumber: true,
          OfficeLocationEmailAddress: true,
          OfficeLocationContactFirstName: true,
          OfficeLocationContactLastName: true,
          OfficeLocationContactRole: true,
          OfficeLocationNumberOfJobs: true,
          OfficeLocationAccountType: true,
          OfficeLocationIsMultiLocation: true,
          OfficeLocationId: true,
          OfficeLocationValidationResult: true,
          EyeDoctorNpiNumber: true,
          EyeDoctorUseLicenseNumber: true,
          EyeDoctorLicenseNumber: true,
          EyeDoctorState: true,
          EyeDoctorFirstName: true,
          EyeDoctorLastName: true,
          EyeDoctorSuffix: true,
          EyeDoctorEmailAddress: true,
          EyeDoctorYearsInPractice: true,
          EyeDoctorAccountType: true,
          EyeDoctorId: true,
          EyeDoctorValidationResult: true,
          IndividualLabels: false,
          BusinessLabels: true,
          NonProfitLabels: false,
          IndividualOrganization: false,
          BusinessOrganization: true,
          NonProfitOrganization: false,
          BusinessTypeIndividual: false,
          BusinessTypeBusiness: true,
          BusinessTypeNonProfit: false,
          RoleBusiness: true,
          RoleNonProfit: false,
          OfficeLocationContact: true,
          EyeDoctorName: true,
          EyeDoctorEmail: true,
          AddEyeDoctor: true,
          MultipleDoctor: true,
          Associations: true,
          ProfessionalInfo: false,
          BusinessPrimaryContact: true,
          NonprofitPrimaryContact: false,
          BusinessAccountNpiNumber: true,
          IndividualNpiNumber: true,
          IndividualNpiNumberField: true,
          ParticipantAccountNpiNumber: true,
          BusinessNonProfitFormGroup: false,
          PrimaryContactChecked: true,
          LicenseNumber: true
        },

        NonProfit: (_NonProfit = {
          AccountAccountType: true,
          AccountAccountStatus: true,
          AccountEmailAddress: true,
          AccountEmailAddressConfirm: true,
          AccountPassword: true,
          AccountPasswordConfirm: true,
          AccountHasNpiNumber: false,
          AccountNpiNumber: false,
          AccountLicenseNumber: false,
          AccountState: false,
          AccountPrimaryContact: true,
          AccountEyeDoctors: true,
          AccountId: true,
          AccountValidationResult: true,
          ContactFirstName: true,
          ContactLastName: true,
          ContactSuffix: true,
          ContactPhoneNumber: true,
          ContactYearsInPractice: false,
          ContactLegalName: true,
          ContactBusinessType: true,
          ContactIsMultiLocation: true,
          ContactRole: true,
          ContactOfficeLocation: true,
          ContactAccountType: true,
          ContactId: true,
          ContactValidationResult: true,
          EyeDoctorInformation: true,
          InviteDoctor: true,
          NonProfitOrganizationDetails: true,
          OfficeLocationName: true,
          OfficeLocationStreetAddress: true,
          OfficeLocationSuite: true,
          OfficeLocationCity: true,
          OfficeLocationState: true,
          OfficeLocationZip: true,
          OfficeLocationPhoneNumber: true,
          OfficeLocationEmailAddress: true,
          OfficeLocationContactFirstName: true,
          OfficeLocationContactLastName: true,
          OfficeLocationContactRole: true,
          OfficeLocationNumberOfJobs: true,
          OfficeLocationAccountType: true,
          OfficeLocationIsMultiLocation: true,
          OfficeLocationId: true,
          OfficeLocationValidationResult: true,
          EyeDoctorNpiNumber: true,
          EyeDoctorUseLicenseNumber: true,
          EyeDoctorLicenseNumber: true,
          EyeDoctorState: true,
          EyeDoctorFirstName: true,
          EyeDoctorLastName: true,
          EyeDoctorSuffix: true,
          EyeDoctorEmailAddress: true,
          EyeDoctorYearsInPractice: true,
          EyeDoctorAccountType: true,
          EyeDoctorId: true,
          EyeDoctorValidationResult: true,
          IndividualLabels: false,
          BusinessLabels: false,
          NonProfitLabels: true,
          IndividualOrganization: false,
          BusinessOrganization: false,
          NonProfitOrganization: true,
          BusinessTypeIndividual: false,
          BusinessTypeBusiness: false,
          BusinessTypeNonProfit: true,
          RoleBusiness: false,
          RoleNonProfit: true,
          OfficeLocationContact: true,
          EyeDoctorName: true,
          EyeDoctorEmail: true,
          AddEyeDoctor: true,
          MultipleDoctor: true,
          Associations: false,
          ProfessionalInfo: false,
          BusinessPrimaryContact: true,
          NonprofitPrimaryContact: true,
          AccountIndividualNpiNumber: true,
          IndividualNpiNumber: true,
          IndividualNpiNumberField: false,
          ParticipantAccountNpiNumber: true,
          BusinessNonProfitFormGroup: false,
          PrimaryContactChecked: true
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NonProfit, "PrimaryContactChecked", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NonProfit, "LicenseNumber", true), _NonProfit),
        LoginInformation: {
          EmailAddress: true,
          EmailAddressConfirm: true,
          Password: true,
          NewPassword: true,
          NewPasswordConfirm: true,
          ValidationResult: true,
          ErrorMessage: true
        }
      }
    };
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isWufooLoading: false
    };
  },

  methods: {
    RemovePOBOX: function RemovePOBOX(address) {
      if (address != null) {
        address = address.replace(/\s\s+/g, " ");
        address = address.replace(/PO BOX/gi, "");
        address = address.replace(/POBOX/gi, "");
        address = address.replace(/P.O.BOX/gi, "");
        address = address.replace(/P.O..BOX/gi, "");
        address = address.replace(/P.O.BOX:/gi, "");
        address = address.replace(/P.O..BOX:/gi, "");
        address = address.replace(/P.O.BOX\./gi, "");
        address = address.replace(/P.O..BOX\./gi, "");
        address = address.trim();
        return address;
      } else {
        return null;
      }
    },
    checkIfAddressHasPO_BOX: function checkIfAddressHasPO_BOX(address) {
      if (address != null) {
        if (address.match(/\s\s+/g, " ")) return true;
        if (address.match(/\s\s+/g, " ")) return true;
        if (address.match(/PO BOX/gi, "")) return true;
        if (address.match(/POBOX/gi, "")) return true;
        if (address.match(/P.O.BOX/gi, "")) return true;
        if (address.match(/P.O..BOX/gi, "")) return true;
        if (address.match(/P.O.BOX:/gi, "")) return true;
        if (address.match(/P.O..BOX:/gi, "")) return true;
        if (address.match(/P.O.BOX\./gi, "")) return true;
        if (address.match(/P.O..BOX\./gi, "")) return true;
        return false;
      } else {
        return false;
      }
    },
    FormatDate: function FormatDate(value) {
      if (value != null) {
        var dateTime = value.split("T");
        var datePart = dateTime[0].split("-");
        var time = dateTime[1].split(".");
        return datePart[1] + "/" + datePart[2] + "/" + datePart[0] + " " + this.ConvertTime(time[0]);
      } else {
        return null;
      }
    },
    FormatDateToLocal: function FormatDateToLocal(value) {
      var dsUTC = new Date(value);
      var newDsUTC = dsUTC.getMonth() + 1 + "/" + dsUTC.getDate() + "/" + dsUTC.getFullYear() + " " + dsUTC.getHours() + ":" + dsUTC.getMinutes() + ":" + dsUTC.getSeconds();
      var ds = new Date(newDsUTC + " UTC");
      var getTime = this.PadLeftZero(ds.getHours()) + ":" + this.PadLeftZero(ds.getMinutes()) + ":" + this.PadLeftZero(ds.getSeconds());

      return ds.getMonth() + 1 + "/" + ds.getDate() + "/" + ds.getFullYear() + " " + this.ConvertTime(getTime);
    },
    PadLeftZero: function PadLeftZero(value) {
      if (value < 10) {
        return "0" + value;
      } else return value;
    },
    ConvertTime: function ConvertTime(time) {
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        time = time.slice(1);
        time[5] = +time[0] < 12 ? "AM" : "PM";
        time[0] = +time[0] % 12 || 12;
      }
      return time.join("");
    },
    G_NumberCheck: function G_NumberCheck(evt) {
      console.log('G_NumberCheck(evt) => ', evt);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    G_NumberInputCheck: function G_NumberInputCheck(element) {
      if (element.NumberOfJobs < 0 || element.NumberOfJobs == ".") {
        element.NumberOfJobs = null;
      }
    },
    G_NumberOfYearsCheck: function G_NumberOfYearsCheck(element, option) {
      if (option == "YearsInPractice") {
        if (element.YearsInPractice < 1 || element.YearsInPractice == ".") element.YearsInPractice = null;else {}
      } else if (option == "YearsInpractice") {
        if (element.YearsInpractice < 1 || element.YearsInpractice == ".") element.YearsInpractice = null;else {}
      } else if (option == "yearsInPractice") {
        if (element.yearsInPractice < 1 || element.yearsInPractice == ".") element.yearsInPractice = null;else {}
      } else {
        if (element < 1 || element == ".") element = null;else {}
      }
    },
    IsNull: function IsNull(str) {
      if (str == null) return "";
      return str;
    },
    IsEmpty: function IsEmpty(params) {
      if (params != "") return params + ", ";
      return params;
    },
    G_CheckPasswordDigits: function G_CheckPasswordDigits(password) {
      if (password) {
        if (password.length > 0) {
          if (password.length < 6) {
            return {
              error: true,
              message: "Password must be at least 6 characters long"
            };
          } else {
            return {
              error: false,
              message: ""
            };
          }
        }
      }
    },
    G_CheckMatchPassword: function G_CheckMatchPassword(password, passwordConfirm) {
      if (password && passwordConfirm) {
        if (password.length > 0 && passwordConfirm.length > 0) {
          if (password == passwordConfirm) {
            return [{ error: false, message: "" }, { error: false, message: "" }];
          } else {
            return [{ error: true, message: "" }, { error: true, message: "Password does not match" }];
          }
        }
      }
      return [];
    },
    G_CheckMatchCurrentPassword: function G_CheckMatchCurrentPassword(currentPassword, newPassword) {
      if (currentPassword && newPassword) {
        if (currentPassword.length > 0 && newPassword.length > 0) {
          if (currentPassword == newPassword) {
            return {
              error: true,
              message: "New password is same as current password"
            };
          } else {
            return {
              error: false,
              message: ""
            };
          }
        }
      }
    },
    ConvertToTitleCase: function ConvertToTitleCase(stringToConvert) {
      var convertedString = stringToConvert.toLowerCase().split(" ").map(function (item) {
        return item.replace(/\b[a-zA-Z]/, function (c) {
          return c.toUpperCase();
        });
      }).join(" ");

      return convertedString;
    },
    G_CheckYearLicense: function G_CheckYearLicense(input) {
      var date = new Date();
      if (input.length < 4) {
        return "Year licensed must be valid";
      } else if (input > date.getFullYear()) {
        return "Year licensed must be equal or less than current year";
      } else return "";
    },
    G_ShowModal: function G_ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
    },
    G_ShowCovidReliefModal: function G_ShowCovidReliefModal() {
      this.isCovidReliefModalShown = !this.isCovidReliefModalShown;
    },
    G_CloseModal: function G_CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    G_ProcessLogin: function G_ProcessLogin(response) {
      var _this = this;
      if (response.data.isSuccess == true) {
        localStorage.setItem("host", response.data.raw.username);
        localStorage.setItem("token", response.data.raw.token);
        localStorage.setItem("watchword", response.data.raw.password);
        localStorage.setItem("accountStatus", response.data.raw.accountStatus);
        var crps = response.data.raw.covidReliefParticipantStatus || undefined;

        console.log("set covidReliefParticipantStatus");
        console.log("covidReliefParticipantStatus", crps);

        localStorage.setItem("covidReliefParticipantStatus", crps);
        localStorage.setItem("frameAndLensOrderIsAllowed", response.data.raw.frameAndLensOrderIsAllowed);

        localStorage.setItem("PersistentNotificationMessage", response.data.raw.persistentNotification);
        var pNotification = localStorage.getItem("PersistentNotificationMessage");

        if (pNotification == "") {
          localStorage.setItem("ShowPersistentNotification", false);
        }
        if (pNotification != "") {
          localStorage.setItem("ShowPersistentNotification", true);
        }
        var shippingAddress = {
          shippingAddressLineOne: response.data.raw.shippingAddressLineOne,
          shippingAddressLineTwo: response.data.raw.shippingAddressLineTwo,
          shippingCity: response.data.raw.shippingCity,
          shippingState: response.data.raw.shippingState,
          shippingPostalCode: response.data.raw.shippingPostalCode
        };

        localStorage.setItem("shippingAddress", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(shippingAddress));

        var sponsors = {
          minorLogos: [response.data.raw.logoMinorSponsor1, response.data.raw.logoMinorSponsor2, response.data.raw.logoMinorSponsor3],
          majorLogo: response.data.raw.logoMajorSponsorSmall,
          majorLogoLg: response.data.raw.logoMajorSponsorLarge,
          header: response.data.raw.logoMajorSponsorHeader,
          paragraph: response.data.raw.logoMajorSponsorParagraph,
          hyperLinkMinor: [response.data.raw.firstMinorSponsorLogoHyperlink, response.data.raw.secondMinorSponsorLogoHyperlink, response.data.raw.thirdMinorSponsorLogoHyperlink],
          hyperLinkMajor: response.data.raw.majorSponsorLogoHyperlink
        };
        localStorage.setItem("sponsors", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sponsors));

        var targetURL = localStorage.getItem("nextURL");
        if (targetURL != null) {
          _this.$router.push(targetURL);
        } else {
          _this.$router.push({ name: "PortalHome" });
        }
      } else {
        var index = response.data.errorMessage.indexOf("activation");
        if (response.data.errorMessage == "Outdated" || response.data.errorMessage == "AnnualForecastRequired") {
          localStorage.setItem("email", _this.Account.EmailAddress);
          localStorage.setItem("password", _this.Account.Password);
          localStorage.setItem("accountType", response.data.raw.accountType);
          localStorage.setItem("accountStatus", response.data.raw.accountStatus);
          localStorage.setItem("isCoveredUnderHIPAA", response.data.raw.isCoveredUnderHIPAA);
          localStorage.setItem("name", response.data.raw.name);
          localStorage.setItem("salesforceId", response.data.raw.salesforceId);
          localStorage.setItem("frameAndLensOrderIsAllowed", response.data.raw.frameAndLensOrderIsAllowed);
          _this.$router.push({
            name: response.data.errorMessage == "Outdated" ? "ContractAgreement" : "AnnualForecasting",
            params: { salesforceId: response.data.raw.salesforceId }
          });
        }
      }
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
            data: function data() {
                        return {
                                    main_bg_image: '../../../static/assets/img/KidImages/Portal Photo_KidImage3.jpeg',
                                    portal_benefits_img: '../../../../static/assets/img/DoctorImages/Portal Photo_DoctorImage4.jpg',
                                    portal_requirements_img: '../../../../static/assets/img/DoctorImages/Portal Photo_DoctorImage2.jpeg',
                                    blue_bg: '../static/assets/img/bg/bg-img1.png',
                                    cycle_of_giving_img: '../../../../static/assets/img/cycle_of_giving.png',

                                    learn_icon: '../../../../static/assets/img/icons/Landing Page Icons/OSEL_Foundation_white_vertical.png',
                                    discover_icon: '../../../../static/assets/img/icons/Landing Page Icons/Discover_More_400x400.png',
                                    contact_portal_icon: '../../../../static/assets/img/icons/Landing Page Icons/Mail_400x400.png',

                                    cltl_logo_blue: '../../../../static/assets/img/logo/cltl_logo_blue.png',
                                    cltl_logo_white: '../../../../static/assets/img/logo/ChampionForSight_Badge-White.png',

                                    covidrelief_banner_miss_img: '../../../../static/assets/img/miss_doctor.png',
                                    covidrelief_banner_mister_img: '../../../../static/assets/img/mister_doctor_2.png',
                                    home_banner_img: '../../../../static/assets/img/home_banner_champions_for_sight.png',
                                    CNN_Top_Left: '../../../../static/img/TopLeftCNN.png',
                                    CNN_Top_Right: '../../../../static/img/BottomLeftCNN2.jpg',
                                    CNN_Bottom_Left: '../../../../static/assets/img/CLTLDay/AdobeStock_103567562_Edit.jpg',
                                    CNN_Bottom_Right: '../../../../static/img/BottomRightCNN.png',
                                    colleague_bg: '../../../static/assets/img/bg/Phoropter_1.jpeg',
                                    success_story_1: '../../../../static/assets/img/FamilyImages/portal Photo_Family2.jpg',
                                    success_story_2: '../../../../static/assets/img/DoctorImages/Portal Photo_DoctorImage5.jpg',
                                    success_story_3: '../../../../static/assets/img/FamilyImages/portal Photo_FamilyImage5.jpg',

                                    story_wufoo_loader: '../../../../static/img/loading.gif',

                                    info_share_link: '../../../../static/resources/EVF_PortalFlyer_March2018.pdf',

                                    frame_banner_img: '../../../../../static/assets/img/FamilyImages/portal Photo_FamilyImage 3.jpeg',
                                    charitable_outreach_img: '../../../../../static/assets/img/E43A3409.jpg',

                                    invAccountTooltip: "This account is for eye doctors who want to submit orders for charitable work done independent of their practice or through a charitable referral network.",
                                    businessAccountTooltip: "This account is for a business to submit charitable work done through their practice.  This will cover all eye doctors working on behalf of this business.",
                                    nonprofitAccountTooltip: "This account is for non-profits to submit orders for charitable glasses. This is only for non-profits who serve directly, not those who operate as a referral network and do not place orders for glasses directly.",

                                    relationshipTooltip: "Please select the affiliation the doctor has with the participant/account. If the doctor is not formally associated with the business or organization, select 'Unaffiliated'",
                                    npiTooltip: "An NPI (National Provider Identifier) is a unique 10-digit identification number issued to health care providers in the US by the Centers for Medicare and Medicaid Services (CMS). This number will only be used as a unique identifier for each doctor in our system.",
                                    doctorAffiliationToolTip: "Please select the affiliation the doctor has with the participant/account. If the doctor is not formally associated with the business or organization, select 'Unaffiliated'",
                                    businessTypeTooltip: "Please select the choice which most closely aligns with your business.",
                                    organizationTypeTooltip: "Please select the choice which most closely aligns with your organization.",
                                    pledgeTooltip: "Please provide a best estimate. You can modifiy your estimate on the My Account page after Registration.",
                                    hipaaTooltip: "Are you a Covered Entity? For assistance in determining whether you are treated as a covered entity for purposes of HIPAA, please refer to HHS' decision-making tool located <a target='_blank' href='https://www.cms.gov/Regulations-and-Guidance/Administrative-Simplification/HIPAA-ACA/Downloads/CoveredEntitiesChart20160617.pdf'>here.</a>",
                                    npiForBusinessTooltip: "An NPI (National Provider Identifier) is a unique 10-digit identification number issued to health care providers in the US by the Centers for Medicare and Medicaid Services (CMS). This number will only be used as a unique identifier for each business in our system",

                                    pageLoader_img: '../../../static/img/loading.gif',

                                    majorSponsorLogo: '',
                                    minorSponsorLogos: [],
                                    minorSponsorLogosHome: [],
                                    tempSponsorLogo: '../../../../../static/essilorvision/logo-black.png',
                                    tempSponsorLogo_H: '../../../../../static/essilorvision/logo.png',

                                    sponsors: JSON.parse(localStorage.getItem('sponsors')),
                                    accountType: localStorage.getItem("accountType") != null ? localStorage.getItem('accountType') : 'user_',

                                    internationalMissionTooltip: "One-time support for a US participant of an international clinic. Not suitable for ongoing activities. Contact <a target='_blank' href='mailto:shindhe.gunputh@essilor.com?cc=email-cc@gmail.com&bcc=email-bcc@gmail.com&subject=Subject&body=Email Using Body'>2.5NVG Ready2Clip</a> for sustainable support.",

                                    shippingAddress: JSON.parse(localStorage.getItem('shippingAddress'))
                        };
            },
            created: function created() {
                        var sponsorLength = 3;
                        for (var index = 0; index < sponsorLength; index++) {
                                    this.minorSponsorLogos.push(this.tempSponsorLogo_H);
                        }
            }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_registration_Registration__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_registration_Registration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_registration_Registration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_registration_RegistrationSuccess__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_registration_RegistrationSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_registration_RegistrationSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_registration_RegistrationSummary__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_registration_RegistrationSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_registration_RegistrationSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_registration_Activation__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_registration_Activation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_registration_Activation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_listData_ResetPassword__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_listData_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_home_listData_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_ContractAgreement__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_ContractAgreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_ContractAgreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_Home__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_portal_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_home_Version__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_home_Version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_home_Version__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_UserAccount__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_UserAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_UserAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_Catalog__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_Catalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_portal_Catalog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_portal_Order_Order__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_portal_Order_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_portal_Order_Order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_portal_Order_OrderConfirmation__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_portal_Order_OrderConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_portal_Order_OrderConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_portal_Order_ExamConfirmation__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_portal_Order_ExamConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_portal_Order_ExamConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_portal_OrderTracking_OrderTracking__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_portal_OrderTracking_OrderTracking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_portal_OrderTracking_OrderTracking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_portal_Order_OrderSubmit_OrderSubmit__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_portal_Order_OrderSubmit_OrderSubmit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_portal_Order_OrderSubmit_OrderSubmit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_portal_AnnualForcasting__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_portal_AnnualForcasting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_portal_AnnualForcasting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_portal_Order_OrderSummary__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_portal_Order_OrderSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_portal_Order_OrderSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_portal_Order_ExamSummary__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_portal_Order_ExamSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_portal_Order_ExamSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_portal_frameResources_FramesCenter__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_portal_frameResources_FramesCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_portal_frameResources_FramesCenter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_portal_frameResources_FrameOrderSuccess__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_portal_frameResources_FrameOrderSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_portal_frameResources_FrameOrderSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_portal_Resource__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_portal_Resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_portal_Resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_portal_Help__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_portal_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_portal_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_portal_Demo__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_portal_Demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_portal_Demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_shared_ErrorPage__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_shared_ErrorPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_shared_ErrorPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_home_listData_LogIn_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_home_listData_LogIn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_home_listData_LogIn_vue__);


































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var guard = function guard(to, from, next) {
    axios.get('/Auth/TryConnect', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        if (response.data.isSuccess) {
            next();
        } else {
            removeLocalStorageItems();
        }
    }).catch(function (error) {
        removeLocalStorageItems();
    });
};

var removeLocalStorageItems = function removeLocalStorageItems() {
    localStorage.removeItem('accountType');
    localStorage.removeItem('host');
    localStorage.removeItem('id');
    sessionStorage.removeItem('referralCode');
    localStorage.removeItem('referrer');
    localStorage.removeItem('token');
    localStorage.removeItem('watchword');
    var fromName = localStorage.getItem("fromName");
    if (fromName == "ToMasterAccount") {
        localStorage.removeItem('fromName');
        window.location.href = "/MasterAccount";
    } else {
        window.location.href = "/";
    }
    localStorage.removeItem("ClinicEventList");
};

var setItems = function setItems(to, from, next) {
    localStorage.setItem("nextURL", to.path.toUpperCase().replace('/MASTERACCOUNT', ''));
    localStorage.setItem("fromName", "ToMasterAccount");
    guard(to, from, next);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: "history",
    routes: [{
        path: "/Portal/Order/MasterAccount",
        name: 'OrdersMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/Order" });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/Order/:code?/:EditOrReuse?/MasterAccount",
        name: 'OrderMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/Order/" + to.params.code + "/" + to.params.EditOrReuse });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/OrderConfirmation/:code/:isSummaryOnly/MasterAccount",
        name: 'OrderConfirmationMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/OrderConfirmation/" + to.params.code + "/" + to.params.isSummaryOnly });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/UserAccount/MasterAccount",
        name: 'UserAccountMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/UserAccount" });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/Home/MasterAccount",
        name: 'HomeMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            setItems(to, from, next);
        }
    }, {
        path: "/Portal/OrderTracking/MasterAccount",
        name: 'OrderTrackingMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/OrderTracking" });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/Frames/MasterAccount",
        name: 'FramesMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/Frames" });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/Resources/MasterAccount",
        name: 'ResourcesMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/Resources" });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/Help/MasterAccount",
        name: 'HelpMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/Help" });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/Portal/ExamConfirmation/:code/:isSummaryOnly/MasterAccount",
        name: 'ExamConfirmationMasterAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (localStorage.getItem('accountType') == 'master') {
                next({ path: "/Portal/ExamConfirmation/" + to.params.code + "/" + to.params.isSummaryOnly });
            } else {
                setItems(to, from, next);
            }
        }
    }, {
        path: "/",
        name: "Home",
        component: function component() {
            return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 81));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            var token = localStorage.getItem("token");
            if (token) {
                next({ path: "/Portal/Home/" });
            } else {
                next();
            }
        }
    }, {
        path: "/cltl-day",
        name: "CLTLDay",
        component: function component() {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 608));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            next();
        }
    }, {
        path: "/Referral/:referralCode?",
        name: "Referral",
        component: function component() {
            return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 81));
        }
    }, {
        path: "/Error",
        name: "Error",
        component: __WEBPACK_IMPORTED_MODULE_25__components_shared_ErrorPage___default.a
    }, {
        path: "/MasterAccount",
        name: "MasterAccount",
        component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 14));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            next();
        }
    }, {
        path: "/Registration/:type",
        name: "Registration",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 127));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            next();
        }
    }, {
        path: "/Donate/",
        name: "Donate",
        component: function component() {
            return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 609));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            next();
        }
    }, {
        path: "/RegistrationSuccess",
        name: "RegistrationSuccess",
        component: function component() {
            return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 81));
        }
    }, {
        path: "/RegistrationSummary:accountId?",
        name: "RegistrationSummary",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
        }
    }, {
        path: "/Activation/:code",
        name: "Activation",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 125));
        }
    }, {
        path: "/ResetPassword/:code",
        name: "ResetPassword",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 117));
        }
    }, {
        path: "/Portal/ContractAgreement",
        name: "ContractAgreement",
        component: __WEBPACK_IMPORTED_MODULE_7__components_portal_ContractAgreement___default.a
    }, {
        path: "/Portal/AnnualForecasting",
        name: "AnnualForecasting",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 118));
        }
    }, {
        path: "/Portal/Home/",
        name: "PortalHome",
        component: __WEBPACK_IMPORTED_MODULE_8__components_portal_Home___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            guard(to, from, next);
        }
    }, {
        path: "/Login/",
        name: "Login",
        component: __WEBPACK_IMPORTED_MODULE_26__components_home_listData_LogIn_vue___default.a
    }, {
        path: "/Version/",
        name: "Version",
        component: __WEBPACK_IMPORTED_MODULE_9__components_home_Version___default.a
    }, {
        path: "/Portal/UserAccount",
        name: "UserAccount",
        component: __WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_UserAccount___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            if (from.path == "/" && from.name != "Home") {
                localStorage.setItem("nextURL", to.path);
            }
            guard(to, from, next);
        }
    }, {
        path: "/Portal/Order/:code?/:EditOrReuse?",
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_12__components_portal_Order_Order___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            if (from.path == "/" && from.name != "Home") {
                guard(to, from, next);
                localStorage.setItem("nextURL", to.path);
            } else {
                var toBeConvertedToOrder = to.params.EditOrReuse === 2 || to.params.EditOrReuse === 3;

                var isRemakeOrRedo = to.fullPath.split('/')[4] == "1";

                var currentUrl = window.location.pathname == "/" || window.location.pathname == "/Portal/AnnualForecasting" ? to.path : window.location.pathname;
                var orderId = currentUrl.split('/')[3];
                var orderIdValue = orderId == undefined ? "" : orderId;

                var userIsPlacingNewOrder = to.fullPath == "/Portal/Order" && (from.name == "OrderConfirmation" || from.name == "OrderSubmit" || from.name == "ExamConfirmation");

                if (orderIdValue != "" && !isRemakeOrRedo) {

                    var orderStatus = '';

                    axios.get('/Order/GetOrderStatus/' + orderId + '/', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                        if (response.data.raw) {

                            var originPath = from.name;
                            var destinationPath = to.name;
                            orderStatus = response.data.raw.orderStatus;

                            var userIsEditingAnExamOnlyOrder = originPath == "ExamConfirmation" && destinationPath == "Order" && orderStatus == "ExamOnly";

                            if (toBeConvertedToOrder || userIsPlacingNewOrder || userIsEditingAnExamOnlyOrder || orderStatus === 'Pending' || orderStatus === 'PendingError' || response.data.raw.isMaster && orderStatus === 'PendingApproval') {
                                guard(to, from, next);
                            } else {
                                window.location.href = "/Portal/OrderTracking";
                            }
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                } else {
                    guard(to, from, next);
                }
            }
        }
    }, {
        path: "/Portal/OrderConfirmation/:code/:isSummaryOnly",
        name: 'OrderConfirmation',
        component: __WEBPACK_IMPORTED_MODULE_13__components_portal_Order_OrderConfirmation___default.a,
        beforeEnter: function beforeEnter(to, from, next) {

            if (from.path == "/" && from.name != "Home") {
                guard(to, from, next);
                localStorage.setItem("nextURL", to.path);
            } else {
                var currentUrl = window.location.pathname == "/" || window.location.pathname == "/Portal/AnnualForecasting" ? to.path : window.location.pathname;
                var orderId = currentUrl.split('/')[3];
                var isSummaryOnly = currentUrl.split('/')[4];
                var orderIdValue = orderId == undefined ? "" : orderId;

                if (orderIdValue != "") {

                    var orderStatus = '';

                    axios.get('/Order/GetOrderStatus/' + orderId + '/', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                        if (response.data.raw) {

                            orderStatus = response.data.raw.orderStatus;

                            if (orderStatus == "InProcess" || orderStatus == "Shipped" || orderStatus == "Cancelled") {
                                guard(to, from, next);
                            } else {
                                window.location.href = "/Portal/Order/" + orderIdValue + "/" + isSummaryOnly;
                            }
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                } else {
                    guard(to, from, next);
                }
            }
        }
    }, {
        path: "/Portal/ExamConfirmation/:code/:isSummaryOnly",
        name: 'ExamConfirmation',
        component: __WEBPACK_IMPORTED_MODULE_14__components_portal_Order_ExamConfirmation___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            if (from.path == "/" && from.name != "Home") {
                localStorage.setItem("nextURL", to.path);
            }
            guard(to, from, next);
        }
    }, {
        path: "/Portal/OrderSubmit/:code/:type",
        name: 'OrderSubmit',
        component: __WEBPACK_IMPORTED_MODULE_16__components_portal_Order_OrderSubmit_OrderSubmit___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            guard(to, from, next);
        }
    }, {
        path: "/Portal/OrderTracking/",
        name: 'OrderTracking',
        component: __WEBPACK_IMPORTED_MODULE_15__components_portal_OrderTracking_OrderTracking___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            if (from.path == "/" && from.name != "Home") {
                localStorage.setItem("nextURL", to.path);
            }
            guard(to, from, next);
        }
    }, {
        path: "/ExamSummary/:orderId?",
        name: "ExamSummary",
        component: __WEBPACK_IMPORTED_MODULE_19__components_portal_Order_ExamSummary___default.a
    }, {
        path: "/OrderSummary/:orderId?",
        name: "OrderSummary",
        component: __WEBPACK_IMPORTED_MODULE_18__components_portal_Order_OrderSummary___default.a
    }, {
        path: "/Portal/Resources",
        name: "Resource",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 122));
        },
        beforeEnter: function beforeEnter(to, from, next) {
            if (from.path == "/" && from.name != "Home") {
                localStorage.setItem("nextURL", to.path);
            }
            guard(to, from, next);
        }
    }, {
        path: "/Portal/Help",
        name: "Help",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 119));
        }
    }, {
        path: "/Resources/Demo",
        name: "Demo",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 79));
        }
    }, {
        path: "/Resources/Demo",
        name: "Demo",
        component: function component() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 79));
        }
    }, {
        path: "/Portal/Frames",
        name: "FramesCenter",
        component: __WEBPACK_IMPORTED_MODULE_20__components_portal_frameResources_FramesCenter___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            if (from.path == "/" && from.name != "Home") {
                guard(to, from, next);
                localStorage.setItem("nextURL", to.path);
            } else {
                var retFrame = localStorage.getItem("frameAndLensOrderIsAllowed");
                if (retFrame == "true") {
                    guard(to, from, next);
                } else window.location.href = "/Portal/Home/";
            }
        }
    }, {
        path: "/Portal/FrameOrderSuccess",
        name: "FramesOrderSuccess",
        component: __WEBPACK_IMPORTED_MODULE_21__components_portal_frameResources_FrameOrderSuccess___default.a,
        beforeEnter: function beforeEnter(to, from, next) {
            guard(to, from, next);
        }
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    GetOrderStatus: function GetOrderStatus(orderId) {
        var _this = this;
    }
}));

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return theme; });
var theme = {
  'default': {
    primary: '#26304d',
    primary2: '#44537e',
    secondary: '#a61d37',
    background: '#f5f6fa',
    testimonialBullet: '#ffffff',
    testimonialBulletActive: '#000000'
  },
  'rebrand': {
    primary: '#000000',
    primary2: '#000000',
    secondary: '#a6a6a6',
    background: '#f5f6fa',
    testimonialBullet: '#666666',
    testimonialBulletActive: '#ffffff'
  }
};

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(596)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-417ef92c", Component.options)
  } else {
    hotAPI.reload("data-v-417ef92c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(599)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(520),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bc74044",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\home\\listData\\LogIn.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LogIn.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4bc74044", Component.options)
  } else {
    hotAPI.reload("data-v-4bc74044", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\PortalForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PortalForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e8b0df4", Component.options)
  } else {
    hotAPI.reload("data-v-6e8b0df4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

(function (w, d, s, l, i) {
  w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-MKSJ39Q');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Account", "CheckboxBusiness", "CheckboxIndividual", "FormInputs"],
  created: function created() {
    var referral = sessionStorage.getItem('referralCode');
    if (referral === 'teamvision') {
      this.Account.Organizations.List.push('Team Vision');
    }

    if (this.FormInputs.IndividualOrganization || this.FormInputs.NonProfitOrganization) this.Account.IsOrderFrameKit = null;
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    CovidRelief: __WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief___default.a,
    LoadingComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default.a
  },
  data: function data() {
    return {
      isFormLoading: false,
      isModalShown: true,
      CovidReliefParticipantStatus: ''
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('CtlModalForm');
    },
    SubmitCRPS: function SubmitCRPS() {
      var _this = this;
      _this.isFormLoading = true;
      axios.post("/Account/CovidReliefParticipant", {
        response: this.CovidReliefParticipantStatus
      }, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        if (response.data.isSuccess == true) {
          localStorage.setItem("covidReliefParticipantStatus", response.data.raw.covidReliefParticipantStatus);
          localStorage.setItem("isCovidReliefStatusChecked", "true");

          _this.isFormLoading = false;
          _this.CloseModal();
        } else {
          localStorage.setItem("isCovidReliefStatusChecked", "true");
          alert("We got an Error on your request.");
          _this.isFormLoading = false;
          _this.CloseModal();
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {}
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Account", "EyeDoctorValidation", "FormInputs", "Suffix", "State"],
  data: function data() {
    return {
      errorMessage: {
        year: null
      },
      IsInputDisabled: false,
      invalidNpiNumberPaste: false
    };
  },

  methods: {
    pasteNpiNumber: function pasteNpiNumber(event) {
      var re = /^\d+$/;
      if (!re.test(event.clipboardData.getData('text'))) {
        this.invalidNpiNumberPaste = true;
      } else {
        this.invalidNpiNumberPaste = false;
      }
    },
    AddDoctor: function AddDoctor() {
      this.Account.EyeDoctors.push({
        NoEyeDoctor: false,
        UseLicenseNumber: false,
        NpiNumber: null,
        LicenseNumber: null,
        State: null,
        FirstName: null,
        LastName: null,
        Suffix: null,
        EmailAddress: null,
        YearsInPractice: null,
        Role: null

      });
      this.EyeDoctorValidation.push({ validationResult: {} });

      var size = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.Account.EyeDoctors).length;

      if (size > 1) {
        var printNPINumber = size;

        this.Account.EyeDoctors.NpiNumber = "Empty";
      }
    },
    RemoveDoctor: function RemoveDoctor(index) {
      this.Account.EyeDoctors.splice(index, 1);
    },
    ValidateNpiNumberEyeDoctor: function ValidateNpiNumberEyeDoctor(index) {
      console.log('ValidateNpiNumberEyeDoctor(index) => ', index);
      this.$emit("npiIsDirtyBusiness", index);
    },
    CheckYearLicense: function CheckYearLicense(yearPractice) {
      var year = yearPractice;
      var result = this.G_CheckYearLicense(year);
      if (result) this.errorMessage.year = result;else this.errorMessage.year = "";
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_directive_tooltip__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_directive_tooltip_css_index_css__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_directive_tooltip_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_directive_tooltip_css_index_css__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_directive_tooltip___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['Account', 'AccountValidationResult', 'FormInputs'],
    data: function data() {
        return {
            isModalShown: false
        };
    },

    methods: {
        ShowModal: function ShowModal() {
            document.body.classList.add("body-overflow");
            this.isModalShown = !this.isModalShown;
        },
        CloseModal: function CloseModal() {
            this.isModalShown = false;
            document.body.classList.remove("body-overflow");
        }
    }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registration_Pledge__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registration_Pledge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__registration_Pledge__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { Pledge: __WEBPACK_IMPORTED_MODULE_1__registration_Pledge___default.a },
    props: ['Account', 'OfficeLocationValidationResult', 'FormInputs', 'State', 'RoleNonProfit', 'RoleBusiness', 'IsValidNPI', 'IsAddressValidating'],
    data: function data() {
        var _ref;

        return _ref = {
            otherDonationSolution: null,
            otherPaymentProcessor: null,
            isInviteDoctor: false,
            isTooltipVisible: false
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'otherDonationSolution', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'otherPaymentProcessor', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'paymentProcessingOptions', ['Global Payments', 'Open Edge by Global Payments', 'Square', 'Clover', 'Ciao!']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'donationSolutionOptions', ['Integration Point of Sale Solution', 'Charitable SKU (UPC Code)', 'QR Code']), _ref;
    },

    computed: {
        pledge: function pledge() {
            var text = null;
            if (this.$route.params.type == "Individual") {
                text = "The participant pledges to place the following number of charitable orders this calendar year.*";
            } else if (this.$route.params.type == "Business") {
                text = "This location of the business pledges/forecasts to place the following number of charitable orders this calendar year.*";
            } else if (this.$route.params.type == "NonProfit") {
                text = "This location of the organization forecasts to place the following number of charitable orders this calendar year.*";
            }
            return text;
        },
        invite: function invite() {
            var text = null;
            if (this.$route.params.type == "Business") {
                text = "Invite another location within your business";
            } else if (this.$route.params.type == "NonProfit") {
                text = "Invite another location within your organization";
            }
            return text;
        }
    },
    methods: {
        addressChanged: function addressChanged(evt) {
            if (!this.Account.PrimaryContact.OfficeLocation.StreetAddress) return;
            if (this.checkIfAddressHasPO_BOX(this.Account.PrimaryContact.OfficeLocation.StreetAddress.toString()) == true) {
                alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.");
            }
        },
        IsNumber: function IsNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        PhoneNumberCheck: function PhoneNumberCheck(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();;
            }
        },
        NextField: function NextField(field) {
            var focus1 = this.$refs.office_number_1;
            var focus2 = this.$refs.office_number_2;
            var focus3 = this.$refs.office_number_3;

            if (field == 1 && focus1.value.length == 3) {
                focus2.focus();
            } else if (field == 2 && focus2.value.length == 3) {
                focus3.focus();
            }
        },
        FocusNextField: function FocusNextField(element1, element2, element3) {
            if (element1.value.length == 2) {
                element2.focus();
            } else if (element2.value.length == 2) {
                element3.focus();
            }
        },
        ValidateAddress: function ValidateAddress() {
            this.$emit("addressCheck");
        }
    }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Account", "AccountValidationResult", "FormInputs", "ContactValidationResult", "Suffix", "RoleNonProfit", "RoleBusiness", "BusinessTypeNonProfit", "BusinessTypeBusiness", "BusinessTypeIndividual", "State"],
  components: { LoadingComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default.a },
  data: function data() {
    return {
      yearStarted: [],
      yearToday: new Date().getFullYear(),
      errorMessage: {
        year: null
      },
      FirstName: null,
      LastName: null,
      passSuffix: null,
      NpiNumber: null,
      primaryLicenseNumber: null,
      primaryState: null,
      isLoading: false,
      invalidNpiNumberPaste: false
    };
  },

  computed: {
    GetNpi: function GetNpi() {
      return this.Account.PrimaryContact.NpiNumber;
    },
    GetLicenseNumber: function GetLicenseNumber() {
      return this.Account.PrimaryContact.IsPrimaryLicenseNumber;
    },
    GetAccountValidationResult: function GetAccountValidationResult() {
      return this.AccountValidationResult;
    },
    GetContactValidationResult: function GetContactValidationResult() {
      return this.ContactValidationResult;
    },
    GetPrimaryContact: function GetPrimaryContact() {
      return this.Account.PrimaryContact;
    }
  },
  watch: {
    'Account.PrimaryContact.Phone': function AccountPrimaryContactPhone(newValue) {
      this.$set(this.Account.PrimaryContact.OfficeLocation, 'Phone', newValue);
    },
    'Account.PrimaryContact.CountryCode': function AccountPrimaryContactCountryCode(newValue) {
      this.$set(this.Account.PrimaryContact.OfficeLocation, 'CountryCode', newValue);
    },
    'Account.PrimaryContact.AreaCode': function AccountPrimaryContactAreaCode(newValue) {
      this.$set(this.Account.PrimaryContact.OfficeLocation, 'AreaCode', newValue);
    },
    GetNpi: function GetNpi(val) {
      if (this.Account.PrimaryContact.IsEyeDoctor) {
        this.Account.EyeDoctors[0].NpiNumber = val;
        this.Account.NpiNumber = val;
      }
      if (val && val.length === 10) {} else {
        this.NpiNumber;
        this.FirstName = null;
        this.LastName = null;
        this.passSuffix = null;
        this.Account.PrimaryContact.CountryCode = null;
        this.Account.PrimaryContact.AreaCode = null;
        this.Account.PrimaryContact.Phone = null;
        this.Account.EyeDoctors[0].NpiNumber = val;
        this.Account.NpiNumber = null;
      }
    },
    GetLicenseNumber: function GetLicenseNumber(val) {
      if (this.Account.PrimaryContact.IsEyeDoctor) {
        this.Account.EyeDoctors[0].UseLicenseNumber = val;
      }
      if (val && val.length === 10) {} else {
        this.primaryLicenseNumber = null;
        this.primaryState = null;
      }
    },

    FirstName: function FirstName(val) {
      if (val) {
        this.Account.PrimaryContact.FirstName = val;
        if (this.Account.PrimaryContact.IsEyeDoctor) {
          this.Account.EyeDoctors[0].FirstName = this.Account.PrimaryContact.FirstName;
        }
      } else {
        this.Account.EyeDoctors[0].FirstName = "";
      }
    },
    LastName: function LastName(val) {
      if (val) {
        this.Account.PrimaryContact.LastName = val;
        if (this.Account.PrimaryContact.IsEyeDoctor) {
          this.Account.EyeDoctors[0].LastName = this.Account.PrimaryContact.LastName;
        }
      } else {
        this.Account.EyeDoctors[0].LastName = "";
      }
    },
    passSuffix: function passSuffix(val) {
      if (val) {
        this.Account.PrimaryContact.Suffix = val;
        if (this.Account.PrimaryContact.IsEyeDoctor) {
          this.Account.EyeDoctors[0].Suffix = this.Account.PrimaryContact.Suffix;
        }
      } else {
        this.Account.EyeDoctors[0].Suffix = "";
      }
    },
    primaryLicenseNumber: function primaryLicenseNumber(val) {
      if (val) {
        this.Account.PrimaryContact.LicenseNumber = val;
        this.Account.LicenseNumber = val;
        if (this.Account.PrimaryContact.IsPrimaryLicenseNumber) {
          this.Account.EyeDoctors[0].LicenseNumber = this.Account.PrimaryContact.LicenseNumber;
        }
      } else {
        this.Account.EyeDoctors[0].LicenseNumber = '';

        this.Account.LicenseNumber = '';
      }
    },
    primaryState: function primaryState(val) {
      if (val) {
        this.Account.PrimaryContact.State = val;
        this.Account.State = val;
        if (this.Account.PrimaryContact.IsPrimaryLicenseNumber) {
          this.Account.EyeDoctors[0].State = this.Account.PrimaryContact.State;
        }
      }
    }
  },
  methods: {
    AccountRoleChanged: function AccountRoleChanged(role) {
      this.Account.EyeDoctors[0].Role = role;
    },
    pasteNpiNumber: function pasteNpiNumber(event) {
      var re = /^\d+$/;
      if (!re.test(event.clipboardData.getData('text'))) {
        this.invalidNpiNumberPaste = true;
      } else {
        this.invalidNpiNumberPaste = false;
      }
    },
    MakeParticipantDoctor: function MakeParticipantDoctor() {
      if (this.Account.PrimaryContact.IsEyeDoctor == false) {
        this.Account.NpiNumber = null;
        this.Account.EyeDoctors[0].NpiNumber = null;
        this.Account.EyeDoctors[0].FirstName = null;
        this.Account.EyeDoctors[0].LastName = null;
        this.Account.EyeDoctors[0].Suffix = null;
        this.Account.EyeDoctors[0].LicenseNumber = null;
        this.Account.EyeDoctors[0].State = null;
        this.Account.PrimaryContact.IsPrimaryLicenseNumber = false;
        this.Account.EyeDoctors[0].UseLicenseNumber = false;
        this.Account.PrimaryContact.NpiNumber = null;
        this.FirstName = null;
        this.LastName = null;
        this.passSuffix = null;
        this.Account.PrimaryContact.CountryCode = null;
        this.Account.PrimaryContact.AreaCode = null;
        this.Account.PrimaryContact.Phone = null;
        this.Account.Role = null;
      } else {
        this.Account.EyeDoctors[0].FirstName = this.FirstName;
        this.Account.EyeDoctors[0].LastName = this.LastName;
        this.Account.EyeDoctors[0].Suffix = this.passSuffix;
      }
    },
    PassNpiValue: function PassNpiValue() {
      if (this.Account.NpiNumber) {
        this.FirstName = this.Account.PrimaryContact.FirstName;
        this.LastName = this.Account.PrimaryContact.LastName;
        this.passSuffix = this.Account.PrimaryContact.Suffix;
      }
    },
    updateUseLicenseNumber: function updateUseLicenseNumber() {
      if (this.Account.PrimaryContact.IsPrimaryLicenseNumber) {
        this.Account.EyeDoctors[0].LicenseNumber = this.primaryLicenseNumber;
        this.Account.EyeDoctors[0].State = this.primaryState;
      } else {

        this.Account.EyeDoctors[0].LicenseNumber = null;
        this.Account.EyeDoctors[0].State = null;
      }
    },
    NumberCheck: function NumberCheck(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      }
    },
    ValidateNpiNumber: function ValidateNpiNumber(npi) {
      var _this = this;

      var npiNumber = npi;
      if (npiNumber.length == 10) {
        _this.isLoading = true;

        var doctor = {
          AccountType: this.$route.params.type,
          NpiNumber: npiNumber
        };

        axios.post('/Account/IsNpiNumberValid/', doctor).then(function (response) {
          if (response.data.isSuccess) {

            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];

            _this.FirstName = _this.ConvertToTitleCase(basicDetails.first_name);
            _this.LastName = _this.ConvertToTitleCase(basicDetails.last_name);
            _this.passSuffix = basicDetails.credential;
            _this.Account.PrimaryContact.CountryCode = address.telephone_number.split("-")[0];
            _this.Account.PrimaryContact.AreaCode = address.telephone_number.split("-")[1];
            _this.Account.PrimaryContact.Phone = address.telephone_number.split("-")[2];

            _this.isLoading = false;
            _this.GetContactValidationResult.ContactNpiNumber = '';
            _this.GetAccountValidationResult.AccountNpiNumber = '';
          } else {
            _this.GetContactValidationResult.ContactNpiNumber = response.data.errorMessage;
            _this.GetAccountValidationResult.AccountNpiNumber = response.data.errorMessage;
            _this.FirstName = null;
            _this.LastName = null;
            _this.passSuffix = null;
            _this.Account.PrimaryContact.CountryCode = null;
            _this.Account.PrimaryContact.AreaCode = null;
            _this.Account.PrimaryContact.Phone = null;

            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateNpiNumberForBusinessType: function ValidateNpiNumberForBusinessType() {
      var _this2 = this;

      var _this = this;
      var npiNumber = _this.Account.BusinessNpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        var business = {
          AccountType: this.$route.params.type,
          BusinessNpiNumber: npiNumber
        };

        axios.post("/Account/IsNpiNumberBusinessType", business).then(function (response) {
          if (response.data.isSuccess) {
            _this.GetAccountValidationResult.AccountNpiNumber = null;
            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];

            var legalName = _this2.ConvertToTitleCase(basicDetails.organization_name);
            _this.GetPrimaryContact.LegalName = legalName;
            _this.isLoading = false;

            _this.GetAccountValidationResult.AccountBusinessNpiNumber = '';
          } else {

            _this.GetAccountValidationResult.AccountBusinessNpiNumber = response.data.errorMessage;

            _this.called = _this.GetAccountValidationResult.AccountBusinessNpiNumber;
            _this.GetPrimaryContact.LegalName = null;
            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    NextField: function NextField(field) {
      var focus1 = this.$refs.participant_number_1;
      var focus2 = this.$refs.participant_number_2;
      var focus3 = this.$refs.participant_number_3;

      if (field == 1 && focus1.value.length == 3) {
        focus2.focus();
      } else if (field == 2 && focus2.value.length == 3) {
        focus3.focus();
      }
    },
    FocusNextField: function FocusNextField(element1, element2, element3) {
      if (element1.value.length == 2) {
        element2.focus();
      } else if (element2.value.length == 2) {
        element3.focus();
      }
    },
    NumberOfYearsCheck: function NumberOfYearsCheck(yearsInpractice) {
      if (yearsInpractice < 1) yearsInpractice = null;else yearsInpractice = input;
    },
    ComputeYear: function ComputeYear() {
      var year = this.yearToday;
      for (var i = 0; i < 30; i++) {
        this.yearStarted.push({ value: year, text: year });
        year += 1;
      }
    },
    CheckYearLicense: function CheckYearLicense() {
      var year = this.Account.PrimaryContact.YearsInPractice;
      var result = this.G_CheckYearLicense(year);
      if (result) this.errorMessage.year = result;else this.errorMessage.year = "";
    }
  },
  created: function created() {
    this.ComputeYear();
    console.log(this.FormInputs);
    if (this.FormInputs.IndividualOrganization) this.Account.Role = 'Self';
    if (this.Account.PrimaryContact.FirstName) this.FirstName = this.Account.PrimaryContact.FirstName;
    if (this.Account.PrimaryContact.LastName) this.LastName = this.Account.PrimaryContact.LastName;
    if (this.Account.PrimaryContact.Suffix) this.passSuffix = this.Account.PrimaryContact.Suffix;
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PortalForm__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PortalForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PortalForm__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Account", "AccountValidationResult", "FormInputs", "BusinessEmail", "TermsEmail"],
  components: { PortalForm: __WEBPACK_IMPORTED_MODULE_0__components_shared_PortalForm___default.a },
  data: function data() {
    return {
      isModalShown: false,
      isModalShownTAC: false,
      isModalShownBAA: false,
      agreementOptions: {
        termsAndCondition: [true, true, true, true, true, true]
      },
      termsAndConditionError: 'You must select "I Agree" to submit the form',
      termsAndConditionError2: 'You must select "I Agree" to submit the form.  Please click here to contact us with questions or concerns'
    };
  },

  methods: {
    SubmitEmail: function SubmitEmail(ind) {
      var email = null;
      if (ind == 1) {
        email = this.TermsEmail;
      } else if (ind == 2) {
        email = this.BusinessEmail;
      }
      axios.post("/Account/SendFeedback", email).then(function (response) {
        console.log("success");
      }).catch(function (error) {
        console.log(error);
      });
    },
    ShowModal: function ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
    },
    ShowModalBAA: function ShowModalBAA() {
      document.body.classList.add("body-overflow");
      this.isModalShownBAA = !this.isModalShownBAA;
    },
    ShowModalTAC: function ShowModalTAC() {
      document.body.classList.add("body-overflow");
      this.isModalShownTAC = !this.isModalShownTAC;
    },
    EnableTermAndAgreementSubmitBtn: function EnableTermAndAgreementSubmitBtn(index, value) {
      this.agreementOptions.termsAndCondition[index] = value;
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      this.isModalShownTAC = false;
      this.isModalShownBAA = false;
      document.body.classList.remove("body-overflow");
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var typingTimer;
/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['Account', 'AccountValidationResult', 'FormInputs'],
    data: function data() {
        return {
            hasPasswordError: false,
            hasConfirmPasswordError: false,
            hasPasswordErrorMessage: '',
            hasConfirmPasswordErrorMessage: ''
        };
    },

    methods: {
        ValidateEmail: function ValidateEmail() {
            this.$emit("clicked");
        },
        ValidateConfirmEmail: function ValidateConfirmEmail() {
            this.$emit("confirm");
        },
        CheckPasswordDigits: function CheckPasswordDigits() {
            var tempAccountPassword = this.AccountValidationResult.AccountPassword;
            if (this.Account.Password) {
                if (this.Account.Password.length > 0) {
                    this.AccountValidationResult.AccountPassword = null;
                    if (this.Account.Password.length < 6) {
                        this.hasPasswordError = true;
                        this.hasPasswordErrorMessage = "Password must be at least 6 characters";
                    } else {
                        this.hasPasswordError = false;
                        this.hasPasswordErrorMessage = "";
                    }
                }
            } else {}
        },
        CheckConfirmPasswordDigits: function CheckConfirmPasswordDigits() {
            var tempAccountPassword = this.AccountValidationResult.AccountPasswordConfirm;
            if (this.Account.PasswordConfirm) {
                if (this.Account.PasswordConfirm.length > 0) {
                    this.AccountValidationResult.AccountPasswordConfirm = null;
                    if (this.Account.PasswordConfirm.length < 6) {
                        this.hasConfirmPasswordError = true;
                        this.hasConfirmPasswordErrorMessage = "Password must be at least 6 characters";
                    } else {
                        this.hasConfirmPasswordError = false;
                        this.hasConfirmPasswordErrorMessage = "";
                    }
                }
            } else {}
        },
        CheckMatchPassword: function CheckMatchPassword() {
            var tempAccountPassword = this.AccountValidationResult.AccountPassword;
            var tempAccountPasswordConfirm = this.AccountValidationResult.AccountPasswordConfirm;
            if (this.Account.Password && this.Account.PasswordConfirm) {
                if (this.Account.Password.length > 0 && this.Account.PasswordConfirm.length > 0) {
                    this.AccountValidationResult.AccountPassword = null;
                    this.AccountValidationResult.AccountPasswordConfirm = null;
                    if (this.Account.Password == this.Account.PasswordConfirm) {
                        this.hasPasswordError = false;
                        this.hasConfirmPasswordError = false;
                        this.hasConfirmPasswordErrorMessage = "";
                        this.CheckPasswordDigits();
                        this.CheckConfirmPasswordDigits();
                    } else {
                        this.hasPasswordError = true;
                        this.hasConfirmPasswordError = true;
                        this.hasConfirmPasswordErrorMessage = "Password does not match";
                    }
                }
            } else {}
        }
    }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isAuth: false
    };
  },

  methods: {}
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
    components: { LoadingComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default.a },
    data: function data() {
        return {
            isModalShown: true,
            RequestEmail: "",
            errorMessage: null,
            ResetStatus: false,
            ResetForm: true,
            isLoading: false

        };
    },

    methods: {
        validatePortal: function validatePortal() {
            var currentUrl = window.location.href;
            return currentUrl.includes("championsforsight") ? "CFS" : "CLTL";
        },
        CloseModal: function CloseModal() {
            this.isModalShown = false;
            this.$emit("clicked");
            document.body.classList.remove("body-overflow");
        },
        ResetValidation: function ResetValidation() {
            this.errorMessage = "";
        },
        ForgotPassword: function ForgotPassword() {
            var _this2 = this;

            this.isLoading = true;
            axios.post("/Account/ForgotPassword", { "EmailAddress": this.RequestEmail, "PortalType": this.validatePortal() }, {
                "headers": {
                    "Content-Type": "application/json" } }).then(function (response) {
                var _this = _this2;
                _this.isLoading = false;
                if (response.data.isSuccess == true) {
                    _this.ResetForm = !_this.ResetForm;
                    _this.ResetStatus = !_this.ResetStatus;
                } else {
                    _this.errorMessage = response.data.errorMessage;
                    console.log(response.data.errorMessage);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_listData_ForgotPassword__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_listData_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_listData_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_listData_ResendActivation__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_listData_ResendActivation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_listData_ResendActivation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_HelpFormLoggedOut__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_HelpFormLoggedOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_HelpFormLoggedOut__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, ForgotPassword: __WEBPACK_IMPORTED_MODULE_2__components_home_listData_ForgotPassword___default.a, ResendActivation: __WEBPACK_IMPORTED_MODULE_3__components_home_listData_ResendActivation___default.a, HelpForm: __WEBPACK_IMPORTED_MODULE_4__components_shared_HelpFormLoggedOut___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a },
    data: function data() {
        return {
            isModalShown: false,
            isResendModalShown: false,
            Account: {
                EmailAddress: null,
                Password: null,
                salesForceId: null,

                PortalType: window.location.href.includes("championsforsight") ? "CFS" : "CLTL"
            },
            isLoginfalse: false,
            isForActivation: false,
            errorMessage: null,
            isLoginLoading: false,
            isGenericError: false,
            isHelpShown: false
        };
    },

    methods: {
        RouterRedirect: function RouterRedirect(name) {
            this.$router.push({ name: name });
        },
        validatePortal: function validatePortal() {
            var currentUrl = window.location.href;
            return currentUrl.includes("championsforsight") ? "CFS" : "CLTL";
        },
        ShowModal: function ShowModal() {
            this.isModalShown = !this.isModalShown;
        },
        RedirectToSignUp: function RedirectToSignUp() {
            this.$router.push({ name: 'Registration', params: { type: 'Business' } });
        },
        ShowResendModal: function ShowResendModal() {
            document.body.classList.add("body-overflow");
            this.isResendModalShown = !this.isResendModalShown;
        },
        validateBeforeReview: function validateBeforeReview() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result == true) {
                    _this2.Submit();
                } else {}
            }).catch(function () {});
        },
        ToggleWufoo: function ToggleWufoo() {
            this.isHelpShown = !this.isHelpShown;
            if (this.isHelpShown) {
                document.body.classList.add("body-overflow");
            } else {
                document.body.classList.remove("body-overflow");
            }
        },
        Submit: function Submit() {
            var _this = this;
            _this.isLoginLoading = true;
            this.Account.PortalType = window.location.href.includes("championsforsight") ? "CFS" : "CLTL";
            axios.post('/Auth/Login', this.Account).then(function (response) {
                _this.G_ProcessLogin(response);
                if (response.data.isSuccess == true) {
                    _this.isLoginfalse = false;
                    var targetURL = localStorage.getItem("nextURL") || "/Portal/Home";
                    _this.$router.push(targetURL);
                } else {
                    var index = response.data.errorMessage.indexOf('activation');
                    _this.isLoginfalse = true;
                    if (response.data.errorMessage == "Outdated" || response.data.errorMessage == "AnnualForecastRequired") {} else if (response.data.errorMessage == "GenericError") {
                        _this.isGenericError = true;
                    } else {
                        _this.errorMessage = response.data.errorMessage;
                    }
                    _this.isForActivation = index > 0;
                    _this.isLoginLoading = false;
                }
            }).catch(function (error) {
                console.log(error);
                _this.$router.push({ name: 'Error' });
            });
        }
    }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ["RequestEmail"],
    components: { LoadingComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default.a },
    data: function data() {
        return {
            isResendModalShown: true,

            errorMessage: null,
            ResetStatus: false,
            ResetForm: true,
            isLoading: false

        };
    },

    methods: {
        CloseModal: function CloseModal() {
            this.isResendModalShown = false;
            this.$emit("clicked");
            document.body.classList.remove("body-overflow");
        },
        ResetValidation: function ResetValidation() {
            this.errorMessage = "";
        },
        ResendActivation: function ResendActivation() {
            var _this2 = this;

            this.isLoading = true;
            axios.post("/Account/ResendActivation/" + this.RequestEmail, { "headers": { "Content-Type": "application/json" } }).then(function (response) {
                var _this = _this2;
                _this.isLoading = false;
                if (response.data.isSuccess == true) {
                    _this.ResetForm = !_this.ResetForm;
                    _this.ResetStatus = !_this.ResetStatus;
                } else {
                    _this.errorMessage = response.data.errorMessage;
                    console.log(response.data.errorMessage);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    created: function created() {
        this.ResendActivation();
    }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      IsCodeValid: false,
      IsCodeInvalid: false,
      validationResult: {},
      isFormLoading: false,
      isSuccess: false,
      ResetNewPassword: {
        code: "",
        Password: "",
        PasswordConfirm: ""
      },
      hasPasswordError: false,
      hasConfirmPasswordError: false,
      hasPasswordErrorMessage: "",
      hasConfirmPasswordErrorMessage: ""
    };
  },

  methods: {
    ValidateCode: function ValidateCode() {
      var _this2 = this;

      axios.post("/Account/ResetPassword/" + this.$route.params.code, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var _this = _this2;
        if (response.data.isSuccess == true) {
          _this.IsCodeValid = true;
          _this.ResetNewPassword.code = response.data.raw.code;
        } else {
          _this.IsCodeInvalid = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    ResetPassword: function ResetPassword() {
      var _this3 = this;

      this.isFormLoading = true;
      axios.post("/Account/ResetPassword", this.ResetNewPassword, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var _this = _this3;
        _this.isFormLoading = false;
        if (response.data.isSuccess == true) {
          _this.isSuccess = true;
        } else {
          _this.validationResult = response.data.raw;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    CheckPasswordDigits: function CheckPasswordDigits() {
      var tempAccountPassword = this.validationResult.AccountPassword;
      if (this.ResetNewPassword.Password) {
        if (this.ResetNewPassword.Password.length > 0) {
          this.validationResult.AccountPassword = null;
          if (this.ResetNewPassword.Password.length < 6) {
            this.hasPasswordError = true;
            this.hasPasswordErrorMessage = "Password must be at least 6 characters";
          } else {
            this.hasPasswordError = false;
            this.hasPasswordErrorMessage = "";
          }
        }
      } else {}
    },
    CheckConfirmPasswordDigits: function CheckConfirmPasswordDigits() {
      var tempAccountPassword = this.validationResult.AccountPasswordConfirm;
      if (this.ResetNewPassword.PasswordConfirm) {
        if (this.ResetNewPassword.PasswordConfirm.length > 0) {
          this.validationResult.AccountPasswordConfirm = null;
          if (this.ResetNewPassword.PasswordConfirm.length < 6) {
            this.hasConfirmPasswordError = true;
            this.hasConfirmPasswordErrorMessage = "Password must be at least 6 characters";
          } else {
            this.hasConfirmPasswordError = false;
            this.hasConfirmPasswordErrorMessage = "";
          }
        }
      } else {}
    },
    CheckMatchPassword: function CheckMatchPassword() {
      var tempAccountPassword = this.validationResult.AccountPassword;
      var tempAccountPasswordConfirm = this.validationResult.AccountPasswordConfirm;
      if (this.ResetNewPassword.Password && this.ResetNewPassword.PasswordConfirm) {
        if (this.ResetNewPassword.Password.length > 0 && this.ResetNewPassword.PasswordConfirm.length > 0) {
          this.validationResult.AccountPassword = null;
          this.validationResult.AccountPasswordConfirm = null;
          if (this.ResetNewPassword.Password == this.ResetNewPassword.PasswordConfirm) {
            this.hasPasswordError = false;
            this.hasConfirmPasswordError = false;
            this.hasConfirmPasswordErrorMessage = "";
            this.CheckPasswordDigits();
            this.CheckConfirmPasswordDigits();
          } else {
            this.hasPasswordError = true;
            this.hasConfirmPasswordError = true;
            this.hasConfirmPasswordErrorMessage = "Password does not match";
          }
        }
      } else {}
    },
    RedirectHome: function RedirectHome() {
      window.location.href = "/";
    }
  },
  created: function created() {
    this.ValidateCode();
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_HelpForm__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_HelpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_HelpForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_AnnualForecastingModal__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_AnnualForecastingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_AnnualForecastingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registration_Pledge__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registration_Pledge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__registration_Pledge__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Pledge: __WEBPACK_IMPORTED_MODULE_5__registration_Pledge___default.a,
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a,
    LoadingComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default.a,
    HelpForm: __WEBPACK_IMPORTED_MODULE_3__components_shared_HelpForm___default.a,
    AnnualForecastingModal: __WEBPACK_IMPORTED_MODULE_4__components_portal_AnnualForecastingModal___default.a
  },
  data: function data() {
    return {
      Account: {
        SalesforceId: null,
        EmailAddress: null,
        Password: null,
        AccountType: null,
        FeedBack: null,
        UseCase: "",
        toBeContactedAsVolunteer: null,
        PrimaryContact: {
          LegalName: null,
          OfficeLocation: {
            NumberOfJobs: null,
            Jobs: {
              January: null,
              February: null,
              March: null,
              April: null,
              May: null,
              June: null,
              July: null,
              August: null,
              September: null,
              October: null,
              November: null,
              December: null
            }
          }
        }
      },
      q1: "How did you use CLTL last year?*",
      q2: "Do you have any other feedback, comments, or thoughts you would like to share about Changing Life through Lenses?",
      pledge: "The participant pledges to place the following number of charitable orders this calendar year.*",
      pledgeHelpText: "Please provide a best estimate. You can modify your estimate on the My Account page any time.",
      isLoadFinish: true,
      showForecastingModal: false,
      FormInputs: null,
      OfficeLocationValidationResult: {
        OfficeLocationZip: null
      },
      forecastServices: [],

      toBeContactedAsVolunteer: true
    };
  },

  methods: {
    GetAccountValues: function GetAccountValues() {
      var _this = this;
      this.isAccountLoading = true;
      axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        _this.Account = response.data.raw;
      }).catch(function (error) {
        console.log(error);
      });
    },
    GetForm: function GetForm(type) {
      this.FormInputs = this.FieldFlags[type];
    },
    getForecastServicesToPatients: function getForecastServicesToPatients() {
      var _this2 = this;

      axios.get("/Account/Forecasting/" + this.Account.SalesforceId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (res) {
        _this2.forecastServices = res.data.raw || [];
      });
    },
    SubmitForecast: function SubmitForecast() {
      var _this3 = this;

      this.isLoadFinish = false;
      var numberOfJobs = this.Account.PrimaryContact.OfficeLocation.NumberOfJobs;
      if (numberOfJobs < 100) {
        this.Account.PrimaryContact.OfficeLocation.Jobs = {
          January: null,
          February: null,
          March: null,
          April: null,
          May: null,
          June: null,
          July: null,
          August: null,
          September: null,
          October: null,
          November: null,
          December: null
        };
      }
      var totalOfJobs = this.SaveTotalJobs(this.Account.PrimaryContact.OfficeLocation.Jobs);
      if (numberOfJobs < totalOfJobs) {
        this.Account.PrimaryContact.OfficeLocation.NumberOfJobs = totalOfJobs;
      }
      this.Account.HowDoYouPlanOnServingThosePatient = this.forecastServices;
      this.Account.toBeContactedAsVolunteer = this.toBeContactedAsVolunteer;

      axios.post("/Account/UpdateForecasting", this.Account).then(function (response) {
        if (response.data.isSuccess) {
          var targetURL = localStorage.getItem("nextURL");
          if (targetURL != null) {
            _this3.GetToken(targetURL);
          } else {
            _this3.isLoadFinish = true;
            _this3.showForecastingModal = true;
          }
        } else {
          _this3.isLoadFinish = true;
          _this3.OfficeLocationValidationResult = response.data.raw.primaryContact.officeLocation.validationResult;
        }
      }).catch(function (error) {
        _this3.isLoadFinish = true;
        console.log(error);
      });
    },
    GetToken: function GetToken(targetURL) {
      var _this4 = this;

      axios.post("/Auth/TryRequestToken", this.Account).then(function (response) {
        if (response.data.isSuccess == true) {
          localStorage.setItem("token", response.data.raw.token);
          if (targetURL != null) {
            _this4.$router.push(targetURL);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    SaveTotalJobs: function SaveTotalJobs(job) {
      return (job.January ? parseInt(job.January) : 0) + (job.February ? parseInt(job.February) : 0) + (job.March ? parseInt(job.March) : 0) + (job.April ? parseInt(job.April) : 0) + (job.May ? parseInt(job.May) : 0) + (job.June ? parseInt(job.June) : 0) + (job.July ? parseInt(job.July) : 0) + (job.August ? parseInt(job.August) : 0) + (job.September ? parseInt(job.September) : 0) + (job.October ? parseInt(job.October) : 0) + (job.November ? parseInt(job.November) : 0) + (job.December ? parseInt(job.December) : 0);
    }
  },
  created: function created() {
    var accountType = localStorage.getItem("accountType");
    this.GetForm(accountType);
    this.getForecastServicesToPatients();
    this.Account.EmailAddress = localStorage.getItem("email");
    this.Account.Password = localStorage.getItem("password");
    this.Account.AccountType = accountType;
    this.Account.PrimaryContact.LegalName = localStorage.getItem("name");
    this.Account.SalesforceId = localStorage.getItem("salesforceId");
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      Account: {
        EmailAddress: null,
        Password: null
      },
      isLoading: false,
      isContractLoading: false
    };
  },

  methods: {
    Login: function Login() {
      var _this = this;
      _this.isLoading = true;
      axios.post('/Auth/TryRequestToken', this.Account).then(function (response) {
        if (response.data.isSuccess == true) {
          _this.isLoginfalse = false;
        }
        localStorage.removeItem('email');
        localStorage.removeItem('accountType');
        localStorage.removeItem('isCoveredUnderHIPAA');
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('password');
        _this.G_ProcessLogin(response);
      }).catch(function (error) {
        _this.$router.push({ name: 'Home' });
        _this.$router.push({ name: 'Error' });
      });
    },
    GeneratePdf: function GeneratePdf() {}
  },
  created: function created() {
    this.Account.EmailAddress = localStorage.getItem("email");
    this.Account.Password = localStorage.getItem("password");
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_ContractAgreementModal__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_ContractAgreementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_portal_ContractAgreementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_HelpForm__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_HelpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_HelpForm__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a, ContractAgreementModal: __WEBPACK_IMPORTED_MODULE_2__components_portal_ContractAgreementModal___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_3__components_shared_LoadingComponent___default.a, HelpForm: __WEBPACK_IMPORTED_MODULE_4__components_shared_HelpForm___default.a },
    data: function data() {
        return {
            Account: {
                emailAddress: null,
                AccountType: null,
                ParticipantResponsibilitiesSignature: null,
                TermAgreement: null,
                BusinessAssociateAgreementSignature: null,
                BusinessAssociateAgreement: null,
                IsCoveredUnderHIPAA: false,
                PrimaryContact: {
                    LegalName: null
                }
            },
            isLoading: false,
            AccountValidationResult: {},
            isContractModalShown: false,
            showHelpForm: false,
            ParticipantResponsibilitiesDate: new Date().getMonth() + 1 + "/" + new Date().getDate() + "/" + new Date().getFullYear(),
            BusinessAssociateAgreementDate: new Date().getMonth() + 1 + "/" + new Date().getDate() + "/" + new Date().getFullYear()
        };
    },

    methods: {
        UpdateContract: function UpdateContract() {
            var _this = this;
            this.isLoading = true;
            this.Account.PortalType = window.location.href.includes("championsforsight") ? "CFS" : "CLTL";
            if (!this.Account.IsCoveredUnderHIPAA || this.Account.IsCoveredUnderHIPAA == 'false') {
                delete this.Account.BusinessAssociateAgreementSignature;
                delete this.Account.BusinessAssociateAgreement;
            }
            axios.post('/Account/UpdateContract', this.Account).then(function (response) {
                if (response.data.isSuccess == false) {
                    _this.AccountValidationResult = response.data.raw.validationResult;
                } else {
                    _this.isContractModalShown = true;
                }
                _this.isLoading = false;
            }).catch(function (error) {
                console.log(error);
                _this.isLoading = false;
                _this.$router.push({ name: 'Error' });
            });
        },
        ToggleHelpForm: function ToggleHelpForm() {
            this.showHelpForm = !this.showHelpForm;
        },
        PromptDisagree: function PromptDisagree(val) {
            if (val == 1) {
                this.AccountValidationResult.TermAgreement = true;
            } else {
                this.AccountValidationResult.BusinessAssociateAgreement = true;
            }
        }
    },
    created: function created() {
        this.Account.emailAddress = localStorage.getItem("email");
        this.Account.AccountType = localStorage.getItem("accountType");
        this.Account.IsCoveredUnderHIPAA = localStorage.getItem("isCoveredUnderHIPAA");
        this.Account.PrimaryContact.LegalName = localStorage.getItem("name");
        this.Account.salesforceId = localStorage.getItem("salesforceId");
    }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    data: function data() {
        return {
            Account: {
                EmailAddress: null,
                Password: null
            },
            isLoading: false,
            isContractLoading: false,
            isAwaitingActivation: "false"
        };
    },

    methods: {
        Login: function Login() {
            var _this = this;
            _this.isLoading = true;
            console.log("Contract update ACCT STATUS: ");
            console.log(this.accountStatus);
            if (this.accountStatus != "Active") {
                _this.$router.push({ name: 'Home' });
                _this.isLoading = false;
            } else {
                axios.post('/Auth/TryRequestToken', this.Account).then(function (response) {
                    if (response.data.isSuccess == true) {
                        _this.isLoginfalse = false;
                    }
                    localStorage.removeItem('email');
                    localStorage.removeItem('accountType');
                    localStorage.removeItem('isCoveredUnderHIPAA');
                    localStorage.removeItem('firstName');
                    localStorage.removeItem('lastName');
                    localStorage.removeItem('password');
                    _this.G_ProcessLogin(response);
                }).catch(function (error) {
                    _this.$router.push({ name: 'Home' });
                    _this.$router.push({ name: 'Error' });
                });
            }
        },
        GeneratePdf: function GeneratePdf() {
            var _this = this;
            _this.isContractLoading = true;
            var salesforceId = _this.$route.params.salesforceId;
            axios.get("/Account/GetContractBySalesforceId/" + salesforceId, {
                headers: { Authorization: "Bearer " + localStorage.getItem("token") }
            }).then(function (response) {
                var result = response.data.raw;
                var link = document.createElement("a");
                link.href = result;
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                _this.isContractLoading = false;
            }).catch(function (error) {
                console.log(error);
                _this.$router.push({ name: 'Error' });
            });
        }
    },
    created: function created() {
        this.Account.EmailAddress = localStorage.getItem("email");
        this.Account.Password = localStorage.getItem("password");
        this.accountStatus = localStorage.getItem("accountStatus");
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a
  },
  data: function data() {
    return {
      fromRoute: null
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.fromRoute = from;
    });
  },


  methods: {
    RouterRedirect: function RouterRedirect(name) {
      this.$router.push({ name: name });
    },
    RedirectToSignUp: function RedirectToSignUp() {
      this.$router.push({ name: 'Registration', params: { type: 0 } });
    },
    GoBackOne: function GoBackOne() {
      this.$router.go(-1);
    },
    handleBack: function handleBack(fallback) {
      if (!this.fromRoute.name) {
        this.$router.push(fallback);
      } else {
        this.$router.back();
      }
    }
  },
  created: function created() {
    localStorage.setItem('is-active', 'Resources');
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_HelpArticle__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_HelpArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_HelpArticle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_HelpContact__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_HelpContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_HelpContact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_HelpInfo__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_HelpInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_HelpInfo__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a,
    HelpArticle: __WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_HelpArticle___default.a,
    HelpContact: __WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_HelpContact___default.a,
    HelpInfo: __WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_HelpInfo___default.a
  },
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {
    localStorage.setItem('is-active', 'help');
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_homeData_HomeBanner__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_homeData_HomeBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_portal_homeData_HomeBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_homeData_HomeIcons__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_homeData_HomeIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_portal_homeData_HomeIcons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_homeData_HomePromo__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_homeData_HomePromo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_homeData_HomePromo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_homeData_HomeBlock__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_homeData_HomeBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_portal_homeData_HomeBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_homeData_HomeStory__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_homeData_HomeStory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_homeData_HomeStory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_homeData_HomeInvite__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_homeData_HomeInvite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_homeData_HomeInvite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_homeData_HomeSupport__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_homeData_HomeSupport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_portal_homeData_HomeSupport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_CovidReliefModalForm__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_CovidReliefModalForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_shared_CovidReliefModalForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_CovidReliefFeedbackResultModal__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_CovidReliefFeedbackResultModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_shared_CovidReliefFeedbackResultModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_helpData_HelpInfo__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_helpData_HelpInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_portal_helpData_HelpInfo__);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a,
    HomeBanner: __WEBPACK_IMPORTED_MODULE_2__components_portal_homeData_HomeBanner___default.a,
    HomeIcons: __WEBPACK_IMPORTED_MODULE_3__components_portal_homeData_HomeIcons___default.a,
    HomePromo: __WEBPACK_IMPORTED_MODULE_4__components_portal_homeData_HomePromo___default.a,
    HomeBlock: __WEBPACK_IMPORTED_MODULE_5__components_portal_homeData_HomeBlock___default.a,
    HomeStory: __WEBPACK_IMPORTED_MODULE_6__components_portal_homeData_HomeStory___default.a,
    HomeInvite: __WEBPACK_IMPORTED_MODULE_7__components_portal_homeData_HomeInvite___default.a,
    CovidReliefModalForm: __WEBPACK_IMPORTED_MODULE_9__components_shared_CovidReliefModalForm___default.a,
    CovidReliefFeedbackResultModal: __WEBPACK_IMPORTED_MODULE_10__components_shared_CovidReliefFeedbackResultModal___default.a,
    HomeSupport: __WEBPACK_IMPORTED_MODULE_8__components_portal_homeData_HomeSupport___default.a,
    HelpInfo: __WEBPACK_IMPORTED_MODULE_11__components_portal_helpData_HelpInfo___default.a
  },

  props: ["HeaderComponent"],
  data: function data() {
    return {
      isCovidReliefModalFormShow: false,
      isCovidReliefFeedbackResultModalShow: false,
      crps: null,
      MasterAccount: null
    };
  },

  methods: {
    CtlModalForm: function CtlModalForm() {
      this.crps = localStorage.getItem("covidReliefParticipantStatus");
      this.isCovidReliefModalFormShow = !this.isCovidReliefModalFormShow;
      if (this.crps == "Declined" || this.crps == "Enrolled") {
        this.isCovidReliefFeedbackResultModalShow = !this.isCovidReliefFeedbackResultModalShow;
      }
    },
    CtlCovidReliefFeedbackResultModal: function CtlCovidReliefFeedbackResultModal() {
      this.isCovidReliefFeedbackResultModalShow = false;
    }
  },
  created: function created() {
    this.isActive = "home";
    localStorage.setItem("is-active", "home");
    this.MasterAccountType = localStorage.getItem("accountType");

    this.crps = localStorage.getItem("covidReliefParticipantStatus");
    var _cprs = this.crps;
    console.log("isCovidReliefStatusChecked", this.isCovidReliefStatusChecked);
    this.isCovidReliefStatusChecked = localStorage.getItem("isCovidReliefStatusChecked") || "false";
    if (this.isCovidReliefStatusChecked == "true") {
      this.isCovidReliefModalFormShow = false;
    } else {
      switch (_cprs) {
        case "":
          console.log("1");
        case undefined:
          console.log("2");
        case null:
          console.log("3");
        case "Not Seen":
          console.log("4");
        case "Reminder Requested":
          this.isCovidReliefModalFormShow = true;
          break;
        case "Enrolled":
        case "Declined":
          this.isCovidReliefModalFormShow = false;
          break;
        default:
          console.log("defaulting");
          this.isCovidReliefModalFormShow = true;
          break;
      }
    }
    console.log("crps", _cprs);
    console.log("this.isCovidReliefModalFormShow", this.isCovidReliefModalFormShow);
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingTable__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingFilters__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_HelpForm__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_HelpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_HelpForm__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent___default.a, OrderTrackingTable: __WEBPACK_IMPORTED_MODULE_5__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingTable___default.a, OrderTrackingFilters: __WEBPACK_IMPORTED_MODULE_6__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingFilters___default.a, HelpForm: __WEBPACK_IMPORTED_MODULE_7__components_shared_HelpForm___default.a },
    data: function data() {
        return {
            DispenseList: null,
            OrderList: [],
            SalesforceId: null,
            PageValues: {
                currentPage: 1,
                totalList: 70,
                itemsPerPage: 20
            },
            isDataLoading: true,
            SearchObject: [{ RefinerType: 'Keyword', RefinerValue: '' }, { RefinerType: "Date", RefinerValue: '' }, { RefinerType: "OrderStatus", RefinerValue: 'Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly' }],
            SortValues: {
                sortBy: 'default',
                sortOrder: 1
            },
            isModalShown: false,
            MasterAccountType: null,
            Account: {},
            searchValue: '',
            status: ['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed', 'Cancelled', 'PendingError', 'ExamOnly'],
            statusFilter: ['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed', 'Cancelled', 'PendingError', 'ExamOnly'],
            statusString: 'Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly'

        };
    },

    methods: {
        Reset: function Reset() {
            this.SearchObject = [{ RefinerType: 'Keyword', RefinerValue: '' }, { RefinerType: "Date", RefinerValue: '' }, { RefinerType: "OrderStatus", RefinerValue: 'Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly' }];
            this.GetOrderTableData(1);
        },
        GetAccountValues: function GetAccountValues() {
            var _this = this;
            this.isAccountLoading = true;
            axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.Account = response.data.raw;
            }).catch(function (error) {
                console.log(error);
            });
        },
        GetOrderTableData: function GetOrderTableData(initialLoad) {
            var _this = this;
            _this.isDataLoading = true;
            axios.post('/Order/ListValidOrders/' + this.PageValues.currentPage + '/' + this.PageValues.itemsPerPage + '/' + this.SortValues.sortBy + '/' + this.SortValues.sortOrder + '/' + initialLoad, this.SearchObject, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {

                _this.OrderList = response.data.raw.list;
                localStorage.setItem("orderTrackingList", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.OrderList));
                localStorage.setItem("resultCount", response.data.raw.resultCount.toString());
                _this.PageValues.totalList = response.data.raw.resultCount;
                _this.isDataLoading = false;

                _this.DispenseList = _this.OrderList.slice();
                _this.DispenseList.forEach(function (e) {
                    e.dispense = false;
                });
            }).catch(function (error) {
                console.log(error);
                _this.$router.push({ name: 'Error' });
            });
        },
        UpdateOrderStatus: function UpdateOrderStatus() {
            axios.get('/Order/UpdateOrderStatus', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {}).catch(function (error) {
                console.log(error);
            });
        },
        ShowModal: function ShowModal() {
            document.body.classList.add("body-overflow");
            this.isModalShown = !this.isModalShown;
        },
        CloseModal: function CloseModal() {
            this.isModalShown = false;
            document.body.classList.remove("body-overflow");
        }
    },
    created: function created() {
        var _this2 = this;

        var queryRoute = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$route.query).reduce(function (c, k) {
            return c[k.toLowerCase()] = _this2.$route.query[k], c;
        }, {});
        this.searchValue = queryRoute.search || '';

        this.statusFilter = this.status.filter(function (e) {
            var filter = queryRoute[e.toLowerCase()] || 'false';
            if (filter.toLowerCase() == 'true') {
                return true;
            } else {
                return false;
            }
        });

        if (this.statusFilter.length > 0) {
            var find = ',';
            var re = new RegExp(find, 'g');
            this.statusString = this.statusFilter.toString().replace(re, '|');
        } else {
            this.statusFilter = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.status));
        }

        this.SearchObject = [{ RefinerType: 'Keyword', RefinerValue: this.searchValue }, { RefinerType: "Date", RefinerValue: '' }, { RefinerType: "OrderStatus", RefinerValue: this.statusString }];

        this.MasterAccountType = localStorage.getItem("accountType");
        this.GetOrderTableData(0);
        this.UpdateOrderStatus();
        localStorage.setItem('is-active', 'track-order');
        this.GetAccountValues();
    }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_2__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pagination_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_pagination_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: { Datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_2_vue_pagination_2__["Pagination"] },
    props: ['OrderList', 'DispenseList', 'SearchObject', 'PageValues', 'isDataLoading', 'searchValue', 'statusFilter', 'statusString'],
    data: function data() {
        return {
            markDispenseModal: false,
            isDispensed: false,
            listToMarkDispense: [],
            dateDispense: null,
            theme: 'bootstrap4',
            chunk: 5,
            searchValueC: this.searchValue,
            format: 'MM/dd/yyyy',
            dateFrom: null,
            dateTo: null,
            statusFilterC: this.statusFilter,
            statusStringC: this.statusString,

            isFirstLoad: true,
            MasterAccountType: null
        };
    },

    watch: {
        searchValueC: function searchValueC(newValue) {
            this.$emit('update:searchValue', newValue);
        },
        statusFilterC: function statusFilterC(newValue) {
            this.$emit('update:statusFilter', newValue);
        },
        statusStringC: function statusStringC(newValue) {
            this.$emit('update:statusString', newValue);
        }
    },
    computed: {
        datepickerState: function datepickerState() {
            var disabledDate = {
                disabled: {
                    to: this.dateFrom
                }
            };
            return disabledDate;
        },
        computedIsLoading: {
            get: function get() {
                this.isDataLoading;
            },
            set: function set(newValue) {
                this.isDataLoading = newValue;
            }
        }
    },
    methods: {
        markDispenseModalClose: function markDispenseModalClose() {
            this.markDispenseModal = false;
            if (this.isDispensed) {
                this.isDispensed = false;
                this.$router.go();
            }
        },
        setPage: function setPage(page) {
            this.PageValues.currentPage = page;
            this.$emit("clicked");
        },
        SearchTable: function SearchTable() {
            this.PageValues.currentPage = 1;
            this.SearchObject[0].RefinerValue = this.searchValueC;
            if (this.dateFrom != null && this.dateTo != null) {
                this.SearchObject[1].RefinerValue = this.dateFrom + "|" + this.dateTo;
            }
            this.SearchObject[2].RefinerValue = this.statusStringC;
            this.$refs.pagination.setPage(1);
        },
        EmptySearch: function EmptySearch() {
            if (this.searchValueC.length == 0 || this.searchValueC == null) {
                this.SearchTable();
            }
        },
        MarkAsDispensed: function MarkAsDispensed() {
            var _this2 = this;

            var hasForMarking = false;
            var confirmDispensed = false;
            var dispenseAlert = false;
            var noDispenseList = [];
            var noDispenseText = "";
            for (var index = 0; index < this.DispenseList.length; index++) {
                if (this.DispenseList[index].dispense == true) {
                    hasForMarking = true;
                    if (this.DispenseList[index].orderStatus != "shipped" && this.DispenseList[index].orderStatus != "Shipped") {
                        noDispenseList.push(this.DispenseList[index]);
                        noDispenseText = noDispenseText + (this.DispenseList[index].patFirstName + ' ' + this.DispenseList[index].patLastName + ' : ' + this.DispenseList[index].orderStatus + ' \n');
                        dispenseAlert = true;
                    }
                }
            }
            if (hasForMarking == false) {
                alert("Please select order to dispense.");
                return;
            }

            var list = [];
            this.listToMarkDispense = [];
            if (this.DispenseList && this.DispenseList.length > 0) {
                list = this.DispenseList.filter(function (e) {
                    return (e.orderStatus == "shipped" || e.orderStatus == "Shipped") && e.dispense == true;
                });
            }
            list.forEach(function (e) {
                _this2.listToMarkDispense.push({ id: e.id, date: null });
            });

            if (this.listToMarkDispense.length == 0) {
                alert("Please select \"Shipped\" order to be marked as dispensed.");
                this.markDispenseModal = false;
                return;
            }

            if (dispenseAlert == true) {
                confirmDispensed = confirm('Please note, the following order(s) are not yet shipped and will not be marked as dispensed. \n\n ' + noDispenseText);
                if (confirmDispensed) {
                    this.markDispenseModal = true;
                }
            } else {
                this.markDispenseModal = true;
            }
        },
        SaveMarkForDispense: function SaveMarkForDispense() {
            var _this3 = this;

            this.isDataLoading = true;
            this.listToMarkDispense.forEach(function (e) {
                e.date = _this3.dateDispense;
            });

            var _this = this;
            axios.post('/Order/MarkDispensed', this.listToMarkDispense, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' }).then(function (response) {
                _this.isDispensed = true;
                _this.isDataLoading = false;
                _this.listToMarkDispense = [];
            }).catch(function (error) {
                console.log(error);
                _this.markDispenseModal = false;
                _this.isDataLoading = false;
                _this.listToMarkDispense = [];
            });
        },
        Reset: function Reset() {
            this.searchValueC = '';
            this.dateFrom = null;
            this.dateTo = null;

            this.statusStringC = 'Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly';
            this.statusFilterC = ["Pending", "PendingApproval", "InProcess", "Shipped", "Dispensed", "Cancelled", "PendingError", "ExamOnly"];
            this.statusFilter = ['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed', 'Cancelled', 'PendingError', 'ExamOnly'];
            this.$emit("reset");
        },
        ExportToExcel: function ExportToExcel() {
            var _this = this;
            _this.isDataLoading = true;
            var searchObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(_this.SearchObject);
            searchObject.push({ RefinerType: 'Count', RefinerValue: _this.PageValues.totalList });
            axios.post('/Order/ExportToExcel', searchObject, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' }).then(function (response) {

                var blob = new Blob([response.data], { type: 'text/csv' });
                __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(blob, "OrderTrackingList.csv");

                _this.isDataLoading = false;
            }).catch(function (error) {
                console.log(error);
                _this.$router.push({ name: 'Error' });
            });
        },
        FilterToString: function FilterToString(value) {
            var index = this.statusFilterC.findIndex(function (x) {
                return x == value;
            });
            if (index != -1) {
                this.statusFilterC.splice(index, 1);
            } else {
                this.statusFilterC.push(value);
            }
            var find = ',';
            var re = new RegExp(find, 'g');
            this.statusStringC = this.statusFilterC.toString().replace(re, '|');
            console.log("this.statusFilterC");
            console.log(this.statusFilterC);
            console.log("this.statusStringC");
            console.log(this.statusStringC);
            this.SearchTable();
        }
    },
    created: function created() {
        this.MasterAccountType = localStorage.getItem("accountType");

        this.statusFilterC = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.statusFilter));
        this.statusStringC = this.statusString;
        console.log("this.statusFilterC");
        console.log(this.statusFilterC);
        console.log("this.statusStringC");
        console.log(this.statusStringC);
        this.dateDispense = new Date();
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingVisionWebStatus__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingVisionWebStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingVisionWebStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_PromptComponent__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_PromptComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_PromptComponent__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: { PromptComponent: __WEBPACK_IMPORTED_MODULE_3__components_shared_PromptComponent___default.a, OrderTrackingVisionWebStatus: __WEBPACK_IMPORTED_MODULE_1__components_portal_OrderTracking_OrderTrackingComponents_OrderTrackingVisionWebStatus___default.a, Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a },
    props: ['OrderList', 'DispenseList', 'PageValues', 'isDataLoading', 'SortValues', 'MasterAccountType'],
    data: function data() {
        return {
            dateFrom: null,
            dateformat: 'MM/dd/yyyy',
            orderDispenseList: [],
            isEOrderDesc: false,
            isSubmittedDesc: false,
            isPatientNameDesc: false,
            isOrderStatusDesc: false,
            isLabAssignmentDesc: false,
            isLastNameDesc: false,
            promptMessage: 'Are you sure you want to delete this order?',
            isDeleteModelShown: false,
            idToDelete: null,
            br: '&#10;',
            isStatusModalShown: false,
            currentOrderNumber: null,
            currentVisionWebStatus: null,
            currentDateSubmitted: null
        };
    },

    methods: {
        AddToDispense: function AddToDispense(value, index, orderNumber, status) {
            console.log(this.DispenseList);
            if (value) {
                this.DispenseList[index].dispense = true;
            } else {
                this.DispenseList[index].dispense = false;
            }

            this.$emit('update:DispenseList', this.DispenseList);
        },
        Sort: function Sort(sortValue, sortOrder) {
            this.SortValues.sortBy = sortValue;
            this.SortValues.sortOrder = sortOrder;

            if (sortValue == 'id') {
                this.isEOrderDesc = !this.isEOrderDesc;
            } else if (sortValue == 'dateSubmitted') {
                this.isSubmittedDesc = !this.isSubmittedDesc;
            } else if (sortValue == 'patLastName') {
                this.isPatientNameDesc = !this.isPatientNameDesc;
            } else if (sortValue == 'orderStatus') {
                this.isOrderStatusDesc = !this.isOrderStatusDesc;
            } else if (sortValue == 'orderLab') {
                this.isLabAssignmentDesc = !this.isLabAssignmentDesc;
            } else if (sortValue == 'lastName') {
                this.isLastNameDesc = !this.isLastNameDesc;
            }
            this.$emit("sort");
        },
        ShowDeleteModal: function ShowDeleteModal(id) {
            this.idToDelete = id;
            this.isDeleteModelShown = true;
        },
        CloseDeleteModal: function CloseDeleteModal() {
            this.isDeleteModelShown = false;
        },
        DeleteOrder: function DeleteOrder() {
            var _this = this;
            this.isDeleteModelShown = false;
            var params = {
                Id: this.idToDelete
            };
            axios.post("/Order/Delete/", params, {
                headers: { Authorization: "Bearer " + localStorage.getItem("token") }
            }).then(function (response) {
                _this.$emit("delete");
            }).catch(function (error) {
                console.log(error);
            });
        },
        ViewVisionWebStatus: function ViewVisionWebStatus(orderNumber, status, dateSubmitted) {
            this.currentOrderNumber = orderNumber;
            this.currentVisionWebStatus = status;
            this.currentDateSubmitted = dateSubmitted;
            this.isStatusModalShown = true;
        },
        CloseVisionWebStatus: function CloseVisionWebStatus() {
            this.isStatusModalShown = false;
        },
        ViewOrder: function ViewOrder(id) {
            localStorage.setItem('trackorder-param', 'fromViewOrder');
            localStorage.setItem('url', 'null');
            var routeData = this.$router.resolve({ name: 'OrderConfirmation', params: { code: id, isSummaryOnly: "0" } });
            window.open(routeData.href, 'newwindow', 'width=' + parseInt(window.innerWidth) + ', height=' + parseInt(window.innerHeight) + '');
        },
        ViewExam: function ViewExam(id) {
            this.$router.push({ name: 'ExamConfirmation', params: { code: id, isSummaryOnly: '0' } });
        },
        EditOrder: function EditOrder(id) {
            localStorage.setItem('trackorder-param', 'null');
            localStorage.setItem('url', '/Portal/Order/' + id + '/0');
            this.$router.push({ name: 'Order', params: { code: id, EditOrReuse: 0 } });
        },
        IsEmpty: function IsEmpty(param) {
            if (param == null) return "";
            return param;
        },
        GetPortalUserId: function GetPortalUserId() {
            axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                localStorage.setItem("portalUserSalesforceId", response.data.raw.portalUserSalesforceId);
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    created: function created() {
        this.GetPortalUserId();
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    props: ['orderNumber', 'visionWebOrderStatus', 'dateSubmitted'],
    data: function data() {
        return {};
    },

    methods: {
        Close: function Close() {
            this.$emit('close');
        }
    },
    created: function created() {}
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_ServicePayment__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_ServicePayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_ServicePayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xkeshi_vue_barcode__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xkeshi_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__xkeshi_vue_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_PromptComponent__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_PromptComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_PromptComponent__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a, VueBarcode: __WEBPACK_IMPORTED_MODULE_4__xkeshi_vue_barcode___default.a, ServicePayment: __WEBPACK_IMPORTED_MODULE_3__components_shared_ServicePayment___default.a, PromptComponent: __WEBPACK_IMPORTED_MODULE_5__components_shared_PromptComponent___default.a },
  data: function data() {
    return {
      Order: {},
      Account: {},
      isDataLoading: true,
      MasterAccountType: null,
      isServicePaymentShown: false,
      isCoveredPaymentShown: false,
      isOrderValid: false,
      isDeleteModelShown: false,
      idToDelete: 0,
      promptMessage: 'Deleting this entry will remove it from your records and Track Order page.  Would you like to delete?',
      isOrderLoaded: false,
      doctor: null
    };
  },

  methods: {
    CloseDeleteModal: function CloseDeleteModal() {
      this.isDeleteModelShown = false;
    },
    ShowDeleteModal: function ShowDeleteModal(id) {
      this.idToDelete = id;
      this.isDeleteModelShown = true;
    },
    GetOrderData: function GetOrderData() {
      var _this = this;
      axios.get('/Order/Get/' + this.$route.params.code, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        if (response.data.isSuccess == false) {
          _this.isDataLoading = false;
          _this.isOrderValid = false;
          _this.isOrderLoaded = true;
        } else {
          _this.isOrderValid = true;
          _this.isDataLoading = false;
          _this.Order = response.data.raw;
          _this.Account = response.data.raw.accountDetails;
          if (_this.Order.jobType == 'FTC') {
            if (_this.$route.params.isSummaryOnly == '1') {
              _this.GenerateHtml();
            }
          }
          if (_this.Order.payment && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master') {
            _this.isCoveredPaymentShown = true;
          } else if (_this.Order.payment == false && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master') {
            _this.isServicePaymentShown = true;
          }

          axios.post('/Account/EyeDoctor/GetEyeDoctor/' + _this.Order.eyeDoctorId, _this.Account).then(function (response) {
            if (response.data.isSuccess == true) {
              _this.Account.eyeDoctors = response.data.raw;
              _this.doctor = _this.Account.eyeDoctors.filter(function (a) {
                return a.salesforceId == _this.Order.eyeDoctorId;
              })[0];
              _this.isLoaded = true;

              _this.isOrderLoaded = true;
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    GetAccountValues: function GetAccountValues() {
      var _this = this;
      axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        _this.Account = response.data.raw;
      }).catch(function (error) {
        console.log(error);
      });
    },
    GetAccountBySalesForce: function GetAccountBySalesForce() {
      var _this = this;
      _this.isDataLoading = true;

      axios.get('/Account/GetBySalesforceId/' + this.Order.accountId, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        _this.isDataLoading = false;
        _this.Account = response.data.raw;
      }).catch(function (error) {
        console.log(error);
      });
    },
    NewOrder: function NewOrder(id) {
      this.$router.push({ name: 'Order', params: { code: id, EditOrReuse: 2 } });
    },
    EditOrder: function EditOrder(id) {
      this.$router.push({ name: 'Order', params: { code: id, EditOrReuse: 0 } });
    },
    ReuseOrder: function ReuseOrder(id) {
      this.$router.push({ name: 'Order', params: { code: id, EditOrReuse: 1 } });
    },
    DeleteOrder: function DeleteOrder() {
      var _this = this;
      this.isDeleteModelShown = false;
      var params = {
        Id: this.idToDelete
      };
      axios.post("/Order/Delete/", params, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.$router.push({ name: 'OrderTracking' });
      }).catch(function (error) {
        console.log(error);
      });
    },
    GenerateHtml: function GenerateHtml() {
      var _this = this;
      var routeData = this.$router.resolve({ name: 'ExamSummary', query: { orderId: _this.Order.id } });

      window.open(routeData.href, '_blank', 'width=' + parseInt(window.innerWidth) + ', height=' + parseInt(window.innerHeight) + '');
    }
  },
  created: function created() {
    this.MasterAccountType = localStorage.getItem("accountType");
    this.GetOrderData();
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode__);


function InitialData(orderId) {
  return {
    Order: {},
    Account: {},
    isLoaded: false
  };
}



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a, VueBarcode: __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode___default.a },
  data: function data() {
    return InitialData();
  },

  mounted: function mounted() {
    this.GetOrderById(this.$route.query.orderId);
  },
  methods: {
    GetOrderById: function GetOrderById(orderId) {
      var _this = this;

      axios.get('/Order/GetOrderAccount/' + orderId, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        _this.Order = response.data.raw.order;
        _this.Account = response.data.raw.account;

        axios.post('/Account/EyeDoctor/GetEyeDoctor/' + _this.Order.eyeDoctorId, _this.Account).then(function (response) {
          if (response.data.isSuccess == true) {
            _this.Account.eyeDoctors = response.data.raw;
            _this.doctor = _this.Account.eyeDoctors.filter(function (a) {
              return a.salesforceId == _this.Order.eyeDoctorId;
            })[0];
            _this.isLoaded = true;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_HelpForm__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_HelpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_HelpForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_Order_OrderComponent_ParticipantAccountInformation__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_Order_OrderComponent_ParticipantAccountInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_Order_OrderComponent_ParticipantAccountInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_Order_OrderComponent_GeneralInformation__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_Order_OrderComponent_GeneralInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_Order_OrderComponent_GeneralInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_Order_OrderComponent_PatientInformation__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_Order_OrderComponent_PatientInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_portal_Order_OrderComponent_PatientInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_portal_Order_OrderComponent_OrderInformation__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_portal_Order_OrderComponent_OrderInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_portal_Order_OrderComponent_OrderInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_Order_OrderComponent_FrameInformation__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_Order_OrderComponent_FrameInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_portal_Order_OrderComponent_FrameInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_Order_OrderComponent_AdditionalInformation__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_Order_OrderComponent_AdditionalInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_portal_Order_OrderComponent_AdditionalInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_portal_Order_OrderComponent_OrderReview__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_portal_Order_OrderComponent_OrderReview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_portal_Order_OrderComponent_OrderReview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_shared_PageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_shared_LoadingComponent__);

















/* harmony default export */ __webpack_exports__["default"] = ({
      components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_3__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_FooterComponent___default.a, GeneralInformation: __WEBPACK_IMPORTED_MODULE_7__components_portal_Order_OrderComponent_GeneralInformation___default.a, PatientInformation: __WEBPACK_IMPORTED_MODULE_8__components_portal_Order_OrderComponent_PatientInformation___default.a,
            OrderInformation: __WEBPACK_IMPORTED_MODULE_9__components_portal_Order_OrderComponent_OrderInformation___default.a, FrameInformation: __WEBPACK_IMPORTED_MODULE_10__components_portal_Order_OrderComponent_FrameInformation___default.a, AdditionalInformation: __WEBPACK_IMPORTED_MODULE_11__components_portal_Order_OrderComponent_AdditionalInformation___default.a, OrderReview: __WEBPACK_IMPORTED_MODULE_12__components_portal_Order_OrderComponent_OrderReview___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_13__components_shared_PageLoader___default.a,
            LoadingComponent: __WEBPACK_IMPORTED_MODULE_14__components_shared_LoadingComponent___default.a, ParticipantAccountInformation: __WEBPACK_IMPORTED_MODULE_6__components_portal_Order_OrderComponent_ParticipantAccountInformation___default.a, HelpForm: __WEBPACK_IMPORTED_MODULE_5__components_shared_HelpForm___default.a },
      data: function data() {
            var _Order;

            return {
                  isOrderValid: false,
                  Order: (_Order = {
                        Id: 0,
                        IsOnly1DistancePD: false,
                        IsOnly1NearPD: false,
                        IsSpecialOrderNecessary: false,
                        ShippingUseDifferent: false,
                        DoesNotMeetRequirements: false,
                        JobType: '',
                        LensTreatment: [],
                        LensType: {},
                        LensTypeCode: '',
                        ReSph: '',
                        ReCyl: null,
                        ReAxis: null,
                        ReAdd: null,
                        ReSegHeight: null,
                        LeSph: null,
                        LeCyl: null,
                        LeAxis: null,
                        LeAdd: null,
                        LeSegHeight: null,
                        ReDistPD: null,
                        LeDistPD: null,
                        ReNearPD: null,
                        LeNearPD: null,
                        NearPD: null,
                        DistancePD: null,
                        LensDesign: null,
                        LensDesignObject: {
                              designCode: null
                        },
                        LensMaterial: null,
                        LensMaterialObject: {
                              code: null
                        },
                        FrameType: null,
                        EyeDoctorId: null,
                        PatFirstName: null,
                        PatLastName: null,
                        ReferralOrg: null,
                        ReferralCode: null,
                        PatDOB: null,
                        PatGender: null,
                        PatIsFirstTimeGlassesWearer: null,
                        PatEthnicity: null,
                        PatIsFirstTimeEyeExam: null
                  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "JobType", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameManufacturer", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameId", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameBrand", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameModel", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameColor", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameEyeSize", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameTempleLength", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShippingFullName", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShippingAddressLineOne", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShippingAddressLineTwo", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShippingSuite", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShippingCity", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShippingState", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShippingPostcode", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "isFirstLoad", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IsReuse", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "SpecialLabInstructions", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "AccountDetails", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "PortalUserSalesforceId", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "OrderLab", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "Age", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "DateSubmitted", new Date()), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "OriginalFrameChoice", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "SecondaryFrameChoice", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IsInternationalMission", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IsRemakeRedo", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "RemakeRedoComments", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "RemakeRedoReason", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IsExtra", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "OriginId", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IsExamOnly", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "DemographicId", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "OtherReferral", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ReferenceNoPo", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "DispenserNotes", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameFpc", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IncludeAdditionalRxFields", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "REHorizontalPrismValue", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "REHorizontalPrismDirection", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "REVerticalPrismValue", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "REVerticalPrismDirection", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "REOCHeight", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LEHorizPrismDirection", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LEVerticalPrismDirection", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LEHorizontalPrismValue", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LEHorizontalPrismDirection", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LEVerticalPrismValue", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LEVerticalPrismDirection", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LEOCHeight", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "FrameCollection", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LabBillTo", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LabDefaultShipTo", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LabId", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ShipToAccountOverride", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "RemakeSourceOrderId", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "OrderLabInfoId", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "SupplierName", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "PrescribingDoctorObject", {
                        salesforceId: null
                  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ClinicEvent", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "SchoolOrganization", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ClinicEventName", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "SchoolOrganizationName", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "RequiredClinicEvent", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ReManifestAcuity", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "LeManifestAcuity", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "PatWearingInstructions", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "StudentID", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "TeacherRoomNum", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IsReferredForEval", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ReferralReasons", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ReferralReasonsArray", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "ReferralNotes", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "IsUsingStockLensLab", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_Order, "DoNotRequireFrameMeasurement", false), _Order),
                  OrderReturn: {},
                  errorMessage: '',
                  isSuccess: false,
                  AccountEnums: ['Ethnicity', 'ReferralOrg', 'Suffix', 'State', 'PrismDirection'],
                  Ethnicity: {},
                  ReferralOrgSelect: {},
                  Suffix: {},
                  State: {},
                  PrismDirection: {},
                  ValidationResult: {},
                  Account: { primaryContact: { officeLocation: {} }, accountType: 0 },
                  VoucherList: [],
                  isLoadFinish: false,
                  isVoucherLoadFinish: false,
                  isSubmitFinish: false,
                  isSubmitFail: false,
                  isSubmitPending: false,
                  isAccountFinishLoading: false,
                  isModalReviewShown: false,
                  ToSave: null,
                  IsPending: null,
                  MasterAccountType: null,
                  AccountStatus: null,
                  Capping: { frameLensCount: 1 },
                  isThreshHoldShown: false,
                  isorderCapMet: false,
                  showHelpForm: false,
                  Voucher: {
                        Payment: false
                  },
                  isSaveChangesModalShown: false,
                  goToNext: null,
                  countDownTimer: null,
                  OrderSaveChanges: false,
                  submitPendingSave: false,
                  examOnlySave: false
            };
      },

      methods: {
            GetSelectValues: function GetSelectValues() {
                  var _this = this;
                  axios.post('/Util/GetEnums', this.AccountEnums, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                        _this.Ethnicity = response.data.raw.Ethnicity;
                        _this.Suffix = response.data.raw.Suffix;
                        _this.ReferralOrgSelect = response.data.raw.ReferralOrg;
                        _this.State = response.data.raw.State;
                        _this.PrismDirection = response.data.raw.PrismDirection;
                  }).catch(function (error) {
                        console.log('ERROR:', error);
                  });
            },
            AccountValue: function AccountValue(value) {
                  this.Account = value;
            },
            SubmitExamOnlyOrder: function SubmitExamOnlyOrder() {
                  var _this = this;
                  this.isSubmitFinish = true;
                  this.isSubmitFail = false;
                  this.Order.AccountDetails = this.Account;
                  this.Order.DateSubmitted = new Date();
                  this.Order.ReferralReasons = this.Order.ReferralReasonsArray.toString();

                  if (this.MasterAccountType) {
                        this.Order.AccountId = parseInt(this.Account.id);
                  }
                  if (this.Account.accountType == 1) {
                        this.Order.EyeDoctorId = this.Account.primaryContact.salesforceId;
                  }
                  axios.post('/Order/SaveChanges/', this.Order, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                        _this.isSubmitFinish = false;
                        if (response.data.isSuccess == false) {
                              _this.isSubmitFail = true;
                              _this.ValidationResult = response.data.raw.validationResult;
                              _this.$scrollTo("#errorDivOrder", 300, {
                                    el: "#errorDivOrder",
                                    offset: -100,
                                    x: false,
                                    y: true
                              });
                        } else {
                              _this.Order.Id = response.data.raw.id;
                              _this.examOnlySave = true;
                              _this.$router.push({ name: 'ExamConfirmation', params: { code: _this.Order.Id, isSummaryOnly: '0' } });

                              _this.isSubmitFail = false;
                        }
                  }).catch(function (error) {
                        console.log('ERROR:', error);
                        _this.$router.push({ name: 'Error' });
                  });
            },
            ValidateOrder: function ValidateOrder(isSave, isReview, isPending, masterAccountApprove) {

                  if (this.Order.ShippingAddressLineOne) {
                        var check_PO_BOX = this.checkIfAddressHasPO_BOX(this.Order.ShippingAddressLineOne);
                        if (check_PO_BOX == true) {
                              alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.");
                              return;
                        }
                  }
                  var _this = this;
                  this.isSubmitFinish = true;
                  this.isSubmitFail = false;
                  this.Order.ToSave = isSave;
                  this.Order.IsPending = isPending;
                  this.Order.AccountDetails = this.Account;
                  this.Order.DateSubmitted = new Date();
                  this.Order.PortalUserSalesforceId = _this.Account.portalUserSalesforceId;

                  if (this.Order.JobType == "FTC") {
                        this.Order.FrameEyeSize = this.Order.FrameEyeSize;
                        this.Order.FrameDBL = this.Order.FrameDBL;
                        this.Order.FrameBBox = null;
                        this.Order.FrameED = null;
                  }
                  if (this.Order.JobType == "UNC") {
                        this.Order.FrameEyeSize = this.Order.FrameEyeSize;
                        this.Order.FrameDBL = this.Order.FrameDBL;
                        this.Order.FrameBBox = this.Order.FrameBBox;
                        this.Order.FrameED = this.Order.FrameED == undefined || this.Order.FrameED == '' ? this.Order.FrameEyeSize * 1.05 : this.Order.FrameED;
                  }

                  this.Order.PortalUserSalesforceId = _this.Account.portalUserSalesforceId;
                  if (this.Order.IsRemakeRedo) {
                        if (this.Order.RemakeRedoReason != null || this.Order.RemakeRedoReason != null) {
                              this.Order.LensTreatment = this.Order.LensTreatment.filter(function (item) {
                                    return item !== "OTH-LABREDO";
                              });
                              this.Order.LensTreatment = this.Order.LensTreatment.filter(function (item) {
                                    return item !== "OTH-OPTERROR";
                              });
                              this.Order.LensTreatment = this.Order.LensTreatment.filter(function (item) {
                                    return item !== "OTH-OPENSOFT";
                              });
                              this.Order.LensTreatment.push(this.Order.RemakeRedoReason);
                        }
                  }
                  if (this.MasterAccountType) {
                        this.Order.AccountId = parseInt(this.Account.id);
                  }
                  if (this.Account.accountType == 1) {
                        this.Order.EyeDoctorId = this.Account.primaryContact.salesforceId;
                  }
                  this.Order.ReferralReasons = this.Order.ReferralReasonsArray.toString();
                  axios.post('/Order/SaveChanges/', this.Order, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                        _this.isSubmitFinish = false;
                        if (response.data.isSuccess == false) {
                              _this.isSubmitFail = true;
                              _this.ValidationResult = response.data.raw.validationResult;
                              _this.$scrollTo("#errorDivOrder", 300, {
                                    el: "#errorDivOrder",
                                    offset: -100,
                                    x: false,
                                    y: true
                              });
                        } else {
                              _this.Order.Id = response.data.raw.id;
                              _this.submitPendingSave = true;
                              if (isSave == 'false') {
                                    _this.isModalReviewShown = true;
                                    document.body.classList.add("body-overflow");
                                    _this.OrderReturn = response.data.raw;
                              } else {
                                    if (isReview == 'false') {
                                          _this.$router.push({ name: 'OrderSubmit', params: { code: response.data.raw.id, type: 0 } });
                                    } else {
                                          if (response.data.raw.orderStatus == 'PendingError' || response.data.raw.orderStatus == 'Review') {
                                                _this.$router.push({ name: 'OrderSubmit', params: { code: response.data.raw.id, type: 3 } });
                                          } else {
                                                if (response.data.raw.isSpecialOrderNecessary == true && masterAccountApprove == 'false') {
                                                      _this.$router.push({ name: 'OrderSubmit', params: { code: response.data.raw.id, type: 1 } });
                                                } else {
                                                      _this.$router.push({ name: 'OrderConfirmation', params: { code: response.data.raw.id, isSummaryOnly: "1" } });
                                                }
                                          }
                                    }
                                    document.body.classList.remove("body-overflow");
                              }
                              _this.isSubmitFail = false;
                        }
                  }).catch(function (error) {
                        console.log('ERROR:', error);
                        _this.$router.push({ name: 'Error' });
                  });
            },
            GetAccountValues: function GetAccountValues() {
                  var _this = this;
                  if (!this.MasterAccountType) {
                        axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                              if (_this.$route.params.code == null) {
                                    _this.isLoadFinish = true;
                              }
                              _this.isAccountFinishLoading = true;
                              _this.Account = response.data.raw;

                              if (_this.Account.primaryContact.officeLocation.streetAddress) _this.Account.primaryContact.officeLocation.streetAddress = _this.RemovePOBOX(_this.Account.primaryContact.officeLocation.streetAddress);
                              localStorage.setItem("portalUserSalesforceId", _this.Account.portalUserSalesforceId);
                              localStorage.setItem("customUserPermissionFlag", _this.Account.customUserPermissionFlag);

                              localStorage.setItem("stock_Lens_Account_Number__c", _this.Account.stock_Lens_Account_Number__c);
                              localStorage.setItem("stock_Lens_Lab_Assignment__c", _this.Account.stock_Lens_Lab_Assignment__c);
                              localStorage.setItem("stock_Lens_Lab_Bill_To__c", _this.Account.stock_Lens_Lab_Bill_To__c);
                              localStorage.setItem("stock_Lens_Lab_ID__c", _this.Account.stock_Lens_Lab_ID__c);
                              localStorage.setItem("stock_Lens_Lab_PCAT__c", _this.Account.stock_Lens_Lab_PCAT__c);
                              localStorage.setItem("stock_Lens_Lab_Ship_To__c", _this.Account.stock_Lens_Lab_Ship_To__c);
                              localStorage.setItem("stock_Lens_Lab_Ship_to_Override__c", _this.Account.stock_Lens_Lab_Ship_to_Override__c);

                              _this.Order.RequiredClinicEvent = _this.Account.customUserPermissionFlag.includes("Show Clinics and Schools");
                              _this.Order.ShowExtraStudentFields = _this.Account.customUserPermissionFlag.includes("Show Extra Student Fields");
                        }).catch(function (error) {
                              console.log('ERROR:', error);
                        });
                  } else {
                        this.isLoadFinish = true;
                        this.isAccountFinishLoading = true;
                  }
            },
            GetOrderCount: function GetOrderCount() {
                  var _this = this;
                  axios.get('order/GetOrderCount', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                        _this.Capping = response.data.raw;
                        if (_this.Capping.orderCap - _this.Capping.orderCount <= _this.Capping.orderThreshold && _this.Capping.orderCount < _this.Capping.orderCap && _this.MasterAccountType != 'master' && _this.Capping.isOrderCapOn) {
                              _this.isThreshHoldShown = true;
                        }
                        if (_this.Capping.orderCount >= _this.Capping.orderCap && _this.MasterAccountType != 'master' && _this.Capping.isOrderCapOn) {
                              _this.isorderCapMet = true;
                        }
                  }).catch(function (error) {
                        console.log('ERROR:', error);
                  });
            },
            GetVouchers: function GetVouchers() {
                  var _this = this;
                  axios.get('/Order/ListVoucher', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                        _this.VoucherList = response.data.raw;
                        _this.isVoucherLoadFinish = true;
                  }).catch(function (error) {
                        console.log('ERROR:', error);
                  });
            },
            setOriginalOrder: function setOriginalOrder() {
                  localStorage.setItem("originalOrder", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.Order));
            },
            EditForm: function EditForm() {
                  this.isOrderValid = true;
                  if (this.$route.params.code) {
                        this.isLoadFinish = false;
                        var _this = this;
                        var retVal = null;
                        var framePageVisible = localStorage.getItem("frameAndLensOrderIsAllowed");
                        axios.get('/Order/Get/' + this.$route.params.code, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                              _this.isLoadFinish = true;
                              if (response.data.isSuccess == false) {
                                    _this.isOrderValid = false;
                              } else {
                                    _this.isOrderValid = true;
                                    retVal = response.data.raw;

                                    if (_this.$route.params.EditOrReuse != 1 && _this.$route.params.EditOrReuse != 3) {
                                          _this.Order.Id = retVal.id;
                                          _this.Order.IsRemakeRedo = retVal.isRemakeRedo;
                                          _this.Order.RemakeRedoComments = retVal.remakeRedoComments;
                                          _this.Order.RemakeRedoReason = retVal.remakeRedoReason;
                                          _this.Order.IsExtra = retVal.isExtra;
                                          _this.Order.OriginId = retVal.originId;
                                    } else {
                                          if (_this.$route.params.EditOrReuse == 3) {
                                                _this.Order.Id = 0;
                                                _this.Order.IsReuse = false;
                                                _this.Order.IsRemakeRedo = false;
                                                _this.Order.RemakeRedoComments = null;
                                                _this.Order.RemakeRedoReason = null;
                                                _this.Order.RemakeSourceOrderId = retVal.remakeSourceOrderId;
                                                _this.Order.OriginId = retVal.originId;
                                                _this.Order.IsExtra = true;
                                          } else {
                                                _this.Order.IsReuse = true;
                                                _this.Order.IsRemakeRedo = true;
                                                _this.Order.RemakeSourceOrderId = retVal.remakeSourceOrderId;
                                                _this.Order.RemakeRedoComments = retVal.remakeRedoComments;
                                                _this.Order.RemakeRedoReason = retVal.remakeRedoReason;
                                                _this.Order.OriginId = retVal.originId;
                                          }
                                    }

                                    if (_this.$route.params.EditOrReuse == 2 || _this.$route.params.EditOrReuse == 3) {
                                          _this.Order.IsExamOnly = false;
                                    } else {
                                          _this.Order.IsExamOnly = retVal.isExamOnly;
                                          _this.Order.OriginId = retVal.originId;
                                    }

                                    _this.Order.OrderId = retVal.orderId;
                                    _this.Order.FrameId = retVal.frameId;
                                    _this.Order.IsOnly1DistancePD = retVal.isOnly1DistancePD;
                                    _this.Order.IsOnly1NearPD = retVal.isOnly1NearPD;
                                    _this.Order.IsSpecialOrderNecessary = retVal.isSpecialOrderNecessary;
                                    _this.Order.DoesNotMeetRequirements = retVal.doesNotMeetRequirements;
                                    _this.Order.ShippingUseDifferent = retVal.shippingUseDifferent;
                                    _this.Order.PatGender = retVal.patGender;
                                    _this.Order.OrderStatus = retVal.orderStatus;
                                    _this.Order.OriginId = retVal.originId;

                                    if (framePageVisible == "true") {
                                          _this.Order.JobType = retVal.jobType;
                                    } else if (retVal.jobType != "LSF") {
                                          _this.Order.JobType = retVal.jobType;
                                    } else {
                                          _this.Order.JobType = null;
                                    }
                                    if (_this.MasterAccountType == 'master') {
                                          _this.Account = retVal.accountDetails;
                                          _this.Order.JobType = retVal.jobType;
                                    }
                                    _this.Order.LensTreatment = retVal.lensTreatment;
                                    _this.Order.LensTypeCode = retVal.lensTypeCode;
                                    _this.Order.ReSph = retVal.reSph;
                                    _this.Order.ReCyl = retVal.reCyl;
                                    _this.Order.ReAxis = retVal.reAxis;
                                    _this.Order.ReAdd = retVal.reAdd;
                                    _this.Order.ReSegHeight = retVal.reSegHeight;
                                    _this.Order.LeSph = retVal.leSph;
                                    _this.Order.LeCyl = retVal.leCyl;
                                    _this.Order.LeAxis = retVal.leAxis;
                                    _this.Order.LeAdd = retVal.leAdd;
                                    _this.Order.LeSegHeight = retVal.leSegHeight;
                                    _this.Order.ReDistPD = retVal.reDistPD;
                                    _this.Order.LeDistPD = retVal.leDistPD;
                                    _this.Order.ReNearPD = retVal.reNearPD;
                                    _this.Order.LeNearPD = retVal.leNearPD;
                                    _this.Order.NearPD = retVal.nearPD;
                                    _this.Order.DistancePD = retVal.distancePD;
                                    _this.Order.LensDesign = retVal.lensDesign;
                                    _this.Order.LensMaterial = retVal.lensMaterial;
                                    _this.Order.EyeDoctorId = retVal.eyeDoctorId;
                                    _this.Order.PatFirstName = retVal.patFirstName;
                                    _this.Order.PatLastName = retVal.patLastName;
                                    _this.Order.ReferralOrg = retVal.referralOrg;
                                    _this.Order.ReferralCode = retVal.referralCode;
                                    _this.Order.PatDOB = retVal.patDOB;
                                    _this.Order.PatIsFirstTimeGlassesWearer = retVal.patIsFirstTimeGlassesWearer;
                                    _this.Order.PatEthnicity = retVal.patEthnicity;
                                    _this.Order.PatIsFirstTimeEyeExam = retVal.patIsFirstTimeEyeExam;
                                    _this.Order.FrameManufacturer = retVal.frameManufacturer;
                                    _this.Order.FrameBrand = retVal.frameBrand;
                                    _this.Order.FrameModel = retVal.frameModel;
                                    _this.Order.FrameType = retVal.frameType;
                                    _this.Order.FrameColor = retVal.frameColor;
                                    _this.Order.FrameEyeSize = retVal.frameEyeSize;
                                    _this.Order.FrameDBL = retVal.frameDBL;
                                    _this.Order.FrameED = retVal.frameED;
                                    _this.Order.FrameCheckMeasurements = retVal.frameCheckMeasurements;
                                    _this.Order.FrameBBox = retVal.frameBBox;
                                    _this.Order.FrameTempleLength = retVal.frameTempleLength;
                                    _this.Order.ShippingFullName = retVal.shippingFullName;
                                    _this.Order.ShippingAddressLineOne = _this.RemovePOBOX(retVal.shippingAddressLineOne);
                                    _this.Order.ShippingAddressLineTwo = _this.RemovePOBOX(retVal.shippingAddressLineTwo);
                                    _this.Order.ShippingSuite = retVal.shippingSuite;
                                    _this.Order.ShippingCity = retVal.shippingCity;
                                    _this.Order.ShippingState = retVal.shippingState;
                                    _this.Order.ShippingPostcode = retVal.shippingPostcode;
                                    _this.Order.DispenserNotes = retVal.dispenserNotes;
                                    _this.Order.SpecialLabInstructions = retVal.specialLabInstructions;
                                    _this.Order.SpecialInstructions1 = retVal.specialInstructions1;
                                    _this.Order.OrderLab = retVal.orderLab;
                                    _this.Order.ErrorMessage = retVal.errorMessage;
                                    _this.Order.isFirstLoad = true;
                                    _this.Order.OriginalFrameChoice = retVal.originalFrameChoice;
                                    _this.Order.SecondaryFrameChoice = retVal.secondaryFrameChoice;
                                    _this.Order.FrameFpc = retVal.frameFpc;
                                    _this.Order.IsInternationalMission = retVal.isInternationalMission;
                                    _this.Order.Age = retVal.age;
                                    _this.Order.PatEthnicity = retVal.patEthnicity;
                                    _this.Order.PatGender = retVal.patGender;
                                    _this.Order.PatIsFirstTimeEyeExam = retVal.patIsFirstTimeEyeExam;
                                    _this.Order.PatIsFirstTimeGlassesWearer = retVal.patIsFirstTimeGlassesWearer;
                                    _this.Order.DemographicId = retVal.demographicId;
                                    _this.Order.OtherReferral = retVal.otherReferral;
                                    _this.Order.ReferenceNoPo = retVal.referenceNoPo;
                                    _this.Order.IncludeAdditionalRxFields = retVal.includeAdditionalRxFields;
                                    _this.Order.REHorizontalPrismValue = retVal.reHorizontalPrismValue;
                                    _this.Order.REVerticalPrismValue = retVal.reVerticalPrismValue;
                                    _this.Order.LEHorizontalPrismValue = retVal.leHorizontalPrismValue;
                                    _this.Order.LEVerticalPrismValue = retVal.leVerticalPrismValue;

                                    _this.Order.REHorizontalPrismDirection = _this.ConvertToTitleCase(retVal.reHorizontalPrismDirection);
                                    _this.Order.REVerticalPrismDirection = _this.ConvertToTitleCase(retVal.reVerticalPrismDirection);
                                    _this.Order.LEHorizontalPrismDirection = _this.ConvertToTitleCase(retVal.leHorizontalPrismDirection);
                                    _this.Order.LEVerticalPrismDirection = _this.ConvertToTitleCase(retVal.leVerticalPrismDirection);
                                    _this.Order.LEOCHeight = retVal.leocHeight;
                                    _this.Order.REOCHeight = retVal.reocHeight;
                                    _this.Order.FrameCollection = retVal.frameCollection;
                                    _this.Order.LabBillTo = retVal.labBillTo;
                                    _this.Order.LabDefaultShipTo = retVal.labDefaultShipTo;
                                    _this.Order.LabId = retVal.labId;
                                    _this.Order.ShipToAccountOverride = retVal.shipToAccountOverride;
                                    _this.Order.SupplierName = retVal.supplierName;
                                    _this.Order.OrderLabInfoId = retVal.orderLabInfoId;
                                    _this.Order.ClinicEvent = retVal.clinicEvent;
                                    _this.Order.SchoolOrganization = retVal.schoolOrganization;
                                    _this.Order.ClinicEventName = retVal.clinicEventName;
                                    _this.Order.SchoolOrganizationName = retVal.schoolOrganizationName;

                                    _this.Order.ReManifestAcuity = retVal.patientDemographic.reManifestAcuity;
                                    _this.Order.LeManifestAcuity = retVal.patientDemographic.leManifestAcuity;
                                    _this.Order.PatWearingInstructions = retVal.patientDemographic.patWearingInstructions;

                                    _this.Order.StudentID = retVal.patientDemographic.studentID;
                                    _this.Order.TeacherRoomNum = retVal.patientDemographic.teacherRoomNum;
                                    _this.Order.IsReferredForEval = retVal.patientDemographic.isReferredForEval;
                                    _this.Order.ReferralReasons = retVal.patientDemographic.referralReasons;
                                    _this.Order.ReferralNotes = retVal.patientDemographic.referralNotes;
                                    _this.Order.ReferralReasonsArray = retVal.patientDemographic.referralReasons != null ? retVal.patientDemographic.referralReasons.split(',') : [];
                                    localStorage.setItem('orderObj', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.Order));
                              }
                        }).catch(function (error) {
                              console.log('ERROR:', error);
                              _this.$router.push({ name: 'Error' });
                        });
                  }
            },
            showModal: function showModal() {
                  document.body.classList.add("body-overflow");
                  this.isModalReviewShown = !this.isModalReviewShown;
            },
            closeModal: function closeModal() {
                  this.isModalReviewShown = false;
                  this.submitPendingSave = false;
                  document.body.classList.remove("body-overflow");
            },
            ToggleHelpForm: function ToggleHelpForm() {
                  this.showHelpForm = !this.showHelpForm;
            },
            CloseSaveChangesModal: function CloseSaveChangesModal(value) {
                  this.goToNext = value;
                  this.isSaveChangesModalShown = false;
                  document.body.classList.remove("body-overflow");
            }
      },
      created: function created() {
            this.MasterAccountType = localStorage.getItem("accountType");
            this.GetVouchers();
            this.GetSelectValues();
            this.GetAccountValues();
            this.EditForm();
            this.setOriginalOrder();
            this.AccountStatus = localStorage.getItem("accountStatus");
            if (this.MasterAccountType != 'master') {
                  this.GetOrderCount();
            }
            localStorage.setItem('is-active', 'order');
            localStorage.removeItem('orderObj');
            localStorage.setItem('orderObj', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.Order));
      },
      beforeRouteLeave: function beforeRouteLeave(to, from, next) {
            if (!this.OrderSaveChanges || this.isModalReviewShown || this.submitPendingSave || this.examOnlySave) {
                  next();
            } else {
                  var _confirm = confirm('Are you sure you want to leave this page? Your order information will not be saved.  To save the info, please select “Save as Pending Order” at the bottom of the page.');
                  if (_confirm) {
                        localStorage.setItem('logout_session_acc', true);
                        next();
                  } else {
                        localStorage.setItem('logout_session_acc', false);
                  }
            }
      },

      watch: {
            Order: {
                  handler: function handler(val, oldVal) {
                        var tempOldObject = JSON.parse(localStorage.getItem("orderObj"));

                        if (val.LensTypeCode == undefined) {
                              tempOldObject.LensTypeCode = val.LensTypeCode;
                        }
                        var _oldObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tempOldObject);
                        var oldObject = JSON.parse(_oldObject);
                        var _newOjb = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(val);
                        var newObject = JSON.parse(_newOjb);

                        var oldArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(oldObject).map(function (k) {
                              return oldObject[k];
                        });
                        var newArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newObject).map(function (k) {
                              return newObject[k];
                        });

                        var arrCtr = 0;
                        var undefinedCtr = 0;
                        var hasChangesCount = 0;
                        var getUndefined = [];
                        var hasChanges = false;

                        oldArray.forEach(function (element) {
                              if (newArray[arrCtr] === undefined) {
                                    undefinedCtr++;
                              }
                              if (newArray[arrCtr] == element) {} else {
                                    if (typeof newArray[arrCtr + undefinedCtr] === 'string' || newArray[arrCtr] instanceof String) {
                                          if (newArray[arrCtr] != "") {
                                                hasChanges = true;
                                                hasChangesCount++;
                                          }
                                    } else {}
                              }
                              arrCtr++;
                        });

                        if (hasChangesCount == 2 && newObject.DateSubmitted != null) {
                              this.OrderSaveChanges = false;
                        } else if (hasChanges) this.OrderSaveChanges = true;else {
                                    this.OrderSaveChanges = false;
                              }
                  },
                  deep: true
            }
      }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Order", "Account", "State", "ValidationResult", "MasterAccountType"],
  components: { LoadingComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default.a, Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a },
  data: function data() {
    return {
      isLoadingAddress: false,
      isValidAddress: false,
      labList: [],
      selectedLab: null
    };
  },

  methods: {
    addressChanged: function addressChanged(evt) {
      if (this.Order.ShippingAddressLineOne) {
        var check_PO_BOX = this.checkIfAddressHasPO_BOX(this.Order.ShippingAddressLineOne.toString());
        if (check_PO_BOX == true) {
          alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.");
          return;
        }
      }
    },
    acuityPrefixR: function acuityPrefixR() {
      var prefix = "20/";
      if (this.Order.ReManifestAcuity.indexOf(prefix) !== 0 & this.Order.ReManifestAcuity != '') {
        this.Order.ReManifestAcuity = prefix + this.Order.ReManifestAcuity;
      }
    },
    acuityPrefixL: function acuityPrefixL() {
      var prefix = "20/";
      if (this.Order.LeManifestAcuity.indexOf(prefix) !== 0 & this.Order.LeManifestAcuity != '') {
        this.Order.LeManifestAcuity = prefix + this.Order.LeManifestAcuity;
      }
    },
    ValidateAddress: function ValidateAddress() {
      this.isLoadingAddress = true;
      var _this = this;
      if (true) {
        var params = {
          Address2: this.Order.ShippingAddressLineOne,
          City: this.Order.ShippingCity,
          State: this.Order.ShippingState,
          Zip5: this.Order.ShippingPostcode,
          Suite: this.Order.ShippingSuite
        };
        axios.post("/Account/GetAddressDetails/", params).then(function (response) {
          if (response.data.isSuccess) {
            var details = response.data.raw;

            _this.isLoadingAddress = false;
            _this.isValidAddress = true;

            _this.Order.ShippingAddressLineOne = details.address2;
            _this.Order.ShippingAddressLineTwo = details.suite;
            _this.Order.ShippingCity = details.city;
            _this.Order.ShippingState = details.state;
            _this.Order.ShippingPostCode = details.zip5;

            _this.ValidationResult.OrderShippingPostCode = null;
          } else {
            _this.isLoadingAddress = false;
            _this.isValidAddress = false;

            _this.ValidationResult.OrderShippingPostCode = response.data.errorMessage;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    GetOrderLab: function GetOrderLab() {
      var _this = this;
      axios.get("Account/GetOrderLab", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.labList = response.data.raw;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    if (this.MasterAccountType == "master") {
      this.GetOrderLab();
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_PageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_Order_OrderComponent_ParticipantAccountInformation__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_Order_OrderComponent_ParticipantAccountInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_portal_Order_OrderComponent_ParticipantAccountInformation__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_1__components_shared_PageLoader___default.a },
  props: ["Order", "ValidationResult", "Capping", "MasterAccountType", "isFrameLensServiceFee", "Account"],
  data: function data() {
    return {
      JobType: null,
      FrameType: null,
      FrameAndLens: [],
      CurrentFrameAndLens: null,
      FrameAndLensIndex: 0,
      isFalLoaded: false,
      currentJobType: null,
      framePageVisible: localStorage.getItem("frameAndLensOrderIsAllowed"),
      isModalShown: false,
      isFrameSizeModalShown: false,
      suggestedFrameList: [],
      isFormLoading: false
    };
  },

  methods: {
    customLabel: function customLabel(_ref) {
      var name = _ref.name,
          color = _ref.color,
          eyeSize = _ref.eyeSize,
          frameType = _ref.frameType,
          catalogId = _ref.catalogId;

      return "Name/Model: " + name + "  -  Color: " + color + "  -  Eyesize: " + eyeSize + "  -  Frame Type: " + frameType + " -  Catalog: " + catalogId;
    },
    GetFrameInformation: function GetFrameInformation(portalUserSalesforceId) {
      var _this = this;
      axios.get("/Order/Catalog/ListJobType", { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        _this.JobType = response.data.raw;
        if (_this.framePageVisible == "false") _this.JobType = _this.RemoveFrameLens(_this.JobType);
      }).catch(function (error) {
        console.log(error);
      });
    },
    CheckVal: function CheckVal(type) {
      this.Order.JobType = type;
      this.currentJobType = type;
    },
    FrameAndLensValue: function FrameAndLensValue(isSelectedSuggestedFrame) {
      this.Order.FrameProgramAssignments = this.CurrentFrameAndLens.frameProgramAssignments;
      this.Order.CatalogId = this.CurrentFrameAndLens.catalogId;
      this.Order.FrameManufacturer = this.CurrentFrameAndLens.manufacturer;
      this.Order.FrameModel = this.CurrentFrameAndLens.name;
      this.Order.FrameColor = this.CurrentFrameAndLens.color;
      this.Order.FrameEyeSize = this.CurrentFrameAndLens.eyeSize;
      this.Order.FrameTempleLength = this.CurrentFrameAndLens.templeLength;
      this.Order.FrameType = this.CurrentFrameAndLens.frameType;
      this.Order.FrameId = this.CurrentFrameAndLens.id;
      this.Order.FrameBrand = this.CurrentFrameAndLens.frameBrand;
      this.Order.FrameFpc = this.CurrentFrameAndLens.frameFpc;
      if (this.CurrentFrameAndLens.isOutOfStock) {
        this.GetFramesSuggestion(this.Order.FrameId);
        this.ShowModal();
      } else {
        if (!isSelectedSuggestedFrame) {
          this.Order.OriginalFrameChoice = null;
          this.Order.SecondaryFrameChoice = null;
        }
      }
    },
    GetFrameAndLens: function GetFrameAndLens(portalUserSalesforceId) {
      var _this = this;

      axios.get("/Order/Catalog/ListFrameInformation" + "/" + portalUserSalesforceId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.FrameAndLens = response.data.raw;
        if (_this.Order.JobType) {
          var frameIndex = _this.FrameAndLens.findIndex(function (x) {
            return x.id == _this.Order.FrameId;
          });
          _this.CurrentFrameAndLens = _this.FrameAndLens[frameIndex];
          _this.FrameAndLensValue(true);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    GetFrameType: function GetFrameType() {
      var _this = this;
      axios.get("/Order/Catalog/ListFrame", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.FrameType = response.data.raw;
      }).catch(function (error) {
        console.log(error);
      });
    },
    OpenHelpForm: function OpenHelpForm() {
      this.$emit("help");
    },
    ShowModal: function ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = true;
    },
    ShowFrameSizeModal: function ShowFrameSizeModal() {
      document.body.classList.add("body-overflow");
      this.isFrameSizeModalShown = true;
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    CloseFrameSizeModal: function CloseFrameSizeModal() {
      this.isFrameSizeModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    GetFramesSuggestion: function GetFramesSuggestion(id) {
      var _this = this;
      this.isFormLoading = true;
      axios.post("/Order/Catalog/ListFrameSuggestions", { id: id }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      }).then(function (response) {
        _this.suggestedFrameList = response.data.raw;
        _this.isFormLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: "Error" });
      });
    },
    SelectFrameSuggestion: function SelectFrameSuggestion(frame) {
      this.Order.OriginalFrameChoice = this.CurrentFrameAndLens.id;
      this.Order.SecondaryFrameChoice = frame.id;
      var isSelectedSuggestedFrame = true;
      this.CurrentFrameAndLens = frame;
      this.FrameAndLensValue(isSelectedSuggestedFrame);
      this.CloseModal();
    },
    CloseOOSModal: function CloseOOSModal() {
      this.CurrentFrameAndLens = null;
      this.CloseModal();
    },
    ImageExists: function ImageExists(_frame) {
      _frame.frontImageURL = '../../../../../static/assets/img/evf-frame.png';
    },
    RemoveFrameLens: function RemoveFrameLens(frames) {
      return frames.filter(function (e) {
        return e.id != 17;
      });
    },
    ClickNoFrameMeasurements: function ClickNoFrameMeasurements() {
      this.Order.FrameCheckMeasurements = !this.Order.FrameCheckMeasurements;
      if (this.Order.JobType == 'FTC') {
        if (!this.Order.FrameCheckMeasurements) {
          this.Order.FrameEyeSize = null;
          this.Order.FrameDBL = null;
        } else {
          this.Order.FrameEyeSize = 57;
          this.Order.FrameDBL = 15;
        }
      }
      if (this.Order.JobType == 'UNC') {
        if (!this.Order.FrameCheckMeasurements) {
          this.Order.FrameEyeSize = null;
          this.Order.FrameDBL = null;
          this.Order.FrameBBox = null;
          this.Order.FrameED = null;
        } else {
          this.Order.FrameEyeSize = 57;
          this.Order.FrameDBL = 15;
          this.Order.FrameBBox = 18;
          this.Order.FrameED = 58;
        }
      }
    }
  },
  watch: {
    Account: function Account(newAcct, oldAcct) {
      console.log("SelectedAccount watcher");
      console.log(oldAcct);
      console.log(newAcct);
      this.GetFrameAndLens(newAcct.portalUserSalesforceId);
    }
  },
  created: function created() {
    var portalUserSalesforceId = localStorage.getItem("portalUserSalesforceId");
    if (this.Account) {
      console.log("Selected account is logged in: ", this.Account.portalUserSalesforceId === portalUserSalesforceId);
      portalUserSalesforceId = this.Account.portalUserSalesforceId;
    }

    console.log("Selected account: ", portalUserSalesforceId);
    this.GetFrameInformation(portalUserSalesforceId);
    this.GetFrameType();
    this.GetFrameAndLens(portalUserSalesforceId);
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_MultiSelectCheckbox__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_MultiSelectCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_MultiSelectCheckbox__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Order", "ReferralOrgSelect", "Suffix", "ValidationResult", "Account", "State", "VoucherList", "Voucher"],
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default.a, MultiSelectCheckbox: __WEBPACK_IMPORTED_MODULE_3__components_shared_MultiSelectCheckbox___default.a },
  data: function data() {
    return {
      option: null,
      Doctor: {
        UseLicenseNumber: false,
        NpiNumber: null
      },
      useLicenseNumber: false,
      isModalShown: false,
      DoctorValidation: { EyeDoctorNpiNumber: null },
      isLoading: false,
      isVoucherShown: false,
      isReferralCodeRequired: false,
      ReferralObject: null,
      isVoucherCodeValid: false,
      voucherValidation: {},
      originalLenstreatment: [],
      isVoucherRequireValidation: false,

      ClinicEvent: { clinicEventId: '', name: '' },
      ClinicEventList: [],
      disable_SchoolOrganization: true,
      SchoolOrganization: {},
      SchoolOrganizationList: [],
      isUpdateCacheAndRefreshLoading: false,

      falsex: false,
      truex: true,
      checkedProxy: false
    };
  },

  methods: {
    iDontHaveNPINumber: function iDontHaveNPINumber() {
      this.Doctor.UseLicenseNumber = !this.Doctor.UseLicenseNumber;
      if (this.Doctor.UseLicenseNumber == true) this.DoctorValidation.EyeDoctorNpiNumber = null;
    },
    RamakeRedoCheck: function RamakeRedoCheck(val) {
      if (val) {
        this.Order.RemakeRedoReason = 'OTH-LABREDO';
        this.Order.RemakeRedoComments = '';
      }
    },
    ClearFirstTimeGlasses: function ClearFirstTimeGlasses(ExamOnlyVal) {
      if (this.Order.IsExamOnly == true) {
        this.Order.PatIsFirstTimeGlassesWearer = null;
      };
    },
    SetPrescribingDoctorID: function SetPrescribingDoctorID(eyeDoctorId) {
      this.Order.EyeDoctorId = eyeDoctorId;
    },
    ShowModal: function ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = true;
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
      this.Doctor.NpiNumber = "";
      this.DoctorValidation.EyeDoctorNpiNumber = null;
    },
    AddDoctorForThisJobOnly: function AddDoctorForThisJobOnly() {
      if (this.useLicenseNumber == false && this.IsNPINumberValid() == false) {
        alert("Please make sure all required fields are complete.");
        return;
      }
      var _this = this;
      this.isLoading = true;

      axios.post("/Account/EyeDoctor/SaveChangesForOrder/" + this.Account.salesforceId, this.Doctor, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      }).then(function (response) {
        _this.isLoading = false;
        _this.DoctorValidation = response.data.raw.validationResult;
        if (response.data.isSuccess == true) {
          _this.Account.eyeDoctors = _this.Account.eyeDoctors || [];
          _this.Account.eyeDoctors.push({
            salesforceId: response.data.raw.salesforceId,
            lastName: response.data.raw.lastName,
            firstName: response.data.raw.firstName,
            suffix: response.data.raw.suffix,
            eyeDoctorFullName: response.data.raw.lastName + ", " + response.data.raw.firstName
          });

          var index = _this.Account.eyeDoctors.findIndex(function (x) {
            return x.salesforceId == response.data.raw.salesforceId;
          });
          _this.Order.PrescribingDoctorObject = _this.Account.eyeDoctors[index];
          _this.isModalShown = false;
          _this.Order.EyeDoctorId = response.data.raw.salesforceId;
          document.body.classList.remove("body-overflow");
        } else {
          console.log(error);
          alert("An Error occurred.");
          _this.isLoading = false;
        }
      }).catch(function (error) {
        console.log('ERROR:', error);
      });
    },
    AddDoctorAndUseNow: function AddDoctorAndUseNow() {
      if (this.useLicenseNumber == false && this.IsNPINumberValid() == false) {
        alert("Please make sure all required fields are complete.");
        return;
      }
      var _this = this;
      this.isLoading = true;

      axios.post("/Account/EyeDoctor/SaveDoctor/" + this.Account.salesforceId, this.Doctor, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      }).then(function (response) {
        _this.isLoading = false;
        _this.DoctorValidation = response.data.raw.validationResult;
        if (response.data.isSuccess == true) {
          _this.Account.eyeDoctors = _this.Account.eyeDoctors || [];
          _this.Account.eyeDoctors.push({
            salesforceId: response.data.raw.salesforceId,
            lastName: response.data.raw.lastName,
            firstName: response.data.raw.firstName,
            suffix: response.data.raw.suffix,
            eyeDoctorFullName: response.data.raw.lastName + ", " + response.data.raw.firstName
          });

          var index = _this.Account.eyeDoctors.findIndex(function (x) {
            return x.salesforceId == response.data.raw.salesforceId;
          });
          _this.Order.PrescribingDoctorObject = _this.Account.eyeDoctors[index];
          _this.isModalShown = false;
          _this.Order.EyeDoctorId = response.data.raw.salesforceId;
          document.body.classList.remove("body-overflow");
        } else if (response.data.isSuccess == false) {
          alert("An error occurred.");
        }
      }).catch(function (error) {
        console.log('ERROR:', error);
      });
    },
    IsNPINumberValid: function IsNPINumberValid() {
      if (this.Doctor.NpiNumber && this.Doctor.NpiNumber.length == 10) {
        return true;
      } else {
        return false;
      }
    },
    changedNPINumber: function changedNPINumber() {
      if (this.IsNPINumberValid() == true) {
        this.DoctorValidation.EyeDoctorNpiNumber = null;
      } else {
        this.DoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number";
      }
    },
    GetOrderEyeDoctor: function GetOrderEyeDoctor() {
      var _this = this;
      if (_this.Order.EyeDoctorId == null) return;
      axios.post('/Account/EyeDoctor/GetEyeDoctor/' + _this.Order.EyeDoctorId, _this.Account).then(function (response) {
        if (response.data.isSuccess == true) {
          _this.Account.eyeDoctors = response.data.raw;
          var index = _this.Account.eyeDoctors.findIndex(function (x) {
            return x.salesforceId == _this.Order.EyeDoctorId;
          });
          _this.Order.PrescribingDoctorObject = _this.Account.eyeDoctors[index];
        }
      }).catch(function (error) {
        console.log('ERROR:', error);
      });
    },
    NumberCheck: function NumberCheck(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    CheckVouchers: function CheckVouchers() {
      if (this.ReferralObject) {
        this.isVoucherShown = this.ReferralObject.showReferralField;
        this.isReferralCodeRequired = this.ReferralObject.referralFieldRequired;
        this.isVoucherRequireValidation = this.ReferralObject.validationRequired;
        this.Order.ReferralOrg = this.ReferralObject.name;
      }
    },
    CheckSelectedReferralOrg: function CheckSelectedReferralOrg() {
      var _this2 = this;

      if (this.Order.ReferralOrg) {
        var index = this.VoucherList.findIndex(function (x) {
          return x.name == _this2.Order.ReferralOrg;
        });
        this.ReferralObject = this.VoucherList[index];
      }
      this.CheckVouchers();
    },
    ValidateNpiNumberNewDoctor: function ValidateNpiNumberNewDoctor() {
      var _this = this;
      var npiNumber = _this.Doctor.NpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.DoctorDetails = { NpiNumber: npiNumber };
        axios.post('/Account/IsNpiNumberValidEyeDoctor/', _this.DoctorDetails).then(function (response) {
          if (response.data.isSuccess) {
            _this.DoctorValidation = { EyeDoctorNpiNumber: null };
            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];
            _this.Doctor.FirstName = basicDetails.first_name;
            _this.Doctor.LastName = basicDetails.last_name;
            _this.Doctor.Suffix = basicDetails.credential;
            _this.isLoading = false;
          } else {
            _this.DoctorValidation = { EyeDoctorNpiNumber: response.data.errorMessage };
            _this.Doctor.FirstName = null;
            _this.Doctor.LastName = null;
            _this.Doctor.Suffix = null;
            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log('ERROR:', error);
        });
      } else {
        _this.DoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number";
      }
    },
    ValidateVoucherCode: function ValidateVoucherCode(voucherCode) {
      if (this.isVoucherRequireValidation) {
        if (voucherCode) {
          var _this = this;
          this.isLoading = true;
          this.isVoucherCodeValid = false;
          var data = {
            AssignmentGroup: _this.Order.ReferralOrg,
            VoucherId: voucherCode
          };
          axios.post('/order/IsVoucherCodeValid/', data, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
            _this.isLoading = false;
            if (response.data.isSuccess == false) {
              _this.voucherValidation.OrderReferralCode = response.data.errorMessage;
            } else {
              _this.isVoucherCodeValid = true;
              _this.voucherValidation = {};
              _this.Voucher.Payment = response.data.raw.payment;
            }
          }).catch(function (error) {
            console.log('ERROR:', error);
          });
        } else {
          this.voucherValidation = {};
        }
      } else {
        this.voucherValidation = {};
      }
    },
    APIGetClinicEventList: function APIGetClinicEventList() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var _this = this;
      _this.isUpdateCacheAndRefreshLoading = true;
      var list = JSON.parse(localStorage.getItem("ClinicEventList")) || [];
      if (list.length > 0 && refresh == false) {
        _this.ClinicEventList = JSON.parse(localStorage.getItem("ClinicEventList"));
        if (_this.ClinicEventList && _this.ClinicEventList.length == 1) _this.InitiateClinicEventSelectObj(_this.ClinicEventList);
        if (_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) this.UpdateClinicEventSelectObj();
        _this.isUpdateCacheAndRefreshLoading = false;
      } else {
        axios.get('/Order/GetClinicEventList/' + localStorage.getItem("portalUserSalesforceId"), { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
          _this.isUpdateCacheAndRefreshLoading = false;
          _this.UpdateClinicEventList(response.data.raw);
          console.log(response.data.raw);
          if (response.data.raw && response.data.raw.length == 1) _this.InitiateClinicEventSelectObj(response.data.raw);
          if (_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) _this.UpdateClinicEventSelectObj();
        }).catch(function (error) {
          console.log('ERROR:', error);
        });
      }
    },
    APIGetSchoolOrganizationList: function APIGetSchoolOrganizationList() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var _this = this;
      _this.isUpdateCacheAndRefreshLoading = true;
      var list = JSON.parse(localStorage.getItem("SchoolOrganizationList_" + id)) || [];
      if (list.length > 0 && refresh == false) {
        _this.SchoolOrganizationList = JSON.parse(localStorage.getItem("SchoolOrganizationList_" + id));
        _this.disable_SchoolOrganization = false;
        if (_this.SchoolOrganizationList && _this.SchoolOrganizationList.length == 1) _this.InitiateSchoolOrganizationObj(_this.SchoolOrganizationList);
        if (_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) this.UpdateSchoolOrganizationObj();
        _this.isUpdateCacheAndRefreshLoading = false;
        this.UpdateOrder();
      } else {
        axios.get('/Order/GetSchoolOrganizationList/' + id, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
          _this.UpdateSchoolOrganizationList(id, response.data.raw);
          _this.disable_SchoolOrganization = false;
          if (response.data.raw && response.data.raw.length == 1) _this.InitiateSchoolOrganizationObj(response.data.raw);
          if (_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) this.UpdateSchoolOrganizationObj();
          _this.isUpdateCacheAndRefreshLoading = false;
          _this.UpdateOrder();
        }).catch(function (error) {
          _this.isUpdateCacheAndRefreshLoading = false;
          console.log('ERROR:', error);
        });
      }
    },

    ClinicEventChangedEvent: function ClinicEventChangedEvent(e) {
      if (this.ClinicEvent && this.ClinicEvent.clinicEventId) {
        this.APIGetSchoolOrganizationList(this.ClinicEvent.clinicEventId, false);
      } else {
        console.log("ERROR: no updating clinic");
      }
    },
    UpdateCacheAndRefresh: function UpdateCacheAndRefresh() {
      this.Order.ClinicEvent = null;
      this.SchoolOrganization = null;

      this.Order.SchoolOrganization = null;
      this.ClinicEventList = [];
      this.SchoolOrganizationList = [];
      this.disable_SchoolOrganization = true;

      localStorage.removeItem("ClinicEventList");
      var arr = [];
      for (var i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).substring(0, 23) == 'SchoolOrganizationList_') {
          arr.push(localStorage.key(i));
        }
      }

      for (var i = 0; i < arr.length; i++) {
        localStorage.removeItem(arr[i]);
      }
      var _this = this;
      setTimeout(function () {
        _this.APIGetClinicEventList(true);
      }, 444);
    },
    UpdateOrder: function UpdateOrder() {
      this.Order.ClinicEvent = this.ClinicEvent.clinicEventId;
      this.Order.SchoolOrganization = this.SchoolOrganization.schoolOrganizationId;
      this.Order.ClinicEventName = this.ClinicEvent.name;
      this.Order.SchoolOrganizationName = this.SchoolOrganization.school_Organization_Name__c;
      this.Order.ReferenceNoPo = this.SchoolOrganization.default_Order_PO__c;
    },
    UpdateClinicEventList: function UpdateClinicEventList(val) {
      this.ClinicEventList = val;
      localStorage.setItem("ClinicEventList", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
    },
    UpdateSchoolOrganizationList: function UpdateSchoolOrganizationList(id, val) {
      this.SchoolOrganizationList = val;
      localStorage.setItem("SchoolOrganizationList_" + id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
    },
    InitiateSchoolOrganizationObj: function InitiateSchoolOrganizationObj(list) {
      this.SchoolOrganization = list[0];
    },
    InitiateClinicEventSelectObj: function InitiateClinicEventSelectObj(list) {
      this.ClinicEvent = list[0];
      this.APIGetSchoolOrganizationList(list[0].clinicEventId, false);
    },
    UpdateSchoolOrganizationObj: function UpdateSchoolOrganizationObj() {
      var _this3 = this;

      var index = this.SchoolOrganizationList.findIndex(function (x) {
        return x.schoolOrganizationId === _this3.Order.SchoolOrganization;
      });
      this.disable_SchoolOrganization = false;
      this.SchoolOrganization = index > -1 ? this.SchoolOrganizationList[index] : null;
    },
    UpdateClinicEventSelectObj: function UpdateClinicEventSelectObj() {
      var _this4 = this;

      if (this.ClinicEventList && this.ClinicEventList.length > 0) {
        if (this.Order.ClinicEvent && this.Order.ClinicEvent != "") {
          var index = this.ClinicEventList.findIndex(function (x) {
            return x.clinicEventId === _this4.Order.ClinicEvent;
          });
          this.ClinicEvent = index > -1 ? this.ClinicEventList[index] : null;
          this.APIGetSchoolOrganizationList(this.Order.ClinicEvent, false);
        }
      }
    },
    SetCustomUserPermissionFlag: function SetCustomUserPermissionFlag() {}
  },
  created: function created() {
    var AccountType = localStorage.getItem("accountType");
    this.CheckSelectedReferralOrg();
    if (!this.Account.eyeDoctors) {
      this.Account.eyeDoctors = [];
    }
    if (this.Account.accountType == 3 && (this.Order.ReferralOrg == null || this.Order.ReferralOrg == '')) {
      this.ReferralObject = this.VoucherList[0];
      this.isVoucherShown = this.ReferralObject.showReferralField;
      this.isReferralCodeRequired = this.ReferralObject.referralFieldRequired;
      this.isVoucherRequireValidation = this.ReferralObject.validationRequired;
      this.Order.ReferralOrg = this.ReferralObject.name;
    }

    this.SetCustomUserPermissionFlag();
  },

  mounted: function mounted() {
    var _this5 = this;

    if (this.$route.params.EditOrReuse != null || this.$route.params.EditOrReuse != undefined) {
      this.ClinicEventList = JSON.parse(localStorage.getItem("ClinicEventList"));
      if (this.ClinicEventList == null) this.ClinicEventList = [];
      var indexC = this.ClinicEventList.findIndex(function (x) {
        return x.clinicEventId === _this5.Order.ClinicEvent;
      });
      if (this.ClinicEventList[0] == null || indexC == -1) {
        this.ClinicEventList.unshift({
          clinicEventId: this.Order.ClinicEvent,
          name: this.Order.ClinicEventName
        });
        this.ClinicEvent = this.ClinicEventList[0];
      } else {
        this.ClinicEvent = this.ClinicEventList[indexC];
      }
      console.log(localStorage);
      this.SchoolOrganizationList = JSON.parse(localStorage.getItem("SchoolOrganizationList_" + this.Order.ClinicEvent));
      if (this.SchoolOrganizationList == null) this.SchoolOrganizationList = [];
      var indexO = this.SchoolOrganizationList.findIndex(function (x) {
        return x.schoolOrganizationId === _this5.Order.SchoolOrganization;
      });
      if (this.SchoolOrganizationList[0] == null || indexO == -1) {
        this.SchoolOrganizationList.unshift({
          schoolOrganizationId: this.Order.SchoolOrganization,
          school_Organization_Name__c: this.Order.SchoolOrganizationName
        });
        this.SchoolOrganization = this.SchoolOrganizationList[0];
      } else {
        this.SchoolOrganization = this.SchoolOrganizationList[indexO];
      }
      if (this.$route.params.EditOrReuse == '0') {
        this.disable_SchoolOrganization = false;
      }
    } else {
      this.APIGetClinicEventList(false);
    }

    this.GetOrderEyeDoctor();
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RxInput_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RxInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RxInput_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: { Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a, RxInput: __WEBPACK_IMPORTED_MODULE_4__RxInput_vue___default.a },
    props: ["Order", "PrismDirection", "ValidationResult", "MasterAccountType"],
    data: function data() {
        return {
            stock_Lens_Account_Number__c: "",
            stock_Lens_Lab_Assignment__c: "",
            stock_Lens_Lab_Bill_To__c: "",
            stock_Lens_Lab_ID__c: "",
            stock_Lens_Lab_PCAT__c: "",
            stock_Lens_Lab_Ship_To__c: "",
            stock_Lens_Lab_Ship_to_Override__c: "",

            showLensStock: false,
            sphere: [],
            cylinder: [],
            axis: [],
            addition: [],
            height: [],
            distancePd: [],
            nearPd: [],
            isOneDistance: false,
            isOneNear: false,
            lensDesign: [],
            lensType: [],
            lensMaterial: [],
            lensTreatment: [],
            lensTreatmentMaster: [],
            singleDistancePd: [],
            singleNearPd: [],
            isDisabled: false,
            isLensDesignLoading: false,
            isLensMaterialLoading: false,
            incompatabilityList: [],
            lensTreatmentLength: 0,
            selectedLensTreatment: [],
            isCompatibleLoading: false,
            lensSuggestionTimeout: null,
            lensTreatmentTimeout: null,
            lensMaterialTimeout: null,
            isLensDesignDisabled: false,
            isLensDesignLoadingx: false,
            isLensMaterialLoadingx: false,
            Order_DistancePD: null,
            gg: null
        };
    },

    computed: {
        ComputedDistancePD: function ComputedDistancePD() {
            return this.Order.DistancePD;
        },
        ComputedNearPD: function ComputedNearPD() {
            return this.Order.NearPD;
        },
        ComputedLeSph: function ComputedLeSph() {
            return this.Order.LeSph;
        },
        ComputedReSph: function ComputedReSph() {
            return this.Order.ReSph;
        },
        ComputedLeCyl: function ComputedLeCyl() {
            return this.Order.LeCyl;
        },
        ComputedReCyl: function ComputedReCyl() {
            return this.Order.ReCyl;
        },
        ComputedLeAdd: function ComputedLeAdd() {
            return this.Order.LeAdd;
        },
        ComputedReAdd: function ComputedReAdd() {
            return this.Order.ReAdd;
        },
        ComputedLensDesignObject: function ComputedLensDesignObject() {
            return this.Order.LensDesignObject;
        },
        ComputedIsLensDesignDisabled: function ComputedIsLensDesignDisabled() {
            return this.isLensDesignDisabled || this.lensDesign.length == 0;
        }
    },
    watch: {
        lensTreatment: function lensTreatment(val) {
            if (val.length == 1) {
                this.selectedLensTreatment = val[0];
            }
        },
        lensDesign: function lensDesign(val) {
            if (val.length == 1) {
                this.Order.LensDesignObject = val[0];
                this.Order.LensDesign = val[0].designCode;
                this.GetMaterialSuggestion();
            }
        },
        lensMaterial: function lensMaterial(val) {
            if (val.length == 1) {
                this.Order.LensMaterialObject = val[0];
                this.Order.LensMaterial = val[0].code;
            }
            this.Order.LensTreatment = [];
            this.LensMaterialDependency(this.Order.LensDesignObject.designCode, this.Order.LensMaterialObject.code);
        },

        ComputedDistancePD: {
            immediate: true,
            handler: function handler(val) {
                this.Order.DistancePD = val;
                if (val > 0) {
                    var minSize = 20;
                    var maxSize = 40;
                    var stepSize = 0.50;
                    var fixedSize = 1;
                    var half = val / 2;
                    var unrounded = Math.min(Math.max(half, minSize), maxSize);

                    this.Order.ReDistPD = unrounded;
                    this.Order.LeDistPD = unrounded;
                }
            }
        },
        ComputedNearPD: {
            immediate: true,
            handler: function handler(val) {
                this.Order.NearPD = val;
                if (val > 0) {
                    var minSize = 20;
                    var maxSize = 40;
                    var stepSize = 0.50;
                    var fixedSize = 2;
                    var half = val / 2;
                    var unrounded = Math.min(Math.max(half, minSize), maxSize);

                    this.Order.LeNearPD = unrounded;
                    this.Order.ReNearPD = unrounded;
                }
            }
        },
        ComputedLeSph: {
            immediate: true,
            handler: function handler(val) {
                var _this2 = this;

                this.CheckIfLensSpecsIsCompleted();
                if (this.lensSuggestionTimeout) {
                    clearTimeout(this.lensSuggestionTimeout);
                }
                this.isLensDesignDisabled = true;
                this.lensSuggestionTimeout = setTimeout(function () {
                    return _this2.GetLensDesignSuggestion();
                }, 1000);
            }
        },
        ComputedReSph: {
            immediate: true,
            handler: function handler(val) {
                var _this3 = this;

                this.CheckIfLensSpecsIsCompleted();
                if (this.lensSuggestionTimeout) {
                    clearTimeout(this.lensSuggestionTimeout);
                }
                this.isLensDesignDisabled = true;
                this.lensSuggestionTimeout = setTimeout(function () {
                    return _this3.GetLensDesignSuggestion();
                }, 1000);
            }
        },
        ComputedLeCyl: {
            immediate: true,
            handler: function handler(val) {
                var _this4 = this;

                this.CheckIfLensSpecsIsCompleted();
                if (this.lensSuggestionTimeout) {
                    clearTimeout(this.lensSuggestionTimeout);
                }

                this.lensSuggestionTimeout = setTimeout(function () {
                    return _this4.GetLensDesignSuggestion();
                }, 2000);
            }
        },
        ComputedReCyl: {
            immediate: true,
            handler: function handler(val) {
                var _this5 = this;

                this.CheckIfLensSpecsIsCompleted();
                if (this.lensSuggestionTimeout) {
                    clearTimeout(this.lensSuggestionTimeout);
                }

                this.lensSuggestionTimeout = setTimeout(function () {
                    return _this5.GetLensDesignSuggestion();
                }, 2000);
            }
        },
        ComputedLeAdd: {
            immediate: true,
            handler: function handler(val) {
                var _this6 = this;

                if (this.lensSuggestionTimeout) {
                    clearTimeout(this.lensSuggestionTimeout);
                }

                this.lensSuggestionTimeout = setTimeout(function () {
                    return _this6.GetLensDesignSuggestion();
                }, 2000);
            }
        },
        ComputedReAdd: {
            immediate: true,
            handler: function handler(val) {
                var _this7 = this;

                if (this.lensSuggestionTimeout) {
                    clearTimeout(this.lensSuggestionTimeout);
                }

                this.lensSuggestionTimeout = setTimeout(function () {
                    return _this7.GetLensDesignSuggestion();
                }, 2000);
            }
        },
        ComputedLensDesignObject: function ComputedLensDesignObject(val) {
            if (val.designCode == null) {
                this.lensMaterial = [];
            }
        }
    },
    methods: {
        CheckIfLensSpecsIsCompleted: function CheckIfLensSpecsIsCompleted() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var ReCyl, LeCyl, ReSph, LeSph, LensValue;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log('LensType :>> ', _this8.Order.LensType);
                                console.log('LensTypeCode :>> ', _this8.Order.LensTypeCode);
                                console.log('LensLabPCAT :>> ', _this8.stock_Lens_Lab_PCAT__c);

                                if (!(_this8.Order.LensTypeCode != null && _this8.Order.LensTypeCode != '' && _this8.Order.LensTypeCode == "SV" && _this8.Order.ReSph != null && _this8.Order.LeSph != null)) {
                                    _context.next = 19;
                                    break;
                                }

                                ReCyl = _this8.Order.ReCyl == null ? "0.00" : _this8.Order.ReCyl;
                                LeCyl = _this8.Order.LeCyl == null ? "0.00" : _this8.Order.LeCyl;

                                ReCyl = ReCyl.replace(/\+/, '');
                                LeCyl = LeCyl.replace(/\+/, '');
                                ReSph = _this8.Order.ReSph.replace(/\+/, '');
                                LeSph = _this8.Order.LeSph.replace(/\+/, '');


                                console.log('ReCyl :>> ', ReCyl);
                                console.log('LeCyl :>> ', LeCyl);

                                _context.next = 14;
                                return _this8.GetLensPcat(_this8.stock_Lens_Lab_PCAT__c, ReSph, ReCyl, LeSph, LeCyl);

                            case 14:
                                LensValue = _context.sent;

                                console.log(LensValue);

                                if (ReSph == LeSph && LeCyl == ReCyl && LensValue && LensValue.length > 0) {
                                    _this8.showLensStock = true;
                                    _this8.Order.IsUsingStockLensLab = true;
                                } else if (LensValue && LensValue.length > 1) {
                                    _this8.showLensStock = true;
                                    _this8.Order.IsUsingStockLensLab = true;
                                } else {
                                    _this8.Order.IsUsingStockLensLab = false;
                                    _this8.showLensStock = false;
                                }

                                _context.next = 21;
                                break;

                            case 19:
                                _this8.Order.IsUsingStockLensLab = false;
                                _this8.showLensStock = false;

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this8);
            }))();
        },
        GetLensPcat: function GetLensPcat(code, reSph, reCyl, leSph, leCyl) {
            var url = "/Order/Catalog/LensPcat/Code/" + code + "/re/" + reSph + "/" + reCyl + "/le/" + leSph + "/" + leCyl;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                axios.get(url, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                    resolve(response.data.raw);
                }).catch(function (error) {
                    console.log('ERROR:', error);
                    reject({ error: error });
                });
            });
        },
        ClearDistancePD: function ClearDistancePD(e) {
            if (this.Order.IsOnly1DistancePD == false) this.Order.DistancePD = null;
        },
        ClearNearPD: function ClearNearPD(e) {
            if (this.Order.IsOnly1NearPD == false) this.Order.NearPD = null;
        },
        AddLensTreatment: function AddLensTreatment(retVal) {
            this.GetCompatability(retVal.code);
            this.Order.LensTreatment.push(retVal.code);
        },
        RemoveLensDesign: function RemoveLensDesign() {
            this.Order.LensDesign = null;
        },
        RemoveMaterial: function RemoveMaterial() {
            this.Order.LensMaterial = null;
        },
        SpecialOrder: function SpecialOrder(value) {
            this.Order.IsSpecialOrderNecessary = false;
        },
        ShowAdditionalFields: function ShowAdditionalFields(value) {
            this.IncludeAdditionalRxFields = false;
        },
        RemoveLensTreatment: function RemoveLensTreatment(retVal) {
            var index = this.Order.LensTreatment.findIndex(function (x) {
                return x.code == retVal.code;
            });
            this.GetCompatability(retVal.code);
            this.Order.LensTreatment.splice(index, 1);
        },
        Reset: function Reset() {
            this.lensTreatment = [];
            for (var i = 0; i < this.lensTreatmentMaster.length; i++) {
                this.lensTreatment.push(this.lensTreatmentMaster[i]);
            }
            this.selectedLensTreatment = [];
        },
        OneDistancePD: function OneDistancePD() {
            this.Order.IsOnly1DistancePD = !this.Order.IsOnly1DistancePD;
        },
        OneNearPD: function OneNearPD() {
            this.Order.IsOnly1NearPD = !this.Order.IsOnly1NearPD;
        },
        GetValues: function GetValues(start, end, increment, isPositiveDisplay, isInteger) {
            var currentVal = start;
            var retVal = [];
            if (isInteger == false) {

                retVal.push(currentVal.toFixed(2));
            } else {
                retVal.push(currentVal);
            }
            while (currentVal < end) {
                currentVal = currentVal + increment;
                if (currentVal <= 0) {
                    if (isInteger == false) {
                        retVal.push(currentVal.toFixed(2));
                    } else {
                        retVal.push(currentVal);
                    }
                } else {
                    if (isPositiveDisplay) {
                        if (isInteger == false) {
                            retVal.push("+" + currentVal.toFixed(2));
                        } else {
                            retVal.push("+" + currentVal);
                        }
                    } else {
                        if (isInteger == false) {
                            retVal.push(currentVal.toFixed(2));
                        } else {
                            retVal.push(currentVal);
                        }
                    }
                }
            }
            return retVal;
        },
        ResetNonBifocalVal: function ResetNonBifocalVal(value) {
            if (value === 'SV') {
                this.Order.ReAdd = null;
                this.Order.ReSegHeight = null;
                this.Order.LeAdd = null;
                this.Order.LeSegHeight = null;
                this.Order.ReNearPD = null;
                this.Order.LeNearPD = null;
                this.Order.NearPD = null;
            }
        },
        SetLensTreatmentValuesMaster: function SetLensTreatmentValuesMaster() {
            for (var i = 0; i < this.lensTreatment.length; i++) {
                var currentLensTreatmentCode = this.lensTreatment[i].code;
                for (var j = 0; j < this.Order.LensTreatment.length; j++) {
                    if (currentLensTreatmentCode == this.Order.LensTreatment[j]) {
                        this.selectedLensTreatment.push(this.lensTreatment[i]);
                        this.GetCompatability(this.lensTreatment[i].code);
                    }
                }
            }
        },
        SetLensTreatmentValuesNormal: function SetLensTreatmentValuesNormal() {
            for (var i = 0; i < this.lensTreatment.length; i++) {
                var currentLensTreatmentCode = this.lensTreatment[i].code;
                for (var j = 0; j < this.Order.LensTreatment.length; j++) {
                    if (currentLensTreatmentCode == this.Order.LensTreatment[j]) {
                        this.GetCompatability(this.lensTreatment[i].code);
                    }
                }
            }
        },
        GetLensType: function GetLensType() {
            var _this = this;
            axios.get('/Order/Catalog/ListLensType', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.lensType = response.data.raw;
                if (_this.Order.LensTypeCode) {
                    var index = _this.lensType.findIndex(function (x) {
                        return x.lensCode == _this.Order.LensTypeCode;
                    });
                    _this.Order.LensType = _this.lensType[index];
                }
                if (!_this.Order.isFirstLoad) {
                    _this.JobTypeDependency(_this.Order.LensType);
                }
            }).catch(function (error) {
                console.log('ERROR:', error);
            });
        },
        JobTypeDependency: function JobTypeDependency(value) {
            this.Order.LensType = value;
            this.Order.LensTypeCode = value.lensCode;
            this.CheckIfLensSpecsIsCompleted();
            if (!this.Order.isFirstLoad) {
                this.Order.LensMaterialObject = { code: null };
                this.Order.LensDesignObject = { designCode: null };
            }
            if (this.Order.ReSph || this.Order.LeSph || this.Order.ReCyl || this.Order.LeCyl || this.Order.ReAdd || this.LeAdd) {
                this.GetLensDesignSuggestion();
            } else {
                this.GetLensDesign(value.lensCode, null);
            }
        },
        LensDesignDependency: function LensDesignDependency(lensDesign, lensMaterial) {
            this.Order.LensDesign = lensDesign;
            this.Order.LensMaterialObject = { code: null };
            this.Order.LensMaterial = null;
            this.lensTreatment = [];
            this.lensMaterial = [];
            if (lensDesign) {
                if (this.Order.ReSph || this.Order.LeSph || this.Order.ReCyl || this.Order.LeCyl || this.Order.ReAdd || this.LeAdd) {
                    this.GetMaterialSuggestion();
                } else {
                    this.GetLensMaterial(lensDesign);
                }
            }
        },
        LensMaterialDependency: function LensMaterialDependency(lensDesign, lensMaterial) {
            this.Order.LensMaterial = lensMaterial;
            if (!lensDesign) {
                this.GetLensDesign(this.Order.LensTypeCode, lensMaterial);
            } else {
                this.GetLensTreatmentWrapper(lensDesign, lensMaterial);
            }
        },
        GetLensDesign: function GetLensDesign(value, value2) {
            var _this = this;
            axios.get('/Order/Catalog/ListLensDesign/' + value + '/' + value2, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.lensDesign = response.data.raw;
                _this.ResetNonBifocalVal(value);
                if (_this.Order.isFirstLoad) {
                    var index = _this.lensDesign.findIndex(function (x) {
                        return x.designCode == _this.Order.LensDesign;
                    });
                    _this.Order.LensDesignObject = _this.lensDesign[index];
                    if (index === -1) {
                        _this.Order.LensDesignObject = { designCode: null };
                    }
                    _this.GetLensMaterial(_this.Order.LensDesign);
                }
            }).catch(function (error) {
                console.log('ERROR:', error);
            });
        },
        GetLensDesignSuggestion: function GetLensDesignSuggestion() {
            var _this = this;

            _this.isLensDesignDisabled = true;
            if (_this.Order.LensTypeCode && (_this.Order.ReSph || _this.Order.LeSph || this.Order.ReCyl || this.Order.LeCyl || this.Order.ReAdd || this.LeAdd)) {
                _this.isLensDesignLoadingx = true;

                axios.post('/Order/Catalog/ListLensDesignSuggestions', { prescription: _this.Order, lensType: _this.Order.LensTypeCode, materialCode: null }, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                    if (response.data && response.data.raw) {
                        _this.lensDesign = response.data.raw;
                        _this.ResetNonBifocalVal(_this.Order.LensTypeCode);
                        var index = _this.lensDesign.findIndex(function (x) {
                            return x.designCode == _this.Order.LensDesign;
                        });
                        _this.isLensDesignDisabled = false;
                        _this.isLensDesignLoadingx = false;
                        if (_this.Order.isFirstLoad) {
                            var index = _this.lensDesign.findIndex(function (x) {
                                return x.designCode == _this.Order.LensDesign;
                            });
                            _this.Order.LensDesignObject = _this.lensDesign[index];
                            _this.isLensDesignDisabled = false;
                            _this.isLensDesignLoadingx = false;
                            if (index == -1) {
                                _this.Order.LensDesignObject = { designCode: null };
                            }
                            _this.GetMaterialSuggestion();
                        } else {
                            if (index == -1) {
                                _this.Order.LensDesignObject = { designCode: null };
                            } else {
                                _this.GetMaterialSuggestion();
                            }
                        }
                    }
                }).catch(function (error) {
                    console.log('ERROR:', error);
                    _this.isLensDesignLoadingx = false;
                });
            } else {
                if (_this.Order.LensTypeCode) {
                    _this.GetLensDesign(_this.Order.LensTypeCode, null);
                }
                _this.Order.LensMaterialObject = { code: null };
                _this.Order.LensDesignObject = { designCode: null };
            }
        },
        GetLensMaterial: function GetLensMaterial(value) {
            var _this = this;
            _this.isLensDesignLoading = true;
            axios.get('/Order/Catalog/ListMaterial/' + value, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.lensMaterial = response.data.raw;
                _this.isLensDesignLoading = false;
                if (_this.Order && _this.Order.isFirstLoad) {
                    var index = _this.lensMaterial.findIndex(function (x) {
                        return x.code == _this.Order.LensMaterial;
                    });
                    _this.Order.LensMaterialObject = _this.lensMaterial[index];
                    if (index == -1) {
                        _this.Order.LensMaterialObject = { code: null };
                    }
                    _this.GetLensTreatmentWrapper(_this.Order.LensDesign, _this.Order.LensMaterial);
                }
            }).catch(function (error) {
                _this.isLensDesignLoading = false;
                console.log('ERROR:', error);
            });
        },
        GetMaterialSuggestion: function GetMaterialSuggestion() {
            var _this = this;
            _this.isLensMaterialLoadingx = true;
            axios.post('/Order/Catalog/ListMaterialSuggestions', { prescription: _this.Order, lensType: _this.Order.LensTypeCode, designCode: _this.Order.LensDesignObject ? _this.Order.LensDesignObject.designCode : null }, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.isLensMaterialLoadingx = false;
                if (response.data && response.data.raw) {
                    _this.lensMaterial = response.data.raw;
                    _this.isLensDesignLoading = false;
                    var index = _this.lensMaterial.findIndex(function (x) {
                        return x.code == _this.Order.LensMaterial;
                    });
                    if (_this.Order && _this.Order.isFirstLoad) {
                        _this.Order.LensMaterialObject = _this.lensMaterial[index];
                        if (index == -1) {
                            _this.Order.LensMaterialObject = { code: null };
                        }
                        _this.GetLensTreatmentWrapper(_this.Order.LensDesign, _this.Order.LensMaterial);
                    } else {
                        if (index == -1) {
                            _this.Order.LensMaterialObject = { code: null };
                        }
                    }
                }
            }).catch(function (error) {
                _this.isLensMaterialLoadingx = false;
                console.log('ERROR:', error);
            });
        },
        GetMaterialSuggestionWrapper: function GetMaterialSuggestionWrapper() {
            var _this9 = this;

            if (this.lensMaterialTimeout) {
                clearTimeout(this.lensMaterialTimeout);
            }

            this.lensMaterialTimeout = setTimeout(function () {
                return _this9.GetMaterialSuggestion();
            }, 2000);
        },
        GetLensTreatment: function GetLensTreatment(value, value2) {
            var _this = this;
            _this.isLensMaterialLoading = true;
            if (value && value2) {
                axios.get('/Order/Catalog/ListTreatment/' + value + "/" + value2, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                    var retVal = response.data.raw;
                    if (retVal == null) {
                        retVal = [];
                    }
                    _this.lensTreatment = _this.Clone(retVal);
                    _this.lensTreatmentMaster = _this.Clone(retVal);
                    if (_this.Order && _this.Order.isFirstLoad == false) {
                        if (_this.MasterAccountType == 'master') {
                            _this.Reset();
                            _this.Order.LensTreatment = [];
                        }
                    } else {
                        if (_this.MasterAccountType == 'master') {
                            _this.SetLensTreatmentValuesMaster();
                        } else {
                            _this.SetLensTreatmentValuesNormal();
                        }
                    }
                    _this.isLensMaterialLoading = false;
                    _this.Order.isFirstLoad = false;
                }).catch(function (error) {
                    _this.isLensMaterialLoadingx = false;
                    _this.isLensMaterialLoading = false;
                    console.log('ERROR:', error);
                });
            }
        },
        GetLensTreatmentWrapper: function GetLensTreatmentWrapper(code1, code2) {
            var _this10 = this;

            if (this.lensTreatmentTimeout) {
                clearTimeout(this.lensTreatmentTimeout);
            }

            this.lensTreatmentTimeout = setTimeout(function () {
                return _this10.GetLensTreatment(code1, code2);
            }, 3000);
        },
        GetCompatability: function GetCompatability(code) {
            var _this = this;
            this.isCompatibleLoading = true;
            var isCompatible = this.incompatabilityList.findIndex(function (x) {
                return x.lensCode == code;
            });
            if (isCompatible == -1) {
                axios.get('/Order/Catalog/ListIncompatibleTreatment/' + code, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                    _this.isCompatibleLoading = false;
                    _this.incompatabilityList.push({ lensCode: code, list: response.data.raw });
                    _this.lensTreatment = _this.FilterCompatability(response.data.raw, _this.lensTreatment);
                }).catch(function (error) {
                    console.log('ERROR:', error);
                });
            } else {
                this.incompatabilityList.splice(isCompatible, 1);
                var concatOfList = [];
                var tempArray = [];
                for (var i = 0; i < this.incompatabilityList.length; i++) {
                    concatOfList = concatOfList.concat(this.incompatabilityList[i].list);
                }
                concatOfList.filter(function (item) {
                    var i = tempArray.findIndex(function (x) {
                        return x.incompatableTreatmentCode == item.incompatableTreatmentCode;
                    });
                    if (i <= -1) {
                        tempArray.push(item);
                    }
                    return null;
                });
                concatOfList = tempArray;
                var newList = this.FilterCompatability(concatOfList, this.lensTreatmentMaster);
                this.lensTreatment = newList;
                this.isCompatibleLoading = false;
            }
        },
        FilterCompatability: function FilterCompatability(incompatibleList, lensTreatment) {
            var clonedLensTreatment = this.Clone(lensTreatment);
            for (var i = 0; i < incompatibleList.length; i++) {
                var index = clonedLensTreatment.findIndex(function (x) {
                    return x.code == incompatibleList[i].incompatableTreatmentCode;
                });
                if (index >= 0) {
                    clonedLensTreatment.splice(index, 1);
                }
            }
            return clonedLensTreatment;
        },
        Clone: function Clone(array) {
            var tempArray = [];
            for (var i = 0; i < array.length; i++) {
                tempArray.push(array[i]);
            }
            return tempArray;
        }
    },
    created: function created() {
        var _this11 = this;

        this.stock_Lens_Account_Number__c = localStorage.getItem("stock_Lens_Account_Number__c");
        this.stock_Lens_Lab_Assignment__c = localStorage.getItem("stock_Lens_Lab_Assignment__c");
        this.stock_Lens_Lab_Bill_To__c = localStorage.getItem("stock_Lens_Lab_Bill_To__c");
        this.stock_Lens_Lab_ID__c = localStorage.getItem("stock_Lens_Lab_ID__c");
        this.stock_Lens_Lab_PCAT__c = localStorage.getItem("stock_Lens_Lab_PCAT__c");
        if (this.stock_Lens_Lab_PCAT__c === '') this.stock_Lens_Lab_PCAT__c = null;
        this.stock_Lens_Lab_Ship_To__c = localStorage.getItem("stock_Lens_Lab_Ship_To__c");
        this.stock_Lens_Lab_Ship_to_Override__c = localStorage.getItem("stock_Lens_Lab_Ship_to_Override__c");

        if (!this.Order.LensTypeCode && !this.Order.LensDesign && !this.Order.LensMaterial) {
            this.Order.isFirstLoad = false;
        }
        this.GetLensType();
        this.sphere = this.GetValues(-20.00, 20.00, 0.25, true, false).reverse();
        this.cylinder = this.GetValues(-10.00, 0.00, 0.25, false, false);
        this.axis = this.GetValues(0, 180, 1, false, true);
        this.addition = this.GetValues(0, 5, 0.25, false, false);
        this.height = this.GetValues(0, 40, 1, false, false);
        this.distancePd = this.GetValues(20, 40, 0.5, false, false);
        this.singleDistancePd = this.GetValues(40, 80, 0.5, false, false);
        this.nearPd = this.GetValues(20, 40, 0.5, false, false);
        this.singleNearPd = this.GetValues(40, 80, 0.5, false, false);
        if (this.Order.LensDesign && this.Order.LensMaterial) {
            this.lensSuggestionTimeout = setTimeout(function () {
                return _this11.GetLensDesign(_this11.Order.LensTypeCode, _this11.Order.LensMaterial);
            }, 2000);
        }
        this.CheckIfLensSpecsIsCompleted();
    }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["OrderReturn", "Account", "Voucher"],
  data: function data() {
    return {
      MasterAccountType: null
    };
  },

  methods: {},
  created: function created() {
    console.log(this.OrderReturn);

    console.log(this.Account);

    console.log(this.Voucher);
    this.MasterAccountType = localStorage.getItem("accountType");
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['Order'],
    components: {},
    data: function data() {
        return {
            AccountList: [],
            SelectedAccount: null,
            isDropDownShown: false,
            searchKeyword: null,
            isSearchResultLoaded: false,
            noResults: false,
            selectedAccountLoading: true,
            isActiveClassName: false,
            isActiveClassId: false,
            isActiveClassEmail: false,
            activeClass: 'g-bg-main g-bg-main-blue--hover'
        };
    },

    methods: {
        clickSearchOption: function clickSearchOption(option) {

            this.isActiveClassName = false;
            this.isActiveClassId = false;
            this.isActiveClassEmail = false;

            switch (option) {
                case 'name':
                    this.isActiveClassName = true;
                    alert(option);
                    break;
                case 'id':
                    this.isActiveClassId = true;
                    break;
                case 'email':
                    this.isActiveClassEmail = true;
                    break;
                default:
                    break;
            }
        },
        test: function test(index) {
            this.$refs.index.$el.focus();
        },
        escapeQuote: function escapeQuote(text) {
            text = text.replace(/'/g, "");
            text = escape(text);
            return text;
        },
        Search: function Search(search) {
            this.isSearchResultLoaded = false;
            this.isDropDownShown = true;
            var _this = this;
            this.search = this.escapeQuote(search);

            axios.get('/Account/SearchAccount/' + search, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.isSearchResultLoaded = true;
                _this.noResults = false;
                _this.AccountList = response.data.raw.account;
                if (response.data.raw.count == 0) {
                    _this.noResults = true;
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        ViewResultsAgain: function ViewResultsAgain() {
            if (this.AccountList.length > 0) {
                this.isDropDownShown = true;
            }
        },
        OpenSalesForce: function OpenSalesForce(id) {
            var url = "https://evf.my.salesforce.com/" + id;
            var win = window.open(url, '_blank');
            win.focus();
        },
        SelectAccount: function SelectAccount(sfId) {
            var _this = this;
            this.isDropDownShown = false;
            this.selectedAccountLoading = true;
            this.SelectedAccount = {};
            axios.get('account/GetBySalesforceId/' + sfId, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.SelectedAccount = response.data.raw;
                _this.selectedAccountLoading = false;
                _this.$emit('search', _this.SelectedAccount);
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    created: function created() {}
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RxInput_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RxInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RxInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Order", "Ethnicity", "ValidationResult"],
  components: { Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a, RxInput: __WEBPACK_IMPORTED_MODULE_1__RxInput_vue___default.a },
  directives: { mask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["mask"] },
  data: function data() {
    return {
      dob: null,
      isOrderRefPO: null,
      max: 15,
      datepickerState: {
        disabled: {
          from: new Date() }
      }
    };
  },

  computed: {
    age: function age() {}
  },
  methods: {
    ComputeAge: function ComputeAge(ageval) {
      if (this.Order.PatDOB) {
        if (ageval.length >= 10) {
          var dateNow = new Date();
          var dateAgeVal = new Date(ageval);
          var age = dateNow - dateAgeVal;
          var ageDate = new Date(age);
          if (dateNow > dateAgeVal) {
            var computedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
            this.Order.Age = computedAge.toString();
          }
        }
      }
    },
    ComputeFirstTimeWear: function ComputeFirstTimeWear(EverWornVal) {
      if (this.Order.IsExamOnly == false && this.Order.EverWornGlasses == 'Yes') {
        this.Order.PatIsFirstTimeGlassesWearer = 'No';
      } else if (this.Order.IsExamOnly == false && this.Order.EverWornGlasses == 'No') {
        this.Order.PatIsFirstTimeGlassesWearer = 'Yes';
      } else if (this.Order.EverWornGlasses == 'Unsure') {
        this.Order.PatIsFirstTimeGlassesWearer = 'Unsure';
      };
    }
  },
  created: function created() {}
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: [Number, String],
    minSize: [Number, String],
    maxSize: [Number, String],
    stepSize: [Number, String],
    fixedSize: [Number, String],
    displayPlus: { type: [Boolean, String], default: false },
    disabled: false,
    roundToStepSize: { type: Boolean, default: true },
    defaultNegative: { type: [Boolean, String], default: false },
    inputName: [String, String]
  },
  data: function data() {
    return {
      numericValue: undefined,
      positiveValue: false,
      isArrowUp: false,
      isArrowDown: false
    };
  },
  created: function created() {
    if (this.value !== undefined && this.value !== "" && this.value !== null) {
      this.numericValue = Number(this.value);
    }
  },

  methods: {
    arrowUp: function arrowUp() {
      if (!this.disabled) {
        this.numericValue = this.numericValue || 0;
        this.isArrowUp = true;
        this.isArrowDown = true;
        this.handleChange(this.numericValue + this.step);
      }
    },
    arrowDown: function arrowDown() {
      if (!this.disabled) {
        this.numericValue = this.numericValue || 0;
        this.isArrowUp = true;
        this.isArrowDown = true;
        this.handleChange(this.numericValue - this.step);
      }
    },
    updateValue: function updateValue(val) {
      this.handleChange(val);
    },
    handleBlur: function handleBlur(val) {
      this.handleChange(val);
    },
    handleChange: function handleChange(val) {
      if (val === "" || isNaN(val)) {
        this.$refs.input.value = "";
        this.$emit("input", null);
        this.numericValue = undefined;
        return;
      }
      if (!this.isArrowUp && !this.isArrowDown) {
        this.positiveValue = val.includes("+", 0);
      } else {
        this.isArrowUp = false;
        this.isArrowDown = false;
      }
      var unrounded = Math.min(Math.max(val, this.min), this.max);

      if (this.roundToStepSize) {
        unrounded = Math.ceil(unrounded / this.step) * this.step;
      }
      this.numericValue = unrounded;

      this.$refs.input.value = this.displayValue;
      this.$emit("input", this.displayValue);
    }
  },

  computed: {
    displayValue: function displayValue() {
      if (this.numericValue === undefined) {
        return null;
      }

      var tempObject = JSON.parse(localStorage.getItem("orderObj"));

      if (tempObject.ReCyl != null && tempObject.LeCyl != null) {
        if (this.inputName == "ReCyl" && tempObject.ReCyl.includes("+", 0) || this.inputName == "LeCyl" && tempObject.LeCyl.includes("+", 0)) {
          this.positiveValue = true;
        }
      }
      var proposed = this.numericValue.toFixed(this.fixed);

      if (!this.positiveValue) {
        if (proposed > 0 && this.displayPlus) {
          return "+" + proposed;
        } else if (proposed > 0 && this.defaultNegative) {
          var temp = -this.numericValue;
          return temp.toFixed(this.fixed);
        }
      } else {
        var temp = this.numericValue.toFixed(this.fixed);
        if (temp.includes("-", 0)) {
          return temp;
        } else {
          return "+" + temp;
        }
      }
      return proposed;
    },
    step: function step() {
      return Number(this.stepSize);
    },
    max: function max() {
      return Number(this.maxSize);
    },
    min: function min() {
      return Number(this.minSize);
    },
    fixed: function fixed() {
      return Number(this.fixedSize);
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_MessageLoader__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_MessageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_MessageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ServicePayment__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ServicePayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_ServicePayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_JotformModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_JotformModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_JotformModal_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a, VueBarcode: __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode___default.a, ServicePayment: __WEBPACK_IMPORTED_MODULE_4__components_shared_ServicePayment___default.a, MessageLoader: __WEBPACK_IMPORTED_MODULE_3__components_shared_MessageLoader___default.a, Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a, JotformModal: __WEBPACK_IMPORTED_MODULE_7__shared_JotformModal_vue___default.a },
    data: function data() {
        return {
            markDispenseModal: false,
            dateDispense: null,
            format: 'MM/dd/yyyy',
            Order: {},
            Account: {},
            isDataLoading: true,
            MasterAccountType: null,
            isServicePaymentShown: false,
            isCoveredPaymentShown: false,
            isOrderValid: false,
            isModalShown: false,
            isCancelled: false,
            orderDateSubmitted: null,
            wufooStatus: 'default',
            countDownTimer: null,
            isCancelSuccess: false,
            cancelMessage: 'Sorry, this order is no longer able to be cancelled',
            shippingAddressLineOne: '',
            shippingAddressLineTwo: '',
            shippingCity: '',
            shippingState: '',
            shippingPostalCode: ''
        };
    },

    methods: {
        RevertDispensed: function RevertDispensed(id) {
            var _this2 = this;

            var confirmRevert = window.confirm("Are you sure you want to remove the dispensed status for this order?");
            if (confirmRevert) {
                axios.post('/Order/RevertDispensed', [{ id: id, date: null }], { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' }).then(function (response) {
                    _this2.isDataLoading = false;
                    alert("The dispensed status has been removed.");
                    _this2.$router.go();
                }).catch(function (error) {
                    console.log(error);
                    alert("An Error occurred.");
                    this.isDataLoading = false;
                });
            } else {}
        },
        MarkAsDispensed: function MarkAsDispensed(id) {
            this.markDispenseModal = true;
        },
        SaveMarkForDispense: function SaveMarkForDispense(id) {
            var _this3 = this;

            axios.post('/Order/MarkDispensed', [{ id: id, date: this.dateDispense }], { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' }).then(function (response) {
                alert("Records has been marked as dispensed.");

                _this3.$router.go();
            }).catch(function (error) {
                console.log(error);
                alert("An Error occurred.");
            });
        },
        GetOrderData: function GetOrderData() {
            var _this = this;
            axios.get('/Order/Get/' + this.$route.params.code, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                if (response.data.isSuccess == false) {
                    _this.isDataLoading = false;
                    _this.isOrderValid = false;
                } else {
                    _this.isOrderValid = true;
                    _this.isDataLoading = false;
                    _this.Order = response.data.raw;
                    _this.shippingAddressLineOne = response.data.raw.shippingAddressLineOne;
                    _this.shippingAddressLineTwo = response.data.raw.shippingAddressLineTwo;
                    _this.shippingCity = response.data.raw.shippingCity;
                    _this.shippingState = response.data.raw.shippingState;
                    _this.shippingPostalCode = response.data.raw.shippingPostcode;

                    _this.Account = response.data.raw.accountDetails;
                    _this.Account.orderNumber = _this.Order.orderNumber;
                    if (_this.Order.jobType == 'FTC') {
                        if (_this.$route.params.isSummaryOnly == '1') {
                            _this.GenerateHtml();
                        }
                    }
                    if (_this.Order.payment && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master') {
                        _this.isCoveredPaymentShown = true;
                    } else if (_this.Order.payment == false && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master') {
                        _this.isServicePaymentShown = true;
                    }
                    _this.orderDateSubmitted = _this.Order.dateSubmitted;
                    var dateDiff = _this.getDateDiff(_this.orderDateSubmitted);
                    if (dateDiff <= 172800 && _this.Order.cancellationRequestedDateTime == null && _this.Order.orderStatus != 'Cancelled' && _this.Order.visionWebOrderStatus != 'Cancelled') {
                        _this.isCancelled = false;
                    } else {
                        _this.isCancelled = true;
                    }
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        GetAccountValues: function GetAccountValues() {
            var _this = this;
            axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.Account = response.data.raw;
            }).catch(function (error) {
                console.log(error);
            });
        },
        GetAccountBySalesForce: function GetAccountBySalesForce() {
            var _this = this;
            _this.isDataLoading = true;

            axios.get('/Account/GetBySalesforceId/' + this.Order.accountId, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.isDataLoading = false;
                _this.Account = response.data.raw;
            }).catch(function (error) {
                console.log(error);
            });
        },
        NewOrder: function NewOrder() {
            this.$router.push({ name: 'Order' });
        },
        ReuseOrder: function ReuseOrder(id) {
            this.$router.push({ name: 'Order', params: { code: id, EditOrReuse: 1 } });
        },
        ExtraPair: function ExtraPair(id) {
            this.$router.push({ name: 'Order', params: { code: id, EditOrReuse: 3 } });
        },
        GenerateHtml: function GenerateHtml() {
            var _this = this;
            var routeData = this.$router.resolve({ name: 'OrderSummary', query: { orderId: _this.Order.id } });

            window.open(routeData.href, '_blank', 'width=' + parseInt(window.innerWidth) + ', height=' + parseInt(window.innerHeight) + '');
        },
        Test: function Test() {
            alert('test');
        },
        ToggleJotForm: function ToggleJotForm(jotFormID) {
            this.isModalShown = !this.isModalShown;
            if (this.isModalShown) {
                document.body.classList.add("body-overflow");
            } else {
                document.body.classList.remove("body-overflow");
            }
        },
        CloseModal: function CloseModal() {
            this.isModalShown = false;
            document.body.classList.remove("body-overflow");
        },
        getDateDiff: function getDateDiff(_dateSubmitted) {
            var dsUTC = new Date(_dateSubmitted);
            var newDsUTC = dsUTC.getMonth() + 1 + '/' + dsUTC.getDate() + '/' + dsUTC.getFullYear() + ' ' + dsUTC.getHours() + ':' + dsUTC.getMinutes() + ':' + dsUTC.getSeconds();
            var ds = new Date(newDsUTC + ' UTC');
            var dn = new Date();
            var dateDiff = dn.getTime() - ds.getTime();
            return parseInt(dateDiff / 1000);
        },
        CountDownWufoo: function CountDownWufoo() {
            var _this = this;
            _this.countDownTimer = setInterval(function () {
                var _dateDiff = _this.getDateDiff(_this.orderDateSubmitted);
                if (_dateDiff > 172800) {
                    _this.isCancelled = true;
                    _this.wufooStatus = 'cancel';
                    clearInterval(_this.countDownTimer);
                }
            }, 1000);
        },
        UpdateOrderStatus: function UpdateOrderStatus() {
            var _this = this;
            _this.wufooStatus = 'submitting';
            axios.post('/Order/UpdateCancellationData/', this.Order, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.wufooStatus = 'default';
                _this.isCancelSuccess = true;
                _this.isCancelled = true;
                clearInterval(_this.countDownTimer);
            }).catch(function (error) {
                console.log(error);
            });
        },
        GetTooltip: function GetTooltip(param) {
            if (!param) return false;else return this.cancelMessage;
        }
    },
    created: function created() {
        this.MasterAccountType = localStorage.getItem("accountType");

        this.GetOrderData();
        this.dateDispense = new Date();
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderSpecial__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderSpecial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderSpecial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderPending__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderPending___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderPending__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderError__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, HelpForm: __WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a, OrderSpecial: __WEBPACK_IMPORTED_MODULE_3__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderSpecial___default.a, OrderPending: __WEBPACK_IMPORTED_MODULE_4__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderPending___default.a, OrderError: __WEBPACK_IMPORTED_MODULE_5__components_portal_Order_OrderSubmit_OrderSubmitComponent_OrderError___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader___default.a },
    data: function data() {
        return {
            orderType: null,
            orderDetails: null,
            orderDetailsLoading: false,
            showHelpForm: false,
            Account: null
        };
    },

    methods: {
        Route: function Route(value) {
            this.$router.push({ name: value });
        },
        GetOrderType: function GetOrderType() {
            if (this.$route.params.type == '0') {
                this.orderType = 'pending';
            } else if (this.$route.params.type == '1') {
                this.orderType = 'special';
            } else {
                this.orderType = 'error';
                this.GetOrderDetails();
            }
        },
        GetOrderDetails: function GetOrderDetails() {
            var _this = this;
            this.orderDetailsLoading = true;
            axios.get('/Order/Get/' + this.$route.params.code, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.orderDetails = response.data.raw;
                _this.Account = response.data.raw.accountDetails;
                _this.orderDetailsLoading = false;
            }).catch(function (error) {
                console.log(error);
            });
        },
        EditOrder: function EditOrder(id) {
            this.$router.push({ name: 'Order', params: { code: id, EditOrReuse: 0 } });
        },
        ToggleHelpForm: function ToggleHelpForm() {
            this.showHelpForm = !this.showHelpForm;
        },
        CloseModal: function CloseModal() {
            this.showHelpForm = false;
            document.body.classList.remove("body-overflow");
        }
    },
    created: function created() {
        this.GetOrderType();
    }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['orderDetails'],
    components: {},
    data: function data() {
        return {};
    },

    methods: {
        ShowHelpForm: function ShowHelpForm() {
            document.body.classList.add("body-overflow");
            this.$emit('clicked');
        }
    },
    created: function created() {}
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isPending: false
        };
    }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode__);


function InitialData(orderId) {
    return {
        Order: {},
        Account: {}
    };
}



/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a, VueBarcode: __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_barcode___default.a },
    data: function data() {
        return InitialData();
    },

    mounted: function mounted() {
        this.GetOrderById(this.$route.query.orderId);
    },
    methods: {
        GetOrderById: function GetOrderById(orderId) {
            var _this = this;

            axios.get('/Order/GetOrderAccount/' + orderId, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.Order = response.data.raw.order;
                _this.Account = response.data.raw.account;
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_resourceData_ResourcePromo__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_resourceData_ResourcePromo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_portal_resourceData_ResourcePromo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_resourceData_ResourceServices__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_resourceData_ResourceServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_portal_resourceData_ResourceServices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_resourceData_ResourceSuggest__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_resourceData_ResourceSuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_resourceData_ResourceSuggest__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a,
    ResourcePromo: __WEBPACK_IMPORTED_MODULE_2__components_portal_resourceData_ResourcePromo___default.a,
    ResourceServices: __WEBPACK_IMPORTED_MODULE_3__components_portal_resourceData_ResourceServices___default.a,
    ResourceSuggest: __WEBPACK_IMPORTED_MODULE_4__components_portal_resourceData_ResourceSuggest___default.a },
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {
    localStorage.setItem('is-active', 'resource');
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameShippingBilling__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameShippingBilling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameShippingBilling__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_FooterComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_FooterComponent___default.a, FrameShippingBilling: __WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameShippingBilling___default.a },
    data: function data() {
        return {
            isBillingShown: true
        };
    },

    methods: {
        Route: function Route(value) {
            this.$router.push({ name: value });
        },
        ToggleBilling: function ToggleBilling() {
            this.isBillingShown = !this.isBillingShown;
        }
    },
    created: function created() {
        localStorage.setItem('is-active', 'frame');
    }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_frameResources_frameComponents_FrameHeader__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_frameResources_frameComponents_FrameHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_portal_frameResources_frameComponents_FrameHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_frameResources_frameComponents_FrameFilters__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_frameResources_frameComponents_FrameFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_frameResources_frameComponents_FrameFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_frameResources_frameComponents_FrameOrderCollection__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_frameResources_frameComponents_FrameOrderCollection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_portal_frameResources_frameComponents_FrameOrderCollection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_frameResources_frameComponents_FrameList__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_frameResources_frameComponents_FrameList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_frameResources_frameComponents_FrameList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_frameResources_frameComponents_FrameShippingBilling__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_frameResources_frameComponents_FrameShippingBilling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_frameResources_frameComponents_FrameShippingBilling__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_FrameOrderForm__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_FrameOrderForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_FrameOrderForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_JotformModal_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_JotformModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__shared_JotformModal_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FrameHeader: __WEBPACK_IMPORTED_MODULE_3__components_portal_frameResources_frameComponents_FrameHeader___default.a,
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a,
    FrameList: __WEBPACK_IMPORTED_MODULE_6__components_portal_frameResources_frameComponents_FrameList___default.a,
    FrameFilters: __WEBPACK_IMPORTED_MODULE_4__components_portal_frameResources_frameComponents_FrameFilters___default.a,
    PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a,
    FrameShippingBilling: __WEBPACK_IMPORTED_MODULE_7__components_portal_frameResources_frameComponents_FrameShippingBilling___default.a,

    JotformModal: __WEBPACK_IMPORTED_MODULE_9__shared_JotformModal_vue___default.a
  },
  data: function data() {
    return {
      frameInformationList: [],
      frameList: [],
      BillingAddress: { isBillingDifferent: true },
      isPlaceOrder: false,
      ShowDisplayCaseField: false,
      showJotForm: false,
      searchValues: {
        FirstLoad: true,
        Color: [],
        FrameType: [],
        MinRange: 35,
        MaxRange: 70
      },
      isFrameLoading: true,
      Account: {},
      orderType: null,
      showMessageOrdered: false,
      isWufooModalShown: false
    };
  },

  methods: {
    Reset: function Reset() {
      this.searchValues = {
        FirstLoad: true,
        Color: [],
        FrameType: [],
        MinRange: 35,
        MaxRange: 70
      };
      this.GetFrames();
    },
    GetFrames: function GetFrames() {
      var _this = this;
      this.isFrameLoading = true;
      axios.post("/frame/SearchFrame", this.searchValues, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.isFrameLoading = false;
        _this.frameInformationList = response.data.raw.frameInformationList;
        for (var j = 0; j < _this.frameInformationList.length; j++) {
          for (var i = 0; i < _this.frameInformationList[j].frameList.length; i++) {
            _this.frameInformationList[j].frameList[i].swiperOptionSingle = {
              navigation: {
                prevEl: "#previousFrame" + j + i,
                nextEl: "#nextFrame-gallery-prev" + j + i
              }
            };
            _this.frameInformationList[j].frameList[i].idList = {
              prevEl: "previousFrame" + j + i,
              nextEl: "nextFrame-gallery-prev" + j + i
            };
          }
        }
      }).catch(function (error) {
        _this.isFrameLoading = false;
        console.log(error);
        _this.$router.push({ name: "Error" });
      });
    },
    PlaceOrder: function PlaceOrder() {
      if (this.Account.isFrameKitAllowed) {
        this.isPlaceOrder = true;
      } else {
        this.showMessageOrdered = true;
      }
    },
    GetAccountValues: function GetAccountValues() {
      var _this = this;
      this.isAccountLoading = true;
      axios.get("/Account/Self", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.Account = response.data.raw;
        localStorage.setItem("customUserPermissionFlag", _this.Account.customUserPermissionFlag);
        _this.ShowDisplayCaseField = _this.Account.customUserPermissionFlag.includes("Order Display Case Only");
      }).catch(function (error) {
        console.log(error);
      });
    },
    ToggleFrameOrderForm: function ToggleFrameOrderForm(passOrderType) {
      this.orderType = passOrderType;
      this.Account.orderType = passOrderType;
      this.showJotForm = !this.showJotForm;
      if (this.showJotForm) {
        document.body.classList.add("body-overflow");
      } else {
        document.body.classList.remove("body-overflow");
      }
    },
    CloseModal: function CloseModal() {
      document.body.classList.remove("body-overflow");

      this.showJotForm = false;
      if (this.showJotForm) {
        document.body.classList.add("body-overflow");
      } else {
        document.body.classList.remove("body-overflow");
      }
      this.isPlaceOrder = false;
    },
    GetTooltip: function GetTooltip(param) {
      if (param) return false;else return "Frame replacements are unavailable at this time";
    },
    RemoveNullImages: function RemoveNullImages(images) {
      return images.filter(function (e) {
        return e != "NULL";
      });
    },
    CountFrames: function CountFrames(evfFrames) {
      var retValue = true;
      var arrEVF = [];
      var arrNonEVF = [];

      if (evfFrames == true) return arrEVF.length;else {
        return arrNonEVF.length;
      }
    },
    goToVirtualTryOn: function goToVirtualTryOn() {
      window.location.href = "https://onesightframes.org/";
    }
  },
  created: function created() {
    var _this2 = this;

    this.GetFrames();
    this.GetAccountValues();
    localStorage.setItem("is-active", "frame");
    this.frameInformationList.forEach(function (frameInfo) {
      frameInfo.frameList.forEach(function (frame) {
        frame.imageUrl = _this2.RemoveNullImages(frame.imageUrl);
      });
    });
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['searchValues'],
    components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
    data: function data() {
        return {
            color: [],
            frameType: [],
            SelectedFrameType: null
        };
    },

    methods: {
        GetEnums: function GetEnums() {
            var _this = this;
            axios.get('frame/GetEnum/', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.color = response.data.raw.color;
            }).catch(function (error) {
                console.log(error);
            });
        },
        GetFrameType: function GetFrameType() {
            var _this = this;
            axios.get("/Order/Catalog/ListFrame", {
                headers: { Authorization: "Bearer " + localStorage.getItem("token") }
            }).then(function (response) {
                _this.frameType = response.data.raw;
            }).catch(function (error) {
                console.log(error);
            });
        },
        Search: function Search() {
            this.searchValues.FirstLoad = false;
            this.$emit("clicked");
        },
        Reset: function Reset() {
            this.$emit('reset');
        }
    },
    watch: {
        SelectedFrameType: function SelectedFrameType(val) {
            var _this2 = this;

            this.searchValues.FrameType = [];
            val.forEach(function (e) {
                if (typeof e === 'string' || e instanceof String) {
                    _this2.searchValues.FrameType.push(e);
                } else {
                    _this2.searchValues.FrameType.push(e.code);
                }
            });
        }
    },
    created: function created() {
        this.GetEnums();
        this.GetFrameType();
    }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameModal__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameModal__);



/* harmony default export */ __webpack_exports__["default"] = ({
    components: { FrameModal: __WEBPACK_IMPORTED_MODULE_0__components_portal_frameResources_frameComponents_FrameModal___default.a },
    props: ['frameList'],
    data: function data() {
        return {
            swiperOption: {
                direction: "horizontal",
                slidesPerView: 3,
                spaceBetween: 0
            },
            isModalShown: false,
            selectedImages: '',
            imageIndex: 0
        };
    },

    methods: {
        ToggleModal: function ToggleModal() {
            this.isModalShown = !this.isModalShown;
        },
        ShowFrameModal: function ShowFrameModal(images, index) {
            this.selectedImages = images;
            this.imageIndex = index;
            this.ToggleModal();
        },
        RemoveImage: function RemoveImage(key, index) {
            this.frameList[key].imageUrl.splice(index, 1);
        },
        ImageExists: function ImageExists(pic, key, index) {
            this.frameList[key].imageUrl[index] = '../../../../../static/assets/img/evf-frame.png';
            var _this = this;
            var imageArray = _this.RemoveNullImages(_this.frameList[key].imageUrl);
            _this.frameList[key].imageUrl = imageArray;
        },
        RemoveNullImages: function RemoveNullImages(images) {
            return images.filter(function (e) {
                return e != "NULL";
            });
        },
        CheckEVFFrames: function CheckEVFFrames(evfFrames) {
            var retValue = false;
            evfFrames.forEach(function (frame) {
                if (frame) {
                    retValue = true;
                }
            });
            return retValue;
        }
    },
    created: function created() {
        var _this2 = this;

        this.frameList.forEach(function (frame) {
            frame.imageUrl = _this2.RemoveNullImages(frame.imageUrl);
        });
    }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['images', 'imageIndex'],
  components: {},
  data: function data() {
    return {
      isModalShown: true,
      swiperOptions: {
        navigation: {
          prevEl: "#prev-image",
          nextEl: "#next-image"
        },
        initialSlide: 0
      }
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('close');
    }
  },
  created: function created() {
    this.swiperOptions.initialSlide = this.imageIndex;
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    data: function data() {
        return {};
    },

    methods: {
        ScrollBottom: function ScrollBottom() {
            this.$scrollTo("#PlaceOrder", 300, {
                el: "#PlaceOrder",
                offset: -100,
                x: false,
                y: true
            });
        }
    }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageLoader: __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default.a },
  props: ["Account"],
  data: function data() {
    return {
      isBillingDifferent: true,
      ValidationResult: {}
    };
  },

  methods: {
    Close: function Close() {
      document.body.classList.remove("body-overflow");
      this.$emit("exitModal");
    }
  },
  created: function created() {}
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_helpData_HelpBlock__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_helpData_HelpBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_helpData_HelpBlock__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HelpBlock: __WEBPACK_IMPORTED_MODULE_0__components_portal_helpData_HelpBlock___default.a }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_HelpServices__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_HelpServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_HelpServices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_HelpCenter__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_HelpCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_HelpCenter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(9);











/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HelpServices: __WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_HelpServices___default.a,
        HelpCenter: __WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_HelpCenter___default.a },
    data: function data() {
        return {
            items: null
        };
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _this, response, apiitems, sections, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, curItem;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _this = _this2;
                            _context.next = 4;
                            return fetch(__WEBPACK_IMPORTED_MODULE_8_vue__["default"].config.API_ENDPOINT + 'CMS/GetHelpFAQs?portalType=CFS', {
                                method: 'get',
                                headers: {
                                    'Authorization': "Bearer " + localStorage.getItem("token")
                                }
                            });

                        case 4:
                            response = _context.sent;
                            _context.next = 7;
                            return response.json();

                        case 7:
                            apiitems = _context.sent;

                            apiitems = apiitems.sort(function (x, y) {
                                return (x.sortOrder || 99999) - (y.sortOrder || 99999);
                            });
                            sections = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 13;

                            for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(apiitems); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                curItem = _step.value;

                                sections.add(curItem.section);
                            }
                            _context.next = 21;
                            break;

                        case 17:
                            _context.prev = 17;
                            _context.t0 = _context["catch"](13);
                            _didIteratorError = true;
                            _iteratorError = _context.t0;

                        case 21:
                            _context.prev = 21;
                            _context.prev = 22;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 24:
                            _context.prev = 24;

                            if (!_didIteratorError) {
                                _context.next = 27;
                                break;
                            }

                            throw _iteratorError;

                        case 27:
                            return _context.finish(24);

                        case 28:
                            return _context.finish(21);

                        case 29:
                            _this2.items = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(sections)).reduce(function (resultMap, curSection) {
                                return resultMap.set(curSection, apiitems.filter(function (x) {
                                    return x.section == curSection;
                                }));
                            }, new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a());
                            _context.next = 35;
                            break;

                        case 32:
                            _context.prev = 32;
                            _context.t1 = _context["catch"](0);

                            console.log(_context.t1);

                        case 35:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 32], [13, 17, 21, 29], [22,, 24, 28]]);
        }))();
    },

    methods: {
        Scroll: function Scroll(id) {
            this.$scrollTo(id, 300, {
                el: id,
                offset: -100,
                x: false,
                y: true
            });
        }
    }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_helpList_General__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_helpList_General___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_helpList_General__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_helpList_Order__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_helpList_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_helpList_Order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_helpList_TrackOrder__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_helpList_TrackOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_helpList_TrackOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_helpData_helpList_Frames__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_helpData_helpList_Frames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_portal_helpData_helpList_Frames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_helpList_Resources__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_helpList_Resources___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_helpList_Resources__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_helpList_MyAccount__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_helpList_MyAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_helpList_MyAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpList_HelpItem_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpList_HelpItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__helpList_HelpItem_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HelpItem: __WEBPACK_IMPORTED_MODULE_9__helpList_HelpItem_vue___default.a, General: __WEBPACK_IMPORTED_MODULE_2__components_portal_helpData_helpList_General___default.a, Order: __WEBPACK_IMPORTED_MODULE_3__components_portal_helpData_helpList_Order___default.a, TrackOrder: __WEBPACK_IMPORTED_MODULE_4__components_portal_helpData_helpList_TrackOrder___default.a, Frames: __WEBPACK_IMPORTED_MODULE_5__components_portal_helpData_helpList_Frames___default.a, Resources: __WEBPACK_IMPORTED_MODULE_6__components_portal_helpData_helpList_Resources___default.a, MyAccount: __WEBPACK_IMPORTED_MODULE_7__components_portal_helpData_helpList_MyAccount___default.a },
    props: ["items"],
    data: function data() {
        return {};
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            try {
                                console.log(_this.items);
                            } catch (ex) {
                                console.log(ex);
                            }

                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_JotformEmbed__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_JotformEmbed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_JotformEmbed__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { JotformEmbed: __WEBPACK_IMPORTED_MODULE_0__components_shared_JotformEmbed___default.a }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapseStatus: false,
            groups: [{
                "name": "Are frames available?",
                "open": false,
                "items": "Check out the <a href='Frames'>Frames Page</a> where you can view the catalog from FGX International, and order a Frame Collection and Frame Replacement."
            }, {
                "name": "Can I order more than one frame collection?",
                "open": false,
                "items": "You are limited one frame collection per account. Extra Frame Collections may be rented through the Equipment/Hardware Rentals on the Resources Page "
            }, {
                "name": "Can I only order the frames in the Collection I received?",
                "open": false,
                "items": "No, you are able to order all frame color options available on the Order page."
            }, {
                "name": "Can I pick the frames in the Collection?",
                "open": false,
                "items": "Unfortunately, you are not able to select the frames in your Collection. You will be provided with a sample of all styles offered to use as trial frames (for your frame board). However, you are able to order all frame color options on the Order page."
            }, {
                "name": "Can I request all frames for my Collection?",
                "open": false,
                "items": "No, unfortunately, there is not an option to order all frames."
            }, {
                "name": "If I order the EVF Frame Collection, can I still use my own frames?",
                "open": false,
                "items": "Absolutely. You are always welcome to offer patients a frame from your own inventory and place orders as Frame-to-Come."
            }, {
                "name": "If the frame is low stock do I use the one from my Collection?",
                "open": false,
                "items": "No, if the frame is low stock you may continue to place orders, and if it becomes out of stock, similar options will be provided on the Order page. Please do not use frames from your Collection for frame-to-come orders as this negatively affects inventory and replacement frame ordering."
            }, {
                "name": "What does it mean when a frame is low stock/out of stock?",
                "open": false,
                "items": "A frame is indicated as low stock when a limited quantity for ordering is available. We suggest that if a patient selects a frame that you know to be of low stock, that you ask the patient to select another frame as a back-up option. A frame will be indicated as out of stock when it is no longer able to be ordered. Similar frame options will be provided for you to select when placing an order. A frame that is out of stock is still part of the Collection and is in process of being reordered. All frames will remain in the Collection unless specifically discontinued."
            }, {
                "name": "Can I order another Frame Collection?",
                "open": false,
                "items": "Unfortunately, the program offers one Frame Collection per account. If you are trying to order a Collection for trial at another location, we recommend you set up a second account for that location. There is no option to purchase additional Frame Collections, however they may be rented from the Resources Page (subject to availability)."
            }, {
                "name": "How often do you plan to refresh the Frame Collection?",
                "open": false,
                "items": "We have established a Collection to remain in-tact over a 2-3 year period. Should a frame become discontinued, we will make adjustments as necessary."
            }, {
                "name": "What do I do if a frame breaks?",
                "open": false,
                "items": "If a frame breaks you are asked to select the Order Replacement button on the Frame page to request an individual frame replacement. All frame replacements will be subject to Essilor Vision Foundation approval."
            }]
        };
    },

    methods: {
        toggleCollapse: function toggleCollapse(collapseStatus) {
            var _this = this;

            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(function (element) {
                element.open = _this.collapseStatus;
            });
        },
        changeCollapse: function changeCollapse(group) {
            this.groups.forEach(function (element) {
                element.open = false;
            });
            group.open = true;
        }
    }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapseStatus: false,
            groups: [{
                "name": "How does this program help the eye doctor or charity?",
                "open": false,
                "items": "Changing Life through Lenses&reg; is intended to support eye doctors and non-profits providing philanthropic vision services. The site offers real-time ordering of glasses and lenses, referral tracking and educational resources on how to engage in your community."
            }, {
                "name": "What kind of product selection will I have?",
                "open": false,
                "items": "Essilor Vision Foundation offers Polycarbonate Single Vision and Bifocal lenses and frames provided by FGX International. Should medically necessary products be required, the doctor may indicate the Special Request in the order for review and consideration."
            }, {
                "name": "What costs are associated for each order?",
                "open": false,
                "items": "There is no charge for the hardware or the manufacturing of the glasses. The only costs to the eye doctor or charity will be the shipping of the frame for any frame-to-come orders, to the designated laboratory."
            }, {
                "name": "What are the requirements for a free pair of glasses?",
                "open": false,
                "items": "This program is for patients who are at or below the poverty level and do not have insurance for vision services and hardware, as reasonably determined by the provider. It is expected that the eye doctor and his or her staff would donate the time for the exam; however, if not, dollars can only be reimbursed by the patient for the eye exam or any hardware NOT provided by EVF."
            }, {
                "name": "What costs are associated for each order?",
                "open": false,
                "items": "There is no charge for the glasses provided by EVF. The only costs to the eye doctor or charity would be for Frame-to-Come orders 1) the cost of the frame and 2) the shipping of the frame to the designated laboratory."
            }, {
                "name": "Can I register for more than one account?",
                "open": false,
                "items": "You can register for more than one account type (Individual, Business, Non-Profit); however, you may only register for one account per type. Additionally, each account will require a different email address for login. For instance you can register as an<b> Individual</b> for any charity work you may do on your own and you may register as a <b>Practice/Business</b> for that work which may be done within your practice or practice locations."
            }, {
                "name": "How will a lab be selected?",
                "open": false,
                "items": "Essilor Vision Foundation will determine the lab at the time the order is placed online. The website is designed to select the most efficient manner for production based on the Essilor lab network."
            }, {
                "name": "Can the same lab account be used for private pay and charity work?",
                "open": false,
                "items": "Unfortunately not. Charitable lab work will not be processed through an existing private pay or managed care lab account. Accounts cannot be linked for the purposes of ordering charity jobs."
            }]
        };
    },

    methods: {
        toggleCollapse: function toggleCollapse(collapseStatus) {
            var _this = this;

            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(function (element) {
                element.open = _this.collapseStatus;
            });
        },
        changeCollapse: function changeCollapse(group) {
            this.groups.forEach(function (element) {
                element.open = false;
            });
            group.open = true;
        }
    }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ["section", "items"],
    data: function data() {
        return {
            collapseStatus: false,
            groups: []
        };
    },
    created: function created() {
        var g = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.items).map(function (x) {
            return {
                "name": x.title,
                "open": false,
                "items": x.description
            };
        });

        this.groups = g;
    },

    methods: {
        toggleCollapse: function toggleCollapse(collapseStatus) {
            var _this = this;

            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(function (element) {
                element.open = _this.collapseStatus;
            });
        },
        changeCollapse: function changeCollapse(group) {
            this.groups.forEach(function (element) {
                element.open = false;
            });
            group.open = true;
        }
    }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapseStatus: false,
            groups: [{
                "name": "Where can I update my account information?",
                "open": false,
                "items": "Click on the <a href='UserAccount'>My Account</a> page and on that page you can edit Login Information such as email and password, Account Information and Shipping Address, Professional Information, Forecast and Communication preferences."
            }, {

                "name": "Can I change my Business/Participant Name?",
                "open": false,
                "items": "Users will not be able to edit their Account Number or Business/Participant name. Should you have any changes to your Business/Participant name, please contact Customer Service at support@onesight.org or (866) 385-0447. You may be required to create a separate account and complete the contract for the new Business/Practice entity."
            }, {
                "name": "How can I cancel my account?",
                "open": false,
                "items": "Please contact Customer Service at support@onesight.org or 385-044747 to cancel your account"
            }, {
                "name": "How and when should I update my forecast?",
                "open": false,
                "items": "We ask that you complete an estimated forecast at the time of registration, and we will ask for a revised estimate on a calendar year basis. In the interim, should you have any updates that dramatically increase or reduce your forecast, please proceed to the <a href='UserAccount'>My Account</a> page in order to edit your forecast." + "<br><br>If the forecast exceeds 100 orders per year you will be asked to complete a forecast by month so that we can ensure the supply chain can accommodate the orders. Essilor Vision Foundation may inquire and audit any forecast and has the right to cap any forecasts at any time."
            }, {
                "name": "Where can I locate the assigned lab?",
                "open": false,
                "items": "The lab assignment will be made available to you when you place an order. The lab information will be provided on the Order Confirmation, Order Summary and Track Order page. In a frame-to-come order, please plan to print the Order Summary, retain one half and return the other with the frame for manufacturing."
            }]
        };
    },

    methods: {
        toggleCollapse: function toggleCollapse(collapseStatus) {
            var _this = this;

            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(function (element) {
                element.open = _this.collapseStatus;
            });
        },
        changeCollapse: function changeCollapse(group) {
            this.groups.forEach(function (element) {
                element.open = false;
            });
            group.open = true;
        }
    }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapseStatus: false,
            groups: [{
                "name": "Can I add/affiliate new eye doctors to my account?",
                "open": false,
                "items": "Yes, you may add eye doctors by going to <a href='UserAccount'>My Account</a> and selecting Edit to add doctors who will be conducting charity exams for your Business or Non-Profit. Additionally, you may add the eye doctor on the Order page at the time of the order, and identify if the eye doctor should be added only to this order, or to your account for this and future orders."
            }, {
                "name": "Why are you capturing demographic information on the order?",
                "open": false,
                "items": "We are requesting limited data (gender and ethnicity) in order to assess regional trends and be able to customize resources or programs based on the anticipated need. The data fields are not required, but will be helpful in delivery of services and program enhancements. In proceeding with the registration process, you were asked to complete a Business Associate Agreement (BAA) which allows for the capture of a limited data set for program operations. If you wish to review the BAA, you may view it on the <a href='UserAccount'>My Account</a> page under Communication Preferences."
            }, {
                "name": "What if my patient requires a lens that is not offered on the Order page?",
                "open": false,
                "items": "If a patient has a medically necessary prescription requirement, please indicate the Special Request by checking the box that says “The lens options above do not meet the medical needs of this patient” on the Order page. The order will be submitted to Essilor Vision Foundation for review and approval. Including a Special Request may increase the time for production."
            }, {
                "name": "Can I order glasses with prism or OC height?",
                "open": false,
                "items": "Yes, to order glasses with prism or OC height just check the 'Additional Rx Fields' checkbox."
            }, {
                "name": "What does the “Exam only” check box mean?",
                "open": false,
                "items": "This selection on the Order page allows you to indicate any patients who have received exams and are not issued a prescription. This will allow you the opportunity to track total number of patients who have received vision services. These exam entries will be displayed on the Track Order page and should the need arise to convert this exam into an order you can View the entry and select the “Convert to Order” button on the Order Confirmation page. This will open an Order form populated with the exam information to add a prescription and Submit to the lab."
            }, {
                "name": "What does the “Remake/Redo” check box mean?",
                "open": false,
                "items": "This check box will be automatically selected if you choose the “Remake/Redo” option on the Order Confirmation of an order that was received with an error. This is only to be used in remaking an existing order submitted through Changing Life through Lenses™"
            }, {
                "name": "What does the “International Mission” check box mean?",
                "open": false,
                "items": "This selection should be used for those who are supporting a one-time International vision clinic. Essilor Vision Foundation supports one-time International mission aid for US-based doctors and non-profits. We simply ask you indicate the order is for an International patient, so that we can have accurate recordkeeping of the services rendered. It is not for use for any ongoing sustainable clinics outside the United States."
            }, {
                "name": "What is the Order Reference/P.O. field?",
                "open": false,
                "items": "This is a free-entry text field to allow you to put a reference name/number (i.e.: Washington Elem., Student ID: 12345) to track or organize your orders. This optional field will be printed on the Order Summary and on the completed order when it returns from the lab "
            }]
        };
    },

    methods: {
        toggleCollapse: function toggleCollapse(collapseStatus) {
            var _this = this;

            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(function (element) {
                element.open = _this.collapseStatus;
            });
        },
        changeCollapse: function changeCollapse(group) {
            this.groups.forEach(function (element) {
                element.open = false;
            });
            group.open = true;
        },
        RouterRedirect: function RouterRedirect(name) {
            this.$router.push({ name: name });
        }
    }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapseStatus: false,
            groups: [{
                "name": "How do I use the Resources provided?",
                "open": false,
                "items": "The Resources provided are intended to support your charity work. Resources include key statistics, marketing materials to promote your charity outreach, and specifics on setting up a vision event with downloadable guides, templates, webinars and videos. Materials will be updated quarterly."
            }, {
                "name": "Where can I provide Resource suggestions or helpful ideas?",
                "open": false,
                "items": "Please make suggestions for additional Resources on the <a href='Resources'>Resources Page</a>. We welcome ideas and best practices. "
            }, {
                "name": "Do you support with any other Resources such as stock lenses and portable examination equipment?",
                "open": false,
                "items": "Essilor Vision Foundaton provides additional resources such as in-kind stock lenses, rental portable examination equipment (phoropter, tripod, and wallchart), or extra frame collections for vision events. Subject to rental fees and availability."
            }, {
                "name": "What Resources are available for International charitable efforts?",
                "open": false,
                "items": "Essilor Vision Foundation is committed to offering support for domestic vision initiatives, specifically those focused on children. However, we also offer support for one-time International mission aid for US-based doctors and non-profits. For ongoing International support and relief efforts, please reach out to the following agencies directly supporting International vision services with sustainable resources:" + "<ul>" + "<li><a href='http://vosh.org/' target='_blank'>Volunteer Optometric Services for Humanity (VOSH) International</a></li>" + "<li><a href='http://members.lionsclubs.org/EN/serve/other-ways-to-serve/global-outreach/index.php' target='_blank'>Lions Club International</a></li>" + "<li><a href='http://restoringvision.org/' target='_blank'>Restoring Vision</a></li>" + "<li><a href='https://onesight.org/' target='_blank'>OneSight</a></li>" + "<li><a href='http://www.givingsight.org' target='_blank'>Optometry Giving Sight</a></li>" + "<li><a href='https://www.essilorindia.com/about-essilor/NVG' target='_blank'>2.5 New Vision Generation</a></li>" + "</ul>"
            }]
        };
    },

    methods: {
        toggleCollapse: function toggleCollapse(collapseStatus) {
            var _this = this;

            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(function (element) {
                element.open = _this.collapseStatus;
            });
        },
        changeCollapse: function changeCollapse(group) {
            this.groups.forEach(function (element) {
                element.open = false;
            });
            group.open = true;
        }
    }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapseStatus: false,
            groups: [{
                "name": "What is the turn-time of an order processed through Changing Life through Lenses\u2122?",
                "open": false,
                "items": "Most orders will be delivered within 2-3 weeks from the date you submit your order or from the date the lab receives the frame for Frame-to-Come orders. If you have made a Special Request, your order is not submitted to the laboratory until Essilor Vision Foundation approves or declines the request. Including a Special Request may increase the time for production."
            }, {
                "name": "Why does my order status say “Error”?",
                "open": false,
                "items": "This means there was an issue submitting your order to the lab. Essilor Vision Foundation is aware of any orders with this error status and should review your order within 2-3 business days."
            }, {
                "name": "What is a Pending Order?",
                "open": false,
                "items": "A Pending Order is an order that is saved but not yet submitted to the lab. You may choose to save an order as Pending if you need to locate more information before submitting the order. You may also save an order as Pending if you know you will not be able to send the frame to the lab within the next few days."
            }, {
                "name": "Can I make a change or cancel an order that I’ve already submitted?",
                "open": false,
                "items": "Unfortunately, there is no way to edit an order once it has been submitted to the lab. If you notice that a mistake was made on your order within 48 hours of ordering, please select the “Request Cancellation” button on the Order Confirmation page for that order (accessible by clicking the SP number). Once the initial order has been cancelled, you can resubmit the order with the correct information."
            }, {
                "name": "What do I do after submitting an order that is Pending Approval?",
                "open": false,
                "items": "If you have made a special request on the Order page and selected “Submit for Approval”, your order is Pending Approval by Essilor Vision Foundation. You will receive notice via email within a week. If approved, your notice will contain the confirmed Order Summary. At that time you can print the Order Summary and send the frame to the lab if it is a frame-to-come order. Please DO NOT send the frame without the printed Order Summary."
            }, {
                "name": "What if there is an error on the order I received?",
                "open": false,
                "items": "If you have received an order with an error, please select the “Remake/Redo” button on the Order Confirmation page for that order (accessible by clicking the SP number). This will populate an Order form with all order information to which you can make minor edits, as necessary, and select Submit button at the bottom of the page."
            }, {
                "name": "What does the “Export File with Current Filters” button mean?",
                "open": false,
                "items": "Use this button when you want a complete download of all exams and orders into a CSV file for reporting. This file can be opened in Excel. Most of the additional information entered on the Order page can be found in this download, such as: Referral Organization, Voucher Number/Code, Prescribing Doctor etc.) for you to more easily sort and filter. "
            }]
        };
    },

    methods: {
        toggleCollapse: function toggleCollapse(collapseStatus) {
            var _this = this;

            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(function (element) {
                element.open = _this.collapseStatus;
            });
        },
        changeCollapse: function changeCollapse(group) {
            this.groups.forEach(function (element) {
                element.open = false;
            });
            group.open = true;
        }
    }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      swiperOption: {
        slidesPerView: 1
      }
    };
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      isLogIn: false,
      IsNavbarShown: true,
      framePageVisible: localStorage.getItem("frameAndLensOrderIsAllowed"),
      kitOrderedYet: localStorage.getItem("IsFrameKitAllowed")
    };
  },

  methods: {
    RouterRedirect: function RouterRedirect(name) {
      this.$router.push({ name: name });
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { LoadingComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_LoadingComponent___default.a },
  data: function data() {
    return {
      isModalShown: false,
      EmailAddress: "",
      errorMessage: null,
      ResetStatus: false,
      ResetForm: true,
      isLoading: false,
      donationIcon: '../../../../static/assets/img/icons/Home Page Icons/money_inv.png',
      communityIcon: '../../../../static/assets/img/icons/Home Page Icons/hehc_inv.png'
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.isModalShown = false;
    },
    Referral: function Referral(referralType) {
      var _this2 = this;

      this.errorMessage = null;
      axios.post("/Account/Referral", { "EmailAddress": this.EmailAddress, "Type": referralType }, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this2;
        if (response.data.isSuccess == true) {
          _this.isModalShown = true;
          _this.EmailAddress = "";
        } else {
          _this.errorMessage = response.data.errorMessage;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    HoverDonation: function HoverDonation(event) {
      if (event == 'enter') {
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money.png';
      } else if (event == 'leave') {
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money_inv.png';
      }
    },
    HoverCommunity: function HoverCommunity(event) {
      if (event == 'enter') {
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/hehc.png';
      } else if (event == 'leave') {
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/hehc_inv.png';
      }
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    RouterRedirect: function RouterRedirect(name) {
      var href = window.location.href;
      if (href[href.length - 1] == "/") window.open("../" + name + "/", "_blank");else window.open(href + "/../" + name + "/", "_blank");
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_homeData_ShareStoryForm__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_homeData_ShareStoryForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_homeData_ShareStoryForm__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ShareStoryForm: __WEBPACK_IMPORTED_MODULE_0__components_portal_homeData_ShareStoryForm___default.a },
  data: function data() {
    return {
      isModalShown: false
    };
  },

  methods: {
    ShowModal: function ShowModal() {
      this.isModalShown = !this.isModalShown;
      document.body.classList.add("body-overflow");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      donationIcon: '../../../../static/assets/img/icons/Home Page Icons/money_inv.png',
      communityIcon: '../../../../static/assets/img/icons/Home Page Icons/hehc_inv.png'
    };
  },

  methods: {
    HoverDonation: function HoverDonation(event) {
      if (event == 'enter') {
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money.png';
      } else if (event == 'leave') {
        this.donationIcon = '../../../../static/assets/img/icons/Home Page Icons/money_inv.png';
      }
    },
    HoverCommunity: function HoverCommunity(event) {
      if (event == 'enter') {
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/path5119.png';
      } else if (event == 'leave') {
        this.communityIcon = '../../../../static/assets/img/icons/Home Page Icons/path5069.png';
      }
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {},
  data: function data() {
    return {
      isModalShown: true
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('closeWufoo');
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        ArrowDown: function ArrowDown() {
            this.$scrollTo("#errorDiv", 300, {
                el: "#errorDiv",
                offset: -100,
                x: false,
                y: true
            });
        }
    }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_JotformModal__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_JotformModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_JotformModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(9);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_6__components_shared_PageLoader___default.a, JotformModal: __WEBPACK_IMPORTED_MODULE_7__components_shared_JotformModal___default.a },
  data: function data() {
    return {
      Account: {},
      cardItems: [],
      jotFormID: null,
      showJotForm: false,
      showStockForm: false,
      ShowStockLensTile: false,
      showPrintableForm: false };
  },

  methods: {
    RouterRedirect: function RouterRedirect(path) {
      this.$router.push({ path: path });
    },
    ToggleJotForm: function ToggleJotForm(jotFormID) {
      this.jotFormID = jotFormID;
      this.showJotForm = !this.showJotForm;
      if (this.showJotForm) {
        document.body.classList.add("body-overflow");
      } else {
        document.body.classList.remove("body-overflow");
      }
    },
    GetAccountValues: function GetAccountValues() {
      var _this = this;
      axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        _this.Account = response.data.raw;
        localStorage.setItem("customUserPermissionFlag", _this.Account.customUserPermissionFlag);
        _this.ShowStockLensTile = _this.Account.customUserPermissionFlag.includes("Show Stock Lens Tile");
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("modal mounted");

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var portalType, apiUrl, response, apiitems, parentFlex, parentIdx, childIdx, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, x;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.GetAccountValues();
              console.log("modal created");
              _context2.prev = 2;
              portalType = window.location.href.includes("championsforsight") ? "CFS" : "CLTL";
              apiUrl = __WEBPACK_IMPORTED_MODULE_8_vue__["default"].config.API_ENDPOINT + "CMS/GetResourcesItems?portalType=" + portalType;
              _context2.next = 7;
              return fetch(apiUrl, {
                method: 'get',
                headers: {
                  'Authorization': "Bearer " + localStorage.getItem("token")
                }
              });

            case 7:
              response = _context2.sent;


              console.log(response);
              _context2.next = 11;
              return response.json();

            case 11:
              apiitems = _context2.sent;

              apiitems = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(apiitems)).sort(function (x, y) {
                return (x.sortOrder || 99999) - (y.sortOrder || 99999);
              });
              apiitems = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(apiitems)).sort(function (x, y) {
                if (x.type < y.type) {
                  return -1;
                } else if (x.type > y.type) {
                  return 1;
                } else {
                  return 0;
                }
              });
              console.log("API items");
              console.log(apiitems);

              parentFlex = [];
              parentIdx = 0;
              childIdx = 0;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 22;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(apiitems); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                x = _step.value;


                if (parentFlex[parentIdx] === undefined) parentFlex[parentIdx] = [];

                parentFlex[parentIdx][childIdx] = x;
                parentFlex[parentIdx][childIdx].isModal = x.linkURL.startsWith("#");
                parentFlex[parentIdx][childIdx].isLocalLInk = !x.linkURL.startsWith("http");

                if (parentFlex[parentIdx][childIdx].isModal) parentFlex[parentIdx][childIdx].jotFormID = x.linkURL.substring(1);

                childIdx++;

                if (x.type === 'List') {
                  childIdx = 0;
                  parentIdx++;
                }

                if (childIdx >= x.columnWidth) {
                  childIdx = 0;
                  parentIdx++;
                }
              }
              _context2.next = 30;
              break;

            case 26:
              _context2.prev = 26;
              _context2.t0 = _context2["catch"](22);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 30:
              _context2.prev = 30;
              _context2.prev = 31;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 33:
              _context2.prev = 33;

              if (!_didIteratorError) {
                _context2.next = 36;
                break;
              }

              throw _iteratorError;

            case 36:
              return _context2.finish(33);

            case 37:
              return _context2.finish(30);

            case 38:
              _this3.cardItems = parentFlex;
              _context2.next = 44;
              break;

            case 41:
              _context2.prev = 41;
              _context2.t1 = _context2["catch"](2);

              console.log(_context2.t1);

            case 44:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[2, 41], [22, 26, 30, 38], [31,, 33, 37]]);
    }))();
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_resourceData_SuggestForm__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_resourceData_SuggestForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_resourceData_SuggestForm__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SuggestForm: __WEBPACK_IMPORTED_MODULE_0__components_portal_resourceData_SuggestForm___default.a },
  data: function data() {
    return {
      isModalShown: false
    };
  },

  methods: {
    ShowModal: function ShowModal() {
      this.isModalShown = !this.isModalShown;
      document.body.classList.add("body-overflow");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_JotformEmbed__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_JotformEmbed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_JotformEmbed__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: { PageLoader: __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default.a, JotformEmbed: __WEBPACK_IMPORTED_MODULE_1__components_shared_JotformEmbed___default.a },
  data: function data() {
    return {
      isModalShown: true,
      prefillFields: null,
      isWufooLoading: true,
      Account: {}
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('closeWufoo');
    },
    GetAccountValues: function GetAccountValues() {
      var _this = this;
      this.isAccountLoading = true;
      axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        _this.Account = response.data.raw;
        _this.prefillFields = "peid=" + _this.Account.portalUserSalesforceId;
        _this.isWufooLoading = false;
      }).catch(function (error) {});
    }
  },
  created: function created() {
    this.GetAccountValues();
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountData_LoginInfo__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountData_LoginInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountData_LoginInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_userAccount_accountData_AccountInfo__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_portal_userAccount_accountData_AccountInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_portal_userAccount_accountData_AccountInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_userAccount_accountData_LocationInfo__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_userAccount_accountData_LocationInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_userAccount_accountData_LocationInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_userAccount_accountData_EyeDoctorInfo__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_userAccount_accountData_EyeDoctorInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_userAccount_accountData_EyeDoctorInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_userAccount_accountData_ForecastingInfo__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_userAccount_accountData_ForecastingInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_portal_userAccount_accountData_ForecastingInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_portal_userAccount_accountData_LabInfo__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_portal_userAccount_accountData_LabInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_portal_userAccount_accountData_LabInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_accountData_AssociationInfo__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_accountData_AssociationInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_accountData_AssociationInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_userAccount_accountData_CommunicationInfo__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_portal_userAccount_accountData_CommunicationInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_portal_userAccount_accountData_CommunicationInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_shared_PageLoader__);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_3__components_shared_FooterComponent___default.a,
    LoginInfo: __WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountData_LoginInfo___default.a,
    AccountInfo: __WEBPACK_IMPORTED_MODULE_5__components_portal_userAccount_accountData_AccountInfo___default.a,
    LocationInfo: __WEBPACK_IMPORTED_MODULE_6__components_portal_userAccount_accountData_LocationInfo___default.a,
    EyeDoctorInfo: __WEBPACK_IMPORTED_MODULE_7__components_portal_userAccount_accountData_EyeDoctorInfo___default.a,
    ForecastingInfo: __WEBPACK_IMPORTED_MODULE_8__components_portal_userAccount_accountData_ForecastingInfo___default.a,
    LabInfo: __WEBPACK_IMPORTED_MODULE_9__components_portal_userAccount_accountData_LabInfo___default.a,
    AssociationInfo: __WEBPACK_IMPORTED_MODULE_10__components_portal_userAccount_accountData_AssociationInfo___default.a,
    CommunicationInfo: __WEBPACK_IMPORTED_MODULE_11__components_portal_userAccount_accountData_CommunicationInfo___default.a,
    PageLoader: __WEBPACK_IMPORTED_MODULE_12__components_shared_PageLoader___default.a
  },
  data: function data() {
    return {
      pageShown: "account",
      isSwitchingTabs: false,
      isSuccess: false,
      labels: null,
      isLoading: true,
      isLoadingEdit: true,
      isFormLoading: false,
      FormInputs: null,
      LoginFormInputs: null,
      isSubmitFail: false,
      called: "",
      TermsEmail: {
        Subject: "Terms and Conditions",
        Name: "",
        Email: "",
        Message: ""
      },
      BusinessEmail: {
        Subject: "Business Associate Agreement",
        Name: "",
        Email: "",
        Message: ""
      },
      Account: {},
      AccountView: {},
      AccountEdit: {},
      NewDoctor: {
        useLicenseNumber: false,
        npiNumber: null,
        licenseNumber: null,
        state: null,
        firstName: null,
        lastName: null,
        suffix: null,
        emailAddress: null,
        yearsInPractice: null,
        organizations: {
          list: [],
          others: null
        },
        id: 0
      },
      AccountEnums: ["Suffix", "State", "BusinessTypeIndividual", "BusinessTypeBusiness", "BusinessTypeNonProfit", "RoleBusiness", "RoleNonProfit", "OrganizationIndividual", "OrganizationBusinessCFS"],
      State: {},
      Suffix: {},
      BusinessTypeIndividual: {},
      BusinessTypeBusiness: {},
      BusinessTypeNonProfit: {},
      RoleBusiness: {},
      RoleNonProfit: {},
      CheckboxIndividual: {},
      CheckboxBusiness: {},
      AccountValidationResult: {},
      LoginEdit: {
        emailAddress: "",
        emailAddressConfirm: "",
        password: "",
        newPassword: "",
        newPasswordConfirm: ""
      }
    };
  },

  methods: {
    SwitchTab: function SwitchTab(tab, event) {
      console.log(this.Account.accountType);
      if (this.pageShown == tab) return;

      var els = this.$el.querySelectorAll('.active');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(els), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var e = _step.value;

          e.className = "btn btn-outline-primary";
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      event.target.parentElement.className = "btn active g-bg-main  g-color-white";
      this.pageShown = tab;
    },
    GetForm: function GetForm() {
      this.GetSelectValues();
      this.GetAccountValues();
      this.GetEditValues();
    },
    GetSelectValues: function GetSelectValues() {
      var _this = this;
      axios.post("/Util/GetEnums", this.AccountEnums).then(function (response) {
        _this.CheckboxBusiness = response.data.raw.OrganizationBusinessCFS;
        _this.CheckboxIndividual = response.data.raw.OrganizationIndividual;
        _this.State = response.data.raw.State;
        _this.Suffix = response.data.raw.Suffix;
        _this.RoleBusiness = response.data.raw.RoleBusiness;
        _this.RoleNonProfit = response.data.raw.RoleNonProfit;
        _this.BusinessTypeIndividual = response.data.raw.BusinessTypeIndividual;
        _this.BusinessTypeBusiness = response.data.raw.BusinessTypeBusiness;
        _this.BusinessTypeNonProfit = response.data.raw.BusinessTypeNonProfit;
        _this.BusinessType = response.data.raw.BusinessType;
      }).catch(function (error) {
        console.log(error);
      });
    },
    GetAccountValues: function GetAccountValues() {
      var _this2 = this;

      axios.get("/Account/self", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this2.isLoading = false;
        _this2.AccountView = response.data.raw;
        _this2.Account = response.data.raw;
        _this2.LoginFormInputs = _this2.FieldFlags.LoginInformation;
        if (response.data.raw.accountType == 1) {
          _this2.FormInputs = _this2.FieldFlags.Individual;
        } else if (response.data.raw.accountType == 2) {
          _this2.FormInputs = _this2.FieldFlags.Business;
        } else if (response.data.raw.accountType == 3) {
          _this2.FormInputs = _this2.FieldFlags.NonProfit;
        }
      }).catch(function (error) {
        console.log(error);
        if (error.response.status == 401) window.location.href = "/";
      });
    },
    GetEditValues: function GetEditValues() {
      var _this = this;
      axios.get("/Account/self", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.isLoadingEdit = false;
        _this.AccountEdit = response.data.raw;
        _this.EndLoad();
      }).catch(function (error) {
        console.log(error);
        if (error.response.status == 401) window.location.href = "/";
      });
    },
    SuccessFade: function SuccessFade() {
      this.isSuccess = !this.isSuccess;
      this.SuccessFadeOut();
      document.body.classList.remove("body-overflow");
    },
    SuccessFadeOut: function SuccessFadeOut() {
      var _this3 = this;

      var myTimerPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(function () {
          _this3.isSuccess = !_this3.isSuccess;
          resolve();
        }, 5000);
      });
    },
    StartLoad: function StartLoad() {
      this.isFormLoading = !this.isFormLoading;
    },
    EndLoad: function EndLoad() {
      var _this4 = this;

      var myTimerPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(function () {
          _this4.isFormLoading = false;
          resolve();
        }, 1000);
      });
    },
    RefreshAddDoctorForm: function RefreshAddDoctorForm() {
      this.NewDoctor = {
        useLicenseNumber: false,
        npiNumber: null,
        licenseNumber: null,
        state: null,
        firstName: null,
        lastName: null,
        suffix: null,
        emailAddress: null,
        yearsInPractice: null,
        organizations: {
          list: [],
          others: null
        },
        id: 0
      };
    }
  },
  created: function created() {
    this.GetForm();
    localStorage.setItem('is-active', 'my-account');
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAccountInfo__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAccountInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAccountInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["AccountView", "AccountEdit", "AccountValidationResult", "FormInputs", "Suffix", "RoleNonProfit", "RoleBusiness", "BusinessTypeNonProfit", "BusinessTypeBusiness", "BusinessTypeIndividual", "State", "isFormLoading"],
  components: { EditAccountInfo: __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAccountInfo___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: false,
      ContactValidationResult: {},
      isLoading: false
    };
  },

  methods: {
    EditSection: function EditSection() {
      document.body.classList.add("body-overflow");
      this.ContactValidationResult = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveAccount: function SaveAccount() {
      var _this2 = this;

      this.AccountEdit.eyeDoctors = null;

      this.isLoading = true;
      this.ContactValidationResult = {};
      axios.post("/Account/AccountInformation", this.AccountEdit, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this2;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.$emit("selfReload");
          _this.CloseModal();
          _this.$emit("success");
        } else {
          _this.ContactValidationResult = response.data.raw.primaryContact.validationResult;
          alert(response.data.errorMessage);
          console.log("Error in Saving!");
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAssociationInfo__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAssociationInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAssociationInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['AccountView', 'AccountEdit', 'AccountValidationResult', 'CheckboxBusiness', 'FormInputs', "isFormLoading"],
  components: { EditAssociationInfo: __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditAssociationInfo___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: false,
      isLoading: false
    };
  },

  methods: {
    EditSection: function EditSection() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveAccount: function SaveAccount() {
      var _this2 = this;

      this.isLoading = true;
      axios.post("/Account/ProfessionalAssociationInformation", this.AccountEdit, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this2;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.$emit("selfReload");
          _this.CloseModal();
          _this.$emit("success");
        } else {
          console.log("Error in Saving!");
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditCommunicationInfo__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditCommunicationInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditCommunicationInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['AccountView', 'AccountEdit', 'FormInputs', 'isFormLoading'],
  components: { EditCommunicationInfo: __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditCommunicationInfo___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: false,
      isLoading: false,
      isContractLoading: false
    };
  },

  methods: {
    EditSection: function EditSection() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveAccount: function SaveAccount() {
      var _this2 = this;

      this.isLoading = true;
      axios.post("/Account/CommunicationInformation", this.AccountEdit, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this2;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.$emit("selfReload");
          _this.CloseModal();
          _this.$emit("success");
        } else {
          console.log("Error in Saving!");
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    },
    GeneratePdf: function GeneratePdf() {
      var _this = this;
      _this.isContractLoading = true;
      var salesforceId = _this.AccountEdit.salesforceId;
      axios.get("/Account/GetContractBySalesforceId/" + salesforceId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var result = response.data.raw;
        var link = document.createElement("a");
        link.href = result;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        _this.isContractLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditEyeDoctorInfo__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditEyeDoctorInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditEyeDoctorInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditProfessionalInfo__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditProfessionalInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditProfessionalInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_userAccount_accountList_DeleteModal__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_portal_userAccount_accountList_DeleteModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_portal_userAccount_accountList_DeleteModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountList_AddDoctor__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountList_AddDoctor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountList_AddDoctor__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['AccountView', 'AccountEdit', 'FormInputs', 'Suffix', 'State', 'CheckboxIndividual', 'isFormLoading', 'NewDoctor'],
  components: { EditEyeDoctorInfo: __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditEyeDoctorInfo___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default.a, EditProfessionalInfo: __WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditProfessionalInfo___default.a, DeleteModal: __WEBPACK_IMPORTED_MODULE_3__components_portal_userAccount_accountList_DeleteModal___default.a, AddDoctor: __WEBPACK_IMPORTED_MODULE_4__components_portal_userAccount_accountList_AddDoctor___default.a },
  data: function data() {
    return {
      isModalShown: false,
      isLoading: false,
      isDeleteModalShown: false,
      eyeDoctorActive: {},
      eyeDoctorActiveIndex: null,
      AccountValidationResult: {},
      isAddModalShown: false,
      EyeDoctorValidation: {},
      NewDoctorValidationResult: {},
      isOneDoctorRemain: false
    };
  },

  methods: {
    EditSection: function EditSection(index) {
      document.body.classList.add("body-overflow");
      this.eyeDoctorActiveIndex = index;
      this.AccountEdit.eyeDoctorActiveIndex = index;
      this.EyeDoctorValidation = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    EditProfessional: function EditProfessional() {
      this.AccountValidationResult = {};
      this.ContactValidationResult = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    ShowModal: function ShowModal() {
      this.isModalShown = !this.isModalShown;
    },
    ShowDeleteDoctorModal: function ShowDeleteDoctorModal(index) {
      if (this.AccountView.eyeDoctors.length > 1) {
        document.body.classList.add("body-overflow");
        this.AccountView.eyeDoctorActiveIndex = index;
        this.eyeDoctorActiveIndex = index;
        this.isDeleteModalShown = !this.isDeleteModalShown;
      } else {
        this.isOneDoctorRemain = true;
      }
    },
    SaveAccount: function SaveAccount() {
      var _this2 = this;

      this.isLoading = true;
      var doctor = this.AccountEdit.eyeDoctors[this.eyeDoctorActiveIndex];
      axios.post("/Account/EyeDoctor/Update/" + this.AccountView.salesforceId, doctor, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this2;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.$emit("selfReload");
          _this.CloseEyeDoctorModal();
          _this.$emit("success");
        } else {
          _this.EyeDoctorValidation = response.data.raw.validationResult;
          console.log("Error in Saving!");
          console.log(response);
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    },
    CloseEyeDoctorModal: function CloseEyeDoctorModal() {
      this.isModalShown = !this.isModalShown;
    },
    SaveProfessionalInfo: function SaveProfessionalInfo() {
      var _this3 = this;

      this.isLoading = true;
      this.AccountValidationResult = {};
      axios.post("/Account/ProfessionalInformation", this.AccountEdit, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this3;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.$emit("selfReload");
          _this.CloseEyeDoctorModal();
          _this.$emit("success");
        } else {
          _this.AccountValidationResult = response.data.raw.validationResult;
          console.log("Error in Saving!");
          console.log(response);
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    },
    DeleteDoctor: function DeleteDoctor() {
      var _this4 = this;

      this.isLoading = true;
      var doctor = this.AccountEdit.eyeDoctors[this.eyeDoctorActiveIndex];
      axios.post("/Account/EyeDoctor/Delete", doctor, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this4;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.$emit("selfReload");
          _this.isDeleteModalShown = false;
          _this.$emit("success");
        } else {
          console.log("Error in Saving!");
          console.log(response);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    ShowAddDoctorModal: function ShowAddDoctorModal() {
      document.body.classList.add("body-overflow");
      this.isAddModalShown = !this.isAddModalShown;
      this.$emit("refreshDoctorForm");
      this.NewDoctorValidationResult = {};
    },
    AddDoctorInfo: function AddDoctorInfo() {
      var _this5 = this;

      this.isLoading = true;
      axios.post("/Account/EyeDoctor/Create/" + this.AccountView.salesforceId, this.NewDoctor, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this5;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.isAddModalShown = false;
          _this.$emit("selfReload");
          _this.$emit("success");
        } else {
          _this.NewDoctorValidationResult = response.data.raw.validationResult;
          console.log("Error in Saving!");
          console.log(response);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    RefreshEyeDoctorValidation: function RefreshEyeDoctorValidation() {
      this.EyeDoctorValidation = [];
      var numberOfDoc = this.AccountEdit.eyeDoctors.length;
      for (var i = 0; i < numberOfDoc; i++) {
        this.EyeDoctorValidation.push({ validationResult: {} });
      }
    },
    ValidateNpiNumber: function ValidateNpiNumber() {
      var _this = this;
      var npiNumber = _this.AccountEdit.npiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;

        _this.AccountEdit.AccountType = this.$route.params.type;
        axios.post('/Account/IsNpiNumberValid/', _this.AccountEdit).then(function (response) {
          if (response.data.isSuccess) {
            _this.AccountValidationResult = { AccountNpiNumber: null };

            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];

            _this.AccountEdit.primaryContact.firstName = basicDetails.first_name;
            _this.AccountEdit.primaryContact.lastName = basicDetails.last_name;
            _this.AccountEdit.primaryContact.suffix = basicDetails.credential;
            _this.AccountEdit.primaryContact.countryCode = address.telephone_number.split('-')[0];
            _this.AccountEdit.primaryContact.areaCode = address.telephone_number.split('-')[1];
            _this.AccountEdit.primaryContact.phone = address.telephone_number.split('-')[2];

            _this.isLoading = false;
          } else {
            _this.AccountValidationResult = { AccountNpiNumber: response.data.errorMessage };
            _this.called = _this.AccountValidationResult.AccountNpiNumber;

            _this.AccountEdit.primaryContact.firstName = null;
            _this.AccountEdit.primaryContact.lastName = null;
            _this.AccountEdit.primaryContact.suffix = null;
            _this.AccountEdit.primaryContact.countryCode = null;
            _this.AccountEdit.primaryContact.areaCode = null;
            _this.AccountEdit.primaryContact.phone = null;

            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateNpiNumberNewDoctor: function ValidateNpiNumberNewDoctor() {
      var _this = this;
      var npiNumber = _this.NewDoctor.npiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;

        _this.DoctorDetails = {
          AccountType: this.$route.params.type,
          NpiNumber: npiNumber
        };

        axios.post('/Account/IsNpiNumberValidEyeDoctor/', _this.DoctorDetails).then(function (response) {
          if (response.data.isSuccess) {
            _this.NewDoctorValidationResult = { EyeDoctorNpiNumber: null };

            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];

            _this.NewDoctor.firstName = basicDetails.first_name;
            _this.NewDoctor.lastName = basicDetails.last_name;
            _this.NewDoctor.suffix = basicDetails.credential;

            _this.isLoading = false;
          } else {
            _this.NewDoctorValidationResult = { EyeDoctorNpiNumber: response.data.errorMessage };

            _this.NewDoctor.firstName = null;
            _this.NewDoctor.lastName = null;
            _this.NewDoctor.suffix = null;

            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateNpiNumberEyeDoctor: function ValidateNpiNumberEyeDoctor(index) {
      var _this = this;
      var npiNumber = _this.AccountEdit.eyeDoctors[index].npiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.AccountEdit.NpiNumber = npiNumber;

        axios.post('/Account/IsNpiNumberValidEyeDoctor/', _this.AccountEdit).then(function (response) {
          if (response.data.isSuccess) {
            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];

            _this.AccountEdit.eyeDoctors[index].firstName = basicDetails.first_name;
            _this.AccountEdit.eyeDoctors[index].lastName = basicDetails.last_name;
            _this.AccountEdit.eyeDoctors[index].suffix = basicDetails.credential;

            _this.EyeDoctorValidation = { EyeDoctorNpiNumber: null };
            _this.isLoading = false;
          } else {
            _this.AccountEdit.eyeDoctors[index].firstName = null;
            _this.AccountEdit.eyeDoctors[index].lastName = null;
            _this.AccountEdit.eyeDoctors[index].suffix = null;

            _this.EyeDoctorValidation = { EyeDoctorNpiNumber: response.data.errorMessage };

            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  created: function created() {
    this.RefreshEyeDoctorValidation();
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditForecastingInfo__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditForecastingInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditForecastingInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['AccountView', 'AccountEdit', 'FormInputs', 'isFormLoading'],
  components: { EditForecastingInfo: __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditForecastingInfo___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_2__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: false,
      OfficeLocationValidationResult: {},
      isLoading: false,
      orderDesc: "",
      forecastServices: [] };
  },

  methods: {
    EditSection: function EditSection() {
      document.body.classList.add("body-overflow");
      this.OfficeLocationValidationResult = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SetUpdatedServices: function SetUpdatedServices(services) {
      this.AccountEdit.primaryContact.officeLocation.howDoYouPlanOnServingThosePatient = services;
    },
    SaveAccount: function SaveAccount() {
      var _this = this;

      this.isLoading = true;
      this.OfficeLocationValidationResult = {};
      var numberOfJobs = this.AccountEdit.primaryContact.officeLocation.numberOfJobs;
      if (numberOfJobs < 100) {
        this.AccountEdit.primaryContact.officeLocation.jobs = {
          january: null,
          february: null,
          march: null,
          april: null,
          may: null,
          june: null,
          july: null,
          august: null,
          september: null,
          october: null,
          november: null,
          december: null
        };
      }
      var totalOfJobs = this.SaveTotalJobs(this.AccountEdit.primaryContact.officeLocation.jobs);
      if (numberOfJobs < totalOfJobs) {
        this.AccountEdit.primaryContact.officeLocation.numberOfJobs = totalOfJobs;
      }

      axios.post("/Account/ForecastingInformation", this.AccountEdit.primaryContact.officeLocation, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (res) {
        _this.isLoading = false;
        if (res.data.isSuccess == true) {
          var forcastingResp = res.request.responseURL.indexOf('ForecastingInformation') !== -1;
          if (forcastingResp) {
            _this.forecastServices = res.data.raw.howDoYouPlanOnServingThosePatient;
          }
          _this.$emit("selfReload");
          _this.CloseModal();
          _this.$emit("success");
        } else {
          _this.OfficeLocationValidationResult = res.data.raw.validationResult;
          console.log("Error in Saving!");
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    },
    SaveTotalJobs: function SaveTotalJobs(job) {
      return (job.january ? parseInt(job.january) : 0) + (job.february ? parseInt(job.february) : 0) + (job.march ? parseInt(job.march) : 0) + (job.april ? parseInt(job.april) : 0) + (job.may ? parseInt(job.may) : 0) + (job.june ? parseInt(job.june) : 0) + (job.july ? parseInt(job.july) : 0) + (job.august ? parseInt(job.august) : 0) + (job.september ? parseInt(job.september) : 0) + (job.october ? parseInt(job.october) : 0) + (job.november ? parseInt(job.november) : 0) + (job.december ? parseInt(job.december) : 0);
    },
    CheckNumberofJobs: function CheckNumberofJobs() {
      var numberOfJobs = this.AccountEdit.primaryContact.officeLocation.numberOfJobs;
      if (numberOfJobs == 1) {
        this.orderDesc = 'order';
        return this.orderDesc;
      } else {
        this.orderDesc = 'orders';
        return this.orderDesc;
      }
    },
    getForecastServicesToPatients: function getForecastServicesToPatients() {
      var _this2 = this;

      axios.get("/Account/Forecasting/" + this.AccountEdit.salesforceId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (res) {
        _this2.forecastServices = res.data.raw;
      });
    }
  },

  created: function created() {
    this.CheckNumberofJobs();
    this.getForecastServicesToPatients();
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: [""]
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditLocationInfo__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditLocationInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditLocationInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_PageLoader__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["AccountView", "AccountEdit", "FormInputs", "State", "RoleNonProfit", "RoleBusiness", "isFormLoading"],
  components: { EditLocationInfo: __WEBPACK_IMPORTED_MODULE_1__components_portal_userAccount_accountEdit_EditLocationInfo___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default.a, PageLoader: __WEBPACK_IMPORTED_MODULE_3__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: false,
      OfficeLocationValidationResult: {},
      isLoading: false,
      IsValidNPI: false,
      IsAddressValidating: false
    };
  },

  methods: {
    EditSection: function EditSection() {
      document.body.classList.add("body-overflow");
      this.OfficeLocationValidationResult = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    IsPhoneEmpty: function IsPhoneEmpty(Phoneparams) {
      if (Phoneparams != "") return Phoneparams + "-";
      return Phoneparams;
    },
    SaveAccount: function SaveAccount() {
      var _this2 = this;

      if (this.AccountEdit.primaryContact.officeLocation.streetAddress) {
        var check_PO_BOX = this.checkIfAddressHasPO_BOX(this.AccountEdit.primaryContact.officeLocation.streetAddress.toString());
        if (check_PO_BOX == true) {
          alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.");
          return;
        }
      }

      this.AccountEdit.eyeDoctors = null;

      this.isLoading = true;
      this.OfficeLocationValidationResult = {};
      axios.post("/Account/MyLocationInformation", this.AccountEdit, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var _this = _this2;
        _this2.isLoading = false;
        if (response.data.isSuccess == true) {
          _this2.$emit("selfReload");
          _this2.CloseModal();
          _this.$emit("success");

          var shippingAddress = {
            shippingAddressLineOne: response.data.raw.primaryContact.officeLocation.streetAddress,
            shippingAddressLineTwo: response.data.raw.primaryContact.officeLocation.suite,
            shippingCity: response.data.raw.primaryContact.officeLocation.city,
            shippingState: response.data.raw.primaryContact.officeLocation.state,
            shippingPostalCode: response.data.raw.primaryContact.officeLocation.zip
          };

          localStorage.setItem("shippingAddress", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(shippingAddress));
        } else {
          _this.OfficeLocationValidationResult = response.data.raw.primaryContact.officeLocation.validationResult;
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    },
    ValidateAddress: function ValidateAddress() {
      var _this = this;
      if (true) {
        _this.IsAddressValidating = true;
        var params = {
          Address2: _this.AccountEdit.primaryContact.officeLocation.streetAddress,
          City: _this.AccountEdit.primaryContact.officeLocation.city,
          State: _this.AccountEdit.primaryContact.officeLocation.state,
          Zip5: _this.AccountEdit.primaryContact.officeLocation.zip
        };
        axios.post("/Account/GetAddressDetails/", params).then(function (response) {
          if (response.data.isSuccess) {
            var details = response.data.raw;
            _this.AccountEdit.primaryContact.officeLocation.streetAddress = details.address2;
            _this.AccountEdit.primaryContact.officeLocation.city = details.city;
            _this.AccountEdit.primaryContact.officeLocation.state = details.state;
            _this.AccountEdit.primaryContact.officeLocation.zip = details.zip5;
            _this.OfficeLocationValidationResult.OfficeLocationZip = null;
            _this.IsAddressValidating = false;
            _this.IsValidNPI = true;
          } else {
            _this.OfficeLocationValidationResult.OfficeLocationZip = response.data.errorMessage;
            _this.IsAddressValidating = false;
            _this.IsValidNPI = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditLoginInfo__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditLoginInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditLoginInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserAccount_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UserAccount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["AccountView", "LoginFormInputs", "LoginEdit"],
  components: { EditLoginInfo: __WEBPACK_IMPORTED_MODULE_0__components_portal_userAccount_accountEdit_EditLoginInfo___default.a, LoadingComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_LoadingComponent___default.a },
  data: function data() {
    return {
      isModalShown: false,
      LoginValidationResult: {},
      LoginErrorMessage: "",
      isLoading: false
    };
  },

  methods: {
    HidePassword: function HidePassword() {},
    EditSection: function EditSection() {
      document.body.classList.add("body-overflow");
      this.LoginValidationResult = {};
      this.LoginErrorMessage = "";
      this.NewLoginEdit();
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveLoginInformation: function SaveLoginInformation() {
      var _this = this;
      _this.isLoading = true;
      _this.LoginValidationResult = {};
      _this.LoginErrorMessage = "";
      axios.post("/Account/LoginInformation", this.LoginEdit, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          localStorage.removeItem("host");
          localStorage.removeItem("token");
          localStorage.removeItem("watchword");
          localStorage.setItem("host", response.data.raw.username);
          localStorage.setItem("token", response.data.raw.token);
          localStorage.setItem("watchword", response.data.raw.password);
          _this.NewLoginEdit();
          _this.isModalShown = false;
          _this.$emit("selfReload");
          _this.CloseModal();
          _this.$emit("success");
        } else {
          if (response.data.errorMessage == "Invalid parameters") {
            _this.LoginValidationResult = response.data.raw.validationResult;
          } else {
            _this.LoginErrorMessage = response.data.errorMessage;
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    },
    NewLoginEdit: function NewLoginEdit() {
      this.LoginEdit.emailAddress = "";
      this.LoginEdit.emailAddressConfirm = "";
      this.LoginEdit.password = "";
      this.LoginEdit.newPassword = "";
      this.LoginEdit.newPasswordConfirm = "";
    },
    IsEmailAddressValid: function IsEmailAddressValid() {
      var _this = this;
      var emailAddress = _this.LoginEdit.emailAddress;
      if (emailAddress == null || emailAddress == '') {
        _this.LoginValidationResult = { AccountEmailAddress: null };
      } else {
        axios.get("/Account/IsEmailAddressValid/" + this.LoginEdit.emailAddress).then(function (response) {
          _this.LoginValidationResult = { AccountEmailAddress: response.data.errorMessage };
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateConfirmEmail: function ValidateConfirmEmail() {
      var _this = this;
      var confirmEmailAddress = _this.LoginEdit.emailAddressConfirm;
      if (confirmEmailAddress == null || confirmEmailAddress == '') {
        _this.LoginValidationResult = { AccountEmailAddressConfirm: null };
      } else {
        axios.get("/Account/IsEmailAddressValid/" + this.LoginEdit.emailAddressConfirm).then(function (response) {
          _this.LoginValidationResult = { AccountEmailAddressConfirm: response.data.errorMessage };
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateMatchEmail: function ValidateMatchEmail() {
      var _this = this;
      if (_this.LoginEdit.emailAddress == null || _this.LoginEdit.emailAddress == '') {
        _this.ValidateConfirmEmail();
      } else {
        if (_this.LoginEdit.emailAddress != _this.LoginEdit.emailAddressConfirm) {
          _this.LoginValidationResult = {
            AccountEmailAddressConfirm: "Email address does not match"
          };
        } else {
          _this.LoginValidationResult = { AccountEmailAddressConfirm: null };
        }
      }
    }
  },
  created: function created() {
    this.HidePassword();
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['AccountEdit', 'AccountValidationResult', 'FormInputs', 'ContactValidationResult', 'Suffix', 'RoleNonProfit', 'RoleBusiness', 'BusinessTypeNonProfit', 'BusinessTypeBusiness', 'BusinessTypeIndividual', 'State'],
    methods: {
        NumberCheck: function NumberCheck(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();;
            }
        },
        NextField: function NextField(field) {
            var focus1 = this.$refs.participant_number_1;
            var focus2 = this.$refs.participant_number_2;
            var focus3 = this.$refs.participant_number_3;

            if (field == 1 && focus1.value.length == 3) {
                focus2.focus();
            } else if (field == 2 && focus2.value.length == 3) {
                focus3.focus();
            }
        },
        FocusNextField: function FocusNextField(element1, element2, element3) {
            if (element1.value.length == 2) {
                element2.focus();
            } else if (element2.value.length == 2) {
                element3.focus();
            }
        },
        ValidateNpiNumber: function ValidateNpiNumber(npiNumber, event) {
            this.NumberCheck(event);
            var _this = this;
            if (npiNumber.length == 10) {
                axios.get("/Account/IsNpiNumberValid/" + npiNumber).then(function (response) {
                    _this.AccountValidationResult.AccountNpiNumber = response.data.errorMessage;
                    _this.called = _this.AccountValidationResult.AccountNpiNumber;
                }).catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['AccountEdit', 'CheckboxBusiness', 'FormInputs']
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['AccountEdit', 'CheckboxBusiness', 'CheckboxIndividual', 'FormInputs'],
  data: function data() {
    return {
      isContractLoading: false
    };
  },

  methods: {
    GeneratePdf: function GeneratePdf() {
      var _this = this;
      _this.isContractLoading = true;
      var salesforceId = _this.AccountEdit.salesforceId;
      axios.get("/Account/GetContractBySalesforceId/" + salesforceId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var result = response.data.raw;
        var link = document.createElement("a");
        link.href = result;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        _this.isContractLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ["AccountView", "AccountEdit", "FormInputs", "Suffix", "State", 'CheckboxIndividual', 'isFormLoading', 'eyeDoctorActive', 'eyeDoctorActiveIndex', 'EyeDoctorValidation'],
    components: { PageLoader: __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default.a },
    data: function data() {
        return {
            isValid: true,
            isModalShown: true,
            doctorIndex: this.AccountEdit.eyeDoctorActiveIndex,
            errorMessage: {
                year: null
            }
        };
    },

    methods: {
        useLicenseNumberChange: function useLicenseNumberChange(index, value) {
            if (value == false) {
                this.ValidateNpiNumberEyeDoctor(index);
            } else {
                this.isValid = true;
                this.EyeDoctorValidation.EyeDoctorNpiNumber = null;
            }
        },
        AddDoctor: function AddDoctor() {
            this.AccountEdit.eyeDoctors.push({ useLicenseNumber: false });
            this.EyeDoctorValidation.push({ validationResult: {} });
        },
        RemoveDoctor: function RemoveDoctor() {
            this.AccountEdit.eyeDoctors.pop();
        },
        ValidateNpiNumberEyeDoctor: function ValidateNpiNumberEyeDoctor(index) {
            if (this.AccountEdit.eyeDoctors[this.doctorIndex].useLicenseNumber == false) {
                var npiLength = this.AccountEdit.eyeDoctors[this.doctorIndex].npiNumber.length || 0;
                if (npiLength != 10) {
                    this.EyeDoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number";
                    this.isValid = false;
                } else {
                    this.isValid = true;
                }
            } else {
                this.isValid = true;
                this.EyeDoctorValidation.EyeDoctorNpiNumber = null;
            }

            this.$emit("npiIsDirty");
        },
        CloseModal: function CloseModal() {
            this.isModalShown = false;
            this.$emit("modalClick");
            document.body.classList.remove("body-overflow");
        },
        SaveChanges: function SaveChanges() {
            var npiLength = 0;
            if (this.AccountEdit.eyeDoctors[this.doctorIndex].useLicenseNumber == false) {
                if (this.AccountEdit.eyeDoctors[this.doctorIndex] && this.AccountEdit.eyeDoctors[this.doctorIndex].npiNumber) {
                    npiLength = this.AccountEdit.eyeDoctors[this.doctorIndex].npiNumber.length;
                }
                if (npiLength != 10) {
                    this.EyeDoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number";
                    this.isValid = false;
                }
                if (this.EyeDoctorValidation.EyeDoctorNpiNumber == null || this.EyeDoctorValidation.EyeDoctorNpiNumber == undefined) {
                    this.isValid = true;
                } else {
                    this.isValid = false;
                }
            }

            if (this.isValid == true) {
                this.$emit("saveDoctorChanges");
            } else {
                alert("Please make sure all required fields are complete.");
            }
        },
        NumberOfYearsCheck: function NumberOfYearsCheck(input) {
            if (input < 1) this.AccountEdit.eyeDoctors[this.doctorIndex].yearsInPractice = null;else this.AccountEdit.eyeDoctors[this.doctorIndex].yearsInPractice = input;
        },
        CheckYearLicense: function CheckYearLicense(yearPractice) {
            var year = yearPractice;
            var result = this.G_CheckYearLicense(year);
            if (result) this.errorMessage.year = result;else this.errorMessage.year = "";
        }
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['AccountEdit', 'ForcastServices', 'FormInputs', 'OfficeLocationValidationResult'],
    data: function data() {
        return {
            isInviteDoctor: false,
            total: 0,
            currentMonth: 0,
            forcastServices: []
        };
    },

    computed: {
        computedOfficeLocation: function computedOfficeLocation() {
            return this.AccountEdit.primaryContact.officeLocation;
        }
    },
    watch: {
        total: function total(val) {
            if (val >= 100) this.computedOfficeLocation.numberOfJobs = val;
        }
    },
    methods: {
        TotalJobs: function TotalJobs() {
            this.total = (this.AccountEdit.primaryContact.officeLocation.jobs.january ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.january) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.february ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.february) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.march ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.march) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.april ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.april) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.may ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.may) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.june ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.june) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.july ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.july) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.august ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.august) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.september ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.september) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.october ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.october) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.november ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.november) : 0) + (this.AccountEdit.primaryContact.officeLocation.jobs.december ? parseInt(this.AccountEdit.primaryContact.officeLocation.jobs.december) : 0);
        },
        onChangeServices: function onChangeServices() {
            this.$emit('setUpdatedServices', this.forcastServices);
        }
    },
    created: function created() {
        this.TotalJobs();
        this.currentMonth = new Date().getMonth() + 1;
        this.forcastServices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.ForcastServices));
    }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['AccountEdit', 'OfficeLocationValidationResult', 'FormInputs', 'State', 'RoleNonProfit', 'RoleBusiness', 'IsValidNPI', 'IsAddressValidating'],
    data: function data() {
        return {
            isInviteDoctor: false,
            total: 0
        };
    },

    computed: {
        pledge: function pledge() {
            var text = null;
            if (this.$route.params.type == "Individual") {
                text = "The participant pledges to do the following number of charitable jobs this calendar year.*";
            } else if (this.$route.params.type == "Business") {
                text = "This location of the business pledges/forecasts to serve the do the following number of charitable jobs this calendar year.*";
            } else if (this.$route.params.type == "NonProfit") {
                text = "This location of the organization forecasts to do the following number of charitable jobs this calendar year.*";
            }
            return text;
        }
    },
    methods: {
        addressChanged: function addressChanged(evt) {
            if (this.AccountEdit.primaryContact.officeLocation.streetAddress) {
                var check_PO_BOX = this.checkIfAddressHasPO_BOX(this.AccountEdit.primaryContact.officeLocation.streetAddress.toString());
                if (check_PO_BOX == true) {
                    alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.");
                    return;
                }
            }
        },
        NumberCheck: function NumberCheck(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();;
            }
        },
        NextField: function NextField(field) {
            var focus1 = this.$refs.office_number_1;
            var focus2 = this.$refs.office_number_2;
            var focus3 = this.$refs.office_number_3;

            if (field == 1 && focus1.value.length == 3) {
                focus2.focus();
            } else if (field == 2 && focus2.value.length == 3) {
                focus3.focus();
            }
        },
        FocusNextField: function FocusNextField(element1, element2, element3) {
            if (element1.value.length == 2) {
                element2.focus();
            } else if (element2.value.length == 2) {
                element3.focus();
            }
        },
        ValidateAddress: function ValidateAddress() {
            this.$emit("addressCheck");
        }
    }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ["LoginValidationResult", "LoginFormInputs", "LoginEdit", "LoginErrorMessage"],
    data: function data() {
        return {
            hasPasswordError: false,
            hasConfirmPasswordError: false,
            hasPasswordErrorMessage: '',
            hasConfirmPasswordErrorMessage: ''
        };
    },

    methods: {
        CheckPasswordDigits: function CheckPasswordDigits() {
            if (this.LoginEdit.newPassword == null || this.LoginEdit.newPassword == '') {
                this.hasPasswordError = false;
                this.hasPasswordErrorMessage = '';
            } else {
                var result = this.G_CheckPasswordDigits(this.LoginEdit.newPassword);
                if (result) {
                    this.hasPasswordError = result.error;
                    this.hasPasswordErrorMessage = result.message;
                }
                this.CheckMatchPassword();
                this.CheckMatchCurrentPassword();
            }
        },
        CheckConfirmPasswordDigits: function CheckConfirmPasswordDigits() {
            if (this.LoginEdit.newPasswordConfirm == null || this.LoginEdit.newPasswordConfirm == '') {
                this.hasConfirmPasswordError = false;
                this.hasConfirmPasswordErrorMessage = '';
            } else {
                var result = this.G_CheckPasswordDigits(this.LoginEdit.newPasswordConfirm);
                if (result) {
                    this.hasConfirmPasswordError = result.error;
                    this.hasConfirmPasswordErrorMessage = result.message;
                }
                this.CheckMatchPassword();
                this.CheckMatchCurrentPassword();
            }
        },
        CheckMatchPassword: function CheckMatchPassword() {
            var result = this.G_CheckMatchPassword(this.LoginEdit.newPassword, this.LoginEdit.newPasswordConfirm);
            if (result.length != 0) {
                this.hasPasswordError = result[0].error;
                this.hasPasswordErrorMessage = result[0].message;
                this.hasConfirmPasswordError = result[1].error;
                this.hasConfirmPasswordErrorMessage = result[1].message;
            }
        },
        CheckMatchCurrentPassword: function CheckMatchCurrentPassword() {
            var result1 = this.G_CheckMatchCurrentPassword(this.LoginEdit.password, this.LoginEdit.newPassword);
            var result2 = this.G_CheckMatchCurrentPassword(this.LoginEdit.password, this.LoginEdit.newPasswordConfirm);
            if (result1) {
                this.hasPasswordError = result1.error;
                this.hasPasswordErrorMessage = result1.message;
            }
            if (result2) {
                this.hasConfirmPasswordError = result2.error;
                this.hasConfirmPasswordErrorMessage = result2.message;
            }
        },
        ValidateEmail: function ValidateEmail() {
            this.$emit("ValidateEmail");
        },
        ValidateConfirmEmail: function ValidateConfirmEmail() {
            this.$emit("confirmEmail");
        }
    },
    created: function created() {
        this.LoginValidationResult = {};
    }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["AccountEdit", "FormInputs", "Suffix", "State", 'CheckboxIndividual', 'AccountValidationResult', 'isFormLoading'],
  components: { PageLoader: __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: true,
      errorMessage: {
        year: null
      }
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.isModalShown = false;
      this.$emit("modalClick");
      document.body.classList.remove("body-overflow");
    },
    SaveInfo: function SaveInfo() {
      this.$emit("saveProfessional");
    },
    ValidateNpiNumber: function ValidateNpiNumber() {
      this.$emit("npiIsDirty");
    },
    CheckYearLicense: function CheckYearLicense(yearPractice) {
      var year = yearPractice;
      var result = this.G_CheckYearLicense(year);
      if (result) this.errorMessage.year = result;else this.errorMessage.year = "";
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["AccountView", "AccountEdit", "FormInputs", "Suffix", "State", 'CheckboxIndividual', 'isFormLoading', 'eyeDoctorActive', 'eyeDoctorActiveIndex', 'EyeDoctorValidation', 'NewDoctor', 'NewDoctorValidationResult'],
  components: {},
  data: function data() {
    return {
      isValid: true,
      isAddModalShown: true,
      errorMessage: {
        year: null
      },
      invalidNpiNumberPaste: false
    };
  },

  methods: {
    pasteNpiNumber: function pasteNpiNumber(event) {
      var re = /^\d+$/;
      if (!re.test(event.clipboardData.getData('text'))) {
        this.invalidNpiNumberPaste = true;
      } else {
        this.invalidNpiNumberPaste = false;
      }
    },
    CloseModal: function CloseModal() {
      this.isAddModalShown = false;
      this.$emit("modalClose");
      document.body.classList.remove("body-overflow");
    },
    AddThisDoctor: function AddThisDoctor() {
      var npiLength = 0;
      if (this.NewDoctor && this.NewDoctor.npiNumber) {
        npiLength = this.NewDoctor.npiNumber.length;
      }
      if (this.NewDoctor.useLicenseNumber == false) {
        if (npiLength != 10) {
          this.NewDoctorValidationResult.EyeDoctorNpiNumber = "Invalid NPI Number";
          this.isValid = false;
        } else {
          if (this.NewDoctorValidationResult.EyeDoctorNpiNumber == null) {
            this.isValid = true;
          }
        }
      } else {
        this.isValid = true;
      }

      if (this.isValid) {
        this.$emit("AddEyeDoctor");
      } else {
        alert("Please make sure all required fields are complete.");
      }
    },
    ValidateNpiNumberEyeDoctor: function ValidateNpiNumberEyeDoctor() {
      var npiLength = 0;
      if (this.NewDoctor && this.NewDoctor.npiNumber) {
        npiLength = this.NewDoctor.npiNumber.length;
      }

      if (npiLength != 10) {
        this.NewDoctorValidationResult.EyeDoctorNpiNumber = "Invalid NPI Number";
        this.isValid = false;
      }

      this.$emit("npiIsDirty");
    },
    CheckYearLicense: function CheckYearLicense(yearPractice) {
      var year = yearPractice;
      var result = this.G_CheckYearLicense(year);
      if (result) this.errorMessage.year = result;else this.errorMessage.year = "";
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['AccountView', 'FormInputs', 'Suffix', 'State', 'CheckboxIndividual', 'isFormLoading', 'AccountValidationResult', 'eyeDoctorActiveIndex'],
  components: {},
  data: function data() {
    return {
      isDeleteModalShown: true,
      doctorIndex: this.AccountView.eyeDoctorActiveIndex
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.isDeleteModalShown = false;
      this.$emit("modalClose");
      document.body.classList.remove("body-overflow");
    },
    DeleteDoctor: function DeleteDoctor() {
      this.$emit("delete");
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      individualIcon: '../../../static/assets/img/Registration/optometrist_inv.png',
      practiceIcon: '../../../static/assets/img/Registration/practice_acc_inv.png',
      nonProfitIcon: '../../../static/assets/img/Registration/nonprofit_acc_inv.png'
    };
  },

  methods: {
    ChooseFormType: function ChooseFormType(formType) {
      this.$router.push({ name: 'Registration', params: { type: formType } });
      this.$emit("clicked");
    },
    HoverIndividual: function HoverIndividual(event) {
      if (event == 'enter') {
        this.individualIcon = '../../../static/assets/img/Registration/optometrist.png';
      } else if (event == 'leave') {
        this.individualIcon = '../../../static/assets/img/Registration/optometrist_inv.png';
      }
    },
    HoverPractice: function HoverPractice(event) {
      if (event == 'enter') {
        this.practiceIcon = '../../../static/assets/img/Registration/practice_acc.png';
      } else if (event == 'leave') {
        this.practiceIcon = '../../../static/assets/img/Registration/practice_acc_inv.png';
      }
    },
    HoverNonProfit: function HoverNonProfit(event) {
      if (event == 'enter') {
        this.nonProfitIcon = '../../../static/assets/img/Registration/nonprofit_acc.png';
      } else if (event == 'leave') {
        this.nonProfitIcon = '../../../static/assets/img/Registration/nonprofit_acc_inv.png';
      }
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a },
    data: function data() {
        return {
            isLoading: true,
            messageHeader: '',
            isSuccess: false
        };
    },

    methods: {
        VerifyAccount: function VerifyAccount() {
            var _this = this;
            axios.get('/Account/Verify/' + this.$route.params.code).then(function (response) {
                _this.isLoading = false;
                _this.isSuccess = response.data.isSuccess;
                if (response.data.isSuccess) {
                    _this.messageHeader = "Congratulations";
                } else {
                    _this.messageHeader = "Error";
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    created: function created() {
        this.VerifyAccount();
    }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['Account', 'OfficeLocationValidationResult', 'FormInputs', 'PledgeLabel', 'PledgeHelpText'],
  data: function data() {
    return {
      total: 0,
      currentMonth: 0
    };
  },

  computed: {
    computedOfficeLocation: function computedOfficeLocation() {
      return this.Account.PrimaryContact.OfficeLocation;
    }
  },
  watch: {
    total: function total(val) {
      if (val >= 100) this.computedOfficeLocation.NumberOfJobs = val;
    }
  },
  methods: {
    TotalJobs: function TotalJobs() {
      this.total = (this.Account.PrimaryContact.OfficeLocation.Jobs.January ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.January) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.February ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.February) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.March ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.March) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.April ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.April) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.May ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.May) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.June ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.June) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.July ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.July) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.August ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.August) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.September ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.September) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.October ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.October) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.November ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.November) : 0) + (this.Account.PrimaryContact.OfficeLocation.Jobs.December ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.December) : 0);
    }
  },
  created: function created() {
    var dateTime = new Date();
    this.currentMonth = dateTime.getMonth() + 1;
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_registration_AccountType__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_registration_AccountType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_registration_AccountType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_LoadingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AccountDetails_NonProfitOrganizationDetails__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AccountDetails_NonProfitOrganizationDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AccountDetails_NonProfitOrganizationDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AccountDetails_UsernameAndPassword__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AccountDetails_UsernameAndPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_AccountDetails_UsernameAndPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountDetails_ParticipantInformation__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountDetails_ParticipantInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AccountDetails_ParticipantInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountDetails_OfficeLocationInformation__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountDetails_OfficeLocationInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AccountDetails_OfficeLocationInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountDetails_EyeDoctorInformation__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountDetails_EyeDoctorInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AccountDetails_EyeDoctorInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountDetails_AssociationAndCommunication__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountDetails_AssociationAndCommunication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AccountDetails_AssociationAndCommunication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountDetails_TermAgreementAndBaa__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountDetails_TermAgreementAndBaa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_AccountDetails_TermAgreementAndBaa__);




function InitialData() {
  return {
    labels: null,
    isLoading: false,
    FormInputs: null,
    isSubmitFail: false,
    called: "",
    TermsEmail: {
      Subject: "Terms and Conditions",
      Name: "",
      Email: "",
      Message: ""
    },
    BusinessEmail: {
      Subject: "Business Associate Agreement",
      Name: "",
      Email: "",
      Message: ""
    },
    AccountValidateNpi: {},
    Account: {
      PortalType: window.location.href.includes("championsforsight") ? "CFS" : "CLTL",
      AccountType: null,
      UseLicenseNumber: false,
      NoEyeDoctor: false,
      IsCoveredUnderHIPAA: true,
      IsCoBrandAgreed: true,
      IsLensesAgreementAgreed: true,
      BusinessNpiNumber: null,
      IsOrderFrameKit: false,
      IsPatientChargeAgreed: true,
      IsElectronicLogAgreed: true,
      BusinessAssociateAgreement: true,
      TermAgreement: null,
      ToBeContactedAsVolunteer: true,
      ToReceiveNewsLetter: true,
      isFrameOrderingAllowed: false,
      isFrameKitAllowed: false,
      HowDoYouPlanOnServingThosePatient: [],
      PrimaryContact: {
        IsEyeDoctor: false,
        IsLicenseNumber: false,
        IsPrimaryLicenseNumber: false,

        IsMultiLocation: false,
        IsFirstName: false,
        OfficeLocation: {
          Jobs: {},
          StreetAddress: null,
          City: null,
          State: null,
          Zip: null,
          QRDonationCode: null
        },
        LicenseNumber: null,
        State: null,
        NpiNumber: null
      },
      EyeDoctors: [{
        UseLicenseNumber: false,
        NpiNumber: null,
        LicenseNumber: null,
        State: null,
        FirstName: null,
        LastName: null,
        Suffix: null,
        EmailAddress: null,
        YearsInPractice: null,
        Organizations: {
          List: [],
          Others: null
        },
        NoEyeDoctor: false,
        Role: null
      }],
      NewsLetter: true,
      Opportunities: true,
      Organizations: {
        List: []
      },
      ParticipantResponsibilitiesDate: new Date().getMonth() + 1 + "/" + new Date().getDate() + "/" + new Date().getFullYear(),
      BusinessAssociateAgreementDate: new Date().getMonth() + 1 + "/" + new Date().getDate() + "/" + new Date().getFullYear(),
      PaymentProcessors: {
        List: [],
        Other: null
      },
      DonationSolutions: {
        List: [],
        Other: null
      }
    },
    AccountEnums: ["Suffix", "State", "BusinessTypeIndividual", "BusinessTypeBusiness", "BusinessTypeNonProfit", "RoleBusiness", "RoleNonProfit", "OrganizationIndividual", "OrganizationBusinessCFS"],
    State: {},
    Suffix: {},
    BusinessTypeIndividual: {},
    BusinessTypeBusiness: {},
    BusinessTypeNonProfit: {},
    RoleBusiness: {},
    RoleNonProfit: {},
    CheckboxIndividual: {},
    CheckboxBusiness: {},
    AccountValidationResult: {},
    HasEmailAddressError: "",
    HasConfirmEmailAddressError: "",
    ContactValidationResult: {},
    OfficeLocationValidationResult: {
      OfficeLocationJobs: null,
      OfficeLocationNumberOfJobs: null,
      OfficeLocationZip: null
    },
    EyeDoctorValidation: [{
      validationResult: {}
    }],
    IsValidNPI: false,
    IsAddressValidating: false
  };
}













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_2__components_shared_HeaderComponent___default.a,
    AccountType: __WEBPACK_IMPORTED_MODULE_3__components_registration_AccountType___default.a,
    LoadingComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_LoadingComponent___default.a,
    FooterComponent: __WEBPACK_IMPORTED_MODULE_5__components_shared_FooterComponent___default.a,
    NonProfitOrganizationDetails: __WEBPACK_IMPORTED_MODULE_6__components_AccountDetails_NonProfitOrganizationDetails___default.a,
    UsernameAndPassword: __WEBPACK_IMPORTED_MODULE_7__components_AccountDetails_UsernameAndPassword___default.a,
    ParticipantInformation: __WEBPACK_IMPORTED_MODULE_8__components_AccountDetails_ParticipantInformation___default.a,
    OfficeLocationInformation: __WEBPACK_IMPORTED_MODULE_9__components_AccountDetails_OfficeLocationInformation___default.a,
    EyeDoctorInformation: __WEBPACK_IMPORTED_MODULE_10__components_AccountDetails_EyeDoctorInformation___default.a,
    AssociationAndCommunication: __WEBPACK_IMPORTED_MODULE_11__components_AccountDetails_AssociationAndCommunication___default.a,
    TermAgreementAndBaa: __WEBPACK_IMPORTED_MODULE_12__components_AccountDetails_TermAgreementAndBaa___default.a
  },
  data: function data() {
    return InitialData();
  },

  computed: {
    registrationType: function registrationType() {
      var type = null;
      if (this.$route.params.type == "Individual") {
        type = "Individual";
      } else if (this.$route.params.type == "Business") {
        type = "Practice/Business";
      } else if (this.$route.params.type == "NonProfit") {
        type = "Non-Profit";
      }
      return type;
    },
    noteLabel: function noteLabel() {
      var note = null;
      if (this.$route.params.type == "Individual") {
        note = "NOTE:  You must be an eye care professional with a valid NPI number or License number to complete this form.";
      } else if (this.$route.params.type == "Business") {
        note = "NOTE: Please ensure you have legal authority to sign agreements on behalf of your company before completing this registration form.";
      } else if (this.$route.params.type == "NonProfit") {
        note = "NOTE: Please ensure you have legal authority to sign agreements on behalf of your organization before completing this registration form.";
      }
      return note;
    }
  },
  methods: {
    Reset: function Reset() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, InitialData());
    },
    GetForm: function GetForm() {
      this.Reset();
      this.GetSelectValues();
      this.FormInputs = this.FieldFlags[this.$route.params.type];
    },
    GetSelectValues: function GetSelectValues() {
      var _this = this;
      axios.post("/Util/GetEnums", this.AccountEnums).then(function (response) {
        _this.CheckboxBusiness = response.data.raw.OrganizationBusinessCFS;
        _this.CheckboxIndividual = response.data.raw.OrganizationIndividual;
        _this.State = response.data.raw.State;
        _this.Suffix = response.data.raw.Suffix;
        _this.RoleBusiness = response.data.raw.RoleBusiness;
        _this.RoleNonProfit = response.data.raw.RoleNonProfit;
        _this.BusinessTypeIndividual = response.data.raw.BusinessTypeIndividual;
        _this.BusinessTypeBusiness = response.data.raw.BusinessTypeBusiness;
        _this.BusinessTypeNonProfit = response.data.raw.BusinessTypeNonProfit;
        _this.BusinessType = response.data.raw.BusinessType;
      }).catch(function (error) {
        console.log(error);
      });
    },
    IsEmailAddressValid: function IsEmailAddressValid(event) {
      var _this = this;
      axios.get("/Account/IsEmailAddressValid/" + this.Account.EmailAddress + "/" + this.Account.PortalType).then(function (response) {
        _this.AccountValidationResult = {
          AccountEmailAddress: response.data.errorMessage,
          AccountEmailAddressConfirm: _this.HasConfirmEmailAddressError
        };
        _this.HasEmailAddressError = response.data.errorMessage;
        _this.called = _this.AccountValidationResult.AccountEmailAddress;
      }).catch(function (error) {
        console.log(error);
      });
    },
    SubmitForm: function SubmitForm() {
      if (this.$route.params.type == "Individual") {
        this.Account.EyeDoctors = [];
      }

      if (this.Account.PrimaryContact.FirstName && this.Account.PrimaryContact.LastName) {
        this.Account.PrimaryContact.LegalName = ((this.Account.PrimaryContact.FirstName || '') + " " + (this.Account.PrimaryContact.LastName || '')).trim();
      }

      if (this.Account.PrimaryContact.OfficeLocation.StreetAddress) {
        var check_PO_BOX = this.checkIfAddressHasPO_BOX(this.Account.PrimaryContact.OfficeLocation.StreetAddress.toString());
        if (check_PO_BOX == true) {
          alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.");
          return;
        }
      }
      var _this = this;
      console.log("_this.AccountValidationResult");
      console.log(_this.AccountValidationResult);
      var isValid = true;
      if (_this.AccountValidationResult.AccountEmailAddress != null || _this.AccountValidationResult.AccountEmailAddressConfirm) {
        isValid = false;
      }
      if (isValid == false) {
        alert("Please make sure all required fields are complete.");
        return;
      }

      if (this.Account.ParticipantResponsibilitiesSignature != null) {
        this.Account.BusinessAssociateAgreementSignature = this.Account.ParticipantResponsibilitiesSignature;
      }

      this.Account.AccountType = this.$route.params.type;
      if (sessionStorage.getItem("referralCode")) {
        this.Account.ReferralCode = sessionStorage.getItem("referralCode");
      }

      this.isLoading = true;
      if (!_this.Account.IsCoveredUnderHIPAA) _this.Account.BusinessAssociateAgreement = "true";

      var numberOfJobs = _this.Account.PrimaryContact.OfficeLocation.NumberOfJobs;
      if (numberOfJobs < 100) {
        console.log("if (numberOfJobs < 100) {");
        _this.Account.PrimaryContact.OfficeLocation.Jobs = {
          january: null,
          february: null,
          march: null,
          april: null,
          may: null,
          june: null,
          july: null,
          august: null,
          september: null,
          october: null,
          november: null,
          december: null
        };
        console.log("this.Account.PrimaryContact.OfficeLocation");
        console.log(this.Account.PrimaryContact.OfficeLocation);
        this.Account.PrimaryContact.OfficeLocation.Jobs = _this.Account.PrimaryContact.OfficeLocation.Jobs;
      }
      var totalOfJobs = _this.SaveTotalJobs(_this.Account.PrimaryContact.OfficeLocation.Jobs);
      if (numberOfJobs < totalOfJobs) {
        _this.Account.PrimaryContact.OfficeLocation.NumberOfJobs = totalOfJobs;
        this.Account.PrimaryContact.OfficeLocation.NumberOfJobs = totalOfJobs;
      }
      console.log("Account/SaveChanges this.Account");
      console.log(this.Account);
      axios.post("Account/Register/CFS", this.Account).then(function (response) {
        _this.AccountValidationResult = response.data.raw.validationResult;
        console.log("_this.AccountValidationResult");
        console.log(_this.AccountValidationResult);
        _this.ContactValidationResult = response.data.raw.primaryContact.validationResult;
        _this.OfficeLocationValidationResult = response.data.raw.primaryContact.officeLocation.validationResult;
        _this.EyeDoctorValidation = response.data.raw.eyeDoctors;
        _this.isLoading = false;
        if (response.data.isSuccess == true) {
          _this.$router.push({
            name: "RegistrationSuccess",
            query: { salesforceId: response.data.raw.salesforceId }
          });
        } else {
          if (_this.$route.params.type == 2 && _this.$route.query.BusinessNpiNumber != "") {
            console.log("fail to register business");
          }


          _this.isSubmitFail = true;
          _this.$scrollTo("#errorDiv", 300, {
            el: "#errorDiv",
            offset: -100,
            x: false,
            y: true
          });
        }
      }).catch(function (error) {
        _this.isLoading = false;
        console.log(error);
        _this.$router.push({ name: "Error" });
      });
    },
    EnablebCheck: function EnablebCheck() {
      var isEnabled = false;
      if (this.Account.TermAgreement == "true" && this.Account.ParticipantResponsibilitiesSignature) {
        isEnabled = true;
      }
      return isEnabled;
    },
    ValidateAddress: function ValidateAddress() {
      var _this = this;

      if (true) {
        _this.IsAddressValidating = true;
        var params = {
          Address2: _this.Account.PrimaryContact.OfficeLocation.StreetAddress,
          City: _this.Account.PrimaryContact.OfficeLocation.City,
          State: _this.Account.PrimaryContact.OfficeLocation.State,
          Zip5: _this.Account.PrimaryContact.OfficeLocation.Zip
        };
        axios.post("/Account/GetAddressDetails/", params).then(function (response) {
          if (response.data.isSuccess) {
            var details = response.data.raw;
            _this.Account.PrimaryContact.OfficeLocation.StreetAddress = details.address2;
            _this.Account.PrimaryContact.OfficeLocation.City = details.city;
            _this.Account.PrimaryContact.OfficeLocation.State = details.state;
            _this.Account.PrimaryContact.OfficeLocation.Zip = details.zip5;
            _this.OfficeLocationValidationResult.OfficeLocationZip = null;
            _this.IsAddressValidating = false;
            _this.IsValidNPI = true;
          } else {
            _this.OfficeLocationValidationResult.OfficeLocationZip = response.data.errorMessage;
            _this.IsAddressValidating = false;
            _this.IsValidNPI = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateConfirmEmail: function ValidateConfirmEmail(event) {
      var _this = this;
      if (_this.Account.EmailAddress != _this.Account.EmailAddressConfirm) {
        _this.AccountValidationResult = {
          AccountEmailAddress: _this.HasEmailAddressError,
          AccountEmailAddressConfirm: "Email address does not match"
        };
        _this.HasConfirmEmailAddressError = "Email address does not match";
      } else {
        _this.AccountValidationResult.AccountEmailAddressConfirm = null;
        _this.HasConfirmEmailAddressError = null;
      }
    },
    ValidateNpiNumber: function ValidateNpiNumber() {
      var _this = this;
      var npiNumber = _this.Account.NpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.AccountValidateNpi.AccountType = this.$route.params.type;
        _this.AccountValidateNpi.NpiNumber = npiNumber;

        axios.post("/Account/IsNpiNumberValid", _this.AccountValidateNpi).then(function (response) {
          if (response.data.isSuccess) {
            _this.AccountValidationResult = { AccountNpiNumber: null };
            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];
            _this.Account.PrimaryContact.FirstName = basicDetails.first_name;
            _this.Account.PrimaryContact.LastName = basicDetails.last_name;
            _this.Account.PrimaryContact.Suffix = basicDetails.credential;
            _this.Account.PrimaryContact.CountryCode = address.telephone_number.split("-")[0];
            _this.Account.PrimaryContact.AreaCode = address.telephone_number.split("-")[1];
            _this.Account.PrimaryContact.Phone = address.telephone_number.split("-")[2];
            _this.isLoading = false;
            if (_this.Account.PrimaryContact.IsEyeDoctor) {
              _this.Account.EyeDoctors[0].NpiNumber = _this.Account.NpiNumber;
            }
          } else {
            var businessNpiValidationResult = _this.AccountValidationResult.AccountBusinessNpiNumber;
            _this.AccountValidationResult = {
              AccountNpiNumber: response.data.errorMessage,
              AccountBusinessNpiNumber: businessNpiValidationResult
            };
            _this.called = _this.AccountValidationResult.AccountNpiNumber;
            _this.Account.PrimaryContact.FirstName = null;
            _this.Account.PrimaryContact.LastName = null;
            _this.Account.PrimaryContact.Suffix = null;
            _this.Account.PrimaryContact.CountryCode = null;
            _this.Account.PrimaryContact.AreaCode = null;
            _this.Account.PrimaryContact.Phone = null;
            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateNpiNumberForBusinessType: function ValidateNpiNumberForBusinessType() {
      var _this2 = this;

      var _this = this;
      var npiNumber = _this.Account.BusinessNpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.AccountValidateNpi.AccountType = this.$route.params.type;
        _this.AccountValidateNpi.BusinessNpiNumber = npiNumber;

        axios.post("/Account/IsNpiNumberBusinessType", _this.AccountValidateNpi).then(function (response) {
          if (response.data.isSuccess) {
            _this.AccountValidationResult = { AccountNpiNumber: null };
            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];

            var legalName = _this2.ConvertToTitleCase(basicDetails.name);
            _this.Account.PrimaryContact.LegalName = legalName;
            _this.isLoading = false;
          } else {
            var individualNpiValidationResult = _this.AccountValidationResult.AccountNpiNumber;
            _this.AccountValidationResult = {
              AccountBusinessNpiNumber: response.data.errorMessage,
              AccountNpiNumber: individualNpiValidationResult
            };
            _this.called = _this.AccountValidationResult.AccountBusinessNpiNumber;
            _this.Account.PrimaryContact.LegalName = null;
            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    ValidateNpiNumberEyeDoctor: function ValidateNpiNumberEyeDoctor(index) {
      var _this = this;
      var npiNumber = _this.Account.EyeDoctors[index].NpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.AccountValidateNpi.AccountType = this.$route.params.type;
        _this.AccountValidateNpi.NpiNumber = npiNumber;

        axios.post("/Account/IsNpiNumberValidEyeDoctor/", _this.AccountValidateNpi).then(function (response) {
          if (response.data.isSuccess) {
            var details = response.data.raw.results[0];
            var basicDetails = details.basic;
            var address = details.addresses[0];

            _this.Account.EyeDoctors[index].FirstName = _this.ConvertToTitleCase(basicDetails.first_name);
            _this.Account.EyeDoctors[index].LastName = _this.ConvertToTitleCase(basicDetails.last_name);
            _this.Account.EyeDoctors[index].Suffix = basicDetails.credential;

            _this.EyeDoctorValidation[index].validationResult = {
              EyeDoctorNpiNumber: null
            };

            _this.isLoading = false;
          } else {
            _this.Account.EyeDoctors[index].FirstName = null;
            _this.Account.EyeDoctors[index].LastName = null;
            _this.Account.EyeDoctors[index].Suffix = null;

            _this.EyeDoctorValidation[index].validationResult = {
              EyeDoctorNpiNumber: response.data.errorMessage
            };

            _this.isLoading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    SaveTotalJobs: function SaveTotalJobs(job) {
      return (job.January ? parseInt(job.January) : 0) + (job.February ? parseInt(job.February) : 0) + (job.March ? parseInt(job.March) : 0) + (job.April ? parseInt(job.April) : 0) + (job.May ? parseInt(job.May) : 0) + (job.June ? parseInt(job.June) : 0) + (job.July ? parseInt(job.July) : 0) + (job.August ? parseInt(job.August) : 0) + (job.September ? parseInt(job.September) : 0) + (job.October ? parseInt(job.October) : 0) + (job.November ? parseInt(job.November) : 0) + (job.December ? parseInt(job.December) : 0);
    }
  },
  created: function created() {
    this.GetForm();
    if (sessionStorage.getItem("referralCode")) {
      this.Account.ReferralCode = sessionStorage.getItem("referralCode");
    } else if (this.$route.query.referralcode) {
      sessionStorage.setItem("referralCode", this.$route.query.referralcode);
      this.Account.ReferralCode = this.$route.query.referralcode;
    }

    var referralcode = this.$route.query.referralcode || null;

    console.log("Created:");
    console.log("this.$route");
    console.log(this.$route);
    console.log("this.$route.query");
    console.log(this.$route.query);
    console.log("this.$route.params.type");
    console.log(this.$route.params.type);


    if (this.$route.query.NpiNumber || this.$route.query.BusinessNpiNumber || this.$route.query.NumberOfJobs || this.$route.query.EmailAddress) {
      console.log("AutoFill mode");
      var org = [];
      var doctors = [];

      for (var index = 1; index < 100; index++) {
        var d = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          UseLicenseNumber: this.$route.query["doctor" + index + "_UseLicenseNumber"] == "true" ? true : false,
          NpiNumber: Number(this.$route.query["doctor" + index + "_NpiNumber"]) ? this.$route.query["doctor" + index + "_NpiNumber"] : null,
          LicenseNumber: this.$route.query["doctor" + index + "_LicenseNumber"] || undefined,
          State: this.$route.query["doctor" + index + "_State"] || undefined,
          FirstName: this.$route.query["doctor" + index + "_FirstName"],
          LastName: this.$route.query["doctor" + index + "_LastName"],
          Suffix: this.$route.query["doctor" + index + "_Suffix"],
          EmailAddress: this.$route.query["doctor" + index + "_EmailAddress"],
          YearsInPractice: this.$route.query["doctor" + index + "_YearsInPractice"],
          Organizations: {
            List: [],
            Others: null
          },
          NoEyeDoctor: false
        }, "UseLicenseNumber", this.$route.query["doctor" + index + "_UseLicenseNumber"] == "true" ? true : false);
        if (this.$route.query["doctor" + index + "_FirstName"]) {
          console.log("this.$route.query[`doctor${index}_FirstName`]");
          this.EyeDoctorValidation.push({ validationResult: {} });

          doctors.push(d);
        }
      }

      for (var _index = 1; _index < 20; _index++) {
        console.log("org" + _index);
        org.push(this.$route.query["org" + _index]);
      }

      this.Account.UseLicenseNumber = this.$route.query.UseLicenseNumber || false;
      this.Account.NoEyeDoctor = this.$route.query.NoEyeDoctor == "true" ? true : false;
      this.Account.NpiNumber = Number(this.$route.query.NpiNumber) ? this.$route.query.NpiNumber : null;
      this.Account.BusinessNpiNumber = Number(this.$route.query.BusinessNpiNumber) ? this.$route.query.BusinessNpiNumber : null;

      this.Account.ToBeContactedAsVolunteer = this.$route.query.ToBeContactedAsVolunteer == "true" ? true : false;
      this.Account.ToReceiveNewsLetter = this.$route.query.ToReceiveNewsLetter == "true" ? true : false;
      this.Account.NewsLetter = this.$route.query.ToBeContactedAsVolunteer == "true" ? true : false;
      this.Account.Opportunities = this.$route.query.ToReceiveNewsLetter == "true" ? true : false;

      this.Account.PrimaryContact.YearsInPractice = this.$route.query.YearsInPractice || null;

      this.Account.PrimaryContact.IsLicenseNumber = this.$route.query.UseLicenseNumber == "true" ? true : false;
      this.Account.PrimaryContact.UseLicenseNumber = this.$route.query.UseLicenseNumber == "true" ? true : false;
      this.Account.PrimaryContact.IsPrimaryLicenseNumber = this.$route.query.IsPrimaryLicenseNumber == "true" ? true : false;
      this.Account.PrimaryContact.IsMultiLocation = this.$route.query.IsMultiLocation == "true" ? true : false;
      this.Account.PrimaryContact.IsFirstName = false;
      this.Account.PrimaryContact.OfficeLocation.Jobs = {}, this.Account.PrimaryContact.OfficeLocation.NumberOfJobs = this.$route.query.NumberOfJobs || null, this.Account.PrimaryContact.OfficeLocation.StreetAddress = this.$route.query.office_StreetAddress || null, this.Account.PrimaryContact.OfficeLocation.City = this.$route.query.office_City || null, this.Account.PrimaryContact.OfficeLocation.State = this.$route.query.office_State || null, this.Account.PrimaryContact.OfficeLocation.Zip = this.$route.query.office_Zip || null, this.Account.PrimaryContact.OfficeLocation.Suite = this.$route.query.office_Suite || null, this.Account.PrimaryContact.OfficeLocation.CountryCode = this.$route.query.office_CountryCode || null, this.Account.PrimaryContact.OfficeLocation.AreaCode = this.$route.query.office_AreaCode || null, this.Account.PrimaryContact.OfficeLocation.Phone = this.$route.query.office_Phone || null, this.Account.PrimaryContact.OfficeLocation.QRDonationCode = this.$route.query.office_QRDonationCode || null, this.Account.PrimaryContact.NpiNumber = Number(this.$route.query.NpiNumber) ? this.$route.query.NpiNumber : null;
      this.Account.PrimaryContact.LicenseNumber = this.$route.query.LicenseNumber || null;
      this.Account.PrimaryContact.State = this.$route.query.State;
      this.Account.PrimaryContact.CountryCode = this.$route.query.CountryCode;
      this.Account.PrimaryContact.AreaCode = this.$route.query.AreaCode;
      this.Account.PrimaryContact.Phone = this.$route.query.Phone;
      this.Account.PrimaryContact.FirstName = this.$route.query.FirstName;
      this.Account.PrimaryContact.LastName = this.$route.query.LastName;
      this.Account.PrimaryContact.Suffix = this.$route.query.Suffix;
      this.Account.PrimaryContact.BusinessType = this.$route.query.BusinessType;

      console.log("this.Account.PrimaryContact");
      console.log(this.Account.PrimaryContact);

      if (this.$route.params.type != "Individual") {
        this.Account.PrimaryContact.LegalName = this.$route.query.LegalName;
        this.Account.PrimaryContact.Title = this.$route.query.Role;

        if (this.Account.PrimaryContact.IsEyeDoctor == false) {
          this.Account.NpiNumber = null;
        }
        if (doctors.length != 0) {
          this.Account.EyeDoctors = doctors;
          console.log("adding doctors: ");
          console.log(this.Account.EyeDoctors);
        }
      }

      if (this.Account.PrimaryContact.IsEyeDoctor == false && this.$route.params.type == "Business") {
        this.Account.NpiNumber = null;
        this.Account.PrimaryContact.NpiNumber = null;
      }

      this.Account.Organizations = {
        List: org.filter(function (w) {
          return w != undefined;
        })
      }, this.Account.EmailAddress = this.$route.query.EmailAddress, this.Account.EmailAddressConfirm = this.$route.query.EmailAddressConfirm;
      this.Account.Password = this.$route.query.Password;
      this.Account.PasswordConfirm = this.$route.query.PasswordConfirm;
      this.Account.State = this.$route.query.State;
      this.IsEmailAddressValid();
      this.ValidateAddress();
    }

    console.log("this.Account");
    console.log(this.Account);
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a },
  data: function data() {
    return {
      isLoading: false
    };
  },

  methods: {
    GeneratePdf: function GeneratePdf() {
      var _this = this;
      _this.isLoading = true;
      var salesforceId = _this.$route.query.salesforceId;
      axios.get("/Account/GetContractBySalesforceId/" + salesforceId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        var result = response.data.raw;
        var link = document.createElement("a");
        link.href = result;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        _this.isLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: "Error" });
      });
    }
  },
  created: function created() {
    this.userRefId = sessionStorage.getItem("referralCode");
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);


function InitialData() {
  return {
    Account: {}
  };
}


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a },
  data: function data() {
    return InitialData();
  },

  mounted: function mounted() {
    this.GetAccountById(this.$route.query.salesforceId);
  },
  methods: {
    GetAccountById: function GetAccountById(salesforceId) {
      var _this = this;

      axios.get("/Account/GetBySalesforceId/" + salesforceId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        _this.Account = response.data.raw;
      }).catch(function (error) {
        console.log(error);
        _this.$router.push({ name: 'Error' });
      });
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["crps"],
  components: {},
  data: function data() {
    return {
      isFormLoading: false,
      isModalShown: true,
      CovidReliefParticipantStatus: ""
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit("CtlCovidReliefFeedbackResultModal");
    },
    SubmitCRPS: function SubmitCRPS() {
      var _this = this;
      _this.isFormLoading = true;
      axios.post("/Account/CovidReliefParticipant", {
        response: this.CovidReliefParticipantStatus
      }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      }).then(function (response) {
        if (response.data.isSuccess == true) {
          _this.isFormLoading = false;
          _this.CloseModal();

          localStorage.setItem("covidReliefParticipantStatus", response.data.raw.covidReliefParticipantStatus);
          localStorage.setItem("isCovidReliefStatusChecked", "true");
        } else {
          _this.isFormLoading = false;
          localStorage.setItem("isCovidReliefStatusChecked", "true");
          alert("We got an Error on your request.");
          _this.CloseModal();
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {}
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    CovidRelief: __WEBPACK_IMPORTED_MODULE_0__components_AccountDetails_CovidRelief___default.a,
    LoadingComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_LoadingComponent___default.a
  },
  data: function data() {
    return {
      Account: null,
      isFormLoading: false,
      isModalShown: true
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('CtlModalForm');
    },
    SubmitCRPS: function SubmitCRPS(CovidReliefParticipantStatus) {
      var _this = this;
      _this.isFormLoading = true;
      axios.post("/Account/CovidReliefParticipant", {
        response: CovidReliefParticipantStatus
      }, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(function (response) {
        if (response.data.isSuccess == true && CovidReliefParticipantStatus != 'enrolledAlready') {
          localStorage.setItem("covidReliefParticipantStatus", response.data.raw.covidReliefParticipantStatus);
          localStorage.setItem("isCovidReliefStatusChecked", "true");
          _this.isFormLoading = false;
          _this.CloseModal();
          if (CovidReliefParticipantStatus == "yes") {
            var organizationName = _this.Account.accountType === 1 ? _this.Account.primaryContact.firstName + ' ' + _this.Account.primaryContact.lastName + ' ' + _this.Account.primaryContact.suffix : _this.Account.primaryContact.legalName;
            var qparams = "?businesscompanyName=" + organizationName;
            qparams += "&email=" + _this.Account.emailAddress;
            qparams += "&cltlPeid=" + _this.Account.portalUserSalesforceId;
            qparams += "&city=" + _this.Account.primaryContact.officeLocation.city;
            qparams += "&state=" + _this.Account.primaryContact.officeLocation.state;
            qparams += "&cltlaccount=Yes";
            qparams += "&whereFrom=CLTLModal";
            console.log(qparams);
          }
        } else if (response.data.isSuccess == true && CovidReliefParticipantStatus == 'enrolledAlready') {
          localStorage.setItem("covidReliefParticipantStatus", response.data.raw.covidReliefParticipantStatus);
          localStorage.setItem("isCovidReliefStatusChecked", "true");
          _this.isFormLoading = false;
          _this.CloseModal();
        } else {
          console.log('>> 3 ');
          localStorage.setItem("isCovidReliefStatusChecked", "true");
          alert("We got an Error on your request.");
          _this.isFormLoading = false;
          _this.CloseModal();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    GetAccountValues: function GetAccountValues() {
      var _this = this;
      axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
        console.log("it ran!");
        _this.Account = response.data.raw;
        localStorage.setItem("customUserPermissionFlag", _this.Account.customUserPermissionFlag);
        _this.ShowStockLensTile = _this.Account.customUserPermissionFlag.includes("Show Stock Lens Tile");
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    this.GetAccountValues();
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_HeaderComponent___default.a, HelpForm: __WEBPACK_IMPORTED_MODULE_2__components_shared_HelpForm___default.a, FooterComponent: __WEBPACK_IMPORTED_MODULE_1__components_shared_FooterComponent___default.a },
    data: function data() {
        return {
            Account: {},
            showHelpForm: false
        };
    },

    methods: {
        Route: function Route(value) {
            this.$router.push({ name: value });
        },
        ToggleHelpForm: function ToggleHelpForm() {
            this.showHelpForm = !this.showHelpForm;
            if (this.showHelpForm) {
                document.body.classList.add("body-overflow");
            } else {
                document.body.classList.remove("body-overflow");
            }
        },
        GetAccountValues: function GetAccountValues() {
            var _this = this;
            axios.get('/Account/Self', { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") } }).then(function (response) {
                _this.Account = response.data.raw;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    created: function created() {
        this.GetAccountValues();
    }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    CheckLogin: function CheckLogin() {
      var token = localStorage.getItem("token");
      if (token) {
        return true;
      } else {
        return false;
      }
    },
    RouterRedirect: function RouterRedirect(name) {
      var href = window.location.href;
      if (href[href.length - 1] == "/") window.location.href = '../' + name + '/';else window.location.href = href + '/../' + name + '/';
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Account", "orderType"],
  components: {},
  data: function data() {
    return {
      isModalShown: false
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit("closeWufoo");
    },
    ShowWufoo: function ShowWufoo(salesforceId) {
      var _this = this;
      var organizationName = _this.Account.accountType === 1 ? _this.Account.primaryContact.firstName + " " + _this.Account.primaryContact.lastName + " " + _this.Account.primaryContact.suffix : _this.Account.primaryContact.legalName;
      var ifr = document.getElementById("JotFormIFrame-201614063686050");
      if (window.location.href && window.location.href.indexOf("?") > -1) {
        var get = window.location.href.substr(window.location.href.indexOf("?") + 1);
        if (ifr && get.length > 0) {
          var src = ifr.src;
          src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
          ifr.src = src;
        }
      }
      window.handleIFrameMessage = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e.data) === "object") {
          return;
        }
        var args = e.data.split(":");
        if (args.length > 2) {
          iframe = document.getElementById("JotFormIFrame-" + args[args.length - 1]);
        } else {
          iframe = document.getElementById("JotFormIFrame");
        }
        if (!iframe) {
          return;
        }
        switch (args[0]) {
          case "scrollIntoView":
            iframe.scrollIntoView();
            break;
          case "setHeight":
            iframe.style.height = args[1] + "px";
            break;
          case "collapseErrorPage":
            if (iframe.clientHeight > window.innerHeight) {
              iframe.style.height = window.innerHeight + "px";
            }
            break;
          case "reloadPage":
            window.location.reload();
            break;
          case "loadScript":
            var src = args[1];
            if (args.length > 3) {
              src = args[1] + ":" + args[2];
            }
            var script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            document.body.appendChild(script);
            break;
          case "exitFullscreen":
            if (window.document.exitFullscreen) window.document.exitFullscreen();else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
            break;
        }
        var isJotForm = e.origin.indexOf("jotform") > -1 ? true : false;
        if (isJotForm && "contentWindow" in iframe && "postMessage" in iframe.contentWindow) {
          var urls = {
            docurl: encodeURIComponent(document.URL),
            referrer: encodeURIComponent(document.referrer)
          };
          iframe.contentWindow.postMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ type: "urls", value: urls }), "*");
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", handleIFrameMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", handleIFrameMessage);
      }
      this.isWufooLoading = false;
      this.prefillFields = "userSf=" + this.Account.portalUserSalesforceId + "&orderType=" + this.orderType + "&name[first]=" + this.Account.primaryContact.firstName + "&name[last]=" + this.Account.primaryContact.lastName + "&email=" + this.Account.emailAddress + "&address[addr_line1]=" + this.Account.primaryContact.officeLocation.streetAddress + "&address[addr_line2]=" + this.Account.primaryContact.officeLocation.suite + "&address[city]=" + this.Account.primaryContact.officeLocation.city + "&address[state]=" + this.Account.primaryContact.officeLocation.state + "&stateCode=" + this.Account.primaryContact.officeLocation.state + "&address[postal]=" + this.Account.primaryContact.officeLocation.zip;
    }
  },
  created: function created() {
    this.isWufooLoading = true;
    var portalUserSalesforceId = localStorage.getItem("portalUserSalesforceId");
    this.ShowWufoo(portalUserSalesforceId);
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fixed_header__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fixed_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_fixed_header__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FixedHeader: __WEBPACK_IMPORTED_MODULE_1_vue_fixed_header___default.a },
  data: function data() {
    return {
      isLogIn: false,
      IsNavbarShown: true,
      AccountStatus: null,
      isFixed: false,
      isCollapse: false,
      showOrderSubMenuOnMobile: false,
      activeCurrentPage: localStorage.getItem("is-active"),
      isActive: false,
      MasterAccountType: null,
      framePageVisible: localStorage.getItem("frameAndLensOrderIsAllowed"),
      notificationMessage: localStorage.getItem("PersistentNotificationMessage"),
      countDownTimer: null,
      showTheNotificationAlert: localStorage.getItem("ShowPersistentNotification")
    };
  },

  methods: {
    LogOut: function LogOut() {
      var _this = this;

      this.$router.push({ name: "Home" });
      var activePage = localStorage.getItem("is-active");
      var x = 0;
      if (activePage == "order") {
        new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          _this.countDownTimer = setInterval(function () {
            if (localStorage.getItem("logout_session_acc")) {
              resolve(localStorage.getItem("logout_session_acc"));
            }
          }, 1000);
        }).then(function (isLogout) {
          clearInterval(_this.countDownTimer);
          if (isLogout == "true") {
            _this.RemoveItems();
            _this.isLogIn = false;
            location.reload();
          }
        });
      } else {
        this.RemoveItems();
        this.isLogIn = false;
        location.reload();
      }
    },
    hideNotificationAlert: function hideNotificationAlert() {
      localStorage.setItem("ShowPersistentNotification", false);
      this.showTheNotificationAlert = false;
    },
    RemoveItems: function RemoveItems() {
      localStorage.removeItem("host");
      localStorage.removeItem("PersistentNotification");
      localStorage.removeItem("token");
      localStorage.removeItem("watchword");
      localStorage.removeItem("accountType");
      localStorage.removeItem("accountStatus");
      localStorage.removeItem("frameAndLensOrderIsAllowed");
      localStorage.removeItem("is-active");
      localStorage.removeItem("orderTrackingList");
      localStorage.removeItem("resultCount");
      localStorage.removeItem("orderObj");
      localStorage.removeItem("nextURL");
      localStorage.clear();
      console.log(localStorage);
    },
    CheckLogin: function CheckLogin() {
      if (localStorage.getItem("token")) {
        this.isLogIn = true;
      }
    },
    RouterRedirect: function RouterRedirect(name) {
      if (this.$route.name === name) {
        if (name === "Home") {
          this.$router.push({ name: "HomePage" });
        } else {
          this.$router.go(0);
        }
      } else {
        this.$router.push({ name: name });
      }
    },
    redirectToLogin: function redirectToLogin() {
      this.$router.push({ name: "Login" });
    }
  },
  created: function created() {
    this.CheckLogin();
    this.MasterAccountType = localStorage.getItem("accountType");
    this.AccountStatus = localStorage.getItem("accountStatus");
    this.isActive = localStorage.getItem("is-active");
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Account"],
  components: { PageLoader: __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: true
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('closeWufoo');
    }
  },
  created: function created() {
    this.isWufooLoading = true;
    var portalUserSalesforceId = localStorage.getItem("portalUserSalesforceId");
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['Account'],
  components: {},
  data: function data() {
    return {
      isModalShown: true
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('closeWufoo');
    }
  },
  created: function created() {}
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["jotFormID"],
  data: function data() {
    return {
      Account: null,
      formIframe: null,
      iframeHeight: 640,
      jotFormElementID: null,
      prefillFields: ''
    };
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var acctRes, prefillRes, acctJson, jotFormPrefills, organizationName, preFillArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, field, elements, value, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.isJotFormLoading = true;
              _this2.jotFormElementID = "JotFormIFrame-" + _this2.jotFormID;
              _context.prev = 2;
              acctRes = fetch(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.API_ENDPOINT + "Account/Self", {
                method: "get",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token")
                }
              });
              prefillRes = fetch(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.API_ENDPOINT + "CMS/GetJotFormPrefills/" + _this2.jotFormID, {
                method: "get",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token")
                }
              });
              _context.next = 7;
              return acctRes;

            case 7:
              _context.next = 9;
              return _context.sent.json();

            case 9:
              acctJson = _context.sent;

              _this2.Account = acctJson.raw;
              console.log("this.Account => ", _this2.Account);

              _context.next = 14;
              return prefillRes;

            case 14:
              _context.next = 16;
              return _context.sent.json();

            case 16:
              jotFormPrefills = _context.sent;

              console.log("jotFormPrefills => ", jotFormPrefills);

              organizationName = _this2.Account.accountType === 1 ? _this2.Account.primaryContact.firstName + " " + _this2.Account.primaryContact.lastName + " " + _this2.Account.primaryContact.suffix : _this2.Account.primaryContact.legalName;
              preFillArray = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 23;
              _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(jotFormPrefills);

            case 25:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 79;
                break;
              }

              field = _step.value;

              console.log("jotFormPrefills => field", field);

              if (!(field.valueType == "CONSTANT")) {
                _context.next = 32;
                break;
              }

              preFillArray.push(field.fieldName + "=" + field.value);
              _context.next = 76;
              break;

            case 32:
              if (!(field.fieldName === "iframeHeight")) {
                _context.next = 36;
                break;
              }

              _this2.iframeHeight = field.value;
              _context.next = 76;
              break;

            case 36:
              if (!(field.value === "organizationName")) {
                _context.next = 40;
                break;
              }

              preFillArray.push(field.fieldName + "=" + organizationName);
              _context.next = 76;
              break;

            case 40:
              elements = field.value.split(".");


              console.log("using reduce");

              console.log(elements);
              value = _this2.Account;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 47;
              _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(elements);

            case 49:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context.next = 60;
                break;
              }

              key = _step2.value;

              if (!(value[key] !== undefined)) {
                _context.next = 55;
                break;
              }

              value = value[key];
              _context.next = 57;
              break;

            case 55:
              value = null;
              return _context.abrupt("break", 60);

            case 57:
              _iteratorNormalCompletion2 = true;
              _context.next = 49;
              break;

            case 60:
              _context.next = 66;
              break;

            case 62:
              _context.prev = 62;
              _context.t0 = _context["catch"](47);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 66:
              _context.prev = 66;
              _context.prev = 67;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 69:
              _context.prev = 69;

              if (!_didIteratorError2) {
                _context.next = 72;
                break;
              }

              throw _iteratorError2;

            case 72:
              return _context.finish(69);

            case 73:
              return _context.finish(66);

            case 74:
              console.log(value);

              if (value != null) preFillArray.push(field.fieldName + "=" + value);

            case 76:
              _iteratorNormalCompletion = true;
              _context.next = 25;
              break;

            case 79:
              _context.next = 85;
              break;

            case 81:
              _context.prev = 81;
              _context.t1 = _context["catch"](23);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 85:
              _context.prev = 85;
              _context.prev = 86;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 88:
              _context.prev = 88;

              if (!_didIteratorError) {
                _context.next = 91;
                break;
              }

              throw _iteratorError;

            case 91:
              return _context.finish(88);

            case 92:
              return _context.finish(85);

            case 93:
              console.log(preFillArray);
              _this2.prefillFields = preFillArray.join("&");
              console.log(_this2.prefillFields);
              _context.next = 101;
              break;

            case 98:
              _context.prev = 98;
              _context.t2 = _context["catch"](2);

              console.log(_context.t2);

            case 101:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[2, 98], [23, 81, 85, 93], [47, 62, 66, 74], [67,, 69, 73], [86,, 88, 92]]);
    }))();
  },

  methods: {
    ShowJotForm: function ShowJotForm() {
      var _this = this;
      var ifr = document.getElementById(this.jotFormElementID);
      if (window.location.href && window.location.href.indexOf("?") > -1) {
        var get = window.location.href.substr(window.location.href.indexOf("?") + 1);
        if (ifr && get.length > 0) {
          var src = ifr.src;
          src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
          ifr.src = src;
        }
      }
      window.handleIFrameMessage = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e.data) === "object") {
          return;
        }
        var args = e.data.split(":");
        var iframe = null;
        if (args.length > 2) {
          iframe = document.getElementById("JotFormIFrame-" + args[args.length - 1]);
        } else {
          iframe = document.getElementById("JotFormIFrame");
        }
        if (!iframe) {
          return;
        }
        switch (args[0]) {
          case "scrollIntoView":
            iframe.scrollIntoView();
            break;
          case "setHeight":
            iframe.style.height = args[1] + "px";
            break;
          case "collapseErrorPage":
            if (iframe.clientHeight > window.innerHeight) {
              iframe.style.height = window.innerHeight + "px";
            }
            break;
          case "reloadPage":
            window.location.reload();
            break;
          case "loadScript":
            var src = args[1];
            if (args.length > 3) {
              src = args[1] + ":" + args[2];
            }
            var script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            document.body.appendChild(script);
            break;
          case "exitFullscreen":
            if (window.document.exitFullscreen) window.document.exitFullscreen();else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
            break;
        }
        var isJotForm = e.origin.indexOf("jotform") > -1 ? true : false;
        if (isJotForm && "contentWindow" in iframe && "postMessage" in iframe.contentWindow) {
          var urls = {
            docurl: encodeURIComponent(document.URL),
            referrer: encodeURIComponent(document.referrer)
          };
          iframe.contentWindow.postMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ type: "urls", value: urls }), "*");
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", handleIFrameMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", handleIFrameMessage);
      }
      this.isJotFormLoading = false;
    }
  },
  mounted: function mounted() {
    this.ShowJotForm();
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["Account", "formID"],
  components: {},
  data: function data() {
    return {
      isModalShown: false,
      prefillFields: null,
      jotFormPrefills: null
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit("closeJotForm");
    },
    ShowJotForm: function ShowJotForm() {
      var _this = this;
      var ifr = document.getElementById("JotFormIFrame-" + this.formID);
      if (window.location.href && window.location.href.indexOf("?") > -1) {
        var get = window.location.href.substr(window.location.href.indexOf("?") + 1);
        if (ifr && get.length > 0) {
          var src = ifr.src;
          src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
          ifr.src = src;
        }
      }
      window.handleIFrameMessage = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e.data) === "object") {
          return;
        }
        var args = e.data.split(":");
        var iframe = null;
        if (args.length > 2) {
          iframe = document.getElementById("JotFormIFrame-" + args[args.length - 1]);
        } else {
          iframe = document.getElementById("JotFormIFrame");
        }
        if (!iframe) {
          return;
        }
        switch (args[0]) {
          case "scrollIntoView":
            iframe.scrollIntoView();
            break;
          case "setHeight":
            iframe.style.height = args[1] + "px";
            break;
          case "collapseErrorPage":
            if (iframe.clientHeight > window.innerHeight) {
              iframe.style.height = window.innerHeight + "px";
            }
            break;
          case "reloadPage":
            window.location.reload();
            break;
          case "loadScript":
            var src = args[1];
            if (args.length > 3) {
              src = args[1] + ":" + args[2];
            }
            var script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            document.body.appendChild(script);
            break;
          case "exitFullscreen":
            if (window.document.exitFullscreen) window.document.exitFullscreen();else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
            break;
        }
        var isJotForm = e.origin.indexOf("jotform") > -1 ? true : false;
        if (isJotForm && "contentWindow" in iframe && "postMessage" in iframe.contentWindow) {
          var urls = {
            docurl: encodeURIComponent(document.URL),
            referrer: encodeURIComponent(document.referrer)
          };
          iframe.contentWindow.postMessage(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({ type: "urls", value: urls }), "*");
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", handleIFrameMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", handleIFrameMessage);
      }
      this.isWufooLoading = false;
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response, organizationName, preFillArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, field, elements, valueP, value, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.isWufooLoading = true;
              _this2.jotFormElementID = "JotFormIFrame-" + _this2.formID;
              _context.prev = 2;
              _context.next = 5;
              return fetch(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.API_ENDPOINT + 'CMS/GetJotFormPrefills/' + _this2.formID, {
                method: 'get',
                headers: {
                  'Authorization': "Bearer " + localStorage.getItem("token")
                }
              });

            case 5:
              response = _context.sent;
              _context.next = 8;
              return response.json();

            case 8:
              _this2.jotFormPrefills = _context.sent;

              console.log(_this2.jotFormPrefills);

              organizationName = _this2.Account.accountType === 1 ? _this2.Account.primaryContact.firstName + ' ' + _this2.Account.primaryContact.lastName + ' ' + _this2.Account.primaryContact.suffix : _this2.Account.primaryContact.legalName;
              preFillArray = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 15;
              _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.jotFormPrefills);

            case 17:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 68;
                break;
              }

              field = _step.value;

              console.log(field);

              if (!(field.valueType == "CONSTANT")) {
                _context.next = 24;
                break;
              }

              preFillArray.push(field.fieldName + "=" + field.value);
              _context.next = 65;
              break;

            case 24:
              if (!(field.value === "organizationName")) {
                _context.next = 28;
                break;
              }

              preFillArray.push(field.fieldName + "=" + organizationName);
              _context.next = 65;
              break;

            case 28:
              elements = field.value.split('.');
              valueP = elements.reduce(function (v, e) {
                return v[e];
              }, _this2.Account);


              console.log(valueP);
              console.log(elements);
              value = _this2.Account;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 36;
              _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(elements);

            case 38:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context.next = 49;
                break;
              }

              key = _step2.value;

              if (!(value[key] !== undefined)) {
                _context.next = 44;
                break;
              }

              value = value[key];
              _context.next = 46;
              break;

            case 44:
              value = null;
              return _context.abrupt("break", 49);

            case 46:
              _iteratorNormalCompletion2 = true;
              _context.next = 38;
              break;

            case 49:
              _context.next = 55;
              break;

            case 51:
              _context.prev = 51;
              _context.t0 = _context["catch"](36);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 55:
              _context.prev = 55;
              _context.prev = 56;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 58:
              _context.prev = 58;

              if (!_didIteratorError2) {
                _context.next = 61;
                break;
              }

              throw _iteratorError2;

            case 61:
              return _context.finish(58);

            case 62:
              return _context.finish(55);

            case 63:
              console.log(value);

              if (value != null) preFillArray.push(field.fieldName + "=" + value);

            case 65:
              _iteratorNormalCompletion = true;
              _context.next = 17;
              break;

            case 68:
              _context.next = 74;
              break;

            case 70:
              _context.prev = 70;
              _context.t1 = _context["catch"](15);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 74:
              _context.prev = 74;
              _context.prev = 75;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 77:
              _context.prev = 77;

              if (!_didIteratorError) {
                _context.next = 80;
                break;
              }

              throw _iteratorError;

            case 80:
              return _context.finish(77);

            case 81:
              return _context.finish(74);

            case 82:
              console.log(preFillArray);
              _this2.prefillFields = preFillArray.join('&');
              console.log(_this2.prefillFields);
              _context.next = 90;
              break;

            case 87:
              _context.prev = 87;
              _context.t2 = _context["catch"](2);

              console.log(_context.t2);

            case 90:

              _this2.ShowJotForm();

            case 91:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[2, 87], [15, 70, 74, 82], [36, 51, 55, 63], [56,, 58, 62], [75,, 77, 81]]);
    }))();
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isModalShown: true
        };
    },

    methods: {}
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['Message', 'Height']
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value', "val", "label"],
  components: {},
  data: function data() {
    return {
      checkedProxy: false
    };
  },

  computed: {
    checked: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.checkedProxy = val;
      }
    }
  },
  methods: {
    onChange: function onChange(e) {
      this.$emit('input', this.checkedProxy);
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: { PageLoader: __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: true
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('closeWufoo');
    }
  },
  created: function created() {
    this.isWufooLoading = true;
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['message'],
    data: function data() {
        return {};
    },

    methods: {
        CloseModal: function CloseModal() {
            this.$emit("close");
        },
        Agree: function Agree() {
            this.$emit("onAgree");
        }
    }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['Account', 'Order'],
  components: { PageLoader: __WEBPACK_IMPORTED_MODULE_0__components_shared_PageLoader___default.a },
  data: function data() {
    return {
      isModalShown: true
    };
  },

  methods: {
    CloseModal: function CloseModal() {
      this.$emit('close');
    }
  },
  created: function created() {
    this.isWufooLoading = true;
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_FormType__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_GlobalFunctions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_scrollto__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_carousel__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_Tenancy__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_ElementConfig__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_idle_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_idle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_idle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_prevent_back__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_prevent_back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_prevent_back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__theme_js__ = __webpack_require__(138);


















var eventsHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

__WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a.polyfill();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.API_ENDPOINT = "https://api2.changinglifethroughlenses.org/api/";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.HOST_URL = "https://api2.changinglifethroughlenses.org/";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_prevent_back___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_idle_vue___default.a, {
    eventEmitter: eventsHub,
    idleTime: 3000000
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__mixins_FormType__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__mixins_GlobalFunctions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_11__mixins_Tenancy__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_12__mixins_ElementConfig__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('phone_format', function (phone) {
    var input = phone.replace(/[|&;$%@"<>()+,]/g, "");
    input = input.replace(/\D/g, '').substring(0, 10);
    var zip = input.substring(0, 3);
    var middle = input.substring(3, 6);
    var last = input.substring(6, 10);

    if (input.length > 6) {
        phone = "(" + zip + ") " + middle + "-" + last;
    } else if (input.length > 3) {
        phone = "(" + zip + ") " + middle;
    } else if (input.length > 0) {
        phone = "(" + zip;
    }
    return phone;
});

var instance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.API_ENDPOINT,
    timeout: 300000,
    headers: { "X-Custom-Header": "EVF Portal" }
});

window.axios = instance;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: "#app",
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: "<App/>",
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
    onIdle: function onIdle() {
        localStorage.removeItem('host');
        localStorage.removeItem('token');
        localStorage.removeItem('watchword');
        localStorage.removeItem('accountType');
        localStorage.removeItem('accountStatus');
        localStorage.removeItem("ClinicEventList");
        this.$router.push({ name: 'Home' });
    },
    onActive: function onActive() {},

    methods: {
        getTheme: function getTheme() {
            var setStyleProperty = function setStyleProperty(color) {
                return bodyStyles.setProperty("--" + color + "-color", __WEBPACK_IMPORTED_MODULE_15__theme_js__["a" /* theme */][envTheme][color]);
            };
            var bodyStyles = document.body.style;
            var envTheme = "rebrand";
            setStyleProperty('primary');
            setStyleProperty('secondary');
            setStyleProperty('background');
            setStyleProperty('primary2');
            setStyleProperty('testimonialBullet');
            setStyleProperty('testimonialBulletActive');
        }
    },
    created: function created() {
        this.getTheme();
    }
});

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.btn[data-v-0279f276] {\n  border-radius: 15px 15px 0 0;\n}\n@media only screen and (max-width: 600px) {\n.btn > h4[data-v-0279f276] {\n    font-size: 1.2rem;\n}\n}\n", ""]);

// exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.VueCarousel-dot .VueCarousel-dot-inner {\n  background: var(--testimonialBullet-color) !important;\n}\n.VueCarousel-dot.VueCarousel-dot--active .VueCarousel-dot-inner {\n  background: var(--testimonialBulletActive-color) !important;\n}\n", ""]);

// exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.order-tracking-filter[data-v-2ce8a543] {\n  padding-left: 0px;\n}\n", ""]);

// exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.social-media__icon {\n  height: 100%;\n  opacity: 0.8;\n  cursor: pointer;\n}\n.social-media__icon:hover {\n  opacity: 1;\n}\n\n", ""]);

// exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\ntemplate[data-v-3bfda0a7] { margin:auto;\n}\nh2[data-v-3bfda0a7], h4[data-v-3bfda0a7], p[data-v-3bfda0a7] { text-align:center;\n}\nth[data-v-3bfda0a7] {background-color: #eeeeee; text-align:left;\n}\nth.title[data-v-3bfda0a7] { text-align:center;\n}\n.container[data-v-3bfda0a7] { width:50%; margin: auto; float:left; margin-bottom: 20px;\n}\ntable[data-v-3bfda0a7] { width:100%;\n}\ntable tr td[data-v-3bfda0a7], table tr th[data-v-3bfda0a7] { border: 1px solid;\n}\n.spacer[data-v-3bfda0a7] {padding: 15px;\n}\n#customerLabel[data-v-3bfda0a7] { margin-bottom: 40px;\n}\n#patientCopy[data-v-3bfda0a7] { margin-bottom: 40px;\n}\n.barcode-font[data-v-3bfda0a7] {height: 90px\n}\n@media print {\n*[data-v-3bfda0a7] {font-size:10px;\n}\n#customerLabel[data-v-3bfda0a7] { margin-bottom: 35px;\n}\n#patientCopy[data-v-3bfda0a7] { margin-bottom: 35px;\n}\n.spacer[data-v-3bfda0a7] {padding: 1px;\n}\ntemplate[data-v-3bfda0a7] { margin: 0px; padding: 0px;\n}\n#btnPrint[data-v-3bfda0a7] { display:none;\n}\nh2[data-v-3bfda0a7], h4[data-v-3bfda0a7], p[data-v-3bfda0a7] { font-size:12px;\n}\n@page { size: landscape;\n}\n.barcode-font[data-v-3bfda0a7] {height: 70px\n}\n}\n", ""]);

// exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports
exports.i(__webpack_require__(345), "");
exports.i(__webpack_require__(346), "");
exports.i(__webpack_require__(344), "");
exports.i(__webpack_require__(343), "");
exports.i(__webpack_require__(348), "");
exports.i(__webpack_require__(347), "");

// module
exports.push([module.i, "\n/* @import '../static/css/essilorvision.css';\n@import '../static/css/portal-home-page.css'; */\n", ""]);

// exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.spinner-disabled {\r\n  opacity: 0.6;\n}\n.spinner {\r\n  display: inline-block;\r\n  position: relative;\r\n  cursor: pointer;\n}\n.spinner-button {\r\n  position: absolute;\r\n  right: 0;\r\n  color: #999;\r\n  height: 19px;\r\n  width: 33px;\n}\n.spinner-button-disabled {\r\n  color: #a6a6a6;\r\n  background-color: #ededed;\n}\n.spinner-up {\r\n  top: 0;\n}\n.spinner-down {\r\n  bottom: 0;\n}\n.spinner-icon-up {\r\n  position: relative;\r\n  top: 2px;\r\n  left: 5;\n}\n.spinner-icon-down {\r\n  color: #999;\r\n  position: relative;\r\n  top: -2px;\n}\r\n", ""]);

// exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\ntemplate[data-v-47870908] { margin:auto;\n}\nh2[data-v-47870908], h4[data-v-47870908], p[data-v-47870908] { text-align:center;\n}\nth[data-v-47870908] {background-color: #eeeeee; text-align:left;\n}\nth.title[data-v-47870908] { text-align:center;\n}\n.container[data-v-47870908] { width:50%; margin: auto; float:left; margin-bottom: 10px;\n}\ntable[data-v-47870908] { width:100%;\n}\ntable tr td[data-v-47870908], table tr th[data-v-47870908] { border: 1px solid;\n}\n.spacer[data-v-47870908] {padding: 10px;\n}\n#customerLabel[data-v-47870908] { margin-bottom: 20px;\n}\n.barcode-font[data-v-47870908] {height: 90px\n}\n@media print {\n*[data-v-47870908] {font-size:10px;\n}\n#customerLabel[data-v-47870908] { margin-bottom: 35px;\n}\n.spacer[data-v-47870908] {padding: 1px;\n}\ntemplate[data-v-47870908] { margin: 0px; padding: 0px;\n}\n#btnPrint[data-v-47870908] { display:none;\n}\nh2[data-v-47870908], h4[data-v-47870908], p[data-v-47870908] { font-size:12px;\n}\n@page { size: landscape;\n}\n.barcode-font[data-v-47870908] {height: 60px\n}\n}\n", ""]);

// exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.signin-wrapper[data-v-4bc74044] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding: 60px;\n    background-color: var(--background-color);\n}\n.signin-container[data-v-4bc74044] {\n}\n.signin-header[data-v-4bc74044] {\n    text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\nh2[data-v-a68a028a],\r\nh4[data-v-a68a028a] {\r\n  text-align: center;\n}\nth.title[data-v-a68a028a] {\r\n  background-color: #26304d;\r\n  color: #ffffff;\r\n  text-align: left;\n}\n.container[data-v-a68a028a] {\r\n  margin: 20px auto;\n}\n.section[data-v-a68a028a] {\r\n  width: 80%;\r\n  margin: auto;\n}\ntable tr td[data-v-a68a028a],\r\ntable tr th[data-v-a68a028a] {\r\n  border: 1px solid #000000;\r\n  padding: 5px;\n}\n.spacer[data-v-a68a028a] {\r\n  padding: 15px;\n}\n#customerLabel[data-v-a68a028a] {\r\n  margin-bottom: 40px;\n}\n.caption[data-v-a68a028a] {\r\n  font-weight: bold;\n}\n.terms[data-v-a68a028a] {\r\n  height: 200px;\r\n  overflow-y: scroll;\r\n  border: 1px solid #eeeeee;\r\n  text-align: left;\r\n  margin-bottom: 10px;\r\n  background-color: whitesmoke;\n}\n.terms p[data-v-a68a028a],\r\np[data-v-a68a028a] {\r\n  font-size: 14px;\n}\n.radio[data-v-a68a028a] {\r\n  margin: auto;\r\n  width: 20%;\n}\n@media print {\n*[data-v-a68a028a] {\r\n    font-size: 10px;\n}\n.g-bg-main[data-v-a68a028a] {\r\n    display: none;\n}\n.section[data-v-a68a028a] {\r\n    width: auto;\n}\n#customerLabel[data-v-a68a028a] {\r\n    margin-bottom: 35px;\n}\n.spacer[data-v-a68a028a] {\r\n    padding: 1px;\n}\ntemplate[data-v-a68a028a] {\r\n    margin: 0px;\r\n    padding: 0px;\n}\n#btnPrint[data-v-a68a028a] {\r\n    display: none;\n}\nh2[data-v-a68a028a],\r\n  h4[data-v-a68a028a],\r\n  p[data-v-a68a028a] {\r\n    font-size: 12px;\n}\n.terms[data-v-a68a028a] {\r\n    height: auto;\r\n    border: 1px solid #eeeeee;\r\n    text-align: left;\r\n    margin-bottom: 10px;\n}\n}\r\n", ""]);

// exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports
exports.i(__webpack_require__(349), "");

// module
exports.push([module.i, "\r\n", ""]);

// exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.login-button-container[data-v-cc0229ac] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  z-index: 20000;\r\n  margin-left: auto; /* Pushes the login button to the far right */\n}\n.login-button[data-v-cc0229ac] {\r\n  background-color: var(--secondary-color);\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  margin-right: 30px;\r\n  cursor: pointer;\n}\n.login-button[data-v-cc0229ac]:hover {\r\n  background-color: var(--primary-color);\n}\r\n\r\n/* Flexbox properties for the header */\n.main-header[data-v-cc0229ac] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center; /* Center children vertically */\n}\n.order-sub-menu[data-v-cc0229ac] {\r\n  display: none;\r\n  border-radius: 2px;\n}\n.order-sub-menu li[data-v-cc0229ac] {\r\n  margin-bottom: 5px;\n}\n.order-dropdown:hover ul.order-sub-menu[data-v-cc0229ac] {\r\n  display: block!important;\n}\nul.order-sub-menu a[data-v-cc0229ac] {\r\n  color: #000;\n}\r\n\r\n", ""]);

// exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".evf_logo {\r\n  height: 95px;\r\n  margin-top: 12px;\r\n  /* margin-top: 25px; */\r\n  /* margin-top: 10px; */\r\n  margin-right: 25px;\r\n  margin-left: 50px;\r\n  -webkit-transition: height 0.5s; /* For Safari 3.1 to 6.0 */\r\n  transition: height 0.5s;\r\n  -webkit-transition: margin 0.5s; /* For Safari 3.1 to 6.0 */\r\n  transition: margin 0.5s;\r\n}\r\n\r\n.evf_logo_height {\r\n  margin-top: 5px;\r\n}\r\n\r\n.portal_header_link {\r\n  cursor: pointer\r\n}\r\n\r\n.img-size {\r\n  height: 200px;\r\n  width: 500px;\r\n}\r\n\r\n.main-menu {\r\n  position: absolute;\r\n  bottom: 0;\r\n}\r\n.nav-Item {\r\n  cursor: pointer\r\n}\r\n\r\n.nav-item a {\r\n  cursor:pointer;\r\n}\r\n\r\n.portal_img {\r\n  height: 350px;\r\n  width: 665px;\r\n}\r\n\r\n.g-bg-main-light-v2 {\r\n  background-color: var(--primary2-color) }\r\n\r\n  [data-animation].js-carousel {\r\n    visibility: visible; }\r\n\r\n.js-slide:first-child {\r\n      height: auto; }\r\n\r\n.g-pl-30 {\r\n        padding-left: 2.14286rem !important; }\r\n\r\n.navigation-bar {\r\n  float: right;\r\n  margin-right: 60px !important;\r\n  -webkit-transition: margin 0.5s; /* For Safari 3.1 to 6.0 */\r\n  transition: margin 0.5s;\r\n}\r\n.evf-watermark {\r\n  height: auto;\r\n  width: 250px;\r\n  position: absolute;\r\n  top: 0; bottom:0; left: 0; right:0;\r\n  margin: auto;\r\n  float: right;\r\n\r\n}\r\n\r\n.evf-watermark-2 {\r\n  height: auto;\r\n  width: 450px;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  margin: auto;\r\n  display: block;\r\n}\r\n\r\n\r\n@media screen and (max-width: 860px) {\r\n  .track-order-btns {\r\n    margin-bottom: 10px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n    .evf-social-2{\r\n      position: unset !important;\r\n      display: block;\r\n      top: 200px;\r\n      bottom: 0;\r\n      right: 0;\r\n      text-align: center;\r\n      margin-top: 10px !important;\r\n    }\r\n    .evf-watermark-2 {\r\n      height: 100px;\r\n      width: auto;\r\n      max-width: 350px;\r\n      position: unset;\r\n      top: 0;\r\n      bottom: 0;\r\n      right: 0;\r\n      margin: auto;\r\n      display: block;\r\n    }\r\n\r\n    .login-box {\r\n      margin-bottom: 0px !important;\r\n    }\r\n\r\n    .minor-sponsor-box {\r\n      margin-top: 0px !important;\r\n    }\r\n\r\n    .minor-sponsor-box .sub-box {\r\n      margin-top: 0 !important;\r\n    }\r\n\r\n    .cltl-text-bg {\r\n      margin-bottom: 10px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 1316px) {\r\n  .minor-sponsor-box {\r\n    right: 0 !important;\r\n  }\r\n  .minor-sponsor-box .sub-box {\r\n    width: 350px;\r\n    text-align: center;\r\n  }\r\n  img.major-sponsor-sm {\r\n    position: relative;\r\n    right: 20px;\r\n  }\r\n\r\n  img.evf_logo {\r\n    width: 260px;\r\n    height: 50px;\r\n  }\r\n  li.nav-item {\r\n    margin-right: 5px !important;\r\n  }\r\n\r\n  li.nav-item > a {\r\n    font-size: 13px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1240px) {\r\n  .col-div-0 {\r\n    max-width: 0% !important;\r\n    padding: 0;\r\n  }\r\n\r\n  .col-div-4 {\r\n    flex: unset;\r\n    max-width: 33.333333% !important;\r\n  }\r\n\r\n  .col-div-6 {\r\n    flex: unset;\r\n    max-width: 50% !important;\r\n  }\r\n\r\n  .col-div-1 {\r\n    /* flex: unset; */\r\n    max-width: 8.333333%;\r\n  }\r\n\r\n  .col-div-5 {\r\n    /* flex: unset; */\r\n    max-width: 41.666667%;\r\n  }\r\n\r\n  .col-div-6 .div-left {\r\n    padding-left: 33% !important;\r\n  }\r\n\r\n  .col-div-6 .div-right {\r\n    padding-right: 33% !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n  .login-box {\r\n    padding: 10px !important;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .minor-sponsor-box {\r\n    right: -16px;\r\n    padding: 0;\r\n    top: -60px !important;\r\n    right: -16px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .cltl-text-bg {\r\n    margin-top: 0 !important;\r\n  }\r\n  .img-bg {\r\n    text-align: center;;\r\n  }\r\n  .img-bg img {\r\n    margin-bottom: 40px !important;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-width: 620px) {\r\n  .col-div-4 {\r\n    flex: unset;\r\n    max-width: unset !important;\r\n  }\r\n\r\n  .col-div-6 {\r\n    flex: unset;\r\n    max-width: unset !important;\r\n  }\r\n\r\n  .col-div-6 .div-left {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .col-div-6 .div-right {\r\n    padding-right: 0 !important;\r\n  }\r\n}\r\n\r\n.evf-social {\r\n  position: absolute;\r\n  top: 170px;\r\n  bottom: 0;\r\n  left: 80px;\r\n  right: 0;\r\n  margin: auto;\r\n}\r\n\r\n.evf-social-2 {\r\n  position: absolute;\r\n  top: 210px;\r\n  bottom: 0;\r\n  right: 80px;\r\n  margin: auto;\r\n  display: block;\r\n  padding-right: 30px;\r\n}\r\n\r\n/*Added CSS - MNL Team - March 2018*/\r\n.VueCarousel-pagination {\r\n  float: none !important;\r\n  padding-top: -50px !important;\r\n}\r\n\r\na.hover:hover {\r\n  font-weight: bold;\r\n}\r\n\r\n.g-pt-180{\r\n  padding-top: 14rem !important;\r\n}\r\n\r\n.order-form-disabled{\r\n  font-size: 14px !important;\r\n  background-color: gray;\r\n  border-radius: 15px !important;\r\n  border: 3px solid gray !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor:not-allowed;;\r\n  min-width: 130px;\r\n}\r\n\r\n.error_select{\r\n  border: 1px solid red !important;\r\n}\r\n\r\n.g-icon-link {\r\n  cursor: pointer;\r\n}\r\n\r\n.g-float-right {\r\n  float: right;\r\n}\r\n\r\n.g-view-document {\r\n  padding: 0px 1.5rem 2.85714rem;\r\n}\r\n\r\n.g-help-view-document {\r\n  padding: 0px 2.85714rem 2.85714rem;\r\n}\r\n\r\na{\r\n  cursor: pointer !important;\r\n}\r\n\r\n.collapse-button {\r\n  right: 40px;\r\n  position: absolute;\r\n  top: 16px;\r\n  border: none;\r\n  height: 26px;\r\n  width: 40px;\r\n  cursor: pointer;\r\n  display: none;\r\n  /* -webkit-transition: height 0.5s;\r\n  transition: height 0.5s; */\r\n}\r\n\r\n.collapse-line {\r\n  height: 1px;\r\n  width: 100%;\r\n  background: white;\r\n  position: absolute;\r\n}\r\n\r\n.nav-collapse {\r\n  height: unset !important;\r\n  left: 0px;\r\n  background: whitesmoke;\r\n  /* display: none; */\r\n}\r\n\r\n.navigation-bar-collapse {\r\n  margin-top: 10px;\r\n  list-style-type: none;\r\n}\r\n\r\n.navigation-bar-collapse li {\r\n  padding: 10px 0px 10px 30px ;\r\n}\r\n\r\n.navigation-bar-collapse li a {\r\n  color: #26304d !important;\r\n}\r\n\r\n.navigation-bar-collapse li a:hover {\r\n  font-weight: bold;\r\n  color: #26304d !important;\r\n}\r\n\r\n.header, .temp-header {\r\n  position: fixed;\r\n  top: 0;\r\n  width: 100%;\r\n  left: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.main-header {\r\n  height: 110px;\r\n  -webkit-transition: height 0.5s; /* For Safari 3.1 to 6.0 */\r\n  transition: height 0.5s;\r\n  /* box-shadow: 0px 3px 2px rgba(0,0,0,0.2); */\r\n}\r\n.header .main-header {\r\n  height: 60px !important;\r\n  /* border-bottom: white 1px solid; */\r\n}\r\n\r\n.nav-container {\r\n  position: absolute;\r\n  top: 30px;\r\n  right: 0;\r\n  width: 75%;\r\n}\r\n\r\n.header .main-header .evf_logo {\r\n  height: 38px !important;\r\n  margin-top: 9px !important;\r\n}\r\n\r\n.header .main-header .navigation-bar {\r\n  margin-top: -25px !important;\r\n}\r\n\r\n.img-story-1 {\r\n  margin-right: 240px;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  /* .collapse-button {\r\n    display: block;\r\n  }\r\n\r\n  .main-header {\r\n    height: unset;\r\n  }\r\n\r\n  .header .main-header.is-collapse {\r\n    height: unset !important;\r\n  } */\r\n\r\n  .minor-sponsor-box {\r\n    margin-top: 20px !important;\r\n    right: 0 !important;\r\n  }\r\n\r\n  .minor-sponsor-box .sub-box {\r\n    text-align: center;\r\n    float: unset;\r\n    width: unset;\r\n    margin-top: 60px;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-width: 1087px) {\r\n  .collapse-button {\r\n    display: block;\r\n  }\r\n\r\n  .main-header {\r\n    height: unset;\r\n  }\r\n\r\n  .header .main-header.is-collapse {\r\n    height: unset !important;\r\n  }\r\n\r\n  .nav-container {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* 992 */\r\n@media screen and (min-width: 992px) {\r\n  .nav-collapse {\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n\r\n@media screen and (max-width: 576px) {\r\n  .img-story-1 {\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .div-phone .sm {\r\n    width: 30%;\r\n  }\r\n\r\n  .div-phone .md {\r\n    width: 40%;\r\n  }\r\n}\r\n.gray-border{\r\n  border: 1px solid #ddd !important;\r\n}\r\n\r\n.max-width-number{\r\n  max-width: 70px\r\n}\r\n\r\n.mar-right-10{\r\n  margin-right: 10px;\r\n}\r\n\r\n.mar-right-left-10{\r\n  margin-right: 10px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.no-arrow-updown::-webkit-inner-spin-button,\r\n.no-arrow-updown::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.landing-page-icon {\r\n  background: var(--primary-color);\r\n  padding: 20px;\r\n  width: 140px;\r\n  height: 140px;\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 30px;\r\n}\r\n\r\n.portal_link_content:hover .landing-page-icon {\r\n  box-shadow: 0 10px 15px 0 #efefef !important;\r\n  background: var(--secondary-color) !important;\r\n}\r\n\r\n.no-underline {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.portal_link_content:hover p {\r\n  color: var(--secondary-color) !important;\r\n}\r\n\r\n.g-bg-main-blue--hover:hover {\r\n  background-color: #213264 !important;\r\n}\r\n\r\n.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.registration-icon{\r\n  height: 150px;\r\n}\r\n\r\n.home-page-icon {\r\n  height: 200px;\r\n}\r\n\r\n.help-page-icon, .resource-page-icon {\r\n  height: 50px;\r\n}\r\n\r\n.contact-us-icon {\r\n  height: 70px;\r\n}\r\n\r\n.capitalize {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.isActive {\r\n  font-weight: bold;\r\n  color: whitesmoke !important;\r\n  padding-bottom: 39px !important;\r\n  border-bottom: 5px solid white;\r\n  -webkit-transition: padding 0.5s ease-in-out; /* For Safari 3.1 to 6.0 */\r\n  transition: padding 0.5s ease-in;\r\n}\r\n\r\n.header .isActive {\r\n  font-weight: bold;\r\n  color: whitesmoke !important;\r\n  padding-bottom: 13px !important;\r\n  border-bottom: 5px solid white;\r\n}\r\n\r\n.custom-tooltip {\r\n  background:rgba(0,0,0,0.85);\r\n  font-family: sans-serif !important;\r\n  width: 250px;\r\n  color: white;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n}\r\n\r\n#tooltipContent a {\r\n  color: dodgerblue !important;\r\n  font-size: 12px;\r\n}\r\n\r\n#tooltipContentInternational a {\r\n  color: dodgerblue !important;\r\n  font-size: 12px;\r\n}\r\n.stock-banner {\r\n  background: #b3b7c1;\r\n  height: 30px;\r\n}\r\n\r\n.stock-text {\r\n  float: right;\r\n  margin: 4px 10px;\r\n  font-weight: bold;\r\n  color: #26304d;\r\n}\r\n\r\n.stock-banner-sm {\r\n  background: #b3b7c1;\r\n  height: 10px;\r\n}\r\n\r\n.stock-text-sm {\r\n  float: right;\r\n  margin: -1px 4px;\r\n  font-weight: bold;\r\n  color: #26304d;\r\n  font-size: 8px;\r\n}\r\n\r\n.frame-pic-div.lowstock, .frame-pic-div.nostock {\r\n  height: 150px;\r\n}\r\n.frame-pic-div.lowstock img, .frame-pic-div.nostock img {\r\n  position: unset;\r\n}\r\n\r\n.frame-thumbnail-div.lowstock, .frame-thumbnail-div.nostock {\r\n  height: 40px;\r\n}\r\n.frame-thumbnail-div.lowstock img, .frame-thumbnail-div.nostock img {\r\n  position: unset;\r\n  margin-top: unset;\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-xl {\r\n  max-width: 950px;\r\n}\r\n\r\n.cltl-bg {\r\n  background-position-y: 65%;\r\n}\r\n\r\n.cltl-logo {\r\n  height: 200px;\r\n  margin-left: -10px;\r\n  margin-top: -20px;\r\n}\r\n.cltl-logo-white-bg {\r\n  margin-left: -10px;\r\n  margin-top: -20px;\r\n  /* max-width: fit-content; */\r\n  max-width:11ex;\r\n  /* background-color: white; */\r\n  /* box-shadow: teal; */\r\n}\r\n\r\n.cltl-text-bg {\r\n  background: white;\r\n  opacity: 0.4;\r\n  padding: 5px 10px;\r\n  border-radius: 5px;\r\n  -webkit-border-radius: 5px;\r\n  -moz-border-radius: 5px;\r\n  -ms-border-radius: 5px;\r\n  -o-border-radius: 5px;\r\n}\r\n.cltl-text-body {\r\n  line-height: 1.2;\r\n}\r\n\r\n.cltl-logo-white {\r\n  max-height: 250px;\r\n  height: auto;\r\n  margin: auto;\r\n  max-width: 100%;\r\n  width: auto;\r\n}\r\n\r\n.cltl-span {\r\n  display: block;\r\n  text-align: center;\r\n}\r\n\r\n.minor-sponsor-h {\r\n  height: 90px;\r\n  background: transparent;\r\n  width: 150px;\r\n  text-align: center;\r\n  padding: 3px;\r\n  margin: 5px 8px;\r\n}\r\n\r\n.minor-sponsor-h.home {\r\n  border-color: #61a9d1;\r\n}\r\n\r\n\r\n.minor-sponsor {\r\n  height: 90px;\r\n  background: transparent;\r\n  width: 150px;\r\n  text-align: center;\r\n  padding: 3px;\r\n  margin: 5px 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.minor-sponsor.landing {\r\n  border-radius: 5px;\r\n  -webkit-border-radius: 5px;\r\n  -moz-border-radius: 5px;\r\n  -ms-border-radius: 5px;\r\n  -o-border-radius: 5px;\r\n  border: 3px solid white;\r\n}\r\n\r\n.minor-sponsor.home {\r\n  border-color: #61a9d1;\r\n}\r\n\r\n.major-sponsor-sm {\r\n  height: 80px;\r\n  margin-top: 15px;\r\n  -webkit-transition: height 0.5s; /* For Safari 3.1 to 6.0 */\r\n  transition: height 0.5s;\r\n  -webkit-transition: margin 0.5s; /* For Safari 3.1 to 6.0 */\r\n  transition: margin 0.5s;\r\n}\r\n\r\n.header .main-header .major-sponsor-sm {\r\n  height: 45px !important;\r\n  margin-top: 7px !important;\r\n}\r\n\r\n.min_sp_img {\r\n  max-height: 80px;\r\n  height: auto;\r\n  max-width: 150px;\r\n  width: auto;\r\n  vertical-align: middle;\r\n  position: relative;\r\n}\r\n\r\n.minor-sponsor-box {\r\n  top: -40px;\r\n  right: -80px;\r\n}\r\n\r\n.nomargin {\r\n  margin: 0;\r\n}\r\n\r\n.btnDisabled:disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.cancelRequest-txt {\r\n  font-weight: bold;\r\n  text-align: center;\r\n}\r\n\r\n.track-order-btns {\r\n  margin: auto;\r\n  z-index: 1;\r\n  margin-bottom: -38px;\r\n}\r\n\r\n.track-order-btns.btn-pos-if-empty {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.track-order-btns.loading {\r\n  margin-bottom: 20px !important;\r\n}\r\n\r\n.pledge-input:disabled {\r\n  background-color: #eee !important;\r\n}\r\n\r\n  .btn-circle.btn-xl {\r\n    width: 140px;\r\n    height: 140px;\r\n    padding: 10px 16px;\r\n    border-radius: 70px;\r\n    font-size: 24px;\r\n    line-height: 1.33;\r\n  }\r\n\r\n  .x-blue {\r\n    background-color: #213264;\r\n    border-color: #213264;\r\n  }\r\n\r\n  .txt-blue {\r\n    color: #213264;\r\n  }\r\n\r\n  .btn-circle {\r\n    width: 30px;\r\n    height: 30px;\r\n    padding: 6px 0px;\r\n    border-radius: 15px;\r\n    text-align: center;\r\n    font-size: 12px;\r\n    line-height: 1.42857;\r\n  }\r\n\r\n  .btn-circle.btn-lg {\r\n    width: 100px;\r\n    height: 100px;\r\n    padding: 10px 16px;\r\n    border-radius: 50px;\r\n    font-size: 24px;\r\n    line-height: 1.33;\r\n  }\r\n\r\n  .bg-sha-gray {\r\n    background-color: #979797;\r\n  }\r\n\r\n  .cltl-day__banner {\r\n    height: 700px;\r\n    max-height: 700px;\r\n    width: 100%;\r\n    max-width: 1440px;\r\n    margin: auto;\r\n    position: relative;\r\n  }\r\n\r\n  .cltl-day__register-a {\r\n    font-weight: 600;\r\n    color: #fff!important;\r\n    background-color: #229cb4;\r\n    font-size: 18px;\r\n    padding: 14px 20px;\r\n    text-decoration: none;\r\n    position: absolute;\r\n    bottom: 46px;\r\n    left: 220px;\r\n  }\r\n\r\n  .cltl-day__text-module {\r\n    max-width: 1440px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .cltl_day__text-module-wrapper {\r\n    padding: 50px 0;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n    width: 90%;\r\n  }\r\n\r\n  .cltl-day__text-module-title {\r\n    color: #26304d!important;\r\n    line-height: 45px;\r\n    font-size: 36px;\r\n    box-sizing: border-box;\r\n    font-weight: 700;\r\n    margin-bottom: 52px;\r\n  }\r\n\r\n  .cltl-day__text-module-long-text {\r\n    color: #26304d!important;\r\n    font-weight: 500;\r\n    font-size: 20px;\r\n    line-height: 28px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .cltl-day__text-module-long-text a {\r\n    color: #27bac4!important;\r\n    font-weight: 700;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .cltl-day__stepper {\r\n    display: flex;\r\n    max-width: 1440px;\r\n    margin: 0 auto;\r\n    gap: 58px;\r\n  }\r\n\r\n  .cltl-day__stepper-step {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n  }\r\n\r\n  .cltl-day__stepper-step-wrapper {\r\n    margin-top: 64px;\r\n    background-color: #ececec;\r\n    padding-top: 35px;\r\n    padding-bottom: 50px;\r\n    padding-left: 50px;\r\n    padding-right: 50px;\r\n    width: 100%;\r\n    max-width: 400px;\r\n  }\r\n\r\n  .cltl-day__stepper-step-wrapper.active {\r\n    background-color: #d5e4ef;\r\n  }\r\n\r\n  .cltl-day__stepper-step-title {\r\n    color: #219cb3;\r\n    font-size: 24px;\r\n    letter-spacing: 3px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n  }\r\n\r\n  .cltl-day__stepper-step-text {\r\n    margin: 10px 0;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    color: #6f6e6d;\r\n    font-weight: 400;\r\n    line-height: 28px;\r\n  }\r\n\r\n  .cltl-day__stepper-step img {\r\n    max-width: 120px;\r\n    position: absolute\r\n  }\r\n\r\n  .cltl-day__register-host {\r\n    display: flex;\r\n    background-color: #d5e4ef;\r\n    padding: 50px 72px;\r\n    max-width: 1440px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .cltl-day__host-form {\r\n    display: flex;\r\n    width: 50%;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .cltl-day__form-image {\r\n    display: flex;\r\n    width: 50%;\r\n  }\r\n\r\n  .cltl-day__form-image img {\r\n    height: 100%;\r\n    display: block;\r\n    margin: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n.clear { clear: both;}\r\n\r\n.alignright { float: right; }\r\n.alignleft { float: left; }\r\n\r\n.wrapper-content a {color: #27bac4; text-decoration: underline; font-weight: 700;}\r\n.wrapper-content a:visited {color: #075055; text-decoration: none;}\r\n.wrapper-content a:hover {color: #075055; text-decoration: underline;}\r\n\r\n.bluefade { opacity: 1; transition: all .25s ease-in-out; -moz-transition: all .25s ease-in-out; -webkit-transition: all .25s ease-in-out; color: #fff; }\r\n.bluefade:hover { opacity: 1; color: #179ab2; }\r\n\r\n.s-bluefade { opacity: 1; transition: all .25s ease-in-out; -moz-transition: all .25s ease-in-out; -webkit-transition: all .25s ease-in-out; color: #777; }\r\n.s-bluefade:hover { opacity: 1; color: #179ab2; }\r\n\r\n.box-bluefade { opacity: 1; transition: all .25s ease-in-out; -moz-transition: all .25s ease-in-out; -webkit-transition: all .25s ease-in-out; color: #fff; text-transform: uppercase; font-size: 14px; letter-spacing: 1px; background-color: #179ab2; text-decoration: none; padding: 6px 20px; font-weight: 700;}\r\n.box-bluefade:hover { opacity: 1; color: #fff; background-color: #075055; text-decoration: none; font-weight: 700;}\r\n\r\n/* SEARCH LIGHTBOX */\r\n\r\n.lightbox {display: none; padding: 30px 50px; border: 5px solid #ccc; margin: 0 0 25px 0;}\r\nh1.lbtitle {margin: 0; padding: 0; font-size: 32px;}\r\n.lbcontent {margin: 20px 0 0 0; padding: 0; text-align: center;}\r\n\r\ninput.searchform {font-size: 18px; padding: 10px 20px 10px 55px; border-radius: 15px; border: 1px solid #179ab2; color: #555; width: 90%; }\r\n.input-icons i {position: absolute; }\r\n.input-icons {width: 100%; margin-bottom: 0px; }\r\n.icon { padding: 5px 0; color: #179ab2; min-width: 60px; text-align: center; font-size: 30px !important;}\r\n\r\n.searchresults-holder {border-bottom: 2px dotted #ccc; margin: 20px 0 0 0; padding: 0 0 20px 0;}\r\nh1.searchresults-title {font-size: 24px; line-height: 30px;}\r\n.searchresults-desc {}\r\n.searchresults-link {}\r\n\r\n.navigation {padding: 5px 0px; margin: 20px 0; width: 100%;}\r\n.newsnav-button {font-size: 14px; font-weight: 700; text-transform: uppercase; margin: 0;}\r\n.newsnav-button a {background-color: #179ab2; text-decoration: none; color: #fff; padding: 5px  10px;}\r\n.newsnav-button a:visited {background-color: #179ab2; color: #fff; text-decoration: none;}\r\n.newsnav-button a:hover {background-color: #ccc; color: #000; text-decoration: none;}\r\n\r\n/* FORM ELEMENTS */\r\n\r\nselect .form-text {border: 5px solid #F3F0E7; font-size: 16px; padding: 10px 10px 13px 10px; width: 100%;}\r\n.form-text {border: 5px solid #F3F0E7; font-size: 16px; padding: 10px 10px 13px 10px; width: 100%;}\r\n.form-textfull {border: 5px solid #F3F0E7; font-size: 16px; padding: 10px 10px 13px 10px; width: 92.8%;}\r\ninput.input-button {background-color: #179ab2; font-size: 21px; text-transform: uppercase; color: #fff; padding: 13.5px 54px; border: none; font-weight: 700; letter-spacing: 1px; cursor: pointer; transition: all .3s;}\r\n\r\n.checkboxOne { width: 25px; margin: 0px 0px 0px 0; position: relative; }\r\n.checkboxOne label {cursor: pointer; position: absolute; width: 25px; height: 25px; top: 0; left: 0; background: #fff; border:3px solid #ddd;}\r\n.checkboxOne label:after {opacity: 0.2; content: ''; position: absolute; width: 9px; height: 5px; background: transparent; top: 6px; left: 7px; border: 3px solid #369; border-top: none; border-right: none; transform: rotate(-45deg);}\r\n.checkboxOne label:hover::after {opacity: 0.5;}\r\n.checkboxOne input[type=checkbox]:checked + label:after { opacity: 1; }\r\n\r\n.checkboxTwo { width: 25px; margin: 0px 0px 0px 0; position: relative; }\r\n.checkboxTwo label {cursor: pointer; position: absolute; width: 25px; height: 25px; top: 0; left: 0; background: #fff; border:3px solid #ddd;}\r\n.checkboxTwo label:after {opacity: 0.2; content: ''; position: absolute; width: 9px; height: 5px; background: transparent; top: 6px; left: 7px; border: 3px solid #369; border-top: none; border-right: none; transform: rotate(-45deg);}\r\n.checkboxTwo label:hover::after {opacity: 0.5;}\r\n.checkboxTwo input[type=checkbox]:checked + label:after { opacity: 1; }\r\n\r\n.checkboxThree { width: 25px; margin: 0px 0px 0px 0; position: relative; }\r\n.checkboxThree label {cursor: pointer; position: absolute; width: 25px; height: 25px; top: 0; left: 0; background: #fff; border:3px solid #ddd;}\r\n.checkboxThree label:after {opacity: 0.2; content: ''; position: absolute; width: 9px; height: 5px; background: transparent; top: 6px; left: 7px; border: 3px solid #369; border-top: none; border-right: none; transform: rotate(-45deg);}\r\n.checkboxThree label:hover::after {opacity: 0.5;}\r\n.checkboxThree input[type=checkbox]:checked + label:after { opacity: 1; }\r\n\r\n.checkboxFour { width: 25px; margin: 0px 0px 0px 0; position: relative; }\r\n.checkboxFour label {cursor: pointer; position: absolute; width: 25px; height: 25px; top: 0; left: 0; background: #fff; border:3px solid #ddd;}\r\n.checkboxFour label:after {opacity: 0.2; content: ''; position: absolute; width: 9px; height: 5px; background: transparent; top: 6px; left: 7px; border: 3px solid #369; border-top: none; border-right: none; transform: rotate(-45deg);}\r\n.checkboxFour label:hover::after {opacity: 0.5;}\r\n.checkboxFour input[type=checkbox]:checked + label:after { opacity: 1; }\r\n\r\n/* GLOBAL TYPOGRAPHY */\r\n.blue {color: #229cb4;}\r\n.green {color: #075055;}\r\n.teal {color: #075055;}\r\n.beige {color: #f8f6f1;}\r\n.white {color: #ffffff;}\r\n.red {color: #ed1f24;}\r\n.vfvblue {color: #2c3691;}\r\n.vfvblack {color: #111111;}\r\n\r\n\r\n/* GLOBAL MARGINS, PADDING */\r\n.mt10 {margin-top:10px !important;}\r\n.mt20 {margin-top:20px !important;}\r\n.mt30 {margin-top:30px !important;}\r\n.mt40 {margin-top:40px !important;}\r\n.mt50 {margin-top:50px !important;}\r\n.mt60 {margin-top:60px !important;}\r\n.mt70 {margin-top:70px !important;}\r\n.mt80 {margin-top:80px !important;}\r\n.mt90 {margin-top:90px !important;}\r\n.mt100 {margin-top:100px !important;}\r\n\r\n.mb0 {margin-bottom: 0 !important;}\r\n.mb10 {margin-bottom:10px !important;}\r\n.mb20 {margin-bottom:20px !important;}\r\n.mb30 {margin-bottom:30px !important;}\r\n.mb40 {margin-bottom:40px !important;}\r\n.mb50 {margin-bottom:50px !important;}\r\n.mb60 {margin-bottom:60px !important;}\r\n.mb70 {margin-bottom:70px !important;}\r\n.mb80 {margin-bottom:80px !important;}\r\n.mb90 {margin-bottom:90px !important;}\r\n.mb100 {margin-bottom:100px !important;}\r\n\r\n.ml10 {margin-left:10px !important;}\r\n.ml20 {margin-left:20px !important;}\r\n.ml30 {margin-left:30px !important;}\r\n.ml40 {margin-left:40px !important;}\r\n.ml50 {margin-left:50px !important;}\r\n.ml60 {margin-left:60px !important;}\r\n.ml70 {margin-left:70px !important;}\r\n.ml80 {margin-left:80px !important;}\r\n.ml90 {margin-left:90px !important;}\r\n.ml100 {margin-left:100px !important;}\r\n\r\n.mr10 {margin-right:10px !important;}\r\n.mr20 {margin-right:20px !important;}\r\n.mr30 {margin-right:30px !important;}\r\n.mr40 {margin-right:40px !important;}\r\n.mr50 {margin-right:50px !important;}\r\n.mr60 {margin-right:60px !important;}\r\n.mr70 {margin-right:70px !important;}\r\n.mr80 {margin-right:80px !important;}\r\n.mr90 {margin-right:90px !important;}\r\n.mr100 {margin-right:100px !important;}\r\n\r\n/* h1 {font-size: 48px; text-transform: uppercase; line-height: 54px;}\r\nh2 {font-size: 36px; text-transform: uppercase; line-height: 45px;}\r\nh3 {font-size: 30px; text-transform: uppercase; line-height: 40px; text-align: center;}\r\nh4 {font-size: 24px; text-transform: uppercase; line-height: 36px;} */\r\n/* h5 {font-size: 21px; text-transform: uppercase; line-height: 28px;} */\r\n\r\n/*p {font-size: 16px; color: #6f6e6d; font-weight: 500; line-height: 28px;}*/\r\n/*p.intro {font-size: 24px; font-weight: 500; line-height: 36px; text-align: left;}*/\r\n/*li.vsmembernames {list-style-type: none !important; text-align:left;color:#f8f6f1;font-size:16px; margin-bottom:18px;font-weight:600; letter-spacing:.3px;}*/\r\n/*li.vsmembernames:hover {color: #075055;}*/\r\n\r\n/*.blocktitle {*/\r\n/*  margin: 20px 0 0 0; padding: 0; letter-spacing: 1px; line-height: 54px; width: 100%; text-align: center;*/\r\n/*}*/\r\n\r\n/* .100perwidth {width: 100% !important;} */\r\n\r\n\r\n/* BLOCK GLOBAL */\r\n\r\n.beigebg {background-color: #f8f6f1 !important;}\r\n.bluebg {background-color: #0093B2 !important;}\r\n.greenbg {background-color: #075055 !important;}\r\n.whitebg {background-color: #ffffff !important;}\r\n.babybeigebg {background-color: #fdfbf8 !important;}\r\n.babybluebg {background-color: #e1f0fb !important;}\r\n.babygreenbg {background-color: #daf7f9 !important;}\r\n.cfsbluebg {background-color: #009bdb !important;}\r\n.cfsorangebg {background-color: #f68f47 !important;}\r\n.cfsbluegreenbg {background-color: #02b1d0 !important;}\r\n.cfsyellowbg {background-color: #ffe54f !important;}\r\n.cfspurplebg {background-color: #9691c7 !important;}\r\n.cfspinkbg {background-color: #f493bf !important;}\r\n\r\n\r\n\r\nh1.front-bluetitle {color: #229cb4; font-size: 48px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 54px; width: 100%; text-align: center;}\r\nh1.front-titlegreen {color: #075055; font-size: 30px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 54px; width: 100%; text-align: center; font-weight: 600;}\r\n\r\nh1.blocktitle-teal {color: #075055; font-size: 42px; text-transform: uppercase; margin: -75px 0 40px 0; padding: 0; letter-spacing: 1px; line-height: 48px;}\r\nh1.blocktitle-teal-lowercase {color: #075055; font-size: 42px; margin: 0px 0 40px 0; padding: 0; letter-spacing: 1px; line-height: 48px;}\r\nh1.blocktitle-teal-next {color: #075055; font-size: 42px; text-transform: uppercase; margin: -40px 0 30px 0; padding: 0; letter-spacing: 1px; line-height: 48px; font-weight: 400;}\r\nh1.blocktitle-blue-up {color: #229cb4; font-size: 42px; text-transform: uppercase; margin: -75px 0 40px 0; padding: 0; letter-spacing: 1px; line-height: 48px;}\r\nh1.blocktitle-blue {color: #229cb4; font-size: 42px; text-transform: uppercase; margin: 0px 0 20px 0; padding: 0; letter-spacing: 1px; line-height: 48px;}\r\nh1.blocktitle-smallteal {color: #075055; font-size: 30px; text-transform: uppercase; margin: 0px 0 40px 0; padding: 0; letter-spacing: 1px;}\r\nh1.blocktitle-smallblue {color: #229cb4; font-size: 30px; text-transform: uppercase; margin: 0px 0 40px 0; padding: 0; letter-spacing: 1px;}\r\nh1.blocktitle-white {color: #fff; font-size: 42px; text-transform: uppercase; margin: 0px 0 40px 0; padding: 0; letter-spacing: 1px; line-height: 48px;}\r\nh1.blocktitle-smallwhite {color: #fff; font-size: 30px; margin: 0px 0 40px 0; padding: 0; letter-spacing: 1px; line-height: 48px; font-weight: 600;}\r\n\r\nh1.blocktitle-orange {color: #fbb03b; font-size: 42px; text-transform: uppercase; margin: 0px 0 40px 0; padding: 0; letter-spacing: 1px; line-height: 48px;}\r\n\r\nh4.blocktitle-subtitle {font-size: 24px; color: #6f6e6d; font-weight: 500; line-height: 28px; margin: -30px 0 0 0; text-transform: initial !important;}\r\n\r\n.blockcontent {font-size: 16px; color: #6f6e6d; font-weight: 500; line-height: 28px; width: 70%; margin:0 auto;}\r\n.front-blockcontent-beige {font-size: 16px; color: #6f6e6d; font-weight: 500; line-height: 28px; margin:30px 0;}\r\n.blockcontent-beige {font-size: 16px; color: #6f6e6d; font-weight: 500; line-height: 28px; width: 70%; margin:0 auto;} /*JC*/\r\n.blockcontent-green {font-size: 16px; color: #ffffff; font-weight: 500; line-height: 28px; width: 70%; margin:0 auto;} /*JC*/\r\n.blockcontent-white {font-size: 16px; color: #fff; font-weight: 500; line-height: 28px; width: 70%; margin:0 auto;}\r\n.blockcontent-white2 {font-size: 24px; color: #fff; font-weight: 500; line-height: 34px;}\r\n.blockcontent-orange {font-size: 24px; color: #fbb03b; font-weight: 500; line-height: 34px;}\r\n.narrowwidth {width: 48% !important;}\r\n\r\n.blockcontent img {width: 80%;}\r\n\r\nh1.holder-2block-title {color: #229cb4; font-size: 42px; text-transform: uppercase; margin: 0 0 20px 0; line-height: 48px;}\r\nh1.holder-2block-title-teal {color: #075055; font-size: 42px; text-transform: uppercase; margin: 0 0 20px 0; line-height: 48px;}\r\nh1.holder-2block-title-white {color: #fff; font-size: 42px; text-transform: uppercase; margin: 0 0 20px 0;}\r\n.holder-2block-desc {font-size: 16px; font-weight: 400; line-height: 28px;}\r\n.holder-2block-button {margin: 50px 0 0 0;}\r\n\r\n.holder-2block-desc a {color: #229cb4; text-decoration: underline;}\r\n.holder-2block-desc a:visited {color: #229cb4; text-decoration: underline;}\r\n.holder-2block-desc a:hover {color: #075055; text-decoration: underline;}\r\n\r\n.news-contentblock a {color: #ffffff; text-decoration: underline;} /* News Section - Links */\r\n.news-contentblock a:visited {color: #ffffff; text-decoration: underline;} /* News Section - Links */\r\n.news-contentblock a:hover {color: #229cb4; text-decoration: underline;} /* News Section - Links */\r\n\r\n/* .bluebutton {display:block; text-align: center; margin: 0 20%;} */\r\n\r\na.bluebutton {font-size: 18px; color: #fff; text-transform: uppercase; background-color: #229cb4; padding: 14px 20px; letter-spacing: 5px; text-decoration: none; font-weight: 600;}\r\na:visited.bluebutton {color: #fff; text-decoration: none;}\r\na:hover.bluebutton {background-color: #075055; color: #fff; text-decoration: none; }\r\n\r\na.bluebutton2 {font-size: 16px; color: #fff; text-transform: uppercase; background-color: #229cb4; padding: 10px 20px; letter-spacing: 5px; text-decoration: none; font-weight: 600;}\r\na:visited.bluebutton2 {color: #fff; text-decoration: none;}\r\na:hover.bluebutton2 {background-color: #075055; color: #fff; text-decoration: none; }\r\n\r\na.whitebutton {font-size: 18px; color: #075055; text-transform: uppercase; background-color: #ffffff; padding: 14px 20px; letter-spacing: 5px; text-decoration: none; font-weight: 600;}\r\na:visited.whitebutton {color: #075055; text-decoration: none;}\r\na:hover.whitebutton {background-color: #075055; color: #fff; text-decoration: none; }\r\n\r\na.vfvbluebutton {font-size: 18px; color: #fff; text-transform: uppercase; background-color: #2f3690; padding: 14px 20px; letter-spacing: 5px; text-decoration: none; font-weight: 600;}\r\na:visited.vfvbluebutton {color: #fff; text-decoration: none;}\r\na:hover.vfvbluebutton {background-color: #075055; color: #fff; text-decoration: none; }\r\n\r\n\r\n\r\n\r\na.greenlink-nobox {font-size: 18px; color: #075055; text-transform: uppercase; letter-spacing: 1px; text-decoration: none; font-weight: 600;}\r\na:visited.greenlink-nobox {color: #075055; text-decoration: none;}\r\na:hover.greenlink-nobox {color: #075055; text-decoration: underline; }\r\n\r\na.bluelink-nobox {font-size: 30px; color: #229cb4; text-transform: uppercase; letter-spacing: 1px; text-decoration: none; font-weight: 600;}\r\na:visited.bluelink-nobox {color: #229cb4; text-decoration: none;}\r\na:hover.bluelink-nobox {color: #229cb4; text-decoration: underline; }\r\n\r\na.bluelinksmall-nobox {font-size: 14px; color: #229cb4; text-decoration: none; font-weight: 400;}\r\na:visited.bluelinksmall-nobox {color: #229cb4; text-decoration: none;}\r\na:hover.bluelinksmall-nobox {color: #229cb4; text-decoration: underline; }\r\n\r\na.omm-orange {font-size: 28px; color: #fff; text-transform: uppercase; background-color: #e5801a; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border: 4px solid #f7931e; border-radius: 20px 20px 20px 20px; }\r\na:visited.omm-orange {color: #fff; text-decoration: none;}\r\na:hover.omm-orange {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\na.omm-white {font-size: 28px; color: #e5801a; text-transform: uppercase; background-color: #fff; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border-radius: 20px 20px 20px 20px; font-weight: 600;}\r\na:visited.omm-white {color: #e5801a; text-decoration: none;}\r\na:hover.omm-white {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\na.round-green-button {font-size: 20px; color: #fff; text-transform: uppercase; text-align: center; background-color: #075055; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border-radius: 20px 20px 20px 20px; font-weight: 600; display: inline-block;}\r\na:visited.round-green-button {color: #ffffff; text-align: center; display: inline-block; background-color:#075055; text-decoration: none;}\r\na:hover.round-green-button {color: #ffffff; text-align: center; display: inline-block; background-color: #229cb4; text-decoration: none;}\r\n\r\na.round-blue-button {font-size: 20px; color: #ffffff; text-transform: uppercase; background-color: #229cb4; padding: 20px 55px; letter-spacing: 2px; text-decoration: none; border-radius: 18px 18px 18px 18px; font-weight: 600;}\r\na:visited.round-blue-button { color: #ffffff; background-color: #229cb4;}\r\na:hover.round-blue-button {color: #ffffff; background-color: #075055; text-decoration: none;}\r\n\r\na.round-white-button {font-size: 20px; color: #075055; text-transform: uppercase; background-color: #ffffff;padding: 20px 55px; letter-spacing: 2px; text-decoration: none; border-radius: 18px 18px 18px 18px; font-weight: 600;}\r\na:visited.round-white-button { color: #075055; background-color: #ffffff;}\r\na:hover.round-white-button {color: #ffffff; background-color: #075055; text-decoration: none;}\r\n\r\n.centered-button {display: inline-block; width: 95%; position: relative; margin:0 auto;}\r\n\r\nhr.whitedotted {border-top: 6px dotted #fff; margin: 60px 0; border-bottom: 0;}\r\nhr.bluedotted {border-top: 6px dotted #229cb4; margin: 60px 0; border-bottom: 0;}\r\nhr.solidorange {border-top: 4px solid #f7931e; margin: 60px 0; border-bottom: 0;}\r\nhr.solidred {border-top: 4px solid #ec1d23; margin: 60px 0; border-bottom: 0;}\r\n\r\n\r\n/*hr.omm-arrow {width: 140px; height: 45px; min-height: 45px; background-image: url(\"/static/assets/img/omm-arrow.png\"); border: 0px;}*/\r\n/*hr.vfv-arrow {width: 140px; height: 45px; min-height: 45px; background-image: url(\"/static/assets/img/vfv-arrow.png\"); border: 0px;}*/\r\n\r\n\r\n.borderred {border-width:9px; border-color: #ec1d23; border-style: solid;}\r\n.borderbabyblue {border-width:9px; border-color: #ec1d23; border-style: solid;}\r\n.borderroyalblue {border-width:9px; border-color: #ec1d23; border-style: solid;}\r\n\r\n.video-container {\r\n  position: relative;\r\n  padding-bottom: 56.25%;\r\n  padding-top: 30px; height: 0; overflow: hidden;\r\n}\r\n\r\n.video-container-80 {\r\n  position: relative;\r\n  padding-bottom: 56.25%;\r\n  padding-top: 10px; height: 0; overflow: hidden;\r\n}\r\n\r\n.videoslate {margin: 0 auto; border: 10px #ffffff solid;  width: 100%; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);}\r\n\r\n.video-container-80 iframe,\r\n.video-container-80 object,\r\n.video-container-80 embed {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.video-container iframe,\r\n.video-container object,\r\n.video-container embed {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.imgfade {\r\n  opacity: 1;\r\n  transition: opacity .25s ease-in-out;\r\n  -moz-transition: opacity .25s ease-in-out;\r\n  -webkit-transition: opacity .25s ease-in-out;\r\n}\r\n\r\n.imgfade:hover {\r\n  opacity: 0.5;\r\n}\r\n\r\n.slidingDiv {\r\n  z-index: 9999999999999999999;\r\n  position: fixed;\r\n  height:100%;\r\n  background-color: #229cb4;\r\n  padding:30px 40px 40px 40px;\r\n  margin-top:0px;\r\n  right: 0;\r\n  width: 100%;\r\n  z-index: 999999999;\r\n}\r\n.show_hide {\r\n  display:none;\r\n}\r\n\r\n.mobilenav-close {z-index: 99999999999999999; text-align: right; margin: 0; font-size: 18px; color: #fff; text-transform: uppercase;}\r\n.mobilenav-close a {color: #fff; text-decoration: none;}\r\n.mobilenav-close a:visited {color: #fff; text-decoration: none;}\r\n.mobilenav-close a:hover {color: #fff; text-decoration: none;}\r\n.mobilenav-list {width: 90%; margin: 0 auto; }\r\n.mobilenav-list a {color: #fff; text-decoration: none;}\r\n.mobilenav-list a:visited {color: #fff; text-decoration: none;}\r\n.mobilenav-list a:hover {color: #075055; text-decoration: none;}\r\n.mobilenav-list a:active {color: #075055; text-decoration: none;}\r\n.mobilenav-list ul {list-style-type: none; margin: 20px 0 0 0; padding: 0;}\r\n.mobilenav-list ul li {border-bottom: 6px dotted #fff; text-transform: uppercase; font-size: 20px; font-weight: 600; text-align: center; padding: 15px 0;}\r\n.mobilenav-list ul li a {color: #fff; text-decoration: none;}\r\n.mobilenav-list ul li a:visited {color: #fff; text-decoration: none;}\r\n.mobilenav-list ul li a:hover {color: #075055; text-decoration: none;}\r\n.mobilenav-list ul li a:active {color: #075055; text-decoration: none;}\r\n\r\n.mobilenav-list-small {width: 90%; margin: 0 auto; }\r\n.mobilenav-list-small a {color: #fff; text-decoration: none;}\r\n.mobilenav-list-small a:visited {color: #fff; text-decoration: none;}\r\n.mobilenav-list-small a:hover {color: #075055; text-decoration: none;}\r\n.mobilenav-list-small a:active {color: #075055; text-decoration: none;}\r\n.mobilenav-list-small ul {list-style-type: none; margin: 30px 0 0 0; padding: 0;}\r\n.mobilenav-list-small ul li {text-transform: uppercase; font-size: 18px; font-weight: 600; text-align: center; padding: 8px 0;}\r\n.mobilenav-list-small ul li a {color: #fff; text-decoration: none;}\r\n.mobilenav-list-small ul li a:visited {color: #fff; text-decoration: none;}\r\n.mobilenav-list-small ul li a:hover {color: #075055; text-decoration: none;}\r\n.mobilenav-list-small ul li a:active {color: #075055; text-decoration: none;}\r\n\r\n.mobilenav-donate {margin: 40px auto; text-align: center;}\r\na.mobilenav-donatebutton {text-align: center; background-color: #075055; color: #fff; text-transform: uppercase; font-weight: 600; padding: 15px 90px; font-size: 20px; text-decoration: none;}\r\na:visited.mobilenav-donatebutton {background-color: #075055; color: #fff; text-transform: uppercase; font-weight: 600; text-decoration: none;}\r\na:hover.mobilenav-donatebutton {background-color: #075055; color: #fff; text-transform: uppercase; font-weight: 600; text-decoration: none;}\r\n\r\n.omm-faq-question {font-size: 20px; color: #f7931e; font-weight: 600; margin: 30px 0 0;}\r\n.omm-faq-question img {margin: 0 20px 0 0;}\r\n.omm-faq-answer {display: none; margin: 10px 0 0 70px; line-height: 24px;}\r\n\r\n.content-story-column {width: 70% !important; text-align: left; margin:0 auto;}\r\n\r\n.newslisting-type {/*background-color: #b5b1ac;*/ font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; /*padding: 10px;*/ max-width: 200px; text-align: left; margin: 20px 0;}\r\n\r\n.news-teaser {margin-bottom: 25px;}\r\n\r\n/* GLOBAL - DROP-DOWN */\r\n\r\n.container-header-fullwidth {z-index: 9999999999; width: 90%; max-width: 1400px; margin: 0 auto;}\r\n.topnav-dropdown {text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 0 0 0 200px;}\r\n.topnav-dropdown-sticky {text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 0 0 0 300px;}\r\n\r\n#dropmenu, #dropmenu ul {\r\n  margin:0;\r\n  padding:0;\r\n  list-style-type:none;\r\n  list-style-position:outside;\r\n  position:relative;\r\n  font-weight:bold;\r\n  z-index: 6000;\r\n}\r\n#dropmenu a {\r\n  color: #FFF;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n}\r\n\r\n#dropmenu li a.about{display:block; float:left; height:50px; text-decoration:none; padding:20px 20px 10px 20px; cursor:pointer;}\r\n#dropmenu li a.stories {display:block; float:left; height:50px; padding:20px 20px 10px 20px; text-decoration:none; cursor:pointer;}\r\n#dropmenu li a.involved {display:block; float:left; height:50px; padding:20px 20px 10px 20px; text-decoration:none; cursor:pointer;}\r\n#dropmenu li a.resources {display:block; float:left; height:50px; padding:20px 20px 10px 20px; text-decoration:none;cursor:pointer;}\r\n#dropmenu li a.campaign {display:block; float:left; height:50px; padding:20px 20px 10px 20px; text-decoration:none;cursor:pointer;}\r\n#dropmenu li a.onemillion {display:block; float:left; height:50px; padding:20px 20px 10px 20px; text-decoration:none; cursor:pointer;}\r\n\r\n#dropmenu li a.about {margin: 0 10px;}\r\n#dropmenu li a.stories {margin: 0 10px;}\r\n#dropmenu li a.involved {margin: 0 10px;}\r\n#dropmenu li a.resources {margin: 0 10px;}\r\n#dropmenu li a.campaign {margin: 0 10px;}\r\n#dropmenu li a.onemillion {margin: 0 10px;}\r\n\r\n\r\n#dropmenu li:hover a.about, #dropmenu a:hover.about {background-color: #fff; color: #179ab2;}\r\n#dropmenu li:hover a.stories, #dropmenu a:hover.stories {background-color: #fff; color: #179ab2;}\r\n#dropmenu li:hover a.involved, #dropmenu a:hover.involved {background-color: #fff; color: #179ab2;}\r\n#dropmenu li:hover a.resources, #dropmenu a:hover.resources {background-color: #fff; color: #179ab2;}\r\n#dropmenu li:hover a.campaign, #dropmenu a:hover.campaign {background-color: #fff; color: #179ab2;}\r\n#dropmenu li:hover a.onemillion, #dropmenu a:hover.onemillion {background-color: #fff; color: #179ab2;}\r\n\r\n/* STICKY DROPDOWN STYLES */\r\n\r\n#dropmenu li a.about-sticky {display:block; float:left; height:60px; text-decoration:none; padding:28px 20px 42px 20px; cursor:pointer; }\r\n#dropmenu li a.stories-sticky {display:block; float:left; height:60px; padding:28px 20px 42px 20px; text-decoration:none; cursor:pointer;}\r\n#dropmenu li a.involved-sticky {display:block; float:left; height:60px; padding:28px 20px 42px 20px; text-decoration:none; cursor:pointer;}\r\n#dropmenu li a.resources-sticky {display:block; float:left; height:60px; padding:28px 20px 42px 20px; text-decoration:none;cursor:pointer;}\r\n#dropmenu li a.campaign-sticky {display:block; float:left; height:60px; padding:28px 20px 42px 20px; text-decoration:none;cursor:pointer;}\r\n#dropmenu li a.onemillion-sticky {display:block; float:left; height:60px; padding:28px 20px 42px 20px; text-decoration:none; cursor:pointer;}\r\n\r\n#dropmenu li a.about-sticky {margin: 0 5px; color: #179ab2;}\r\n#dropmenu li a.stories-sticky {margin: 0 5px; color: #179ab2;}\r\n#dropmenu li a.involved-sticky {margin: 0 5px; color: #179ab2;}\r\n#dropmenu li a.resources-sticky {margin: 0 5px; color: #179ab2;}\r\n#dropmenu li a.campaign-sticky {margin: 0 5px; color: #179ab2;}\r\n#dropmenu li a.onemillion-sticky {margin: 0 5px; color: #179ab2;}\r\n\r\n\r\n#dropmenu li:hover a.about-sticky, #dropmenu a:hover.about-sticky {background-color: #179ab2; color: #fff;}\r\n#dropmenu li:hover a.stories-sticky, #dropmenu a:hover.stories-sticky {background-color: #179ab2; color: #fff;}\r\n#dropmenu li:hover a.involved-sticky, #dropmenu a:hover.involved-sticky {background-color: #179ab2; color: #fff;}\r\n#dropmenu li:hover a.resources-sticky, #dropmenu a:hover.resources-sticky {background-color: #179ab2; color: #fff;}\r\n#dropmenu li:hover a.campaign-sticky, #dropmenu a:hover.campaign-sticky {background-color: #179ab2; color: #fff;}\r\n#dropmenu li:hover a.onemillion-sticky, #dropmenu a:hover.onemillion-sticky {background-color: #179ab2; color: #fff;}\r\n\r\n\r\n#dropmenu li {\r\n  float:left;\r\n  position:relative;\r\n  display:block;\r\n}\r\n#dropmenu ul {\r\n  position:absolute;\r\n  display:none;\r\n  height:auto;\r\n  border-bottom:2px solid #000;\r\n}\r\n#dropmenu ul a {\r\n  color:#333;\r\n  padding:0px;\r\n}\r\n#dropmenu ul a:hover {\r\n  background-color: #fff;\r\n}\r\n#dropmenu li ul {\r\n  background:#fff;\r\n  top:50px;\r\n  float: left;\r\n  padding: 5px 0;\r\n  margin: 0px 0 0 10px;\r\n  width: 300px;\r\n  border-right:0px solid #fff;\r\n  border-left:0px solid #fff;\r\n  border-bottom: 3px solid #179ab2;\r\n  opacity: .9;\r\n}\r\n\r\n#dropmenu li ul.sticky-dropdown {\r\n  background:#fff;\r\n  top:70px;\r\n  float: left;\r\n  padding: 5px 0;\r\n  margin: 0px 0 0 10px;\r\n  width: 300px;\r\n  border-right:0px solid #fff;\r\n  border-left:0px solid #fff;\r\n  border-bottom: 3px solid #179ab2;\r\n  opacity: .9;\r\n}\r\n\r\n#dropmenu li ul li.current_page_item a {\r\n  background:#fff;\r\n  color:#369;\r\n}\r\n\r\n#dropmenu li ul li {\r\n  border-top:0px solid #fff;\r\n}\r\n\r\n#dropmenu li ul a {\r\n  width:260px;\r\n  padding:10px 10px 6px 20px;\r\n  font-size: 14px;\r\n  float:left;\r\n  font-weight: 700;\r\n}\r\n\r\n#dropmenu li ul a:hover {\r\n  color: #179ab2;\r\n}\r\n\r\n#dropmenu ul ul {\r\n  top:auto;\r\n}\r\n#dropmenu li ul ul {\r\n  left:175px;\r\n  margin:0px 0 0 10px;\r\n}\r\n#dropmenu li:hover ul ul, #dropmenu li:hover ul ul ul, #dropmenu li:hover ul ul ul ul {\r\n  display:none;\r\n}\r\n#dropmenu li:hover ul, #dropmenu li li:hover ul, #dropmenu li li li:hover ul, #dropmenu li li li li:hover ul {\r\n  display:block;\r\n}\r\n\r\n/*/ * GLOBAL - MEGA MENU *!*/\r\n\r\n.topnav-megamenu {text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; float: left; width: 50%;}\r\n\r\n\r\n/* GLOBAL - Classy Styles */\r\n/* .classy-org-progress {} */\r\n/* .classy-org-widget {} */\r\n/* .classy-org-progress_title {display: none;} */ /* Title of campaign */\r\n/* span.classy-org-progress_raised {} */  /* number of money raised style */\r\n/* span.classy-org-progress_goal {} */ /* number of goal style */\r\n/* .classy-org-progress_bar-mask {} */ /* entire width of progress bar */\r\n/* .classy-org-progress_bar-value {} */ /* raised bar style */\r\n\r\n\r\n/*.wrapper-header-testing, .wrapper-header-form-embed, .wrapper-header-kvfl-events, .wrapper-header-kvfl-events-scheduler {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}*/\r\n\r\n\r\n@media screen and (min-width: 0px) and (max-width: 2440px) { /*changed to 2440 so styles wouldn't break on wider screens */\r\n\r\n  @media screen and (min-width: 1201px) and (max-width: 2440px) {\r\n\r\n    .mobile-menubutton, .m-wrapper-sectionpic {display: none;}\r\n    .hidedesktop {display: none;}\r\n\r\n    /* FRONT 2019 */\r\n\r\n    .front-picholder {width: 45%; float: right;}\r\n    .front-pictext {width: 50%; text-align: left !important;}\r\n    .front-pictext-right {width: 50%; text-align: left !important; float:right !important;}\r\n    .front-picholder-left {width: 45%; float: left;}\r\n\r\n    .front-3column-holder {width: 25%; max-width: 305px; display: inline-block; text-align: center; margin: 0 2%; vertical-align: top; background-color: #fff;}\r\n    .front-3column-pic {width: 100%;}\r\n    .front-3column-pic img {width: 100%;}\r\n    .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n    .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n    .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n    .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n    .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n    .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n    /* Header Section 2 */\r\n    .wrapper-front-sect2 {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .container-front-sect2 {width: 90%; margin: 0 auto; text-align: center; padding:60px 0 80px 0;}\r\n\r\n    /* Simple Section 2 */\r\n    .simple-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n    .simple-sect2-descright {float: right; text-align: center; width: 35%; color: #fff; font-size: 24px; line-height:30px;}\r\n    .simple-sect2-descleft {float: left; text-align: left; width: 60%; color: #fff; font-size: 24px; line-height: 30px;}\r\n    .simple-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .simple-sect2-button {margin: 40px 0 0 0;}\r\n    .simple-front-sect2-circle {width: 100% !important; text-align: center; margin: -60px auto 0 auto !important;}\r\n    .simple-front-sect2-circle img {width:60% !important; max-width: 180px;}\r\n\r\n    /* Simple Section 5 */\r\n    .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #f4f2f3; margin: 0 auto; }\r\n    .simple-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: center;}\r\n    .simple-sect5-content {color: #777777; font-size: 18px; line-height: 28px;}\r\n    .simple-sect5-button {margin: 50px 0;}\r\n    .simple-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .simple-sect5-child img {width: 100%;}\r\n    .simple-sect5-child-circle {display: none;}\r\n\r\n\r\n    /* VFV */\r\n\r\n    .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n    .vfv-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vfv-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n    .vfv-sect2-desc {float: right; text-align: center; width: 75%;}\r\n    .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .vfv-sect2-button {margin: 40px 0 0 0;}\r\n    .vfv-front-sect2-arrow {width: 100%; text-align: center;}\r\n    .vfv-videoslate {margin: 30px auto; border: 20px #e5ebf6 solid;  width: 100%;}\r\n\r\n    /* OMM */\r\n\r\n    .omm-faq-m {display: none;}\r\n\r\n    .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n    .omm-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .omm-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n    .omm-sect2-desc {float: right; text-align: center; width: 45%;}\r\n    .omm-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-button {margin: 40px 0 0 0;}\r\n    .omm-front-sect2-arrow {width: 100%; text-align: center;}\r\n\r\n    .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n    .vp2020-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vp2020-sect2-brandingmark {float: left; width: 45%; text-align: center; padding-left: 5%; }\r\n    .vp2020-sect2-brandingmark img {max-width:300px; }\r\n    .vp2020-sect2-desc {float: right; text-align: center; width: 45%;}\r\n    .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .vp2020-sect2-button {margin: 40px 0 0 0;}\r\n    .vp2020-front-sect2-arrow {width: 100%; text-align: center;}\r\n\r\n\r\n    .omm-sect2-donatetext {float: left; width: 100%; text-align: center; font-size: 30px; color: #fff; font-weight: 600; line-height: 30px;}\r\n    .omm-sect2-donateembed {float: right; text-align: center; width: 35%;}\r\n\r\n    /*\r\n\t\t.omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/omm-sect5-childbg.jpg\") no-repeat bottom right; margin: 0 auto; min-height: 800px;}\r\n\t\t.omm-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n\t\t.omm-sect5-content {color: #fff; font-size: 20px; line-height: 30px; width: 45%;}\r\n\t\t.omm-sect5-button {margin: 50px 0;}\r\n\t\t.omm-sect5-child {display: none;}\r\n\t\t.omm-sect5-child-circle {display: none;}\r\n\t\t*/\r\n\r\n    .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto; }\r\n    .omm-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n    .omm-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .omm-sect5-button {margin: 50px 0;}\r\n    .omm-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .omm-sect5-child img {width: 100%;}\r\n    .omm-sect5-child-circle {display: none;}\r\n\r\n    .omm-videoslate {margin: 30px auto; border: 20px #fbb03b solid;  width: 100%;}\r\n\r\n    .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n    .omm-container-orange {width: 60%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;} /*JC* changed width to 60*/\r\n\r\n    .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n    .omm-container-blue {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n    .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700;}\r\n    .omm-greatnews-stat {margin: 30px 0 0 0;}\r\n    .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; float: left; text-align: right; width: 40%; vertical-align: top; margin: 40px 0 0 0;}\r\n    .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; float: left ; text-align: left; text-transform: uppercase; width: 40%; vertical-align: top; line-height: 50px; margin: 0 0 0 50px;}\r\n\r\n    .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n    .omm-checkout-brandingmark {width: 50%; margin: 0 auto;}\r\n    .omm-checkout-brandingmark img {width:90%;}\r\n\r\n    .omm-container-checkout {width: 50%; margin: 50px auto;}\r\n    .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n    .omm-thankyou-brandingmark {width: 70%; margin: 0 0 0 -30px;}\r\n    .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n    .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .omm-container-faq {width: 70%; margin: 50px auto;}\r\n    .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n    /* HEADER */\r\n\r\n    .wrapper-header-welcome, .wrapper-header-testing, .wrapper-header-form-embed, .wrapper-header-kvfl-events, .wrapper-header-kvfl-events-scheduler {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-onemillion, .wrapper-header {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-donate.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n    .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n    .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-faq.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n    .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-onemillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n    .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px}\r\n\r\n    .wrapper-header-help-a-child {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-help-a-child.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px}\r\n\r\n    .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-see-kids-soar-eoa, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-grants-for-good-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-grantsforgoodsight.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day, .wrapper-header-cltl-day-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n\r\n    .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-golfthankyou {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-golfthankyou.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-impact-report {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-impactreport.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit, .wrapper-header-thank-you-presidents-day-kit, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    /* PARTNERSHIPS HEADER IMAGES */\r\n    .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    /* STORY HEADER IMAGE */\r\n    .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .container-header {z-index: 9999999999; width: 100%; max-width: 1000px; margin: 0 auto;}\r\n\r\n    .header-logo {float: left; width: 200px; margin: 20px 0 0 0;}\r\n    .header-logo img {width: 100%;}\r\n    .topnav {float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 70px; font-weight: 600;}\r\n    .topnav a {text-decoration: none; margin: 0 19px 0 0;} /*JC*/\r\n    .topnav a:visited {text-decoration: none;}\r\n    .topnav a:hover {text-decoration: none;}\r\n\r\n    .header-donate {z-index: 99999999; float: right; margin: 20px 0 0 0;}\r\n\r\n    .header-sectiontext-wide {position: absolute; margin: 150px 0 0 8%; color: #fff; height: 400px; display: table; width: 550px;}\r\n    .header-sectiontext {position: absolute; margin: 150px 0 0 12%; color: #fff; height: 400px; display: table; width: 550px;}\r\n    .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n    .sectiontext-headline {font-size: 62px; text-transform: uppercase; font-weight: 600; line-height: 62px; width: 100%;}\r\n    .sectiontext-headlinethin {font-size: 62px; text-transform: uppercase; font-weight: 300;}\r\n\r\n    .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 40px 0 0 0; line-height: 30px; width: 80%;}\r\n\r\n    .topnav-dropdown {text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 0 0 0 200px;}\r\n    .topnav-dropdown-sticky {text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 0 0 0 200px;}\r\n\r\n    .header-airplane {z-index: 999; position: absolute; margin: 50px 0 0 -100px;}\r\n    .header-dots {z-index: 999; margin: -10px -220px 0 0; float: right;}\r\n\r\n    #dropmenu li a.about {margin: 0 10px;}\r\n    #dropmenu li a.stories {margin: 0 10px;}\r\n    #dropmenu li a.involved {margin: 0 10px;}\r\n    #dropmenu li a.resources {margin: 0 10px;}\r\n    #dropmenu li a.campaign {margin: 0 10px;}\r\n    #dropmenu li a.onemillion {margin: 0 10px;}\r\n\r\n    #dropmenu li a.about-sticky {margin: 0 5px; color: #179ab2;}\r\n    #dropmenu li a.stories-sticky {margin: 0 5px; color: #179ab2;}\r\n    #dropmenu li a.involved-sticky {margin: 0 5px; color: #179ab2;}\r\n    #dropmenu li a.resources-sticky {margin: 0 5px; color: #179ab2;}\r\n    #dropmenu li a.campaign-sticky {margin: 0 5px; color: #179ab2;}\r\n    #dropmenu li a.onemillion-sticky {margin: 0 5px; color: #179ab2;}\r\n\r\n    /* STICKY HEADER */\r\n\r\n    .container-header-sticky {z-index: 999999; width: 100%; max-width: 1440px; margin: 0 auto; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n    .holder-header-sticky {width: 96%; margin: 0 auto;}\r\n    .s-header-logo {float: left; width: 300px; margin: 16px 0 0 0;}\r\n    .s-header-logo img {width: 100%;}\r\n    .s-topnav {float: left; margin: 26px 0 0 20px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n    .s-topnav a {text-decoration: none; margin: 0 20px 0 0;}\r\n    .s-topnav a:visited {text-decoration: none;}\r\n    .s-topnav a:hover {text-decoration: none;}\r\n    .s-header-donate {float: right; margin: 24px 0 0 0;}\r\n    .s-mobile-menubutton {display: none;}\r\n\r\n    /* SUBNAV */\r\n\r\n    .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n    .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n    .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .container-subnav ul li {margin: 0 30px; padding: 0; display: inline; font-size: 30px; text-transform: uppercase; font-weight: 500;}\r\n    .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n\r\n    /* FRONT - BLOCK - 3columns */\r\n\r\n    .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-3columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n    .front-holder-3columnquote {width: 56%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n    .front-column3-icon {margin: 20px 0;}\r\n    .front-column3-icon img {width: 80%; }\r\n    .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600;}\r\n\r\n\r\n    /* BLOCK - 4columns */\r\n    .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-4columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-4column {width: 20%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n    .front-column4-icon {margin: 20px 0;}\r\n    .front-column4-icon img {width: 60%; }\r\n\r\n    /* PRESS & NEWS COLUMNS */\r\n    .news-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .news-container-3columns { text-align: center; margin: 30px auto; }\r\n    .news-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top; background-color: #115e67; color: #ffffff;}\r\n    .news-contentblock {width:100%; margin: 0 auto; padding: 20px 20px; line-height: 1.5em;}\r\n    .news-snippet {width: 100%; text-align: left; display: inline-block; vertical-align: top; color: #ffffff;}\r\n    .news-column3-icon {margin: 20px 0;}\r\n    /* .news-column3-icon img {width: 100%; } */\r\n    .news-holder-3column img {width: 100%; margin: 0 auto;}\r\n    .news-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #ffffff; text-align: left; }\r\n\r\n\r\n    /* PARTNERSHIPS STYLES */\r\n    .program-bgimage {width: 40%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: bottom;}\r\n    .program-text {width:40%; text-align: center; display: inline-block; margin: 7% 0; vertical-align: top;}\r\n    .program-text img {margin: 20px auto;}\r\n\r\n    .program-2columns-bgimage {width: 40%; float: left; text-align: center; display: inline-block; margin: 0 auto; vertical-align: middle;}\r\n    .program-2columns-bgimage img {width:85%; max-width: 500px; margin: 0 auto;}\r\n    .program-2columns-text {width:40%; float: right; text-align: center; display: inline-block; margin: 7% 6%; vertical-align: top;}\r\n    .program-text img {margin: 20px auto;}\r\n\r\n    .partner-social {margin: 20px 0 0 0;}\r\n    .partner-social a {margin: 0 20px;}\r\n\r\n    .partner-logo {margin: 40px 0;}\r\n\r\n    /* CONTENT */\r\n\r\n    .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .content-story-column {width: 80%; text-align: left; margin:0 auto;}\r\n\r\n    .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 60%; margin: 100px auto; text-align: center;}\r\n    .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n    .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n    .container-contentblock-news {width: 100%; margin: 30px auto 0; text-align: center;}\r\n\r\n    .pretextimage {float: right; margin: 0 0 30px 30px; width: 25%;}\r\n    .pretextimage img {width: 35%;} /*JC was 90*/\r\n\r\n    .wrapper-contentblock-white img {width: 100%;}\r\n\r\n    .blockcontent img {width: 60%;} /*JC*/\r\n    .blockcontent img.pretextimage {width: 20%;} /*JC*/\r\n\r\n    /* BLOCK - COLOR */\r\n\r\n    .wrapper-contentblock {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center;}\r\n    .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n    .wrapper-contentblock-beige-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n    .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n    .wrapper-contentblock-green-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n    .container-contentblock-beige, .container-contentblock-green, .container-contentblock, .container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n\r\n\r\n    /* BLOCK - 2cols offset with image */\r\n\r\n    .wrapper-2block-left {width: 100%; margin: 20px auto; }\r\n    .holder-2blockL-image {width: 45%; float: left;}\r\n    .holder-2blockL-image img {width: 100%;}\r\n    .holder-2blockL-content {width: 50%; float: right; text-align: left; height: auto; min-height: auto; vertical-align: middle; padding-top: 60px;}\r\n    .holder-2blockL-desc {padding: 0 30% 0 0; font-size: 18px; line-height: 30px;}\r\n\r\n    .wrapper-2block-right {width: 100%; margin: 100px auto; vertical-align: middle;}\r\n    .holder-2blockR-content {width: 50%; float: left; text-align: right; height: auto; min-height: auto; vertical-align: middle; padding-top: 60px;}\r\n    .holder-2blockR-image {width: 45%; float: right;}\r\n    .holder-2blockR-image img {width: 100%;}\r\n    .holder-2blockR-desc {padding: 0 0 0 30%; font-size: 18px; line-height: 30px;}\r\n\r\n    /* BLOCK - 2cols offset with Bio */\r\n\r\n    .wrapper-2block-leftbio {width: 90%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n    .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n    .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n    h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n    .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n    .holder-2block-desc {}\r\n\r\n    /* BLOCK - 3columns */\r\n\r\n    .wrapper-3columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-3columns { text-align: center; margin: 0 auto; }\r\n    .holder-3column {width: 30%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n    .column3-icon {margin: 20px 0;}\r\n    .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 180px;}\r\n\r\n    .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n    /* BLOCK - 2columns */\r\n\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; /* background-color: #fff;*/ text-align: center;}\r\n    .container-2columns { text-align: center; margin: 0 auto; }\r\n    .holder-2column {width: 35%; text-align: center; display: inline-block; margin: 0 4%; vertical-align: top;}\r\n    .column2-icon {}\r\n    .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n    /* RESOURCES NEW */\r\n\r\n    SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 400px; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n    .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n    .holder-block-resourcesnewText {position: absolute; top: 50%; height: 30%; margin: -15% 0 0 0;}\r\n    .adjustTop1 {top: 50%; height: 50%; margin: -25% 0 0 0;}\r\n\r\n    .holder-block-resourcesnewTitleRight {float: right; width: 48%; display: block; min-height: 400px; position: relative; margin-right: 1%;}\r\n    .holder-block-resourcesnewContentLeft {float: left; width: 48%; display: block;  min-height: 400px;}\r\n\r\n    .holder-block-resourcesnewTitleLeft {float: left; width: 48%; display: block;  min-height: 400px; position: relative;}\r\n    .holder-block-resourcesnewContentRight {float: right; width: 48%; display: block;  min-height: 400px;}\r\n\r\n    /* BLOCK - 2columns White + Gray */\r\n\r\n    .graybg {background-color: #f4f1ed;}\r\n    .textleft {text-align: left;}\r\n    .textright {text-align: right;}\r\n    .whitebg {padding: 0px 50px;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 */\r\n    .wrapper-2columns {width: 100%; margin: 20px auto; text-align: center;}\r\n    /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n    .content-2columns-twothird-left {width:50%; float: left; margin: 20px auto; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-twothird-right {width:50%; float: right; margin: 20px auto; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-left {width:28%; float: left; margin: 20px auto; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-right {width:28%; float: right; margin: 20px auto; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 IMAGES */\r\n    .wrapper-2columns {width: 100%; margin: 20px auto; text-align: center;}\r\n    /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n    .content-2columns-twothird-left-images {width:66%; float: left; margin: 0; text-align: left;}\r\n    .content-2columns-twothird-left-images img {width:100%; display: inline-block;}\r\n    .content-2columns-twothird-right-images {width:66%; float: right; margin: 0; text-align: left;}\r\n    .content-2columns-twothird-right-images img {width:100%; display: inline-block;}\r\n    .content-2columns-onethird-left-images {width:33%; float: left; margin: 0; text-align: center;}\r\n    .content-2columns-onethird-right-images {width:33%; float: right; margin: 0; text-align: center;}\r\n    .content-2columns-onethird-right-images img {width:100%; display: inline-block;}\r\n\r\n    /* BLOCK - 2columns 1/2 1/2 */\r\n    .content-2columns-onehalf-left {width:48%; float: left; text-align: left; display: inline-block;}\r\n    .content-2columns-onehalf-right {width: 48%; float: right; text-align: left; display: inline-block;}\r\n    .content-2columns-onehalf-left img, .content-2columns-onehalf-right img {width: 100%; margin-bottom:0px;}\r\n    .content-2columns-onehalf-left p, .content-2columns-onehalf-right p {margin-top: -2px;}\r\n\r\n\r\n    /* BLOCK - 2columns <ul> <li> list */\r\n\r\n    .container-column2-list {width: 100%; margin: 60px auto;}\r\n    .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n    .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n    /* BLOCK - circles */\r\n\r\n    .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055; line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#075055; line-height:80px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#075055; line-height:70px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n\r\n    /* BLOCK  - Donate */\r\n\r\n    .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n    .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n    .container-contentblock-donate {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n    .container-contentblock-donate-orange {width: 60%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n    .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n    a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 40%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 40%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n    /* FOOTER */\r\n\r\n    .wrapper-footer {z-index: 99999999; width: 100%; position: absolute;}\r\n    .container-footer {z-index: 99999999; width: 90%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n    .footer-holder {z-index: 9999999999; width: 48%; display: inline-block; vertical-align: top;}\r\n    .footer-navL {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n    .footer-navR {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n    .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links {z-index: 9999999999; margin: 0 0 0 0;}\r\n    .footer-links ul {list-style-type: none; margin: 20px 0 0 0; padding: 0;}\r\n    .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n    .footer-social {margin: 50px 0 0 0;}\r\n    .footer-social a {margin: 0 20px;}\r\n\r\n    .copyright {font-size: 10px; margin: 100px 300px 100px 0; font-weight: 300; text-align: right;}\r\n\r\n    .footer-airplane {z-index: 999; position: absolute; margin: 0px 0 0 -200px; text-align: left;}\r\n\r\n    .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n    .footer-dot-blue80 {margin: 0 0 0 -20px;}\r\n    .footer-dot-green60 {margin: 160px 0 0 60px;}\r\n    .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n    .footer-dot-blue60 {float: right; margin: -200px 60px 0 0;}\r\n    .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n    /* NEWS */\r\n\r\n    .wrapper-news-title {margin: 140px auto 0 auto; width: 90%; }\r\n    .holder-news-title {width: 49%; text-align: center; display: inline-block;}\r\n\r\n    .wrapper-news-block {margin: 0 auto; width: 90%;}\r\n    .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px 5%;}\r\n    .holder-news-image1 {width: 48%; float: left;}\r\n    .holder-news-image1 img {width: 100%;}\r\n    .holder-news-righttitle {width: 47%; float: right; text-align: left;}\r\n\r\n    h1.news-title {color: #075055; font-size: 42px; margin: 0px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 54px; width: 100%;font-weight: 900;}\r\n    .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n    .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n    .wrapper-news-content {width: 60%; margin: 60px auto;}\r\n    .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n    h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n    .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n    .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px; min-height: 400px; vertical-align: top;}\r\n    .morestory-image {width: 100%;}\r\n    .morestory-image img {width: 100%;}\r\n    .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n    .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n    .morestory-text p {color: #fff;}\r\n    .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n    .morestory-link a {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n    .holder-media-left {width: 60%; float: left; text-align: center;}\r\n    .holder-contact-right {width: 35%; float: right; text-align: center;}\r\n\r\n    .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n    .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n    .holder-newslisting-image1 {width: 35%; float: left;}\r\n    .holder-newslisting-image1 img {width: 100%;}\r\n    .holder-newslisting-righttitle {width: 60%; float: right; text-align: left;}\r\n\r\n    h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n    .newslisting-type {/*background-color: #b5b1ac;*/ font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; /*padding: 10px;*/ max-width: 200px; text-align: left; margin: 20px 0;}\r\n\r\n    /* OFFER STYLES */\r\n\r\n    h3.subheading-offer {color: #075055; font-size: 20px; font-weight: 900; text-transform: none; text-align: left; margin: -40px 0 40px 0 !important;}\r\n\r\n    .holder-form {width: 70%; display: inline-block; margin: 0; vertical-align: top;}\r\n\r\n    .form-row {margin: 0 0 0 0;}\r\n    .form-cellhalf {width: 95%; margin: 0 0 20px 0;}\r\n    .form-cellfour {display: inline-block; margin: 30px 0 0 0;}\r\n    .form-cellfull {width: 95%; margin: -25px 0 0 0;}\r\n    .form-text {width: 100%;}\r\n    .form-textfull {width: 100%;}\r\n\r\n\r\n  }\r\n\r\n  @media screen and (min-width: 1024px) and (max-width: 1200px) {\r\n\r\n    /*h1 {font-size: 48px; text-transform: uppercase; line-height: 54px;}*/\r\n    /*h2 {font-size: 36px; text-transform: uppercase; line-height: 45px;}*/\r\n    /*h3 {font-size: 30px; text-transform: uppercase; line-height: 40px; text-align: center;}*/\r\n    /*h4 {font-size: 24px; text-transform: uppercase; line-height: 36px;}*/\r\n    /* h5 {font-size: 21px; text-transform: uppercase; line-height: 28px;} */\r\n\r\n    .mobile-menubutton, .m-wrapper-sectionpic {display: none;}\r\n    .blockcontent-orange {font-size: 20px; color: #fbb03b; font-weight: 400; line-height: 28px;}\r\n    h3 {font-size: 30px; text-transform: uppercase; line-height: 40px; text-align: center; margin: 0 auto; /*padding-left: 35%;*/}\r\n    p.intro {font-size: 20px; font-weight: 500; line-height: 36px; text-align: left;}\r\n    .narrowwidth {width: 48% !important;}\r\n    .hidedesktop {display: none;}\r\n\r\n    /* FRONT 2019 */\r\n\r\n    .front-picholder {width: 45%; float: right;}\r\n    .front-picholder img {width: 100%;}\r\n    .front-pictext {width: 50%; text-align: left !important;}\r\n    .front-pictext-right {width: 50%; text-align: left !important; float:right !important;}\r\n    .front-picholder-left {width: 45%; float: left;}\r\n    .front-picholder-left img {width: 100%;}\r\n\r\n    .front-3column-holder {width: 25%; max-width: 305px; display: inline-block; text-align: center; margin: 0 2%; vertical-align: top; background-color: #fff;}\r\n    .front-3column-pic {width: 100%;}\r\n    .front-3column-pic img {width: 100%;}\r\n    .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n    .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n    .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n    .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n    .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n    .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n    /* Header Section 2 */\r\n    .wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: inherit; margin: 0 auto;}\r\n    .container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n    /* Simple Section 2 */\r\n    .simple-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n    .simple-sect2-descright {float: right; text-align: center; width: 35%; color: #fff; font-size: 22px; line-height:30px;}\r\n    .simple-sect2-descleft {float: left; text-align: left; width: 60%; color: #fff; font-size: 22px; line-height: 30px;}\r\n    .simple-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .simple-sect2-button {margin: 40px 0 0 0;}\r\n    .simple-front-sect2-circle {width: 100% !important; text-align: center; margin: -60px auto 0 auto !important;}\r\n    .simple-front-sect2-circle img {width:60% !important; max-width: 180px;}\r\n\r\n    /* Simple Section 5 */\r\n    .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #f4f2f3; margin: 0 auto; }\r\n    .simple-container-sect5 {width: 95%; margin: 0 auto; padding: 60px 0 40px 0; text-align: center;}\r\n    .simple-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .simple-sect5-button {margin: 50px 0;}\r\n    .simple-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .simple-sect5-child img {width: 100%;}\r\n    .simple-sect5-child-circle {display: none;}\r\n\r\n\r\n    /* VFV */\r\n\r\n    .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n    .vfv-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vfv-sect2-brandingmark {float: left; width: 50%; text-align: center; padding-top: 10px;}\r\n    .vfv-sect2-brandingmark img {width:98%;}\r\n    .vfv-sect2-desc {float: right; text-align: center; width: 45%;}\r\n    .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .vfv-sect2-button {margin: 40px 0 0 0;}\r\n    .vfv-front-sect2-arrow {width: 100%; text-align: center; max-width: 1200px;}\r\n\r\n    .vfv-videoslate {margin: 30px auto; border: 20px #e5ebf6 solid;  width: 100%;}\r\n\r\n    /* OMM */\r\n\r\n    .omm-faq-m {display: none;}\r\n\r\n    .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n    .omm-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .omm-sect2-brandingmark {float: left; width: 50%; text-align: center; padding-top: 10px;}\r\n    .omm-sect2-brandingmark img {width: 98%;}\r\n    .omm-sect2-desc {float: right; text-align: center; width: 45%;}\r\n    .omm-sect2-text {font-size: 24px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-button {margin: 40px 0 0 0;}\r\n    .omm-front-sect2-arrow {width: 100%; text-align: center; max-width: 1200px;}\r\n\r\n    .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n    .vp2020-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vp2020-sect2-brandingmark {float: left; width: 45%; text-align: center; padding-left: 5%; }\r\n    .vp2020-sect2-brandingmark img {max-width:300px; }\r\n    .vp2020-sect2-desc {float: right; text-align: center; width: 45%;}\r\n    .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .vp2020-sect2-button {margin: 40px 0 0 0;}\r\n    .vp2020-front-sect2-arrow {width: 100%; text-align: center;}\r\n\r\n    .omm-donate-brandingmark {width: 40%; margin: 0 auto; text-align: center; padding: 40px 0;}\r\n    .omm-donate-brandingmark img {width: 100%;}\r\n\r\n    .omm-sect2-donatetext {float: left; width: 100%; text-align: center; font-size: 30px; color: #fff; font-weight: 800; line-height: 30px;}\r\n    .omm-sect2-donateembed {float: right; text-align: center; width: 35%;}\r\n\r\n    .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto; }\r\n    .omm-container-sect5 {width: 95%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n    .omm-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .omm-sect5-button {margin: 50px 0;}\r\n    .omm-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .omm-sect5-child img {width: 100%;}\r\n    .omm-sect5-child-circle {display: none;}\r\n\r\n    .omm-videoslate {margin: 30px auto; border: 20px #fbb03b solid;  width: 100%;}\r\n\r\n    .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n    .omm-container-orange {width: 60%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;} /*JC changed width to 60*/\r\n\r\n    .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n    .omm-container-blue {width: 100%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n    .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700;}\r\n    .omm-greatnews-stat {margin: 30px 0 0 0;}\r\n    .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; float: left; text-align: right; width: 40%; vertical-align: top; margin: 40px 0 0 0;}\r\n    .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; float: right; text-align: left; text-transform: uppercase; width: 55%; vertical-align: top; line-height: 50px;}\r\n\r\n    .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n    .omm-checkout-brandingmark {width: 50%; margin: 0 auto;}\r\n    .omm-checkout-brandingmark img {width:90%;}\r\n\r\n    .omm-container-checkout {width: 90%; margin: 50px auto;}\r\n    .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n    .omm-thankyou-brandingmark {width: 70%; margin: 0 0 0 -30px;}\r\n    .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n    .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .omm-container-faq {width: 70%; margin: 50px auto;}\r\n    .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n    a.omm-orangeB {font-size: 20px; color: #fff; text-transform: uppercase; background-color: #e5801a; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border: 4px solid #f7931e; border-radius: 20px 20px 20px 20px; }\r\n    a:visited.omm-orangeB {color: #fff; text-decoration: none;}\r\n    a:hover.omm-orangeB {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\n    /* HEADER */\r\n\r\n    .wrapper-header-welcome, .wrapper-header-testing, .wrapper-header-form-embed, .wrapper-header-kvfl-events, .wrapper-header-kvfl-events-scheduler {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-onemillion {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-donate.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n    .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n    .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-faq.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n    .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-onemillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n    .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-help-a-child {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-help-a-child.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-see-kids-soar-eoa, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-grants-for-good-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-grantsforgoodsight.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day, .wrapper-header-cltl-day-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapaper-header-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-golfthankyou {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-golfthankyou.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-impact-report {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-impactreport.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    /* PARTNERSHIPS HEADER IMAGES */\r\n    .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    /* STORY HEADER IMAGE */\r\n    .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .container-header {z-index: 9999999999; width: 90%; max-width: 1000px; margin: 0 auto;}\r\n\r\n    .header-logo {float: left; width: 150px; margin: 20px 0 0 0;}\r\n    .header-logo img {width: 100%;}\r\n    .topnav {float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 50px; font-weight: 600;}\r\n    .topnav a {text-decoration: none; margin: 0 19px 0 0;} /*JC*/\r\n    .topnav a:visited {text-decoration: none;}\r\n    .topnav a:hover {text-decoration: none;}\r\n\r\n    .header-donate {z-index: 99999999; float: right; margin: 20px 0 0 0;}\r\n\r\n    .header-sectiontext-wide {position: absolute; margin: 210px 0 0 4%; color: #fff; height: 400px; display: table; width: 550px;}\r\n    .header-sectiontext {position: absolute; margin: 150px 0 0 5%; color: #fff; height: 400px; display: table; width: 550px;}\r\n    .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n    .sectiontext-headline {font-size: 62px; text-transform: uppercase; font-weight: 600; line-height: 62px; width: 100%;}\r\n    .sectiontext-headlinethin {font-size: 62px; text-transform: uppercase; font-weight: 300;}\r\n\r\n    .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 40px 0 0 0; line-height: 30px; width: 80%;}\r\n    .sectiontext-desc-large {font-size: 24px; font-weight: 400; margin: 40px 0 0 0; line-height: 32px; width: 80%;}\r\n\r\n\r\n    .topnav-dropdown {text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 0 0 0 150px;}\r\n    .topnav-dropdown-sticky {text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 0 0 0 100px;}\r\n\r\n    #dropmenu li a.about {margin: 0 0px;}\r\n    #dropmenu li a.stories {margin: 0 0px;}\r\n    #dropmenu li a.involved {margin: 0 0px;}\r\n    #dropmenu li a.resources {margin: 0 0px;}\r\n    #dropmenu li a.campaign {margin: 0 0px;}\r\n    #dropmenu li a.onemillion {margin: 0 0px;}\r\n\r\n    #dropmenu li a.about-sticky {margin: 0 0px; color: #179ab2;}\r\n    #dropmenu li a.stories-sticky {margin: 0 0px; color: #179ab2;}\r\n    #dropmenu li a.involved-sticky {margin: 0 0px; color: #179ab2;}\r\n    #dropmenu li a.resources-sticky {margin: 0 0px; color: #179ab2;}\r\n    #dropmenu li a.campaign-sticky {margin: 0 0px; color: #179ab2;}\r\n    #dropmenu li a.onemillion-sticky {margin: 0 0px; color: #179ab2;}\r\n\r\n    /* STICKY HEADER */\r\n\r\n    .container-header-sticky {z-index: 999999; width: 100%; max-width: 1440px; margin: 0 auto; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n    .holder-header-sticky {width: 100%; margin: 0 auto;}\r\n    .s-header-logo {float: left; width: 240px; margin: 20px 0 0 10px;}\r\n    .s-header-logo img {width: 100%;}\r\n    .s-topnav {float: left; margin: 26px 0 0 20px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n    .s-topnav a {text-decoration: none; margin: 0 20px 0 0;}\r\n    .s-topnav a:visited {text-decoration: none;}\r\n    .s-topnav a:hover {text-decoration: none;}\r\n    .s-header-donate {float: right; margin: 24px 0 0 0;}\r\n    .s-mobile-menubutton {display: none;}\r\n\r\n\r\n\r\n\r\n\r\n    .header-airplane {z-index: 999; position: absolute; margin: 50px 0 0 -160px;}\r\n    .header-dots {z-index: 999; margin: -10px -220px 0 0; float: right;}\r\n    .header-dots img {width: 100px;}\r\n\r\n\r\n    /* SUBNAV */\r\n\r\n    .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n    .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n    .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .container-subnav ul li {margin: 0 30px; padding: 0; display: inline; font-size: 30px; text-transform: uppercase; font-weight: 500;}\r\n    .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n\r\n    /* FRONT - BLOCK - 3columns */\r\n\r\n    .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-3columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n    .front-holder-3columnquote {width: 56%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n    .front-column3-icon {margin: 20px 0;}\r\n    .front-column3-icon img {width: 80%; }\r\n    .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #229cb4; }\r\n\r\n    .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-4columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-4column {width: 20%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n    .front-column4-icon {margin: 20px 0;}\r\n    .front-column4-icon img {width: 60%; }\r\n\r\n\r\n    /* PRESS & NEWS COLUMNS */\r\n    .news-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .news-container-3columns { text-align: center; margin: 30px auto; }\r\n    .news-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top; background-color: #115e67; color: #ffffff;}\r\n    .news-contentblock {width:100%; margin: 0 auto; padding: 20px 20px; line-height: 1.5em;}\r\n    .news-snippet {width: 100%; text-align: left; display: inline-block; vertical-align: top; color: #ffffff;}\r\n    .news-column3-icon {margin: 20px 0;}\r\n    /* .news-column3-icon img {width: 100%; } */\r\n    .news-holder-3column img {width: 100%; margin: 0 auto;}\r\n    .news-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #ffffff; text-align: left; }\r\n\r\n    /* PARTNERSHIPS STYLES */\r\n    .program-bgimage {z-index: 1; width: 100%; position: relative; text-align: center; display: inline-block; margin: 0 2%; vertical-align: bottom; opacity: 0.15; filter: alpha(opacity=15);}\r\n    .program-text {z-index: 5; width:70%; position: relative; text-align: center; display: inline-block; margin: -400px 0 0 15%; vertical-align: top;}\r\n    .program-text img {margin: 20px auto;}\r\n\r\n    .partner-social {margin: 20px 0 0 0;}\r\n    .partner-social a {margin: 0 10px;}\r\n\r\n    .partner-logo {margin: 40px 0;}\r\n    .partner-logo img {width: 80%;}\r\n\r\n    /* CONTENT */\r\n\r\n    .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n\r\n    .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 80%; margin: 100px auto; text-align: center;}\r\n    .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n    .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .pretextimage {float: right; margin: 0 0 30px 30px; width: 25%;}\r\n    .pretextimage img {width: 30%;} /*JC was 90*/\r\n\r\n    .blockcontent img {width: 60%;} /*JC*/\r\n    .blockcontent img.pretextimage {width: 20%;} /*JC*/\r\n\r\n    /* RESOURCES NEW */\r\n\r\n    SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 400px; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n    .graybg {background-color: #f4f1ed;}\r\n    .textleft {text-align: left;}\r\n    .textright {text-align: right;}\r\n    .whitebg {padding: 0px 50px;}\r\n\r\n    .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n    .holder-block-resourcesnewText {position: absolute; top: 50%; height: 30%; margin: -15% 0 0 0;}\r\n    .adjustTop1 {top: 50%; height: 50%; margin: -25% 0 0 0;}\r\n    .adjustTop2 {margin: -35% 0 0 0;}\r\n\r\n    .holder-block-resourcesnewTitleRight {float: right; width: 48%; display: block; min-height: 400px; position: relative; margin-right: 1%;}\r\n    .holder-block-resourcesnewContentLeft {float: left; width: 48%; display: block;  min-height: 400px;}\r\n\r\n    .holder-block-resourcesnewTitleLeft {float: left; width: 48%; display: block;  min-height: 400px; position: relative;}\r\n    .holder-block-resourcesnewContentRight {float: right; width: 48%; display: block;  min-height: 400px;}\r\n\r\n    /* BLOCK - BEIGE */\r\n\r\n    .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n    .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n    .wrapper-contentblock-green-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n    .container-contentblock-beige, .container-contentblock-green, .container-contentblock, .container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n\r\n    /* BLOCK - 2cols offset with image */\r\n\r\n    .wrapper-2block-left {width: 100%; margin: 20px auto; }\r\n    .holder-2blockL-image {width: 45%; float: left;}\r\n    .holder-2blockL-image img {width: 100%;}\r\n    .holder-2blockL-content {width: 50%; float: right; text-align: left; height: auto; min-height: auto; vertical-align: middle; padding-top: 60px;}\r\n    .holder-2blockL-desc {padding: 0 30% 0 0; font-size: 18px; line-height: 30px;}\r\n\r\n    .wrapper-2block-right {width: 100%; margin: 100px auto; vertical-align: middle;}\r\n    .holder-2blockR-content {width: 50%; float: left; text-align: right; height: auto; min-height: auto; vertical-align: middle; padding-top: 60px;}\r\n    .holder-2blockR-image {width: 45%; float: right;}\r\n    .holder-2blockR-image img {width: 100%;}\r\n    .holder-2blockR-desc {padding: 0 0 0 30%; font-size: 18px; line-height: 30px;}\r\n\r\n    /* BLOCK - 2cols offset with Bio */\r\n\r\n    .wrapper-2block-leftbio {width: 90%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n    .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n    .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n    h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n    .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n    .holder-2block-desc {}\r\n\r\n    /* BLOCK - 3columns */\r\n\r\n    .wrapper-3columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-3columns { text-align: center; margin: 0 auto; }\r\n    .holder-3column {width: 30%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n    .column3-icon {}\r\n    .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 180px;}\r\n\r\n    .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n    /* BLOCK - 2columns */\r\n\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-2columns { text-align: center; margin: 0 auto; }\r\n    .holder-2column {width: 35%; text-align: center; display: inline-block; margin: 0 4%; vertical-align: top;}\r\n    .column2-icon {}\r\n    .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 */\r\n    .wrapper-2columns {}\r\n    /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n    .content-2columns-twothird-left {width:50%; float: left; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-twothird-right {width:50%; float: right; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-left {width:28%; float: left; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-right {width:28%; float: right; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 IMAGES */\r\n    .wrapper-2columns {width: 100%; margin: 20px auto; text-align: center;}\r\n    /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n    .content-2columns-twothird-left-images {width:66%; float: left; margin: 0; text-align: left;}\r\n    .content-2columns-twothird-left-images img {width:100%; display: inline-block;}\r\n    .content-2columns-twothird-right-images {width:66%; float: right; margin: 0; text-align: left;}\r\n    .content-2columns-twothird-right-images img {width:100%; display: inline-block;}\r\n    .content-2columns-onethird-left-images {width:33%; float: left; margin: 0; text-align: center;}\r\n    .content-2columns-onethird-right-images {width:33%; float: right; margin: 0; text-align: center;}\r\n    .content-2columns-onethird-right-images img {width:100%; display: inline-block;}\r\n\r\n    /* BLOCK - 2columns <ul> <li> list */\r\n\r\n    .container-column2-list {width: 100%; margin: 60px auto;}\r\n    .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n    .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n    /* BLOCK - circles */\r\n\r\n    .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055; line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#075055; line-height:80px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#075055; line-height:70px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n\r\n    /* BLOCK  - Donate */\r\n\r\n    .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n    .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n    .container-contentblock-donate {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n    .container-contentblock-donate-orange {width: 60%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n    .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n    a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 40%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 40%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n    /* FOOTER */\r\n\r\n    .wrapper-footer {z-index: 99999999; width: 100%; position: absolute;}\r\n    .container-footer {z-index: 99999999; width: 90%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n    .footer-holder {z-index: 9999999999; width: 48%; display: inline-block; vertical-align: top;}\r\n    .footer-navL {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n    .footer-navR {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n    .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links {z-index: 9999999999; margin: 0 0 0 0;}\r\n    .footer-links ul {list-style-type: none; margin: 20px 0 0 0; padding: 0;}\r\n    .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n    .footer-social {margin: 50px 0 0 0;}\r\n    .footer-social a {margin: 0 20px;}\r\n\r\n    .copyright {font-size: 10px; margin: 100px 300px 100px 0; font-weight: 300; text-align: right;}\r\n\r\n    .footer-airplane {z-index: 999; position: absolute; margin: 0px 0 0 -450px; text-align: left;}\r\n\r\n    .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n    .footer-dot-blue80 {margin: 0 0 0 -20px;}\r\n    .footer-dot-green60 {margin: 160px 0 0 60px;}\r\n    .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n    .footer-dot-blue60 {float: right; margin: -200px 60px 0 0;}\r\n    .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n    /* NEWS */\r\n\r\n    .wrapper-news-title {margin: 50px auto 0 auto; width: 90%; }\r\n    .holder-news-title {width: 49%; text-align: center; display: inline-block;}\r\n\r\n    h1.titlenews {font-size: 46px !important;}\r\n\r\n    .wrapper-news-block {margin: 0 auto; width: 90%;}\r\n    .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px 5%;}\r\n    .holder-news-image1 {width: 48%; float: left;}\r\n    .holder-news-image1 img {width: 100%;}\r\n    .holder-news-righttitle {width: 47%; float: right; text-align: left;}\r\n\r\n    h1.news-title {color: #075055; font-size: 36px; margin: 0px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 40px; width: 100%;font-weight: 900;}\r\n    .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n    .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n    .wrapper-news-content {width: 60%; margin: 60px auto;}\r\n    .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n    h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n    .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n    .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px; min-height: 400px; vertical-align: top;}\r\n    .morestory-image {width: 100%;}\r\n    .morestory-image img {width: 100%;}\r\n    .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n    .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n    .morestory-text p {color: #fff;}\r\n    .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n    .morestory-link a {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n    .holder-media-left {width: 60%; float: left; text-align: center;}\r\n    .holder-contact-right {width: 35%; float: right; text-align: center;}\r\n\r\n    .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n    .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n    .holder-newslisting-image1 {width: 35%; float: left;}\r\n    .holder-newslisting-image1 img {width: 100%;}\r\n    .holder-newslisting-righttitle {width: 60%; float: right; text-align: left;}\r\n\r\n    h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n    .newslisting-type {background-color: #075055; font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 8px 30px; width: 200px; text-align: center; margin: 20px 0;}\r\n\r\n    .holder-form {width: 45%; display: inline-block; margin: 0; vertical-align: top;}\r\n\r\n    .form-row {margin: 0 0 0 0;}\r\n    .form-cellhalf {width: 95%; margin: 0 0 20px 0;}\r\n    .form-cellfour {margin: 20px 0 0 0;}\r\n    .form-cellfull {width: 95%; margin: -25px 0 0 0;}\r\n    .form-text {width: 100%;}\r\n    .form-textfull {width: 100%;}\r\n\r\n  }\r\n\r\n  @media screen and (min-width: 768px) and (max-width: 1023px) {\r\n\r\n    @media screen and (min-width: 768px) and (max-width: 1023px) {\r\n\r\n      .mobile-menubutton {float: right; margin: 20px  0 0;}\r\n      .blockcontent-orange {font-size: 20px; color: #fbb03b; font-weight: 400; line-height: 28px;}\r\n      h3 {font-size: 30px; text-transform: uppercase; line-height: 40px; text-align: center; margin: 0 auto; /* padding-left: 35%;*/}\r\n      p.intro {font-size: 20px; font-weight: 500; line-height: 36px; text-align: left;}\r\n      .centered-button {display: inline-block; width: 90%; margin:0 auto;}\r\n      .narrowwidth {width: 55% !important;}\r\n      .hidedesktop {display: block;}\r\n\r\n      /* FRONT 2019 */\r\n\r\n      .front-picholder {width: 45%; float: right;}\r\n      .front-picholder img {width: 100%;}\r\n      .front-pictext {width: 50%; text-align: left !important; margin-left:25px !important;}\r\n      .front-pictext-right {width: 50%; text-align: left !important; float:right !important;}\r\n      .front-picholder-left {width: 45%; float: left;}\r\n      .front-picholder-left img {width: 100%;}\r\n\r\n      .front-3column-holder {width: 60%; display: inline-block; text-align: center; margin: 0 auto 40px auto; vertical-align: top; background-color: #fff;}\r\n      .front-3column-pic {width: 100%;}\r\n      .front-3column-pic img {width: 100%;}\r\n      .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n      .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n      .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n      .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n      .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n      .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n      .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n      .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n      .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n      .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n      /* Header Section 2 */\r\n      .wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: inherit; margin: 0 auto;}\r\n      .container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 20px 0 80px 0;}\r\n\r\n      /* Simple Section 2 */\r\n      .simple-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n      .simple-sect2-descright {float: right; text-align: center; width: 35%; color: #fff; font-size: 22px; line-height:30px;}\r\n      .simple-sect2-descleft {float: left; text-align: left; width: 60%; color: #fff; font-size: 22px; line-height: 30px;}\r\n      .simple-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n      .simple-sect2-button {margin: 40px 0 0 0;}\r\n      .simple-front-sect2-circle {width: 100% !important; text-align: center; margin: -60px auto 0 auto !important;}\r\n      .simple-front-sect2-circle img {width:60% !important; max-width: 180px;}\r\n\r\n\r\n      /* Simple Section 5 */\r\n      .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #f4f2f3; margin: 0 auto; }\r\n      .simple-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n      .simple-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n      .simple-sect5-button {margin: 50px 0;}\r\n      /* .simple-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;} */\r\n      .simple-sect5-child {display: none;}\r\n      .simple-sect5-child img {width: 80%; margin:0 auto;}\r\n      .simple-sect5-child-circle {display: block; margin: 0 auto;}\r\n\r\n\r\n      /* VFV */\r\n\r\n      .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n      .vfv-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n      .vfv-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n      .vfv-sect2-brandingmark img {width:60%;}\r\n      .vfv-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n      .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n      .vfv-sect2-button {margin: 40px 0 0 0;}\r\n      .vfv-front-sect2-arrow {width: 100%; text-align: center; max-width: 1023px;}\r\n\r\n      .vfv-videoslate {margin: 30px auto; border: 20px #e5ebf6 solid;  width: 100%;}\r\n\r\n      /* OMM */\r\n\r\n      .omm-faq-m {display: none;}\r\n\r\n      .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n      .omm-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n      .omm-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n      .omm-sect2-brandingmark img {width: 60%;}\r\n      .omm-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n      .omm-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n      .omm-sect2-button {margin: 40px 0 0 0;}\r\n      .omm-front-sect2-arrow {width: 100%; text-align: center; max-width: 1023px;}\r\n\r\n      .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n      .vp2020-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n      .vp2020-sect2-brandingmark {float: left; width: 45%; text-align: center; margin: 0 auto; }\r\n      .vp2020-sect2-brandingmark img {max-width:300px; }\r\n      .vp2020-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n      .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n      .vp2020-sect2-button {margin: 40px 0 0 0;}\r\n      .vp2020-front-sect2-arrow {width: 100%; text-align: center; max-width: 1023px;}\r\n\r\n      .omm-sect2-donatetext {float: left; width: 90%; text-align: left; font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n      .omm-sect2-donateembed {float: right; text-align: center; width: 45%;}\r\n\r\n      .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto; }\r\n      .omm-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n      .omm-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n      .omm-sect5-button {margin: 50px 0;}\r\n      .omm-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n      .omm-sect5-child img {width: 100%;}\r\n      .omm-sect5-child-circle {display: none;}\r\n\r\n      .omm-videoslate {margin: 30px auto; border: 20px #fbb03b solid;  width: 100%;}\r\n      img.omm-donate-mark {width: 70% !important;}\r\n\r\n      .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n      .omm-container-orange {width: 70%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n      .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n      .omm-container-blue {width: 100%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n      .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700;}\r\n      .omm-greatnews-stat {margin: 30px 0 0 0;}\r\n      .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; float: left; text-align: right; width: 40%; vertical-align: top; margin: 40px 0 0 0;}\r\n      .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; float: right; text-align: left; text-transform: uppercase; width: 55%; vertical-align: top; line-height: 50px;}\r\n\r\n      .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n      .omm-checkout-brandingmark {width: 50%; margin: 0 auto;}\r\n      .omm-checkout-brandingmark img {width:90%;}\r\n\r\n      .omm-container-checkout {width: 50%; margin: 50px auto;}\r\n      .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n      .omm-thankyou-mark {margin: -50px 0 0 30px !important;}\r\n      .omm-thankyou-brandingmark {width: 70%; margin: -100px 0 0 0px !important;}\r\n      .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n      .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n      .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n      .omm-container-faq {width: 70%; margin: 50px auto;}\r\n      .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n      a.omm-orangeB {font-size: 20px; color: #fff; text-transform: uppercase; background-color: #e5801a; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border: 4px solid #f7931e; border-radius: 20px 20px 20px 20px; }\r\n      a:visited.omm-orangeB {color: #fff; text-decoration: none;}\r\n      a:hover.omm-orangeB {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\n      .blockcontent-white2 {font-size: 20px; color: #fff; font-weight: 400; line-height: 32px;}\r\n\r\n      /* HEADER */\r\n\r\n      .wrapper-header-welcome, .wrapper-header-testing, .wrapper-header-form-embed, .wrapper-header-kvfl-events, .wrapper-header-kvfl-events-scheduler {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-bdayhome-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-onemillion {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m.png\") no-repeat top; margin: 0 auto; height: 600px; min-height: 600px;}\r\n      .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-m.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n      .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout-m.png\") no-repeat top; margin: 0 auto; height: 280px; min-height: 280px;}\r\n      .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-faq-m.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n      .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation-m.png\") no-repeat top; margin: 0 auto; height: 480px; min-height: 480px;}\r\n\r\n      .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 600px;}\r\n\r\n      .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 600px;}\r\n\r\n      .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-twomillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n      .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause-m.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n      .wrapper-header-help-a-child {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-m-help-a-child.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork-m.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n      .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons-m.jpg\") no-repeat top; margin: 0 auto; height: 506px; min-height: 500px;}\r\n      .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-grants-for-good-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-grantsforgoodsight-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-cltl-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-cltl-day-resources, .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 1024px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      .wrapper-header-golfthankyou {width: 100%; max-width: 1024px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-impact-report {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-impactreport-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      /* PARTNERSHIPS HEADER IMAGES */\r\n      .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      /* STORY HEADER IMAGE */\r\n      .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n\r\n      .container-header {z-index: 9999999999; width: 90%; max-width: 1000px; margin: 0 auto;}\r\n\r\n      .header-logo {float: left; width: 160px; margin: 20px 0 0 0;}\r\n      .header-logo img {width: 100%;}\r\n      .topnav {display: none; float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 80px; font-weight: 700;}\r\n      .topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n      .topnav a:visited {text-decoration: none;}\r\n      .topnav a:hover {text-decoration: none;}\r\n\r\n      .header-donate {display: none; z-index: 99999999; float: right; margin: 20px 0 0 0;}\r\n\r\n      .header-sectiontext-wide {position: absolute; margin: 150px 0 0 4%; color: #fff; height: 400px; display: table; width: 500px;}\r\n      .header-sectiontext {position: absolute; margin: 100px 0 0 5%; color: #fff; height: 400px; display: table; width: 500px;}\r\n      .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n      .sectiontext-headline {font-size: 48px; text-transform: uppercase; font-weight: 600; line-height: 48px; width: 100%;}\r\n      .sectiontext-headlinethin {font-size: 48px; text-transform: uppercase; font-weight: 300;}\r\n\r\n      .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 20px 0 0 0; line-height: 24px; width: 80%;}\r\n      .sectiontext-desc-large {font-size: 22px; font-weight: 400; margin: 20px 0 0 0; line-height: 28px; width: 80%;}\r\n\r\n      .header-airplane {z-index: 999; position: absolute; margin: 30px 0 0 -100px;}\r\n      .header-airplane img {width: 400px;}\r\n      .header-dots {display: none; z-index: 999; margin: -50px -20px 0 0; float: right; }\r\n\r\n      .topnav-dropdown {display: none;}\r\n      .topnav-dropdown-sticky {display: none;}\r\n\r\n      /* STICKY HEADER */\r\n\r\n      .container-header-sticky {z-index: 999999; width: 100%; max-width: 1440px; margin: 0 auto; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n      .holder-header-sticky {width: 100%; margin: 0 auto;}\r\n      .s-header-logo {float: left; width: 300px; margin: 16px 0 0 30px;}\r\n      .s-header-logo img {width: 100%;}\r\n      .s-topnav {display: none; float: left; margin: 26px 0 0 50px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n      .s-topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n      .s-topnav a:visited {text-decoration: none;}\r\n      .s-topnav a:hover {text-decoration: none;}\r\n      .s-header-donate {display: none; float: right; margin: 24px 0 0 0;}\r\n      .s-mobile-menubutton {float: right; margin: 20px 30px 0 0;}\r\n\r\n      /* SUBNAV */\r\n\r\n      .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n      .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n      .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n      .container-subnav ul li {margin: 0 30px; padding: 0; display: inline; font-size: 30px; text-transform: uppercase; font-weight: 500;}\r\n      .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n      .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n      .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n      /* RESOURCES NEW */\r\n\r\n      SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 400px; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n      .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n      .holder-block-resourcesnewText {}\r\n      .adjustTop1 {}\r\n      .adjustTop2 {}\r\n\r\n      .holder-block-resourcesnewTitleRight {width: 90%; text-align: center; margin: 0 auto;}\r\n      .holder-block-resourcesnewContentLeft {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n      .holder-block-resourcesnewTitleLeft {width: 90%; text-align: center; margin: 0 auto;}\r\n      .holder-block-resourcesnewContentRight {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n      /* FRONT - BLOCK - 3columns */\r\n\r\n      .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n      .front-container-3columns { text-align: center; margin: 30px auto; }\r\n      .front-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n      .front-column3-icon {margin: 20px 0;}\r\n      .front-column3-icon img {width: 80%; }\r\n      .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #229cb4; }\r\n\r\n      .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n      .front-container-4columns { text-align: center; margin: 30px auto; }\r\n      .front-holder-4column {width: 22%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n      .front-column4-icon {margin: 20px 0;}\r\n      .front-column4-icon img {width: 60%; }\r\n\r\n      /* PRESS & NEWS COLUMNS */\r\n      .news-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n      .news-container-3columns { text-align: center; margin: 30px auto; }\r\n      .news-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top; background-color: #115e67; color: #ffffff;}\r\n      .news-contentblock {width:100%; margin: 0 auto; padding: 20px 20px; line-height: 1.5em;}\r\n      .news-snippet {width: 100%; text-align: left; display: inline-block; vertical-align: top; color: #ffffff;}\r\n      .news-column3-icon {margin: 20px 0;}\r\n      /* .news-column3-icon img {width: 100%; } */\r\n      .news-holder-3column img {width: 100%; margin: 0 auto;}\r\n      .news-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #ffffff; text-align: left; }\r\n\r\n      /* PARTNERSHIPS STYLES */\r\n      .program-bgimage {z-index: 1; width: 100%; position: relative; text-align: center; display: inline-block; margin: 0 2%; vertical-align: bottom; opacity: 0.15; filter: alpha(opacity=15);}\r\n      .program-text {z-index: 5; width:70%; position: relative; text-align: center; display: inline-block; margin: -400px 0 0 15%; vertical-align: top;}\r\n      .program-text img {margin: 20px auto;}\r\n\r\n      .partner-social {margin: 20px 0 0 0;}\r\n      .partner-social a {margin: 0 10px;}\r\n\r\n      .partner-logo {margin: 40px 0;}\r\n      .partner-logo img {width: 80%;}\r\n\r\n\r\n      /* CONTENT */\r\n\r\n      .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n      .content-story-column {width: 80%; text-align: left; margin:0 auto;}\r\n      .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 80%; margin: 100px auto; text-align: center;}\r\n      .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n      .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n      .pretextimage {float: right; margin: 0 0 30px 30px; width: 25%;}\r\n      .pretextimage img {width: 35%;} /*JC was 90*/\r\n\r\n      .wrapper-contentblock-white img {width: 100%;}\r\n\r\n      .blockcontent img {width: 60%;} /*JC*/\r\n      .blockcontent img.pretextimage {width: 30%;} /*JC*/\r\n\r\n      /* BLOCK - COLOR */\r\n\r\n      .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n      .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n      .wrapper-contentblock-green-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n      .container-contentblock-beige, .container-contentblock-green, .container-contentblock, .container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n      .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n\r\n      /* BLOCK - 2cols offset with image */\r\n\r\n      .wrapper-2block-left {width: 100%; margin: 20px auto; }\r\n      .holder-2blockL-image {width: 45%; float: left;}\r\n      .holder-2blockL-image img {width: 100%;}\r\n      .holder-2blockL-content {width: 50%; float: right; text-align: left; height: auto; min-height: auto; vertical-align: middle; padding-top: 10px;}\r\n      .holder-2blockL-desc {padding: 0 5% 0 0; font-size: 18px; line-height: 30px;}\r\n\r\n      .wrapper-2block-right {width: 100%; margin: 100px auto; vertical-align: middle;}\r\n      .holder-2blockR-content {width: 50%; float: left; text-align: right; height: auto; min-height: auto; vertical-align: middle; padding-top: 10px;}\r\n      .holder-2blockR-image {width: 45%; float: right;}\r\n      .holder-2blockR-image img {width: 100%;}\r\n      .holder-2blockR-desc {padding: 0 0 0 5%; font-size: 18px; line-height: 30px;}\r\n\r\n      /* BLOCK - 2cols offset with Bio */\r\n\r\n      .wrapper-2block-leftbio {width: 90%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n      .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n      .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n      h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n      .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n      .holder-2block-desc {}\r\n\r\n      /* BLOCK - 3columns */\r\n\r\n      .wrapper-3columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n      .container-3columns { text-align: center; margin: 0 auto; }\r\n      .holder-3column {width: 30%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n      .column3-icon {}\r\n      .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n      .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 180px;}\r\n\r\n      .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n      /* BLOCK - 2columns */\r\n\r\n      .wrapper-2columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n      .container-2columns { text-align: center; margin: 0 auto; }\r\n      .holder-2column {width: 35%; text-align: center; display: inline-block; margin: 0 4%; vertical-align: top;}\r\n      .column2-icon {}\r\n      .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n      .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n      /* BLOCK - 2columns 1/3 2/3 */\r\n      .wrapper-2columns {width: 100%; margin: 20px auto; text-align: center;}\r\n      /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n      .content-2columns-twothird-left {width:50%; float: left; margin: 20px auto; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n      .content-2columns-twothird-right {width:50%; float: right; margin: 20px auto; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n      .content-2columns-onethird-left {width:28%; float: left; margin: 20px auto; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n      .content-2columns-onethird-right {width:28%; float: right; margin: 20px auto; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n\r\n\r\n      /* BLOCK - 2columns 1/3 2/3 IMAGES */\r\n      .wrapper-2columns {width: 100%; margin: 20px auto; text-align: center;}\r\n      /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n      .content-2columns-twothird-left-images {width:95%; margin: 0 auto; text-align: center;}\r\n      .content-2columns-twothird-left-images img {width:100%; display: inline-block;}\r\n      .content-2columns-twothird-right-images {width:95%; margin: 0 auto; text-align: center;}\r\n      .content-2columns-twothird-right-images img {width:100%; display: inline-block;}\r\n      .content-2columns-onethird-left-images {width:33%; float: left; margin: 0; text-align: center; display: none;}\r\n      .content-2columns-onethird-right-images {width:33%; float: right; margin: 0; text-align: center; display: none;}\r\n      .content-2columns-onethird-right-images img {width:100%; display: inline-block;}\r\n\r\n      /* BLOCK - 2columns <ul> <li> list */\r\n\r\n      .container-column2-list {width: 100%; margin: 60px auto;}\r\n      .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n      .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n      .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n      /* BLOCK - circles */\r\n\r\n      .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n      .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n      .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n      .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055;line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n      .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n      .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n      .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n      .circle-white-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#075055; line-height:80px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n      .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n      .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n      .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n      .circle-white-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#075055; line-height:70px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n\r\n      /* BLOCK  - Donate */\r\n\r\n      .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n      .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n      .container-contentblock-donate {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n      .container-contentblock-donate-orange {width: 60%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n      .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n      a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n      a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n      a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n      /* FOOTER */\r\n\r\n      .wrapper-footer {z-index: 99999999; width: 100%; position: absolute;}\r\n      .container-footer {z-index: 99999999; width: 90%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n      .footer-holder {z-index: 9999999999; width: 48%; display: inline-block; vertical-align: top;}\r\n      .footer-navL {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n      .footer-navR {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n      .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n      .footer-links {z-index: 9999999999; margin: 0 0 0 0;}\r\n      .footer-links ul {list-style-type: none; margin: 20px 0 0 0; padding: 0;}\r\n      .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n      .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n      .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n      .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n      .footer-social {margin: 50px 0 0 0;}\r\n      .footer-social a {margin: 0 20px;}\r\n\r\n      .copyright {font-size: 10px; margin: 160px 100px 100px 0; font-weight: 300; text-align: right;}\r\n\r\n      .footer-airplane {z-index: 999; position: absolute; margin: -100px 0 0 -250px; text-align: left;}\r\n\r\n      .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n      .footer-dot-blue80 {margin: 20px 0 0 -20px;}\r\n      .footer-dot-green60 {margin: 160px 0 0 10px;}\r\n      .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n      .footer-dot-blue60 {float: right; margin: -200px 40px 0 0;}\r\n      .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n      /* NEWS */\r\n\r\n      .wrapper-news-title {margin: 140px auto 0 auto; width: 90%; }\r\n      .holder-news-title {width: 49%; text-align: center; display: inline-block;}\r\n\r\n      h1.titlenews {font-size: 30px !important;}\r\n\r\n      .wrapper-news-block {margin: 0 auto; width: 90%;}\r\n      .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px 5%;}\r\n      .holder-news-image1 {width: 48%; float: left;}\r\n      .holder-news-image1 img {width: 100%;}\r\n      .holder-news-righttitle {width: 47%; float: right; text-align: left;}\r\n\r\n      h1.news-title {color: #075055; font-size: 36px; margin: 0px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 40px; width: 100%;font-weight: 900;}\r\n      .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n      .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n      .wrapper-news-content {width: 60%; margin: 60px auto;}\r\n      .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n      h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n      .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n      .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px; min-height: 400px; vertical-align: top;}\r\n      .morestory-image {width: 100%;}\r\n      .morestory-image img {width: 100%;}\r\n      .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n      .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n      .morestory-text p {color: #fff;}\r\n      .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n      .morestory-link a {color: #fff; text-decoration: underline;}\r\n      .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n      .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n      .holder-media-left {width: 60%; float: left; text-align: center;}\r\n      .holder-contact-right {width: 35%; float: right; text-align: center;}\r\n\r\n      .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n      .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n      .holder-newslisting-image1 {width: 35%; float: left;}\r\n      .holder-newslisting-image1 img {width: 100%;}\r\n      .holder-newslisting-righttitle {width: 60%; float: right; text-align: left;}\r\n\r\n      h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n      .newslisting-type {background-color: #075055; font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 8px 30px; width: 200px; text-align: center; margin: 20px 0;}\r\n\r\n      .holder-form {width: 65%; display: inline-block; margin: 0; vertical-align: top;}\r\n\r\n      .form-row {margin: 0 0 0 0;}\r\n      .form-cellhalf {width: 95%; margin: 0 0 20px 0;}\r\n      .form-cellfour {margin: 20px 0 0 0;}\r\n      .form-cellfull {width: 95%; margin: -25px 0 0 0;}\r\n      .form-text {width: 100%;}\r\n      .form-textfull {width: 100%;}\r\n\r\n    }\r\n\r\n    @media screen and (min-width: 768px) and (max-width: 1023px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {\r\n\r\n      .mobile-menubutton {float: right; margin: 20px  0 0;}\r\n      .blockcontent-orange {font-size: 20px; color: #fbb03b; font-weight: 400; line-height: 26px;}\r\n      .centered-button {display: inline-block; width: 90%; margin:0 auto; text-align: center;}\r\n\r\n      h3 {font-size: 30px; text-transform: uppercase; line-height: 40px; text-align: center; margin: 0 auto; /*padding-left: 35%;*/}\r\n      p.intro {font-size: 18px; font-weight: 500; line-height: 26px; text-align: left;}\r\n      .narrowwidth {width: 55% !important;}\r\n      .hidedesktop {display: block;}\r\n      .hidemobile {display: none !important;}\r\n\r\n      /* FRONT 2019 */\r\n\r\n      .front-picholder {width: 45%; float: right;}\r\n      .front-pictext {width: 50%; text-align: left !important; margin-left:25px !important;}\r\n      .front-pictext-right {width: 50%; text-align: left !important; float:right !important;}\r\n      .front-picholder-left {width: 45%; float: left;}\r\n\r\n      .front-3column-holder {width: 60%; display: inline-block; text-align: center; margin: 0 auto 40px auto; vertical-align: top; background-color: #fff;}\r\n      .front-3column-pic {width: 100%;}\r\n      .front-3column-pic img {width: 100%;}\r\n      .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n      .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n      .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n      .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n      .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n      .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n      .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n      .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n      .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n      .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n      /* Simple Section 2 */\r\n      .simple-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n      .simple-sect2-descright {text-align: center; width: 100%; color: #fff; font-size: 22px; line-height:30px;}\r\n      .simple-sect2-descleft { text-align: center; width: 100%; color: #fff; font-size: 22px; line-height: 30px;}\r\n      .simple-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n      .simple-sect2-button {margin: 40px 0 0 0;}\r\n      .simple-front-sect2-circle {width: 100% !important; text-align: center; margin: -60px auto 0 auto !important;}\r\n      .simple-front-sect2-circle img {width:60% !important; max-width: 180px;}\r\n\r\n      /* Simple Section 5 */\r\n      .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #f4f2f3; margin: 0 auto; }\r\n      .simple-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n      .simple-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n      .simple-sect5-button {margin: 50px 0;}\r\n      /* .simple-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;} */\r\n      .simple-sect5-child {display: none;}\r\n      .simple-sect5-child img {width: 80%; display:none;}\r\n      .simple-sect5-child-circle {display: block; width:80%}\r\n      .simple-sect5-child-circle img {width: 100%; margin: 0 auto;}\r\n\r\n\r\n      /* VFV */\r\n\r\n      .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n      .vfv-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n      .vfv-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto; }\r\n      .vfv-sect2-brandingmark img {width:60%;}\r\n      .vfv-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n      .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n      .vfv-sect2-button {margin: 40px 0 0 0;}\r\n      .vfv-front-sect2-arrow {width: 100%; text-align: center;}\r\n\r\n      .vfv-videoslate {margin: 30px auto; border: 20px #e5ebf6 solid;  width: 100%;}\r\n\r\n      /* OMM */\r\n\r\n      .omm-faq-m {display: none;}\r\n\r\n      .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n      .omm-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n      .omm-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n      .omm-sect2-brandingmark img {width: 60%;}\r\n      .omm-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n      .omm-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n      .omm-sect2-button {margin: 40px 0 0 0;}\r\n      .omm-front-sect2-arrow {width: 100%; text-align: center;}\r\n\r\n      .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n      .vp2020-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n      .vp2020-sect2-brandingmark {float: left; width: 45%; text-align: center; margin: 0 auto; }\r\n      .vp2020-sect2-brandingmark img {max-width:300px; }\r\n      .vp2020-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n      .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n      .vp2020-sect2-button {margin: 40px 0 0 0; display: inline-block; width: 95%;}\r\n      .vp2020-front-sect2-arrow {width: 100%; text-align: center; max-width: 1023px;}\r\n\r\n      .omm-sect2-donatetext {float: left; width: 90%; text-align: left; font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n      .omm-sect2-donateembed {float: right; text-align: center; width: 45%;}\r\n\r\n      .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto; }\r\n      .omm-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n      .omm-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n      .omm-sect5-button {margin: 50px 0;}\r\n      .omm-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n      .omm-sect5-child img {width: 100%;}\r\n      .omm-sect5-child-circle {display: none;}\r\n\r\n      .omm-videoslate {margin: 30px auto; border: 20px #fbb03b solid;  width: 100%;}\r\n      img.omm-donate-mark {width: 70% !important;}\r\n\r\n      .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n      .omm-container-orange {width: 70%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n      .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n      .omm-container-blue {width: 100%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n      .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700;}\r\n      .omm-greatnews-stat {margin: 30px 0 0 0;}\r\n      .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; float: left; text-align: right; width: 40%; vertical-align: top; margin: 40px 0 0 0;}\r\n      .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; float: right; text-align: left; text-transform: uppercase; width: 55%; vertical-align: top; line-height: 50px;}\r\n\r\n      .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n      .omm-checkout-brandingmark {width: 50%; margin: 0 auto;}\r\n      .omm-checkout-brandingmark img {width:90%;}\r\n\r\n      .omm-container-checkout {width: 90%; margin: 50px auto;}\r\n      .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n      .omm-thankyou-mark {margin: -50px 0 0 30px !important;}\r\n      .omm-thankyou-brandingmark {width: 70%; }\r\n      .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n      .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n      .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n      .omm-container-faq {width: 70%; margin: 50px auto;}\r\n      .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n      a.omm-orangeB {font-size: 20px; color: #fff; text-transform: uppercase; background-color: #e5801a; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border: 4px solid #f7931e; border-radius: 20px 20px 20px 20px; }\r\n      a:visited.omm-orangeB {color: #fff; text-decoration: none;}\r\n      a:hover.omm-orangeB {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\n      .blockcontent-white2 {font-size: 20px; color: #fff; font-weight: 400; line-height: 32px;}\r\n\r\n      /* HEADER */\r\n\r\n      .wrapper-header-welcome, .wrapper-header-testing, .wrapper-header-form-embed, .wrapper-header-kvfl-events, .wrapper-header-kvfl-events-scheduler {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-bdayhome-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-onemillion {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m.png\") no-repeat top; margin: 0 auto; height: 600px; min-height: 600px;}\r\n      .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-m.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n      .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout-m.png\") no-repeat top; margin: 0 auto; height: 280px; min-height: 280px;}\r\n      .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-faq-m.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n      .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation-m.png\") no-repeat top; margin: 0 auto; height: 480px; min-height: 480px;}\r\n\r\n      .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 600px;}\r\n\r\n      .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 600px;}\r\n\r\n      .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-twomillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n      .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause-m.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n      .wrapper-header-help-a-child {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-m-help-a-child.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 700px;}\r\n\r\n      .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork-m.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n      .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-see-kids-soar-eoa, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-grants-for-good-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-grantsforgoodsight-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-cltl-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-cltl-day-resources, .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons-m.jpg\") no-repeat top; margin: 0 auto; height: 506px; min-height: 500px;}\r\n\r\n      .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n\r\n      .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 1024px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-golfthankyou {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-impact-report {width: 100%; max-width: 1440px; min-width:50%; background:#fff url(\"/static/assets/img/sectionpic-impactreport-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n      .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n      /* PARTNERSHIPS HEADER IMAGES */\r\n      .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n      /* STORY HEADER IMAGE */\r\n      .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n      .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n\r\n      .container-header {z-index: 9999999999; width: 90%; max-width: 1000px; margin: 0 auto;}\r\n\r\n      .header-logo {float: left; width: 160px; margin: 20px 0 0 0;}\r\n      .header-logo img {width: 100%;}\r\n      .topnav {display: none; float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 80px; font-weight: 700;}\r\n      .topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n      .topnav a:visited {text-decoration: none;}\r\n      .topnav a:hover {text-decoration: none;}\r\n\r\n      .header-donate {display: none; z-index: 99999999; float: right; margin: 20px 0 0 0;}\r\n\r\n      .header-sectiontext-wide {position: absolute; margin: 150px 0 0 4%; color: #fff; height: 400px; display: table; width: 500px;}\r\n      .header-sectiontext {position: absolute; margin: 100px 0 0 5%; color: #fff; height: 400px; display: table; width: 500px;}\r\n      .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n      .sectiontext-headline {font-size: 42px; text-transform: uppercase; font-weight: 600; line-height: 42px; width: 100%;}\r\n      .sectiontext-headlinethin {font-size: 42px; text-transform: uppercase; font-weight: 300;}\r\n\r\n      .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 20px 0 0 0; line-height: 24px; width: 80%;}\r\n      .sectiontext-desc-large {font-size: 22px; font-weight: 400; margin: 20px 0 0 0; line-height: 28px; width: 80%;}\r\n\r\n      .header-airplane {z-index: 999; position: absolute; margin: 30px 0 0 -100px;}\r\n      .header-airplane img {width: 400px;}\r\n      .header-dots {display: none; z-index: 999; margin: -50px -20px 0 0; float: right; }\r\n\r\n      .topnav-dropdown {display: none;}\r\n      .topnav-dropdown-sticky {display: none;}\r\n\r\n      /* STICKY HEADER */\r\n\r\n      .container-header-sticky {z-index: 99999; width: 100%; max-width: 1440px; margin: 0 auto; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n      .holder-header-sticky {width: 100%; margin: 0 auto;}\r\n      .s-header-logo {float: left; width: 300px; margin: 16px 0 0 30px;}\r\n      .s-header-logo img {width: 100%;}\r\n      .s-topnav {display: none; float: left; margin: 26px 0 0 50px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n      .s-topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n      .s-topnav a:visited {text-decoration: none;}\r\n      .s-topnav a:hover {text-decoration: none;}\r\n      .s-header-donate {display: none; float: right; margin: 24px 0 0 0;}\r\n      .s-mobile-menubutton {float: right; margin: 20px 30px 0 0;}\r\n\r\n      /* SUBNAV */\r\n\r\n      .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n      .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n      .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n      .container-subnav ul li {margin: 0 30px; padding: 0; display: inline; font-size: 30px; text-transform: uppercase; font-weight: 500;}\r\n      .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n      .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n      .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n      /* FRONT - BLOCK - 3columns */\r\n\r\n      .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n      .front-container-3columns { text-align: center; margin: 30px auto; }\r\n      .front-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n      .front-column3-icon {margin: 20px 0;}\r\n      .front-column3-icon img {width: 80%; }\r\n      .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #229cb4; }\r\n\r\n      .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n      .front-container-4columns { text-align: center; margin: 30px auto; }\r\n      .front-holder-4column {width: 22%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n      .front-column4-icon {margin: 20px 0;}\r\n      .front-column4-icon img {width: 60%; }\r\n\r\n\r\n      /* PRESS & NEWS COLUMNS */\r\n      .news-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n      .news-container-3columns { text-align: center; margin: 30px auto; }\r\n      .news-holder-3column {width: 58%; text-align: center; display: inline-block; margin: 0 2% 20px; vertical-align: top; background-color: #115e67; color: #ffffff;}\r\n      .news-contentblock {width:100%; margin: 0 auto; padding: 20px 20px; line-height: 1.5em;}\r\n      .news-snippet {width: 100%; text-align: left; display: inline-block; vertical-align: top; color: #ffffff;}\r\n      .news-column3-icon {margin: 20px 0;}\r\n      /* .news-column3-icon img {width: 100%; } */\r\n      .news-holder-3column img {width: 100%; margin: 0 auto;}\r\n      .news-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #ffffff; text-align: left; }\r\n\r\n\r\n      /* PARTNERSHIPS STYLES */\r\n      .program-bgimage {z-index: 1; width: 100%; position: relative; text-align: center; display: inline-block; margin: 0 2%; vertical-align: bottom; opacity: 0.15; filter: alpha(opacity=15);}\r\n      .program-text {z-index: 5; width:70%; position: relative; text-align: center; display: inline-block; margin: -450px 0 0 15%; vertical-align: top;}\r\n      .program-text img {margin: 20px auto;}\r\n\r\n      .partner-social {margin: 20px 0 0 0;}\r\n      .partner-social a {margin: 0 10px;}\r\n\r\n      .partner-logo {margin: 40px 0;}\r\n      .partner-logo img {width: 80%;}\r\n\r\n      /* CONTENT */\r\n\r\n      .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n      .content-story-column {width: 80%; text-align: left; margin:0 auto;}\r\n      .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 80%; margin: 100px auto; text-align: center;}\r\n      .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n      .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n      .pretextimage {float: right; margin: 0 0 30px 30px; width: 25%; display: block;}\r\n      .pretextimage img {width: 35%;} /*JC was 90*/\r\n\r\n      .wrapper-contentblock-white img {width: 100%;}\r\n\r\n      .blockcontent img {width: 30%;}\r\n\r\n      /* RESOURCES NEW */\r\n\r\n      SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 400px; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n      .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n      .holder-block-resourcesnewText {}\r\n      .adjustTop1 {}\r\n      .adjustTop2 {}\r\n\r\n      .holder-block-resourcesnewTitleRight {width: 90%; text-align: center; margin: 0 auto;}\r\n      .holder-block-resourcesnewContentLeft {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n      .holder-block-resourcesnewTitleLeft {width: 90%; text-align: center; margin: 0 auto;}\r\n      .holder-block-resourcesnewContentRight {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n      /* BLOCK - BEIGE */\r\n\r\n      .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n      .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color:#115e67;}\r\n      .wrapper-contentblock-green-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n      .container-contentblock-beige, .container-contentblock-green, .container-contentblock, container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n      .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n\r\n      /* BLOCK - 2cols offset with image */\r\n\r\n      .wrapper-2block-left {width: 100%; margin: 20px auto; }\r\n      .holder-2blockL-image {width: 45%; float: left;}\r\n      .holder-2blockL-image img {width: 100%;}\r\n      .holder-2blockL-content {width: 50%; float: right; text-align: left; height: auto; min-height: auto; vertical-align: middle; padding-top: 10px;}\r\n      .holder-2blockL-desc {padding: 0 5% 0 0; font-size: 18px; line-height: 30px;}\r\n\r\n      .wrapper-2block-right {width: 100%; margin: 100px auto; vertical-align: middle;}\r\n      .holder-2blockR-content {width: 50%; float: left; text-align: right; height: auto; min-height: auto; vertical-align: middle; padding-top: 10px;}\r\n      .holder-2blockR-image {width: 45%; float: right;}\r\n      .holder-2blockR-image img {width: 100%;}\r\n      .holder-2blockR-desc {padding: 0 0 0 5%; font-size: 18px; line-height: 30px;}\r\n\r\n      /* BLOCK - 2cols offset with Bio */\r\n\r\n      .wrapper-2block-leftbio {width: 90%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n      .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n      .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n      h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n      .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n      .holder-2block-desc {}\r\n\r\n      /* BLOCK - 3columns */\r\n\r\n      .wrapper-3columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n      .container-3columns { text-align: center; margin: 0 auto; }\r\n      .holder-3column {width: 30%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n      .column3-icon {}\r\n      .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n      .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 180px;}\r\n\r\n      .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n      /* BLOCK - 2columns */\r\n\r\n      .wrapper-2columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n      .container-2columns { text-align: center; margin: 0 auto; }\r\n      .holder-2column {width: 35%; text-align: center; display: inline-block; margin: 0 4%; vertical-align: top;}\r\n      .column2-icon {}\r\n      .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n      .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n      /* BLOCK - 2columns 1/3 2/3 */\r\n      .wrapper-2columns {width: 100%; margin: 20px auto; text-align: center;}\r\n      /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n      .content-2columns-twothird-left {width:50%; float: left; margin: 20px auto; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n      .content-2columns-twothird-right {width:50%; float: right; margin: 20px auto; text-align: left; height: auto; min-height: auto; vertical-align: middle;}\r\n      .content-2columns-onethird-left {width:28%; float: left; margin: 20px auto; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n      .content-2columns-onethird-right {width:28%; float: right; margin: 20px auto; text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n\r\n      /* BLOCK - 2columns 1/3 2/3 IMAGES */\r\n      .wrapper-2columns {width: 100%; margin: 20px auto; text-align: center;}\r\n      /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n      .content-2columns-twothird-left-images {width:95%; margin: 0 auto; text-align: center;}\r\n      .content-2columns-twothird-left-images img {width:100%; display: inline-block;}\r\n      .content-2columns-twothird-right-images {width:95%; margin: 0 auto; text-align: center;}\r\n      .content-2columns-twothird-right-images img {width:100%; display: inline-block;}\r\n      .content-2columns-onethird-left-images {width:33%; float: left; margin: 0; text-align: center; display: none;}\r\n      .content-2columns-onethird-right-images {width:33%; float: right; margin: 0; text-align: center; display: none;}\r\n      .content-2columns-onethird-right-images img {width:100%; display: inline-block;}\r\n\r\n      /* BLOCK - 2columns <ul> <li> list */\r\n\r\n      .container-column2-list {width: 100%; margin: 60px auto;}\r\n      .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n      .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n      .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n      /* BLOCK - circles */\r\n\r\n      .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n      .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n      .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n      .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055; line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n      .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n      .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n      .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n      .circle-white-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#075055; line-height:80px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n      .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n      .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n      .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n      .circle-white-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#075055; line-height:70px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n\r\n      /* BLOCK  - Donate */\r\n\r\n      .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n      .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n      .container-contentblock-donate {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n      .container-contentblock-donate-orange {width: 90%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n      .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n      a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n      a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n      a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n      /* FOOTER */\r\n\r\n      .wrapper-footer {z-index: 99999999; width: 100%; position: absolute;}\r\n      .container-footer {z-index: 99999999; width: 90%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n      .footer-holder {z-index: 9999999999; width: 48%; display: inline-block; vertical-align: top;}\r\n      .footer-navL {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n      .footer-navR {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n      .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n      .footer-links {z-index: 9999999999; margin: 0 0 0 0;}\r\n      .footer-links ul {list-style-type: none; margin: 20px 0 0 0; padding: 0;}\r\n      .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n      .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n      .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n      .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n      .footer-social {margin: 50px 0 0 0;}\r\n      .footer-social a {margin: 0 20px;}\r\n\r\n      .copyright {font-size: 10px; margin: 160px 100px 100px 0; font-weight: 300; text-align: right;}\r\n\r\n      .footer-airplane {z-index: 999; position: absolute; margin: -100px 0 0 -250px; text-align: left;}\r\n\r\n      .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n      .footer-dot-blue80 {margin: 20px 0 0 -20px;}\r\n      .footer-dot-green60 {margin: 160px 0 0 10px;}\r\n      .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n      .footer-dot-blue60 {float: right; margin: -200px 40px 0 0;}\r\n      .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n      /* NEWS */\r\n\r\n      .wrapper-news-title {margin: 140px auto 0 auto; width: 90%; }\r\n      .holder-news-title {width: 49%; text-align: center; display: inline-block;}\r\n\r\n      h1.titlenews {font-size: 30px !important;}\r\n\r\n      .wrapper-news-block {margin: 0 auto; width: 90%;}\r\n      .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px 5%;}\r\n      .holder-news-image1 {width: 48%; float: left;}\r\n      .holder-news-image1 img {width: 100%;}\r\n      .holder-news-righttitle {width: 47%; float: right; text-align: left;}\r\n\r\n      h1.news-title {color: #075055; font-size: 36px; margin: 0px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 40px; width: 100%;font-weight: 900;}\r\n      .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n      .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n      .wrapper-news-content {width: 60%; margin: 60px auto;}\r\n      .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n      h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n      .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n      .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px; min-height: 400px; vertical-align: top;}\r\n      .morestory-image {width: 100%;}\r\n      .morestory-image img {width: 100%;}\r\n      .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n      .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n      .morestory-text p {color: #fff;}\r\n      .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n      .morestory-link a {color: #fff; text-decoration: underline;}\r\n      .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n      .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n      .holder-media-left {width: 60%; float: left; text-align: center;}\r\n      .holder-contact-right {width: 35%; float: right; text-align: center;}\r\n\r\n      .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n      .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n      .holder-newslisting-image1 {width: 35%; float: left;}\r\n      .holder-newslisting-image1 img {width: 100%;}\r\n      .holder-newslisting-righttitle {width: 60%; float: right; text-align: left;}\r\n\r\n      h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n      .newslisting-type {background-color: #075055; font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 8px 30px; width: 200px; text-align: center; margin: 20px 0;}\r\n\r\n      .holder-form {width: 65%; display: inline-block; margin: 0; vertical-align: top;}\r\n\r\n    }\r\n\r\n  }\r\n\r\n  @media screen and (min-width: 481px) and (max-width: 767px) {\r\n\r\n    h1 {font-size: 36px; text-transform: uppercase; line-height: 46px;}\r\n    h2 {font-size: 30px; text-transform: uppercase; line-height: 40px;}\r\n    h3 {font-size: 24px; text-transform: uppercase; line-height: 36px; text-align: center;}\r\n    h4 {font-size: 21px; text-transform: uppercase; line-height: 29px;}\r\n    /* h5 {font-size: 21px; text-transform: uppercase; line-height: 28px;} */\r\n\r\n    p.vsmembernames {font-size:13px !important;}\r\n    .bluebutton {display:inline-block; text-align: center; margin: 0 10%;}\r\n    .centered-button {display: inline-block; width: 90%; margin:0 auto;}\r\n\r\n    .mobile-menubutton {float: right; margin: 20px  0 0;}\r\n    .hidebr {display: none;} /*JC*/\r\n    .hidemobile {display: none !important;}\r\n    .blockcontent-orange {font-size: 18px; color: #fbb03b; font-weight: 400; line-height: 24px;}\r\n    h3 {font-size: 25px; text-transform: uppercase; line-height: 40px; text-align: center; margin: 0 auto; /*padding-left: 30%;*/}\r\n    p.intro {font-size: 16px; font-weight: 500; line-height: 24px; text-align: left;}\r\n    p.vsmembernames {font-size:13px !important;}\r\n    li.vsmembernames {font-size:14px !important;}\r\n    .narrowwidth {width: 75% !important;}\r\n    .hidedesktop {display: block;}\r\n    .scalemobile {width:80%;}\r\n\r\n    /* FRONT 2019 */\r\n\r\n    .front-picholder {width: 60%; margin: 0 auto; text-align: center;}\r\n    .front-picholder img {width: 100%;}\r\n    .front-pictext {width: 90%; text-align: center !important; margin: 20px auto;}\r\n    .front-pictext-right {width: 90%; text-align: left !important; float:right !important;}\r\n    .front-picholder-left {width: 60%; margin: 0 auto; text-align: center;}\r\n    .front-picholder-left img {width: 100%;}\r\n\r\n    .front-3column-holder {width: 60%; display: inline-block; text-align: center; margin: 0 2% 40px 2%; vertical-align: top; background-color: #fff;}\r\n    .front-3column-pic {width: 100%;}\r\n    .front-3column-pic img {width: 100%;}\r\n    .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n    .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n    .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n    .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n    .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n    .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n    /* VFV */\r\n\r\n    .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n    .vfv-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vfv-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto; }\r\n    .vfv-sect2-brandingmark img {width:60%;}\r\n    .vfv-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .vfv-sect2-button {margin: 40px 0 0 0;}\r\n    .vfv-front-sect2-arrow {width: 100%; text-align: center;}\r\n\r\n    .vfv-videoslate {margin: 30px auto; border: 10px #e5ebf6 solid;  width: 100%;}\r\n\r\n    /* Simple Section 2 */\r\n    .wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: inherit; margin: 0 auto; padding:5% 5%;}\r\n    .simple-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n    .simple-sect2-descright {text-align: center; width: 100%; color: #fff; font-size: 22px; line-height:30px;}\r\n    .simple-sect2-descleft {text-align: center; width: 100%; color: #fff; font-size: 22px; line-height: 30px;}\r\n    .simple-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .simple-sect2-button {margin: 40px 0 0 0;}\r\n    .simple-front-sect2-circle {width: 40% !important; text-align: center; margin: -27px auto 0 auto !important;}\r\n    .simple-front-sect2-circle img {width:100% !important; max-width: 180px;}\r\n\r\n\r\n    /* Simple Section 5 */\r\n    .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #f4f2f3; margin: 0 auto; }\r\n    .simple-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n    .simple-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .simple-sect5-button {margin: 50px 0;}\r\n    /* .simple-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;} */\r\n    .simple-sect5-child {display: none;}\r\n    .simple-sect5-child img {width: 80%; margin:0 auto;}\r\n    .simple-sect5-child-circle {display: block; margin: 0 auto; width:70%;}\r\n    .simple-sect5-child-circle img {width: 100%; margin: 0 auto;}\r\n\r\n\r\n    /* OMM */\r\n\r\n    .omm-faq {display: none;}\r\n\r\n    .omm-sectiontext {margin: 150px 0 0 30px !important;}\r\n\r\n    .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n    .omm-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .omm-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n    .omm-sect2-brandingmark img {width: 60%;}\r\n    .omm-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .omm-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-button {margin: 40px 0 0 0;}\r\n    .omm-front-sect2-arrow {width: 100%; text-align: center; max-width:767px;}\r\n\r\n    .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n    .vp2020-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vp2020-sect2-brandingmark {float: left; width: 45%; text-align: center; margin: 0 auto; }\r\n    .vp2020-sect2-brandingmark img {max-width:300px; }\r\n    .vp2020-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .vp2020-sect2-button {margin: 40px 0 0 0; display:inline-block; width: 90%;}\r\n    .vp2020-front-sect2-arrow {width: 100%; text-align: center; max-width: 767px;}\r\n\r\n    .omm-sect2-donatetext {width: 90%; margin: 0 auto; text-align: center; font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-donateembed {text-align: center; width: 90%; margin: 0 auto;}\r\n\r\n    .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto; }\r\n    .omm-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: left;}\r\n    .omm-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .omm-sect5-button {margin: 50px 0;}\r\n    .omm-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .omm-sect5-child img {width: 100%;}\r\n    .omm-sect5-child-circle {display: none;}\r\n\r\n    .omm-videoslate {margin: 30px auto; border: 10px #fbb03b solid;  width: 100%;}\r\n    .omm-donate-markholder {width: 100%; text-align: center; margin: -200px 0 0 0 !important; }\r\n    img.omm-donate-mark {width: 60% !important; }\r\n\r\n    .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n    .omm-container-orange {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n    .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n    .omm-container-blue {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n    .omm-3col {border-bottom: 3px dotted #fff; padding: 0 0 50px 0;}\r\n\r\n    .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700; line-height: 60px;}\r\n    .omm-greatnews-stat {width: 100%; text-align: center;}\r\n    .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; width: 100%; text-align: center; margin: 40px 0 0 0;}\r\n    .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; width: 100%; text-align: center; text-transform: uppercase; vertical-align: top; line-height: 50px; margin: 40px 0 0px 0;}\r\n\r\n    .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n    .omm-checkout-brandingmark {width: 80%; margin: -80px auto 0 auto !important;}\r\n    .omm-checkout-brandingmark img {width:90%;}\r\n\r\n    .omm-container-checkout {width: 80%; margin: 50px auto;}\r\n    .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n    .omm-container-checkout img {width: 90%;}\r\n\r\n    .omm-thankyou-mark {width: 80%; text-align: center; margin: 0 auto !important;}\r\n    .omm-thankyou-brandingmark {width: 70%; text-align: center; margin: 0 auto !important;}\r\n    .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n    .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .omm-container-faq {width: 70%; margin: 50px auto;}\r\n    .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n    .omm-faq-answer {display: block;}\r\n\r\n    .blockcontent-white2 {font-size: 20px; color: #fff; font-weight: 400; line-height: 32px;}\r\n\r\n    /* HEADER */\r\n\r\n    .wrapper-header-welcome, .wrapper-header-testing, .wrapper-header-form-embed, .wrapper-header-kvfl-events, .wrapper-header-kvfl-events-scheduler {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-onemillion {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m.png\") no-repeat top; margin: 0 auto; height: 600px; min-height: 600px;}\r\n    .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-m.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n    .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout-m.png\") no-repeat top; margin: 0 auto; height: 280px; min-height: 280px;}\r\n    .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-faq-m.png\") no-repeat top; margin: 0 auto; height: 280px; min-height: 280px;}\r\n    .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation-m.png\") no-repeat top; margin: 0 auto; height: 480px; min-height: 480px;}\r\n\r\n    .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 600px;}\r\n\r\n    .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 600px;}\r\n\r\n    .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-twomillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n    .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause-m.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-help-a-child {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-m-help-a-child.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork-m.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021-m2.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 700px;}\r\n\r\n    .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons-m.jpg\") no-repeat top; margin: 0 auto; height: 506px; min-height: 500px;}\r\n    .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n\r\n    .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-see-kids-soar-eoa, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-grants-for-good-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-grantsforgoodsight-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day-resources, .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 1024px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-golfthankyou {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-impact-report {width: 100%; max-width: 1440px; min-width:50%; background:#fff url(\"/static/assets/img/sectionpic-impactreport-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    /* PARTNERSHIPS HEADER IMAGES */\r\n    .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    /* STORY HEADER IMAGE */\r\n    .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie-m.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n    .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl-m.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n\r\n    .container-header {z-index: 9999999999; width: 90%; max-width: 1000px; margin: 0 auto;}\r\n    .m-wrapper-sectionpic {width: 100%; z-index: 9999;}\r\n    .m-wrapper-sectionpic img {width: 100%;}\r\n\r\n    .header-logo {float: left; width: 160px; margin: 20px 0 0 0;}\r\n    .header-logo img {width: 100%;}\r\n    .topnav {display: none; float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 80px; font-weight: 700;}\r\n    .topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n    .topnav a:visited {text-decoration: none;}\r\n    .topnav a:hover {text-decoration: none;}\r\n\r\n    .header-donate {display: none; z-index: 99999999; float: right; margin: 20px 0 0 0;}\r\n\r\n    .header-sectiontext-wide {position: absolute; margin: 200px 0 0 5%; color: #fff; height: 400px; display: table; width: 400px;}\r\n    .header-sectiontext {position: absolute; margin: 200px 0 0 5%; color: #fff; height: 400px; display: table; width: 400px;}\r\n    .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n    .sectiontext-headline {font-size: 42px; text-transform: uppercase; font-weight: 600; line-height: 42px; width: 100%;}\r\n    .sectiontext-headlinethin {font-size: 42px; text-transform: uppercase; font-weight: 300;}\r\n\r\n    .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 20px 0 0 0; line-height: 24px; width: 80%;}\r\n    .sectiontext-desc-large {font-size: 20px; font-weight: 400; margin: 20px 0 0 0; line-height: 26px; width: 80%;}\r\n\r\n    .header-airplane {z-index: 999; position: absolute; margin: 30px 0 0 -100px;}\r\n    .header-airplane img {width: 400px;}\r\n    .header-dots {display: none; z-index: 999; margin: -50px -20px 0 0; float: right; }\r\n\r\n    .topnav-dropdown {display: none;}\r\n    .topnav-dropdown-sticky {display: none;}\r\n\r\n    /* STICKY HEADER */\r\n\r\n    .container-header-sticky {z-index: 999999999; width: 100%; max-width: 1440px; margin: 0 auto; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n    .holder-header-sticky {width: 100%; margin: 0 auto;}\r\n    .s-header-logo {float: left; width: 300px; margin: 16px 0 0 30px;}\r\n    .s-header-logo img {width: 100%;}\r\n    .s-topnav {display: none; float: left; margin: 26px 0 0 50px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n    .s-topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n    .s-topnav a:visited {text-decoration: none;}\r\n    .s-topnav a:hover {text-decoration: none;}\r\n    .s-header-donate {display: none; float: right; margin: 24px 0 0 0;}\r\n    .s-mobile-menubutton {float: right; margin: 20px 30px 0 0;}\r\n\r\n    /* SUBNAV */\r\n\r\n    .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n    .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n    .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .container-subnav ul li {margin: 0 30px; padding: 0; font-size: 24px; text-transform: uppercase; font-weight: 500;}\r\n    .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n    /* FRONT - BLOCK - 3columns */\r\n\r\n    .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-3columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-3column {width: 90%; text-align: center; display: inline-block; margin: 0 2% 40px 2%; vertical-align: top;}\r\n    .front-column3-icon {margin: 20px 0;}\r\n    .front-column3-icon img {width: 60%; }\r\n    .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #229cb4; }\r\n\r\n    .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-4columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-4column {width: 90%; text-align: center; display: inline-block; margin: 0 2% 40px 2%; vertical-align: top;}\r\n    .front-column4-icon {margin: 20px 0;}\r\n    .front-column4-icon img {width: 60%; }\r\n\r\n    /* PRESS & NEWS COLUMNS */\r\n    .news-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .news-container-3columns { text-align: center; margin: 30px auto; }\r\n    .news-holder-3column {width: 78%; text-align: center; display: inline-block; margin: 0 2% 30px; vertical-align: top; background-color: #115e67; color: #ffffff;}\r\n    .news-contentblock {width:100%; margin: 0 auto; padding: 20px 20px; line-height: 1.5em;}\r\n    .news-snippet {width: 100%; text-align: left; display: inline-block; vertical-align: top; color: #ffffff;}\r\n    .news-column3-icon {margin: 20px 0;}\r\n    /* .news-column3-icon img {width: 100%; } */\r\n    .news-holder-3column img {width: 100%; margin: 0 auto;}\r\n    .news-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #ffffff; text-align: left; }\r\n\r\n\r\n    /* PARTNERSHIPS STYLES */\r\n    .program-bgimage {width: 100%; float: none; text-align: center;  margin: 0 2%; vertical-align: bottom; opacity: 0.15; filter: alpha(opacity=15);}\r\n    .program-bgimage img {display: none;}\r\n    .program-text {width: 80%; text-align: center; display: inline-block; margin: 10% 6%;}\r\n    .program-text img {margin: 20px auto;}\r\n\r\n\r\n    .partner-social {margin: 20px 0 0 0;}\r\n    .partner-social a {margin: 0 10px;}\r\n\r\n    .partner-logo {margin: 40px 0;}\r\n    .partner-logo img {width: 60%;}\r\n\r\n    /* RESOURCES NEW */\r\n\r\n    SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 100%; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n    .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n    .holder-block-resourcesnewText {}\r\n    .adjustTop1 {}\r\n    .adjustTop2 {}\r\n\r\n    .holder-block-resourcesnewTitleRight {width: 90%; text-align: center; margin: 0 auto;}\r\n    .holder-block-resourcesnewContentLeft {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n    .holder-block-resourcesnewTitleLeft {width: 90%; text-align: center; margin: 0 auto;}\r\n    .holder-block-resourcesnewContentRight {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n    /* CONTENT */\r\n\r\n    .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .content-story-column {width: 90%; text-align: left; margin:0 auto;}\r\n    .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 80%; margin: 100px auto; text-align: center;}\r\n    .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n    .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .pretextimage {float: right; margin: 0 0 30px 30px; width: 25%; display: block;}\r\n    .pretextimage img {width: 35%;}\r\n\r\n    .wrapper-contentblock-white img {width: 100%;}\r\n\r\n    .blockcontent img {width: 60%;} /*JC*/\r\n\r\n    /* BLOCK - COLOR */\r\n\r\n    .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n    .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color:#115e67;}\r\n    .wrapper-contentblock-green-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n    .container-contentblock-beige, .container-contentblock-green, .container-contentblock, .container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n\r\n    /* BLOCK - 2cols offset with image */\r\n\r\n    .wrapper-2block-left {width: 90%; max-width: 1400px; margin: 20px auto; }\r\n    .holder-2blockL-image {width: 90%; margin: 20px auto;}\r\n    .holder-2blockL-image img {width: 100%;}\r\n    .holder-2blockL-content {width: 80%; text-align: left; height: auto; min-height: auto; margin: 30px auto;}\r\n\r\n    .wrapper-2block-right {width: 90%; max-width: 1400px; margin: 100px auto; }\r\n    .holder-2blockR-content {width: 80%; text-align: left; height: auto; min-height: auto; margin: 30px auto;}\r\n    .holder-2blockR-image {width: 90%; margin: 30px auto;}\r\n    .holder-2blockR-image img {width: 100%;}\r\n\r\n    /* BLOCK - 2cols offset with Bio */\r\n\r\n    .wrapper-2block-leftbio {width: 90%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n    .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n    .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n    h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n    .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n    .holder-2block-desc {}\r\n\r\n    /* BLOCK - 3columns */\r\n\r\n    .wrapper-3columns {width: 90%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-3columns { text-align: center; margin: 0 auto; }\r\n    .holder-3column {width: 80%; text-align: center; display: inline-block; margin: 0 1% 40px 1%; vertical-align: top;}\r\n    .column3-icon {}\r\n    .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; }\r\n\r\n    .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n    /* BLOCK - 2columns */\r\n\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-2columns { text-align: center; margin: 0 auto; }\r\n    .holder-2column {width: 45%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n    .column2-icon {}\r\n    .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 */\r\n    .wrapper-2columns {width: 80%;}\r\n    .container-2columns {text-align: center; margin: 0 auto;}\r\n    .content-2columns-twothird-left {width:100%;  text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-twothird-right {width:100%;  text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-left {width:80%;  text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-right {width:80%;  text-align: center; height: auto; min-height: auto; vertical-align: middle; margin-top:30px 2% 0;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 IMAGES */\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n    .content-2columns-twothird-left-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-twothird-left-images img {width:100%; display: inline-block;}\r\n    .content-2columns-twothird-right-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-twothird-right-images img {width:100%; display: inline-block;}\r\n    .content-2columns-onethird-left-images {width:33%; float: left; margin: 0; text-align: center; display: none;}\r\n    .content-2columns-onethird-right-images {width:33%; float: right; margin: 0; text-align: center; display: none;}\r\n    .content-2columns-onethird-right-images img {width:100%; display: inline-block;}\r\n\r\n    /* BLOCK - 2columns <ul> <li> list */\r\n\r\n    .container-column2-list {width: 100%; margin: 60px auto;}\r\n    .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n    .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n    /* BLOCK - circles */\r\n\r\n    .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055; line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#075055;line-height:80px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#075055; line-height:70px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n\r\n    /* BLOCK  - Donate */\r\n\r\n    .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n    .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n    .container-contentblock-donate {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n    .container-contentblock-donate-orange {width: 90%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n    .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n    a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n    /* FOOTER */\r\n\r\n    .wrapper-footer {z-index: 99999999; width: 100%; position: absolute;}\r\n    .container-footer {z-index: 99999999; width: 90%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n    .footer-holder {z-index: 9999999999; width: 100%; margin: 0 0 40px 0;}\r\n    .footer-navL {z-index: 9999999999; width: 100%; text-align: center; margin: 0 auto;}\r\n    .footer-navR {z-index: 9999999999; width: 100%; text-align: ceter; margin: 0 auto;}\r\n    .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links {z-index: 9999999999; margin: 0 0 0 0;}\r\n    .footer-links ul {list-style-type: none; margin: 20px 0 60px 0; padding: 0;}\r\n    .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n    .footer-social {margin: 50px 0 0 0;}\r\n    .footer-social a {margin: 0 20px;}\r\n\r\n    .copyright {font-size: 10px; margin: 160px 0 80px 0; text-align: center; font-weight: 300; width: 100%; }\r\n\r\n    .footer-airplane {display: none; z-index: 999; position: absolute; margin: -100px 0 0 -180px; text-align: left;}\r\n\r\n    .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n    .footer-dot-blue80 {margin: 20px 0 0 -20px;}\r\n    .footer-dot-green60 {margin: 160px 0 0 10px;}\r\n    .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n    .footer-dot-blue60 {float: right; margin: -200px 40px 0 0;}\r\n    .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n    /* NEWS */\r\n\r\n    .wrapper-news-title {margin: 140px auto 0 auto; width: 90%; }\r\n    .holder-news-title {width: 100%; text-align: center; display: inline-block;}\r\n\r\n    h1.titlenews {font-size: 30px !important; margin: 0 !important;}\r\n\r\n    .wrapper-news-block {margin: 50px auto; width: 90%;}\r\n    .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px;}\r\n    .holder-news-image1 {width: 100%; }\r\n    .holder-news-image1 img {width: 100%;}\r\n    .holder-news-righttitle {width: 100%; text-align: left; margin: 30px 0 0 0;}\r\n\r\n    h1.news-title {color: #075055; font-size: 36px; margin: 0px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 40px; width: 100%;font-weight: 900;}\r\n    .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n    .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n    .wrapper-news-content {width: 90%; margin: 60px auto;}\r\n    .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n    h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n    .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n    .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px 60px 50px; min-height: 400px; vertical-align: top;}\r\n    .morestory-image {width: 100%;}\r\n    .morestory-image img {width: 100%;}\r\n    .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n    .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n    .morestory-text p {color: #fff;}\r\n    .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n    .morestory-link a {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n    .holder-media-left {width: 100%; text-align: center;}\r\n    .holder-contact-right {width: 100%; text-align: center;}\r\n\r\n    .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n    .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n    .holder-newslisting-image1 {width: 100%;}\r\n    .holder-newslisting-image1 img {width: 100%;}\r\n    .holder-newslisting-righttitle {width: 100%; text-align: left;}\r\n\r\n    h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n    .newslisting-type {background-color: #075055; font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 8px 30px; width: 200px; text-align: center; margin: 20px 0;}\r\n\r\n    .holder-form {width: 65%; display: inline-block; margin: 0; vertical-align: top;}\r\n\r\n    .form-row {margin: 0 0 0 0;}\r\n    .form-cellhalf {width: 95%; margin: 0 0 20px 0;}\r\n    .form-cellfour {margin: 20px 0 0 0;}\r\n    .form-cellfull {width: 95%; margin: -25px 0 0 0;}\r\n    .form-text {width: 100%;}\r\n    .form-textfull {width: 100%;}\r\n\r\n  }\r\n\r\n  @media screen and (min-width: 376px) and (max-width: 480px) {\r\n    .bluebutton {display:inline-block; text-align: center; margin: 0 10%;}\r\n    .centered-button {display: inline-block; width: 90%; margin:0 auto; text-align: center;}\r\n    .mobile-menubutton {float: right; margin: 20px  0 0;}\r\n    .hidebr {display: none;} /*JC*/\r\n    .blockcontent-orange {font-size: 18px; color: #fbb03b; font-weight: 400; line-height: 24px;}\r\n    p.intro {font-size: 16px; font-weight: 500; line-height: 24px; text-align: left;}\r\n    p.vsmembernames {font-size:13px !important;}\r\n    li.vsmembernames {font-size:14px !important;}\r\n    .hidemobile {display: none !important;}\r\n    .narrowwidth {width: 85% !important;}\r\n    .scalemobile {width:100%;}\r\n\r\n    /* FRONT 2019 */\r\n\r\n    .front-picholder {width: 60%; margin: 0 auto; text-align: center;}\r\n    .front-picholder img {width: 100%;}\r\n    .front-pictext {width: 90%; text-align: center !important; margin: 20px auto;}\r\n    .front-pictext-right {width: 90%; text-align: left !important; float:right !important;}\r\n    .front-picholder-left {width: 60%; margin: 0 auto; text-align: center;}\r\n    .front-picholder-left img {width: 100%;}\r\n\r\n    .front-3column-holder {width: 60%; display: inline-block; text-align: center; margin: 0 2% 40px 2%; vertical-align: top; background-color: #fff;}\r\n    .front-3column-pic {width: 100%;}\r\n    .front-3column-pic img {width: 100%;}\r\n    .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n    .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n    .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n    .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n    .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n    .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n    /* VFV */\r\n    .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n    .vfv-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vfv-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n    .vfv-sect2-brandingmark img {width: 90%;}\r\n    .vfv-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .vfv-sect2-button {margin: 40px 0 0 0;}\r\n    .vfv-front-sect2-arrow {width: 100%; text-align: center; max-width: 480px;}\r\n    .vfv-front-sect2-arrow {width: 100%; text-align: center; overflow-x: hidden;}\r\n\r\n    .vfv-videoslate {margin: 30px auto; border: 10px #e5ebf6 solid;  width: 100%;}\r\n\r\n    /* Simple Section 2 */\r\n    .wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #inherit; margin: 0 auto;}\r\n    .simple-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n    .simple-sect2-descright {text-align: center; width: 100%; color: #fff; font-size: 22px; line-height:30px;}\r\n    .simple-sect2-descleft {text-align: center; width: 90%; color: #fff; font-size: 22px; line-height: 30px;}\r\n    .simple-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .simple-sect2-button {margin: 40px 0 0 0;}\r\n    .simple-front-sect2-circle {width: 35% !important; text-align: center; margin: -27px auto 0 auto !important;}\r\n    .simple-front-sect2-circle img {width:100% !important; max-width: 180px;}\r\n\r\n\r\n    /* Simple Sect 5 */\r\n    .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #f4f2f3; margin: 0 auto; }\r\n    .simple-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: center;}\r\n    .simple-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .simple-sect5-button {margin: 50px 0;}\r\n    /* .simple-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;} */\r\n    .simple-sect5-child {display: none;}\r\n    .simple-sect5-child img {display: none;}\r\n    .simple-sect5-child-circle {width: 70%; margin: 0 auto; text-align: center;}\r\n    .simple-sect5-child-circle img {width: 100%; margin: 0 auto;}\r\n\r\n\r\n\r\n    /* OMM */\r\n\r\n    .omm-faq {display: none;}\r\n\r\n    .omm-sectiontext {margin: 150px 0 0 30px !important;}\r\n\r\n    .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n    .omm-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .omm-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n    .omm-sect2-brandingmark img {width: 90%;}\r\n    .omm-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .omm-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-button {margin: 40px 0 0 0;}\r\n    /*.omm-front-sect2-arrow {width: 100%; text-align: center; max-width: 480px;}*/\r\n    .omm-front-sect2-arrow {width: 100%; text-align: center; overflow-x: hidden;}\r\n\r\n    .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n    .vp2020-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vp2020-sect2-brandingmark {width: 90%; text-align: center; margin: 0 auto; }\r\n    .vp2020-sect2-brandingmark img {max-width:300px; }\r\n    .vp2020-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .vp2020-sect2-button {margin: 40px 0 0 0;}\r\n    .vp2020-front-sect2-arrow {width: 100%; text-align: center; overflow-x:hidden;}\r\n\r\n    .omm-sect2-donatetext {width: 90%; margin: 0 auto; text-align: center; font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-donateembed {text-align: center; width: 90%; margin: 0 auto;}\r\n\r\n    .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto; }\r\n    .omm-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: center;}\r\n    .omm-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .omm-sect5-button {margin: 50px 0;}\r\n    .omm-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .omm-sect5-child img {display: none; width: 100%;}\r\n    .omm-sect5-child-circle {width: 90%; margin: 0 auto 30px auto; text-align: center;}\r\n    .omm-sect5-child-circle img {width: 100%;}\r\n\r\n    .omm-videoslate {margin: 30px auto; border: 10px #fbb03b solid;  width: 100%;}\r\n    .omm-donate-markholder {width: 100%; text-align: center; margin: -200px 0 0 0 !important; }\r\n    img.omm-donate-mark {width: 60% !important; }\r\n\r\n    .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n    .omm-container-orange {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n    .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n    .omm-container-blue {width: 100%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .omm-3col {border-bottom: 3px dotted #fff; padding: 0 0 50px 0;}\r\n\r\n    .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700; line-height: 60px;}\r\n    .omm-greatnews-stat {width: 100%; text-align: center;}\r\n    .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; width: 100%; text-align: center; margin: 40px 0 0 0;}\r\n    .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; width: 100%; text-align: center; text-transform: uppercase; vertical-align: top; line-height: 50px; margin: 40px 0 0px 0;}\r\n\r\n    .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n    .omm-checkout-brandingmark {width: 80%; margin: -80px auto 0 auto !important;}\r\n    .omm-checkout-brandingmark img {width:90%;}\r\n\r\n    .omm-container-checkout {width: 80%; margin: 50px auto;}\r\n    .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n    .omm-container-checkout img {width: 90%;}\r\n\r\n    .omm-thankyou-mark {width: 80%; text-align: center; margin: 100px auto 0 auto !important;}\r\n    .omm-thankyou-brandingmark {width: 70%; text-align: center; margin: 0 auto !important;}\r\n    .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n    .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .omm-container-faq {width: 90%; margin: 50px auto;}\r\n    .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n    .omm-faq-answer {display: block;}\r\n\r\n    a.omm-orange {font-size: 20px; color: #fff; text-transform: uppercase; background-color: #e5801a; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border: 4px solid #f7931e; border-radius: 20px 20px 20px 20px; }\r\n    a:visited.omm-orange {color: #fff; text-decoration: none;}\r\n    a:hover.omm-orange {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\n    a.omm-white {font-size: 18px; color: #e5801a; text-transform: uppercase; background-color: #fff; padding: 16px 60px; letter-spacing: 2px; text-decoration: none; border-radius: 20px 20px 20px 20px; font-weight: 600;}\r\n    a:visited.omm-white {color: #e5801a; text-decoration: none;}\r\n    a:hover.omm-white {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\n    .blockcontent-white2 {font-size: 20px; color: #fff; font-weight: 400; line-height: 32px;}\r\n\r\n    /* HEADER */\r\n\r\n    .wrapper-header-welcome, .wrapper-header-testing, .wrapper-header-form-embed,, .wrapper-header-kvfl-events, .wrapper-header-kvfl-events-scheduler {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-onemillion {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-m2.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n    .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout-m2.png\") no-repeat top; margin: 0 auto; height: 280px; min-height: 280px;}\r\n    .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-faq-m2.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n    .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n\r\n    .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n\r\n    .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-twomillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n    .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-help-a-child {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-m2-help-a-child.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n    .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-see-kids-soar-eoa, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-grants-for-good-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-grantsforgoodsight-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-cltl-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect-m2.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day-resources, .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n    .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday-m2.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n    .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021-m2.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n    .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons-m2.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 700px;}\r\n    .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 480px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-golfthankyou {width: 100%; max-width: 480px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-impact-report {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-impactreport-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    /* PARTNERSHIPS HEADER IMAGES */\r\n    .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    /* STORY HEADER IMAGE */\r\n    .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .container-header {z-index: 9999999999; width: 90%; max-width: 1000px; margin: 0 auto;}\r\n    .m-wrapper-sectionpic {width: 100%; z-index: 9999;}\r\n    .m-wrapper-sectionpic img {width: 100%;}\r\n\r\n    .header-logo {float: left; width: 160px; margin: 20px 0 0 0;}\r\n    .header-logo img {width: 100%;}\r\n    .topnav {display: none; float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 80px; font-weight: 700;}\r\n    .topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n    .topnav a:visited {text-decoration: none;}\r\n    .topnav a:hover {text-decoration: none;}\r\n\r\n    .header-donate {display: none; z-index: 99999999; float: right; margin: 20px 0 0 0;}\r\n\r\n    .header-sectiontext-wide {position: absolute; margin: 180px 0 0 5%; color: #fff; height: 400px; display: table; width: 400px;}\r\n    .header-sectiontext {position: absolute; margin: 200px 0 0 5%; color: #fff; height: 400px; display: table; width: 400px;}\r\n    .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n    .sectiontext-headline {font-size: 42px; text-transform: uppercase; font-weight: 600; line-height: 42px; width: 100%;}\r\n    .sectiontext-headlinethin {font-size: 42px; text-transform: uppercase; font-weight: 300;}\r\n\r\n    .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 20px 0 0 0; line-height: 24px; width: 80%;}\r\n    .sectiontext-desc-large {font-size: 20px; font-weight: 400; margin: 20px 0 0 0; line-height: 26px; width: 80%;}\r\n\r\n\r\n    .header-airplane {z-index: 999; position: absolute; margin: 30px 0 0 -100px;}\r\n    .header-airplane img {width: 400px;}\r\n    .header-dots {display: none; z-index: 999; margin: -50px -20px 0 0; float: right; }\r\n\r\n    .topnav-dropdown {display: none;}\r\n    .topnav-dropdown-sticky {display: none;}\r\n\r\n    /* STICKY HEADER */\r\n\r\n    .container-header-sticky {z-index: 999999; width: 100%; max-width: 1440px; margin: 0 auto; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n    .holder-header-sticky {width: 100%; margin: 0 auto;}\r\n    .s-header-logo {float: left; width: 250px; margin: 18px 0 0 30px;}\r\n    .s-header-logo img {width: 100%;}\r\n    .s-topnav {display: none; float: left; margin: 26px 0 0 50px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n    .s-topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n    .s-topnav a:visited {text-decoration: none;}\r\n    .s-topnav a:hover {text-decoration: none;}\r\n    .s-header-donate {display: none; float: right; margin: 24px 0 0 0;}\r\n    .s-mobile-menubutton {float: right; margin: 20px 30px 0 0;}\r\n\r\n    /* SUBNAV */\r\n\r\n    .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n    .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n    .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .container-subnav ul li {margin: 0 30px; padding: 0; font-size: 24px; text-transform: uppercase; font-weight: 500;}\r\n    .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n\r\n    /* PARTNERSHIPS STYLES */\r\n    .program-bgimage {z-index: 1; width: 100%; position: relative; text-align: center; display: inline-block; margin: 0 2%; vertical-align: bottom; opacity: 0.15; filter: alpha(opacity=15);}\r\n    .program-text {z-index: 5; width:70%; position: relative; text-align: center; display: inline-block; margin: -450px 0 0 15%; vertical-align: top;}\r\n    .program-text img {margin: 20px auto;}\r\n\r\n    .partner-social {margin: 20px 0 0 0;}\r\n    .partner-social a {margin: 0 10px;}\r\n\r\n    .partner-logo {margin: 40px 0;}\r\n    .partner-logo img {width: 80%;}\r\n\r\n    /* FRONT - BLOCK - 3columns */\r\n\r\n    .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-3columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-3column {width: 90%; text-align: center; display: inline-block; margin: 0 2% 40px 2%; vertical-align: top;}\r\n    .front-column3-icon {margin: 20px 0;}\r\n    .front-column3-icon img {width: 60%; }\r\n    .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #229cb4; }\r\n\r\n    .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-4columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-4column {width: 90%; text-align: center; display: inline-block; margin: 0 2% 40px 2%; vertical-align: top;}\r\n    .front-column4-icon {margin: 20px 0;}\r\n    .front-column4-icon img {width: 60%; }\r\n\r\n    /* RESOURCES NEW */\r\n\r\n    SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 100%; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n    .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n    .holder-block-resourcesnewText {}\r\n    .adjustTop1 {}\r\n    .adjustTop2 {}\r\n\r\n    .holder-block-resourcesnewTitleRight {width: 90%; text-align: center; margin: 0 auto;}\r\n    .holder-block-resourcesnewContentLeft {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n    .holder-block-resourcesnewTitleLeft {width: 90%; text-align: center; margin: 0 auto;}\r\n    .holder-block-resourcesnewContentRight {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n    /* CONTENT */\r\n\r\n    .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .content-story-column {width: 95%; text-align: left; margin:0 auto;}\r\n    .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 80%; margin: 100px auto; text-align: center;}\r\n    .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n    .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .pretextimage {float: right; margin: 0 0 30px 30px; width: 25%;}\r\n    .pretextimage img {width: 90%;}\r\n\r\n    .wrapper-contentblock-white img {width: 100%;}\r\n\r\n    /* .blockcontent img {width: 80%;} JC*/\r\n\r\n    a.button-marketingresources {letter-spacing: 0; font-size: 16px;}\r\n\r\n    /* BLOCK - COLOR */\r\n\r\n    .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n    .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color:#115e67;}\r\n    .wrapper-contentblock-green-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n    .container-contentblock-beige, .container-contentblock-green, .container-contentblock, .container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n\r\n    /* BLOCK - 2cols offset with image */\r\n\r\n    .wrapper-2block-left {width: 100%; max-width: 1400px; margin: 20px auto; }\r\n    .holder-2blockL-image {width: 100%; margin: 20px auto;}\r\n    .holder-2blockL-image img {width: 100%;}\r\n    .holder-2blockL-content {width: 80%; text-align: left; height: auto; min-height: auto; margin: 30px auto;}\r\n\r\n    .wrapper-2block-right {width: 100%; max-width: 1400px; margin: 100px auto; }\r\n    .holder-2blockR-content {width: 80%; text-align: left; height: auto; min-height: auto; margin: 30px auto;}\r\n    .holder-2blockR-image {width: 100%; margin: 30px auto;}\r\n    .holder-2blockR-image img {width: 100%;}\r\n\r\n    /* BLOCK - 2cols offset with Bio */\r\n\r\n    .wrapper-2block-leftbio {width: 90%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n    .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n    .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n    h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n    .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n    .holder-2block-desc {}\r\n\r\n    /* BLOCK - 3columns */\r\n\r\n    .wrapper-3columns {width: 90%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-3columns { text-align: center; margin: 0 auto; }\r\n    .holder-3column {width: 80%; text-align: center; display: inline-block; margin: 0 1% 40px 1%; vertical-align: top;}\r\n    .column3-icon {}\r\n    .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; }\r\n\r\n    .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n    /* BLOCK - 2columns */\r\n\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-2columns { text-align: center; margin: 0 auto; }\r\n    .holder-2column {width: 45%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n    .column2-icon {}\r\n    .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 */\r\n    .wrapper-2columns {width: 100%;}\r\n    .container-2columns {text-align: center; margin: 0 auto;}\r\n    .content-2columns-twothird-left {width:100%;  text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-twothird-right {width:100%;  text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-left {width:100%;  text-align: center; height: auto; min-height: auto; vertical-align: middle;}\r\n    .content-2columns-onethird-right {width:100%;  text-align: center; height: auto; min-height: auto; vertical-align: middle; margin-top:30px;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 IMAGES */\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n    .content-2columns-twothird-left-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-twothird-left-images img {width:100%; display: inline-block;}\r\n    .content-2columns-twothird-right-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-twothird-right-images img {width:100%; display: inline-block;}\r\n    .content-2columns-onethird-left-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-onethird-right-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-onethird-right-images img {width:100%; display: inline-block;}\r\n\r\n    /* BLOCK - 2columns <ul> <li> list */\r\n\r\n    .container-column2-list {width: 100%; margin: 60px auto;}\r\n    .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n    .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n    /* BLOCK - circles */\r\n\r\n    .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055; line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#075055; line-height:80px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#075055; line-height:70px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n\r\n    /* BLOCK  - Donate */\r\n\r\n    .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n    .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n    .container-contentblock-donate {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n    .container-contentblock-donate-orange {width: 90%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n    .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n    a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n    /* FOOTER */\r\n\r\n    .wrapper-footer {z-index: 99999999; width: 100%; position: absolute;}\r\n    .container-footer {z-index: 99999999; width: 90%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n    .footer-holder {z-index: 9999999999; width: 100%; margin: 0 0 40px 0;}\r\n    .footer-navL {z-index: 9999999999; width: 100%; text-align: center; margin: 0 auto;}\r\n    .footer-navR {z-index: 9999999999; width: 100%; text-align: ceter; margin: 0 auto;}\r\n    .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links {z-index: 9999999999; margin: 0 0 0 0;}\r\n    .footer-links ul {list-style-type: none; margin: 20px 0 60px 0; padding: 0;}\r\n    .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n    .footer-social {margin: 50px 0 0 0;}\r\n    .footer-social a {margin: 0 20px;}\r\n\r\n    .copyright {font-size: 10px; margin: 160px 0 80px 0; text-align: center; font-weight: 300; width: 100%; }\r\n\r\n    .footer-airplane {display: none; z-index: 999; position: absolute; margin: -100px 0 0 -180px; text-align: left;}\r\n\r\n    .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n    .footer-dot-blue80 {margin: 20px 0 0 -20px;}\r\n    .footer-dot-green60 {margin: 160px 0 0 10px;}\r\n    .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n    .footer-dot-blue60 {float: right; margin: -200px 40px 0 0;}\r\n    .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n    /* NEWS */\r\n\r\n    .wrapper-news-title {margin: 140px auto 0 auto; width: 90%; }\r\n    .holder-news-title {width: 100%; text-align: center; display: inline-block;}\r\n\r\n    h1.titlenews {font-size: 30px !important; margin: 0 !important;}\r\n\r\n    .wrapper-news-block {margin: 50px auto; width: 90%;}\r\n    .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px;}\r\n    .holder-news-image1 {width: 100%; }\r\n    .holder-news-image1 img {width: 100%;}\r\n    .holder-news-righttitle {width: 100%; text-align: left; margin: 30px 0 0 0;}\r\n\r\n    h1.news-title {color: #075055; font-size: 36px; margin: 0px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 40px; width: 100%;font-weight: 900;}\r\n    .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n    .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n    .wrapper-news-content {width: 90%; margin: 60px auto;}\r\n    .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n    h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n    .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n    .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px 60px 50px; min-height: 400px; vertical-align: top;}\r\n    .morestory-image {width: 100%;}\r\n    .morestory-image img {width: 100%;}\r\n    .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n    .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n    .morestory-text p {color: #fff;}\r\n    .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n    .morestory-link a {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n    .holder-media-left {width: 100%; text-align: center;}\r\n    .holder-contact-right {width: 100%; text-align: center;}\r\n\r\n    .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n    .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n    .holder-newslisting-image1 {width: 100%;}\r\n    .holder-newslisting-image1 img {width: 100%;}\r\n    .holder-newslisting-righttitle {width: 100%; text-align: left;}\r\n\r\n    h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n    .newslisting-type {background-color: #075055; font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 8px 30px; width: 200px; text-align: center; margin: 20px 0;}\r\n\r\n    .form-row {margin: 0 0 0 0;}\r\n    .form-cellhalf {width: 95%; margin: 0 0 20px 0;}\r\n    .form-cellfour {margin: 20px 0 0 0;}\r\n    .form-cellfull {width: 95%; margin: -25px 0 0 0;}\r\n    .form-text {width: 100%;}\r\n    .form-textfull {width: 100%;}\r\n\r\n\r\n  }\r\n\r\n  @media screen and (min-width: 0px) and (max-width: 375px) {\r\n    h1 {font-size: 36px; text-transform: uppercase; line-height: 46px;}\r\n    h2 {font-size: 30px; text-transform: uppercase; line-height: 40px;}\r\n    h3 {font-size: 24px; text-transform: uppercase; line-height: 36px; text-align: center;}\r\n    h4 {font-size: 21px; text-transform: uppercase; line-height: 29px;}\r\n    /* h5 {font-size: 21px; text-transform: uppercase; line-height: 28px;} */\r\n\r\n\r\n    .bluebutton {display:block; text-align: center; margin: 0 10%;}\r\n    .centered-button {display: inline-block; width: 90%; margin:0 auto;}\r\n    .mobile-menubutton {float: right; margin: 20px  0 0;}\r\n    .hidebr {display: none;} /*JC*/\r\n    .blockcontent-orange {font-size: 18px; color: #fbb03b; font-weight: 400; line-height: 24px;}\r\n    p.intro {font-size: 16px; font-weight: 500; line-height: 24px; text-align: left;}\r\n    p.vsmembernames {font-size:13px !important;}\r\n    li.vsmembernames {font-size:14px !important;}\r\n    .narrowwidth {width: 85% !important;}\r\n    .hidemobile {display: none !important;}\r\n    .scalemobile {width:100%;}\r\n\r\n    /* FRONT 2019 */\r\n\r\n    .front-picholder {width: 60%; margin: 0 auto; text-align: center;}\r\n    .front-picholder img {width: 100%;}\r\n    .front-pictext {width: 90%; text-align: center !important; margin: 20px auto;}\r\n    .front-pictext-right {width: 90%; text-align: left !important; float:right !important;}\r\n    .front-picholder-left {width: 60%; margin: 0 auto; text-align:center;}\r\n    .front-picholder-left img {width: 100%;}\r\n\r\n    .front-3column-holder {width: 60%; display: inline-block; text-align: center; margin: 0 2% 40px 2%; vertical-align: top; background-color: #fff;}\r\n    .front-3column-pic {width: 100%;}\r\n    .front-3column-pic img {width: 100%;}\r\n    .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n    .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n    .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n    .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n    .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n    .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n    .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n    .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n    /* VFV */\r\n    .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n    .vfv-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 20px 0;}\r\n    .vfv-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n    .vfv-sect2-brandingmark img {width: 90%;}\r\n    .vfv-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .vfv-sect2-button {margin: 40px 0 0 0; display: inline-block; width: 90%;}\r\n    .vfv-front-sect2-arrow {width: 100%; text-align: center; max-width:375px;}\r\n    .vfv-front-sect2-arrow {width: 100%; text-align: center; overflow-x: hidden !important;}\r\n\r\n    .vfv-videoslate {margin: 30px auto; border: 10px #e5ebf6 solid;  width: 100%;}\r\n\r\n    /* Simple Section 2 */\r\n    .wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #inherit; margin: 0 auto;}\r\n    .simple-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n    .simple-sect2-descright {text-align: center; width: 100%; color: #fff; font-size: 22px; line-height:30px;}\r\n    .simple-sect2-descleft {text-align: center; width: 90%; color: #fff; font-size: 22px; line-height: 30px;}\r\n    .simple-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n    .simple-sect2-button {margin: 40px 0 0 0;}\r\n    .simple-front-sect2-circle {width: 30% !important; text-align: center; margin: -27px auto 0 auto !important;}\r\n    .simple-front-sect2-circle img {width:100% !important; max-width: 180px;}\r\n\r\n\r\n    /* Simple Sect5 */\r\n    .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #f4f2f3; margin: 0 auto; }\r\n    .simple-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: center;}\r\n    .simple-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .simple-sect5-button {margin: 50px 0; display: inline-block; width:90%;}\r\n    .simple-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .simple-sect5-child img {display: none; width: 100%;}\r\n    .simple-sect5-child-circle {width: 90%; margin: 0 auto 30px auto; text-align: center;}\r\n    .simple-sect5-child-circle img {width: 100%;}\r\n\r\n\r\n    /* OMM */\r\n\r\n    .omm-faq {display: none;}\r\n\r\n    .omm-sectiontext {margin: 150px 0 0 30px !important;}\r\n\r\n    .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n    .omm-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 20px 0;}\r\n    .omm-sect2-brandingmark {width: 90%; text-align: center; padding-top: 10px; margin: 0 auto;}\r\n    .omm-sect2-brandingmark img {width: 90%;}\r\n    .omm-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .omm-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-button {margin: 40px 0 0 0; display: inline-block; width: 90%;}\r\n    /*.omm-front-sect2-arrow {width: 100%; text-align: center; max-width:375px;} */\r\n    .omm-front-sect2-arrow {width: 100%; text-align: center; overflow-x: hidden !important;}\r\n\r\n    .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n    .vp2020-container-front-sect2 {width: 90%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .vp2020-sect2-brandingmark {width: 90%; text-align: center; margin: 0 auto; }\r\n    .vp2020-sect2-brandingmark img {width:90%; display: block; }\r\n    .vp2020-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}\r\n    .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .vp2020-sect2-button {margin: 40px 0 0 0; display: inline-block; width: 90%;}\r\n    .vp2020-front-sect2-arrow {width: 100%; text-align: center; overflow-x:hidden !important;}\r\n\r\n    .omm-sect2-donatetext {width: 90%; margin: 0 auto; text-align: center; font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n    .omm-sect2-donateembed {text-align: center; width: 90%; margin: 0 auto;}\r\n\r\n    .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto; }\r\n    .omm-container-sect5 {width: 90%; margin: 0 auto; padding: 60px 0 40px 0; text-align: center;}\r\n    .omm-sect5-content {color: #fff; font-size: 18px; line-height: 28px;}\r\n    .omm-sect5-button {margin: 50px 0; display: inline-block; width:90%;}\r\n    .omm-sect5-child {float: right; width: 45%; margin: -60px 0 0 0;}\r\n    .omm-sect5-child img {display: none; width: 100%;}\r\n    .omm-sect5-child-circle {width: 90%; margin: 0 auto 30px auto; text-align: center;}\r\n    .omm-sect5-child-circle img {width: 100%;}\r\n\r\n    .omm-videoslate {margin: 30px auto; border: 10px #fbb03b solid;  width: 100%;}\r\n    .omm-donate-markholder {margin: -200px 0 0 0 !important; }\r\n    img.omm-donate-mark {width: 60% !important; }\r\n\r\n    .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n    .omm-container-orange {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n    .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n    .omm-container-blue {width: 100%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n    .omm-3col {border-bottom: 3px dotted #fff; padding: 0 0 50px 0;}\r\n\r\n    .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700; line-height: 60px;}\r\n    .omm-greatnews-stat {width: 100%; text-align: center;}\r\n    .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; width: 100%; text-align: center; margin: 40px 0 0 0;}\r\n    .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; width: 100%; text-align: center; text-transform: uppercase; vertical-align: top; line-height: 50px; margin: 40px 0 0px 0;}\r\n\r\n    .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n    .omm-checkout-brandingmark {width: 80%; margin: -80px auto 0 auto;}\r\n    .omm-checkout-brandingmark img {width:90%;}\r\n\r\n    .omm-container-checkout {width: 80%; margin: 50px auto;}\r\n    .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n    .omm-container-checkout img {width: 90%;}\r\n\r\n    .omm-thankyou-mark {width: 80%; text-align: center; margin: 100px auto 0 auto !important;}\r\n    .omm-thankyou-brandingmark {width: 70%; text-align: center; margin: 0 auto !important;}\r\n    .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n    .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .omm-container-faq {width: 90%; margin: 50px auto;}\r\n    .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n    .omm-faq-answer {display: block;}\r\n\r\n    a.omm-orange {font-size: 18px; color: #fff; text-transform: uppercase; background-color: #e5801a; padding: 16px 35px; letter-spacing: 2px; text-decoration: none; border: 4px solid #f7931e; border-radius: 20px 20px 20px 20px; }\r\n    a:visited.omm-orange {color: #fff; text-decoration: none;}\r\n    a:hover.omm-orange {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\n    a.omm-white {font-size: 18px; color: #e5801a; text-transform: uppercase; background-color: #fff; padding: 16px 30px; letter-spacing: 2px; text-decoration: none; border-radius: 20px 20px 20px 20px; font-weight: 600;}\r\n    a:visited.omm-white {color: #e5801a; text-decoration: none;}\r\n    a:hover.omm-white {background-color: #f7931e; color: #fff; text-decoration: none; }\r\n\r\n    .blockcontent-white2 {font-size: 20px; color: #fff; font-weight: 400; line-height: 32px;}\r\n\r\n    /* HEADER */\r\n\r\n    .wrapper-header-welcome {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-onemillion {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#229cb3 url(\"/static/assets/img/sectionpic-onemillion-m2.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n    .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout-m2.png\") no-repeat top; margin: 0 auto; height: 280px; min-height: 280px;}\r\n    .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-faq-m2.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n    .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n\r\n    .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n\r\n    .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-twomillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n    .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-help-a-child, .wrapper-header-form-embed {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-m2-help-a-child.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n    .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-see-kids-soar-eoa, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-grants-for-good-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-grantsforgoodsight-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-cltl-day, .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-m2.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect-m2.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n    .wrapper-header-cltl-day-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision-m2.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n    .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday-m2.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n    .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021-m2.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 650px;}\r\n\r\n    .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons-m2.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n    .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons-m.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n\r\n    .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 480px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-golfthankyou {width: 100%; max-width: 480px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-impact-report {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-impactreport-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n    .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk-m2.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n    /* PARTNERSHIPS HEADER IMAGES */\r\n    .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    /* STORY HEADER IMAGE */\r\n    .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie-m2.png\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n    .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl-m2.jpg\") no-repeat top; margin: 0 auto; height: 650px; min-height: 650px;}\r\n\r\n    .container-header {z-index: 9999999999; width: 90%; max-width: 1000px; margin: 0 auto;}\r\n    .m-wrapper-sectionpic {width: 100%; z-index: 9999;}\r\n    .m-wrapper-sectionpic img {width: 100%;}\r\n\r\n    .header-logo {float: left; width: 160px; margin: 20px 0 0 0;}\r\n    .header-logo img {width: 100%;}\r\n    .topnav {display: none; float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 80px; font-weight: 700;}\r\n    .topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n    .topnav a:visited {text-decoration: none;}\r\n    .topnav a:hover {text-decoration: none;}\r\n\r\n    .header-donate {display: none; z-index: 99999999; float: right; margin: 20px 0 0 0;}\r\n\r\n    .header-sectiontext-wide {position: absolute; margin: 170px 0 0 5%; color: #fff; height: 400px; display: table; width: 400px;}\r\n    .header-sectiontext {position: absolute; margin: 150px 0 0 5%; color: #fff; height: 400px; display: table; width: 90%;}\r\n    .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n    .sectiontext-headline {font-size: 38px; text-transform: uppercase; font-weight: 600; line-height: 38px; width: 100%;}\r\n    .sectiontext-headlinethin {font-size: 38px; text-transform: uppercase; font-weight: 300;}\r\n\r\n    .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 20px 0 0 0; line-height: 24px; width: 100%;}\r\n    .sectiontext-desc-large {font-size: 20px; font-weight: 400; margin: 20px 0 0 0; line-height: 26px; width: 80%;}\r\n\r\n\r\n\r\n    .header-airplane {z-index: 999; position: absolute; margin: 30px 0 0 -120px;}\r\n    .header-airplane img {width: 400px;}\r\n    .header-dots {display: none; z-index: 100; margin: -50px -20px 0 0; float: right; }\r\n\r\n    .topnav-dropdown {display: none;}\r\n    .topnav-dropdown-sticky {display: none;}\r\n\r\n    /* STICY HEADER */\r\n\r\n    .container-header-sticky {z-index: 99999999; width: 100%; max-width: 1440px; margin: 0 auto; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n    .holder-header-sticky {width: 100%; margin: 0 auto;}\r\n    .s-header-logo {float: left; margin: 10px 0 0 30px; width: 60%;}\r\n    .s-header-logo img {width: 100%;}\r\n    .s-topnav {display: none; float: left; margin: 26px 0 0 50px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n    .s-topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n    .s-topnav a:visited {text-decoration: none;}\r\n    .s-topnav a:hover {text-decoration: none;}\r\n    .s-header-donate {display: none; float: right; margin: 24px 0 0 0;}\r\n    .s-mobile-menubutton {float: right; margin: 20px 30px 0 0;}\r\n\r\n    /* SUBNAV */\r\n\r\n    .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n    .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n    .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .container-subnav ul li {margin: 0 30px; padding: 0; font-size: 24px; text-transform: uppercase; font-weight: 500;}\r\n    .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n    .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n\r\n    /* PARTNERSHIPS STYLES */\r\n    .program-bgimage {z-index: 1; width: 70%; position: relative; text-align: center; display: inline-block; margin: 0 0 0 -120px; vertical-align: bottom; opacity: 0.15; filter: alpha(opacity=15);}\r\n    .program-text {z-index: 5; width:80%; position: relative; text-align: center; display: inline-block; margin: -450px 0 30px 10%; vertical-align: top;}\r\n    .program-text img {margin: 0 auto; width:80%;}\r\n\r\n    .partner-social {margin: 20px 0 0 0;}\r\n    .partner-social a {margin: 0 10px;}\r\n\r\n    .partner-logo {margin: 40px 0;}\r\n    .partner-logo img {width: 80%;}\r\n\r\n    /* FRONT - BLOCK - 3columns */\r\n\r\n    .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-3columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-3column {width: 90%; text-align: center; display: inline-block; margin: 0 2% 40px 2%; vertical-align: top;}\r\n    .front-column3-icon {margin: 20px 0;}\r\n    .front-column3-icon img {width: 60%; }\r\n    .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #229cb4; }\r\n\r\n    .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    .front-container-4columns { text-align: center; margin: 30px auto; }\r\n    .front-holder-4column {width: 90%; text-align: center; display: inline-block; margin: 0 2% 40px 2%; vertical-align: top;}\r\n    .front-column4-icon {margin: 20px 0;}\r\n    .front-column4-icon img {width: 60%; }\r\n\r\n    /* RESOURCES NEW */\r\n\r\n    SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 100%; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n    .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n    .holder-block-resourcesnewText {}\r\n    .adjustTop1 {}\r\n    .adjustTop2 {}\r\n\r\n    .holder-block-resourcesnewTitleRight {width: 90%; text-align: center; margin: 0 auto;}\r\n    .holder-block-resourcesnewContentLeft {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n    .holder-block-resourcesnewTitleLeft {width: 90%; text-align: center; margin: 0 auto;}\r\n    .holder-block-resourcesnewContentRight {width: 90%; text-align: center; margin: 0 auto; border-bottom: 2px dotted #229cb4; padding: 0 0 40px 0;}\r\n\r\n    /* CONTENT */\r\n\r\n    .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n    .content-story-column {width: 100%; text-align: left; margin:0 auto;}\r\n    .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 80%; margin: 100px auto; text-align: center;}\r\n    .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n    .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .pretextimage {float: right; margin: 0 0 30px 30px; width: 25%;}\r\n    .pretextimage img {width: 90%;}\r\n\r\n    .wrapper-contentblock-white img.pretext {width: 40%; display: block;}\r\n\r\n    .blockcontent img {width: 30%;}\r\n\r\n    a.button-marketingresources {letter-spacing: 0; font-size: 16px;}\r\n\r\n    /* BLOCK - COLOR */\r\n\r\n    .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n    .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color:#115e67;}\r\n    .wrapper-contentblock-green-0 {width: 100%; margin: 0 auto; max-width: 1440px; text-align: center; background-color: #115e67;}\r\n    .container-contentblock-beige, .container-contentblock-green, .container-contentblock, .container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n    .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n\r\n    /* BLOCK - 2cols offset with image */\r\n\r\n    .wrapper-2block-left {width: 100%; max-width: 1400px; margin: 20px auto; }\r\n    .holder-2blockL-image {width: 100%; margin: 20px auto;}\r\n    .holder-2blockL-image img {width: 100%;}\r\n    .holder-2blockL-content {width: 80%; text-align: left; height: auto; min-height: auto; margin: 30px auto;}\r\n\r\n    .wrapper-2block-right {width: 100%; max-width: 1400px; margin: 100px auto; }\r\n    .holder-2blockR-content {width: 80%; text-align: left; height: auto; min-height: auto; margin: 30px auto;}\r\n    .holder-2blockR-image {width: 100%; margin: 30px auto;}\r\n    .holder-2blockR-image img {width: 100%;}\r\n\r\n    /* BLOCK - 2cols offset with Bio */\r\n\r\n    .wrapper-2block-leftbio {width: 90%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n    .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n    .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n    h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n    .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n    .holder-2block-desc {}\r\n\r\n    /* BLOCK - 3columns */\r\n\r\n    .wrapper-3columns {width: 90%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-3columns { text-align: center; margin: 0 auto; }\r\n    .holder-3column {width: 80%; text-align: center; display: inline-block; margin: 0 1% 40px 1%; vertical-align: top;}\r\n    .column3-icon {}\r\n    .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; }\r\n\r\n    .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n    /* BLOCK - 2columns */\r\n\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n    .container-2columns { text-align: center; margin: 0 auto; }\r\n    .holder-2column {width: 45%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n    .column2-icon {}\r\n    .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n    .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n    /* BLOCK - 2columns 1/3 2/3 IMAGES */\r\n    .wrapper-2columns {width: 100%; margin: 0 auto; text-align: center;}\r\n    /* .container-2columns {text-align: center; margin: 0 auto;} */\r\n    .content-2columns-twothird-left-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-twothird-left-images img {width:100%; display: inline-block;}\r\n    .content-2columns-twothird-right-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-twothird-right-images img {width:100%; display: inline-block;}\r\n    .content-2columns-onethird-left-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-onethird-right-images {width:99%; margin: 0 auto; text-align: center;}\r\n    .content-2columns-onethird-right-images img {width:100%; display: inline-block;}\r\n\r\n    /* BLOCK - 2columns <ul> <li> list */\r\n\r\n    .container-column2-list {width: 100%; margin: 60px auto;}\r\n    .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n    .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n    .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n    /* BLOCK - circles */\r\n\r\n    .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055; line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#075055;line-height:80px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n    .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n    .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n    .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n    .circle-white-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#075055; line-height:70px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n\r\n    /* BLOCK  - Donate */\r\n\r\n    .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n    .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n    .container-contentblock-donate {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n    .container-contentblock-donate-orange {width: 90%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n    .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n    a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 80%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n    a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n    /* FOOTER */\r\n\r\n    .wrapper-footer {z-index: 9999; width: 100%; position: absolute;}\r\n    .container-footer {z-index: 9999; width: 90%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n    .footer-holder {z-index: 9999; width: 100%; margin: 0 0 40px 0;}\r\n    .footer-navL {z-index: 9999; width: 100%; text-align: center; margin: 0 auto;}\r\n    .footer-navR {z-index: 9999; width: 100%; text-align: ceter; margin: 0 auto;}\r\n    .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links {z-index: 9999; margin: 0 0 0 0;}\r\n    .footer-links ul {list-style-type: none; margin: 20px 0 60px 0; padding: 0;}\r\n    .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n    .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n    .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n    .footer-social {margin: 50px 0 0 0;}\r\n    .footer-social a {margin: 0 20px;}\r\n\r\n    .copyright {font-size: 10px; margin: 160px 0 80px 0; text-align: center; font-weight: 300; width: 100%; }\r\n\r\n    .footer-airplane {display: none; z-index: 999; width: 100%; position: absolute; margin: -100px 0 0 -180px; text-align: left;}\r\n    .footer-airplane img {width: 90%;}\r\n\r\n    .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n    .footer-dot-blue80 {margin: 20px 0 0 -20px;}\r\n    .footer-dot-green60 {margin: 160px 0 0 10px;}\r\n    .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n    .footer-dot-blue60 {float: right; margin: -200px 40px 0 0;}\r\n    .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n    /* NEWS */\r\n\r\n    .wrapper-news-title {margin: 140px auto 0 auto; width: 90%; }\r\n    .holder-news-title {width: 100%; text-align: center; display: inline-block;}\r\n\r\n    h1.titlenews {font-size: 30px !important; margin: 0 !important;}\r\n\r\n    .wrapper-news-block {margin: 50px auto; width: 90%;}\r\n    .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px;}\r\n    .holder-news-image1 {width: 100%; }\r\n    .holder-news-image1 img {width: 100%;}\r\n    .holder-news-righttitle {width: 100%; text-align: left; margin: 30px 0 0 0;}\r\n\r\n    h1.news-title {color: #075055; font-size: 36px; margin: 0px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 40px; width: 100%;font-weight: 900;}\r\n    .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n    .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n    .wrapper-news-content {width: 90%; margin: 60px auto;}\r\n    .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n    h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n    .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n    .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px 60px 50px; min-height: 400px; vertical-align: top;}\r\n    .morestory-image {width: 100%;}\r\n    .morestory-image img {width: 100%;}\r\n    .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n    .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n    .morestory-text p {color: #fff;}\r\n    .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n    .morestory-link a {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n    .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n    .holder-media-left {width: 100%; text-align: center;}\r\n    .holder-contact-right {width: 100%; text-align: center;}\r\n\r\n    .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n    .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n    .holder-newslisting-image1 {width: 100%;}\r\n    .holder-newslisting-image1 img {width: 100%;}\r\n    .holder-newslisting-righttitle {width: 100%; text-align: left;}\r\n\r\n    h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n    .newslisting-type {background-color: #075055; font-size: 15px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 8px 30px; width: 200px; text-align: center; margin: 20px 0;}\r\n\r\n    .form-row {margin: 0 0 0 0;}\r\n    .form-cellhalf {width: 95%; margin: 0 0 20px 0;}\r\n    .form-cellfour {margin: 20px 0 0 0;}\r\n    .form-cellfull {width: 95%; margin: -25px 0 0 0;}\r\n    .form-text {width: 100%;}\r\n    .form-textfull {width: 100%;}\r\n\r\n  }\r\n\r\n}\r\n\r\n@media screen and (min-width: 1440px) {\r\n\r\n  .mobile-menubutton, .m-wrapper-sectionpic {display: none;}\r\n  /* PARTNERSHIPS STYLES */\r\n  .program-bgimage {width: 40%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: bottom;}\r\n  .program-text {width:40%; text-align: center; display: inline-block; margin: 4% 0; vertical-align: top;}\r\n  .program-text img {margin: 20px auto;}\r\n\r\n  .program-2columns-bgimage {width: 40%; float: left; text-align: center; display: inline-block; margin: 0 auto; vertical-align: middle;}\r\n  .program-2columns-bgimage img {width:85%; max-width: 500px; margin: 0 auto;}\r\n  .program-2columns-text {width:40%; float: right; text-align: center; display: inline-block; margin: 7% 6%; vertical-align: top;}\r\n  .program-text img {margin: 20px auto;}\r\n\r\n  .partner-social {margin: 20px 0 0 0;}\r\n  .partner-social a {margin: 0 20px;}\r\n\r\n  .partner-logo {margin: 40px 0;}\r\n\r\n  .narrowwidth {width: 48% !important;}\r\n\r\n  /* FRONT 2019 */\r\n\r\n  .front-picholder {width: 45%; float: right;}\r\n  .front-pictext {width: 50%; text-align: left !important;}\r\n  .front-pictext-right {width: 50%; text-align: left !important; float:right !important;}\r\n  .front-picholder-left {width: 45%; float: left;}\r\n\r\n  .front-3column-holder {width: 25%; max-width: 305px; display: inline-block; text-align: center; margin: 0 2%; vertical-align: top; background-color: #fff;}\r\n  .front-3column-pic {width: 100%;}\r\n  .front-3column-pic img {width: 100%;}\r\n  .front-3column-title {color: #333; font-weight: 700; text-transform: uppercase; margin: 20px 0; font-size: 18px;}\r\n  .front-3column-text {margin: 0 20px; font-size: 18px;}\r\n  .front-3column-link {margin: 30px 0; text-transform: uppercase;}\r\n  .front-3column-link a {color: #179ab2 !important; text-decoration: underline;}\r\n  .front-3column-link a:visited {color: #179ab2 !important; text-decoration: underline;}\r\n  .front-3column-link a:hover {color: #179ab2 !important; text-decoration: underline;}\r\n\r\n  .front-3column-alllink {margin: 50px 0; font-size: 20px; text-transform: uppercase;}\r\n  .front-3column-alllink a {color: #fff !important; text-decoration: underline;}\r\n  .front-3column-alllink a:visited {color: #fff !important; text-decoration: underline;}\r\n  .front-3column-alllink a:hover {color: #fff !important; text-decoration: underline;}\r\n\r\n  /* VFV */\r\n  .vfv-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #e5ebf6; margin: 0 auto;}\r\n  .vfv-container-front-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n  .vfv-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n  .vfv-sect2-desc {float: right; text-align: center; width: 45%;}\r\n  .vfv-sect2-text {font-size: 20px; color: #666; font-weight: 400; line-height: 30px;}\r\n  .vfv-sect2-button {margin: 40px 0 0 0;}\r\n  .vfv-front-sect2-arrow {width: 100%; text-align: center;}\r\n  .vfv-front-sec2-arrow {width: 100%; text-align: center; overflow-x:hidden !important;}\r\n\r\n  .vfv-videoslate {margin: 30px auto; border: 20px #e5ebf6 solid;  width: 70%;}\r\n\r\n  /* Simple Sect5 */\r\n  .simple-wrapper-sect5 {width: 100%; max-width: 1440px; background:#f4f2f3 url(\"/static/assets/img/simple-sect5-childbg-bday.jpg\") no-repeat bottom right; margin: 0 auto; min-height: 750px;}\r\n  .simple-container-sect5 {width: 650px; margin: 0 0 0 145px; padding: 60px 0 0 0; text-align: center;}\r\n  .simple-sect5-content {color: #fff; font-size: 20px; line-height: 30px;}\r\n  .simple-sect5-button {margin: 50px 0;}\r\n  .simple-sect5-child {display: none;}\r\n  .simple-sect5-child-circle {display: none;}\r\n\r\n\r\n  /* OMM */\r\n\r\n  .omm-faq-m {display: none;}\r\n\r\n  .omm-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #229cb3; margin: 0 auto;}\r\n  .omm-container-front-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n  .omm-sect2-brandingmark {float: left; width: 45%; text-align: center; }\r\n  .omm-sect2-desc {float: right; text-align: center; width: 45%;}\r\n  .omm-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n  .omm-sect2-button {margin: 40px 0 0 0;}\r\n  /*.omm-front-sect2-arrow {width: 100%; text-align: center;}*/\r\n  .omm-front-sec2-arrow {width: 100%; text-align: center; overflow-x:hidden !important;}\r\n\r\n  .vp2020-wrapper-front-sect2 {width: 100%; max-width: 1440px; background-color: #115e67; margin: 0 auto;}\r\n  .vp2020-container-front-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n  .vp2020-sect2-brandingmark {float: left; width: 45%; text-align: center; margin: 0 auto; }\r\n  .vp2020-sect2-brandingmark img {max-width:300px; }\r\n  /*.vp2020-sect2-desc {text-align: center; width: 90%; margin: 30px auto;}*/\r\n  .vp2020-sect2-text {font-size: 20px; color: #fff; font-weight: 400; line-height: 30px;}\r\n  .vp2020-sect2-button {margin: 40px 0 0 0;}\r\n  .vp2020-front-sect2-arrow {width: 100%; text-align: center; overflow-x: hidden !important;}\r\n\r\n  .omm-sect2-donatetext {float: left; width: 100%; text-align: left; font-size: 30px; color: #fff; font-weight: 800; line-height: 40px;}\r\n  .omm-sect2-donateembed {float: right; text-align: center; width: 35%;}\r\n\r\n  .omm-front-wrapper-sect5 {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/omm-sect5-childbg.jpg\") no-repeat bottom right; margin: 0 auto; min-height: 800px;}\r\n  .omm-container-sect5 {width: 580px; margin: 0 0 0 250px; padding: 60px 0 0 0; text-align: left;}\r\n  .omm-sect5-content {color: #fff; font-size: 20px; line-height: 30px;}\r\n  .omm-sect5-button {margin: 50px 0;}\r\n  .omm-sect5-child {display: none;}\r\n  .omm-sect5-child-circle {display: none;}\r\n\r\n  .omm-videoslate {margin: 30px auto; border: 20px #fbb03b solid;  width: 70%;}\r\n\r\n  .omm-wrapper-orange {width: 100%; max-width: 1440px; background-color: #fbb03b; margin: 0 auto;}\r\n  .omm-container-orange {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n  .omm-wrapper-blue {width: 100%; max-width: 1440px; background-color: #0071bc; margin: 0 auto;}\r\n  .omm-container-blue {width: 80%; margin: 0 auto;  text-align: center; padding: 60px 0 80px 0;}\r\n\r\n  .omm-greatnews-top {color: #e5801a; font-size: 60px; text-transform: uppercase; font-weight: 700;}\r\n  .omm-greatnews-stat {margin: 30px 0 0 0;}\r\n  .omm-greatnews-percent {color: #e5801a; font-size: 120px; font-weight: 600; float: left; text-align: right; width: 40%; vertical-align: top; margin: 40px 0 0 0;}\r\n  .omm-greatnews-desc {color: #fbb03b; font-size: 30px; font-weight: 400; float: left ; text-align: left; text-transform: uppercase; width: 40%; vertical-align: top; line-height: 50px; margin: 0 0 0 50px;}\r\n\r\n  .omm-container-front-checkout-sect2 {width: 80%; margin: 0 auto;  text-align: center; padding: 30px 0;}\r\n  .omm-checkout-brandingmark {width: 50%; margin: 0 auto;}\r\n  .omm-checkout-brandingmark img {width:90%;}\r\n\r\n  .omm-container-checkout {width: 50%; margin: 50px auto;}\r\n  .omm-checkout-content {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n  .omm-thankyou-brandingmark {width: 70%; margin: 0 0 0 -30px;}\r\n  .omm-thankyou-brandingmark img {width: 100%;}\r\n\r\n  .omm-thankyou-wrapper-blue {background-color: #0071bc; width: 100%; max-width: 1440px; margin: 0 auto;}\r\n  .omm-thankyou-container {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n  .omm-container-faq {width: 70%; margin: 50px auto;}\r\n  .omm-checkout-faq {line-height: 30px; font-size: 18px; margin: 30px 0;}\r\n\r\n  /* HEADER */\r\n\r\n  .wrapper-header-welcome {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-onemillion {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-onemillion-landing {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-donate.jpg\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n  .wrapper-header-onemillion-donate, .wrapper-header-onemillion-onetime-checkout, .wrapper-header-onemillion-monthly-checkout {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-checkout.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n  .wrapper-header-onemillion-faq {width: 100%; max-width: 1440px; background:#fbb03b url(\"/static/assets/img/sectionpic-onemillion-faq.png\") no-repeat top; margin: 0 auto; height: 350px; min-height: 350px;}\r\n  .wrapper-header-onemillion-confirmation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-onemillion-confirmation.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-2020-vision-pledge-home {width: 100%; max-width: 1440px; background: #115e67 url(\"/static/assets/img/sectionpic-marsai.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-vision-pledge {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-visionpledge.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-twomillion, .wrapper-header-twomillion-landing {width: 100%; max-width: 1440px; background: #fff url(\"/static/assets/img/sectionpic-onemillion.png\") no-repeat top; margin: 0 auto; height: 500px; min-height: 500px;}\r\n\r\n  .wrapper-header-about-us {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-aboutus.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-our-cause {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourcause.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-help-a-child {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-a-child.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-donation, .wrapper-header-ways-to-give {width: 100%; max-width: 1440px; background:#075055 url(\"/static/assets/img/sectionpic-ways-to-give.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-our-work, .wrapper-header-share-your-story {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-ourwork.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-get-involved {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-getinvolved.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-schools, .wrapper-header-kvfl-school-resources {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-schools.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-eye-doctors {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eyedoctors.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-charities {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-charities.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-corporations, .wrapper-header-corporate-partnerships-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-corporations.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-parents.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-kids-vision-for-life {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kvfl.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-updates-covid19, .wrapper-header-front-page-stl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-show-the-love {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-updates-covid19.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-champions-for-sight-signup {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cfs-sweepstake.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-resources, .wrapper-header-resources-resources-new, .wrapper-header-resources-doctors, .wrapper-header-resources-charities, .wrapper-header-resources-schools, .wrapper-header-resources-parents {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-resources.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-in-office-donation-campaigns, .wrapper-header-see-kids-soar-enrollment, .wrapper-header-sks-foxfire, .wrapper-header-see-kids-soar-enrollment-foxfire, .wrapper-header-see-kids-soar-draft, .wrapper-header-see-kids-soar, .wrapper-header-see-kids-soar-relevate, .wrapper-header-see-kids-soar-ee, .wrapper-header-see-kids-soar-eoa, .wrapper-header-frequently-asked-questions-sks, .wrapper-header-see-kids-soar-visionsource {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-inofficedonations.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-champions-for-sight {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-championsforsight.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-community-grants {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-communitygrants.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-lens-and-labs-services, .wrapper-header-lens-and-labs-services-khloe {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n\r\n  .wrapper-header-cltl-day, .wrapper-header-cltl-day-schedule, .wrapper-header-cltl-pick-a-day {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-cltl-connect {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-connect.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-cltl-day-schedule {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cltl-day-short.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n  .wrapper-header-cltl-relief-campaign {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-lenslabs.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-your-amazing-eyes {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-amazingeyes.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-vote-for-vision {width: 100%; max-width: 1440px; background:#e5ebf6 url(\"/static/assets/img/sectionpic-voteforvision.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-presidents-day-kit-download {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-presday.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-help-kids-see-clearly-2021 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-help-kids-see-clearly-2021.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-super-reasons-visit-eye-doctor-free-education-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-superreasons.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-thank-you-super-reasons-download, .wrapper-header-superhero-comic-book-upload, .wrapper-header-super-sight-six {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyou-superreasons.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n\r\n  .wrapper-header-donate-onetime, .wrapper-header-donate-monthly, .wrapper-header-give {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n  .wrapper-header-contact {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n  .wrapper-header-sweepstakes-thankyou-cfs {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n  .wrapper-header-golfthankyou {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-sweepstakesthankyou.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n  .wrapper-header-visionary-society, .wrapper-header-visionary-society-members {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-welcome.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-impact-report {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-impactreport.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .wrapper-header-disclosures {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n  .wrapper-header-thank-you-subscribe, .wrapper-header-thank-you-your-amazing-eyes, .wrapper-header-subscribe, .wrapper-header-thank-you-presidents-day-kit {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-thankyousubscribe.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n  .wrapper-header-seekidssoardonation {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-donate.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n  .wrapper-header-pivva {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-pivva.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-videos, .wrapper-header-visionary-society-thank-you, .wrapper-header-thank-you-vday-2020, .wrapper-header-immediate-impact-1 {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-videos.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n  .wrapper-header-pivva-see-kids-soar {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-talk.png\") no-repeat top; margin: 0 auto; height: 250px; min-height: 250px;}\r\n\r\n  .wrapper-header-stories-draft {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-stories-draft.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  /* PARTNERSHIPS HEADER IMAGES */\r\n  .wrapper-header-walman-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walman-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-walmart-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-walmart-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-essilor-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-essilor-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-costa-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-costa-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-perc-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-perc-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-dallas-cowboys-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-cowboys-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-foxfire-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-foxfire-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-percept-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-percept-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-kendrascott-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-kendrascott-partnership.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-triangle-visions-partnership {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-triangle-visions-partnership.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  /* STORY HEADER IMAGE */\r\n  .wrapper-header-khloe, .wrapper-header-stories {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-khloe.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-rebecca {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-rebecca.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-victoria {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-victoria.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-eddie {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-eddie.png\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n  .wrapper-header-daniel-sam-owl {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/sectionpic-daniel-sam-owl.jpg\") no-repeat top; margin: 0 auto; height: 700px; min-height: 700px;}\r\n\r\n  .container-header {z-index: 9999999999; width: 100%; max-width: 1000px; margin: 0 auto;}\r\n\r\n  .header-logo {float: left; width: 200px; margin: 20px 0 0 0;}\r\n  .header-logo img {width: 100%;}\r\n  .topnav {float: left; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; margin: 20px 0 0 70px; font-weight: 700;}\r\n  .topnav a {text-decoration: none; margin: 0 30px 0 0;}\r\n  .topnav a:visited {text-decoration: none;}\r\n  .topnav a:hover {text-decoration: none;}\r\n\r\n  .header-donate {z-index: 99999999; float: right; margin: 20px 50px 0 0;}\r\n\r\n  .header-sectiontext-wide {position: absolute; margin: 150px 0 0 6%; color: #fff; height: 400px; display: table; width: 550px;}\r\n  .header-sectiontext {position: absolute; margin: 150px 0 0 220px; color: #fff; height: 400px; display: table; width: 550px;}\r\n  .holder-sectiontext {display: table-cell; vertical-align: bottom;}\r\n  .sectiontext-headline {font-size: 62px; text-transform: uppercase; font-weight: 600; line-height: 62px; width: 100%;}\r\n  .sectiontext-headlinethin {font-size: 62px; text-transform: uppercase; font-weight: 300;}\r\n\r\n  .sectiontext-desc {font-size: 18px; font-weight: 300; margin: 40px 0 0 0; line-height: 30px; width: 80%;}\r\n  .sectiontext-desc-large {font-size: 24px; font-weight: 400; margin: 40px 0 0 0; line-height: 34px; width: 80%;}\r\n\r\n  .header-airplane {z-index: 999; position: absolute; margin: 50px 0 0 -100px;}\r\n  .header-dots {z-index: 999; margin: -10px -220px 0 0; float: right;}\r\n\r\n  /* STICKY HEADER */\r\n\r\n  .container-header-sticky {z-index: 9999999999; width: 100%; max-width: 1440px; margin: 0 0 0 0px; background-color: #f8f6f1; height: 70px; min-height: 70px; position: fixed;}\r\n  .holder-header-sticky {width: 96%; max-width: 1440px; margin: 0 auto;}\r\n  .s-header-logo {float: left; width: 300px; margin: 16px 0 0 0;}\r\n  .s-header-logo img {width: 100%;}\r\n  .s-topnav {float: left; margin: 26px 0 0 20px; text-transform: uppercase; font-size: 14px; letter-spacing: 1.5px; font-weight: 700;}\r\n  .s-topnav a {text-decoration: none; margin: 0 20px 0 0;}\r\n  .s-topnav a:visited {text-decoration: none;}\r\n  .s-topnav a:hover {text-decoration: none;}\r\n  .s-header-donate {float: right; margin: 24px 0 0 0;}\r\n  .s-mobile-menubutton {display: none;}\r\n\r\n  /* SUBNAV */\r\n\r\n  .subnav-title {color: #ccc; font-size: 18px; text-transform: uppercase; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 10px;}\r\n\r\n  .container-subnav {width: 100%; text-align: center; margin: 40px 0;}\r\n  .container-subnav ul {list-style-type: none; margin: 0; padding: 0;}\r\n  .container-subnav ul li {margin: 0 30px; padding: 0; display: inline; font-size: 30px; text-transform: uppercase; font-weight: 500;}\r\n  .container-subnav ul li a {color: #075055; text-decoration: none;}\r\n  .container-subnav ul li a:visited {color: #075055; text-decoration: none;}\r\n  .container-subnav ul li a:hover {color: #229cb3; text-decoration: none;}\r\n\r\n\r\n  /* FRONT - BLOCK - 3columns */\r\n\r\n  .front-wrapper-3columns {width: 100%; margin: 0 auto; text-align: center;}\r\n  .front-container-3columns { text-align: center; margin: 30px auto; }\r\n  .front-holder-3column {width: 28%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n  .front-column3-icon {margin: 20px 0;}\r\n  .front-column3-icon img {width: 80%; }\r\n  .front-column3-title {font-size: 18px; text-transform: uppercase; font-weight: 600; color: #229cb4; }\r\n\r\n  .front-wrapper-4columns {width: 100%; margin: 0 auto; text-align: center;}\r\n  .front-container-4columns { text-align: center; margin: 30px auto; }\r\n  .front-holder-4column {width: 20%; text-align: center; display: inline-block; margin: 0 2%; vertical-align: top;}\r\n  .front-column4-icon {margin: 20px 0;}\r\n  .front-column4-icon img {width: 60%; }\r\n\r\n  /* CONTENT */\r\n\r\n  .wrapper-content {width: 100%; max-width: 1440px; margin: 0 auto;}\r\n\r\n  .wrapper-contentblock-white {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 80%; margin: 100px auto; text-align: center;}\r\n  .wrapper-contentblock-white-wide {font-size: 16px; color: #6f6e6d; font-weight: 400; line-height: 28px; width: 90%; margin: 100px auto; text-align: center;}\r\n\r\n  .container-contentblock-wide {width: 80%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n  .pretextimage {float: right; margin: 0 30px 30px 30px; width: 25%;}\r\n  .pretextimage img {width: 60%;}\r\n\r\n\r\n  .blockcontent img {width: 60%;} /*JC*/\r\n  .blockcontent img.pretextimage {width: 15%;} /*JC*/\r\n\r\n  /* BLOCK - BEIGE */\r\n\r\n  .wrapper-contentblock-beige {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1;}\r\n  .wrapper-contentblock-blue {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color: #179ab2;}\r\n  .wrapper-contentblock-white {width: 100%; margin: 60px auto; max-width: 1440px; text-align: left; background-color: #fff;}\r\n  .wrapper-contentblock-green {width: 100%; margin: 100px auto; max-width: 1440px; text-align: center; background-color:#115e67;}\r\n  .container-contentblock-beige, .container-contentblock-green, .container-contentblock-blue {width: 90%; margin: 0 auto; text-align: center; padding: 50px 0;}\r\n\r\n\r\n  /* BLOCK - 2cols offset with image */\r\n\r\n  .wrapper-2block-left {width: 100%; margin: 20px auto;}\r\n  .holder-2blockL-image {width: 45%; float: left;}\r\n  .holder-2blockL-image img {width: 100%;}\r\n  .holder-2blockL-content {width: 50%; float: right; text-align: left; height: auto; min-height: auto; vertical-align: middle; padding-top: 100px;}\r\n  .holder-2blockL-desc {padding: 0 30% 0 0; font-size: 18px; line-height: 30px;}\r\n\r\n  .wrapper-2block-right {width: 100%; margin: 100px auto; vertical-align: middle;}\r\n  .holder-2blockR-content {width: 50%; float: left; text-align: right; height: auto; min-height: auto; vertical-align: middle; padding-top: 100px;}\r\n  .holder-2blockR-image {width: 45%; float: right;}\r\n  .holder-2blockR-image img {width: 100%;}\r\n  .holder-2blockR-desc {padding: 0 0 0 30%; font-size: 18px; line-height: 30px;}\r\n\r\n  /* BLOCK - 2cols offset with Bio */\r\n\r\n  .wrapper-2block-leftbio {width: 100%; max-width: 1400px; margin: 20px auto 50px auto; }\r\n  .holder-2blockL-name {width: 45%; float: left; text-align: right;}\r\n  .holder-2blockL-bio {width: 50%; float: right; text-align: left; vertical-align: top; }\r\n  h1.holder-2block-titlename {text-transform: uppercase; font-size: 18px; color: #075055; margin: 2px 0 8px 0; padding: 0;}\r\n  .holder-2block-position {font-size: 18px; text-transform: uppercase; color: #075055; font-weight: 400;}\r\n  .holder-2block-desc {}\r\n\r\n  /* BLOCK - 3columns */\r\n\r\n  .wrapper-3columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n  .container-3columns { text-align: center; margin: 0 auto; }\r\n  .holder-3column {width: 30%; text-align: center; display: inline-block; margin: 0 1%; vertical-align: top;}\r\n  .column3-icon {}\r\n  .column3-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n  .column3-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 180px;}\r\n\r\n  .wrapper-3columns-blue {width: 80%; margin: 50px auto 10px auto; text-align: center; color: #fff; font-size: 20px; line-height: 30px;}\r\n\r\n  /* BLOCK - 2columns */\r\n\r\n  .wrapper-2columns {width: 100%; margin: 0 auto; background-color: #fff; text-align: center;}\r\n  .container-2columns { text-align: center; margin: 0 auto; }\r\n  .holder-2column {width: 35%; text-align: center; display: inline-block; margin: 0 4%; vertical-align: top;}\r\n  .column2-icon {}\r\n  .column2-title {font-size: 18px; text-transform: uppercase; font-weight: 300;}\r\n  .column2-desc {font-size: 14px; margin: 30px 0; line-height: 24px; min-height: 100px;}\r\n\r\n  /* RESOURCES NEW */\r\n\r\n  SELECT.selectResources {font-size: 24px; color: #075055; background-color: #fff; border: 4px solid #229cb4; border-radius: 1;  width: 400px; height: 60px; text-align: center; margin: 20px 0; text-transform: uppercase; text-align-last: center;}\r\n\r\n  .resources-container-grid {width: 100%; overflow: hidden; }\r\n\r\n  .holder-block-resourcesnewText {position: absolute; top: 50%; height: 30%; margin: -15% 0 0 0;}\r\n\r\n  .holder-block-resourcesnewTitleRight {float: right; width: 48%; display: block; min-height: 400px; position: relative;}\r\n  .holder-block-resourcesnewContentLeft {float: left; width: 48%; display: block;  min-height: 400px;}\r\n\r\n  .holder-block-resourcesnewTitleLeft {float: left; width: 48%; display: block;  min-height: 400px; position: relative;}\r\n  .holder-block-resourcesnewContentRight {float: right; width: 48%; display: block;  min-height: 400px;}\r\n\r\n  /* BLOCK - 2columns White + Gray */\r\n\r\n  .graybg {background-color: #f4f1ed;}\r\n  .textleft {text-align: left;}\r\n  .textright {text-align: right;}\r\n  .whitebg {padding: 0px 50px;}\r\n\r\n  /* BLOCK - 2columns <ul> <li> list */\r\n\r\n  .container-column2-list {width: 100%; margin: 60px auto;}\r\n  .holder-column2-list {width: 40%; display: inline-block; margin: 0 2%; text-align: center; vertical-align: top;}\r\n  .holder-column2-list ul {list-style-type: none; margin: 0; padding: 0;}\r\n  .holder-column2-list ul li {margin: 10px 0; padding: 0;}\r\n\r\n  /* BLOCK - circles */\r\n\r\n  .circle-blue {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n  .circle-yellow {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#feda39; margin: 30px auto;}\r\n  .circle-green {width:200px; height:200px; border-radius:100px; font-size:60px; color:#fff; line-height:200px; text-align:center; background:#075055; margin: 30px auto;}\r\n  .circle-white {width:200px; height:200px; border-radius:100px; font-size:60px; color:#075055; line-height:200px; text-align:center; background:#ffffff; margin: 30px auto;}\r\n\r\n  .circle-blue-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n  .circle-yellow-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#feda39; margin: 30px auto;}\r\n  .circle-green-small {width:160px; height:160px; border-radius:80px; font-size:80px; color:#fff; line-height:80px; text-align:center; background:#075055; margin: 30px auto;}\r\n\r\n  .circle-blue-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#229cb4; margin: 30px auto;}\r\n  .circle-yellow-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#feda39; margin: 30px auto;}\r\n  .circle-green-tiny {width:140px; height:140px; border-radius:70px; font-size:70px; color:#fff; line-height:70px; text-align:center; background:#075055; margin: 30px auto;}\r\n\r\n\r\n  /* BLOCK  - Donate */\r\n\r\n  .wrapper-contentblock-donate {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg.jpg\") no-repeat top; margin: 0 auto; min-height: 400px; margin: 0 auto;}\r\n  .wrapper-contentblock-donate-orange {width: 100%; max-width: 1440px; background:#fff url(\"/static/assets/img/wrapper-donatebg-orange.jpg\") no-repeat top;  min-height: 300px; margin: 50px auto;}\r\n  .container-contentblock-donate {width: 60%; margin: 0 auto; text-align: center; padding: 50px 0; color: #fff;}\r\n  .container-contentblock-donate-orange {width: 60%; margin: 0 auto; text-align: center; padding: 80px 0 100px 0; color: #fff;}\r\n\r\n  .content-donate-button {margin: 20px 0 20px 0; text-align: center;}\r\n  a.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 40%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n  a:visited.content-donatebutton {font-size: 30px; color: #fff; line-height: 42px; text-transform: uppercase; font-weight: 700;  width: 40%; display: block; text-align: center; border: 5px solid #fff; text-decoration: none; margin: 0 auto; padding: 10px 10px;}\r\n  a:hover.content-donatebutton {background-color: #fff; color: #0d5055;}\r\n\r\n  /* FOOTER */\r\n\r\n  .wrapper-footer {z-index: 99999999; width: 100%; position: absolute;}\r\n  .container-footer {z-index: 99999999; width: 100%; max-width: 1440px; margin: 0 auto; padding: 100px 0 0 0; text-align: center;}\r\n  .footer-holder {z-index: 9999999999; width: 48%; display: inline-block; vertical-align: top;}\r\n  .footer-navL {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n  .footer-navR {z-index: 9999999999; width: 40%; float: right; text-align: left;}\r\n  .footer-title {text-transform: uppercase; color: #229cb4; font-weight: 700; text-transform: uppercase;}\r\n  .footer-links {z-index: 9999999999; margin: 0 0 0 0; font-size: 16px;}\r\n  .footer-links ul {list-style-type: none; margin: 20px 0 0 0; padding: 0;}\r\n  .footer-links ul li {margin: 24px 0; padding: 0; font-weight: 700; text-transform: uppercase;}\r\n  .footer-links ul li a {color: #6f6e6d; text-decoration: none;}\r\n  .footer-links ul li a:visited {color: #6f6e6d; text-decoration: none;}\r\n  .footer-links ul li a:hover {color: #229cb4; text-decoration: none;}\r\n\r\n  .footer-social {margin: 50px 0 0 0;}\r\n  .footer-social a {margin: 0 20px;}\r\n\r\n  .copyright {font-size: 10px; margin: 100px 300px 100px 0; font-weight: 300; text-align: right;}\r\n\r\n  .footer-airplane {z-index: 999; position: absolute; margin: 0px 0 0 0; text-align: left;}\r\n\r\n  .footer-dots {z-index: 999; position: absolute; width: 100%; margin: 0px 0 0 0;}\r\n  .footer-dot-blue80 {margin: 0 0 0 -20px;}\r\n  .footer-dot-green60 {margin: 160px 0 0 60px;}\r\n  .footer-dot-yellow80 {float: right; margin: -300px -20px 0 0;}\r\n  .footer-dot-blue60 {float: right; margin: -200px 60px 0 0;}\r\n  .footer-dot-green80 {float: right; margin: 100px 0 0 0;}\r\n\r\n  /* NEWS */\r\n\r\n  .wrapper-news-title {margin: 140px 0 0 0;}\r\n  .holder-news-title {width: 49%; text-align: center; display: inline-block;}\r\n\r\n  .wrapper-news-block {margin: 0;}\r\n  .wrapper-news-featuredblock {width: 100%; margin: 50px auto; max-width: 1440px; text-align: center; background-color: #f8f6f1; padding: 40px 5%;}\r\n  .holder-news-image1 {width: 48%; float: left;}\r\n  .holder-news-righttitle {width: 47%; float: right; text-align: left;}\r\n\r\n  h1.news-title {color: #075055; font-size: 42px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 54px; width: 100%;font-weight: 900;}\r\n  .news-type {background-color: #075055; font-size: 24px; color: #fff; font-weight: 600; text-transform: uppercase; padding: 10px 30px; width: 260px; text-align: center; margin: 20px 0;}\r\n  .news-date { color: #888; text-transform: uppercase; font-size: 24px;}\r\n\r\n  .wrapper-news-content {width: 60%; margin: 60px auto;}\r\n  .news-prenews {font-size: 24px; font-weight: 900; border-bottom: 6px dotted #075055; padding: 0 0 30px 0; margin: 0 0 20px 0;}\r\n\r\n  h1.pressnews-title {color: #179ab2; font-size: 38px; margin: 20px auto; padding: 30px 0 0 0; letter-spacing: 1px; line-height: 54px; width: 60%;font-weight: 900; text-transform: uppercase; text-align: center; border-top: 6px dotted #075055;}\r\n\r\n  .wrapper-news-morestories { text-align: center; margin: 60px 0 50px 0;}\r\n  .holder-morestory {color: #fff; background-color: #115e67; display: inline-block; width: 300px; margin: 0 50px; min-height: 400px; vertical-align: top;}\r\n  .morestory-image {width: 100%;}\r\n  .morestory-image img {width: 100%;}\r\n  .morestory-headline {font-weight: bold;  text-transform: uppercase; font-size: 24px; margin: 0 0 10px 0;}\r\n  .morestory-text {padding: 25px; text-align: left; font-size: 18px; color: #fff;}\r\n  .morestory-text p {color: #fff;}\r\n  .morestory-link {margin: 20px 0 0 0; font-weight: 400; text-transform: uppercase;}\r\n  .morestory-link a {color: #fff; text-decoration: underline;}\r\n  .morestory-link a:visited {color: #fff; text-decoration: underline;}\r\n  .morestory-link a:hover {color: #fff; text-decoration: underline;}\r\n\r\n  .holder-media-left {width: 60%; float: left; text-align: center;}\r\n  .holder-contact-right {width: 35%; float: right; text-align: center;}\r\n\r\n  .wrapper-news-storylistings { width: 80%; margin: 60px auto; }\r\n  .holder-storylisting {margin: 20px 0 0px 0; padding: 0px 0 40px 0; border-bottom: 1px solid #ccc;}\r\n  .holder-newslisting-image1 {width: 35%; float: left;}\r\n  .holder-newslisting-image1 img {width: 100%;}\r\n  .holder-newslisting-righttitle {width: 60%; float: right; text-align: left;}\r\n\r\n  h1.newslisting-title {color: #075055; font-size: 28px; margin: 20px 0 0px 0; padding: 0; letter-spacing: 1px; line-height: 30px; width: 100%;font-weight: 900;}\r\n  .newslisting-type {/* background-color: #b5b1ac;*/ font-size: 15px; color: #b5b1ac; font-weight: 600; text-transform: uppercase; /*padding: 10px;*/ /* max-width: 200px; */ text-align: left; margin: 20px 0;}\r\n\r\n  /* OFFER STYLES */\r\n\r\n  h3.subheading-offer {color: #075055; font-size: 20px; font-weight: 900; text-transform: none; text-align: left; margin: -40px 0 40px 0 !important;}\r\n\r\n  .holder-form {width: 45%; display: inline-block; margin: 0; vertical-align: top;}\r\n\r\n  select.form-text {border: 5px solid #F3F0E7; font-size: 16px; padding: 10px 10px 13px 10px; width: 100%; display: inline;}\r\n  .form-text {border: 5px solid #F3F0E7; font-size: 16px; padding: 10px 10px 13px 10px; width: 100%;}\r\n  .form-textfull {border: 5px solid #F3F0E7; font-size: 16px; padding: 10px 10px 13px 10px; width: 92.8%;}\r\n  .form-row {width: 95%; margin: 0 0 20px 0;}\r\n  .form-cellhalf {width: 45%; display: inline-block; margin: 0 2% 0 0;}\r\n  .form-cellfour {display: inline-block; margin: 0 0 0 0;}\r\n  .form-cellfull {width: 100%; margin: 20px 0 0 0;}\r\n\r\n}\r\n  .just-link {\r\n    color: #0056b3!important;\r\n  }\r\n.center-icon {\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 100%;\r\n}\r\n.box {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n", ""]);

// exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "/*!\r\n * Bootstrap v4.0.0-beta.3 (https://getbootstrap.com)\r\n * Copyright 2011-2017 The Bootstrap Authors\r\n * Copyright 2011-2017 Twitter, Inc.\r\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\r\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#868e96;--gray-dark:#343a40;--primary:#007bff;--secondary:#868e96;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,::after,::before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:transparent}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus{outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0}address{margin-bottom:1rem;font-style:normal;line-height:inherit}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([tabindex]){color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}[role=button],a,area,button,input:not([type=range]),label,select,summary,textarea{-ms-touch-action:manipulation;touch-action:manipulation}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#868e96;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300;line-height:1.2}.display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.display-4{font-size:3.5rem;font-weight:300;line-height:1.2}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#868e96}.blockquote-footer::before{content:\"\\2014   \\A0\"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#868e96}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-sm-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-sm-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-sm-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-sm-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-sm-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-sm-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-sm-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-sm-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-sm-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-sm-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-sm-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-sm-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-sm-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-sm-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-md-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-md-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-md-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-md-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-md-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-md-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-md-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-md-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-md-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-md-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-md-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-md-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-md-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-md-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-lg-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-lg-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-lg-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-lg-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-lg-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-lg-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-lg-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-lg-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-lg-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-lg-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-lg-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-lg-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-lg-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-lg-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-xl-auto{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-xl-1{-webkit-box-flex:0;-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-webkit-box-flex:0;-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-webkit-box-flex:0;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-webkit-box-flex:0;-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-webkit-box-flex:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-webkit-box-flex:0;-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-webkit-box-flex:0;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-webkit-box-flex:0;-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-webkit-box-flex:0;-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.order-xl-1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.order-xl-2{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.order-xl-3{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3}.order-xl-4{-webkit-box-ordinal-group:5;-ms-flex-order:4;order:4}.order-xl-5{-webkit-box-ordinal-group:6;-ms-flex-order:5;order:5}.order-xl-6{-webkit-box-ordinal-group:7;-ms-flex-order:6;order:6}.order-xl-7{-webkit-box-ordinal-group:8;-ms-flex-order:7;order:7}.order-xl-8{-webkit-box-ordinal-group:9;-ms-flex-order:8;order:8}.order-xl-9{-webkit-box-ordinal-group:10;-ms-flex-order:9;order:9}.order-xl-10{-webkit-box-ordinal-group:11;-ms-flex-order:10;order:10}.order-xl-11{-webkit-box-ordinal-group:12;-ms-flex-order:11;order:11}.order-xl-12{-webkit-box-ordinal-group:13;-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;max-width:100%;margin-bottom:1rem;background-color:transparent}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table .table{background-color:#fff}.table-sm td,.table-sm th{padding:.3rem}.table-bordered{border:1px solid #dee2e6}.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-hover .table-primary:hover{background-color:#9fcdff}.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#dddfe2}.table-hover .table-secondary:hover{background-color:#cfd2d6}.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#cfd2d6}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-hover .table-success:hover{background-color:#b1dfbb}.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-hover .table-info:hover{background-color:#abdde5}.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-hover .table-warning:hover{background-color:#ffe8a1}.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-hover .table-danger:hover{background-color:#f1b0b7}.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-hover .table-light:hover{background-color:#ececf6}.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-hover .table-dark:hover{background-color:#b9bbbe}.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#212529}.table-dark td,.table-dark th,.table-dark thead th{border-color:#32383e}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.table-dark.table-hover tbody tr:hover{background-color:rgba(255,255,255,.075)}@media (max-width:575.99px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.99px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.99px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.99px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#868e96;opacity:1}.form-control::-moz-placeholder{color:#868e96;opacity:1}.form-control:-ms-input-placeholder{color:#868e96;opacity:1}.form-control::-ms-input-placeholder{color:#868e96;opacity:1}.form-control::placeholder{color:#868e96;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:not([size]):not([multiple]){height:calc(2.25rem + 2px)}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding-top:.375rem;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm,.input-group-lg>.form-control-plaintext.form-control,.input-group-lg>.input-group-append>.form-control-plaintext.btn,.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,.input-group-sm>.form-control-plaintext.form-control,.input-group-sm>.input-group-append>.form-control-plaintext.btn,.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:calc(1.8125rem + 2px)}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:calc(2.875rem + 2px)}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label{color:#868e96}.form-check-label{margin-bottom:0}.form-check-inline{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;width:250px;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(40,167,69,.8);border-radius:.2rem}.custom-select.is-valid,.form-control.is-valid,.was-validated .custom-select:valid,.was-validated .form-control:valid{border-color:#28a745}.custom-select.is-valid:focus,.form-control.is-valid:focus,.was-validated .custom-select:valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-select.is-valid~.valid-feedback,.custom-select.is-valid~.valid-tooltip,.form-control.is-valid~.valid-feedback,.form-control.is-valid~.valid-tooltip,.was-validated .custom-select:valid~.valid-feedback,.was-validated .custom-select:valid~.valid-tooltip,.was-validated .form-control:valid~.valid-feedback,.was-validated .form-control:valid~.valid-tooltip{display:block}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label::before,.was-validated .custom-control-input:valid~.custom-control-label::before{background-color:#71dd8a}.custom-control-input.is-valid~.valid-feedback,.custom-control-input.is-valid~.valid-tooltip,.was-validated .custom-control-input:valid~.valid-feedback,.was-validated .custom-control-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid:checked~.custom-control-label::before,.was-validated .custom-control-input:valid:checked~.custom-control-label::before{background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label::before,.was-validated .custom-control-input:valid:focus~.custom-control-label::before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(40,167,69,.25)}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label::before,.was-validated .custom-file-input:valid~.custom-file-label::before{border-color:inherit}.custom-file-input.is-valid~.valid-feedback,.custom-file-input.is-valid~.valid-tooltip,.was-validated .custom-file-input:valid~.valid-feedback,.was-validated .custom-file-input:valid~.valid-tooltip{display:block}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;width:250px;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(220,53,69,.8);border-radius:.2rem}.custom-select.is-invalid,.form-control.is-invalid,.was-validated .custom-select:invalid,.was-validated .form-control:invalid{border-color:#dc3545}.custom-select.is-invalid:focus,.form-control.is-invalid:focus,.was-validated .custom-select:invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-select.is-invalid~.invalid-feedback,.custom-select.is-invalid~.invalid-tooltip,.form-control.is-invalid~.invalid-feedback,.form-control.is-invalid~.invalid-tooltip,.was-validated .custom-select:invalid~.invalid-feedback,.was-validated .custom-select:invalid~.invalid-tooltip,.was-validated .form-control:invalid~.invalid-feedback,.was-validated .form-control:invalid~.invalid-tooltip{display:block}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label::before,.was-validated .custom-control-input:invalid~.custom-control-label::before{background-color:#efa2a9}.custom-control-input.is-invalid~.invalid-feedback,.custom-control-input.is-invalid~.invalid-tooltip,.was-validated .custom-control-input:invalid~.invalid-feedback,.was-validated .custom-control-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid:checked~.custom-control-label::before,.was-validated .custom-control-input:invalid:checked~.custom-control-label::before{background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus~.custom-control-label::before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(220,53,69,.25)}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label::before,.was-validated .custom-file-input:invalid~.custom-file-label::before{border-color:inherit}.custom-file-input.is-invalid~.invalid-feedback,.custom-file-input.is-invalid~.invalid-tooltip,.was-validated .custom-file-input:invalid~.invalid-feedback,.was-validated .custom-file-input:invalid~.invalid-tooltip{display:block}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}.form-inline .form-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:0}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .input-group{width:auto}.form-inline .form-check{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.btn:focus,.btn:hover{text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not([disabled]):not(.disabled){cursor:pointer}.btn:not([disabled]):not(.disabled).active,.btn:not([disabled]):not(.disabled):active{background-image:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-primary.disabled,.btn-primary:disabled{background-color:#007bff;border-color:#007bff}.btn-primary:not([disabled]):not(.disabled).active,.btn-primary:not([disabled]):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not([disabled]):not(.disabled).active:focus,.btn-primary:not([disabled]):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-secondary{color:#fff;background-color:#868e96;border-color:#868e96}.btn-secondary:hover{color:#fff;background-color:#727b84;border-color:#6c757d}.btn-secondary.focus,.btn-secondary:focus{box-shadow:0 0 0 .2rem rgba(134,142,150,.5)}.btn-secondary.disabled,.btn-secondary:disabled{background-color:#868e96;border-color:#868e96}.btn-secondary:not([disabled]):not(.disabled).active,.btn-secondary:not([disabled]):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#666e76}.btn-secondary:not([disabled]):not(.disabled).active:focus,.btn-secondary:not([disabled]):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(134,142,150,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-success.disabled,.btn-success:disabled{background-color:#28a745;border-color:#28a745}.btn-success:not([disabled]):not(.disabled).active,.btn-success:not([disabled]):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not([disabled]):not(.disabled).active:focus,.btn-success:not([disabled]):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-info.disabled,.btn-info:disabled{background-color:#17a2b8;border-color:#17a2b8}.btn-info:not([disabled]):not(.disabled).active,.btn-info:not([disabled]):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not([disabled]):not(.disabled).active:focus,.btn-info:not([disabled]):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-warning.disabled,.btn-warning:disabled{background-color:#ffc107;border-color:#ffc107}.btn-warning:not([disabled]):not(.disabled).active,.btn-warning:not([disabled]):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not([disabled]):not(.disabled).active:focus,.btn-warning:not([disabled]):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-danger.disabled,.btn-danger:disabled{background-color:#dc3545;border-color:#dc3545}.btn-danger:not([disabled]):not(.disabled).active,.btn-danger:not([disabled]):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not([disabled]):not(.disabled).active:focus,.btn-danger:not([disabled]):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-light.disabled,.btn-light:disabled{background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not([disabled]):not(.disabled).active,.btn-light:not([disabled]):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not([disabled]):not(.disabled).active:focus,.btn-light:not([disabled]):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-dark.disabled,.btn-dark:disabled{background-color:#343a40;border-color:#343a40}.btn-dark:not([disabled]):not(.disabled).active,.btn-dark:not([disabled]):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not([disabled]):not(.disabled).active:focus,.btn-dark:not([disabled]):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-primary{color:#007bff;background-color:transparent;background-image:none;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not([disabled]):not(.disabled).active,.btn-outline-primary:not([disabled]):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#212529;background-color:#007bff;border-color:#007bff;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#868e96;background-color:transparent;background-image:none;border-color:#868e96}.btn-outline-secondary:hover{color:#fff;background-color:#868e96;border-color:#868e96}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(134,142,150,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#868e96;background-color:transparent}.btn-outline-secondary:not([disabled]):not(.disabled).active,.btn-outline-secondary:not([disabled]):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#212529;background-color:#868e96;border-color:#868e96;box-shadow:0 0 0 .2rem rgba(134,142,150,.5)}.btn-outline-success{color:#28a745;background-color:transparent;background-image:none;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not([disabled]):not(.disabled).active,.btn-outline-success:not([disabled]):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#212529;background-color:#28a745;border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;background-color:transparent;background-image:none;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not([disabled]):not(.disabled).active,.btn-outline-info:not([disabled]):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#212529;background-color:#17a2b8;border-color:#17a2b8;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;background-color:transparent;background-image:none;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not([disabled]):not(.disabled).active,.btn-outline-warning:not([disabled]):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;background-color:transparent;background-image:none;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not([disabled]):not(.disabled).active,.btn-outline-danger:not([disabled]):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#212529;background-color:#dc3545;border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;background-color:transparent;background-image:none;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not([disabled]):not(.disabled).active,.btn-outline-light:not([disabled]):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#fff;background-color:#f8f9fa;border-color:#f8f9fa;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not([disabled]):not(.disabled).active,.btn-outline-dark:not([disabled]):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#212529;background-color:#343a40;border-color:#343a40;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;background-color:transparent}.btn-link:hover{color:#0056b3;text-decoration:underline;background-color:transparent;border-color:transparent}.btn-link.focus,.btn-link:focus{text-decoration:underline;border-color:transparent;box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#868e96}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.show{opacity:1}.collapse{display:none}.collapse.show{display:block}tr.collapse.show{display:table-row}tbody.collapse.show{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition:height .35s ease}.dropdown,.dropup{position:relative}.dropdown-toggle::after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropup .dropdown-menu{margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle::after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-menu{margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle::after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-toggle::after{vertical-align:0}.dropleft .dropdown-menu{margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle::after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropleft .dropdown-toggle::after{display:none}.dropleft .dropdown-toggle::before{display:inline-block;width:0;height:0;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty::after{margin-left:0}.dropleft .dropdown-toggle::before{vertical-align:0}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#868e96;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#868e96;white-space:nowrap}.btn-group,.btn-group-vertical{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.btn-group-vertical>.btn:hover,.btn-group>.btn:hover{z-index:1}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus{z-index:1}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group,.btn-group-vertical .btn+.btn,.btn-group-vertical .btn+.btn-group,.btn-group-vertical .btn-group+.btn,.btn-group-vertical .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.btn-group-vertical .btn,.btn-group-vertical .btn-group{width:100%}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio],.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group .custom-file,.input-group .custom-select,.input-group .form-control{position:relative;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;margin-bottom:0}.input-group .custom-file:focus,.input-group .custom-select:focus,.input-group .form-control:focus{z-index:3}.input-group .custom-file+.form-control,.input-group .custom-select+.form-control,.input-group .form-control+.form-control{margin-left:-1px}.input-group .custom-select:not(:last-child),.input-group .form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group .custom-select:not(:first-child),.input-group .form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group .custom-file{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.input-group .custom-file:not(:last-child) .custom-file-control,.input-group .custom-file:not(:last-child) .custom-file-control::before{border-top-right-radius:0;border-bottom-right-radius:0}.input-group .custom-file:not(:first-child) .custom-file-control,.input-group .custom-file:not(:first-child) .custom-file-control::before{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:active~.custom-control-label::before{color:#fff;background-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label{color:#868e96}.custom-control-input:disabled~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{margin-bottom:0}.custom-control-label::before{position:absolute;top:.25rem;left:0;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#dee2e6}.custom-control-label::after{position:absolute;top:.25rem;left:0;display:block;width:1rem;height:1rem;content:\"\";background-repeat:no-repeat;background-position:center center;background-size:50% 50%}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::before{background-color:#007bff}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::before{background-color:#007bff}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#868e96;background-color:#e9ecef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{height:calc(1.8125rem + 2px);padding-top:.375rem;padding-bottom:.375rem;font-size:75%}.custom-select-lg{height:calc(2.875rem + 2px);padding-top:.375rem;padding-bottom:.375rem;font-size:125%}.custom-file{position:relative;display:inline-block;width:100%;height:calc(2.25rem + 2px);margin-bottom:0}.custom-file-input{position:relative;z-index:2;width:100%;height:calc(2.25rem + 2px);margin:0;opacity:0}.custom-file-input:focus~.custom-file-control{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:focus~.custom-file-control::before{border-color:#80bdff}.custom-file-input:lang(en)~.custom-file-label::after{content:\"Browse\"}.custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(2.25rem + 2px);padding:.375rem .75rem;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(calc(2.25rem + 2px) - 1px * 2);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:1px solid #ced4da;border-radius:0 .25rem .25rem 0}.nav{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#868e96}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#868e96;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item{-ms-flex-preferred-size:0;flex-basis:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:.5rem 1rem}.navbar>.container,.navbar>.container-fluid{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler:not([disabled]):not(.disabled){cursor:pointer}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat center center;background-size:100% 100%}@media (max-width:575.99px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:767.99px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:991.99px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:1199.99px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .dropup .dropdown-menu{top:auto;bottom:100%}}.navbar-expand{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .dropup .dropdown-menu{top:auto;bottom:100%}.navbar-light .navbar-brand{color:rgba(0,0,0,.9)}.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a{color:rgba(0,0,0,.9)}.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand{color:#fff}.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:rgba(255,255,255,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text{color:rgba(255,255,255,.5)}.navbar-dark .navbar-text a{color:#fff}.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-body{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem;margin-bottom:0}.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img{width:100%;border-radius:calc(.25rem - 1px)}.card-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 0 0%;flex:1 0 0%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-webkit-box-flex:1;-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:first-child .card-header,.card-group>.card:first-child .card-img-top{border-top-right-radius:0}.card-group>.card:first-child .card-footer,.card-group>.card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:last-child .card-header,.card-group>.card:last-child .card-img-top{border-top-left-radius:0}.card-group>.card:last-child .card-footer,.card-group>.card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group>.card:only-child{border-radius:.25rem}.card-group>.card:only-child .card-header,.card-group>.card:only-child .card-img-top{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card-group>.card:only-child .card-footer,.card-group>.card:only-child .card-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-group>.card:not(:first-child):not(:last-child):not(:only-child){border-radius:0}.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top{border-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem}.card-columns .card{display:inline-block;width:100%}}.breadcrumb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item::before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#868e96;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:underline}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.breadcrumb-item.active{color:#868e96}.pagination{display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:focus,.page-link:hover{color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:not([disabled]):not(.disabled){cursor:pointer}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#868e96;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}.badge-primary[href]:focus,.badge-primary[href]:hover{color:#fff;text-decoration:none;background-color:#0062cc}.badge-secondary{color:#fff;background-color:#868e96}.badge-secondary[href]:focus,.badge-secondary[href]:hover{color:#fff;text-decoration:none;background-color:#6c757d}.badge-success{color:#fff;background-color:#28a745}.badge-success[href]:focus,.badge-success[href]:hover{color:#fff;text-decoration:none;background-color:#1e7e34}.badge-info{color:#fff;background-color:#17a2b8}.badge-info[href]:focus,.badge-info[href]:hover{color:#fff;text-decoration:none;background-color:#117a8b}.badge-warning{color:#212529;background-color:#ffc107}.badge-warning[href]:focus,.badge-warning[href]:hover{color:#212529;text-decoration:none;background-color:#d39e00}.badge-danger{color:#fff;background-color:#dc3545}.badge-danger[href]:focus,.badge-danger[href]:hover{color:#fff;text-decoration:none;background-color:#bd2130}.badge-light{color:#212529;background-color:#f8f9fa}.badge-light[href]:focus,.badge-light[href]:hover{color:#212529;text-decoration:none;background-color:#dae0e5}.badge-dark{color:#fff;background-color:#343a40}.badge-dark[href]:focus,.badge-dark[href]:hover{color:#fff;text-decoration:none;background-color:#1d2124}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#464a4e;background-color:#e7e8ea;border-color:#dddfe2}.alert-secondary hr{border-top-color:#cfd2d6}.alert-secondary .alert-link{color:#2e3133}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.progress{display:-webkit-box;display:-ms-flexbox;display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;text-align:center;background-color:#007bff;transition:width .6s ease}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}.media{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.media-body{-webkit-box-flex:1;-ms-flex:1;flex:1}.list-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item:focus,.list-group-item:hover{z-index:1;text-decoration:none}.list-group-item.disabled,.list-group-item:disabled{color:#868e96;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.list-group-flush:first-child .list-group-item:first-child{border-top:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom:0}.list-group-item-primary{color:#004085;background-color:#b8daff}a.list-group-item-primary,button.list-group-item-primary{color:#004085}a.list-group-item-primary:focus,a.list-group-item-primary:hover,button.list-group-item-primary:focus,button.list-group-item-primary:hover{color:#004085;background-color:#9fcdff}a.list-group-item-primary.active,button.list-group-item-primary.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#464a4e;background-color:#dddfe2}a.list-group-item-secondary,button.list-group-item-secondary{color:#464a4e}a.list-group-item-secondary:focus,a.list-group-item-secondary:hover,button.list-group-item-secondary:focus,button.list-group-item-secondary:hover{color:#464a4e;background-color:#cfd2d6}a.list-group-item-secondary.active,button.list-group-item-secondary.active{color:#fff;background-color:#464a4e;border-color:#464a4e}.list-group-item-success{color:#155724;background-color:#c3e6cb}a.list-group-item-success,button.list-group-item-success{color:#155724}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#155724;background-color:#b1dfbb}a.list-group-item-success.active,button.list-group-item-success.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}a.list-group-item-info,button.list-group-item-info{color:#0c5460}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#0c5460;background-color:#abdde5}a.list-group-item-info.active,button.list-group-item-info.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}a.list-group-item-warning,button.list-group-item-warning{color:#856404}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#856404;background-color:#ffe8a1}a.list-group-item-warning.active,button.list-group-item-warning.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}a.list-group-item-danger,button.list-group-item-danger{color:#721c24}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#721c24;background-color:#f1b0b7}a.list-group-item-danger.active,button.list-group-item-danger.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}a.list-group-item-light,button.list-group-item-light{color:#818182}a.list-group-item-light:focus,a.list-group-item-light:hover,button.list-group-item-light:focus,button.list-group-item-light:hover{color:#818182;background-color:#ececf6}a.list-group-item-light.active,button.list-group-item-light.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}a.list-group-item-dark,button.list-group-item-dark{color:#1b1e21}a.list-group-item-dark:focus,a.list-group-item-dark:hover,button.list-group-item-dark:focus,button.list-group-item-dark:hover{color:#1b1e21;background-color:#b9bbbe}a.list-group-item-dark.active,button.list-group-item-dark.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:focus,.close:hover{color:#000;text-decoration:none;opacity:.75}.close:not([disabled]):not(.disabled){cursor:pointer}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none}.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;overflow:hidden;outline:0}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translate(0,-25%);transform:translate(0,-25%)}.modal.show .modal-dialog{-webkit-transform:translate(0,0);transform:translate(0,0)}.modal-dialog-centered{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:calc(100% - (.5rem * 2))}.modal-content{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:1rem;border-bottom:1px solid #e9ecef;border-top-left-radius:.3rem;border-top-right-radius:.3rem}.modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.modal-footer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:1rem;border-top:1px solid #e9ecef}.modal-footer>:not(:first-child){margin-left:.25rem}.modal-footer>:not(:last-child){margin-right:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-centered{min-height:calc(100% - (1.75rem * 2))}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:800px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow::before,.bs-tooltip-top .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow::before,.bs-tooltip-right .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow::before,.bs-tooltip-bottom .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow::before,.bs-tooltip-left .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow::after,.popover .arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top] .arrow,.bs-popover-top .arrow{bottom:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=top] .arrow::after,.bs-popover-auto[x-placement^=top] .arrow::before,.bs-popover-top .arrow::after,.bs-popover-top .arrow::before{border-width:.5rem .5rem 0}.bs-popover-auto[x-placement^=top] .arrow::before,.bs-popover-top .arrow::before{bottom:0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top] .arrow::after,.bs-popover-top .arrow::after{bottom:1px;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right] .arrow,.bs-popover-right .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right] .arrow::after,.bs-popover-auto[x-placement^=right] .arrow::before,.bs-popover-right .arrow::after,.bs-popover-right .arrow::before{border-width:.5rem .5rem .5rem 0}.bs-popover-auto[x-placement^=right] .arrow::before,.bs-popover-right .arrow::before{left:0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right] .arrow::after,.bs-popover-right .arrow::after{left:1px;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom] .arrow,.bs-popover-bottom .arrow{top:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=bottom] .arrow::after,.bs-popover-auto[x-placement^=bottom] .arrow::before,.bs-popover-bottom .arrow::after,.bs-popover-bottom .arrow::before{border-width:0 .5rem .5rem .5rem}.bs-popover-auto[x-placement^=bottom] .arrow::before,.bs-popover-bottom .arrow::before{top:0;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom] .arrow::after,.bs-popover-bottom .arrow::after{top:1px;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left] .arrow,.bs-popover-left .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left] .arrow::after,.bs-popover-auto[x-placement^=left] .arrow::before,.bs-popover-left .arrow::after,.bs-popover-left .arrow::before{border-width:.5rem 0 .5rem .5rem}.bs-popover-auto[x-placement^=left] .arrow::before,.bs-popover-left .arrow::before{right:0;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left] .arrow::after,.bs-popover-left .arrow::after{right:1px;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-item{position:relative;display:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;transition:-webkit-transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.carousel-item-next,.carousel-item-prev{position:absolute;top:0}.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translateX(0);transform:translateX(0)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}.active.carousel-item-right,.carousel-item-next{-webkit-transform:translateX(100%);transform:translateX(100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-right,.carousel-item-next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translateX(-100%);transform:translateX(-100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat center center;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\")}.carousel-indicators{position:absolute;right:0;bottom:10px;left:0;z-index:15;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{position:relative;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;background-color:rgba(255,255,255,.5)}.carousel-indicators li::before{position:absolute;top:-10px;left:0;display:inline-block;width:100%;height:10px;content:\"\"}.carousel-indicators li::after{position:absolute;bottom:-10px;left:0;display:inline-block;width:100%;height:10px;content:\"\"}.carousel-indicators .active{background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#868e96!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#6c757d!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #e9ecef!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#868e96!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.clearfix::after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important}}.d-print-block{display:none!important}@media print{.d-print-block{display:block!important}}.d-print-inline{display:none!important}@media print{.d-print-inline{display:inline!important}}.d-print-inline-block{display:none!important}@media print{.d-print-inline-block{display:inline-block!important}}@media print{.d-print-none{display:none!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive::before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9::before{padding-top:42.857143%}.embed-responsive-16by9::before{padding-top:56.25%}.embed-responsive-4by3::before{padding-top:75%}.embed-responsive-1by1::before{padding-top:100%}.flex-row{-webkit-box-orient:horizontal!important;-webkit-box-direction:normal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-webkit-box-orient:horizontal!important;-webkit-box-direction:normal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-sm-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-webkit-box-orient:horizontal!important;-webkit-box-direction:normal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-md-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-webkit-box-orient:horizontal!important;-webkit-box-direction:normal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-lg-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-webkit-box-orient:horizontal!important;-webkit-box-direction:normal!important;-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-webkit-box-orient:horizontal!important;-webkit-box-direction:reverse!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-webkit-box-orient:vertical!important;-webkit-box-direction:reverse!important;-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-xl-start{-webkit-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-webkit-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-webkit-box-align:end!important;-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-webkit-box-align:baseline!important;-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-webkit-box-align:stretch!important;-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;-webkit-clip-path:inset(50%);clip-path:inset(50%);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal;-webkit-clip-path:none;clip-path:none}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0062cc!important}.text-secondary{color:#868e96!important}a.text-secondary:focus,a.text-secondary:hover{color:#6c757d!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#1e7e34!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#117a8b!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#d39e00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#bd2130!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#dae0e5!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#1d2124!important}.text-muted{color:#868e96!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,::after,::before{text-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}abbr[title]::after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}", ""]);

// exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@font-face {\r\n  font-family: 'ProximaNova-Bold';\r\n  src: url(" + __webpack_require__(53) + ");\r\n  src: url(" + __webpack_require__(53) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(112) + ") format(\"woff2\"), url(" + __webpack_require__(111) + ") format(\"woff\"), url(" + __webpack_require__(110) + ") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ProximaNova-Medium';\r\n  src: url(" + __webpack_require__(54) + ");\r\n  src: url(" + __webpack_require__(54) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(115) + ") format(\"woff2\"), url(" + __webpack_require__(114) + ") format(\"woff\"), url(" + __webpack_require__(113) + ") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ProximaNova-Regular';\r\n  src: url(" + __webpack_require__(52) + ");\r\n  src: url(" + __webpack_require__(52) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(109) + ") format(\"woff2\"), url(" + __webpack_require__(108) + ") format(\"woff\"), url(" + __webpack_require__(107) + ") format(\"truetype\");\r\n}\r\n\r\n/*Portal config*/\r\n.header .upper-header {\r\n  background-color: #000000;\r\n  height: 20px;\r\n}\r\n\r\n.header .lower-header {\r\n  background-color: #0c7cba;\r\n  height: 90px;\r\n}\r\n\r\n.header .lower-header .evf_logo {\r\n  height: 80px;\r\n  margin: 5px 10px;\r\n}\r\n\r\n.header .lower-header .nav_toggle_button {\r\n  color: white;\r\n  float: right;\r\n  padding-right: 30px;\r\n  padding-top: 25px;\r\n  font-size: 25px;\r\n}\r\n\r\n@media only screen and (min-width: 767px) {\r\n  .header .lower-header .nav_toggle_button {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.header .lower-header .my_account_services {\r\n  padding-top: 15px;\r\n  background-color: #0c7cba;\r\n  /* @media only screen and (max-width: 767px) {\r\n                display: none;\r\n            }*/\r\n}\r\n\r\n.header .lower-header .my_account_services .nav_divider {\r\n  padding: 10px;\r\n  border-right: 2px solid black;\r\n}\r\n\r\n@media only screen and (max-width: 575px) {\r\n  .header .lower-header .my_account_services .nav_divider {\r\n    border-right: 0px solid black;\r\n  }\r\n}\r\n\r\n.header .lower-header .my_account_services .nav_divider p.portal_header_link {\r\n  color: white !important;\r\n  text-align: center;\r\n  margin-bottom: 7px;\r\n  font-family: ProximaNova-Medium, sans-serif !important;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  font-size: 16px !important;\r\n}\r\n\r\n.header .lower-header .logout_services {\r\n  background-color: #0c7cba;\r\n  /* @media only screen and (max-width: 767px) {\r\n                display: none;\r\n            }*/\r\n}\r\n\r\n.header .lower-header .logout_services .logout_link {\r\n  color: white;\r\n  float: right;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-top: 28px;\r\n  margin-right: 30px;\r\n}\r\n\r\n.header .lower-header .logout_services .logout_link:hover {\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-content {\r\n  margin-top: 107px;\r\n  background-color: #d5e4ef7a;\r\n  border: 3px solid #0c7cba;\r\n  float: right;\r\n  overflow: hidden;\r\n  width: 385px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .login-content {\r\n    width: 420px;\r\n  }\r\n}\r\n\r\n.login-content .login_info {\r\n  padding: 10px 30px;\r\n}\r\n\r\n.login-content .login_info .email_wrap {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.login-content .login_info .login_info_label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.login-content .login_info .login_input {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  height: 30px;\r\n}\r\n\r\n.login-content .login_info .login_button_info {\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.login-content .login_info .login_button_info .login_button {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  border-radius: 15px;\r\n  border: 2px solid #0c7cba;\r\n  background-color: white;\r\n  width: 100%;\r\n  padding: 0px;\r\n}\r\n\r\n.login-content .login_info .login_validation {\r\n  text-align: center;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.main_login {\r\n  padding-right: 0px !important;\r\n}\r\n\r\n.main_hero_image {\r\n  width: 364px;\r\n  height: auto;\r\n  margin-top: 150px;\r\n  margin-left: 50px;\r\n  background-color: white;\r\n  position: absolute;\r\n  z-index: 0;\r\n  /*display: none*/\r\n  /*1600 x 900 -screen Resolution */\r\n  /*1320 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .main_hero_image {\r\n    width: 428px;\r\n  }\r\n}\r\n\r\n.main_content_title {\r\n  margin-top: 180px;\r\n  font-size: 89px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  float: right;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .main_content_title {\r\n    margin-top: 158px;\r\n    font-size: 110px;\r\n  }\r\n}\r\n\r\n.portal_description {\r\n  font-size: 19px;\r\n  margin: 20px 0px;\r\n  text-align: center;\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .portal_description {\r\n    margin: 50px 0px;\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.sign_up_link {\r\n  margin-top: 43px;\r\n  margin-bottom: 43px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .sign_up_link {\r\n    margin-top: 60px;\r\n    margin-bottom: 60px;\r\n  }\r\n}\r\n\r\n.sign_up_link .sign_up_button {\r\n  font-size: 23px;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px;\r\n  border: 3px solid #0c7cba;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  float: right;\r\n  width: 250px;\r\n  height: 65px;\r\n  padding-top: 10px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .sign_up_link .sign_up_button {\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n.g-color-footer-links {\r\n  color: #fff!important;\r\n}\r\n\r\n.footer_arrow {\r\n  position: absolute;\r\n  left: 0px;\r\n  bottom: 20px;\r\n  z-index: -10;\r\n  background-repeat: no-repeat;\r\n  /*display: none*/\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .footer_arrow {\r\n    bottom: 86px;\r\n  }\r\n}\r\n\r\n.footer_arrow img.arrow_info {\r\n  width: 800px;\r\n  height: 90px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .footer_arrow img.arrow_info {\r\n    /* width: 1100px;\r\n            height: 200px;*/\r\n  }\r\n}\r\n\r\n/*HomeScroll styles*/\r\n@media (max-width: 991px) {\r\n  .portal_program_content .reorder {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n  }\r\n  .portal_program_content .second {\r\n    -webkit-box-ordinal-group: 3;\r\n        -ms-flex-order: 2;\r\n            order: 2;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_program_content .portal_info {\r\n  margin: 40px auto;\r\n  /*1157 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1157px) and (min-width: 991px) {\r\n  .portal_program_content .portal_info {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.portal_program_content .portal_info p.pp_title {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  text-align: left;\r\n  font-size: 25px;\r\n  color: #3f4d5d;\r\n  margin-bottom: 1rem;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n.portal_program_content .program_desc_container .pp_description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 20px;\r\n  text-align: justify;\r\n  color: #000000;\r\n  /*768 -Screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .portal_program_content .program_desc_container .pp_description {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 991px) and (min-width: 768px) {\r\n  .portal_program_content .program_desc_container {\r\n    width: 700px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_desc_content {\r\n  width: 550px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  /*1157 x  -screen Resolution */\r\n  /*876 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1157px) and (min-width: 991px) {\r\n  .portal_program_content .pp_desc_content {\r\n    width: 400px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .portal_program_content .pp_desc_content {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_desc_content ul.pp_desc_info {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 19.5px;\r\n  text-align: justify;\r\n  line-height: 20px;\r\n  color: #000000;\r\n  /*768 -Screen Resolution */\r\n  /*400 -Screen Resolution */\r\n}\r\n\r\n.portal_program_content .pp_desc_content ul.pp_desc_info li {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .portal_program_content .pp_desc_content ul.pp_desc_info {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n  .portal_program_content .pp_desc_content ul.pp_desc_info {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_benefit_content {\r\n  width: 550px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  /*1157 x  -screen Resolution */\r\n  /*876 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1157px) and (min-width: 991px) {\r\n  .portal_program_content .pp_benefit_content {\r\n    width: 400px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .portal_program_content .pp_benefit_content {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_benefit_content ul.pp_benefit_info {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 19.5px;\r\n  text-align: justify;\r\n  line-height: 20px;\r\n  padding-left: 20px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .portal_program_content .pp_benefit_content ul.pp_benefit_info {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n  .portal_program_content .pp_benefit_content ul.pp_benefit_info {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_benefit_content ul.pp_benefit_info li {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.portal_program_content .pp_benefit_content ul.pp_benefit_info li span.benefit_desc {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n}\r\n\r\n.pp_image {\r\n  padding: 0;\r\n}\r\n\r\n.cycle_of_giving_img_wrapper {\r\n  background-color: #000;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.cycle_of_giving_img_wrapper > img {\r\n  width: 100%;\r\n  max-width: 500px;\r\n  margin: auto;\r\n}\r\n\r\n.pp_image .hide_desktop {\r\n  width: 100%;\r\n  /*991px and 768px - Screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 991px) and (min-width: 768px) {\r\n  .pp_image .hide_desktop {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.pp_image .hide_mobile {\r\n  width: 700px;\r\n  margin: 0px auto;\r\n  display: none;\r\n  /*991px and 768px- Screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 991px) and (min-width: 768px) {\r\n  .pp_image .hide_mobile {\r\n    display: block;\r\n  }\r\n  .pp_image .hide_mobile img.mobile_img {\r\n    width: 700px;\r\n  }\r\n}\r\n\r\n.portal_link_services {\r\n  margin-top: 100px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.portal_link_services .portal_link_container {\r\n  width: 900px;\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .portal_link_services .portal_link_container {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content {\r\n  text-align: center;\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content .portal_link_info {\r\n  width: 200px;\r\n  margin: 0 auto;\r\n  /*768px- Screen Resolution*/\r\n  /*299px- Screen Resolution*/\r\n}\r\n\r\n@media only screen and (max-width: 768px) and (min-width: 575px) {\r\n  .portal_link_services .portal_link_container a.portal_link_content .portal_link_info {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 299px) {\r\n  .portal_link_services .portal_link_container a.portal_link_content .portal_link_info {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content .portal_link_info img.portal_link_img {\r\n  width: 130px;\r\n  height: 125px;\r\n  border-radius: 100%;\r\n  margin: 0 auto;\r\n  border: 2px solid #000000;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n@media only screen and (max-width: 767px) and (min-width: 575px) {\r\n  .portal_link_services .portal_link_container a.portal_link_content .portal_link_info img.portal_link_img {\r\n    width: 130px;\r\n    height: 130px;\r\n  }\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content .portal_link_info p.portal_link_p {\r\n  font-size: 21px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n  color: #000000;\r\n}\r\n\r\n/*Footer styles*/\r\n.footer_services .footer_content {\r\n  background-color: #000000;\r\n  height: 100%;\r\n}\r\n\r\n.footer_services .footer_content .footer_info {\r\n  margin-top: 12px;\r\n  bottom: 0;\r\n}\r\n\r\n.footer_services .footer_content .footer_info .footer_container .footer_divider {\r\n  padding: 10px;\r\n  border-right: 2px solid black;\r\n}\r\n\r\n@media only screen and (max-width: 575px) {\r\n  .footer_services .footer_content .footer_info .footer_container .footer_divider {\r\n    border-right: 0px solid black;\r\n  }\r\n}\r\n\r\n.footer_services .footer_content .footer_info .footer_container .footer_divider .footer_link {\r\n  color: white;\r\n  text-align: center;\r\n  margin-bottom: 7px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n  text-decoration: underline;\r\n}\r\n\r\n/*Reset Password Modal*/\r\n.modal-mask {\r\n  position: fixed;\r\n  z-index: 9998;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  /*background-color: transparent;*/\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: table;\r\n  -webkit-transition: opacity .3s ease;\r\n  transition: opacity .3s ease;\r\n  /* overflow-y: auto; */\r\n}\r\n\r\n.modal-mask .overlay-mask {\r\n  overflow-y: auto;\r\n  height: 100vh;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog {\r\n  /* overflow-y: auto;*/\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content {\r\n  background-color: white;\r\n  border: 3px solid #000000;\r\n  border-radius: 10px;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .close_btn {\r\n  background-image: url(" + __webpack_require__(106) + ");\r\n  background-size: 20px 20px;\r\n  width: 20px;\r\n  height: 20px;\r\n  /* background-repeat: no-repeat;\r\n                    border: 1px solid $blue_color;\r\n                    padding: 10px;*/\r\n  cursor: pointer;\r\n  float: right;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header {\r\n  text-align: center;\r\n  background: #0c7cba;\r\n  color: white;\r\n  border-radius: 10px 10px 5px 5px;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-title {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 25px;\r\n  color: #000000;\r\n  /*323px - Screen Resolution*/\r\n}\r\n\r\n@media only screen and (max-width: 323px) {\r\n  .modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-title {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-description {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  width: 380px;\r\n  margin: 10px auto;\r\n  color: #000000;\r\n  /*450px - Screen Resolution*/\r\n}\r\n\r\n@media only screen and (max-width: 450px) {\r\n  .modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-description {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.nonprofit-modal-msg {\r\n  font-family: ProximaNova-Bold, sans-serif !important;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .modal_scroll {\r\n  max-height: 500px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body #style-1::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  border-radius: 10px;\r\n  background-color: #F5F5F5;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body #style-1::-webkit-scrollbar {\r\n  width: 8px;\r\n  background-color: #F5F5F5;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body #style-1::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  background-color: #555;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content.modal-edit-bg {\r\n  background-color: white;\r\n  border: 3px solid #000000;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content.modal-delete-bg {\r\n  background-color: white;\r\n  border: 3px solid #000000;\r\n}\r\n\r\n/*Forgot Password - 02/10/18 - Onesi*/\r\n.reset_info_label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-bottom: 0;\r\n  font-size: 18px;\r\n}\r\n\r\n.forgot_password_button {\r\n  font-size: 18px;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px;\r\n  border: 3px solid #0c7cba;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  width: 250px;\r\n  height: 65px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.contract-header {\r\n  font-size: 24px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n}\r\n\r\n.contract-description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 16px;\r\n}\r\n\r\n.contract-label {\r\n  font-size: 16px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n}\r\n\r\n.bottom-margin-50 {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.bottom-margin-10 {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.frame-list-description1-height {\r\n  height: 180px;\r\n}\r\n\r\n.frame-list-description2-height {\r\n  height: 70px;\r\n  padding-bottom: 10px !important;\r\n  padding-left: 1.78571rem !important;\r\n  padding-top: 10px !important;\r\n}\r\n\r\n.warning-text-color {\r\n  text-align: center;\r\n  color: #a61d37 !important;\r\n  font-size: 14px !important;\r\n}\r\n\r\n.no-margin {\r\n  margin-left: 0px !important;\r\n  margin-right: 0px !important;\r\n}\r\n\r\n/*Portal Home Page - 2018/02/28 - Onesi*/\r\n.portal_home_services {\r\n  background-color: #313c5c;\r\n  margin: 0px;\r\n  padding-bottom: 120px;\r\n}\r\n\r\n.portal_home_services .portal_header_title {\r\n  color: white;\r\n  text-align: center;\r\n  font-family: \"Alegreya\", serif;\r\n}\r\n\r\n.portal_home_services .portal_services {\r\n  margin-top: 40px;\r\n}\r\n\r\n.portal_home_services .portal_services .caption_services {\r\n  padding: 30px;\r\n}\r\n\r\n.portal_home_services .portal_services .caption_services .hearder_caption {\r\n  color: white;\r\n  font-family: \"Alegreya\", serif;\r\n  font-size: 18px;\r\n}\r\n\r\n.portal_home_services .portal_services .caption_services .header_caption_content {\r\n  color: white;\r\n  font-family: \"Barlow\", sans-serif;\r\n  font-size: 14px;\r\n}\r\n\r\n.portal_icon_services {\r\n  margin-top: 15px;\r\n}\r\n\r\n@media only screen and (min-width: 767px) {\r\n  .portal_icon_services {\r\n    position: absolute;\r\n    top: -60px;\r\n  }\r\n}\r\n\r\n.portal_icon_services a.portal_link_content {\r\n  text-align: center;\r\n}\r\n\r\n.portal_icon_services a.portal_link_content .portal_link_info {\r\n  width: 200px;\r\n  margin: 0 auto;\r\n  /*768px- Screen Resolution*/\r\n  /*299px- Screen Resolution*/\r\n}\r\n\r\n@media only screen and (max-width: 1199px) and (min-width: 575px) {\r\n  .portal_icon_services a.portal_link_content .portal_link_info {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 299px) {\r\n  .portal_icon_services a.portal_link_content .portal_link_info {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_icon_services a.portal_link_content .portal_link_info img.portal_link_img {\r\n  width: 100%;\r\n  height: 150px;\r\n  border-radius: 100%;\r\n  margin: 0 auto;\r\n  /* border: 2px solid $black_color;*/\r\n  margin-bottom: 10px;\r\n}\r\n\r\n@media only screen and (max-width: 991px) and (min-width: 767px) {\r\n  .portal_icon_services a.portal_link_content .portal_link_info img.portal_link_img {\r\n    width: 100%;\r\n    height: 130px;\r\n  }\r\n}\r\n\r\n.portal_icon_services a.portal_link_content .portal_link_info .portal_link_p {\r\n  font-size: 21px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n  color: #000000;\r\n}\r\n\r\n@media only screen and (min-width: 767px) {\r\n  .promo_services {\r\n    margin-top: 200px;\r\n  }\r\n}\r\n\r\n.promo_services .promo_info {\r\n  padding: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.promo_services .promo_info .promo_header {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.promo_services .promo_info .promo_caption_content {\r\n  font-family: \"Barlow\", sans-serif;\r\n  font-size: 14px;\r\n}\r\n\r\n.promo_services .promo_info .promo_caption_content_emp {\r\n  font-family: \"Barlow\", sans-serif;\r\n  font-size: 12.5px;\r\n}\r\n\r\n.portal_block_services {\r\n  background-color: #313c5c;\r\n  margin: 0px;\r\n}\r\n\r\n.portal_block_services .block_slider .block_carousel {\r\n  padding-top: 20px;\r\n}\r\n\r\n.portal_block_services .block_slider .block_carousel .portal_block_desc {\r\n  font-family: \"Barlow\", sans-serif;\r\n  font-size: 14px;\r\n  color: white;\r\n}\r\n\r\n.portal_block_services .block_slider .block_carousel .portal_block_desc_title {\r\n  font-family: \"Barlow\", sans-serif;\r\n  font-size: 13px;\r\n  color: gainsboro;\r\n  line-height: 0px;\r\n}\r\n\r\n.portal_story_services {\r\n  background-color: aliceblue;\r\n  margin: 0px;\r\n}\r\n\r\n.portal_story_services .portal_story_desc {\r\n  font-family: \"Barlow\", sans-serif;\r\n  font-size: 13px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.portal_invite_services {\r\n  padding-top: 40px;\r\n}\r\n\r\n.portal_invite_services .invite_header {\r\n  text-align: center;\r\n}\r\n\r\n.portal_invite_services .portal_invite_div {\r\n  border: solid 2px silver;\r\n  padding: 10px 20px 0px;\r\n  text-align: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.portal_invite_services .portal_invite_div .portal_invite_desc {\r\n  font-family: \"Barlow\", sans-serif;\r\n  font-size: 14px;\r\n}\r\n\r\n.g-bg-gray {\r\n  background-color: #efefef; \r\n}\r\n\r\n/*.portal_home{\r\n    margin-top: 130px;\r\n    margin-bottom: 100px;\r\n\r\n    .portal_home_info {\r\n        margin-top: 100px;\r\n        border: 2px solid $blue-color;\r\n        background-color: $light-blue-color;\r\n        text-align: center;\r\n        padding: 20px 30px;\r\n\r\n        .portal_home_header{\r\n            color: $black_color;\r\n            font-family: $font-stack;\r\n        }\r\n\r\n        .portal_home_p{\r\n            font-family: $font-stack-regular;\r\n            font-size: 18px;\r\n        }\r\n    }\r\n}*/\r\n/*!\r\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\r\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\r\n */\r\n/* FONT PATH\r\n * -------------------------- */\r\n@font-face {\r\n  font-family: 'FontAwesome';\r\n  src: url(" + __webpack_require__(368) + ");\r\n  src: url(" + __webpack_require__(367) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"), url(" + __webpack_require__(370) + ") format(\"woff2\"), url(" + __webpack_require__(371) + ") format(\"woff\"), url(" + __webpack_require__(369) + ") format(\"truetype\"), url(" + __webpack_require__(366) + "#fontawesomeregular) format(\"svg\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n.fa {\r\n  display: inline-block;\r\n  font: normal normal normal 14px/1 FontAwesome;\r\n  font-size: inherit;\r\n  text-rendering: auto;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* makes the font 33% larger relative to the icon container */\r\n.fa-lg {\r\n  font-size: 1.33333333em;\r\n  line-height: 0.75em;\r\n  vertical-align: -15%;\r\n}\r\n\r\n.fa-2x {\r\n  font-size: 2em;\r\n}\r\n\r\n.fa-3x {\r\n  font-size: 3em;\r\n}\r\n\r\n.fa-4x {\r\n  font-size: 4em;\r\n}\r\n\r\n.fa-5x {\r\n  font-size: 5em;\r\n}\r\n\r\n.fa-fw {\r\n  width: 1.28571429em;\r\n  text-align: center;\r\n}\r\n\r\n.fa-ul {\r\n  padding-left: 0;\r\n  margin-left: 2.14285714em;\r\n  list-style-type: none;\r\n}\r\n\r\n.fa-ul > li {\r\n  position: relative;\r\n}\r\n\r\n.fa-li {\r\n  position: absolute;\r\n  left: -2.14285714em;\r\n  width: 2.14285714em;\r\n  top: 0.14285714em;\r\n  text-align: center;\r\n}\r\n\r\n.fa-li.fa-lg {\r\n  left: -1.85714286em;\r\n}\r\n\r\n.fa-border {\r\n  padding: .2em .25em .15em;\r\n  border: solid 0.08em #eeeeee;\r\n  border-radius: .1em;\r\n}\r\n\r\n.fa-pull-left {\r\n  float: left;\r\n}\r\n\r\n.fa-pull-right {\r\n  float: right;\r\n}\r\n\r\n.fa.fa-pull-left {\r\n  margin-right: .3em;\r\n}\r\n\r\n.fa.fa-pull-right {\r\n  margin-left: .3em;\r\n}\r\n\r\n/* Deprecated as of 4.4.0 */\r\n.pull-right {\r\n  float: right;\r\n}\r\n\r\n.pull-left {\r\n  float: left;\r\n}\r\n\r\n.fa.pull-left {\r\n  margin-right: .3em;\r\n}\r\n\r\n.fa.pull-right {\r\n  margin-left: .3em;\r\n}\r\n\r\n.fa-spin {\r\n  -webkit-animation: fa-spin 2s infinite linear;\r\n  animation: fa-spin 2s infinite linear;\r\n}\r\n\r\n.fa-pulse {\r\n  -webkit-animation: fa-spin 1s infinite steps(8);\r\n  animation: fa-spin 1s infinite steps(8);\r\n}\r\n\r\n@-webkit-keyframes fa-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n@keyframes fa-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n.fa-rotate-90 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\r\n  -webkit-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.fa-rotate-180 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\r\n  -webkit-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.fa-rotate-270 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\r\n  -webkit-transform: rotate(270deg);\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.fa-flip-horizontal {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\r\n  -webkit-transform: scale(-1, 1);\r\n  transform: scale(-1, 1);\r\n}\r\n\r\n.fa-flip-vertical {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n  -webkit-transform: scale(1, -1);\r\n  transform: scale(1, -1);\r\n}\r\n\r\n:root .fa-rotate-90,\r\n:root .fa-rotate-180,\r\n:root .fa-rotate-270,\r\n:root .fa-flip-horizontal,\r\n:root .fa-flip-vertical {\r\n  -webkit-filter: none;\r\n          filter: none;\r\n}\r\n\r\n.fa-stack {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 2em;\r\n  height: 2em;\r\n  line-height: 2em;\r\n  vertical-align: middle;\r\n}\r\n\r\n.fa-stack-1x,\r\n.fa-stack-2x {\r\n  position: absolute;\r\n  left: 0;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.fa-stack-1x {\r\n  line-height: inherit;\r\n}\r\n\r\n.fa-stack-2x {\r\n  font-size: 2em;\r\n}\r\n\r\n.fa-inverse {\r\n  color: #ffffff;\r\n}\r\n\r\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\r\n     readers do not read off random characters that represent icons */\r\n.fa-glass:before {\r\n  content: \"\\F000\";\r\n}\r\n\r\n.fa-music:before {\r\n  content: \"\\F001\";\r\n}\r\n\r\n.fa-search:before {\r\n  content: \"\\F002\";\r\n}\r\n\r\n.fa-envelope-o:before {\r\n  content: \"\\F003\";\r\n}\r\n\r\n.fa-heart:before {\r\n  content: \"\\F004\";\r\n}\r\n\r\n.fa-star:before {\r\n  content: \"\\F005\";\r\n}\r\n\r\n.fa-star-o:before {\r\n  content: \"\\F006\";\r\n}\r\n\r\n.fa-user:before {\r\n  content: \"\\F007\";\r\n}\r\n\r\n.fa-film:before {\r\n  content: \"\\F008\";\r\n}\r\n\r\n.fa-th-large:before {\r\n  content: \"\\F009\";\r\n}\r\n\r\n.fa-th:before {\r\n  content: \"\\F00A\";\r\n}\r\n\r\n.fa-th-list:before {\r\n  content: \"\\F00B\";\r\n}\r\n\r\n.fa-check:before {\r\n  content: \"\\F00C\";\r\n}\r\n\r\n.fa-remove:before,\r\n.fa-close:before,\r\n.fa-times:before {\r\n  content: \"\\F00D\";\r\n}\r\n\r\n.fa-search-plus:before {\r\n  content: \"\\F00E\";\r\n}\r\n\r\n.fa-search-minus:before {\r\n  content: \"\\F010\";\r\n}\r\n\r\n.fa-power-off:before {\r\n  content: \"\\F011\";\r\n}\r\n\r\n.fa-signal:before {\r\n  content: \"\\F012\";\r\n}\r\n\r\n.fa-gear:before,\r\n.fa-cog:before {\r\n  content: \"\\F013\";\r\n}\r\n\r\n.fa-trash-o:before {\r\n  content: \"\\F014\";\r\n}\r\n\r\n.fa-home:before {\r\n  content: \"\\F015\";\r\n}\r\n\r\n.fa-file-o:before {\r\n  content: \"\\F016\";\r\n}\r\n\r\n.fa-clock-o:before {\r\n  content: \"\\F017\";\r\n}\r\n\r\n.fa-road:before {\r\n  content: \"\\F018\";\r\n}\r\n\r\n.fa-download:before {\r\n  content: \"\\F019\";\r\n}\r\n\r\n.fa-arrow-circle-o-down:before {\r\n  content: \"\\F01A\";\r\n}\r\n\r\n.fa-arrow-circle-o-up:before {\r\n  content: \"\\F01B\";\r\n}\r\n\r\n.fa-inbox:before {\r\n  content: \"\\F01C\";\r\n}\r\n\r\n.fa-play-circle-o:before {\r\n  content: \"\\F01D\";\r\n}\r\n\r\n.fa-rotate-right:before,\r\n.fa-repeat:before {\r\n  content: \"\\F01E\";\r\n}\r\n\r\n.fa-refresh:before {\r\n  content: \"\\F021\";\r\n}\r\n\r\n.fa-list-alt:before {\r\n  content: \"\\F022\";\r\n}\r\n\r\n.fa-lock:before {\r\n  content: \"\\F023\";\r\n}\r\n\r\n.fa-flag:before {\r\n  content: \"\\F024\";\r\n}\r\n\r\n.fa-headphones:before {\r\n  content: \"\\F025\";\r\n}\r\n\r\n.fa-volume-off:before {\r\n  content: \"\\F026\";\r\n}\r\n\r\n.fa-volume-down:before {\r\n  content: \"\\F027\";\r\n}\r\n\r\n.fa-volume-up:before {\r\n  content: \"\\F028\";\r\n}\r\n\r\n.fa-qrcode:before {\r\n  content: \"\\F029\";\r\n}\r\n\r\n.fa-barcode:before {\r\n  content: \"\\F02A\";\r\n}\r\n\r\n.fa-tag:before {\r\n  content: \"\\F02B\";\r\n}\r\n\r\n.fa-tags:before {\r\n  content: \"\\F02C\";\r\n}\r\n\r\n.fa-book:before {\r\n  content: \"\\F02D\";\r\n}\r\n\r\n.fa-bookmark:before {\r\n  content: \"\\F02E\";\r\n}\r\n\r\n.fa-print:before {\r\n  content: \"\\F02F\";\r\n}\r\n\r\n.fa-camera:before {\r\n  content: \"\\F030\";\r\n}\r\n\r\n.fa-font:before {\r\n  content: \"\\F031\";\r\n}\r\n\r\n.fa-bold:before {\r\n  content: \"\\F032\";\r\n}\r\n\r\n.fa-italic:before {\r\n  content: \"\\F033\";\r\n}\r\n\r\n.fa-text-height:before {\r\n  content: \"\\F034\";\r\n}\r\n\r\n.fa-text-width:before {\r\n  content: \"\\F035\";\r\n}\r\n\r\n.fa-align-left:before {\r\n  content: \"\\F036\";\r\n}\r\n\r\n.fa-align-center:before {\r\n  content: \"\\F037\";\r\n}\r\n\r\n.fa-align-right:before {\r\n  content: \"\\F038\";\r\n}\r\n\r\n.fa-align-justify:before {\r\n  content: \"\\F039\";\r\n}\r\n\r\n.fa-list:before {\r\n  content: \"\\F03A\";\r\n}\r\n\r\n.fa-dedent:before,\r\n.fa-outdent:before {\r\n  content: \"\\F03B\";\r\n}\r\n\r\n.fa-indent:before {\r\n  content: \"\\F03C\";\r\n}\r\n\r\n.fa-video-camera:before {\r\n  content: \"\\F03D\";\r\n}\r\n\r\n.fa-photo:before,\r\n.fa-image:before,\r\n.fa-picture-o:before {\r\n  content: \"\\F03E\";\r\n}\r\n\r\n.fa-pencil:before {\r\n  content: \"\\F040\";\r\n}\r\n\r\n.fa-map-marker:before {\r\n  content: \"\\F041\";\r\n}\r\n\r\n.fa-adjust:before {\r\n  content: \"\\F042\";\r\n}\r\n\r\n.fa-tint:before {\r\n  content: \"\\F043\";\r\n}\r\n\r\n.fa-edit:before,\r\n.fa-pencil-square-o:before {\r\n  content: \"\\F044\";\r\n}\r\n\r\n.fa-share-square-o:before {\r\n  content: \"\\F045\";\r\n}\r\n\r\n.fa-check-square-o:before {\r\n  content: \"\\F046\";\r\n}\r\n\r\n.fa-arrows:before {\r\n  content: \"\\F047\";\r\n}\r\n\r\n.fa-step-backward:before {\r\n  content: \"\\F048\";\r\n}\r\n\r\n.fa-fast-backward:before {\r\n  content: \"\\F049\";\r\n}\r\n\r\n.fa-backward:before {\r\n  content: \"\\F04A\";\r\n}\r\n\r\n.fa-play:before {\r\n  content: \"\\F04B\";\r\n}\r\n\r\n.fa-pause:before {\r\n  content: \"\\F04C\";\r\n}\r\n\r\n.fa-stop:before {\r\n  content: \"\\F04D\";\r\n}\r\n\r\n.fa-forward:before {\r\n  content: \"\\F04E\";\r\n}\r\n\r\n.fa-fast-forward:before {\r\n  content: \"\\F050\";\r\n}\r\n\r\n.fa-step-forward:before {\r\n  content: \"\\F051\";\r\n}\r\n\r\n.fa-eject:before {\r\n  content: \"\\F052\";\r\n}\r\n\r\n.fa-chevron-left:before {\r\n  content: \"\\F053\";\r\n}\r\n\r\n.fa-chevron-right:before {\r\n  content: \"\\F054\";\r\n}\r\n\r\n.fa-plus-circle:before {\r\n  content: \"\\F055\";\r\n}\r\n\r\n.fa-minus-circle:before {\r\n  content: \"\\F056\";\r\n}\r\n\r\n.fa-times-circle:before {\r\n  content: \"\\F057\";\r\n}\r\n\r\n.fa-check-circle:before {\r\n  content: \"\\F058\";\r\n}\r\n\r\n.fa-question-circle:before {\r\n  content: \"\\F059\";\r\n}\r\n\r\n.fa-info-circle:before {\r\n  content: \"\\F05A\";\r\n}\r\n\r\n.fa-crosshairs:before {\r\n  content: \"\\F05B\";\r\n}\r\n\r\n.fa-times-circle-o:before {\r\n  content: \"\\F05C\";\r\n}\r\n\r\n.fa-check-circle-o:before {\r\n  content: \"\\F05D\";\r\n}\r\n\r\n.fa-ban:before {\r\n  content: \"\\F05E\";\r\n}\r\n\r\n.fa-arrow-left:before {\r\n  content: \"\\F060\";\r\n}\r\n\r\n.fa-arrow-right:before {\r\n  content: \"\\F061\";\r\n}\r\n\r\n.fa-arrow-up:before {\r\n  content: \"\\F062\";\r\n}\r\n\r\n.fa-arrow-down:before {\r\n  content: \"\\F063\";\r\n}\r\n\r\n.fa-mail-forward:before,\r\n.fa-share:before {\r\n  content: \"\\F064\";\r\n}\r\n\r\n.fa-expand:before {\r\n  content: \"\\F065\";\r\n}\r\n\r\n.fa-compress:before {\r\n  content: \"\\F066\";\r\n}\r\n\r\n.fa-plus:before {\r\n  content: \"\\F067\";\r\n}\r\n\r\n.fa-minus:before {\r\n  content: \"\\F068\";\r\n}\r\n\r\n.fa-asterisk:before {\r\n  content: \"\\F069\";\r\n}\r\n\r\n.fa-exclamation-circle:before {\r\n  content: \"\\F06A\";\r\n}\r\n\r\n.fa-gift:before {\r\n  content: \"\\F06B\";\r\n}\r\n\r\n.fa-leaf:before {\r\n  content: \"\\F06C\";\r\n}\r\n\r\n.fa-fire:before {\r\n  content: \"\\F06D\";\r\n}\r\n\r\n.fa-eye:before {\r\n  content: \"\\F06E\";\r\n}\r\n\r\n.fa-eye-slash:before {\r\n  content: \"\\F070\";\r\n}\r\n\r\n.fa-warning:before,\r\n.fa-exclamation-triangle:before {\r\n  content: \"\\F071\";\r\n}\r\n\r\n.fa-plane:before {\r\n  content: \"\\F072\";\r\n}\r\n\r\n.fa-calendar:before {\r\n  content: \"\\F073\";\r\n}\r\n\r\n.fa-random:before {\r\n  content: \"\\F074\";\r\n}\r\n\r\n.fa-comment:before {\r\n  content: \"\\F075\";\r\n}\r\n\r\n.fa-magnet:before {\r\n  content: \"\\F076\";\r\n}\r\n\r\n.fa-chevron-up:before {\r\n  content: \"\\F077\";\r\n}\r\n\r\n.fa-chevron-down:before {\r\n  content: \"\\F078\";\r\n}\r\n\r\n.fa-retweet:before {\r\n  content: \"\\F079\";\r\n}\r\n\r\n.fa-shopping-cart:before {\r\n  content: \"\\F07A\";\r\n}\r\n\r\n.fa-folder:before {\r\n  content: \"\\F07B\";\r\n}\r\n\r\n.fa-folder-open:before {\r\n  content: \"\\F07C\";\r\n}\r\n\r\n.fa-arrows-v:before {\r\n  content: \"\\F07D\";\r\n}\r\n\r\n.fa-arrows-h:before {\r\n  content: \"\\F07E\";\r\n}\r\n\r\n.fa-bar-chart-o:before,\r\n.fa-bar-chart:before {\r\n  content: \"\\F080\";\r\n}\r\n\r\n.fa-twitter-square:before {\r\n  content: \"\\F081\";\r\n}\r\n\r\n.fa-facebook-square:before {\r\n  content: \"\\F082\";\r\n}\r\n\r\n.fa-camera-retro:before {\r\n  content: \"\\F083\";\r\n}\r\n\r\n.fa-key:before {\r\n  content: \"\\F084\";\r\n}\r\n\r\n.fa-gears:before,\r\n.fa-cogs:before {\r\n  content: \"\\F085\";\r\n}\r\n\r\n.fa-comments:before {\r\n  content: \"\\F086\";\r\n}\r\n\r\n.fa-thumbs-o-up:before {\r\n  content: \"\\F087\";\r\n}\r\n\r\n.fa-thumbs-o-down:before {\r\n  content: \"\\F088\";\r\n}\r\n\r\n.fa-star-half:before {\r\n  content: \"\\F089\";\r\n}\r\n\r\n.fa-heart-o:before {\r\n  content: \"\\F08A\";\r\n}\r\n\r\n.fa-sign-out:before {\r\n  content: \"\\F08B\";\r\n}\r\n\r\n.fa-linkedin-square:before {\r\n  content: \"\\F08C\";\r\n}\r\n\r\n.fa-thumb-tack:before {\r\n  content: \"\\F08D\";\r\n}\r\n\r\n.fa-external-link:before {\r\n  content: \"\\F08E\";\r\n}\r\n\r\n.fa-sign-in:before {\r\n  content: \"\\F090\";\r\n}\r\n\r\n.fa-trophy:before {\r\n  content: \"\\F091\";\r\n}\r\n\r\n.fa-github-square:before {\r\n  content: \"\\F092\";\r\n}\r\n\r\n.fa-upload:before {\r\n  content: \"\\F093\";\r\n}\r\n\r\n.fa-lemon-o:before {\r\n  content: \"\\F094\";\r\n}\r\n\r\n.fa-phone:before {\r\n  content: \"\\F095\";\r\n}\r\n\r\n.fa-square-o:before {\r\n  content: \"\\F096\";\r\n}\r\n\r\n.fa-bookmark-o:before {\r\n  content: \"\\F097\";\r\n}\r\n\r\n.fa-phone-square:before {\r\n  content: \"\\F098\";\r\n}\r\n\r\n.fa-twitter:before {\r\n  content: \"\\F099\";\r\n}\r\n\r\n.fa-facebook-f:before,\r\n.fa-facebook:before {\r\n  content: \"\\F09A\";\r\n}\r\n\r\n.fa-github:before {\r\n  content: \"\\F09B\";\r\n}\r\n\r\n.fa-unlock:before {\r\n  content: \"\\F09C\";\r\n}\r\n\r\n.fa-credit-card:before {\r\n  content: \"\\F09D\";\r\n}\r\n\r\n.fa-feed:before,\r\n.fa-rss:before {\r\n  content: \"\\F09E\";\r\n}\r\n\r\n.fa-hdd-o:before {\r\n  content: \"\\F0A0\";\r\n}\r\n\r\n.fa-bullhorn:before {\r\n  content: \"\\F0A1\";\r\n}\r\n\r\n.fa-bell:before {\r\n  content: \"\\F0F3\";\r\n}\r\n\r\n.fa-certificate:before {\r\n  content: \"\\F0A3\";\r\n}\r\n\r\n.fa-hand-o-right:before {\r\n  content: \"\\F0A4\";\r\n}\r\n\r\n.fa-hand-o-left:before {\r\n  content: \"\\F0A5\";\r\n}\r\n\r\n.fa-hand-o-up:before {\r\n  content: \"\\F0A6\";\r\n}\r\n\r\n.fa-hand-o-down:before {\r\n  content: \"\\F0A7\";\r\n}\r\n\r\n.fa-arrow-circle-left:before {\r\n  content: \"\\F0A8\";\r\n}\r\n\r\n.fa-arrow-circle-right:before {\r\n  content: \"\\F0A9\";\r\n}\r\n\r\n.fa-arrow-circle-up:before {\r\n  content: \"\\F0AA\";\r\n}\r\n\r\n.fa-arrow-circle-down:before {\r\n  content: \"\\F0AB\";\r\n}\r\n\r\n.fa-globe:before {\r\n  content: \"\\F0AC\";\r\n}\r\n\r\n.fa-wrench:before {\r\n  content: \"\\F0AD\";\r\n}\r\n\r\n.fa-tasks:before {\r\n  content: \"\\F0AE\";\r\n}\r\n\r\n.fa-filter:before {\r\n  content: \"\\F0B0\";\r\n}\r\n\r\n.fa-briefcase:before {\r\n  content: \"\\F0B1\";\r\n}\r\n\r\n.fa-arrows-alt:before {\r\n  content: \"\\F0B2\";\r\n}\r\n\r\n.fa-group:before,\r\n.fa-users:before {\r\n  content: \"\\F0C0\";\r\n}\r\n\r\n.fa-chain:before,\r\n.fa-link:before {\r\n  content: \"\\F0C1\";\r\n}\r\n\r\n.fa-cloud:before {\r\n  content: \"\\F0C2\";\r\n}\r\n\r\n.fa-flask:before {\r\n  content: \"\\F0C3\";\r\n}\r\n\r\n.fa-cut:before,\r\n.fa-scissors:before {\r\n  content: \"\\F0C4\";\r\n}\r\n\r\n.fa-copy:before,\r\n.fa-files-o:before {\r\n  content: \"\\F0C5\";\r\n}\r\n\r\n.fa-paperclip:before {\r\n  content: \"\\F0C6\";\r\n}\r\n\r\n.fa-save:before,\r\n.fa-floppy-o:before {\r\n  content: \"\\F0C7\";\r\n}\r\n\r\n.fa-square:before {\r\n  content: \"\\F0C8\";\r\n}\r\n\r\n.fa-navicon:before,\r\n.fa-reorder:before,\r\n.fa-bars:before {\r\n  content: \"\\F0C9\";\r\n}\r\n\r\n.fa-list-ul:before {\r\n  content: \"\\F0CA\";\r\n}\r\n\r\n.fa-list-ol:before {\r\n  content: \"\\F0CB\";\r\n}\r\n\r\n.fa-strikethrough:before {\r\n  content: \"\\F0CC\";\r\n}\r\n\r\n.fa-underline:before {\r\n  content: \"\\F0CD\";\r\n}\r\n\r\n.fa-table:before {\r\n  content: \"\\F0CE\";\r\n}\r\n\r\n.fa-magic:before {\r\n  content: \"\\F0D0\";\r\n}\r\n\r\n.fa-truck:before {\r\n  content: \"\\F0D1\";\r\n}\r\n\r\n.fa-pinterest:before {\r\n  content: \"\\F0D2\";\r\n}\r\n\r\n.fa-pinterest-square:before {\r\n  content: \"\\F0D3\";\r\n}\r\n\r\n.fa-google-plus-square:before {\r\n  content: \"\\F0D4\";\r\n}\r\n\r\n.fa-google-plus:before {\r\n  content: \"\\F0D5\";\r\n}\r\n\r\n.fa-money:before {\r\n  content: \"\\F0D6\";\r\n}\r\n\r\n.fa-caret-down:before {\r\n  content: \"\\F0D7\";\r\n}\r\n\r\n.fa-caret-up:before {\r\n  content: \"\\F0D8\";\r\n}\r\n\r\n.fa-caret-left:before {\r\n  content: \"\\F0D9\";\r\n}\r\n\r\n.fa-caret-right:before {\r\n  content: \"\\F0DA\";\r\n}\r\n\r\n.fa-columns:before {\r\n  content: \"\\F0DB\";\r\n}\r\n\r\n.fa-unsorted:before,\r\n.fa-sort:before {\r\n  content: \"\\F0DC\";\r\n}\r\n\r\n.fa-sort-down:before,\r\n.fa-sort-desc:before {\r\n  content: \"\\F0DD\";\r\n}\r\n\r\n.fa-sort-up:before,\r\n.fa-sort-asc:before {\r\n  content: \"\\F0DE\";\r\n}\r\n\r\n.fa-envelope:before {\r\n  content: \"\\F0E0\";\r\n}\r\n\r\n.fa-linkedin:before {\r\n  content: \"\\F0E1\";\r\n}\r\n\r\n.fa-rotate-left:before,\r\n.fa-undo:before {\r\n  content: \"\\F0E2\";\r\n}\r\n\r\n.fa-legal:before,\r\n.fa-gavel:before {\r\n  content: \"\\F0E3\";\r\n}\r\n\r\n.fa-dashboard:before,\r\n.fa-tachometer:before {\r\n  content: \"\\F0E4\";\r\n}\r\n\r\n.fa-comment-o:before {\r\n  content: \"\\F0E5\";\r\n}\r\n\r\n.fa-comments-o:before {\r\n  content: \"\\F0E6\";\r\n}\r\n\r\n.fa-flash:before,\r\n.fa-bolt:before {\r\n  content: \"\\F0E7\";\r\n}\r\n\r\n.fa-sitemap:before {\r\n  content: \"\\F0E8\";\r\n}\r\n\r\n.fa-umbrella:before {\r\n  content: \"\\F0E9\";\r\n}\r\n\r\n.fa-paste:before,\r\n.fa-clipboard:before {\r\n  content: \"\\F0EA\";\r\n}\r\n\r\n.fa-lightbulb-o:before {\r\n  content: \"\\F0EB\";\r\n}\r\n\r\n.fa-exchange:before {\r\n  content: \"\\F0EC\";\r\n}\r\n\r\n.fa-cloud-download:before {\r\n  content: \"\\F0ED\";\r\n}\r\n\r\n.fa-cloud-upload:before {\r\n  content: \"\\F0EE\";\r\n}\r\n\r\n.fa-user-md:before {\r\n  content: \"\\F0F0\";\r\n}\r\n\r\n.fa-stethoscope:before {\r\n  content: \"\\F0F1\";\r\n}\r\n\r\n.fa-suitcase:before {\r\n  content: \"\\F0F2\";\r\n}\r\n\r\n.fa-bell-o:before {\r\n  content: \"\\F0A2\";\r\n}\r\n\r\n.fa-coffee:before {\r\n  content: \"\\F0F4\";\r\n}\r\n\r\n.fa-cutlery:before {\r\n  content: \"\\F0F5\";\r\n}\r\n\r\n.fa-file-text-o:before {\r\n  content: \"\\F0F6\";\r\n}\r\n\r\n.fa-building-o:before {\r\n  content: \"\\F0F7\";\r\n}\r\n\r\n.fa-hospital-o:before {\r\n  content: \"\\F0F8\";\r\n}\r\n\r\n.fa-ambulance:before {\r\n  content: \"\\F0F9\";\r\n}\r\n\r\n.fa-medkit:before {\r\n  content: \"\\F0FA\";\r\n}\r\n\r\n.fa-fighter-jet:before {\r\n  content: \"\\F0FB\";\r\n}\r\n\r\n.fa-beer:before {\r\n  content: \"\\F0FC\";\r\n}\r\n\r\n.fa-h-square:before {\r\n  content: \"\\F0FD\";\r\n}\r\n\r\n.fa-plus-square:before {\r\n  content: \"\\F0FE\";\r\n}\r\n\r\n.fa-angle-double-left:before {\r\n  content: \"\\F100\";\r\n}\r\n\r\n.fa-angle-double-right:before {\r\n  content: \"\\F101\";\r\n}\r\n\r\n.fa-angle-double-up:before {\r\n  content: \"\\F102\";\r\n}\r\n\r\n.fa-angle-double-down:before {\r\n  content: \"\\F103\";\r\n}\r\n\r\n.fa-angle-left:before {\r\n  content: \"\\F104\";\r\n}\r\n\r\n.fa-angle-right:before {\r\n  content: \"\\F105\";\r\n}\r\n\r\n.fa-angle-up:before {\r\n  content: \"\\F106\";\r\n}\r\n\r\n.fa-angle-down:before {\r\n  content: \"\\F107\";\r\n}\r\n\r\n.fa-desktop:before {\r\n  content: \"\\F108\";\r\n}\r\n\r\n.fa-laptop:before {\r\n  content: \"\\F109\";\r\n}\r\n\r\n.fa-tablet:before {\r\n  content: \"\\F10A\";\r\n}\r\n\r\n.fa-mobile-phone:before,\r\n.fa-mobile:before {\r\n  content: \"\\F10B\";\r\n}\r\n\r\n.fa-circle-o:before {\r\n  content: \"\\F10C\";\r\n}\r\n\r\n.fa-quote-left:before {\r\n  content: \"\\F10D\";\r\n}\r\n\r\n.fa-quote-right:before {\r\n  content: \"\\F10E\";\r\n}\r\n\r\n.fa-spinner:before {\r\n  content: \"\\F110\";\r\n}\r\n\r\n.fa-circle:before {\r\n  content: \"\\F111\";\r\n}\r\n\r\n.fa-mail-reply:before,\r\n.fa-reply:before {\r\n  content: \"\\F112\";\r\n}\r\n\r\n.fa-github-alt:before {\r\n  content: \"\\F113\";\r\n}\r\n\r\n.fa-folder-o:before {\r\n  content: \"\\F114\";\r\n}\r\n\r\n.fa-folder-open-o:before {\r\n  content: \"\\F115\";\r\n}\r\n\r\n.fa-smile-o:before {\r\n  content: \"\\F118\";\r\n}\r\n\r\n.fa-frown-o:before {\r\n  content: \"\\F119\";\r\n}\r\n\r\n.fa-meh-o:before {\r\n  content: \"\\F11A\";\r\n}\r\n\r\n.fa-gamepad:before {\r\n  content: \"\\F11B\";\r\n}\r\n\r\n.fa-keyboard-o:before {\r\n  content: \"\\F11C\";\r\n}\r\n\r\n.fa-flag-o:before {\r\n  content: \"\\F11D\";\r\n}\r\n\r\n.fa-flag-checkered:before {\r\n  content: \"\\F11E\";\r\n}\r\n\r\n.fa-terminal:before {\r\n  content: \"\\F120\";\r\n}\r\n\r\n.fa-code:before {\r\n  content: \"\\F121\";\r\n}\r\n\r\n.fa-mail-reply-all:before,\r\n.fa-reply-all:before {\r\n  content: \"\\F122\";\r\n}\r\n\r\n.fa-star-half-empty:before,\r\n.fa-star-half-full:before,\r\n.fa-star-half-o:before {\r\n  content: \"\\F123\";\r\n}\r\n\r\n.fa-location-arrow:before {\r\n  content: \"\\F124\";\r\n}\r\n\r\n.fa-crop:before {\r\n  content: \"\\F125\";\r\n}\r\n\r\n.fa-code-fork:before {\r\n  content: \"\\F126\";\r\n}\r\n\r\n.fa-unlink:before,\r\n.fa-chain-broken:before {\r\n  content: \"\\F127\";\r\n}\r\n\r\n.fa-question:before {\r\n  content: \"\\F128\";\r\n}\r\n\r\n.fa-info:before {\r\n  content: \"\\F129\";\r\n}\r\n\r\n.fa-exclamation:before {\r\n  content: \"\\F12A\";\r\n}\r\n\r\n.fa-superscript:before {\r\n  content: \"\\F12B\";\r\n}\r\n\r\n.fa-subscript:before {\r\n  content: \"\\F12C\";\r\n}\r\n\r\n.fa-eraser:before {\r\n  content: \"\\F12D\";\r\n}\r\n\r\n.fa-puzzle-piece:before {\r\n  content: \"\\F12E\";\r\n}\r\n\r\n.fa-microphone:before {\r\n  content: \"\\F130\";\r\n}\r\n\r\n.fa-microphone-slash:before {\r\n  content: \"\\F131\";\r\n}\r\n\r\n.fa-shield:before {\r\n  content: \"\\F132\";\r\n}\r\n\r\n.fa-calendar-o:before {\r\n  content: \"\\F133\";\r\n}\r\n\r\n.fa-fire-extinguisher:before {\r\n  content: \"\\F134\";\r\n}\r\n\r\n.fa-rocket:before {\r\n  content: \"\\F135\";\r\n}\r\n\r\n.fa-maxcdn:before {\r\n  content: \"\\F136\";\r\n}\r\n\r\n.fa-chevron-circle-left:before {\r\n  content: \"\\F137\";\r\n}\r\n\r\n.fa-chevron-circle-right:before {\r\n  content: \"\\F138\";\r\n}\r\n\r\n.fa-chevron-circle-up:before {\r\n  content: \"\\F139\";\r\n}\r\n\r\n.fa-chevron-circle-down:before {\r\n  content: \"\\F13A\";\r\n}\r\n\r\n.fa-html5:before {\r\n  content: \"\\F13B\";\r\n}\r\n\r\n.fa-css3:before {\r\n  content: \"\\F13C\";\r\n}\r\n\r\n.fa-anchor:before {\r\n  content: \"\\F13D\";\r\n}\r\n\r\n.fa-unlock-alt:before {\r\n  content: \"\\F13E\";\r\n}\r\n\r\n.fa-bullseye:before {\r\n  content: \"\\F140\";\r\n}\r\n\r\n.fa-ellipsis-h:before {\r\n  content: \"\\F141\";\r\n}\r\n\r\n.fa-ellipsis-v:before {\r\n  content: \"\\F142\";\r\n}\r\n\r\n.fa-rss-square:before {\r\n  content: \"\\F143\";\r\n}\r\n\r\n.fa-play-circle:before {\r\n  content: \"\\F144\";\r\n}\r\n\r\n.fa-ticket:before {\r\n  content: \"\\F145\";\r\n}\r\n\r\n.fa-minus-square:before {\r\n  content: \"\\F146\";\r\n}\r\n\r\n.fa-minus-square-o:before {\r\n  content: \"\\F147\";\r\n}\r\n\r\n.fa-level-up:before {\r\n  content: \"\\F148\";\r\n}\r\n\r\n.fa-level-down:before {\r\n  content: \"\\F149\";\r\n}\r\n\r\n.fa-check-square:before {\r\n  content: \"\\F14A\";\r\n}\r\n\r\n.fa-pencil-square:before {\r\n  content: \"\\F14B\";\r\n}\r\n\r\n.fa-external-link-square:before {\r\n  content: \"\\F14C\";\r\n}\r\n\r\n.fa-share-square:before {\r\n  content: \"\\F14D\";\r\n}\r\n\r\n.fa-compass:before {\r\n  content: \"\\F14E\";\r\n}\r\n\r\n.fa-toggle-down:before,\r\n.fa-caret-square-o-down:before {\r\n  content: \"\\F150\";\r\n}\r\n\r\n.fa-toggle-up:before,\r\n.fa-caret-square-o-up:before {\r\n  content: \"\\F151\";\r\n}\r\n\r\n.fa-toggle-right:before,\r\n.fa-caret-square-o-right:before {\r\n  content: \"\\F152\";\r\n}\r\n\r\n.fa-euro:before,\r\n.fa-eur:before {\r\n  content: \"\\F153\";\r\n}\r\n\r\n.fa-gbp:before {\r\n  content: \"\\F154\";\r\n}\r\n\r\n.fa-dollar:before,\r\n.fa-usd:before {\r\n  content: \"\\F155\";\r\n}\r\n\r\n.fa-rupee:before,\r\n.fa-inr:before {\r\n  content: \"\\F156\";\r\n}\r\n\r\n.fa-cny:before,\r\n.fa-rmb:before,\r\n.fa-yen:before,\r\n.fa-jpy:before {\r\n  content: \"\\F157\";\r\n}\r\n\r\n.fa-ruble:before,\r\n.fa-rouble:before,\r\n.fa-rub:before {\r\n  content: \"\\F158\";\r\n}\r\n\r\n.fa-won:before,\r\n.fa-krw:before {\r\n  content: \"\\F159\";\r\n}\r\n\r\n.fa-bitcoin:before,\r\n.fa-btc:before {\r\n  content: \"\\F15A\";\r\n}\r\n\r\n.fa-file:before {\r\n  content: \"\\F15B\";\r\n}\r\n\r\n.fa-file-text:before {\r\n  content: \"\\F15C\";\r\n}\r\n\r\n.fa-sort-alpha-asc:before {\r\n  content: \"\\F15D\";\r\n}\r\n\r\n.fa-sort-alpha-desc:before {\r\n  content: \"\\F15E\";\r\n}\r\n\r\n.fa-sort-amount-asc:before {\r\n  content: \"\\F160\";\r\n}\r\n\r\n.fa-sort-amount-desc:before {\r\n  content: \"\\F161\";\r\n}\r\n\r\n.fa-sort-numeric-asc:before {\r\n  content: \"\\F162\";\r\n}\r\n\r\n.fa-sort-numeric-desc:before {\r\n  content: \"\\F163\";\r\n}\r\n\r\n.fa-thumbs-up:before {\r\n  content: \"\\F164\";\r\n}\r\n\r\n.fa-thumbs-down:before {\r\n  content: \"\\F165\";\r\n}\r\n\r\n.fa-youtube-square:before {\r\n  content: \"\\F166\";\r\n}\r\n\r\n.fa-youtube:before {\r\n  content: \"\\F167\";\r\n}\r\n\r\n.fa-xing:before {\r\n  content: \"\\F168\";\r\n}\r\n\r\n.fa-xing-square:before {\r\n  content: \"\\F169\";\r\n}\r\n\r\n.fa-youtube-play:before {\r\n  content: \"\\F16A\";\r\n}\r\n\r\n.fa-dropbox:before {\r\n  content: \"\\F16B\";\r\n}\r\n\r\n.fa-stack-overflow:before {\r\n  content: \"\\F16C\";\r\n}\r\n\r\n.fa-instagram:before {\r\n  content: \"\\F16D\";\r\n}\r\n\r\n.fa-flickr:before {\r\n  content: \"\\F16E\";\r\n}\r\n\r\n.fa-adn:before {\r\n  content: \"\\F170\";\r\n}\r\n\r\n.fa-bitbucket:before {\r\n  content: \"\\F171\";\r\n}\r\n\r\n.fa-bitbucket-square:before {\r\n  content: \"\\F172\";\r\n}\r\n\r\n.fa-tumblr:before {\r\n  content: \"\\F173\";\r\n}\r\n\r\n.fa-tumblr-square:before {\r\n  content: \"\\F174\";\r\n}\r\n\r\n.fa-long-arrow-down:before {\r\n  content: \"\\F175\";\r\n}\r\n\r\n.fa-long-arrow-up:before {\r\n  content: \"\\F176\";\r\n}\r\n\r\n.fa-long-arrow-left:before {\r\n  content: \"\\F177\";\r\n}\r\n\r\n.fa-long-arrow-right:before {\r\n  content: \"\\F178\";\r\n}\r\n\r\n.fa-apple:before {\r\n  content: \"\\F179\";\r\n}\r\n\r\n.fa-windows:before {\r\n  content: \"\\F17A\";\r\n}\r\n\r\n.fa-android:before {\r\n  content: \"\\F17B\";\r\n}\r\n\r\n.fa-linux:before {\r\n  content: \"\\F17C\";\r\n}\r\n\r\n.fa-dribbble:before {\r\n  content: \"\\F17D\";\r\n}\r\n\r\n.fa-skype:before {\r\n  content: \"\\F17E\";\r\n}\r\n\r\n.fa-foursquare:before {\r\n  content: \"\\F180\";\r\n}\r\n\r\n.fa-trello:before {\r\n  content: \"\\F181\";\r\n}\r\n\r\n.fa-female:before {\r\n  content: \"\\F182\";\r\n}\r\n\r\n.fa-male:before {\r\n  content: \"\\F183\";\r\n}\r\n\r\n.fa-gittip:before,\r\n.fa-gratipay:before {\r\n  content: \"\\F184\";\r\n}\r\n\r\n.fa-sun-o:before {\r\n  content: \"\\F185\";\r\n}\r\n\r\n.fa-moon-o:before {\r\n  content: \"\\F186\";\r\n}\r\n\r\n.fa-archive:before {\r\n  content: \"\\F187\";\r\n}\r\n\r\n.fa-bug:before {\r\n  content: \"\\F188\";\r\n}\r\n\r\n.fa-vk:before {\r\n  content: \"\\F189\";\r\n}\r\n\r\n.fa-weibo:before {\r\n  content: \"\\F18A\";\r\n}\r\n\r\n.fa-renren:before {\r\n  content: \"\\F18B\";\r\n}\r\n\r\n.fa-pagelines:before {\r\n  content: \"\\F18C\";\r\n}\r\n\r\n.fa-stack-exchange:before {\r\n  content: \"\\F18D\";\r\n}\r\n\r\n.fa-arrow-circle-o-right:before {\r\n  content: \"\\F18E\";\r\n}\r\n\r\n.fa-arrow-circle-o-left:before {\r\n  content: \"\\F190\";\r\n}\r\n\r\n.fa-toggle-left:before,\r\n.fa-caret-square-o-left:before {\r\n  content: \"\\F191\";\r\n}\r\n\r\n.fa-dot-circle-o:before {\r\n  content: \"\\F192\";\r\n}\r\n\r\n.fa-wheelchair:before {\r\n  content: \"\\F193\";\r\n}\r\n\r\n.fa-vimeo-square:before {\r\n  content: \"\\F194\";\r\n}\r\n\r\n.fa-turkish-lira:before,\r\n.fa-try:before {\r\n  content: \"\\F195\";\r\n}\r\n\r\n.fa-plus-square-o:before {\r\n  content: \"\\F196\";\r\n}\r\n\r\n.fa-space-shuttle:before {\r\n  content: \"\\F197\";\r\n}\r\n\r\n.fa-slack:before {\r\n  content: \"\\F198\";\r\n}\r\n\r\n.fa-envelope-square:before {\r\n  content: \"\\F199\";\r\n}\r\n\r\n.fa-wordpress:before {\r\n  content: \"\\F19A\";\r\n}\r\n\r\n.fa-openid:before {\r\n  content: \"\\F19B\";\r\n}\r\n\r\n.fa-institution:before,\r\n.fa-bank:before,\r\n.fa-university:before {\r\n  content: \"\\F19C\";\r\n}\r\n\r\n.fa-mortar-board:before,\r\n.fa-graduation-cap:before {\r\n  content: \"\\F19D\";\r\n}\r\n\r\n.fa-yahoo:before {\r\n  content: \"\\F19E\";\r\n}\r\n\r\n.fa-google:before {\r\n  content: \"\\F1A0\";\r\n}\r\n\r\n.fa-reddit:before {\r\n  content: \"\\F1A1\";\r\n}\r\n\r\n.fa-reddit-square:before {\r\n  content: \"\\F1A2\";\r\n}\r\n\r\n.fa-stumbleupon-circle:before {\r\n  content: \"\\F1A3\";\r\n}\r\n\r\n.fa-stumbleupon:before {\r\n  content: \"\\F1A4\";\r\n}\r\n\r\n.fa-delicious:before {\r\n  content: \"\\F1A5\";\r\n}\r\n\r\n.fa-digg:before {\r\n  content: \"\\F1A6\";\r\n}\r\n\r\n.fa-pied-piper-pp:before {\r\n  content: \"\\F1A7\";\r\n}\r\n\r\n.fa-pied-piper-alt:before {\r\n  content: \"\\F1A8\";\r\n}\r\n\r\n.fa-drupal:before {\r\n  content: \"\\F1A9\";\r\n}\r\n\r\n.fa-joomla:before {\r\n  content: \"\\F1AA\";\r\n}\r\n\r\n.fa-language:before {\r\n  content: \"\\F1AB\";\r\n}\r\n\r\n.fa-fax:before {\r\n  content: \"\\F1AC\";\r\n}\r\n\r\n.fa-building:before {\r\n  content: \"\\F1AD\";\r\n}\r\n\r\n.fa-child:before {\r\n  content: \"\\F1AE\";\r\n}\r\n\r\n.fa-paw:before {\r\n  content: \"\\F1B0\";\r\n}\r\n\r\n.fa-spoon:before {\r\n  content: \"\\F1B1\";\r\n}\r\n\r\n.fa-cube:before {\r\n  content: \"\\F1B2\";\r\n}\r\n\r\n.fa-cubes:before {\r\n  content: \"\\F1B3\";\r\n}\r\n\r\n.fa-behance:before {\r\n  content: \"\\F1B4\";\r\n}\r\n\r\n.fa-behance-square:before {\r\n  content: \"\\F1B5\";\r\n}\r\n\r\n.fa-steam:before {\r\n  content: \"\\F1B6\";\r\n}\r\n\r\n.fa-steam-square:before {\r\n  content: \"\\F1B7\";\r\n}\r\n\r\n.fa-recycle:before {\r\n  content: \"\\F1B8\";\r\n}\r\n\r\n.fa-automobile:before,\r\n.fa-car:before {\r\n  content: \"\\F1B9\";\r\n}\r\n\r\n.fa-cab:before,\r\n.fa-taxi:before {\r\n  content: \"\\F1BA\";\r\n}\r\n\r\n.fa-tree:before {\r\n  content: \"\\F1BB\";\r\n}\r\n\r\n.fa-spotify:before {\r\n  content: \"\\F1BC\";\r\n}\r\n\r\n.fa-deviantart:before {\r\n  content: \"\\F1BD\";\r\n}\r\n\r\n.fa-soundcloud:before {\r\n  content: \"\\F1BE\";\r\n}\r\n\r\n.fa-database:before {\r\n  content: \"\\F1C0\";\r\n}\r\n\r\n.fa-file-pdf-o:before {\r\n  content: \"\\F1C1\";\r\n}\r\n\r\n.fa-file-word-o:before {\r\n  content: \"\\F1C2\";\r\n}\r\n\r\n.fa-file-excel-o:before {\r\n  content: \"\\F1C3\";\r\n}\r\n\r\n.fa-file-powerpoint-o:before {\r\n  content: \"\\F1C4\";\r\n}\r\n\r\n.fa-file-photo-o:before,\r\n.fa-file-picture-o:before,\r\n.fa-file-image-o:before {\r\n  content: \"\\F1C5\";\r\n}\r\n\r\n.fa-file-zip-o:before,\r\n.fa-file-archive-o:before {\r\n  content: \"\\F1C6\";\r\n}\r\n\r\n.fa-file-sound-o:before,\r\n.fa-file-audio-o:before {\r\n  content: \"\\F1C7\";\r\n}\r\n\r\n.fa-file-movie-o:before,\r\n.fa-file-video-o:before {\r\n  content: \"\\F1C8\";\r\n}\r\n\r\n.fa-file-code-o:before {\r\n  content: \"\\F1C9\";\r\n}\r\n\r\n.fa-vine:before {\r\n  content: \"\\F1CA\";\r\n}\r\n\r\n.fa-codepen:before {\r\n  content: \"\\F1CB\";\r\n}\r\n\r\n.fa-jsfiddle:before {\r\n  content: \"\\F1CC\";\r\n}\r\n\r\n.fa-life-bouy:before,\r\n.fa-life-buoy:before,\r\n.fa-life-saver:before,\r\n.fa-support:before,\r\n.fa-life-ring:before {\r\n  content: \"\\F1CD\";\r\n}\r\n\r\n.fa-circle-o-notch:before {\r\n  content: \"\\F1CE\";\r\n}\r\n\r\n.fa-ra:before,\r\n.fa-resistance:before,\r\n.fa-rebel:before {\r\n  content: \"\\F1D0\";\r\n}\r\n\r\n.fa-ge:before,\r\n.fa-empire:before {\r\n  content: \"\\F1D1\";\r\n}\r\n\r\n.fa-git-square:before {\r\n  content: \"\\F1D2\";\r\n}\r\n\r\n.fa-git:before {\r\n  content: \"\\F1D3\";\r\n}\r\n\r\n.fa-y-combinator-square:before,\r\n.fa-yc-square:before,\r\n.fa-hacker-news:before {\r\n  content: \"\\F1D4\";\r\n}\r\n\r\n.fa-tencent-weibo:before {\r\n  content: \"\\F1D5\";\r\n}\r\n\r\n.fa-qq:before {\r\n  content: \"\\F1D6\";\r\n}\r\n\r\n.fa-wechat:before,\r\n.fa-weixin:before {\r\n  content: \"\\F1D7\";\r\n}\r\n\r\n.fa-send:before,\r\n.fa-paper-plane:before {\r\n  content: \"\\F1D8\";\r\n}\r\n\r\n.fa-send-o:before,\r\n.fa-paper-plane-o:before {\r\n  content: \"\\F1D9\";\r\n}\r\n\r\n.fa-history:before {\r\n  content: \"\\F1DA\";\r\n}\r\n\r\n.fa-circle-thin:before {\r\n  content: \"\\F1DB\";\r\n}\r\n\r\n.fa-header:before {\r\n  content: \"\\F1DC\";\r\n}\r\n\r\n.fa-paragraph:before {\r\n  content: \"\\F1DD\";\r\n}\r\n\r\n.fa-sliders:before {\r\n  content: \"\\F1DE\";\r\n}\r\n\r\n.fa-share-alt:before {\r\n  content: \"\\F1E0\";\r\n}\r\n\r\n.fa-share-alt-square:before {\r\n  content: \"\\F1E1\";\r\n}\r\n\r\n.fa-bomb:before {\r\n  content: \"\\F1E2\";\r\n}\r\n\r\n.fa-soccer-ball-o:before,\r\n.fa-futbol-o:before {\r\n  content: \"\\F1E3\";\r\n}\r\n\r\n.fa-tty:before {\r\n  content: \"\\F1E4\";\r\n}\r\n\r\n.fa-binoculars:before {\r\n  content: \"\\F1E5\";\r\n}\r\n\r\n.fa-plug:before {\r\n  content: \"\\F1E6\";\r\n}\r\n\r\n.fa-slideshare:before {\r\n  content: \"\\F1E7\";\r\n}\r\n\r\n.fa-twitch:before {\r\n  content: \"\\F1E8\";\r\n}\r\n\r\n.fa-yelp:before {\r\n  content: \"\\F1E9\";\r\n}\r\n\r\n.fa-newspaper-o:before {\r\n  content: \"\\F1EA\";\r\n}\r\n\r\n.fa-wifi:before {\r\n  content: \"\\F1EB\";\r\n}\r\n\r\n.fa-calculator:before {\r\n  content: \"\\F1EC\";\r\n}\r\n\r\n.fa-paypal:before {\r\n  content: \"\\F1ED\";\r\n}\r\n\r\n.fa-google-wallet:before {\r\n  content: \"\\F1EE\";\r\n}\r\n\r\n.fa-cc-visa:before {\r\n  content: \"\\F1F0\";\r\n}\r\n\r\n.fa-cc-mastercard:before {\r\n  content: \"\\F1F1\";\r\n}\r\n\r\n.fa-cc-discover:before {\r\n  content: \"\\F1F2\";\r\n}\r\n\r\n.fa-cc-amex:before {\r\n  content: \"\\F1F3\";\r\n}\r\n\r\n.fa-cc-paypal:before {\r\n  content: \"\\F1F4\";\r\n}\r\n\r\n.fa-cc-stripe:before {\r\n  content: \"\\F1F5\";\r\n}\r\n\r\n.fa-bell-slash:before {\r\n  content: \"\\F1F6\";\r\n}\r\n\r\n.fa-bell-slash-o:before {\r\n  content: \"\\F1F7\";\r\n}\r\n\r\n.fa-trash:before {\r\n  content: \"\\F1F8\";\r\n}\r\n\r\n.fa-copyright:before {\r\n  content: \"\\F1F9\";\r\n}\r\n\r\n.fa-at:before {\r\n  content: \"\\F1FA\";\r\n}\r\n\r\n.fa-eyedropper:before {\r\n  content: \"\\F1FB\";\r\n}\r\n\r\n.fa-paint-brush:before {\r\n  content: \"\\F1FC\";\r\n}\r\n\r\n.fa-birthday-cake:before {\r\n  content: \"\\F1FD\";\r\n}\r\n\r\n.fa-area-chart:before {\r\n  content: \"\\F1FE\";\r\n}\r\n\r\n.fa-pie-chart:before {\r\n  content: \"\\F200\";\r\n}\r\n\r\n.fa-line-chart:before {\r\n  content: \"\\F201\";\r\n}\r\n\r\n.fa-lastfm:before {\r\n  content: \"\\F202\";\r\n}\r\n\r\n.fa-lastfm-square:before {\r\n  content: \"\\F203\";\r\n}\r\n\r\n.fa-toggle-off:before {\r\n  content: \"\\F204\";\r\n}\r\n\r\n.fa-toggle-on:before {\r\n  content: \"\\F205\";\r\n}\r\n\r\n.fa-bicycle:before {\r\n  content: \"\\F206\";\r\n}\r\n\r\n.fa-bus:before {\r\n  content: \"\\F207\";\r\n}\r\n\r\n.fa-ioxhost:before {\r\n  content: \"\\F208\";\r\n}\r\n\r\n.fa-angellist:before {\r\n  content: \"\\F209\";\r\n}\r\n\r\n.fa-cc:before {\r\n  content: \"\\F20A\";\r\n}\r\n\r\n.fa-shekel:before,\r\n.fa-sheqel:before,\r\n.fa-ils:before {\r\n  content: \"\\F20B\";\r\n}\r\n\r\n.fa-meanpath:before {\r\n  content: \"\\F20C\";\r\n}\r\n\r\n.fa-buysellads:before {\r\n  content: \"\\F20D\";\r\n}\r\n\r\n.fa-connectdevelop:before {\r\n  content: \"\\F20E\";\r\n}\r\n\r\n.fa-dashcube:before {\r\n  content: \"\\F210\";\r\n}\r\n\r\n.fa-forumbee:before {\r\n  content: \"\\F211\";\r\n}\r\n\r\n.fa-leanpub:before {\r\n  content: \"\\F212\";\r\n}\r\n\r\n.fa-sellsy:before {\r\n  content: \"\\F213\";\r\n}\r\n\r\n.fa-shirtsinbulk:before {\r\n  content: \"\\F214\";\r\n}\r\n\r\n.fa-simplybuilt:before {\r\n  content: \"\\F215\";\r\n}\r\n\r\n.fa-skyatlas:before {\r\n  content: \"\\F216\";\r\n}\r\n\r\n.fa-cart-plus:before {\r\n  content: \"\\F217\";\r\n}\r\n\r\n.fa-cart-arrow-down:before {\r\n  content: \"\\F218\";\r\n}\r\n\r\n.fa-diamond:before {\r\n  content: \"\\F219\";\r\n}\r\n\r\n.fa-ship:before {\r\n  content: \"\\F21A\";\r\n}\r\n\r\n.fa-user-secret:before {\r\n  content: \"\\F21B\";\r\n}\r\n\r\n.fa-motorcycle:before {\r\n  content: \"\\F21C\";\r\n}\r\n\r\n.fa-street-view:before {\r\n  content: \"\\F21D\";\r\n}\r\n\r\n.fa-heartbeat:before {\r\n  content: \"\\F21E\";\r\n}\r\n\r\n.fa-venus:before {\r\n  content: \"\\F221\";\r\n}\r\n\r\n.fa-mars:before {\r\n  content: \"\\F222\";\r\n}\r\n\r\n.fa-mercury:before {\r\n  content: \"\\F223\";\r\n}\r\n\r\n.fa-intersex:before,\r\n.fa-transgender:before {\r\n  content: \"\\F224\";\r\n}\r\n\r\n.fa-transgender-alt:before {\r\n  content: \"\\F225\";\r\n}\r\n\r\n.fa-venus-double:before {\r\n  content: \"\\F226\";\r\n}\r\n\r\n.fa-mars-double:before {\r\n  content: \"\\F227\";\r\n}\r\n\r\n.fa-venus-mars:before {\r\n  content: \"\\F228\";\r\n}\r\n\r\n.fa-mars-stroke:before {\r\n  content: \"\\F229\";\r\n}\r\n\r\n.fa-mars-stroke-v:before {\r\n  content: \"\\F22A\";\r\n}\r\n\r\n.fa-mars-stroke-h:before {\r\n  content: \"\\F22B\";\r\n}\r\n\r\n.fa-neuter:before {\r\n  content: \"\\F22C\";\r\n}\r\n\r\n.fa-genderless:before {\r\n  content: \"\\F22D\";\r\n}\r\n\r\n.fa-facebook-official:before {\r\n  content: \"\\F230\";\r\n}\r\n\r\n.fa-pinterest-p:before {\r\n  content: \"\\F231\";\r\n}\r\n\r\n.fa-whatsapp:before {\r\n  content: \"\\F232\";\r\n}\r\n\r\n.fa-server:before {\r\n  content: \"\\F233\";\r\n}\r\n\r\n.fa-user-plus:before {\r\n  content: \"\\F234\";\r\n}\r\n\r\n.fa-user-times:before {\r\n  content: \"\\F235\";\r\n}\r\n\r\n.fa-hotel:before,\r\n.fa-bed:before {\r\n  content: \"\\F236\";\r\n}\r\n\r\n.fa-viacoin:before {\r\n  content: \"\\F237\";\r\n}\r\n\r\n.fa-train:before {\r\n  content: \"\\F238\";\r\n}\r\n\r\n.fa-subway:before {\r\n  content: \"\\F239\";\r\n}\r\n\r\n.fa-medium:before {\r\n  content: \"\\F23A\";\r\n}\r\n\r\n.fa-yc:before,\r\n.fa-y-combinator:before {\r\n  content: \"\\F23B\";\r\n}\r\n\r\n.fa-optin-monster:before {\r\n  content: \"\\F23C\";\r\n}\r\n\r\n.fa-opencart:before {\r\n  content: \"\\F23D\";\r\n}\r\n\r\n.fa-expeditedssl:before {\r\n  content: \"\\F23E\";\r\n}\r\n\r\n.fa-battery-4:before,\r\n.fa-battery:before,\r\n.fa-battery-full:before {\r\n  content: \"\\F240\";\r\n}\r\n\r\n.fa-battery-3:before,\r\n.fa-battery-three-quarters:before {\r\n  content: \"\\F241\";\r\n}\r\n\r\n.fa-battery-2:before,\r\n.fa-battery-half:before {\r\n  content: \"\\F242\";\r\n}\r\n\r\n.fa-battery-1:before,\r\n.fa-battery-quarter:before {\r\n  content: \"\\F243\";\r\n}\r\n\r\n.fa-battery-0:before,\r\n.fa-battery-empty:before {\r\n  content: \"\\F244\";\r\n}\r\n\r\n.fa-mouse-pointer:before {\r\n  content: \"\\F245\";\r\n}\r\n\r\n.fa-i-cursor:before {\r\n  content: \"\\F246\";\r\n}\r\n\r\n.fa-object-group:before {\r\n  content: \"\\F247\";\r\n}\r\n\r\n.fa-object-ungroup:before {\r\n  content: \"\\F248\";\r\n}\r\n\r\n.fa-sticky-note:before {\r\n  content: \"\\F249\";\r\n}\r\n\r\n.fa-sticky-note-o:before {\r\n  content: \"\\F24A\";\r\n}\r\n\r\n.fa-cc-jcb:before {\r\n  content: \"\\F24B\";\r\n}\r\n\r\n.fa-cc-diners-club:before {\r\n  content: \"\\F24C\";\r\n}\r\n\r\n.fa-clone:before {\r\n  content: \"\\F24D\";\r\n}\r\n\r\n.fa-balance-scale:before {\r\n  content: \"\\F24E\";\r\n}\r\n\r\n.fa-hourglass-o:before {\r\n  content: \"\\F250\";\r\n}\r\n\r\n.fa-hourglass-1:before,\r\n.fa-hourglass-start:before {\r\n  content: \"\\F251\";\r\n}\r\n\r\n.fa-hourglass-2:before,\r\n.fa-hourglass-half:before {\r\n  content: \"\\F252\";\r\n}\r\n\r\n.fa-hourglass-3:before,\r\n.fa-hourglass-end:before {\r\n  content: \"\\F253\";\r\n}\r\n\r\n.fa-hourglass:before {\r\n  content: \"\\F254\";\r\n}\r\n\r\n.fa-hand-grab-o:before,\r\n.fa-hand-rock-o:before {\r\n  content: \"\\F255\";\r\n}\r\n\r\n.fa-hand-stop-o:before,\r\n.fa-hand-paper-o:before {\r\n  content: \"\\F256\";\r\n}\r\n\r\n.fa-hand-scissors-o:before {\r\n  content: \"\\F257\";\r\n}\r\n\r\n.fa-hand-lizard-o:before {\r\n  content: \"\\F258\";\r\n}\r\n\r\n.fa-hand-spock-o:before {\r\n  content: \"\\F259\";\r\n}\r\n\r\n.fa-hand-pointer-o:before {\r\n  content: \"\\F25A\";\r\n}\r\n\r\n.fa-hand-peace-o:before {\r\n  content: \"\\F25B\";\r\n}\r\n\r\n.fa-trademark:before {\r\n  content: \"\\F25C\";\r\n}\r\n\r\n.fa-registered:before {\r\n  content: \"\\F25D\";\r\n}\r\n\r\n.fa-creative-commons:before {\r\n  content: \"\\F25E\";\r\n}\r\n\r\n.fa-gg:before {\r\n  content: \"\\F260\";\r\n}\r\n\r\n.fa-gg-circle:before {\r\n  content: \"\\F261\";\r\n}\r\n\r\n.fa-tripadvisor:before {\r\n  content: \"\\F262\";\r\n}\r\n\r\n.fa-odnoklassniki:before {\r\n  content: \"\\F263\";\r\n}\r\n\r\n.fa-odnoklassniki-square:before {\r\n  content: \"\\F264\";\r\n}\r\n\r\n.fa-get-pocket:before {\r\n  content: \"\\F265\";\r\n}\r\n\r\n.fa-wikipedia-w:before {\r\n  content: \"\\F266\";\r\n}\r\n\r\n.fa-safari:before {\r\n  content: \"\\F267\";\r\n}\r\n\r\n.fa-chrome:before {\r\n  content: \"\\F268\";\r\n}\r\n\r\n.fa-firefox:before {\r\n  content: \"\\F269\";\r\n}\r\n\r\n.fa-opera:before {\r\n  content: \"\\F26A\";\r\n}\r\n\r\n.fa-internet-explorer:before {\r\n  content: \"\\F26B\";\r\n}\r\n\r\n.fa-tv:before,\r\n.fa-television:before {\r\n  content: \"\\F26C\";\r\n}\r\n\r\n.fa-contao:before {\r\n  content: \"\\F26D\";\r\n}\r\n\r\n.fa-500px:before {\r\n  content: \"\\F26E\";\r\n}\r\n\r\n.fa-amazon:before {\r\n  content: \"\\F270\";\r\n}\r\n\r\n.fa-calendar-plus-o:before {\r\n  content: \"\\F271\";\r\n}\r\n\r\n.fa-calendar-minus-o:before {\r\n  content: \"\\F272\";\r\n}\r\n\r\n.fa-calendar-times-o:before {\r\n  content: \"\\F273\";\r\n}\r\n\r\n.fa-calendar-check-o:before {\r\n  content: \"\\F274\";\r\n}\r\n\r\n.fa-industry:before {\r\n  content: \"\\F275\";\r\n}\r\n\r\n.fa-map-pin:before {\r\n  content: \"\\F276\";\r\n}\r\n\r\n.fa-map-signs:before {\r\n  content: \"\\F277\";\r\n}\r\n\r\n.fa-map-o:before {\r\n  content: \"\\F278\";\r\n}\r\n\r\n.fa-map:before {\r\n  content: \"\\F279\";\r\n}\r\n\r\n.fa-commenting:before {\r\n  content: \"\\F27A\";\r\n}\r\n\r\n.fa-commenting-o:before {\r\n  content: \"\\F27B\";\r\n}\r\n\r\n.fa-houzz:before {\r\n  content: \"\\F27C\";\r\n}\r\n\r\n.fa-vimeo:before {\r\n  content: \"\\F27D\";\r\n}\r\n\r\n.fa-black-tie:before {\r\n  content: \"\\F27E\";\r\n}\r\n\r\n.fa-fonticons:before {\r\n  content: \"\\F280\";\r\n}\r\n\r\n.fa-reddit-alien:before {\r\n  content: \"\\F281\";\r\n}\r\n\r\n.fa-edge:before {\r\n  content: \"\\F282\";\r\n}\r\n\r\n.fa-credit-card-alt:before {\r\n  content: \"\\F283\";\r\n}\r\n\r\n.fa-codiepie:before {\r\n  content: \"\\F284\";\r\n}\r\n\r\n.fa-modx:before {\r\n  content: \"\\F285\";\r\n}\r\n\r\n.fa-fort-awesome:before {\r\n  content: \"\\F286\";\r\n}\r\n\r\n.fa-usb:before {\r\n  content: \"\\F287\";\r\n}\r\n\r\n.fa-product-hunt:before {\r\n  content: \"\\F288\";\r\n}\r\n\r\n.fa-mixcloud:before {\r\n  content: \"\\F289\";\r\n}\r\n\r\n.fa-scribd:before {\r\n  content: \"\\F28A\";\r\n}\r\n\r\n.fa-pause-circle:before {\r\n  content: \"\\F28B\";\r\n}\r\n\r\n.fa-pause-circle-o:before {\r\n  content: \"\\F28C\";\r\n}\r\n\r\n.fa-stop-circle:before {\r\n  content: \"\\F28D\";\r\n}\r\n\r\n.fa-stop-circle-o:before {\r\n  content: \"\\F28E\";\r\n}\r\n\r\n.fa-shopping-bag:before {\r\n  content: \"\\F290\";\r\n}\r\n\r\n.fa-shopping-basket:before {\r\n  content: \"\\F291\";\r\n}\r\n\r\n.fa-hashtag:before {\r\n  content: \"\\F292\";\r\n}\r\n\r\n.fa-bluetooth:before {\r\n  content: \"\\F293\";\r\n}\r\n\r\n.fa-bluetooth-b:before {\r\n  content: \"\\F294\";\r\n}\r\n\r\n.fa-percent:before {\r\n  content: \"\\F295\";\r\n}\r\n\r\n.fa-gitlab:before {\r\n  content: \"\\F296\";\r\n}\r\n\r\n.fa-wpbeginner:before {\r\n  content: \"\\F297\";\r\n}\r\n\r\n.fa-wpforms:before {\r\n  content: \"\\F298\";\r\n}\r\n\r\n.fa-envira:before {\r\n  content: \"\\F299\";\r\n}\r\n\r\n.fa-universal-access:before {\r\n  content: \"\\F29A\";\r\n}\r\n\r\n.fa-wheelchair-alt:before {\r\n  content: \"\\F29B\";\r\n}\r\n\r\n.fa-question-circle-o:before {\r\n  content: \"\\F29C\";\r\n}\r\n\r\n.fa-blind:before {\r\n  content: \"\\F29D\";\r\n}\r\n\r\n.fa-audio-description:before {\r\n  content: \"\\F29E\";\r\n}\r\n\r\n.fa-volume-control-phone:before {\r\n  content: \"\\F2A0\";\r\n}\r\n\r\n.fa-braille:before {\r\n  content: \"\\F2A1\";\r\n}\r\n\r\n.fa-assistive-listening-systems:before {\r\n  content: \"\\F2A2\";\r\n}\r\n\r\n.fa-asl-interpreting:before,\r\n.fa-american-sign-language-interpreting:before {\r\n  content: \"\\F2A3\";\r\n}\r\n\r\n.fa-deafness:before,\r\n.fa-hard-of-hearing:before,\r\n.fa-deaf:before {\r\n  content: \"\\F2A4\";\r\n}\r\n\r\n.fa-glide:before {\r\n  content: \"\\F2A5\";\r\n}\r\n\r\n.fa-glide-g:before {\r\n  content: \"\\F2A6\";\r\n}\r\n\r\n.fa-signing:before,\r\n.fa-sign-language:before {\r\n  content: \"\\F2A7\";\r\n}\r\n\r\n.fa-low-vision:before {\r\n  content: \"\\F2A8\";\r\n}\r\n\r\n.fa-viadeo:before {\r\n  content: \"\\F2A9\";\r\n}\r\n\r\n.fa-viadeo-square:before {\r\n  content: \"\\F2AA\";\r\n}\r\n\r\n.fa-snapchat:before {\r\n  content: \"\\F2AB\";\r\n}\r\n\r\n.fa-snapchat-ghost:before {\r\n  content: \"\\F2AC\";\r\n}\r\n\r\n.fa-snapchat-square:before {\r\n  content: \"\\F2AD\";\r\n}\r\n\r\n.fa-pied-piper:before {\r\n  content: \"\\F2AE\";\r\n}\r\n\r\n.fa-first-order:before {\r\n  content: \"\\F2B0\";\r\n}\r\n\r\n.fa-yoast:before {\r\n  content: \"\\F2B1\";\r\n}\r\n\r\n.fa-themeisle:before {\r\n  content: \"\\F2B2\";\r\n}\r\n\r\n.fa-google-plus-circle:before,\r\n.fa-google-plus-official:before {\r\n  content: \"\\F2B3\";\r\n}\r\n\r\n.fa-fa:before,\r\n.fa-font-awesome:before {\r\n  content: \"\\F2B4\";\r\n}\r\n\r\n.fa-handshake-o:before {\r\n  content: \"\\F2B5\";\r\n}\r\n\r\n.fa-envelope-open:before {\r\n  content: \"\\F2B6\";\r\n}\r\n\r\n.fa-envelope-open-o:before {\r\n  content: \"\\F2B7\";\r\n}\r\n\r\n.fa-linode:before {\r\n  content: \"\\F2B8\";\r\n}\r\n\r\n.fa-address-book:before {\r\n  content: \"\\F2B9\";\r\n}\r\n\r\n.fa-address-book-o:before {\r\n  content: \"\\F2BA\";\r\n}\r\n\r\n.fa-vcard:before,\r\n.fa-address-card:before {\r\n  content: \"\\F2BB\";\r\n}\r\n\r\n.fa-vcard-o:before,\r\n.fa-address-card-o:before {\r\n  content: \"\\F2BC\";\r\n}\r\n\r\n.fa-user-circle:before {\r\n  content: \"\\F2BD\";\r\n}\r\n\r\n.fa-user-circle-o:before {\r\n  content: \"\\F2BE\";\r\n}\r\n\r\n.fa-user-o:before {\r\n  content: \"\\F2C0\";\r\n}\r\n\r\n.fa-id-badge:before {\r\n  content: \"\\F2C1\";\r\n}\r\n\r\n.fa-drivers-license:before,\r\n.fa-id-card:before {\r\n  content: \"\\F2C2\";\r\n}\r\n\r\n.fa-drivers-license-o:before,\r\n.fa-id-card-o:before {\r\n  content: \"\\F2C3\";\r\n}\r\n\r\n.fa-quora:before {\r\n  content: \"\\F2C4\";\r\n}\r\n\r\n.fa-free-code-camp:before {\r\n  content: \"\\F2C5\";\r\n}\r\n\r\n.fa-telegram:before {\r\n  content: \"\\F2C6\";\r\n}\r\n\r\n.fa-thermometer-4:before,\r\n.fa-thermometer:before,\r\n.fa-thermometer-full:before {\r\n  content: \"\\F2C7\";\r\n}\r\n\r\n.fa-thermometer-3:before,\r\n.fa-thermometer-three-quarters:before {\r\n  content: \"\\F2C8\";\r\n}\r\n\r\n.fa-thermometer-2:before,\r\n.fa-thermometer-half:before {\r\n  content: \"\\F2C9\";\r\n}\r\n\r\n.fa-thermometer-1:before,\r\n.fa-thermometer-quarter:before {\r\n  content: \"\\F2CA\";\r\n}\r\n\r\n.fa-thermometer-0:before,\r\n.fa-thermometer-empty:before {\r\n  content: \"\\F2CB\";\r\n}\r\n\r\n.fa-shower:before {\r\n  content: \"\\F2CC\";\r\n}\r\n\r\n.fa-bathtub:before,\r\n.fa-s15:before,\r\n.fa-bath:before {\r\n  content: \"\\F2CD\";\r\n}\r\n\r\n.fa-podcast:before {\r\n  content: \"\\F2CE\";\r\n}\r\n\r\n.fa-window-maximize:before {\r\n  content: \"\\F2D0\";\r\n}\r\n\r\n.fa-window-minimize:before {\r\n  content: \"\\F2D1\";\r\n}\r\n\r\n.fa-window-restore:before {\r\n  content: \"\\F2D2\";\r\n}\r\n\r\n.fa-times-rectangle:before,\r\n.fa-window-close:before {\r\n  content: \"\\F2D3\";\r\n}\r\n\r\n.fa-times-rectangle-o:before,\r\n.fa-window-close-o:before {\r\n  content: \"\\F2D4\";\r\n}\r\n\r\n.fa-bandcamp:before {\r\n  content: \"\\F2D5\";\r\n}\r\n\r\n.fa-grav:before {\r\n  content: \"\\F2D6\";\r\n}\r\n\r\n.fa-etsy:before {\r\n  content: \"\\F2D7\";\r\n}\r\n\r\n.fa-imdb:before {\r\n  content: \"\\F2D8\";\r\n}\r\n\r\n.fa-ravelry:before {\r\n  content: \"\\F2D9\";\r\n}\r\n\r\n.fa-eercast:before {\r\n  content: \"\\F2DA\";\r\n}\r\n\r\n.fa-microchip:before {\r\n  content: \"\\F2DB\";\r\n}\r\n\r\n.fa-snowflake-o:before {\r\n  content: \"\\F2DC\";\r\n}\r\n\r\n.fa-superpowers:before {\r\n  content: \"\\F2DD\";\r\n}\r\n\r\n.fa-wpexplorer:before {\r\n  content: \"\\F2DE\";\r\n}\r\n\r\n.fa-meetup:before {\r\n  content: \"\\F2E0\";\r\n}\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.sr-only-focusable:active,\r\n.sr-only-focusable:focus {\r\n  position: static;\r\n  width: auto;\r\n  height: auto;\r\n  margin: 0;\r\n  overflow: visible;\r\n  clip: auto;\r\n}\r\n\r\nbutton[data-balloon] {\r\n  overflow: visible;\r\n}\r\n\r\n[data-balloon] {\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n[data-balloon]:after {\r\n  filter: alpha(opacity=0);\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\r\n  -moz-opacity: 0;\r\n  -khtml-opacity: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  -webkit-transition: all 0.18s ease-out 0.18s;\r\n  transition: all 0.18s ease-out 0.18s;\r\n  font-family: sans-serif !important;\r\n  font-weight: normal !important;\r\n  font-style: normal !important;\r\n  text-shadow: none !important;\r\n  font-size: 12px !important;\r\n  background: rgba(17, 17, 17, 0.9);\r\n  border-radius: 4px;\r\n  color: #fff;\r\n  content: attr(data-balloon);\r\n  padding: .5em 1em;\r\n  position: absolute;\r\n  white-space: nowrap;\r\n  z-index: 10;\r\n}\r\n\r\n[data-balloon]:before {\r\n  background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(0)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\r\n  background-size: 100% auto;\r\n  width: 18px;\r\n  height: 6px;\r\n  filter: alpha(opacity=0);\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\r\n  -moz-opacity: 0;\r\n  -khtml-opacity: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  -webkit-transition: all 0.18s ease-out 0.18s;\r\n  transition: all 0.18s ease-out 0.18s;\r\n  content: '';\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n[data-balloon]:hover:before, [data-balloon]:hover:after, [data-balloon][data-balloon-visible]:before, [data-balloon][data-balloon-visible]:after {\r\n  filter: alpha(opacity=100);\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\r\n  -moz-opacity: 1;\r\n  -khtml-opacity: 1;\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n}\r\n\r\n[data-balloon].font-awesome:after {\r\n  font-family: FontAwesome;\r\n}\r\n\r\n[data-balloon][data-balloon-break]:after {\r\n  white-space: pre;\r\n}\r\n\r\n[data-balloon][data-balloon-blunt]:before, [data-balloon][data-balloon-blunt]:after {\r\n  -webkit-transition: none;\r\n  transition: none;\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up\"]:after {\r\n  bottom: 100%;\r\n  left: 50%;\r\n  margin-bottom: 11px;\r\n  -webkit-transform: translate(-50%, 10px);\r\n  transform: translate(-50%, 10px);\r\n  -webkit-transform-origin: top;\r\n  transform-origin: top;\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up\"]:before {\r\n  bottom: 100%;\r\n  left: 50%;\r\n  margin-bottom: 5px;\r\n  -webkit-transform: translate(-50%, 10px);\r\n  transform: translate(-50%, 10px);\r\n  -webkit-transform-origin: top;\r\n  transform-origin: top;\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up\"]:hover:after, [data-balloon][data-balloon-pos=\"up\"][data-balloon-visible]:after {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up\"]:hover:before, [data-balloon][data-balloon-pos=\"up\"][data-balloon-visible]:before {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-left\"]:after {\r\n  bottom: 100%;\r\n  left: 0;\r\n  margin-bottom: 11px;\r\n  -webkit-transform: translate(0, 10px);\r\n  transform: translate(0, 10px);\r\n  -webkit-transform-origin: top;\r\n  transform-origin: top;\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-left\"]:before {\r\n  bottom: 100%;\r\n  left: 5px;\r\n  margin-bottom: 5px;\r\n  -webkit-transform: translate(0, 10px);\r\n  transform: translate(0, 10px);\r\n  -webkit-transform-origin: top;\r\n  transform-origin: top;\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-left\"]:hover:after, [data-balloon][data-balloon-pos=\"up-left\"][data-balloon-visible]:after {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-left\"]:hover:before, [data-balloon][data-balloon-pos=\"up-left\"][data-balloon-visible]:before {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-right\"]:after {\r\n  bottom: 100%;\r\n  right: 0;\r\n  margin-bottom: 11px;\r\n  -webkit-transform: translate(0, 10px);\r\n  transform: translate(0, 10px);\r\n  -webkit-transform-origin: top;\r\n  transform-origin: top;\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-right\"]:before {\r\n  bottom: 100%;\r\n  right: 5px;\r\n  margin-bottom: 5px;\r\n  -webkit-transform: translate(0, 10px);\r\n  transform: translate(0, 10px);\r\n  -webkit-transform-origin: top;\r\n  transform-origin: top;\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-right\"]:hover:after, [data-balloon][data-balloon-pos=\"up-right\"][data-balloon-visible]:after {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos=\"up-right\"]:hover:before, [data-balloon][data-balloon-pos=\"up-right\"][data-balloon-visible]:before {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down']:after {\r\n  left: 50%;\r\n  margin-top: 11px;\r\n  top: 100%;\r\n  -webkit-transform: translate(-50%, -10px);\r\n  transform: translate(-50%, -10px);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down']:before {\r\n  background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\r\n  background-size: 100% auto;\r\n  width: 18px;\r\n  height: 6px;\r\n  left: 50%;\r\n  margin-top: 5px;\r\n  top: 100%;\r\n  -webkit-transform: translate(-50%, -10px);\r\n  transform: translate(-50%, -10px);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down']:hover:after, [data-balloon][data-balloon-pos='down'][data-balloon-visible]:after {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down']:hover:before, [data-balloon][data-balloon-pos='down'][data-balloon-visible]:before {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-left']:after {\r\n  left: 0;\r\n  margin-top: 11px;\r\n  top: 100%;\r\n  -webkit-transform: translate(0, -10px);\r\n  transform: translate(0, -10px);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-left']:before {\r\n  background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\r\n  background-size: 100% auto;\r\n  width: 18px;\r\n  height: 6px;\r\n  left: 5px;\r\n  margin-top: 5px;\r\n  top: 100%;\r\n  -webkit-transform: translate(0, -10px);\r\n  transform: translate(0, -10px);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-left']:hover:after, [data-balloon][data-balloon-pos='down-left'][data-balloon-visible]:after {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-left']:hover:before, [data-balloon][data-balloon-pos='down-left'][data-balloon-visible]:before {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-right']:after {\r\n  right: 0;\r\n  margin-top: 11px;\r\n  top: 100%;\r\n  -webkit-transform: translate(0, -10px);\r\n  transform: translate(0, -10px);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-right']:before {\r\n  background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\r\n  background-size: 100% auto;\r\n  width: 18px;\r\n  height: 6px;\r\n  right: 5px;\r\n  margin-top: 5px;\r\n  top: 100%;\r\n  -webkit-transform: translate(0, -10px);\r\n  transform: translate(0, -10px);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-right']:hover:after, [data-balloon][data-balloon-pos='down-right'][data-balloon-visible]:after {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='down-right']:hover:before, [data-balloon][data-balloon-pos='down-right'][data-balloon-visible]:before {\r\n  -webkit-transform: translate(0, 0);\r\n  transform: translate(0, 0);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='left']:after {\r\n  margin-right: 11px;\r\n  right: 100%;\r\n  top: 50%;\r\n  -webkit-transform: translate(10px, -50%);\r\n  transform: translate(10px, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='left']:before {\r\n  background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(-90 18 18)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\r\n  background-size: 100% auto;\r\n  width: 6px;\r\n  height: 18px;\r\n  margin-right: 5px;\r\n  right: 100%;\r\n  top: 50%;\r\n  -webkit-transform: translate(10px, -50%);\r\n  transform: translate(10px, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='left']:hover:after, [data-balloon][data-balloon-pos='left'][data-balloon-visible]:after {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='left']:hover:before, [data-balloon][data-balloon-pos='left'][data-balloon-visible]:before {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='right']:after {\r\n  left: 100%;\r\n  margin-left: 11px;\r\n  top: 50%;\r\n  -webkit-transform: translate(-10px, -50%);\r\n  transform: translate(-10px, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='right']:before {\r\n  background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(90 6 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\r\n  background-size: 100% auto;\r\n  width: 6px;\r\n  height: 18px;\r\n  left: 100%;\r\n  margin-left: 5px;\r\n  top: 50%;\r\n  -webkit-transform: translate(-10px, -50%);\r\n  transform: translate(-10px, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='right']:hover:after, [data-balloon][data-balloon-pos='right'][data-balloon-visible]:after {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-pos='right']:hover:before, [data-balloon][data-balloon-pos='right'][data-balloon-visible]:before {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n}\r\n\r\n[data-balloon][data-balloon-length='small']:after {\r\n  white-space: normal;\r\n  width: 80px;\r\n}\r\n\r\n[data-balloon][data-balloon-length='medium']:after {\r\n  white-space: normal;\r\n  width: 150px;\r\n}\r\n\r\n[data-balloon][data-balloon-length='large']:after {\r\n  white-space: normal;\r\n  width: 260px;\r\n}\r\n\r\n[data-balloon][data-balloon-length='xlarge']:after {\r\n  white-space: normal;\r\n  width: 380px;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  [data-balloon][data-balloon-length='xlarge']:after {\r\n    white-space: normal;\r\n    width: 90vw;\r\n  }\r\n}\r\n\r\n[data-balloon][data-balloon-length='fit']:after {\r\n  white-space: normal;\r\n  width: 100%;\r\n}\r\n\r\n.body-overflow {\r\n  overflow: hidden;\r\n}\r\n\r\n.form-control {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.form-control:disabled,\r\n.form-control[readonly] {\r\n  background-color: white !important;\r\n}\r\n\r\n.evf-button {\r\n  font-size: 14px !important;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px !important;\r\n  border: 3px solid #0c7cba !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor: pointer;\r\n}\r\n\r\n.evf-button-medium {\r\n  font-size: 14px !important;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px !important;\r\n  border: 3px solid #0c7cba !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  width: 170px;\r\n}\r\n\r\n.registration-title, .order-title {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 20px;\r\n  background-color: #000000;\r\n  color: white;\r\n  padding: 2px 10px;\r\n  margin-bottom: 7px;\r\n}\r\n\r\n.my-account-title, .terms-section {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 20px;\r\n  background-color: #000000;\r\n  color: white;\r\n  padding: 2px 10px;\r\n}\r\n\r\n.margin-top {\r\n  margin-top: 130px;\r\n}\r\n\r\n.center {\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content .registration-header {\r\n  margin-top: 40px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 24px;\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content .registration-header .sign_up_title {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.container.registation_content .account-section-divider {\r\n  border: solid 2px gainsboro;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.loading-div {\r\n  text-align: center;\r\n  margin-top: 50px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area .account-type-header p {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: white;\r\n  text-align: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.row {\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.row div.col-lg-4 .individual-div .img-style {\r\n  border: 3px solid #000000;\r\n  border-radius: 15px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.row div.col-lg-4 .individual-div .acc-title {\r\n  color: white;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 20px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.row div.col-lg-4 .practice-div .img-style {\r\n  border: 3px solid #000000;\r\n  border-radius: 15px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.row div.col-lg-4 .practice-div .acc-title {\r\n  color: white;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 20px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.row div.col-lg-4 .ngo-div .img-style {\r\n  border: 3px solid #000000;\r\n  border-radius: 15px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.row div.col-lg-4 .ngo-div .acc-title {\r\n  color: white;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 20px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.account-description {\r\n  margin-top: 20px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.account-description .row .col-lg-12 .first-description {\r\n  text-align: center;\r\n  color: white;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 20px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.account-description .row .col-lg-12 .second-description {\r\n  text-align: center;\r\n  color: white;\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.account-description .row .col-lg-12 .third-description {\r\n  margin-top: 10px;\r\n  color: white;\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  text-align: left;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.account-description .row .col-lg-12 .list {\r\n  margin-top: 10px;\r\n  color: white;\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  text-align: left;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .row .col-lg-12 .account-type-area div.account-description .row .col-lg-12 .fourth-description {\r\n  color: white;\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  text-align: left;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .section_div {\r\n  width: 120px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .section_div .divider_img {\r\n  width: 120px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12.registration_submit {\r\n  margin-top: 30px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12.registration_submit .submit-button {\r\n  font-size: 14px !important;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px !important;\r\n  border: 3px solid #0c7cba !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  width: 130px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .row .col-lg-12 .email_box_btn {\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .registration-description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .registration-authority {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.row div.col-lg-12 p {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.row div.col-lg-12 div.radio label {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.row div.col-lg-12 p.nonProfit_order {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-top: 1rem;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.row div.col-lg-12 .table-responsive {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.row div.col-lg-12 .table-responsive .table thead {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 14px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.row div.col-lg-12 .table-responsive .table tbody tr td input {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 14px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.row div.col-lg-12 .table {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-6 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-8 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .evf-invite {\r\n  text-align: center;\r\n  margin-top: 20px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .form-check label {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-4 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-4 .form-group label .form-control option {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 14px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-5 .form-group label,\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-2 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-12 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-12 .form-group label .form-control option {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-12 label {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-12 .terms-style {\r\n  border: 1px solid #e5e5e5;\r\n  height: 200px;\r\n  overflow: auto;\r\n  padding: 10px;\r\n  margin-bottom: 20px;\r\n  background-color: white;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-12 .form-check label {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div .col-lg-12 .label-heading {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.col-lg-12 p.invite_desc {\r\n  text-align: center;\r\n}\r\n\r\n.container.registation_content div.row div.col-lg-8 div div.col-lg-6 .form-group .invite_label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.feed-back-div {\r\n  border: 3px solid #0c7cba;\r\n}\r\n\r\n.error-message {\r\n  text-align: center;\r\n  color: red !important;\r\n  font-family: ProximaNova-Bold, sans-serif !important;\r\n  font-size: 16px !important;\r\n}\r\n\r\n.error_field,\r\n.error_field2 {\r\n  border-color: red !important;\r\n}\r\n\r\n.loading-div {\r\n  background-color: transparent !important;\r\n  border-color: transparent !important;\r\n}\r\n\r\n.no-padding-right {\r\n  padding-right: 0px !important;\r\n}\r\n\r\n.registration-success .row .col-lg-6 .success-div {\r\n  text-align: center;\r\n  border: 3px solid #000000;\r\n  border-radius: 10px;\r\n  padding: 20px 40px;\r\n}\r\n\r\n.registration-success .row .col-lg-6 .success-div p.heading {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 30px;\r\n  color: #000000;\r\n}\r\n\r\n.radio_option {\r\n  margin-top: 10px;\r\n  margin-bottom: 15px;\r\n  text-align: center;\r\n}\r\n\r\n.div_bottom {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.no-margin-bot {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.radio_btn {\r\n  margin-right: 20px;\r\n}\r\n\r\n.success_hero_image {\r\n  width: 230px;\r\n  height: auto;\r\n  margin-top: 230px;\r\n  margin-left: -30px;\r\n  background-color: white;\r\n  position: absolute;\r\n  z-index: 0;\r\n  /*display: none*/\r\n}\r\n\r\n.success_footer_arrow {\r\n  position: absolute;\r\n  left: 0px;\r\n  bottom: 20px;\r\n  z-index: -10;\r\n  background-repeat: no-repeat;\r\n  /*display: none*/\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .success_footer_arrow {\r\n    bottom: 86px;\r\n  }\r\n}\r\n\r\n.success_footer_arrow img.success_arrow_info {\r\n  width: 1200px;\r\n  height: 100px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .success_footer_arrow img.success_arrow_info {\r\n    /* width: 1100px;\r\n            height: 200px;*/\r\n  }\r\n}\r\n\r\n/*User Account styles - 01/26/18*/\r\n.account_info .account_header .header_title {\r\n  text-align: center;\r\n  font-size: 25px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n}\r\n\r\n.account_section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.account_login_info {\r\n  padding: 10px 30px;\r\n  border-left: 2px solid #000000;\r\n  border-right: 2px solid #000000;\r\n  border-bottom: 2px solid #000000;\r\n  background-color: white;\r\n}\r\n\r\n.account_login_info .account_label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-bottom: 0px;\r\n  font-size: 18px;\r\n}\r\n\r\n.account_login_info .account_p {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  margin-bottom: 0px;\r\n  font-size: 18px;\r\n}\r\n\r\n.account_login_info ul.association_info li {\r\n  list-style: none;\r\n  padding-left: 18px;\r\n  font-size: 18px;\r\n}\r\n\r\n.account_login_info ul.eyeDoctorAssociation_info li {\r\n  list-style: none;\r\n  font-size: 18px;\r\n}\r\n\r\n.account_login_info .forecasting_services {\r\n  font-size: 18px;\r\n}\r\n\r\n/*Added CSS for My Account Page*/\r\n.g-btn-130 {\r\n  width: 130px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n  margin-top: 10px;\r\n}\r\n\r\n.g-btn-85 {\r\n  width: 85px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n}\r\n\r\n.g-btn-200 {\r\n  width: 200px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n  margin-top: 10px;\r\n}\r\n\r\n.edit_button {\r\n  font-size: 14px !important;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px !important;\r\n  border: 3px solid #0c7cba !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  width: 130px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.add_button {\r\n  font-size: 14px !important;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px !important;\r\n  border: 3px solid #0c7cba !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  width: 200px;\r\n  margin-top: 10px;\r\n}\r\n\r\n/*Account - Edit Modal - 01/31/18 - Onesi*/\r\n.edit_account_modal {\r\n  padding-top: 10px;\r\n}\r\n\r\n.edit_account_modal .account_section_box {\r\n  padding: 10px 15px;\r\n  background-color: white;\r\n}\r\n\r\n.edit_account_modal .account_section_box label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.edit_account_modal .account_section_box .account_p {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  margin-bottom: 0px;\r\n  font-size: 18px;\r\n}\r\n\r\nimg.loaderIcon {\r\n  width: 30px !important;\r\n}\r\n\r\n.modal-width {\r\n  width: 600px !important;\r\n}\r\n\r\n.margin-top {\r\n  margin-top: 130px;\r\n}\r\n\r\n.order-div {\r\n  background-color: #f1f1f17a;\r\n  padding: 2px 10px 10px;\r\n  border-radius: 10px !important;\r\n\r\n}\r\n\r\n.order-padding {\r\n  padding: 2px 10px 10px;\r\n}\r\n\r\n\r\n\r\n.white-bg {\r\n  background-color: white !important;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row p {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-8 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-12 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-12 .form-label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-12 label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-6 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-6 .form-check .form-check-label {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-4 .form-group label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.OrderPage .container-fluid .row .col-lg-8 .row .col-lg-4 label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  color: #000000;\r\n}\r\n\r\n.table-borderless > tbody > tr > td,\r\n.table-borderless > tbody > tr > th,\r\n.table-borderless > tfoot > tr > td,\r\n.table-borderless > tfoot > tr > th,\r\n.table-borderless > thead > tr > td,\r\n.table-borderless > thead > tr > th {\r\n  border: none !important;\r\n}\r\n\r\n.div-spacing-top {\r\n  margin-top: 15px;\r\n}\r\n\r\n.div-spacing-bottom {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.left-padding-div {\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.input-space-right {\r\n  padding-right: 15px !important;\r\n}\r\n\r\n.input-space-left {\r\n  padding-left: 15px !important;\r\n}\r\n\r\n.order-form-button {\r\n  font-size: 14px !important;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px !important;\r\n  border: 3px solid #0c7cba !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  min-width: 130px;\r\n}\r\n\r\n.padding-left {\r\n  padding-left: 32px !important;\r\n}\r\n\r\n.image-div {\r\n  height: 100px;\r\n  width: 100px;\r\n  margin: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.image-div-frame {\r\n  height: 200px;\r\n  width: 200px;\r\n  margin: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.right {\r\n  float: right;\r\n}\r\n\r\n.image-icon {\r\n  padding: 5px;\r\n  border: 2px solid #000000;\r\n}\r\n\r\n.disable {\r\n  pointer-events: none;\r\n  opacity: 0.4;\r\n}\r\n\r\n.page-title {\r\n  text-align: center;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 24px;\r\n  color: #000;\r\n  margin-bottom: 0px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.review-order-border {\r\n  border: 1px solid #000000;\r\n}\r\n\r\n/*input[type=number]::-webkit-inner-spin-button,\r\ninput[type=number]::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.account_section_box {\r\n    border: 2px solid\r\n}*/\r\n/*.fade-enter-active, .fade-leave-active {\r\n    transition: opacity 3s;\r\n}\r\n.fade-enter, .fade-leave-to  {\r\n    opacity: 0;\r\n}*/\r\n.order-review-label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  font-size: 15px !important;\r\n}\r\n\r\n.order-review-description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  color: #000000;\r\n  font-size: 15px;\r\n}\r\n\r\n.order-modal-size {\r\n  max-width: 700px !important;\r\n}\r\n\r\n.right {\r\n  text-align: right;\r\n}\r\n\r\n.left {\r\n  text-align: left;\r\n}\r\n\r\n.box-div {\r\n  border: 1px solid #000000;\r\n}\r\n\r\n.order-confimation-label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 16px;\r\n  color: #000000;\r\n}\r\n\r\n.order-confimation-description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 16px;\r\n  color: #000000;\r\n}\r\n\r\n.order-label-background {\r\n  background-color: #000000;\r\n}\r\n\r\n.label-padding-left {\r\n  padding-left: 3px;\r\n}\r\n\r\n.border-box {\r\n  border: 0.5px solid #000000;\r\n}\r\n\r\n.min-height-dispenser-notes {\r\n  min-height: 100px !important;\r\n}\r\n\r\n.reset_password_services .row .col-lg-6 .reset-password-div {\r\n  border: 3px solid #000000;\r\n  padding: 20px;\r\n}\r\n\r\n.reset_password_services .row .col-lg-6 .reset-password-div p.heading {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 30px;\r\n  color: #000000;\r\n  text-align: center;\r\n}\r\n\r\n.reset_password_services .row .col-lg-6 .reset-password-div p.success_msg {\r\n  text-align: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.link {\r\n  color: #0c7cba !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.link:hover {\r\n  font-weight: bold;\r\n}\r\n\r\n/*Eye Doctor Information Styles - 02/13/18 - Onesi*/\r\n.eye_doctor_button {\r\n  font-size: 14px !important;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px !important;\r\n  border: 3px solid #0c7cba !important;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  cursor: pointer;\r\n  width: 85px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.doctor_label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.doctor_p {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.doctor_title_msg {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n}\r\n\r\n.input_field {\r\n  height: 30px;\r\n}\r\n\r\n.select_field {\r\n  height: 30px !important;\r\n  padding-top: 1px !important;\r\n}\r\n\r\n.no-margin-bottom {\r\n  margin-bottom: 0px !important;\r\n}\r\n\r\n.barcode {\r\n  font-family: \"Libre Barcode 128\", cursive;\r\n  font-size: 60px;\r\n}\r\n\r\n.check_icon {\r\n  color: #20c997 !important;\r\n}\r\n\r\n.pagination {\r\n  float: right !important;\r\n}\r\n\r\n.order-button-spacing {\r\n  margin-top: 10px;\r\n  float: right;\r\n}\r\n\r\n.filter_calendar_icon {\r\n  font-size: 25px;\r\n}\r\n\r\n.no-padding-left {\r\n  padding-left: 0px !important;\r\n}\r\n\r\n#style-1::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  border-radius: 10px;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n#style-1::-webkit-scrollbar {\r\n  width: 8px;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n#style-1::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  background-color: #555;\r\n}\r\n\r\n/*Added CSS style - 2018/02/23 - Onesi*/\r\n.loading_icon {\r\n  width: 25px;\r\n  float: right;\r\n}\r\n\r\n.alert-fixed {\r\n  position: fixed !important;\r\n  -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.3);\r\n          box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.3);\r\n  z-index: 9999;\r\n  right: 1%;\r\n  top: 2%;\r\n  padding: 20px !important;\r\n}\r\n\r\n.list-text {\r\n  display: block;\r\n  font-family: ProximaNova-Regular, sans-serif !important;\r\n  padding: 12px;\r\n  min-height: 40px;\r\n  line-height: 16px;\r\n  text-decoration: none;\r\n  text-transform: none;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.list-hover:hover {\r\n  background-color: #41b883;\r\n  color: white;\r\n}\r\n\r\n.font-order {\r\n  font-size: 18px;\r\n  font-family: ProximaNova-Regular, sans-serif !important;\r\n}\r\n\r\n.div-dropdown {\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  background-color: white;\r\n}\r\n\r\n.ul-dropdown {\r\n  list-style: none;\r\n  padding-left: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.swiper-button-prev {\r\n  background-image: url(\"/static/assets/img/icons/Frame Page Icons/leftArrow.png\") !important;\r\n  background-size: 25px 25px !important;\r\n  width: 25px !important;\r\n  height: 25px !important;\r\n  top: 95% !important;\r\n  left: 0px !important;\r\n  margin-left: 65%;\r\n}\r\n\r\n.swiper-button-next {\r\n  background-image: url(\"/static/assets/img/icons/Frame Page Icons/rightArrow.png\") !important;\r\n  background-size: 25px 25px !important;\r\n  width: 25px !important;\r\n  height: 25px !important;\r\n  top: 95% !important;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  background-color: #000000 !important;\r\n  border-color: #000000 !important;\r\n  color: white !important;\r\n}\r\n\r\n.track-table {\r\n  border: 2px solid gainsboro;\r\n  background-color: white !important;\r\n}\r\n\r\n.order-bg-blue {\r\n  background-color: #d5e4ef7a;\r\n}\r\n\r\n.account_desc_li {\r\n  font-size: 20px;\r\n}\r\n\r\n/*Added CSS - Landing Page - 03/22/18 - Onesi*/\r\n.g-max-width-1030 {\r\n  max-width: 1030px;\r\n}\r\n\r\n.p-font-size-20 {\r\n  font-size: 20px;\r\n  letter-spacing: 1.8px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .p-font-size-20 {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n.p-font-size-default {\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.table-bg {\r\n  background-color: #d5e4ef7a !important;\r\n}\r\n\r\n.frame-description {\r\n  font-size: 15px !important;\r\n  font-family: ProximaNova-Regular, sans-serif !important;\r\n}\r\n\r\n.frame-label {\r\n  font-size: 15px !important;\r\n  font-family: ProximaNova-Bold, sans-serif !important;\r\n}\r\n\r\n.eye-size-range-div {\r\n  padding-top: 14px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.frame-heading-description {\r\n  font-size: 20px !important;\r\n  font-family: ProximaNova-Regular, sans-serif !important;\r\n}\r\n\r\n.frame-thumbnail-div {\r\n  height: 50px;\r\n  width: 50px;\r\n  margin: auto;\r\n}\r\n\r\n.frame-pic-div {\r\n  height: 180px;\r\n  width: 200px;\r\n}\r\n\r\n.image-align-vert-hor {\r\n  position: absolute;\r\n  margin: auto;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.lsf-payment {\r\n  border: 2px solid red;\r\n  padding-left: 10px;\r\n  font-size: 14px !important;\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n}\r\n\r\n.order-payment {\r\n  margin-top: 10px;\r\n  border: 2px solid #000000;\r\n  padding-left: 10px;\r\n}\r\n\r\n.left {\r\n  text-align: left;\r\n}\r\n\r\n.right {\r\n  text-align: right;\r\n}\r\n\r\n.capitalized-text {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.portal-error-text {\r\n  font-size: 20px !important;\r\n}\r\n\r\n/*Added CSS styles - 04/12/2018 - Onesi*/\r\n.VueCarousel-wrapper {\r\n  height: auto;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (min-width: 1200px) {\r\n  .VueCarousel-wrapper {\r\n    height: 209px;\r\n  }\r\n}\r\n\r\n.th-bordered {\r\n  border: 1px solid white;\r\n}\r\n\r\n.th-responsive {\r\n  white-space: nowrap;\r\n}\r\n\r\n.hide-overflow {\r\n  /*768px -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .hide-overflow {\r\n    overflow-y: hidden;\r\n  }\r\n}\r\n\r\n.hide-overflow .primarycontact-eyedoctor {\r\n  margin-top: 0rem;\r\n}\r\n\r\n.primarycontact-eyedoctor {\r\n  margin-top: 2rem;\r\n}\r\n\r\n@media screen and (min-width: 320px) and (max-width: 1200px) {\r\n  .primarycontact-eyedoctor {\r\n    margin-top: 0rem;\r\n  }\r\n}\r\n\r\n.hamburger-div {\r\n  right: 40px;\r\n  position: absolute;\r\n  top: 16px;\r\n  border: none;\r\n  height: 50px;\r\n  width: 40px;\r\n  cursor: pointer;\r\n  z-index: 999 !important;\r\n}\r\n\r\n.img-fluid-sm {\r\n  max-width: 50%;\r\n}\r\n.table-rx{\r\n  width: 100%;\r\n  border: 1px solid #999;\r\n  text-align: center;\r\n}\r\n.table-rx th {\r\n  background: lightgrey;  padding: 5px;\r\n  padding: 5px;\r\n}\r\n.table-rx td {\r\n  border: 1px dotted #999;\r\n  padding: 5px;\r\n}\r\n.table-rx-td-title {\r\n  background: lightgrey;  padding: 5px;\r\n}\r\n.order-review-title-center {\r\n  text-align: center;\r\n}\r\n.order-review-border {\r\n  border-radius: 10px;\r\n  border: #0c7cba;\r\n  border-style: solid;\r\n  /*padding: 5px;*/\r\n}\r\n.order-review-page-title {\r\n  text-align: center;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 24px;\r\n  color: #fff;\r\n  margin-bottom: 0px;\r\n  padding-bottom: 10px;\r\n}\r\n.order-review-content {\r\n  text-align: center;\r\n  color: #000;\r\n  border-radius: 10px;\r\n  border: #0c7cba;\r\n  border-style: solid;\r\n}\r\n.order-info-content {\r\n  text-align: center;\r\n  color: #000;\r\n}\r\n.order-reviewpatient {\r\n  text-align: center;\r\n  color: #000;\r\n  border-radius: 10px;\r\n  border: #0c7cba;\r\n  border-style: solid;\r\n}\r\n.order-reviewpatient-title {\r\n  font-size: larger;\r\n  font-weight: bold;\r\n}\r\n.order-reviewpatient-description {\r\n  font-size: larger;\r\n  font-weight: normal;\r\n}\r\n.tooltiptext {\r\n  visibility: hidden;\r\n  width: 220px;\r\n  background-color: black;\r\n  color: #fff;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  padding: 5px;\r\n  position: absolute;\r\n  z-index: 1;\r\n  bottom: 125%; /* Position above the icon */\r\n  left: 50%;\r\n  margin-left: -110px; /* Center the tooltip */\r\n  opacity: 0; /* Hidden by default */\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n.tooltip-icon:hover + .tooltiptext {\r\n  visibility: visible;\r\n  opacity: 1; /* Show tooltip on hover */\r\n}\r\n", ""]);

// exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "@font-face {\r\n  font-family: 'ProximaNova-Bold';\r\n  src: url(" + __webpack_require__(53) + ");\r\n  src: url(" + __webpack_require__(53) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(112) + ") format(\"woff2\"), url(" + __webpack_require__(111) + ") format(\"woff\"), url(" + __webpack_require__(110) + ") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ProximaNova-Medium';\r\n  src: url(" + __webpack_require__(54) + ");\r\n  src: url(" + __webpack_require__(54) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(115) + ") format(\"woff2\"), url(" + __webpack_require__(114) + ") format(\"woff\"), url(" + __webpack_require__(113) + ") format(\"truetype\");\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ProximaNova-Regular';\r\n  src: url(" + __webpack_require__(52) + ");\r\n  src: url(" + __webpack_require__(52) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(109) + ") format(\"woff2\"), url(" + __webpack_require__(108) + ") format(\"woff\"), url(" + __webpack_require__(107) + ") format(\"truetype\");\r\n}\r\n\r\n/*Portal config*/\r\n.header .upper-header {\r\n  background-color: #26304d;\r\n  height: 20px;\r\n}\r\n\r\n.header .lower-header {\r\n  background-color: #0c7cba;\r\n  height: 90px;\r\n}\r\n\r\n.header .lower-header .evf_logo {\r\n  height: 80px;\r\n  margin: 5px 10px;\r\n}\r\n\r\n.header .lower-header .nav_toggle_button {\r\n  color: white;\r\n  float: right;\r\n  padding-right: 30px;\r\n  padding-top: 25px;\r\n  font-size: 25px;\r\n}\r\n\r\n@media only screen and (min-width: 767px) {\r\n  .header .lower-header .nav_toggle_button {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.header .lower-header .my_account_services {\r\n  padding-top: 15px;\r\n  background-color: #0c7cba;\r\n  /* @media only screen and (max-width: 767px) {\r\n                display: none;\r\n            }*/\r\n}\r\n\r\n.header .lower-header .my_account_services .nav_divider {\r\n  padding: 10px;\r\n  border-right: 2px solid black;\r\n}\r\n\r\n@media only screen and (max-width: 575px) {\r\n  .header .lower-header .my_account_services .nav_divider {\r\n    border-right: 0px solid black;\r\n  }\r\n}\r\n\r\n.header .lower-header .my_account_services .nav_divider p.portal_header_link {\r\n  color: white !important;\r\n  text-align: center;\r\n  margin-bottom: 7px;\r\n  font-family: ProximaNova-Medium, sans-serif !important;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  font-size: 16px !important;\r\n}\r\n\r\n.header .lower-header .logout_services {\r\n  background-color: #0c7cba;\r\n  /* @media only screen and (max-width: 767px) {\r\n                display: none;\r\n            }*/\r\n}\r\n\r\n.header .lower-header .logout_services .logout_link {\r\n  color: white;\r\n  float: right;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-top: 28px;\r\n  margin-right: 30px;\r\n}\r\n\r\n.header .lower-header .logout_services .logout_link:hover {\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-content {\r\n  margin-top: 107px;\r\n  background-color: #d5e4ef7a;\r\n  border: 3px solid #0c7cba;\r\n  float: right;\r\n  overflow: hidden;\r\n  width: 385px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .login-content {\r\n    width: 420px;\r\n  }\r\n}\r\n\r\n.login-content .login_info {\r\n  padding: 10px 30px;\r\n}\r\n\r\n.login-content .login_info .email_wrap {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.login-content .login_info .login_info_label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.login-content .login_info .login_input {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  height: 30px;\r\n}\r\n\r\n.login-content .login_info .login_button_info {\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.login-content .login_info .login_button_info .login_button {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  border-radius: 15px;\r\n  border: 2px solid #0c7cba;\r\n  background-color: white;\r\n  width: 100%;\r\n  padding: 0px;\r\n}\r\n\r\n.login-content .login_info .login_validation {\r\n  text-align: center;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.main_login {\r\n  padding-right: 0px !important;\r\n}\r\n\r\n.main_hero_image {\r\n  width: 364px;\r\n  height: auto;\r\n  margin-top: 150px;\r\n  margin-left: 50px;\r\n  background-color: white;\r\n  position: absolute;\r\n  z-index: 0;\r\n  /*display: none*/\r\n  /*1600 x 900 -screen Resolution */\r\n  /*1320 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .main_hero_image {\r\n    width: 428px;\r\n  }\r\n}\r\n\r\n.main_content_title {\r\n  margin-top: 180px;\r\n  font-size: 89px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  float: right;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .main_content_title {\r\n    margin-top: 158px;\r\n    font-size: 110px;\r\n  }\r\n}\r\n\r\n.portal_description {\r\n  font-size: 19px;\r\n  margin: 20px 0px;\r\n  text-align: center;\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .portal_description {\r\n    margin: 50px 0px;\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.sign_up_link {\r\n  margin-top: 43px;\r\n  margin-bottom: 43px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .sign_up_link {\r\n    margin-top: 60px;\r\n    margin-bottom: 60px;\r\n  }\r\n}\r\n\r\n.sign_up_link .sign_up_button {\r\n  font-size: 23px;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px;\r\n  border: 3px solid #0c7cba;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  float: right;\r\n  width: 250px;\r\n  height: 65px;\r\n  padding-top: 10px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .sign_up_link .sign_up_button {\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n.footer_arrow {\r\n  position: absolute;\r\n  left: 0px;\r\n  bottom: 20px;\r\n  z-index: -10;\r\n  background-repeat: no-repeat;\r\n  /*display: none*/\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .footer_arrow {\r\n    bottom: 86px;\r\n  }\r\n}\r\n\r\n.footer_arrow img.arrow_info {\r\n  width: 800px;\r\n  height: 90px;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1600px) and (min-width: 1367px) {\r\n  .footer_arrow img.arrow_info {\r\n    /* width: 1100px;\r\n            height: 200px;*/\r\n  }\r\n}\r\n\r\n/*HomeScroll styles*/\r\n@media (max-width: 991px) {\r\n  .portal_program_content .reorder {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  .portal_program_content .second {\r\n    order: 2;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_program_content .portal_info {\r\n  margin: 40px auto;\r\n  /*1157 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1157px) and (min-width: 991px) {\r\n  .portal_program_content .portal_info {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.portal_program_content .portal_info p.pp_title {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  text-align: left;\r\n  font-size: 25px;\r\n  color: #3f4d5d;\r\n  margin-bottom: 1rem;\r\n  /*1600 x 900 -screen Resolution */\r\n}\r\n\r\n.portal_program_content .program_desc_container .pp_description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 20px;\r\n  text-align: justify;\r\n  color: #000000;\r\n  /*768 -Screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .portal_program_content .program_desc_container .pp_description {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 991px) and (min-width: 768px) {\r\n  .portal_program_content .program_desc_container {\r\n    width: 700px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_desc_content {\r\n  width: 550px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  /*1157 x  -screen Resolution */\r\n  /*876 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1157px) and (min-width: 991px) {\r\n  .portal_program_content .pp_desc_content {\r\n    width: 400px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .portal_program_content .pp_desc_content {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_desc_content ul.pp_desc_info {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 19.5px;\r\n  text-align: justify;\r\n  line-height: 20px;\r\n  color: #000000;\r\n  /*768 -Screen Resolution */\r\n  /*400 -Screen Resolution */\r\n}\r\n\r\n.portal_program_content .pp_desc_content ul.pp_desc_info li {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .portal_program_content .pp_desc_content ul.pp_desc_info {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n  .portal_program_content .pp_desc_content ul.pp_desc_info {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_benefit_content {\r\n  width: 550px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  /*1157 x  -screen Resolution */\r\n  /*876 x  -screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 1157px) and (min-width: 991px) {\r\n  .portal_program_content .pp_benefit_content {\r\n    width: 400px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .portal_program_content .pp_benefit_content {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_benefit_content ul.pp_benefit_info {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 19.5px;\r\n  text-align: justify;\r\n  line-height: 20px;\r\n  padding-left: 20px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .portal_program_content .pp_benefit_content ul.pp_benefit_info {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n  .portal_program_content .pp_benefit_content ul.pp_benefit_info {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.portal_program_content .pp_benefit_content ul.pp_benefit_info li {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.portal_program_content .pp_benefit_content ul.pp_benefit_info li span.benefit_desc {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n}\r\n\r\n.pp_image {\r\n  padding: 0;\r\n}\r\n\r\n.pp_image .hide_desktop {\r\n  width: 100%;\r\n  /*991px and 768px - Screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 991px) and (min-width: 768px) {\r\n  .pp_image .hide_desktop {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.pp_image .hide_mobile {\r\n  width: 700px;\r\n  margin: 0px auto;\r\n  display: none;\r\n  /*991px and 768px- Screen Resolution */\r\n}\r\n\r\n@media only screen and (max-width: 991px) and (min-width: 768px) {\r\n  .pp_image .hide_mobile {\r\n    display: block;\r\n  }\r\n  .pp_image .hide_mobile img.mobile_img {\r\n    width: 700px;\r\n  }\r\n}\r\n\r\n.portal_link_services {\r\n  margin-top: 100px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.portal_link_services .portal_link_container {\r\n  width: 900px;\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .portal_link_services .portal_link_container {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content {\r\n  text-align: center;\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content .portal_link_info {\r\n  width: 200px;\r\n  margin: 0 auto;\r\n  /*768px- Screen Resolution*/\r\n  /*299px- Screen Resolution*/\r\n}\r\n\r\n@media only screen and (max-width: 768px) and (min-width: 575px) {\r\n  .portal_link_services .portal_link_container a.portal_link_content .portal_link_info {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 299px) {\r\n  .portal_link_services .portal_link_container a.portal_link_content .portal_link_info {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content .portal_link_info img.portal_link_img {\r\n  width: 130px;\r\n  height: 125px;\r\n  border-radius: 100%;\r\n  margin: 0 auto;\r\n  border: 2px solid #000000;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n@media only screen and (max-width: 767px) and (min-width: 575px) {\r\n  .portal_link_services .portal_link_container a.portal_link_content .portal_link_info img.portal_link_img {\r\n    width: 130px;\r\n    height: 130px;\r\n  }\r\n}\r\n\r\n.portal_link_services .portal_link_container a.portal_link_content .portal_link_info p.portal_link_p {\r\n  font-size: 21px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n  color: #000000;\r\n}\r\n\r\n/*Footer styles*/\r\n.footer_services .footer_content {\r\n  background-color: #26304d;\r\n  height: 100%;\r\n}\r\n\r\n.footer_services .footer_content .footer_info {\r\n  margin-top: 12px;\r\n  bottom: 0;\r\n}\r\n\r\n.footer_services .footer_content .footer_info .footer_container .footer_divider {\r\n  padding: 10px;\r\n  border-right: 2px solid black;\r\n}\r\n\r\n@media only screen and (max-width: 575px) {\r\n  .footer_services .footer_content .footer_info .footer_container .footer_divider {\r\n    border-right: 0px solid black;\r\n  }\r\n}\r\n\r\n.footer_services .footer_content .footer_info .footer_container .footer_divider .footer_link {\r\n  color: white;\r\n  text-align: center;\r\n  margin-bottom: 7px;\r\n  font-family: ProximaNova-Medium, sans-serif;\r\n  text-decoration: underline;\r\n}\r\n\r\n/*Reset Password Modal*/\r\n.modal-mask {\r\n  position: fixed;\r\n  z-index: 9998;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  /*background-color: transparent;*/\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: table;\r\n  transition: opacity .3s ease;\r\n  /* overflow-y: auto; */\r\n}\r\n\r\n.modal-mask .overlay-mask {\r\n  overflow-y: auto;\r\n  height: 100vh;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog {\r\n  /* overflow-y: auto;*/\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content {\r\n  background-color: white;\r\n  border: 3px solid #26304d;\r\n  border-radius: 10px;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .close_btn {\r\n  background-image: url(" + __webpack_require__(106) + ");\r\n  background-size: 20px 20px;\r\n  width: 20px;\r\n  height: 20px;\r\n  /* background-repeat: no-repeat;\r\n                    border: 1px solid $blue_color;\r\n                    padding: 10px;*/\r\n  cursor: pointer;\r\n  float: right;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header {\r\n  text-align: center;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-title {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 25px;\r\n  color: #000000;\r\n  /*323px - Screen Resolution*/\r\n}\r\n\r\n@media only screen and (max-width: 323px) {\r\n  .modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-title {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-description {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  font-size: 18px;\r\n  width: 380px;\r\n  margin: 10px auto;\r\n  color: #000000;\r\n  /*450px - Screen Resolution*/\r\n}\r\n\r\n@media only screen and (max-width: 450px) {\r\n  .modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.modal-description {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .passwordReset-header p.nonprofit-modal-msg {\r\n  font-family: ProximaNova-Bold, sans-serif !important;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body .modal_scroll {\r\n  max-height: 500px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body #style-1::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  border-radius: 10px;\r\n  background-color: #F5F5F5;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body #style-1::-webkit-scrollbar {\r\n  width: 8px;\r\n  background-color: #F5F5F5;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content .modal-body #style-1::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  background-color: #555;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content.modal-edit-bg {\r\n  background-color: white;\r\n  border: 3px solid #26304d;\r\n}\r\n\r\n.modal-mask .overlay-mask .modal-dialog .modal-content.modal-delete-bg {\r\n  background-color: white;\r\n  border: 3px solid #26304d;\r\n}\r\n\r\n/*Forgot Password - 02/10/18 - Onesi*/\r\n.reset_info_label {\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  margin-bottom: 0;\r\n  font-size: 18px;\r\n}\r\n\r\n.forgot_password_button {\r\n  font-size: 18px;\r\n  background-color: #d5e4ef7a;\r\n  border-radius: 15px;\r\n  border: 3px solid #0c7cba;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n  color: #000000;\r\n  width: 250px;\r\n  height: 65px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.contract-header {\r\n  font-size: 24px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n}\r\n\r\n.contract-description {\r\n  font-family: ProximaNova-Regular, sans-serif;\r\n  font-size: 16px;\r\n}\r\n\r\n.contract-label {\r\n  font-size: 16px;\r\n  font-family: ProximaNova-Bold, sans-serif;\r\n}\r\n\r\n.bottom-margin-50 {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.bottom-margin-10 {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.frame-list-description1-height {\r\n  height: 180px;\r\n}\r\n\r\n.frame-list-description2-height {\r\n  height: 70px;\r\n  padding-bottom: 10px !important;\r\n  padding-left: 1.78571rem !important;\r\n  padding-top: 10px !important;\r\n}\r\n\r\n.warning-text-color {\r\n  text-align: center;\r\n  color: #a61d37 !important;\r\n  font-size: 14px !important;\r\n}\r\n\r\n.no-margin {\r\n  margin-left: 0px !important;\r\n  margin-right: 0px !important;\r\n}\r\n", ""]);

// exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "/**\r\n * Swiper 3.2.0\r\n * Most modern mobile touch slider and framework with hardware accelerated transitions\r\n * \r\n * http://www.idangero.us/swiper/\r\n * \r\n * Copyright 2015, Vladimir Kharlampidi\r\n * The iDangero.us\r\n * http://www.idangero.us/\r\n * \r\n * Licensed under MIT\r\n * \r\n * Released on: November 7, 2015\r\n */\r\n.swiper-container {\r\n  margin: 0 auto;\r\n  position: relative;\r\n  overflow: hidden;\r\n  z-index: 1;\r\n}\r\n\r\n.swiper-container-no-flexbox .swiper-slide {\r\n  float: left;\r\n}\r\n\r\n.swiper-container-vertical > .swiper-wrapper {\r\n  -webkit-box-orient: vertical;\r\n  -moz-box-orient: vertical;\r\n  -ms-flex-direction: column;\r\n  -webkit-flex-direction: column;\r\n  flex-direction: column;\r\n}\r\n\r\n.swiper-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 0;\r\n  display: -webkit-box;\r\n  display: -moz-box;\r\n  display: -ms-flexbox;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-transition-property: -webkit-transform;\r\n  -moz-transition-property: -moz-transform;\r\n  -o-transition-property: -o-transform;\r\n  -ms-transition-property: -ms-transform;\r\n  transition-property: transform;\r\n  -webkit-box-sizing: content-box;\r\n  -moz-box-sizing: content-box;\r\n  box-sizing: content-box;\r\n}\r\n\r\n.swiper-container-android .swiper-slide, .swiper-wrapper {\r\n  -webkit-transform: translate3d(0, 0, 0);\r\n  -moz-transform: translate3d(0, 0, 0);\r\n  -o-transform: translate(0, 0);\r\n  -ms-transform: translate3d(0, 0, 0);\r\n  transform: translate3d(0, 0, 0);\r\n}\r\n\r\n.swiper-container-multirow > .swiper-wrapper {\r\n  -webkit-box-lines: multiple;\r\n  -moz-box-lines: multiple;\r\n  -ms-flex-wrap: wrap;\r\n  -webkit-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.swiper-container-free-mode > .swiper-wrapper {\r\n  -webkit-transition-timing-function: ease-out;\r\n  -moz-transition-timing-function: ease-out;\r\n  -ms-transition-timing-function: ease-out;\r\n  -o-transition-timing-function: ease-out;\r\n  transition-timing-function: ease-out;\r\n  margin: 0 auto;\r\n}\r\n\r\n.swiper-slide {\r\n  -webkit-flex-shrink: 0;\r\n  -ms-flex: 0 0 auto;\r\n  flex-shrink: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n.swiper-container .swiper-notification {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  pointer-events: none;\r\n  opacity: 0;\r\n  z-index: -1000;\r\n}\r\n\r\n.swiper-wp8-horizontal {\r\n  -ms-touch-action: pan-y;\r\n  touch-action: pan-y;\r\n}\r\n\r\n.swiper-wp8-vertical {\r\n  -ms-touch-action: pan-x;\r\n  touch-action: pan-x;\r\n}\r\n\r\n.swiper-button-next, .swiper-button-prev {\r\n  position: absolute;\r\n  top: 50%;\r\n  width: 27px;\r\n  height: 44px;\r\n  margin-top: -22px;\r\n  z-index: 10;\r\n  cursor: pointer;\r\n  -moz-background-size: 27px 44px;\r\n  -webkit-background-size: 27px 44px;\r\n  background-size: 27px 44px;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled {\r\n  opacity: .35;\r\n  cursor: auto;\r\n  pointer-events: none;\r\n}\r\n\r\n.swiper-button-prev, .swiper-container-rtl .swiper-button-next {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\r\n  left: 10px;\r\n  right: auto;\r\n}\r\n\r\n.swiper-button-prev.swiper-button-black, .swiper-container-rtl .swiper-button-next.swiper-button-black {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.swiper-button-prev.swiper-button-white, .swiper-container-rtl .swiper-button-next.swiper-button-white {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.swiper-button-next, .swiper-container-rtl .swiper-button-prev {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\r\n  right: 10px;\r\n  left: auto;\r\n}\r\n\r\n.swiper-button-next.swiper-button-black, .swiper-container-rtl .swiper-button-prev.swiper-button-black {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.swiper-button-next.swiper-button-white, .swiper-container-rtl .swiper-button-prev.swiper-button-white {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.swiper-pagination {\r\n  position: absolute;\r\n  text-align: center;\r\n  -webkit-transition: .3s;\r\n  -moz-transition: .3s;\r\n  -o-transition: .3s;\r\n  transition: .3s;\r\n  -webkit-transform: translate3d(0, 0, 0);\r\n  -ms-transform: translate3d(0, 0, 0);\r\n  -o-transform: translate3d(0, 0, 0);\r\n  transform: translate3d(0, 0, 0);\r\n  z-index: 10;\r\n}\r\n\r\n.swiper-pagination.swiper-pagination-hidden {\r\n  opacity: 0;\r\n}\r\n\r\n.swiper-pagination-bullet {\r\n  width: 8px;\r\n  height: 8px;\r\n  display: inline-block;\r\n  border-radius: 100%;\r\n  background: #000;\r\n  opacity: .2;\r\n}\r\n\r\nbutton.swiper-pagination-bullet {\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  box-shadow: none;\r\n  -moz-appearance: none;\r\n  -ms-appearance: none;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\n.swiper-pagination-clickable .swiper-pagination-bullet {\r\n  cursor: pointer;\r\n}\r\n\r\n.swiper-pagination-white .swiper-pagination-bullet {\r\n  background: #fff;\r\n}\r\n\r\n.swiper-pagination-bullet-active {\r\n  opacity: 1;\r\n  background: #007aff;\r\n}\r\n\r\n.swiper-pagination-white .swiper-pagination-bullet-active {\r\n  background: #fff;\r\n}\r\n\r\n.swiper-pagination-black .swiper-pagination-bullet-active {\r\n  background: #000;\r\n}\r\n\r\n.swiper-container-vertical > .swiper-pagination {\r\n  right: 10px;\r\n  top: 50%;\r\n  -webkit-transform: translate3d(0, -50%, 0);\r\n  -moz-transform: translate3d(0, -50%, 0);\r\n  -o-transform: translate(0, -50%);\r\n  -ms-transform: translate3d(0, -50%, 0);\r\n  transform: translate3d(0, -50%, 0);\r\n}\r\n\r\n.swiper-container-vertical > .swiper-pagination .swiper-pagination-bullet {\r\n  margin: 5px 0;\r\n  display: block;\r\n}\r\n\r\n.swiper-container-horizontal > .swiper-pagination {\r\n  bottom: 10px;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.swiper-container-horizontal > .swiper-pagination .swiper-pagination-bullet {\r\n  margin: 0 5px;\r\n}\r\n\r\n.swiper-container-3d {\r\n  -webkit-perspective: 1200px;\r\n  -moz-perspective: 1200px;\r\n  -o-perspective: 1200px;\r\n  perspective: 1200px;\r\n}\r\n\r\n.swiper-container-3d .swiper-cube-shadow, .swiper-container-3d .swiper-slide, .swiper-container-3d .swiper-slide-shadow-bottom, .swiper-container-3d .swiper-slide-shadow-left, .swiper-container-3d .swiper-slide-shadow-right, .swiper-container-3d .swiper-slide-shadow-top, .swiper-container-3d .swiper-wrapper {\r\n  -webkit-transform-style: preserve-3d;\r\n  -moz-transform-style: preserve-3d;\r\n  -ms-transform-style: preserve-3d;\r\n  transform-style: preserve-3d;\r\n}\r\n\r\n.swiper-container-3d .swiper-slide-shadow-bottom, .swiper-container-3d .swiper-slide-shadow-left, .swiper-container-3d .swiper-slide-shadow-right, .swiper-container-3d .swiper-slide-shadow-top {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n  z-index: 10;\r\n}\r\n\r\n.swiper-container-3d .swiper-slide-shadow-left {\r\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(transparent));\r\n  background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -moz-linear-gradient(right, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), transparent);\r\n}\r\n\r\n.swiper-container-3d .swiper-slide-shadow-right {\r\n  background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(transparent));\r\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), transparent);\r\n}\r\n\r\n.swiper-container-3d .swiper-slide-shadow-top {\r\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(transparent));\r\n  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -moz-linear-gradient(bottom, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);\r\n}\r\n\r\n.swiper-container-3d .swiper-slide-shadow-bottom {\r\n  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(transparent));\r\n  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -moz-linear-gradient(top, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0.5), transparent);\r\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), transparent);\r\n}\r\n\r\n.swiper-container-coverflow .swiper-wrapper {\r\n  -ms-perspective: 1200px;\r\n}\r\n\r\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\r\n  -webkit-transition-timing-function: ease-out;\r\n  -moz-transition-timing-function: ease-out;\r\n  -ms-transition-timing-function: ease-out;\r\n  -o-transition-timing-function: ease-out;\r\n  transition-timing-function: ease-out;\r\n}\r\n\r\n.swiper-container-fade .swiper-slide {\r\n  pointer-events: none;\r\n}\r\n\r\n.swiper-container-fade .swiper-slide .swiper-slide {\r\n  pointer-events: none;\r\n}\r\n\r\n.swiper-container-fade .swiper-slide-active, .swiper-container-fade .swiper-slide-active .swiper-slide-active {\r\n  pointer-events: auto;\r\n}\r\n\r\n.swiper-container-cube {\r\n  overflow: visible;\r\n}\r\n\r\n.swiper-container-cube .swiper-slide {\r\n  pointer-events: none;\r\n  visibility: hidden;\r\n  -webkit-transform-origin: 0 0;\r\n  -moz-transform-origin: 0 0;\r\n  -ms-transform-origin: 0 0;\r\n  transform-origin: 0 0;\r\n  -webkit-backface-visibility: hidden;\r\n  -moz-backface-visibility: hidden;\r\n  -ms-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\r\n  -webkit-transform-origin: 100% 0;\r\n  -moz-transform-origin: 100% 0;\r\n  -ms-transform-origin: 100% 0;\r\n  transform-origin: 100% 0;\r\n}\r\n\r\n.swiper-container-cube .swiper-slide-active, .swiper-container-cube .swiper-slide-next, .swiper-container-cube .swiper-slide-next + .swiper-slide, .swiper-container-cube .swiper-slide-prev {\r\n  pointer-events: auto;\r\n  visibility: visible;\r\n}\r\n\r\n.swiper-container-cube .swiper-slide-shadow-bottom, .swiper-container-cube .swiper-slide-shadow-left, .swiper-container-cube .swiper-slide-shadow-right, .swiper-container-cube .swiper-slide-shadow-top {\r\n  z-index: 0;\r\n  -webkit-backface-visibility: hidden;\r\n  -moz-backface-visibility: hidden;\r\n  -ms-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.swiper-container-cube .swiper-cube-shadow {\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #000;\r\n  opacity: .6;\r\n  -webkit-filter: blur(50px);\r\n  filter: blur(50px);\r\n  z-index: 0;\r\n}\r\n\r\n.swiper-scrollbar {\r\n  border-radius: 10px;\r\n  position: relative;\r\n  -ms-touch-action: none;\r\n  background: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.swiper-container-horizontal > .swiper-scrollbar {\r\n  position: absolute;\r\n  left: 1%;\r\n  bottom: 3px;\r\n  z-index: 50;\r\n  height: 5px;\r\n  width: 98%;\r\n}\r\n\r\n.swiper-container-vertical > .swiper-scrollbar {\r\n  position: absolute;\r\n  right: 3px;\r\n  top: 1%;\r\n  z-index: 50;\r\n  width: 5px;\r\n  height: 98%;\r\n}\r\n\r\n.swiper-scrollbar-drag {\r\n  height: 100%;\r\n  width: 100%;\r\n  position: relative;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  border-radius: 10px;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.swiper-scrollbar-cursor-drag {\r\n  cursor: move;\r\n}\r\n\r\n.swiper-lazy-preloader {\r\n  width: 42px;\r\n  height: 42px;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  margin-left: -21px;\r\n  margin-top: -21px;\r\n  z-index: 10;\r\n  -webkit-transform-origin: 50%;\r\n  -moz-transform-origin: 50%;\r\n  transform-origin: 50%;\r\n  -webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;\r\n  -moz-animation: swiper-preloader-spin 1s steps(12, end) infinite;\r\n  animation: swiper-preloader-spin 1s steps(12, end) infinite;\r\n}\r\n\r\n.swiper-lazy-preloader:after {\r\n  display: block;\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\r\n  background-position: 50%;\r\n  -webkit-background-size: 100%;\r\n  background-size: 100%;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.swiper-lazy-preloader-white:after {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n@-webkit-keyframes swiper-preloader-spin {\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes swiper-preloader-spin {\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n", ""]);

// exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border-color:#41b883 transparent transparent;border-style:solid;border-width:2px;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:a 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:a 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:14px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{opacity:.6}.multiselect--active{z-index:1}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:6px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #6d6d6d;background:#fff}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 12px 0;padding-right:30px;white-space:nowrap;border-radius:5px;border:1px solid #a6a6a6}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-style:solid;border-width:5px 5px 0;border-color:#999 transparent transparent;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #6d6d6d;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:2;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #6d6d6d}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled{background:#ededed;pointer-events:none}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select,.multiselect__option--disabled{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{cursor:text;pointer-events:none}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede!important}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes a{0%{transform:rotate(0)}to{transform:rotate(2turn)}}", ""]);

// exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".long-modal {\r\n  height: calc(100vh - 200px);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.long-modal::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n", ""]);

// exports


/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Portal Photo_FamilyImage1.91eef29.jpeg";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/frame-measurement.b232e7e.png";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/temple-size.7b81b30.png";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Address_ContactUs.370d722.png";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mail_ContactUs.3c96745.png";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mobile_ContactUs.4326ea1.png";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/place_order.4e90cbf.png";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/track_order.08b679b.png";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ChampionsForSight_PrimaryLogo_White.9cded5b.png";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.acf3dcb.svg";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(504),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\AssociationAndCommunication.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AssociationAndCommunication.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3b2f0fac", Component.options)
  } else {
    hotAPI.reload("data-v-3b2f0fac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(500),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\EyeDoctorInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EyeDoctorInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3781fd82", Component.options)
  } else {
    hotAPI.reload("data-v-3781fd82", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(493),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\NonProfitOrganizationDetails.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NonProfitOrganizationDetails.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-286086f8", Component.options)
  } else {
    hotAPI.reload("data-v-286086f8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\OfficeLocationInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OfficeLocationInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01cfe1b6", Component.options)
  } else {
    hotAPI.reload("data-v-01cfe1b6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(494),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\ParticipantInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ParticipantInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2cd68b1f", Component.options)
  } else {
    hotAPI.reload("data-v-2cd68b1f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\TermAgreementAndBaa.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TermAgreementAndBaa.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62833713", Component.options)
  } else {
    hotAPI.reload("data-v-62833713", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(478),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\AccountDetails\\UsernameAndPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UsernameAndPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b41bdb4", Component.options)
  } else {
    hotAPI.reload("data-v-0b41bdb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(583),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\home\\Version.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Version.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f9558ce8", Component.options)
  } else {
    hotAPI.reload("data-v-f9558ce8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\home\\listData\\ForgotPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ForgotPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71156e4e", Component.options)
  } else {
    hotAPI.reload("data-v-71156e4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\home\\listData\\ResendActivation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResendActivation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4488876c", Component.options)
  } else {
    hotAPI.reload("data-v-4488876c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\AnnualForecastingModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AnnualForecastingModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9f8bd698", Component.options)
  } else {
    hotAPI.reload("data-v-9f8bd698", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Catalog.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(545),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\ContractAgreement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ContractAgreement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-78c8cf99", Component.options)
  } else {
    hotAPI.reload("data-v-78c8cf99", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\ContractAgreementModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ContractAgreementModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c4faeb78", Component.options)
  } else {
    hotAPI.reload("data-v-c4faeb78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(529),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Home.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Home.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f1a056e", Component.options)
  } else {
    hotAPI.reload("data-v-5f1a056e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(470),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\OrderTracking\\OrderTracking.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderTracking.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03d3995c", Component.options)
  } else {
    hotAPI.reload("data-v-03d3995c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(593)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(495),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ce8a543",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\OrderTracking\\OrderTrackingComponents\\OrderTrackingFilters.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderTrackingFilters.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ce8a543", Component.options)
  } else {
    hotAPI.reload("data-v-2ce8a543", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\OrderTracking\\OrderTrackingComponents\\OrderTrackingTable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderTrackingTable.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-153530d4", Component.options)
  } else {
    hotAPI.reload("data-v-153530d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\OrderTracking\\OrderTrackingComponents\\OrderTrackingVisionWebStatus.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderTrackingVisionWebStatus.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-576ec926", Component.options)
  } else {
    hotAPI.reload("data-v-576ec926", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(491),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\ExamConfirmation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ExamConfirmation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-26ec0c84", Component.options)
  } else {
    hotAPI.reload("data-v-26ec0c84", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(595)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bfda0a7",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\ExamSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ExamSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3bfda0a7", Component.options)
  } else {
    hotAPI.reload("data-v-3bfda0a7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(548),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\Order.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Order.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d935bee", Component.options)
  } else {
    hotAPI.reload("data-v-7d935bee", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\AdditionalInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AdditionalInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-79478096", Component.options)
  } else {
    hotAPI.reload("data-v-79478096", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(530),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\FrameInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5fca6f02", Component.options)
  } else {
    hotAPI.reload("data-v-5fca6f02", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\GeneralInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GeneralInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0733c9a4", Component.options)
  } else {
    hotAPI.reload("data-v-0733c9a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(497),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\OrderInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-319a4c7e", Component.options)
  } else {
    hotAPI.reload("data-v-319a4c7e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(499),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\OrderReview.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderReview.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-36eb56f6", Component.options)
  } else {
    hotAPI.reload("data-v-36eb56f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderComponent\\PatientInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PatientInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5dbec9e7", Component.options)
  } else {
    hotAPI.reload("data-v-5dbec9e7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(473),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderConfirmation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderConfirmation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0689b8c3", Component.options)
  } else {
    hotAPI.reload("data-v-0689b8c3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderSubmit\\OrderSubmit.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderSubmit.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2827b07d", Component.options)
  } else {
    hotAPI.reload("data-v-2827b07d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(576),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderSubmit\\OrderSubmitComponent\\OrderError.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderError.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-de89342e", Component.options)
  } else {
    hotAPI.reload("data-v-de89342e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(481),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderSubmit\\OrderSubmitComponent\\OrderPending.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderPending.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-15fe8fb8", Component.options)
  } else {
    hotAPI.reload("data-v-15fe8fb8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(566),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderSubmit\\OrderSubmitComponent\\OrderSpecial.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderSpecial.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0ba344c", Component.options)
  } else {
    hotAPI.reload("data-v-c0ba344c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(598)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(517),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47870908",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\Order\\OrderSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47870908", Component.options)
  } else {
    hotAPI.reload("data-v-47870908", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\FrameOrderSuccess.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameOrderSuccess.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5761d19a", Component.options)
  } else {
    hotAPI.reload("data-v-5761d19a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(542),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\FramesCenter.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FramesCenter.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72b93eda", Component.options)
  } else {
    hotAPI.reload("data-v-72b93eda", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(518),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\frameComponents\\FrameFilters.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameFilters.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-481bc472", Component.options)
  } else {
    hotAPI.reload("data-v-481bc472", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\frameComponents\\FrameHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameHeader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ca518934", Component.options)
  } else {
    hotAPI.reload("data-v-ca518934", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\frameComponents\\FrameList.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameList.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44345592", Component.options)
  } else {
    hotAPI.reload("data-v-44345592", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(559),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\frameComponents\\FrameModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a8808438", Component.options)
  } else {
    hotAPI.reload("data-v-a8808438", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(523),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\frameResources\\frameComponents\\FrameOrderCollection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameOrderCollection.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55316983", Component.options)
  } else {
    hotAPI.reload("data-v-55316983", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(503),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\HelpArticle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpArticle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ae7b380", Component.options)
  } else {
    hotAPI.reload("data-v-3ae7b380", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(466),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\HelpBlock.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpBlock.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00b78252", Component.options)
  } else {
    hotAPI.reload("data-v-00b78252", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(487),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\HelpCenter.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpCenter.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1fd1870a", Component.options)
  } else {
    hotAPI.reload("data-v-1fd1870a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\HelpContact.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpContact.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-97924f2c", Component.options)
  } else {
    hotAPI.reload("data-v-97924f2c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\HelpServices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpServices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0caeef8", Component.options)
  } else {
    hotAPI.reload("data-v-c0caeef8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(565),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\helpList\\Frames.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Frames.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bfe6b97e", Component.options)
  } else {
    hotAPI.reload("data-v-bfe6b97e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(536),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\helpList\\General.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] General.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b64b8dd", Component.options)
  } else {
    hotAPI.reload("data-v-6b64b8dd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\helpList\\HelpItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpItem.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ea56e62", Component.options)
  } else {
    hotAPI.reload("data-v-7ea56e62", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(581),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\helpList\\MyAccount.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MyAccount.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eeb279d4", Component.options)
  } else {
    hotAPI.reload("data-v-eeb279d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(550),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\helpList\\Order.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Order.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-869b70fa", Component.options)
  } else {
    hotAPI.reload("data-v-869b70fa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(475),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\helpList\\Resources.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Resources.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-076ab74c", Component.options)
  } else {
    hotAPI.reload("data-v-076ab74c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(498),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\helpData\\helpList\\TrackOrder.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TrackOrder.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35fb6944", Component.options)
  } else {
    hotAPI.reload("data-v-35fb6944", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(551),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\HomeBanner.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HomeBanner.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8b9e24dc", Component.options)
  } else {
    hotAPI.reload("data-v-8b9e24dc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(592)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\HomeBlock.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HomeBlock.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1cca75d2", Component.options)
  } else {
    hotAPI.reload("data-v-1cca75d2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\HomeIcons.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HomeIcons.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6bc54524", Component.options)
  } else {
    hotAPI.reload("data-v-6bc54524", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\HomeInvite.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HomeInvite.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3f1866ef", Component.options)
  } else {
    hotAPI.reload("data-v-3f1866ef", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(578),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\HomePromo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HomePromo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e42e8ece", Component.options)
  } else {
    hotAPI.reload("data-v-e42e8ece", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(488),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\HomeStory.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HomeStory.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-238d857f", Component.options)
  } else {
    hotAPI.reload("data-v-238d857f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(575),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\HomeSupport.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HomeSupport.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dc468a4e", Component.options)
  } else {
    hotAPI.reload("data-v-dc468a4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\homeData\\ShareStoryForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ShareStoryForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7418f83e", Component.options)
  } else {
    hotAPI.reload("data-v-7418f83e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(489),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\resourceData\\ResourcePromo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResourcePromo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24f2278e", Component.options)
  } else {
    hotAPI.reload("data-v-24f2278e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\resourceData\\ResourceServices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResourceServices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a0502a4", Component.options)
  } else {
    hotAPI.reload("data-v-4a0502a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(574),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\resourceData\\ResourceSuggest.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResourceSuggest.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d3bed8a4", Component.options)
  } else {
    hotAPI.reload("data-v-d3bed8a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(560),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\resourceData\\SuggestForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SuggestForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a88f1d00", Component.options)
  } else {
    hotAPI.reload("data-v-a88f1d00", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(490),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\AccountInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AccountInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-26ab6c12", Component.options)
  } else {
    hotAPI.reload("data-v-26ab6c12", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(482),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\AssociationInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AssociationInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-187f364b", Component.options)
  } else {
    hotAPI.reload("data-v-187f364b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\CommunicationInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommunicationInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a72fba0", Component.options)
  } else {
    hotAPI.reload("data-v-6a72fba0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(506),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\EyeDoctorInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EyeDoctorInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c623b0c", Component.options)
  } else {
    hotAPI.reload("data-v-3c623b0c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\ForecastingInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ForecastingInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c362885e", Component.options)
  } else {
    hotAPI.reload("data-v-c362885e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\LabInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LabInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46525952", Component.options)
  } else {
    hotAPI.reload("data-v-46525952", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(524),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\LocationInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LocationInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55e85992", Component.options)
  } else {
    hotAPI.reload("data-v-55e85992", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(514),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountData\\LoginInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoginInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45707c33", Component.options)
  } else {
    hotAPI.reload("data-v-45707c33", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditAccountInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditAccountInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0a453aed", Component.options)
  } else {
    hotAPI.reload("data-v-0a453aed", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(484),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditAssociationInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditAssociationInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1cacbc41", Component.options)
  } else {
    hotAPI.reload("data-v-1cacbc41", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditCommunicationInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditCommunicationInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1956dc16", Component.options)
  } else {
    hotAPI.reload("data-v-1956dc16", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditEyeDoctorInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditEyeDoctorInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04716df0", Component.options)
  } else {
    hotAPI.reload("data-v-04716df0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditForecastingInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditForecastingInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bb077c72", Component.options)
  } else {
    hotAPI.reload("data-v-bb077c72", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(535),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditLocationInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditLocationInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6acf0101", Component.options)
  } else {
    hotAPI.reload("data-v-6acf0101", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(511),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditLoginInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditLoginInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-43df32a9", Component.options)
  } else {
    hotAPI.reload("data-v-43df32a9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountEdit\\EditProfessionalInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EditProfessionalInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4bcc0a73", Component.options)
  } else {
    hotAPI.reload("data-v-4bcc0a73", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(582),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountList\\AddDoctor.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AddDoctor.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f4f619e0", Component.options)
  } else {
    hotAPI.reload("data-v-f4f619e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(515),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\portal\\userAccount\\accountList\\DeleteModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DeleteModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45e37ab2", Component.options)
  } else {
    hotAPI.reload("data-v-45e37ab2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(539),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\registration\\AccountType.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AccountType.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e338215", Component.options)
  } else {
    hotAPI.reload("data-v-6e338215", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(561),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\registration\\RegistrationSuccess.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RegistrationSuccess.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-af87bed0", Component.options)
  } else {
    hotAPI.reload("data-v-af87bed0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(472),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\CovidReliefFeedbackResultModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CovidReliefFeedbackResultModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-060de7ea", Component.options)
  } else {
    hotAPI.reload("data-v-060de7ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(563),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\CovidReliefModalForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CovidReliefModalForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ba05d75e", Component.options)
  } else {
    hotAPI.reload("data-v-ba05d75e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(467),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\ErrorPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ErrorPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01710cf1", Component.options)
  } else {
    hotAPI.reload("data-v-01710cf1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(579),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\FrameOrderForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FrameOrderForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e622930a", Component.options)
  } else {
    hotAPI.reload("data-v-e622930a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\HelpFormLoggedOut.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpFormLoggedOut.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1e7b7a81", Component.options)
  } else {
    hotAPI.reload("data-v-1e7b7a81", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\MessageLoader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MessageLoader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c511ae98", Component.options)
  } else {
    hotAPI.reload("data-v-c511ae98", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(553),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Jenkins\\jobs\\Champions For Sight PROD Site\\workspace\\ChampionsForSight.Site\\src\\components\\shared\\MultiSelectCheckbox.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MultiSelectCheckbox.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9914409c", Component.options)
  } else {
    hotAPI.reload("data-v-9914409c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container g-pt-50 g-pb-70"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-3 g-mb-30"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav flex-column",
    attrs: {
      "role": "tablist",
      "data-target": "nav-5-3-primary-ver",
      "data-tabs-mobile-type": "slide-up-down",
      "data-btn-classes": "btn btn-md btn-block rounded-0 u-btn-outline-primary"
    }
  }, [_vm._l((_vm.items.keys()), function(group, index) {
    return (_vm.items != null) ? _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link active g-brd-none g-color-main g-color-primary--hover g-px-0 g-py-5 g-font-size-20",
      attrs: {
        "data-toggle": "tab",
        "role": "tab"
      },
      on: {
        "click": function($event) {
          _vm.Scroll('#' + group.replace(/\s+/g, '') + '-div')
        }
      }
    }, [_vm._v("\r\n                  " + _vm._s(group) + "\r\n                ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link g-brd-none g-color-main g-color-primary--hover g-px-0 g-py-5 g-font-size-20",
    attrs: {
      "data-toggle": "tab",
      "role": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.Scroll('#contactDiv')
      }
    }
  }, [_vm._v("\r\n                  Contact Us\r\n                ")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-9 g-mb-30"
  }, [_c('help-services'), _vm._v(" "), _c('help-center', {
    attrs: {
      "items": _vm.items
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-pb-10"
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_vm._v("FAQ Quick Links")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00b78252", module.exports)
  }
}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-my-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "portal-error-text"
  }, [_vm._v("\n                              An unexpected error has occurred. Please try again in a few minutes or "), _c('a', {
    staticClass: "portal-error-text",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(".\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Home')
      }
    }
  }, [_vm._v("Home")])])])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01710cf1", module.exports)
  }
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('div', {
    staticClass: "registration-title"
  }, [_vm._v("Additional Information")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.BusinessLabels) ? _c('div', {
    staticClass: "registration-title"
  }, [_vm._v("Office Location Information")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('div', {
    staticClass: "registration-title"
  }, [_vm._v("Location Information")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('p', [_vm._v("Please enter your shipping information.")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels || _vm.FormInputs.BusinessLabels) ? _c('p', [_vm._v("Please enter the following information for your primary location.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.OfficeLocationName && _vm.Account.PrimaryContact.IsMultiLocation) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Office Location Name*")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Chapter Location Name*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Name),
      expression: "Account.PrimaryContact.OfficeLocation.Name"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "Name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationName))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationStreetAddress),
      expression: "FormInputs.OfficeLocationStreetAddress"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Street Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.StreetAddress),
      expression: "Account.PrimaryContact.OfficeLocation.StreetAddress"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationStreetAddress
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.StreetAddress)
    },
    on: {
      "change": _vm.addressChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "StreetAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationStreetAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationStreetAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationSuite),
      expression: "FormInputs.OfficeLocationSuite"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suite")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Suite),
      expression: "Account.PrimaryContact.OfficeLocation.Suite"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Suite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "Suite", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationCity),
      expression: "FormInputs.OfficeLocationCity"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.City),
      expression: "Account.PrimaryContact.OfficeLocation.City"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationCity
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "City", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationCity) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationCity))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationState),
      expression: "FormInputs.OfficeLocationState"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.State),
      expression: "Account.PrimaryContact.OfficeLocation.State"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationState
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "State", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationState))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationZip),
      expression: "FormInputs.OfficeLocationZip"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Zip Code*")]), _vm._v(" "), (_vm.IsValidNPI) ? _c('span', [_c('i', {
    staticClass: "fa fa-check-circle check_icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.IsAddressValidating) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Zip),
      expression: "Account.PrimaryContact.OfficeLocation.Zip"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationZip
    },
    attrs: {
      "type": "text",
      "maxlength": "5"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Zip)
    },
    on: {
      "keypress": function($event) {
        return _vm.IsNumber(this.event)
      },
      "blur": function($event) {
        return _vm.ValidateAddress()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "Zip", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationZip) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationZip))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-9 col-sm-9 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationPhoneNumber),
      expression: "FormInputs.OfficeLocationPhoneNumber"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone Number"), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row div-phone"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.CountryCode),
      expression: "Account.PrimaryContact.OfficeLocation.CountryCode"
    }],
    ref: "office_number_1",
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.CountryCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.PhoneNumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "CountryCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.AreaCode),
      expression: "Account.PrimaryContact.OfficeLocation.AreaCode"
    }],
    ref: "office_number_2",
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.AreaCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.PhoneNumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "AreaCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4 md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Phone),
      expression: "Account.PrimaryContact.OfficeLocation.Phone"
    }],
    ref: "office_number_3",
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Phone)
    },
    on: {
      "keypress": function($event) {
        return _vm.PhoneNumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "Phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.QRDonationCode),
      expression: "Account.PrimaryContact.OfficeLocation.QRDonationCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.QRDonationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "QRDonationCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("What are your current payment processing company?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.paymentProcessingOptions), function(option, index) {
    return _c('div', {
      key: option,
      staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.PaymentProcessors.List),
        expression: "Account.PaymentProcessors.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": option,
        "checked": Array.isArray(_vm.Account.PaymentProcessors.List) ? _vm._i(_vm.Account.PaymentProcessors.List, option) > -1 : (_vm.Account.PaymentProcessors.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.PaymentProcessors.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.PaymentProcessors, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.PaymentProcessors, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.PaymentProcessors, "List", $$c)
          }
        }
      }
    }), _vm._v("\n                                    " + _vm._s(option) + "\n                                ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherPaymentProcessor),
      expression: "otherPaymentProcessor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Other",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.otherPaymentProcessor) ? _vm._i(_vm.otherPaymentProcessor, "Other") > -1 : (_vm.otherPaymentProcessor)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.otherPaymentProcessor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Other",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.otherPaymentProcessor = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.otherPaymentProcessor = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.otherPaymentProcessor = $$c
        }
      }
    }
  }), _vm._v("\n                                    Other\n                                ")])]), _vm._v(" "), (_vm.otherPaymentProcessor) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PaymentProcessors.Others),
      expression: "Account.PaymentProcessors.Others"
    }],
    staticClass: "form-control mt-2 ml-2",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "placeholder": "Please specify",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PaymentProcessors.Others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PaymentProcessors, "Others", $event.target.value)
      }
    }
  }) : _vm._e()])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Which donation solution are you interested in utilizing? (Multi-Select)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.donationSolutionOptions), function(option, index) {
    return _c('div', {
      key: option,
      staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.DonationSolutions.List),
        expression: "Account.DonationSolutions.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": option,
        "checked": Array.isArray(_vm.Account.DonationSolutions.List) ? _vm._i(_vm.Account.DonationSolutions.List, option) > -1 : (_vm.Account.DonationSolutions.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.DonationSolutions.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.DonationSolutions, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.DonationSolutions, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.DonationSolutions, "List", $$c)
          }
        }
      }
    }), _vm._v("\n                                    " + _vm._s(option) + "\n                                ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherDonationSolution),
      expression: "otherDonationSolution"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Other",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.otherDonationSolution) ? _vm._i(_vm.otherDonationSolution, "Other") > -1 : (_vm.otherDonationSolution)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.otherDonationSolution,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Other",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.otherDonationSolution = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.otherDonationSolution = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.otherDonationSolution = $$c
        }
      }
    }
  }), _vm._v("\n                                    Other\n                                ")])]), _vm._v(" "), (_vm.otherDonationSolution) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.DonationSolutions.Other),
      expression: "Account.DonationSolutions.Other"
    }],
    staticClass: "form-control mt-2 ml-2",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "placeholder": "Please specify",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.DonationSolutions.Other)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.DonationSolutions, "Other", $event.target.value)
      }
    }
  }) : _vm._e()])], 2)])]), _vm._v(" "), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContactFirstName),
      expression: "FormInputs.OfficeLocationContactFirstName"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Office Contact First Name"), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Location Contact First Name"), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.ContactFirstName),
      expression: "Account.PrimaryContact.OfficeLocation.ContactFirstName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationContactFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.ContactFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "ContactFirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationContactFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationContactFirstName))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContactLastName),
      expression: "FormInputs.OfficeLocationContactLastName"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Office Contact Last Name"), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Location Contact Last Name"), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.ContactLastName),
      expression: "Account.PrimaryContact.OfficeLocation.ContactLastName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationContactLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.ContactLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "ContactLastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationContactFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationContactLastName))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Account.PrimaryContact.IsMultiLocation) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContactRole),
      expression: "FormInputs.OfficeLocationContactRole"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Role in Business")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Role in Organization")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.ContactRole),
      expression: "Account.PrimaryContact.OfficeLocation.ContactRole"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "ContactRole", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l(((_vm.FormInputs.RoleBusiness ? _vm.RoleBusiness : _vm.RoleNonProfit)), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }), _vm._v(" "), (_vm.isInviteDoctor && _vm.Account.PrimaryContact.IsMultiLocation) ? _c('div', [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('p', {
    staticClass: "invite_desc"
  }, [_vm._v("\n                        Please enter the following information for other office locations within your business to send them an invite to create a linked portal account.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('p', {
    staticClass: "invite_desc"
  }, [_vm._v("\n                        Please enter the following information for your other chapter locations within your organization or territory to send them an invite to create a linked portal account.\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "invite_label"
  }, [_vm._v("Office Location Name*")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', {
    staticClass: "invite_label"
  }, [_vm._v("Chapter Location Name*")]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("QR Donation Code\n                        "), _c('i', {
    staticClass: "fas fa-question-circle tooltip-icon",
    staticStyle: {
      "cursor": "pointer"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v("Please enter the combination of letters and numbers exactly as shown below the QR Code on the Champions for Sight® register sign."), _c('br'), _vm._v("Make sure there are no spaces or extra characters.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "invite_label"
  }, [_vm._v("Email Address*")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01cfe1b6", module.exports)
  }
}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "UserAccount"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "g-bg-gray"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isSuccess) ? _c('div', {
    staticClass: "alert alert-success center alert-fixed"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Changes Successfully Saved!")]) : _vm._e()]), _vm._v(" "), (_vm.isLoading || _vm.isLoadingEdit) ? _c('div', {
    staticClass: "row g-pt-100"
  }, [_c('page-loader')], 1) : _c('div', {
    staticClass: "container account_info g-pt-70 g-pb-100"
  }, [_c('br', {
    attrs: {
      "id": "errorDiv"
    }
  }), _vm._v(" "), (_vm.Account.accountType != 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12 account_header btn-group account_header btn-group"
  }, [_c('span', {
    staticClass: "btn active g-bg-main  g-color-white",
    attrs: {
      "href": "#"
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.SwitchTab('account', $event)
      }
    }
  }, [_vm._v("Account & Contact")])]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": "#"
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.SwitchTab('doctors', $event)
      }
    }
  }, [_vm._v("Eye Doctors")])])])]) : _c('div', {
    staticClass: "account_header"
  }, [_c('p', {
    staticClass: "header_title"
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageShown == 'account'),
      expression: "pageShown == 'account'"
    }],
    staticClass: "row"
  }, [_c('login-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "LoginFormInputs": _vm.LoginFormInputs,
      "LoginEdit": _vm.LoginEdit,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('account-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "BusinessTypeIndividual": _vm.BusinessTypeIndividual,
      "BusinessTypeBusiness": _vm.BusinessTypeBusiness,
      "BusinessTypeNonProfit": _vm.BusinessTypeNonProfit,
      "Suffix": _vm.Suffix,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "State": _vm.State,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('location-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "State": _vm.State,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('forecasting-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('eye-doctor-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "isFormLoading": _vm.isFormLoading,
      "AccountValidationResult": _vm.AccountValidationResult,
      "NewDoctor": _vm.NewDoctor
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      },
      "refreshDoctorForm": function($event) {
        return _vm.RefreshAddDoctorForm()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('association-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "isFormLoading": _vm.isFormLoading,
      "CheckboxBusiness": _vm.CheckboxBusiness
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('communication-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  })], 1), _vm._v(" "), (_vm.Account.accountType != 1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageShown == 'doctors'),
      expression: "pageShown == 'doctors'"
    }],
    staticClass: "row"
  }, [_c('eye-doctor-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "isFormLoading": _vm.isFormLoading,
      "AccountValidationResult": _vm.AccountValidationResult,
      "NewDoctor": _vm.NewDoctor
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      },
      "refreshDoctorForm": function($event) {
        return _vm.RefreshAddDoctorForm()
      }
    }
  })], 1) : _vm._e()])])])], 1)]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0279f276", module.exports)
  }
}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OrderTracking",
    attrs: {
      "id": "OrderTracking"
    }
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "g-bg-gray"
  }, [_c('div', {
    staticClass: "container-fluid g-py-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("Track Orders & History")]), _vm._v(" "), _c('p', {
    staticClass: "text-center g-pt-40"
  }, [_vm._v("\n                              To see the full order details, please click on the E-Order #. "), _c('br'), _vm._v("To change, edit,\n                              or cancel a submitted order, please "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("click here")]), _vm._v(" to contact us.\n                          ")]), _vm._v(" "), _c('order-tracking-filters', {
    attrs: {
      "OrderList": _vm.OrderList,
      "DispenseList": _vm.DispenseList,
      "SearchObject": _vm.SearchObject,
      "PageValues": _vm.PageValues,
      "isDataLoading": _vm.isDataLoading,
      "searchValue": _vm.searchValue,
      "statusFilter": _vm.statusFilter,
      "statusString": _vm.statusString
    },
    on: {
      "search": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "reset": function($event) {
        return _vm.Reset()
      },
      "clicked": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "update:DispenseList": function($event) {
        _vm.DispenseList = $event
      },
      "update:dispense-list": function($event) {
        _vm.DispenseList = $event
      }
    }
  }), _vm._v(" "), _c('order-tracking-table', {
    attrs: {
      "SortValues": _vm.SortValues,
      "OrderList": _vm.OrderList,
      "DispenseList": _vm.DispenseList,
      "PageValues": _vm.PageValues,
      "isDataLoading": _vm.isDataLoading,
      "MasterAccountType": _vm.MasterAccountType
    },
    on: {
      "sort": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "delete": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "update:DispenseList": function($event) {
        _vm.DispenseList = $event
      },
      "update:dispense-list": function($event) {
        _vm.DispenseList = $event
      }
    }
  })], 1)])])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03d3995c", module.exports)
  }
}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Eye Doctor Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.AccountEdit.eyeDoctors), function(doctor, index) {
    return _c('span', {
      key: index,
      staticClass: "account_section_box"
    }, [(index == _vm.doctorIndex) ? _c('div', [_c('div', {
      staticClass: "row"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("NPI Number\n                                                                "), (!doctor.useLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
      attrs: {
        "data-balloon": _vm.npiTooltip,
        "data-balloon-pos": "down",
        "data-balloon-length": "large"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle-o"
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.npiNumber),
        expression: "doctor.npiNumber"
      }],
      staticClass: "form-control input_field",
      class: {
        error_field: _vm.EyeDoctorValidation.EyeDoctorNpiNumber
      },
      attrs: {
        "type": "text",
        "maxlength": "10"
      },
      domProps: {
        "value": (doctor.npiNumber)
      },
      on: {
        "keypress": function($event) {
          return _vm.G_NumberCheck(this.event)
        },
        "keyup": function($event) {
          return _vm.ValidateNpiNumberEyeDoctor(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "npiNumber", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation.EyeDoctorNpiNumber) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.EyeDoctorNpiNumber))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.useLicenseNumber),
        expression: "doctor.useLicenseNumber"
      }],
      staticClass: "form-check-input",
      attrs: {
        "value": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(doctor.useLicenseNumber) ? _vm._i(doctor.useLicenseNumber, "") > -1 : (doctor.useLicenseNumber)
      },
      on: {
        "change": [function($event) {
          var $$a = doctor.useLicenseNumber,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(doctor, "useLicenseNumber", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(doctor, "useLicenseNumber", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(doctor, "useLicenseNumber", $$c)
          }
        }, function($event) {
          return _vm.useLicenseNumberChange(index, doctor.useLicenseNumber)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Use License Number")])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Relationship*\n                                                                "), _c('span', {
      attrs: {
        "data-balloon": _vm.relationshipTooltip,
        "data-balloon-pos": "down",
        "data-balloon-length": "large"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle-o"
    })])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.role),
        expression: "doctor.role"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation.Role
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.EyeDoctorValidation.Role) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.Role))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("First Name*")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.firstName),
        expression: "doctor.firstName"
      }],
      staticClass: "form-control input_field capitalize",
      class: {
        error_field: _vm.EyeDoctorValidation.EyeDoctorFirstName
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (doctor.firstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "firstName", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation.EyeDoctorFirstName) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.EyeDoctorFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Last Name*")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.lastName),
        expression: "doctor.lastName"
      }],
      staticClass: "form-control input_field capitalize",
      class: {
        error_field: _vm.EyeDoctorValidation.EyeDoctorLastName
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (doctor.lastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "lastName", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation.EyeDoctorLastName) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.EyeDoctorLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Suffix*")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.suffix),
        expression: "doctor.suffix"
      }],
      staticClass: "form-control select_field",
      class: {
        error_field: _vm.EyeDoctorValidation.EyeDoctorSuffix
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.Suffix), function(value, key) {
      return _c('option', {
        domProps: {
          "value": key
        }
      }, [_vm._v(_vm._s(key))])
    }), 0), _vm._v(" "), (_vm.EyeDoctorValidation.EyeDoctorSuffix) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.EyeDoctorSuffix))]) : _vm._e()])])])])]), _vm._v(" "), (doctor.useLicenseNumber) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
    }, [_c('div', {
      staticClass: "row"
    }, [(!doctor.useLicenseNumber) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("License Number *")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.licenseNumber),
        expression: "doctor.licenseNumber"
      }],
      staticClass: "form-control input_field",
      class: {
        error_field: _vm.EyeDoctorValidation.EyeDoctorLicenseNumber
      },
      attrs: {
        "maxlength": "18",
        "type": "text"
      },
      domProps: {
        "value": (doctor.licenseNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "licenseNumber", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation.EyeDoctorLicenseNumber) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.EyeDoctorLicenseNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State *")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.state),
        expression: "doctor.state"
      }],
      staticClass: "form-control select_field",
      class: {
        error_field: _vm.EyeDoctorValidation.EyeDoctorState
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.State), function(value, key) {
      return _c('option', {
        domProps: {
          "value": value
        }
      }, [_vm._v(_vm._s(value))])
    }), 0), _vm._v(" "), (_vm.EyeDoctorValidation.EyeDoctorState) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.EyeDoctorState))]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Year Licensed")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.yearsInPractice),
        expression: "doctor.yearsInPractice"
      }],
      staticClass: "form-control input_field",
      domProps: {
        "value": (doctor.yearsInPractice)
      },
      on: {
        "keypress": function($event) {
          return _vm.G_NumberCheck(this.event)
        },
        "keyup": function($event) {
          return _vm.G_NumberOfYearsCheck(doctor, 'yearsInPractice')
        },
        "blur": function($event) {
          return _vm.CheckYearLicense(doctor.yearsInPractice)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "yearsInPractice", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errorMessage.year) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errorMessage.year))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Doctor's Email Address*")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.emailAddress),
        expression: "doctor.emailAddress"
      }],
      staticClass: "form-control input_field",
      class: {
        error_field: _vm.EyeDoctorValidation.EyeDoctorEmailAddress
      },
      attrs: {
        "type": "text",
        "oninput": "this.value = this.value.toLowerCase()"
      },
      domProps: {
        "value": (doctor.emailAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "emailAddress", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation.EyeDoctorEmailAddress) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation.EyeDoctorEmailAddress))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_vm._l((_vm.CheckboxIndividual), function(value, key) {
      return _c('div', {
        staticClass: "form-check"
      }, [(doctor.organizations) ? _c('p', {
        staticClass: "form-check-label"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (doctor.organizations.list),
          expression: "doctor.organizations.list"
        }],
        staticClass: "form-check-input",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": key,
          "checked": Array.isArray(doctor.organizations.list) ? _vm._i(doctor.organizations.list, key) > -1 : (doctor.organizations.list)
        },
        on: {
          "change": function($event) {
            var $$a = doctor.organizations.list,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = key,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(doctor.organizations, "list", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(doctor.organizations, "list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(doctor.organizations, "list", $$c)
            }
          }
        }
      }), _vm._v(" " + _vm._s(key) + "\n                                                                ")]) : _vm._e()])
    }), _vm._v(" "), (doctor.organizations.list.indexOf('Other') >= 0) ? _c('div', {
      staticClass: "form-group"
    }, [_c('p', [_vm._v("Please enter any other professional organizations you are associated with separated by semicolon(;).")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.organizations.others),
        expression: "doctor.organizations.others"
      }],
      staticClass: "form-control input_field",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (doctor.organizations.others)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor.organizations, "others", $event.target.value)
        }
      }
    })]) : _vm._e()], 2)])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SaveChanges()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 2), _vm._v(" "), _c('div')])])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Doctor's Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("License Number/State:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations:")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04716df0", module.exports)
  }
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.crps == 'Enrolled') ? _c('div', {
    staticClass: "alert alert-dismissible"
  }, [_c('strong', [_vm._v("Thank you for pledging to Adopt-a-School in your community! Visit the Resources Page to access our Adopt-a-School resources.")])]) : _vm._e(), _vm._v(" "), (_vm.crps == 'Declined') ? _c('div', {
    staticClass: "alert alert-dismissible"
  }, [_c('strong', [_vm._v("No problem. If you change your mind you can always learn more and pick your CLTL Day from the Resource Page.")])]) : _vm._e()])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-060de7ea", module.exports)
  }
}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-confirmation"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-py-100"
  }, [(!_vm.isDataLoading) ? _c('div', {
    staticClass: "order-confirmation row"
  }, [(_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$route.params.isSummaryOnly == '1' && _vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('h2', {}, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("Your order has been submitted successfully.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                            Please print a copy of this for your records and include a copy along with your frame if you have placed a frame-to-come order.\n                        ")])]) : (_vm.Order.orderStatus == 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("This order has an error.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                            Kindly contact the OneSight EssilorLuxottica Foundation team for more information\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.isCoveredPaymentShown) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v("The voucher provided covers the payment amount for this order")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row mx-auto"
  }, [(_vm.Order.orderStatus.toLowerCase() == 'shipped') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.MarkAsDispensed(_vm.Order.id)
      }
    }
  }, [_vm._v("Mark as Dispensed")])]) : _vm._e(), _vm._v(" "), (_vm.Order.orderStatus.toLowerCase() == 'dispensed') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.RevertDispensed(_vm.Order.id)
      }
    }
  }, [_vm._v("Not Dispensed")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.GenerateHtml()
      }
    }
  }, [_vm._v("Print Order Summary")])]), _vm._v(" "), (_vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.ReuseOrder(_vm.Order.id)
      }
    }
  }, [_vm._v("Remake/Redo Order")])]) : _vm._e(), _vm._v(" "), (_vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.ExtraPair(_vm.Order.id)
      }
    }
  }, [_vm._v("Order Extra Pair")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10 btnDisabled",
    attrs: {
      "disabled": _vm.isCancelled,
      "data-balloon": _vm.GetTooltip(_vm.isCancelled),
      "data-balloon-pos": "up"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleJotForm()
      }
    }
  }, [_vm._v("Request Cancellation")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mr-3"
  }, [(_vm.$route.params.isSummaryOnly == '1') ? _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.NewOrder()
      }
    }
  }, [_vm._v("Place New Order")]) : _vm._e()])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_vm._m(1)]) : (_vm.Order.jobTypeDescription == 'Uncut') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('p', [_vm._v("\n                            For this order, there is no need to send anything to the lab. Your uncut lens will be mailed to the address below once completed\n                        ")])]) : _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('p', [_vm._v("\n                            For this order, there is no need to send anything to the lab. Keep your sample frame and the complete pair of glasses will be mailed to the address below once completed.\n                        ")])]), _vm._v(" "), (_vm.Order.jobTypeDescription != 'Frame to Come') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [(_vm.Order.orderLab) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center box-div"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet))]), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('span', [_c('br'), _vm._v(_vm._s("ATTN: Frame-to-Come"))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingCity) + ", " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Phone: " + _vm._s("(866) 385-0447"))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters",
    staticStyle: {
      "background-color": "yellow"
    }
  }, [(_vm.Order.orderLab) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center box-div"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet))]), _vm._v(" "), (_vm.Order.jobTypeDescription == 'Frame to Come') ? _c('span', [_c('br'), _vm._v(_vm._s("ATTN: Frame-to-Come"))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Order.orderLab.shippingCity) + ", " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Phone: " + _vm._s("(866) 385-0447"))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Participant Name:")]), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName) + " " + _vm._s(_vm.Account.primaryContact.suffix))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.shippingFullName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingAddressLineOne))]), _vm._v(" "), (_vm.shippingAddressLineTwo = null) ? _c('span', [_c('br'), _vm._v(_vm._s(_vm.shippingAddressLineTwo))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shippingCity) + ", " + _vm._s(_vm.shippingState) + " " + _vm._s(_vm.shippingPostalCode))]), _c('br'), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('vue-barcode', {
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Patient:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.patFirstName) + " " + _vm._s(_vm.Order.patLastName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("E-Order #:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Order Reference/PO:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Submitted:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Right")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reAdd))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reDistPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.distancePD))])]), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reNearPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.nearPD))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Left")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leAdd))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leNearPD))]) : _vm._e()])]), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('thead', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Right")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reHorizontalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reHorizontalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reVerticalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reVerticalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reocHeight))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Left")]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leHorizontalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leHorizontalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leVerticalPrismValue))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leVerticalPrismDirection))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leocHeight))]), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  }), _vm._v(" "), _c('td', {
    staticClass: "order-confimation-description"
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.lensTypeDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.lensDesignDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.jobTypeDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.lensMaterialDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, _vm._l((_vm.Order.lensTreatmentDescription), function(lt) {
    return _c('span', {
      staticClass: "order-confimation-description"
    }, [_vm._v(_vm._s(lt) + ",")])
  }), 0)])]), _vm._v(" "), (_vm.Order.isSpecialOrderNecessary) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.specialInstructions1))])])])]) : _vm._e(), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameManufacturer))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameTypeDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameBrand))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameColor))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameModel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameEyeSize))])]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 border-box"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.frameTempleLength))])])])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 border-box min-height-dispenser-notes"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_vm._m(22)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('jotform-modal', {
    attrs: {
      "Account": _vm.Account,
      "formID": 221084120731038
    },
    on: {
      "closeJotForm": _vm.ToggleJotForm
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markDispenseModal),
      expression: "markDispenseModal"
    }]
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content g-mt-170"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Mark as Dispensed")]), _vm._v(" "), _c('div', {
    staticClass: "row g-my-20 g-mx-20 "
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15"
  }, [_c('label', [_vm._v("Enter Dispense Date:")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDataLoading,
      "bootstrap-styling": true,
      "format": _vm.format,
      "name": "uniquename",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar"
    },
    model: {
      value: (_vm.dateDispense),
      callback: function($$v) {
        _vm.dateDispense = $$v
      },
      expression: "dateDispense"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-info--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.SaveMarkForDispense(_vm.Order.id)
      }
    }
  }, [_vm._v("Mark Dispensed")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15",
    on: {
      "click": function($event) {
        _vm.markDispenseModal = false;
      }
    }
  }, [_vm._v("Cancel")])])])])])])])])]), _vm._v(" "), (_vm.isDataLoading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('page-loader')], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isServicePaymentShown) ? _c('service-payment', {
    attrs: {
      "Account": _vm.Account,
      "Order": _vm.Order
    },
    on: {
      "close": function($event) {
        _vm.isServicePaymentShown = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Lab Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                            Please send your frame along with the lab copy of the Order Summary to this lab as soon as possible. If the frame has not been received within 2 weeks, the order will be cancelled.\n                            "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Please pay careful attention to the lab address. Frames shipped to the wrong lab will be drastically delayed or lost.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                          Participant and Order Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Shipping Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Lens and Prescription Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Sphere")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Cylinder")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Axis")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Addition")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Seg. Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Dist. PD")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Near PD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Horizontal Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Base")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Vertical Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("Base")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }, [_vm._v("OC Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  }), _vm._v(" "), _c('th', {
    staticClass: "order-confimation-label order-bg-blue"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Lens Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Lens Design")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Order Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Lens Material")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Treatment(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Special Instructions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Frame Information\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Manufacturer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Frame Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Brand")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Name/Model")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Eye Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Temple")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n                            Patient/Order Notes\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                            Order requested is not valid.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('small', [_vm._v("This will mark this order as dispensed. This cannot be undone in bulk, but individual orders can be marked as Not Dispensed on the Order Confirmation page.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0689b8c3", module.exports)
  }
}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general-information row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), (_vm.Order.RequiredClinicEvent == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    class: {
      'spinner-disabled': (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3')
    }
  }, [_c('label', [_vm._v("Clinic/Event")]), (_vm.Order.RequiredClinicEvent == true) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClinicEvent),
      expression: "ClinicEvent"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderClinicEvent
    },
    attrs: {
      "name": "clinic",
      "disabled": (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3')
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ClinicEvent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.ClinicEventChangedEvent]
    }
  }, [(_vm.ClinicEventList.length == 0) ? _c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("No clinic/event to select..")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ClinicEventList), function(item, index) {
    return _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.name || item.clinic_Name__c))])
  })], 2), _vm._v(" "), (_vm.ValidationResult.OrderClinicEvent) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderClinicEvent))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.RequiredClinicEvent == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    class: {
      'spinner-disabled': _vm.disable_SchoolOrganization || (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3')
    }
  }, [_c('label', [_vm._v("School/Organization")]), (_vm.Order.RequiredClinicEvent == true) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (!_vm.isUpdateCacheAndRefreshLoading && (!(_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3'))) ? _c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.UpdateCacheAndRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e(), _vm._v(" "), (_vm.isUpdateCacheAndRefreshLoading) ? _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": _vm.pageLoader_img,
      "height": "30px",
      "width": "30px"
    }
  }) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SchoolOrganization),
      expression: "SchoolOrganization"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderSchoolOrganization
    },
    attrs: {
      "disabled": _vm.disable_SchoolOrganization || (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3'),
      "name": "Organization"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SchoolOrganization = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.UpdateOrder()
      }]
    }
  }, _vm._l((_vm.SchoolOrganizationList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.school_Organization_Name__c))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderSchoolOrganization) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderSchoolOrganization))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType != 1 && _vm.accountType != 'Individual') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Prescribing Doctor*")]), _vm._v(" "), _c('multiselect', {
    class: {
      error_field: _vm.ValidationResult.OrderEyeDoctorId
    },
    attrs: {
      "label": "eyeDoctorFullName",
      "options": _vm.Account.eyeDoctors,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "close": function($event) {
        return _vm.SetPrescribingDoctorID(_vm.Order.PrescribingDoctorObject.salesforceId)
      }
    },
    model: {
      value: (_vm.Order.PrescribingDoctorObject),
      callback: function($$v) {
        _vm.$set(_vm.Order, "PrescribingDoctorObject", $$v)
      },
      expression: "Order.PrescribingDoctorObject"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderEyeDoctorId) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderEyeDoctorId))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 g-pt-30--md g-pt-0"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mt-3 g-mx-20",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Add a Doctor\n                    "), _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Patient First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatFirstName),
      expression: "Order.PatFirstName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderPatFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.PatFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "PatFirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderPatFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderPatFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Patient Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatLastName),
      expression: "Order.PatLastName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderPatLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.PatLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "PatLastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderPatLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderPatLastName))]) : _vm._e()])]), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Student ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.StudentID),
      expression: "Order.StudentID"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.StudentID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "StudentID", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Teacher/Room Number/Grade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.TeacherRoomNum),
      expression: "Order.TeacherRoomNum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.TeacherRoomNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "TeacherRoomNum", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-bottom"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Referral Organization*")]), _vm._v(" "), _c('p', [_vm._v("If this patient was referred, please select the primary referral organization. If there was no referral organization involved, please select \"Not Applicable\".\n                    ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReferralObject),
      expression: "ReferralObject"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderReferralOrg
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ReferralObject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.CheckVouchers()
      }]
    }
  }, _vm._l((_vm.VoucherList), function(vl, index) {
    return _c('option', {
      domProps: {
        "value": vl
      }
    }, [_vm._v(_vm._s(vl.name))])
  }), 0), _vm._v(" "), _c('small', [_vm._v("By selecting or indicating a Referral Organization for this order, you hereby consent to the disclosure to such Referral Organization of the prescribing doctor's information including, without limitation, to name and number of orders placed and warrant that you are authorized to provide such consent. ")]), _vm._v(" "), (_vm.ValidationResult.OrderReferralOrg) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderReferralOrg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isVoucherShown) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12",
    class: {
      'col-md-12 col-lg-12': !(_vm.Order.ReferralOrg == 'Other'), 'col-md-6 col-lg-6': _vm.Order.ReferralOrg == 'Other'
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Referral Voucher Number/Code\n                            "), (_vm.isReferralCodeRequired) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.isVoucherCodeValid) ? _c('span', [_c('i', {
    staticClass: "fa fa-check-circle check_icon"
  })]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReferralCode),
      expression: "Order.ReferralCode"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderReferralCode, error_field: _vm.voucherValidation.OrderReferralCode
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ReferralCode)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateVoucherCode(_vm.Order.ReferralCode)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReferralCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderReferralCode || _vm.voucherValidation.OrderReferralCode) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderReferralCode) + _vm._s(_vm.voucherValidation.OrderReferralCode))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ReferralOrg == 'Other') ? _c('div', {
    staticClass: " col-sm-12 col-xs-12",
    class: {
      'col-md-12 col-lg-12': !_vm.isVoucherShown, 'col-md-6 col-lg-6': _vm.isVoucherShown
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Referral Organization\n                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.OtherReferral),
      expression: "Order.OtherReferral"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.OtherReferral)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "OtherReferral", $event.target.value)
      }
    }
  })])]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.Order.IsRemakeRedo) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check  order-div"
  }, [_c('span', {
    attrs: {
      "hidden": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsRemakeRedo),
      expression: "Order.IsRemakeRedo"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsRemakeRedo) ? _vm._i(_vm.Order.IsRemakeRedo, null) > -1 : (_vm.Order.IsRemakeRedo)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsRemakeRedo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsRemakeRedo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsRemakeRedo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsRemakeRedo", $$c)
        }
      }, function($event) {
        return _vm.RamakeRedoCheck(_vm.Order.IsRemakeRedo)
      }]
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "IsRemakeRedo"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('label', [_vm._v("*Remake Reason:")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticClass: "radio-inline radio_btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoReason),
      expression: "Order.RemakeRedoReason"
    }],
    attrs: {
      "type": "radio",
      "checked": "checked",
      "name": "IsLabErrorRedo",
      "value": "OTH-LABREDO"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.RemakeRedoReason, "OTH-LABREDO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "RemakeRedoReason", "OTH-LABREDO")
      }
    }
  }), _vm._v(" Lab Error")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline radio_btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoReason),
      expression: "Order.RemakeRedoReason"
    }],
    attrs: {
      "type": "radio",
      "name": "IsOrderEntryRedo",
      "value": "OTH-OPTERROR"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.RemakeRedoReason, "OTH-OPTERROR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "RemakeRedoReason", "OTH-OPTERROR")
      }
    }
  }), _vm._v(" Order Entry Error")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline radio_btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoReason),
      expression: "Order.RemakeRedoReason"
    }],
    attrs: {
      "type": "radio",
      "name": "IsRxChangeRedo",
      "value": "OTH-OPENSOFT"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.RemakeRedoReason, "OTH-OPENSOFT")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "RemakeRedoReason", "OTH-OPENSOFT")
      }
    }
  }), _vm._v(" Rx Change")])]), _vm._v(" "), (_vm.ValidationResult.OrderRemakeRedoReason) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRemakeRedoReason))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Remake Comments:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoComments),
      expression: "Order.RemakeRedoComments"
    }],
    staticClass: "form-control",
    attrs: {
      "required": _vm.Order.IsRemakeRedo,
      "maxlength": 225,
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.RemakeRedoComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "RemakeRedoComments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRemakeRedoComments) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRemakeRedoComments))]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-8 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('Label', [_vm._v("Select all that apply")]), _vm._v(" (Optional)\n              "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsExamOnly),
      expression: "Order.IsExamOnly"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.Order.IsExtra == true
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsExamOnly) ? _vm._i(_vm.Order.IsExamOnly, null) > -1 : (_vm.Order.IsExamOnly)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsExamOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsExamOnly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsExamOnly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsExamOnly", $$c)
        }
      }, function($event) {
        return _vm.ClearFirstTimeGlasses(_vm.Order.IsExamOnly)
      }]
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsReferredForEval),
      expression: "Order.IsReferredForEval"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.Order.IsExtra == true
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsReferredForEval) ? _vm._i(_vm.Order.IsReferredForEval, null) > -1 : (_vm.Order.IsReferredForEval)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsReferredForEval,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsReferredForEval", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsReferredForEval", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsReferredForEval", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Referred for Further Evaluation")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', [(_vm.Order.IsReferredForEval) ? _c('div', {
    staticClass: "form-group order-div"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Amblyopia f/u",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _vm._m(7)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Strabismus f/u",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _vm._m(8)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Dilated eye health exam",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Dilated eye health exam")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Cycloplegic refraction",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Cycloplegic refraction")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Vision check after wearing new glasses",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Vision check after wearing new glasses")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Vision Therapy",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Vision Therapy")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Other",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Other")])], 1)]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReferralNotes),
      expression: "Order.ReferralNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ReferralNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReferralNotes", $event.target.value)
      }
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsInternationalMission),
      expression: "Order.IsInternationalMission"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsInternationalMission) ? _vm._i(_vm.Order.IsInternationalMission, null) > -1 : (_vm.Order.IsInternationalMission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsInternationalMission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsInternationalMission", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsInternationalMission", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsInternationalMission", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.down",
      value: ({
        html: 'tooltipContentInternational',
        class: 'custom-tooltip'
      }),
      expression: "{ html: 'tooltipContentInternational', class: 'custom-tooltip' }",
      modifiers: {
        "down": true
      }
    }]
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o",
    staticStyle: {
      "cursor": "pointer"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tooltipContentInternational"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.internationalMissionTooltip)
    }
  })])]), _vm._v(" "), (_vm.Order.IsExtra) ? _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsExtra),
      expression: "Order.IsExtra"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsExtra) ? _vm._i(_vm.Order.IsExtra, null) > -1 : (_vm.Order.IsExtra)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsExtra,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsExtra", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsExtra", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsExtra", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('label', [_vm._v("Order Reference/PO")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReferenceNoPo),
      expression: "Order.ReferenceNoPo"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": 15,
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ReferenceNoPo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReferenceNoPo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row g-mt-20 g-mx-20"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-7 col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("NPI Number\n                                                    "), (!_vm.Doctor.UseLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.NpiNumber),
      expression: "Doctor.NpiNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorNpiNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.Doctor.NpiNumber)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.ValidateNpiNumberNewDoctor()
      },
      "change": function($event) {
        return _vm.changedNPINumber()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "NpiNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorNpiNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-7 col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Relationship*\n                                                "), _c('span', {
    attrs: {
      "data-balloon": _vm.relationshipTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.Role),
      expression: "Doctor.Role"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorRole
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Doctor, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorRole) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorRole))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.Doctor.UseLicenseNumber) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), (_vm.Doctor.UseLicenseNumber) ? _c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-7 col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("License Number *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.LicenseNumber),
      expression: "Doctor.LicenseNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorLicenseNumber
    },
    attrs: {
      "maxlength": "18",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Doctor.LicenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "LicenseNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorLicenseNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorLicenseNumber))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Doctor.UseLicenseNumber) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.State),
      expression: "Doctor.State"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorState
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Doctor, "State", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorState))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useLicenseNumber),
      expression: "useLicenseNumber"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useLicenseNumber) ? _vm._i(_vm.useLicenseNumber, null) > -1 : (_vm.useLicenseNumber)
    },
    on: {
      "click": function($event) {
        return _vm.iDontHaveNPINumber()
      },
      "change": function($event) {
        var $$a = _vm.useLicenseNumber,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useLicenseNumber = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useLicenseNumber = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useLicenseNumber = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("I don't have an NPI Number")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.FirstName),
      expression: "Doctor.FirstName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Doctor.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.LastName),
      expression: "Doctor.LastName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Doctor.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suffix*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.Suffix),
      expression: "Doctor.Suffix"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorSuffix
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Doctor, "Suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.Suffix), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorSuffix) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorSuffix))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.EmailAddress),
      expression: "Doctor.EmailAddress"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorEmailAddress
    },
    attrs: {
      "type": "text",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.Doctor.EmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "EmailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorEmailAddress))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    attrs: {
      "data-balloon": "This doctor’s information will only be used for this order and will not be saved to your account for future use",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    },
    on: {
      "click": function($event) {
        return _vm.AddDoctorForThisJobOnly()
      }
    }
  }, [_vm._v("Use for this job only")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    attrs: {
      "data-balloon": "This doctor’s information will be used for this order and will be saved to your account.  It will be available in the “Prescribing Doctor” drop down field",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    },
    on: {
      "click": function($event) {
        return _vm.AddDoctorAndUseNow()
      }
    }
  }, [_vm._v("Save and use now")])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n      General Information\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Remake/Redo "), _c('small', [_vm._v("(Due to error – i.e. order entry/lab error)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Select this box when submitting a remake or redo order.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Exam Only "), _c('small', [_vm._v("(Patient not issued a prescription)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Referral Reason(s)*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Amblyopia f/u "), _c('small', [_vm._v("(aka Lazy Eye)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Strabismus f/u "), _c('small', [_vm._v("(aka Crossed Eyes)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Referral Notes:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "font-order"
  }, [_vm._v("International Mission "), _c('small', [_vm._v("(One-Time Support shipped to domestic participant)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Extra Pair "), _c('small', [_vm._v("(Back up pair for patient with high Rx) ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "The text in this optional field will be printed on the lab ticket with the completed job and may be used for your internal tracking/sorting purposes. (i.e. School/Event Name, Patient ID, etc)",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0733c9a4", module.exports)
  }
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v("Resources")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-font-size-20--md g-font-size-17 g-color-primary--hover g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-076ab74c", module.exports)
  }
}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center",
    staticStyle: {
      "height": "450px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.pageLoader_img
    }
  }), _vm._v(" "), _c('p', [_vm._v("Loading... Please Wait")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-097d9790", module.exports)
  }
}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Account Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountEdit.evfAccountNumber))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactLegalName),
      expression: "FormInputs.ContactLegalName"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Business/Practice Name:")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Organization Name:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountEdit.primaryContact.legalName))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.FormInputs.BusinessLabels || _vm.FormInputs.NonProfitLabels) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactFirstName),
      expression: "FormInputs.ContactFirstName"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.firstName),
      expression: "AccountEdit.primaryContact.firstName"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactLastName),
      expression: "FormInputs.ContactLastName"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.lastName),
      expression: "AccountEdit.primaryContact.lastName"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-5 col-sm-6 col-xs-6"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactSuffix),
      expression: "FormInputs.ContactSuffix"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suffix*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.suffix),
      expression: "AccountEdit.primaryContact.suffix"
    }],
    staticClass: "form-control select_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactSuffix
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.AccountEdit.primaryContact, "suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.Suffix), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.ContactValidationResult.ContactSuffix) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactSuffix))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-12 col-sm-12 col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactPhoneNumber),
      expression: "FormInputs.ContactPhoneNumber"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone Number*")]), _vm._v(" "), _c('div', {
    staticClass: "row div-phone"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.countryCode),
      expression: "AccountEdit.primaryContact.countryCode"
    }],
    ref: "participant_number_1",
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.countryCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "countryCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.areaCode),
      expression: "AccountEdit.primaryContact.areaCode"
    }],
    ref: "participant_number_2",
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.areaCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "areaCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4 md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.phone),
      expression: "AccountEdit.primaryContact.phone"
    }],
    ref: "participant_number_3",
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.phone)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.ContactValidationResult.ContactPhoneNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactPhoneNumber))]) : _vm._e()])])]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [((_vm.AccountEdit.primaryContact.suffix == 'N/A' || _vm.AccountEdit.primaryContact.suffix == '')) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountEdit.primaryContact.firstName + " " + _vm.AccountEdit.primaryContact.lastName))]) : _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountEdit.primaryContact.firstName + " " + _vm.AccountEdit.primaryContact.lastName + ", " + _vm.AccountEdit.primaryContact.suffix))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-12 col-sm-12 col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactPhoneNumber),
      expression: "FormInputs.ContactPhoneNumber"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone Number*")]), _vm._v(" "), _c('div', {
    staticClass: "row div-phone"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.countryCode),
      expression: "AccountEdit.primaryContact.countryCode"
    }],
    ref: "participant_number_1",
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.countryCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "countryCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.areaCode),
      expression: "AccountEdit.primaryContact.areaCode"
    }],
    ref: "participant_number_2",
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.areaCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "areaCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4 md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.phone),
      expression: "AccountEdit.primaryContact.phone"
    }],
    ref: "participant_number_3",
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.phone)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.ContactValidationResult.ContactPhoneNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactPhoneNumber))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactRole),
      expression: "FormInputs.ContactRole"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Role in Business")]) : _c('label', [_vm._v("Role in Organization")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.title),
      expression: "AccountEdit.primaryContact.title"
    }],
    staticClass: "form-control select_field",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.AccountEdit.primaryContact, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l(((_vm.FormInputs.RoleBusiness ? _vm.RoleBusiness : _vm.RoleNonProfit)), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactBusinessType),
      expression: "FormInputs.ContactBusinessType"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.IndividualLabels || _vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Business Type "), _c('span', {
    attrs: {
      "data-balloon": _vm.businessTypeTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]) : _c('label', [_vm._v("Organization Type "), _c('span', {
    attrs: {
      "data-balloon": _vm.organizationTypeTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.businessType),
      expression: "AccountEdit.primaryContact.businessType"
    }],
    staticClass: "form-control select_field",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.AccountEdit.primaryContact, "businessType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l(((_vm.FormInputs.BusinessTypeIndividual ? _vm.BusinessTypeIndividual : (_vm.FormInputs.BusinessTypeBusiness ? _vm.BusinessTypeBusiness : _vm.BusinessTypeNonProfit))), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Account ID:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Primary Contact:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Participant Name:")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a453aed", module.exports)
  }
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n        Username and Password\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12",
    attrs: {
      "id": "AccountEmailAddress"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountEmailAddress),
      expression: "FormInputs.AccountEmailAddress"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.EmailAddress),
      expression: "Account.EmailAddress"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountEmailAddress
    },
    attrs: {
      "type": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.Account.EmailAddress)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "EmailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountEmailAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountEmailAddressConfirm),
      expression: "FormInputs.AccountEmailAddressConfirm"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Confirm Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.EmailAddressConfirm),
      expression: "Account.EmailAddressConfirm"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountEmailAddressConfirm
    },
    attrs: {
      "type": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.Account.EmailAddressConfirm)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateConfirmEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "EmailAddressConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountEmailAddressConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountEmailAddressConfirm))]) : _vm._e()])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountPassword),
      expression: "FormInputs.AccountPassword"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Password),
      expression: "Account.Password"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountPassword, error_field2: _vm.hasPasswordError
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.Account.Password)
    },
    on: {
      "keyup": function($event) {
        _vm.CheckPasswordDigits();
        _vm.CheckMatchPassword()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "Password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountPassword))]) : (_vm.hasPasswordError && !_vm.AccountValidationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasPasswordErrorMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountPasswordConfirm),
      expression: "FormInputs.AccountPasswordConfirm"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Confirm Password*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PasswordConfirm),
      expression: "Account.PasswordConfirm"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountPasswordConfirm, error_field2: _vm.hasConfirmPasswordError
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.Account.PasswordConfirm)
    },
    on: {
      "keyup": function($event) {
        _vm.CheckConfirmPasswordDigits();
        _vm.CheckMatchPassword()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "PasswordConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountPasswordConfirm))]) : _vm._e(), _vm._v(" "), (_vm.hasConfirmPasswordError && !_vm.AccountValidationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasConfirmPasswordErrorMessage))]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', [_vm._v("This email address will be used to log in to your account as well as receive general program and order communications.")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b41bdb4", module.exports)
  }
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content modal-width"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 right"
  }, [_c('button', {
    staticClass: "order-form-button",
    on: {
      "click": function($event) {
        return _vm.Agree()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "order-form-button",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("No")])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b62ec9a", module.exports)
  }
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "table-responsive-md",
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table track-table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "g-color-white g-bg-main th-bordered"
  }, [_vm._v("Select ")]), _vm._v(" "), _c('th', {
    staticClass: "g-color-white g-bg-main th-bordered"
  }, [_vm._v("E-Order# ")]), _vm._v(" "), (_vm.MasterAccountType == 'master' && _vm.isLastNameDesc) ? _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('lastName', 0)
      }
    }
  }, [_vm._v("Participant Name "), _vm._m(0)]) : (_vm.MasterAccountType == 'master' && !_vm.isLastNameDesc) ? _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('lastName', 1)
      }
    }
  }, [_vm._v("Participant Name "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.isSubmittedDesc) ? _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('dateSubmitted', 0)
      }
    }
  }, [_vm._v("Submitted "), _vm._m(2)]) : _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('dateSubmitted', 1)
      }
    }
  }, [_vm._v("Submitted "), _vm._m(3)]), _vm._v(" "), (!_vm.isPatientNameDesc) ? _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('patLastName', 0)
      }
    }
  }, [_vm._v("Patient Name (Last, First) "), _vm._m(4)]) : _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.Sort('patLastName', 1)
      }
    }
  }, [_vm._v("Patient Name (Last, First) "), _vm._m(5)]), _vm._v(" "), (!_vm.isOrderStatusDesc) ? _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('orderStatus', 0)
      }
    }
  }, [_vm._v("Order Status/Last Update "), _vm._m(6)]) : _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('orderStatus', 1)
      }
    }
  }, [_vm._v("Order Status/Last Update "), _vm._m(7)]), _vm._v(" "), (!_vm.isLabAssignmentDesc) ? _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('orderLab', 0)
      }
    }
  }, [_vm._v("Lab Assignment "), _vm._m(8), _vm._m(9)]) : _c('th', {
    staticClass: "g-color-white g-bg-main g-bg-main-blue--hover th-bordered",
    on: {
      "click": function($event) {
        return _vm.Sort('orderLab', 1)
      }
    }
  }, [_vm._v("Lab Assignment "), _vm._m(10), _vm._m(11)])])]), _vm._v(" "), _c('tbody', [(_vm.isDataLoading) ? _c('tr', {
    staticClass: "center"
  }, [(_vm.MasterAccountType == 'master') ? _c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.OrderList), function(order, index) {
    return (!_vm.isDataLoading && _vm.OrderList.length > 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('div', {
      staticClass: "btn-group",
      attrs: {
        "data-toggle": "buttons"
      }
    }, [_c('label', {
      staticClass: "active"
    }, [_c('input', {
      staticStyle: {
        "transform": "scale(1.3)"
      },
      attrs: {
        "type": "checkbox",
        "name": "",
        "id": "",
        "autocomplete": "off"
      },
      on: {
        "change": function($event) {
          return _vm.AddToDispense($event.target.checked, index, order.orderNumber, order.orderStatus)
        }
      }
    })])])]), _vm._v(" "), (order.orderStatus != 'Pending' && order.orderStatus != 'Pending Approval' && order.orderStatus != 'Pending - Error' && order.orderStatus != 'Exam Only') ? _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.ViewOrder(order.id)
        }
      }
    }, [_vm._v(_vm._s(order.orderNumber))])]) : (order.orderStatus == 'Exam Only') ? _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.ViewExam(order.id)
        }
      }
    }, [_vm._v("View")])]) : (order.orderStatus == 'Pending Approval' && _vm.MasterAccountType == 'master') ? _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.EditOrder(order.id)
        }
      }
    }, [_vm._v("EDIT")]), _vm._v(" / "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.ShowDeleteModal(order.id)
        }
      }
    }, [_vm._v("DELETE")])]) : (order.orderStatus == 'Pending Approval') ? _c('td') : (order.orderStatus == 'Error') ? _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.ViewOrder(order.id)
        }
      }
    }, [_vm._v(_vm._s(order.id))])]) : _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.EditOrder(order.id)
        }
      }
    }, [_vm._v("EDIT")]), _vm._v(" / "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.ShowDeleteModal(order.id)
        }
      }
    }, [_vm._v("DELETE")])]), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('td', [_vm._v(_vm._s(order.accountDetails.primaryContact.lastName) + ", " + _vm._s(order.accountDetails.primaryContact.firstName))]) : _vm._e(), _vm._v(" "), (order.orderStatus != 'Pending' && order.orderStatus != 'Pending Approval' && order.orderStatus != 'Error' && order.orderStatus != 'Pending - Error') ? _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(order.dateSubmitted)))]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.patLastName) + ", " + _vm._s(order.patFirstName))]), _vm._v(" "), (order.visionWebOrderStatus == null) ? _c('td', {
      staticClass: "center"
    }, [_vm._v(_vm._s(order.orderStatus) + " "), _c('br'), _vm._v(_vm._s(_vm.FormatDateToLocal(order.dateSubmitted)))]) : (order.orderStatus == 'Pending - Error') ? _c('td', {
      staticClass: "center"
    }, [_vm._v(_vm._s(order.orderStatus) + " "), _c('br'), _vm._v(_vm._s(_vm.FormatDateToLocal(order.dateSubmitted)))]) : _c('td', {
      staticClass: "center"
    }, [_vm._v(_vm._s(order.orderStatus) + " "), _c('br'), _vm._v(" "), (order.dateUpdated) ? _c('span', [_vm._v(_vm._s(_vm.FormatDateToLocal(order.dateUpdated)))]) : _vm._e(), _vm._v(" "), (order.dateUpdated == null) ? _c('span', [_vm._v(_vm._s(_vm.FormatDateToLocal(order.dateSubmitted)))]) : _vm._e()]), _vm._v(" "), (order.orderStatus != 'Pending' && order.orderStatus != 'Pending Approval' && order.orderStatus != 'Pending - Error' && order.orderStatus != 'Exam Only') ? _c('td', {
      attrs: {
        "data-balloon": order.orderLab.name + ' | ' + _vm.IsEmpty(order.orderLab.shippingStreet) + ' ' + _vm.IsEmpty(order.orderLab.shippingCity) + ' ' + _vm.IsEmpty(order.orderLab.shippingStateCode) + ' ' + _vm.IsEmpty(order.orderLab.shippingPostalCode),
        "data-balloon-pos": "left"
      }
    }, [_vm._v(_vm._s(order.orderLab.name))]) : _c('td')]) : _vm._e()
  }), _vm._v(" "), (!_vm.isDataLoading && _vm.OrderList.length == 0 && _vm.MasterAccountType == 'master') ? _c('tr', [_c('td', {
    staticClass: "center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No results found")])]) : _vm._e(), _vm._v(" "), (!_vm.isDataLoading && _vm.OrderList.length == 0 && _vm.MasterAccountType != 'master') ? _c('tr', [_c('td', {
    staticClass: "center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No results found")])]) : _vm._e()], 2)])])]), _vm._v(" "), (_vm.isStatusModalShown) ? _c('order-tracking-vision-web-status', {
    attrs: {
      "orderNumber": _vm.currentOrderNumber,
      "visionWebOrderStatus": _vm.currentVisionWebStatus,
      "dateSubmitted": _vm.currentDateSubmitted
    },
    on: {
      "close": function($event) {
        return _vm.CloseVisionWebStatus()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDeleteModelShown) ? _c('prompt-component', {
    attrs: {
      "message": _vm.promptMessage
    },
    on: {
      "close": function($event) {
        return _vm.CloseDeleteModal()
      },
      "onAgree": function($event) {
        return _vm.DeleteOrder()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-rotate-180"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-rotate-180"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-rotate-180"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-rotate-180"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "z-index": "99999"
    },
    attrs: {
      "data-balloon": "Hovering or clicking the name of the lab will display the lab address and customer service phone number (if available)",
      "data-balloon-pos": "down",
      "data-balloon-length": "medium"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-rotate-180"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "z-index": "99999"
    },
    attrs: {
      "data-balloon": "Hovering or clicking the name of the lab will display the lab address and customer service phone number (if available)",
      "data-balloon-pos": "down",
      "data-balloon-length": "medium"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-153530d4", module.exports)
  }
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "page-title"
  }, [_vm._v("Order Saved as Pending")]), _vm._v(" "), _c('div', {
    staticClass: "g-my-20"
  }, [_c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n            Your order has been saved as a pending order. To continue to edit this order,\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v("go to the Track Order page.")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15fe8fb8", module.exports)
  }
}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.Associations),
      expression: "FormInputs.Associations"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Professional Association Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [(_vm.AccountView.organizations) ? _c('ul', {
    staticClass: "association_info"
  }, [_vm._l((_vm.AccountView.organizations.list), function(value, key) {
    return (value != 'Other') ? _c('li', [_vm._v(_vm._s(value))]) : _vm._e()
  }), _vm._v(" "), (_vm.AccountView.organizations.others) ? _c('li', [_vm._v(_vm._s(_vm.AccountView.organizations.others))]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.EditSection()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('edit-association-info', {
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "CheckboxBusiness": _vm.CheckboxBusiness
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.SaveAccount()
      }
    }
  }, [_vm._v("Save ")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-187f364b", module.exports)
  }
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Communication and Contract Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Account Communication Preferences")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.toBeContactedAsVolunteer),
      expression: "AccountEdit.toBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountEdit.toBeContactedAsVolunteer) ? _vm._i(_vm.AccountEdit.toBeContactedAsVolunteer, null) > -1 : (_vm.AccountEdit.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountEdit.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountEdit, "toBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountEdit, "toBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountEdit, "toBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like to be contacted if there are volunteer opportunities in my area.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.toReceiveNewsLetter),
      expression: "AccountEdit.toReceiveNewsLetter"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountEdit.toReceiveNewsLetter) ? _vm._i(_vm.AccountEdit.toReceiveNewsLetter, null) > -1 : (_vm.AccountEdit.toReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountEdit.toReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountEdit, "toReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountEdit, "toReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountEdit, "toReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like email updates from OneSight EssilorLuxottica Foundation.")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Program Contract")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_c('a', {
    staticClass: "g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isContractLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v("\n          to download a copy of your contract.")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1956dc16", module.exports)
  }
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Professional Association Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_vm._l((_vm.CheckboxBusiness), function(value, key) {
    return (_vm.FormInputs.BusinessOrganization) ? _c('div', {
      staticClass: "form-check"
    }, [(_vm.AccountEdit.organizations) ? _c('span', {
      staticClass: "form-check-label account_p"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.AccountEdit.organizations.list),
        expression: "AccountEdit.organizations.list"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.AccountEdit.organizations.list) ? _vm._i(_vm.AccountEdit.organizations.list, key) > -1 : (_vm.AccountEdit.organizations.list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.AccountEdit.organizations.list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.AccountEdit.organizations, "list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.AccountEdit.organizations, "list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.AccountEdit.organizations, "list", $$c)
          }
        }
      }
    }), _vm._v("\n                  " + _vm._s(key) + "\n              ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.AccountEdit.organizations.list.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "account_p"
  }, [_vm._v("Please enter any other professional organizations you are associated with separated by semicolon(;).")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.organizations.others),
      expression: "AccountEdit.organizations.others"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.organizations.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.organizations, "others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cacbc41", module.exports)
  }
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bg-main-light-v2"
  }, [_c('div', {
    staticClass: "container g-py-20"
  }, [_c('carousel', {
    staticClass: "js-carousel",
    attrs: {
      "perPageCustom": [
        [280, 1],
        [768, 1]
      ],
      "autoplay": true,
      "loop": true,
      "autoplayTimeout": 10000,
      "data-pagi-classes": "u-carousel-indicators-v35--white g-pos-rel text-center"
    }
  }, [_c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("Simply put, the program has significantly expanded our ability to serve the underserved with the gift of sight.  I can not overstate how critical this is to those suffering in our community.\r\n                        "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4  g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Rupert C. Chowins, O.D.")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Eye Clinic Director, SLO Noor Free Clinic")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("A friend (also an OD) and I have been using your program to provide glasses to the homeless in Philadelphia. We have felt drawn to help this population on a pro bono basis for a long time and now we can provide them with no cost quality vision correction!  Many times, those who are materially poor do not have many choices, so it is wonderful to have such a terrific selection of stylish and quality frames to offer them. They were so pleased and excited!\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Christine Chmielewski, O.D.")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("For almost 15 years, we have been setting aside four exam slots per month for Howard Brown Health Center patients. The cost of providing high quality eye wear kept us from being able to offer even more services. The program makes ordering easy, the glasses are high quality and are provided in a timely manner.  Now that the cost of the eye wear is not an obstacle, we are able to open up our services to more patients.\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Michael Ciszek, O.D.")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Visionary Eye Care Professionals")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("This effort has the potential to make a real impact on a large number of kids in underserved communities across the U.S. – all of us here at HKI are super excited!\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Meghan K. Lynch")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Director, ChildSight® U.S. Helen Keller International\r\n                  ")])])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "row justify-content-lg-center g-mb-20"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-10 g-mb-20"
  }, [_c('div', {
    staticClass: "media mb-3"
  }, [_c('div', {
    staticClass: "d-flex mr-3"
  }, [_c('span', {
    staticClass: "g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-pos-rel g-top-minus-10"
  }, [_vm._v("“")])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('blockquote', {
    staticClass: "g-brd-left-none g-color-white g-font-style-italic g-font-size-18 g-pl-0"
  }, [_vm._v("Our patients are always so pleased when they hear that we are doing charitable giving and we always give the program the credit! It's definitely a great practice builder -- do what's right for the patient and it'll always help your practice. It also makes the staff happy to see we are helping patients at no charge to them. It makes them feel like they are part of something special and shows that the goal of the practice is to help people. Of course, they know that we need to make money to keep the doors open, but it's not about that, it's about the patients.\r\n                      "), _c('span', {
    staticClass: "align-self-end g-color-white-opacity-0_8 g-font-secondary g-font-size-40 g-opacity-0_3 g-line-height-0 align-bottom g-pos-rel g-top-minus-10"
  }, [_vm._v("”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-pl-30"
  }, [_c('h3', {
    staticClass: "h4 g-font-size-18 g-color-white-opacity-0_9 mb-0"
  }, [_vm._v("Dr. Suzanne Zamberlan of Evergreen")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-18--md g-color-white-opacity-0_5 g-pl-20"
  }, [_vm._v("— Eye Care in Vancouver, WA\r\n                    ")])])])])])], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cca75d2", module.exports)
  }
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br')])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e7b7a81", module.exports)
  }
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content g-pt-20 g-pt-0--md",
    attrs: {
      "id": "nav-5-3-primary-ver"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items.keys()), function(group, index) {
    return (_vm.items != null) ? _c('div', [_c('help-item', {
      attrs: {
        "id": group.replace(/\s+/g, '') + '-div',
        "section": group,
        "items": _vm.items.get(group)
      }
    }), _vm._v(" "), _c('br'), _c('br'), _c('br')], 1) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-max-width-645 text-center mx-auto g-mt-60 g-mb-0"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Frequently Asked Questions")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Below are the answers to some frequently asked questions.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1fd1870a", module.exports)
  }
}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg-cfs.svg')"
    }
  }, [_c('div', {
    staticClass: "container g-py-50 g-pt-100--lg g-pb-20--lg"
  }, [_c('div', {
    staticClass: "row align-items-lg-center"
  }, [_c('div', {
    staticClass: "col-lg-6 g-mb-70 g-mb-150--sm g-mb-50--lg"
  }, [_c('div', {
    staticClass: "g-pr-15--lg"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-70 g-py-13 mr-2 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Share a Story")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 g-mb-50"
  }, [_c('div', {
    staticClass: "g-max-width-550 g-pos-rel g-pl-15--lg mx-auto"
  }, [_c('div', {
    staticClass: "g-max-width-300--sm g-pos-rel g-z-index-1 g-mb-20 g-mb-0--sm img-story-1"
  }, [_c('img', {
    staticClass: "u-shadow-v36 img-fluid g-brd-around g-brd-4 g-brd-white rounded g-mt-80",
    attrs: {
      "src": _vm.success_story_1,
      "alt": "Photo_Family2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-shadow-v36 g-max-width-300--sm g-pos-abs--sm g-top-minus-70 g-left-130 g-z-index-0 g-mb-20 g-mb-0--sm"
  }, [_c('img', {
    staticClass: "img-fluid g-brd-around g-brd-4 g-brd-white rounded",
    attrs: {
      "src": _vm.success_story_2,
      "alt": "Photo_DoctorImage5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-shadow-v36 g-max-width-300--sm g-pos-abs--sm g-top-65 g-right-0 g-mt-40"
  }, [_c('img', {
    staticClass: "img-fluid g-brd-around g-brd-4 g-brd-white rounded",
    attrs: {
      "src": _vm.success_story_3,
      "alt": "Photo_FamilyImage5"
    }
  })])])])])])]), _vm._v(" "), (_vm.isModalShown) ? _c('share-story-form', {
    on: {
      "close": function($event) {
        return _vm.CloseModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('h1', {
    staticClass: "g-font-size-45 mb-3"
  }, [_vm._v("Share a Success Story!")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Have an inspiring story or best practice to improve delivery of vision services to those in need?  Please share your experiences and upload images to bring to life your contributions in your community.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-238d857f", module.exports)
  }
}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-flex-centered g-bg-img-hero g-bg-pos-top-center g-bg-cover g-bg-bluegray-opacity-0_2--after",
    staticStyle: {
      "background-image": "url('../../../../static/assets/img/bg/Portal Photo_KidImage4.jpeg')",
      "background-position": "center"
    },
    attrs: {
      "data-calc-target": "#js-header"
    }
  }, [_c('div', {
    staticClass: "container g-pos-rel g-z-index-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center g-py-20"
  }, [_c('a', {
    staticClass: "g-color-main g-color-primary--hover",
    on: {
      "click": function($event) {
        return _vm.ArrowDown()
      }
    }
  }, [_vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-shadow-v36 g-max-width-500 g-bg-main-light-v1 g-pa-50 g-mt-130 g-mb-100"
  }, [_c('div', {
    staticClass: "g-mb-10"
  }, [_c('h1', {
    staticClass: "g-color-white g-font-size-40--md mb-3"
  }, [_vm._v("Resources")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-white-opacity-0_8 g-font-size-20"
  }, [_vm._v("Want to get involved, but aren’t sure where to start?  Check out these helpful guides and useful educational tools to explore ways to get engaged in your community.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chevron-down",
    staticStyle: {
      "font-size": "30px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24f2278e", module.exports)
  }
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Account Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.evfAccountNumber))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactLegalName),
      expression: "FormInputs.ContactLegalName"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Business/Practice Name")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Organization Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p capitalized-text"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.legalName))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels || _vm.FormInputs.NonProfitLabels) ? _c('label', {
    staticClass: "account_label capitalized-text"
  }, [_vm._v("Primary Contact")]) : _c('label', {
    staticClass: "account_label capitalized-text"
  }, [_vm._v("Participant Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [((_vm.AccountView.primaryContact.suffix == 'N/A' || _vm.AccountView.primaryContact.suffix == '')) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.firstName + " " + _vm.AccountView.primaryContact.lastName))]) : _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.firstName + " " + _vm.AccountView.primaryContact.lastName + ", " + _vm.AccountView.primaryContact.suffix))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels || _vm.FormInputs.NonProfitLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Primary Phone")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Phone Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [(_vm.AccountView.primaryContact.countryCode) ? _c('span', [_vm._v("(")]) : _vm._e(), _vm._v(_vm._s(+_vm.AccountView.primaryContact.countryCode)), (_vm.AccountView.primaryContact.countryCode) ? _c('span', [_vm._v(")")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.AccountView.primaryContact.areaCode)), (_vm.AccountView.primaryContact.areaCode) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s(_vm.AccountView.primaryContact.phone))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactRole),
      expression: "FormInputs.ContactRole"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Role in Business")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Role in Organization")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [(_vm.AccountView.primaryContact.title) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.titleDesc))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels || _vm.FormInputs.IndividualLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Business Type")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Organization Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [(_vm.AccountView.primaryContact.businessType) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.businessTypeDesc))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.EditSection()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('edit-account-info', {
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "ContactValidationResult": _vm.ContactValidationResult,
      "BusinessTypeIndividual": _vm.BusinessTypeIndividual,
      "BusinessTypeBusiness": _vm.BusinessTypeBusiness,
      "BusinessTypeNonProfit": _vm.BusinessTypeNonProfit,
      "Suffix": _vm.Suffix,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "State": _vm.State
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.SaveAccount()
      }
    }
  }, [_vm._v("Save ")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Account ID")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26ab6c12", module.exports)
  }
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOrderLoaded) ? _c('div', {
    staticClass: "div-confirmation"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-py-100"
  }, [(!_vm.isDataLoading) ? _c('div', {
    staticClass: "order-confirmation row"
  }, [(_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$route.params.isSummaryOnly == '1' && _vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('h2', {}, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("Your order has been submitted successfully.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n              Please print a copy of this for your records and include a copy along with your frame if you have placed a frame-to-come order.\n            ")])]) : (_vm.Order.orderStatus == 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("This order has an error.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n              Kindly contact the OneSight EssilorLuxottica Foundation team for more information\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.isCoveredPaymentShown) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v("The voucher provided covers the payment amount for this order")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.GenerateHtml()
      }
    }
  }, [_vm._v("Print Exam Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.NewOrder(_vm.Order.id)
      }
    }
  }, [_vm._v("Convert to Order")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.EditOrder(_vm.Order.id)
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.ShowDeleteModal(_vm.Order.id)
      }
    }
  }, [_vm._v("Delete")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Patient:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.patFirstName) + " " + _vm._s(_vm.Order.patLastName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Participant Name:")]), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName) + " " + _vm._s(_vm.Account.primaryContact.suffix))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Entry ID:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Examining Doctor:")]), _vm._v(" "), (_vm.doctor) ? _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.doctor.lastName) + ", " + _vm._s(_vm.doctor.firstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Submitted:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 border-box min-height-dispenser-notes"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_vm._m(3)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isDataLoading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('page-loader')], 1) : _vm._e()]), _vm._v(" "), (_vm.isServicePaymentShown) ? _c('service-payment', {
    attrs: {
      "Account": _vm.Account,
      "Order": _vm.Order
    },
    on: {
      "close": function($event) {
        _vm.isServicePaymentShown = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isDeleteModelShown) ? _c('prompt-component', {
    attrs: {
      "message": _vm.promptMessage
    },
    on: {
      "close": function($event) {
        return _vm.CloseDeleteModal()
      },
      "onAgree": function($event) {
        return _vm.DeleteOrder()
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n              Participant and Order Information\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n              Patient/Order Notes\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n              Order requested is not valid.\n            ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26ec0c84", module.exports)
  }
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordersubmit"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-my-100"
  }, [_c('div', {
    staticClass: "g-bg-img-hero g-bg-pos-top-center g-pos-rel g-z-index-0 g-mt-minus-150",
    staticStyle: {
      "background-image": "url(/static/assets/include/svg/svg-bg4.svg)"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row center"
  }, [(_vm.orderType == 'special') ? _c('order-special') : (_vm.orderType == 'pending') ? _c('order-pending') : (_vm.orderDetailsLoading && _vm.orderType == 'error') ? _c('page-loader') : _c('order-error', {
    attrs: {
      "Account": _vm.Account,
      "orderDetails": _vm.orderDetails
    },
    on: {
      "clicked": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }), _vm._v(" "), (_vm.orderType != 'error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('OrderTracking')
      }
    }
  }, [_vm._v("Track Order")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Order')
      }
    }
  }, [_vm._v("Place New Order")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')]) : _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.EditOrder(_vm.$route.params.code)
      }
    }
  }, [_vm._v("Edit Order")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Order')
      }
    }
  }, [_vm._v("Place New Order")])])], 1)])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2827b07d", module.exports)
  }
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.NonProfitOrganizationDetails),
      expression: "FormInputs.NonProfitOrganizationDetails"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-sm-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n        Non-Profit Organization Details\n    ")]), _vm._v(" "), _c('p', [_vm._v("Please answer the following questions about your non-profit organization.")]), _vm._v(" "), _c('p', {
    staticClass: "nonProfit_order"
  }, [_vm._v("Are you considered a Covered Entity under HIPAA classifications?*\n        "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ({
        html: 'tooltipContent',
        class: 'custom-tooltip'
      }),
      expression: "{ html: 'tooltipContent', class: 'custom-tooltip' }",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tooltipContent"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.hipaaTooltip)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "IsCoveredUnderHIPAA"
    },
    on: {
      "click": function($event) {
        _vm.Account.IsCoveredUnderHIPAA = true
      }
    }
  }), _vm._v(" Yes\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "IsCoveredUnderHIPAA"
    },
    on: {
      "click": function($event) {
        _vm.Account.IsCoveredUnderHIPAA = false
      }
    }
  }), _vm._v(" No\n        ")])]), _vm._v(" "), (_vm.AccountValidationResult.AccountIsCoveredUnderHIPAA) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountIsCoveredUnderHIPAA))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "nonProfit_order"
  }, [_vm._v("Do you, as the non-profit organization, plan to enter orders for glasses, or do you refer cases to eye doctors who order and dispense glasses independently?*")]), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.OrderPlan),
      expression: "Account.OrderPlan"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "name": "OrderPlan"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.OrderPlan, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Account, "OrderPlan", "1")
      }
    }
  }), _vm._v(" Non-Profit places orders for glasses\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.OrderPlan),
      expression: "Account.OrderPlan"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "OrderPlan"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.OrderPlan, "2")
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      },
      "change": function($event) {
        return _vm.$set(_vm.Account, "OrderPlan", "2")
      }
    }
  }), _vm._v(" Eye Doctors place orders for glasses\n        ")])]), _vm._v(" "), (_vm.AccountValidationResult.AccountOrderPlan) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountOrderPlan))]) : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md g-mt-100"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-px-30 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Confirm")])])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "nonprofit-modal-msg"
  }, [_vm._v("\n                                    The non-profit may not need to register for an account. Eye doctors that are part of referral \n                                    networks should register for their own accounts.\n                                ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-286086f8", module.exports)
  }
}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n            Participant Information\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountNpiNumber),
      expression: "FormInputs.AccountNpiNumber"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("NPI Number\n                            "), (!_vm.Account.UseLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.NpiNumber),
      expression: "Account.NpiNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountNpiNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.Account.NpiNumber)
    },
    on: {
      "paste": function($event) {
        return _vm.pasteNpiNumber($event)
      },
      "keyup": function($event) {
        return _vm.ValidateNpiNumber(_vm.Account.NpiNumber)
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "NpiNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountNpiNumber))]) : _vm._e(), _vm._v(" "), (_vm.invalidNpiNumberPaste) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("Sorry, only numeric NPI values can be pasted here.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountNpiNumber),
      expression: "FormInputs.AccountNpiNumber"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Relationship*\n                            "), _c('span', {
    attrs: {
      "data-balloon": _vm.relationshipTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Role),
      expression: "Account.Role"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.Role
    },
    staticStyle: {
      "height": "36.5px"
    },
    attrs: {
      "disabled": _vm.FormInputs.IndividualOrganization
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Account, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.AccountValidationResult.Role) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.Role))]) : _vm._e()])]), _vm._v(" "), (_vm.Account.UseLicenseNumber == false || _vm.Account.UseLicenseNumber == null) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), (_vm.Account.UseLicenseNumber == true) ? _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("License Number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.LicenseNumber),
      expression: "Account.LicenseNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountLicenseNumber
    },
    attrs: {
      "maxlength": "18",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.LicenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "LicenseNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountLicenseNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountLicenseNumber))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Account.UseLicenseNumber == true) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.State),
      expression: "Account.State"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountState
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Account, "State", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.AccountValidationResult.AccountState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountState))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountHasNpiNumber),
      expression: "FormInputs.AccountHasNpiNumber"
    }],
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.Account.UseLicenseNumber = !_vm.Account.UseLicenseNumber
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("I don't have an NPI number")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactFirstName),
      expression: "FormInputs.ContactFirstName"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('label', [_vm._v("Participant First Name*")]) : _c('label', [_vm._v("Primary Contact First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FirstName),
      expression: "FirstName"
    }],
    staticClass: "form-control capitalize",
    class: {
      error_field: _vm.ContactValidationResult.ContactFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.FirstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactLastName),
      expression: "FormInputs.ContactLastName"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('label', [_vm._v("Participant Last Name*")]) : _c('label', [_vm._v("Primary Contact Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LastName),
      expression: "LastName"
    }],
    staticClass: "form-control capitalize",
    class: {
      error_field: _vm.ContactValidationResult.ContactLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.LastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactSuffix),
      expression: "FormInputs.ContactSuffix"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suffix*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passSuffix),
      expression: "passSuffix"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactSuffix
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.passSuffix = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.Suffix), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.ContactValidationResult.ContactSuffix) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactSuffix))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-9 col-sm-9 col-xs-12"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('label', [_vm._v("\n                        Participant Phone Number*\n                    ")]) : _c('label', [_vm._v("\n                        Primary Contact Phone Number*\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row div-phone"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.CountryCode),
      expression: "Account.PrimaryContact.CountryCode"
    }],
    ref: "participant_number_1",
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.CountryCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact, "CountryCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.AreaCode),
      expression: "Account.PrimaryContact.AreaCode"
    }],
    ref: "participant_number_2",
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.AreaCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact, "AreaCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4 md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.Phone),
      expression: "Account.PrimaryContact.Phone"
    }],
    ref: "participant_number_3",
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.Phone)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(3)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact, "Phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.ContactValidationResult.ContactPhoneNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactPhoneNumber))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-9 col-sm-9 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactRole),
      expression: "FormInputs.ContactRole"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Role in Business")]) : _c('label', [_vm._v("Role in Organization")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.Title),
      expression: "Account.PrimaryContact.Title"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Account.PrimaryContact, "Title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l(((_vm.FormInputs.RoleBusiness ? _vm.RoleBusiness : _vm.RoleNonProfit)), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactYearsInPractice),
      expression: "FormInputs.ContactYearsInPractice"
    }],
    staticClass: "form-group col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', [_vm._v("Year Licensed")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.YearsInPractice),
      expression: "Account.PrimaryContact.YearsInPractice"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactYearsInPractice
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.YearsInPractice)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event);
      },
      "keyup": function($event) {
        return _vm.G_NumberOfYearsCheck(_vm.Account.PrimaryContact, 'YearsInPractice')
      },
      "blur": function($event) {
        return _vm.CheckYearLicense()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact, "YearsInPractice", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactYearsInPractice) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactYearsInPractice))]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.year && !_vm.ContactValidationResult.ContactYearsInPractice) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage.year))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-9 col-sm-9 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.BusinessPrimaryContact),
      expression: "FormInputs.BusinessPrimaryContact"
    }],
    staticClass: "form-check primarycontact-eyedoctor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.IsEyeDoctor),
      expression: "Account.PrimaryContact.IsEyeDoctor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.PrimaryContact.IsEyeDoctor) ? _vm._i(_vm.Account.PrimaryContact.IsEyeDoctor, null) > -1 : (_vm.Account.PrimaryContact.IsEyeDoctor)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Account.PrimaryContact.IsEyeDoctor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account.PrimaryContact, "IsEyeDoctor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account.PrimaryContact, "IsEyeDoctor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account.PrimaryContact, "IsEyeDoctor", $$c)
        }
      }, function($event) {
        return _vm.MakeParticipantDoctor()
      }]
    }
  }), _vm._v(" "), (_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Primary Contact is an Eye Doctor")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Primary Contact is an Eye Doctor")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ParticipantAccountNpiNumber),
      expression: "FormInputs.ParticipantAccountNpiNumber"
    }],
    staticClass: "form-group col-lg-5 col-md-5 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ParticipantAccountNpiNumber),
      expression: "FormInputs.ParticipantAccountNpiNumber"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Business NPI Number\n                            "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiForBusinessTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.BusinessLabels) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.BusinessNpiNumber),
      expression: "Account.BusinessNpiNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.AccountBusinessNpiNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.Account.BusinessNpiNumber)
    },
    on: {
      "paste": function($event) {
        return _vm.pasteNpiNumber($event)
      },
      "keyup": function($event) {
        return _vm.ValidateNpiNumberForBusinessType()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "BusinessNpiNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.AccountValidationResult.AccountBusinessNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountBusinessNpiNumber))]) : _vm._e(), _vm._v(" "), (_vm.invalidNpiNumberPaste) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("Sorry, only numeric NPI values can be pasted here.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactLegalName),
      expression: "FormInputs.ContactLegalName"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Legal Business Name* (Practice)")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Legal Organization Name* (Participant)")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.LegalName),
      expression: "Account.PrimaryContact.LegalName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactLegalName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.LegalName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact, "LegalName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactLegalName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactLegalName))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "name": "Account.PrimaryContact.IsEyeDoctor"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.IndividualNpiNumber && _vm.Account.PrimaryContact.IsEyeDoctor),
      expression: "FormInputs.IndividualNpiNumber  && Account.PrimaryContact.IsEyeDoctor"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-9 col-sm-9 col-xs-12"
  }, [_c('label', [_vm._v("Individual NPI Number\n                            "), (!_vm.Account.IsPrimaryLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.NpiNumber),
      expression: "Account.PrimaryContact.NpiNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactNpiNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.NpiNumber)
    },
    on: {
      "keyup": function($event) {
        return _vm.ValidateNpiNumber(_vm.Account.PrimaryContact.NpiNumber)
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact, "NpiNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactNpiNumber))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-9 col-sm-9 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Relationship*\n                                                    "), _c('span', {
    attrs: {
      "data-balloon": _vm.relationshipTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Role),
      expression: "Account.Role"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.Role
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Account, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.AccountRoleChanged(_vm.Account.Role)
      }]
    }
  }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.ContactValidationResult.Role) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.Role))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-9 col-sm-9 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.BusinessPrimaryContact),
      expression: "FormInputs.BusinessPrimaryContact"
    }],
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.IsPrimaryLicenseNumber),
      expression: "Account.PrimaryContact.IsPrimaryLicenseNumber"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.PrimaryContact.IsPrimaryLicenseNumber) ? _vm._i(_vm.Account.PrimaryContact.IsPrimaryLicenseNumber, null) > -1 : (_vm.Account.PrimaryContact.IsPrimaryLicenseNumber)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Account.PrimaryContact.IsPrimaryLicenseNumber,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account.PrimaryContact, "IsPrimaryLicenseNumber", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account.PrimaryContact, "IsPrimaryLicenseNumber", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account.PrimaryContact, "IsPrimaryLicenseNumber", $$c)
        }
      }, function($event) {
        _vm.updateUseLicenseNumber();
        _vm.Account.IsPrimaryLicenseNumber = !_vm.Account.IsPrimaryLicenseNumber
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Use License Number")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.IndividualNpiNumber && _vm.Account.PrimaryContact.IsPrimaryLicenseNumber),
      expression: "FormInputs.IndividualNpiNumber  && Account.PrimaryContact.IsPrimaryLicenseNumber"
    }],
    staticClass: "form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 "
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("License Number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryLicenseNumber),
      expression: "primaryLicenseNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactLicenseNumber
    },
    attrs: {
      "maxlength": "18",
      "type": "text"
    },
    domProps: {
      "value": (_vm.primaryLicenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryLicenseNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.ContactValidationResult.ContactLicenseNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactLicenseNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryState),
      expression: "primaryState"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ContactValidationResult.ContactState
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.primaryState = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ContactValidationResult.ContactState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ContactValidationResult.ContactState))]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2cd68b1f", module.exports)
  }
}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-8 offset-sm-2 g-my-20"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValueC),
      expression: "searchValueC"
    }],
    staticClass: "form-control",
    attrs: {
      "value": "",
      "disabled": _vm.isDataLoading,
      "type": "text",
      "placeholder": "Search.."
    },
    domProps: {
      "value": (_vm.searchValueC)
    },
    on: {
      "keyup": [function($event) {
        return _vm.EmptySearch()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.SearchTable()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValueC = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SearchTable()
      }
    }
  }, [_vm._v("Search "), _vm._m(0)])])])]), _vm._v(" "), (_vm.elementConfig.orderTrackingStatusShow || _vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-12 col-lg-12 col-sm-12 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "g-py-10"
  }, [_vm._v("Filter by Date Range")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-5 col-xs-12"
  }, [_c('div', {
    staticClass: "row g-px-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDataLoading,
      "bootstrap-styling": true,
      "format": _vm.format,
      "name": "uniquename",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar"
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  })], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-5 col-xs-12"
  }, [_c('div', {
    staticClass: "row g-px-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDataLoading,
      "disabled": _vm.datepickerState.disabled,
      "bootstrap-styling": true,
      "format": _vm.format,
      "name": "uniquename",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar"
    },
    on: {
      "closed": function($event) {
        return _vm.SearchTable()
      }
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "g-py-10"
  }, [_vm._v("Filter by Status")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "Pending"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "Pending") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('Pending')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Pending",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "PendingError"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "PendingError") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('PendingError')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PendingError",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("Pending - Error")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "PendingApproval"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "PendingApproval") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('PendingApproval')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PendingApproval",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("Pending Approval")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "InProcess"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "InProcess") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('InProcess')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "InProcess",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("In Process")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "Shipped"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "Shipped") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('Shipped')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Shipped",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("Shipped")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "Dispensed"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "Dispensed") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('Dispensed')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Dispensed",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("Dispensed")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "Cancelled"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "Cancelled") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('Cancelled')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Cancelled",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("Cancelled")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusFilterC),
      expression: "statusFilterC"
    }],
    staticClass: "form-check-input",
    attrs: {
      "disabled": _vm.isDataLoading,
      "type": "checkbox",
      "value": "ExamOnly"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusFilterC) ? _vm._i(_vm.statusFilterC, "ExamOnly") > -1 : (_vm.statusFilterC)
    },
    on: {
      "click": function($event) {
        return _vm.FilterToString('ExamOnly')
      },
      "change": function($event) {
        var $$a = _vm.statusFilterC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "ExamOnly",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.statusFilterC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.statusFilterC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.statusFilterC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label order-tracking-filter"
  }, [_vm._v("Exam Only")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center track-order-btns",
    class: [{
      'loading': _vm.isDataLoading
    }, {
      'btn-pos-if-empty': _vm.OrderList.length == 0
    }]
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-20",
    attrs: {
      "disabled": _vm.isDataLoading
    },
    on: {
      "click": function($event) {
        return _vm.MarkAsDispensed()
      }
    }
  }, [_vm._v("Mark selected as dispensed")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-20",
    attrs: {
      "disabled": _vm.isDataLoading
    },
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_vm._v("Reset Filters")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-20",
    attrs: {
      "disabled": _vm.isDataLoading
    },
    on: {
      "click": function($event) {
        return _vm.ExportToExcel()
      }
    }
  }, [_vm._v("Export file with current filters")])])])]) : _c('div', {
    staticClass: "col-md-6 offset-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "g-py-10"
  }, [_vm._v("Filter by Date Range")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-5 col-xs-12"
  }, [_c('div', {
    staticClass: "row g-px-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDataLoading,
      "bootstrap-styling": true,
      "format": _vm.format,
      "name": "uniquename",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar"
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  })], 1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-5 col-xs-12"
  }, [_c('div', {
    staticClass: "row g-px-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDataLoading,
      "disabled": _vm.datepickerState.disabled,
      "bootstrap-styling": true,
      "format": _vm.format,
      "name": "uniquename",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar"
    },
    on: {
      "closed": function($event) {
        return _vm.SearchTable()
      }
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-my-50 g-px-20",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_vm._v("Reset Filters")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDataLoading),
      expression: "!isDataLoading"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('pagination', {
    ref: "pagination",
    attrs: {
      "records": _vm.PageValues.totalList,
      "per-page": _vm.PageValues.itemsPerPage,
      "theme": _vm.theme,
      "chunk": _vm.chunk,
      "count-text": "{from} to {to} of {count} records|{count} records|1 record"
    },
    on: {
      "paginate": _vm.setPage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markDispenseModal),
      expression: "markDispenseModal"
    }]
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content g-mt-170"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v(_vm._s(!_vm.isDispensed ? 'Mark as Dispensed' : 'Successfully Dispensed'))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDispensed),
      expression: "!isDispensed"
    }],
    staticClass: "row g-my-20 g-mx-20 "
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15"
  }, [_c('label', [_vm._v("Enter Dispense Date:")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDataLoading,
      "bootstrap-styling": true,
      "format": _vm.format,
      "name": "uniquename",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar"
    },
    model: {
      value: (_vm.dateDispense),
      callback: function($$v) {
        _vm.dateDispense = $$v
      },
      expression: "dateDispense"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-info--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.SaveMarkForDispense()
      }
    }
  }, [_vm._v("Mark Dispensed")]), _vm._v(" "), _c('div', [_c('small', [_vm._v("This will mark " + _vm._s(_vm.listToMarkDispense.length) + " orders as dispensed. This cannot be undone in bulk, but individual orders can be marked as Not Dispensed on the Order Confirmation page.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.markDispenseModalClose()
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDispensed),
      expression: "isDispensed"
    }],
    staticClass: "row g-my-20 g-mx-20 "
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15"
  }, [_vm._v("\n                                    Record(s) have been marked as \"Dispensed\"\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.markDispenseModalClose()
      }
    }
  }, [_vm._v("Close")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-1 col-xs-12 center"
  }, [_c('p', [_vm._v("To")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-1 col-xs-12 center"
  }, [_c('p', [_vm._v("To")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ce8a543", module.exports)
  }
}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "g-bg-main g-pt-100 g-pb-50"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row g-mb-40"
  }, [(_vm.CheckLogin()) ? _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }, [_c('b', {
    staticClass: "g-font-size-18 g-color-footer-links"
  }, [_vm._v("Pages")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled g-mt-20"
  }, [_c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Home')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_vm._v("Order Now")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_vm._v("Track Orders")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Frames')
      }
    }
  }, [_vm._v("Frames")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resources')
      }
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('UserAccount')
      }
    }
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help")])])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.CheckLogin()) ? _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 col-lg-3 order-md-2 g-mb-30"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3 order-md-1 g-mb-30"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }, [_c('b', {
    staticClass: "g-font-size-18 g-color-footer-links"
  }, [_vm._v("Links and More")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled g-mt-20"
  }, [_c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.onesight.essilorluxottica.com"
    }
  }, [_vm._v("OneSight EssilorLuxottica Foundation")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "https://www.evfusa.org/terms-and-conditions"
    }
  }, [_vm._v("Terms of Use")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.evfusa.org/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.evfusa.org/disclosures"
    }
  }, [_vm._v("Disclosures")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "https://www.essilorusa.com/about/ethics-compliance"
    }
  }, [_vm._v("Ethics & Compliance")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-6 g-mb-20"
  }, [_c('img', {
    staticClass: "evf-watermark-2",
    attrs: {
      "src": "/static/assets/img/logo/Powered_by_OSELF-white.png"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-inline mb-0 evf-social-2 g-my-10"
  }, [_c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--xs u-shadow-v32",
    attrs: {
      "href": "https://www.facebook.com/onesight/"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-facebook.png",
      "alt": "facebook"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32",
    attrs: {
      "href": "https://www.linkedin.com/company/onesightessilorluxotticafoundation"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-linkedin.png",
      "alt": "linkedin"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--xs u-shadow-v32",
    attrs: {
      "href": "https://twitter.com/onesightorg"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-twitter.png",
      "alt": "twitter"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32",
    attrs: {
      "href": "https://www.instagram.com/onesight/"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-instagram.png",
      "alt": "instagram"
    }
  })])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ec4fedc", module.exports)
  }
}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.lensType), function(ld) {
    return _c('div', {
      staticClass: "col-sm center order-div"
    }, [_c('label', {
      staticClass: "g-mb-0 g-font-size-20"
    }, [_vm._v(_vm._s(ld.description))]), _vm._v(" "), _c('div', {
      staticClass: "image-div g-mb-10",
      on: {
        "click": function($event) {
          return _vm.JobTypeDependency(ld)
        }
      }
    }, [(_vm.Order.LensTypeCode != ld.lensCode) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": ld.imageURL
      }
    }) : _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": ld.invertedImageURL
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Order.LensTypeCode),
        expression: "Order.LensTypeCode"
      }],
      attrs: {
        "type": "radio",
        "name": "lensType"
      },
      domProps: {
        "value": ld.lensCode,
        "checked": _vm._q(_vm.Order.LensTypeCode, ld.lensCode)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.Order, "LensTypeCode", ld.lensCode)
        }, function($event) {
          return _vm.JobTypeDependency(ld)
        }]
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.ValidationResult.OrderLensTypeCode) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.ValidationResult.OrderLensTypeCode) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLensTypeCode))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('div', {
    staticClass: " hide-overflow"
  }, [_c('table', {
    staticClass: "table table-borderless white-smoke-bg"
  }, [_c('thead', [_c('tr', {
    staticClass: "center"
  }, [_c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Sphere"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Axis"), (((_vm.Order.ReCyl != null || _vm.Order.LeCyl != null) && (_vm.Order.ReCyl != '0.00' && _vm.Order.LeCyl != '0.00')) && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Addition"), (_vm.Order.LensTypeCode == 'BFF' && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Seg. Height"), (_vm.Order.LensTypeCode == 'BFF' && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "center"
  }, [_vm._m(7), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderRESph
    },
    attrs: {
      "minSize": "-20",
      "maxSize": "20",
      "stepSize": "0.25",
      "fixedSize": "2",
      "displayPlus": "true"
    },
    model: {
      value: (_vm.Order.ReSph),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReSph", $$v)
      },
      expression: "Order.ReSph"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRESph) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRESph))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "-10",
      "maxSize": "10",
      "stepSize": "0.25",
      "fixedSize": "2",
      "defaultNegative": "true",
      "inputName": "ReCyl"
    },
    model: {
      value: (_vm.Order.ReCyl),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReCyl", $$v)
      },
      expression: "Order.ReCyl"
    }
  })], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderREAxis
    },
    attrs: {
      "minSize": "0",
      "maxSize": "180",
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.ReAxis),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReAxis", $$v)
      },
      expression: "Order.ReAxis"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderREAxis) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREAxis))]) : _vm._e()], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderREAdd
    },
    attrs: {
      "minSize": "0",
      "maxSize": "5",
      "stepSize": "0.25",
      "displayPlus": "true",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.ReAdd),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReAdd", $$v)
      },
      expression: "Order.ReAdd"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderREAdd) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREAdd))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderRESegHeight
    },
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "stepSize": "1",
      "fixedSize": "0",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.ReSegHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReSegHeight", $$v)
      },
      expression: "Order.ReSegHeight"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRESegHeight) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRESegHeight))]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "center"
  }, [_vm._m(8), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLESph
    },
    attrs: {
      "minSize": "-30",
      "maxSize": "30",
      "stepSize": "0.25",
      "fixedSize": "2",
      "displayPlus": "true"
    },
    model: {
      value: (_vm.Order.LeSph),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeSph", $$v)
      },
      expression: "Order.LeSph"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLESph) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLESph))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "-10",
      "maxSize": "10",
      "stepSize": "0.25",
      "fixedSize": "2",
      "defaultNegative": "true",
      "inputName": "LeCyl"
    },
    model: {
      value: (_vm.Order.LeCyl),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeCyl", $$v)
      },
      expression: "Order.LeCyl"
    }
  })], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLEAxis
    },
    attrs: {
      "minSize": "0",
      "maxSize": "180",
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.LeAxis),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeAxis", $$v)
      },
      expression: "Order.LeAxis"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLEAxis) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEAxis))]) : _vm._e()], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLEAdd
    },
    attrs: {
      "minSize": "0",
      "maxSize": "5",
      "stepSize": "0.25",
      "displayPlus": "true",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.LeAdd),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeAdd", $$v)
      },
      expression: "Order.LeAdd"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLEAdd) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEAdd))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLESegHeight
    },
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "stepSize": "1",
      "fixedSize": "0",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.LeSegHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeSegHeight", $$v)
      },
      expression: "Order.LeSegHeight"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLESegHeight) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLESegHeight))]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [((_vm.Order.LeCyl > 0 && _vm.Order.ReCyl < 0) || (_vm.Order.LeCyl < 0 && _vm.Order.ReCyl > 0)) ? _c('p', [_c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("You have entered opposite values for left and right eye cylinder. Please confirm Rx.")])]) : _vm._e(), _vm._v(" "), ((_vm.Order.LeSph > 0 && _vm.Order.ReSph < 0) || (_vm.Order.LeSph < 0 && _vm.Order.ReSph > 0)) ? _c('p', [_c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("You have entered opposite values for left and right eye sphere. Please confirm Rx.")])]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLensStock),
      expression: "showLensStock"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsUsingStockLensLab),
      expression: "Order.IsUsingStockLensLab"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsUsingStockLensLab) ? _vm._i(_vm.Order.IsUsingStockLensLab, null) > -1 : (_vm.Order.IsUsingStockLensLab)
    },
    on: {
      "click": function($event) {
        return _vm.ShowAdditionalFields(_vm.Order.IncludeAdditionalRxFields)
      },
      "change": function($event) {
        var $$a = _vm.Order.IsUsingStockLensLab,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsUsingStockLensLab", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsUsingStockLensLab", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsUsingStockLensLab", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("Use Stock lens")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IncludeAdditionalRxFields),
      expression: "Order.IncludeAdditionalRxFields"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IncludeAdditionalRxFields) ? _vm._i(_vm.Order.IncludeAdditionalRxFields, null) > -1 : (_vm.Order.IncludeAdditionalRxFields)
    },
    on: {
      "click": function($event) {
        return _vm.ShowAdditionalFields(_vm.Order.IncludeAdditionalRxFields)
      },
      "change": function($event) {
        var $$a = _vm.Order.IncludeAdditionalRxFields,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IncludeAdditionalRxFields", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IncludeAdditionalRxFields", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IncludeAdditionalRxFields", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("Show Additonal Rx fields.")]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('div', {
    staticClass: " hide-overflow"
  }, [_c('table', {
    staticClass: "table table-borderless white-smoke-bg"
  }, [_c('thead', [_c('tr', {
    staticClass: "center"
  }, [_c('th', {
    staticStyle: {
      "min-width": "100px"
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Base "), (((_vm.Order.REHorizontalPrismValue > 0 || _vm.Order.LEHorizontalPrismValue > 0)) && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('th'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Base "), ((_vm.Order.REVerticalPrismValue > 0 || _vm.Order.LEVerticalPrismValue > 0) && !_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('th'), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "center"
  }, [_vm._m(15), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": "0.25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.REHorizontalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "REHorizontalPrismValue", $$v)
      },
      expression: "Order.REHorizontalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.REHorizontalPrismDirection),
      expression: "Order.REHorizontalPrismDirection"
    }],
    staticClass: "form-control",
    class: {
      error_select: _vm.ValidationResult.OrderREHorizontalPrismDirection
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "REHorizontalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderREHorizontalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREHorizontalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": ".25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.REVerticalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "REVerticalPrismValue", $$v)
      },
      expression: "Order.REVerticalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.REVerticalPrismDirection),
      expression: "Order.REVerticalPrismDirection"
    }],
    staticClass: "form-control order-div",
    class: {
      error_select: _vm.ValidationResult.OrderREVerticalPrismDirection
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "REVerticalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderREVerticalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREVerticalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "disabled": _vm.Order.LensType.isFocal,
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.REOCHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "REOCHeight", $$v)
      },
      expression: "Order.REOCHeight"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "center"
  }, [_vm._m(16), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": "0.25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.LEHorizontalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LEHorizontalPrismValue", $$v)
      },
      expression: "Order.LEHorizontalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LEHorizontalPrismDirection),
      expression: "Order.LEHorizontalPrismDirection"
    }],
    staticClass: "form-control",
    class: {
      error_select: _vm.ValidationResult.OrderLEHorizontalPrismDirection
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "LEHorizontalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderLEHorizontalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEHorizontalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0.25",
      "maxSize": "5",
      "stepSize": ".25",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.LEVerticalPrismValue),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LEVerticalPrismValue", $$v)
      },
      expression: "Order.LEVerticalPrismValue"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LEVerticalPrismDirection),
      expression: "Order.LEVerticalPrismDirection"
    }],
    staticClass: "form-control order-div",
    class: {
      error_select: _vm.ValidationResult.OrderLEVerticalPrismDirection
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "LEVerticalPrismDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.PrismDirection), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderLEVerticalPrismDirection) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEVerticalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('rx-input', {
    attrs: {
      "minSize": "0",
      "maxSize": "40",
      "disabled": _vm.Order.LensType.isFocal,
      "stepSize": "1",
      "fixedSize": "0"
    },
    model: {
      value: (_vm.Order.LEOCHeight),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LEOCHeight", $$v)
      },
      expression: "Order.LEOCHeight"
    }
  })], 1)])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Distance PD"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _vm._m(17), _vm._v(" "), (!_vm.Order.IsOnly1DistancePD) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RE/OD")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderREDistPD
    },
    attrs: {
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "1"
    },
    model: {
      value: (_vm.Order.ReDistPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReDistPD", $$v)
      },
      expression: "Order.ReDistPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderREDistPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderREDistPD))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LE/OS")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLEDistPD
    },
    attrs: {
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "1"
    },
    model: {
      value: (_vm.Order.LeDistPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeDistPD", $$v)
      },
      expression: "Order.LeDistPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLEDistPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLEDistPD))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.Order.IsOnly1DistancePD) ? _c('div', {
    staticClass: "form-group"
  }, [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderDistancePD
    },
    attrs: {
      "minSize": "40",
      "maxSize": "80",
      "stepSize": ".50",
      "fixedSize": "2"
    },
    model: {
      value: (_vm.Order.DistancePD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "DistancePD", $$v)
      },
      expression: "Order.DistancePD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderDistancePD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderDistancePD))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsOnly1DistancePD),
      expression: "Order.IsOnly1DistancePD"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "tabindex": "-500"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsOnly1DistancePD) ? _vm._i(_vm.Order.IsOnly1DistancePD, null) > -1 : (_vm.Order.IsOnly1DistancePD)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsOnly1DistancePD,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsOnly1DistancePD", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsOnly1DistancePD", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsOnly1DistancePD", $$c)
        }
      }, _vm.ClearDistancePD]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Only 1 PD Measurement")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Near PD"), (_vm.Order.LensTypeCode == 'BFF') ? _c('span', [_vm._v("*")]) : (_vm.Order.DoesNotMeetRequirements) ? _c('span') : _vm._e()]), _vm._m(18), _vm._v(" "), (!_vm.Order.IsOnly1NearPD) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RE/OD")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderRENearPD
    },
    attrs: {
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.ReNearPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReNearPD", $$v)
      },
      expression: "Order.ReNearPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRENearPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRENearPD))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LE/OS")]), _vm._v(" "), _c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderLENearPD
    },
    attrs: {
      "minSize": "20",
      "maxSize": "40",
      "stepSize": ".50",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.LeNearPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LeNearPD", $$v)
      },
      expression: "Order.LeNearPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderLENearPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLENearPD))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.Order.IsOnly1NearPD) ? _c('div', {
    staticClass: "form-group"
  }, [_c('rx-input', {
    class: {
      error_select: _vm.ValidationResult.OrderNearPD
    },
    attrs: {
      "minSize": "40",
      "maxSize": "80",
      "stepSize": ".50",
      "fixedSize": "2",
      "disabled": !_vm.Order.LensType.isFocal
    },
    model: {
      value: (_vm.Order.NearPD),
      callback: function($$v) {
        _vm.$set(_vm.Order, "NearPD", $$v)
      },
      expression: "Order.NearPD"
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderNearPD) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderNearPD))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsOnly1NearPD),
      expression: "Order.IsOnly1NearPD"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.Order.LensType.isFocal,
      "tabindex": "-500"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsOnly1NearPD) ? _vm._i(_vm.Order.IsOnly1NearPD, null) > -1 : (_vm.Order.IsOnly1NearPD)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsOnly1NearPD,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsOnly1NearPD", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsOnly1NearPD", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsOnly1NearPD", $$c)
        }
      }, _vm.ClearNearPD]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Only 1 PD Measurement")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Lens Design"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.isLensDesignLoadingx) ? _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": _vm.pageLoader_img,
      "height": "30px",
      "width": "30px"
    }
  }) : _vm._e(), _vm._v(" "), _c('multiselect', {
    class: {
      error_select: _vm.ValidationResult.OrderLensDesign
    },
    attrs: {
      "label": "designName",
      "disabled": _vm.ComputedIsLensDesignDisabled,
      "options": _vm.lensDesign,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " ",
      "preselect-first": true
    },
    on: {
      "remove": function($event) {
        return _vm.RemoveLensDesign()
      },
      "close": function($event) {
        return _vm.LensDesignDependency(_vm.Order.LensDesignObject.designCode, _vm.Order.LensMaterialObject.code)
      }
    },
    model: {
      value: (_vm.Order.LensDesignObject),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LensDesignObject", $$v)
      },
      expression: "Order.LensDesignObject"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderLensDesign) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLensDesign))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group order-div order-div"
  }, [_c('label', [_vm._v("Lens Material"), (!_vm.Order.DoesNotMeetRequirements) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(19)]), _vm._v(" "), (_vm.isLensMaterialLoadingx) ? _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": _vm.pageLoader_img,
      "height": "30px",
      "width": "30px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLensDesignLoading) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    class: {
      error_select: _vm.ValidationResult.OrderLensMaterial
    },
    attrs: {
      "label": "name",
      "disabled": _vm.lensMaterial.length == 0,
      "options": _vm.lensMaterial,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "remove": function($event) {
        return _vm.RemoveMaterial()
      },
      "input": function($event) {
        return _vm.LensMaterialDependency(_vm.Order.LensDesignObject.designCode, _vm.Order.LensMaterialObject.code)
      }
    },
    model: {
      value: (_vm.Order.LensMaterialObject),
      callback: function($$v) {
        _vm.$set(_vm.Order, "LensMaterialObject", $$v)
      },
      expression: "Order.LensMaterialObject"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderLensMaterial) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderLensMaterial))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [(_vm.MasterAccountType != 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div left-padding-div",
    class: {
      disable: _vm.Order.LensDesign == null
    }
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("\n                    Lens Treatment(s)\n                ")]), _vm._v(" "), (_vm.isLensMaterialLoading || _vm.isCompatibleLoading) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lensTreatment), function(lt) {
    return _c('div', {
      staticClass: "form-check"
    }, [_c('span', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Order.LensTreatment),
        expression: "Order.LensTreatment"
      }],
      staticClass: "form-check-input",
      attrs: {
        "disabled": _vm.isCompatibleLoading,
        "type": "checkbox"
      },
      domProps: {
        "value": lt.code,
        "checked": Array.isArray(_vm.Order.LensTreatment) ? _vm._i(_vm.Order.LensTreatment, lt.code) > -1 : (_vm.Order.LensTreatment)
      },
      on: {
        "click": function($event) {
          return _vm.GetCompatability(lt.code)
        },
        "change": function($event) {
          var $$a = _vm.Order.LensTreatment,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = lt.code,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Order, "LensTreatment", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Order, "LensTreatment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Order, "LensTreatment", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "font-order"
    }, [_vm._v(_vm._s(lt.description))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12 div-spacing-top order-div left-padding-div"
  }, [_c('label', [_vm._v("Lens Treatment(s)")]), _vm._v(" "), (_vm.isLensMaterialLoading || _vm.isCompatibleLoading) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "label": "description",
      "track-by": "code",
      "options": _vm.lensTreatment,
      "disabled": _vm.isCompatibleLoading,
      "hideSelected": true,
      "multiple": true,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "remove": _vm.RemoveLensTreatment,
      "select": _vm.AddLensTreatment
    },
    model: {
      value: (_vm.selectedLensTreatment),
      callback: function($$v) {
        _vm.selectedLensTreatment = $$v
      },
      expression: "selectedLensTreatment"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 div-spacing-top order-div left-padding-div"
  }) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Lens Treatment Comments")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LensTreatmentComment),
      expression: "Order.LensTreatmentComment"
    }],
    staticClass: "form-control",
    attrs: {
      "row": "3"
    },
    domProps: {
      "value": (_vm.Order.LensTreatmentComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "LensTreatmentComment", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div g-px-10"
  }, [_c('span', {
    staticClass: "form-label div-spacing-bottom"
  }, [_vm._v("\n                    Special Requests/Instructions\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.DoesNotMeetRequirements),
      expression: "Order.DoesNotMeetRequirements"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.DoesNotMeetRequirements) ? _vm._i(_vm.Order.DoesNotMeetRequirements, null) > -1 : (_vm.Order.DoesNotMeetRequirements)
    },
    on: {
      "click": function($event) {
        return _vm.SpecialOrder(_vm.Order.DoesNotMeetRequirements)
      },
      "change": function($event) {
        var $$a = _vm.Order.DoesNotMeetRequirements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "DoesNotMeetRequirements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "DoesNotMeetRequirements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "DoesNotMeetRequirements", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("The lens options above do not meet the medical needs of this patient.")]), _vm._v(" "), _vm._m(20)])]), _vm._v(" "), (_vm.Order.DoesNotMeetRequirements) ? _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.SpecialInstructions1),
      expression: "Order.SpecialInstructions1"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "What is the special request and why is it needed?",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.Order.SpecialInstructions1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "SpecialInstructions1", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.Order.DoesNotMeetRequirements) ? _c('p', {
    staticClass: "font-order"
  }, [_vm._v("\n                    Special orders will be reviewed by the OneSight EssilorLuxottica Foundation support team in order to approve or decline the request. Special orders will take extra time to process due to this review\n                ")]) : _vm._e(), _vm._v(" "), (_vm.Order.DoesNotMeetRequirements) ? _c('div', {
    staticClass: "form-check"
  }, [_c('span', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsSpecialOrderNecessary),
      expression: "Order.IsSpecialOrderNecessary"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsSpecialOrderNecessary) ? _vm._i(_vm.Order.IsSpecialOrderNecessary, "") > -1 : (_vm.Order.IsSpecialOrderNecessary)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsSpecialOrderNecessary,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsSpecialOrderNecessary", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsSpecialOrderNecessary", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsSpecialOrderNecessary", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v("I attest that this special order request is medically necessary for the patient.*")])]), _vm._v(" "), (_vm.ValidationResult.OrderIsSpecialOrderNecessary) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderIsSpecialOrderNecessary))]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Order Information\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          If the lens options do not meet the needs of the patient, please complete as much of the order form as possible and check the box below to include additional information in the section for special requests.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div"
  }, [_c('p', {
    staticClass: "left-padding-div"
  }, [_vm._v("Please select the lens type from the icons below.*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "SPH (Sphere) - Spherical error, or overall power of lens is the basic part of the prescription. Sometimes, the doctor may write 'PL' or 'Plano' - In this case, select +0.00",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18 th-responsive"
  }, [_vm._v("\n                                    Cylinder "), _c('span', {
    attrs: {
      "data-balloon": "CYL (Cylinder) - Cylinder power indicates correction for astigmatism. This field will default to a negative cylinder power. Plus cylinder can be ordered by adding a + sign before the power. Sometimes, the doctor may write 'Sphere' or 'Sph' in this field. In this case, leave the cylinder and axis fields blank.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Axis - The axis is required for prescriptions with cylinder power. This tells the orientation of the astigmatism.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "ADD (Addition) - If your prescription contains ADD or Addition values, this indicates that the patient requires a bifocal lens. Since ADD power is almost always the same in both eyes, it is common for the doctor to only write this once but this should be entered in both eyes.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Segment (Seg) Height - This is the vertical measurement in millimeters from the bottom of the lens to where the top of the addition power should begin. This field is only necessary for multifocal (bifocal or progressive) lenses. Since ADD power is almost always the same in both eyes, it is common for the doctor to only write this once but this should be entered in both eyes. If the prescription contains an Addition (ADD) but does not contain a height measurement it is recommended that you contact the eye doctor or optician to obtain these measurements but if this is not possible, leave blank. ",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Right Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(RE or OD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Left Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(LE or OS)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Show fields for Prism and Optical Center.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Horiz. Prism "), _c('span', {
    attrs: {
      "data-balloon": "Horizontal Prism - This is the amount of prismatic power, measured in prism diopters.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Base - The direction of the prism. Four abbreviations are used for prism direction: BU = base up; BD = base down; BI = base in (toward the wearer's nose); BO = base out (toward the wearer's ear).",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    Vert. Prism "), _c('span', {
    attrs: {
      "data-balloon": "Vertical Prism - This is the amount of prismatic power, measured in prism diopters.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Base - The direction of the prism. Four abbreviations are used for prism direction: BU = base up; BD = base down; BI = base in (toward the wearer's nose); BO = base out (toward the wearer's ear).",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "g-font-size-18",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_vm._v("\n                                    OC Height "), _c('span', {
    attrs: {
      "data-balloon": "Optical/Ocular Center height - Please note, this option is not available for multifocal orders. If necessary, provide more information in the Special Requests section",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Right Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(RE or OD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("Left Eye")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(LE or OD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "Distance PD (Pupillary Distance) - The distance in millimeters (mm) between the patient's pupils when they are looking at objects in the distance. This will either be represented with 2 numbers (separate measurements for the left and right eyes) or 1 number (a single measurement between pupils).",
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "Near PD (Pupillary Distance) - The distance in millimeters (mm) between the patient's pupils when they are looking at objects close to their face. This will either be represented with 2 numbers (separate measurements for the left and right eyes) or 1 number (a single measurement between pupils). If the prescription contains an Addition (ADD) but does not contain Near PD measurements it is recommended that you contact the eye doctor or optician to obtain these measurements but if this is not possible, leave blank",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "All standard lenses provided are polycarbonate",
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "If the above options do not meet the medical needs of the patient, a special request can be made by clicking this check box and completing the special request fields.  All special requests are subject to approval.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-319a4c7e", module.exports)
  }
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v("Track Order")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-font-size-20--md g-font-size-17  g-color-primary--hover g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35fb6944", module.exports)
  }
}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "order-review-content"
  }, [_c('span', {
    staticClass: "order-reviewpatient-title"
  }, [_vm._v("Patient")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "order-reviewpatient-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.patFirstName) + " " + _vm._s(_vm.OrderReturn.patLastName))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "order-review-border"
  }, [_c('div', {
    staticClass: "order-info-content"
  }, [_c('span', {
    staticClass: "order-reviewpatient-title"
  }, [_vm._v("Order Information")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Lens Design:")]), _vm._v(" " + _vm._s(_vm.OrderReturn.lensDesignDescription))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Lens Material:")]), _vm._v(" " + _vm._s(_vm.OrderReturn.lensMaterialDescription))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table-rx"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("RE/OD")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reAdd))]), _vm._v(" "), (!_vm.OrderReturn.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reDistPD))]) : _c('td', {
    staticClass: "order-review-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.OrderReturn.distancePD))])]), _vm._v(" "), (!_vm.OrderReturn.isOnly1NearPD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reNearPD))]) : _c('td', {
    staticClass: "order-review-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.OrderReturn.nearPD))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("LE/OS")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leSph))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leCyl))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leAxis))]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leAdd))]), _vm._v(" "), (!_vm.OrderReturn.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.OrderReturn.isOnly1NearPD) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leNearPD))]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("RE/OD")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reSegHeight))]), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reocHeight))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reHorizontalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reHorizontalPrismDirection))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reVerticalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.reVerticalPrismDirection))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "order-review-label table-rx-td-title"
  }, [_vm._v("LE/OS")]), _vm._v(" "), _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leSegHeight))]), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leocHeight))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leHorizontalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leHorizontalPrismDirection))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leVerticalPrismValue))]) : _vm._e(), _vm._v(" "), (_vm.OrderReturn.includeAdditionalRxFields) ? _c('td', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.leVerticalPrismDirection))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Lens Treatment:")]), _vm._v(" "), _vm._l((_vm.OrderReturn.lensTreatmentDescription), function(tr) {
    return _c('div', {
      staticClass: "order-review-description"
    }, [_vm._v(_vm._s(tr) + " ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Special Instructions:")]), _vm._v("\n                          " + _vm._s(_vm.OrderReturn.specialInstructions1) + "\n  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Frame:")]), _vm._v(" "), _c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.frameManufacturer) + ", " + _vm._s(_vm.OrderReturn.frameBrand) + " " + _vm._s(_vm.OrderReturn.frameModel) + ", " + _vm._s(_vm.OrderReturn.frameEyeSize) + "-" + _vm._s(_vm.OrderReturn.frameTempleLength) + ", " + _vm._s(_vm.OrderReturn.frameColor))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Job Type:")]), _vm._v(" "), _c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.jobTypeDescription))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-7 col-sm-12 col-xs-12"
  }, [_c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingFullName))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingAddressLineOne))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingAddressLineTwo))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "order-review-description"
  }, [_vm._v(_vm._s(_vm.OrderReturn.shippingCity) + ", " + _vm._s(_vm.OrderReturn.shippingState) + " " + _vm._s(_vm.OrderReturn.shippingPostcode))])])])])]), _vm._v(" "), (_vm.MasterAccountType != 'master' && ((_vm.Account.isStandardOrderServiceFee && _vm.OrderReturn.jobType != 'LSF') || (_vm.OrderReturn.jobType == 'LSF' && _vm.Account.isFrameLensServiceFee))) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "order-review-description left"
  }, [_vm._v("Service Fee")]), _vm._v(" "), _c('span', {
    staticClass: "order-review-description right"
  }, [_vm._v("$" + _vm._s(_vm.Account.serviceFeeAmount))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('span', {
    staticClass: "order-review-description right"
  }, [_vm._v("$" + _vm._s(_vm.Account.serviceFeeAmount))])])])]), _vm._v(" "), (_vm.Voucher.Payment) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing top"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("*The voucher provided covers the payment amount for this order.")])]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-10 offset-lg-1"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Sphere")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Cyl")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Axis")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Addition")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Dist. PD")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Near PD")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Seg Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("OC Height")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("H Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Base")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("V Prism")]), _vm._v(" "), _c('th', {
    staticClass: "order-review-label th-responsive"
  }, [_vm._v("Base")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Shipping Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', {
    staticClass: "order-review-label"
  }, [_vm._v("Order Summary:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8"
  }, [_c('label', {
    staticClass: "order-review-label right"
  }, [_vm._v("Total:")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36eb56f6", module.exports)
  }
}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.EyeDoctorInformation),
      expression: "FormInputs.EyeDoctorInformation"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n        Eye Doctor Information\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "margin": "10px 0px"
    }
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.Account.NoEyeDoctor = !_vm.Account.NoEyeDoctor
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("I do not have an eye doctor to add at this time")])]), _vm._v(" "), (!_vm.Account.NoEyeDoctor) ? _c('p', [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.FormInputs.BusinessLabels) ? _c('p', [_vm._v("\n            Please list the information for at least one eye doctor. You can add more later under My Account page.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('p', [_vm._v("\n            Please list the information for at least one eye doctor you contract with or work with regularly. You can add more later under My Account page.\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Account.EyeDoctors), function(doctor, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("NPI Number\n                                "), (_vm.Account.UseLicenseNumber || (!doctor.UseLicenseNumber && !_vm.Account.NoEyeDoctor)) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
      attrs: {
        "data-balloon": _vm.npiTooltip,
        "data-balloon-pos": "down",
        "data-balloon-length": "large"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle-o"
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.NpiNumber),
        expression: "doctor.NpiNumber"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber
      },
      attrs: {
        "type": "text",
        "maxlength": "10",
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      domProps: {
        "value": (doctor.NpiNumber)
      },
      on: {
        "paste": function($event) {
          return _vm.pasteNpiNumber($event)
        },
        "keyup": function($event) {
          return _vm.ValidateNpiNumberEyeDoctor(index)
        },
        "keypress": function($event) {
          return _vm.G_NumberCheck(this.event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "NpiNumber", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber))]) : _vm._e(), _vm._v(" "), (_vm.invalidNpiNumberPaste) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v("Sorry, only numeric NPI values can be pasted here.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Relationship*\n                                "), _c('span', {
      attrs: {
        "data-balloon": _vm.relationshipTooltip,
        "data-balloon-pos": "down",
        "data-balloon-length": "large"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle-o"
    })])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.Role),
        expression: "doctor.Role"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorRole
      },
      staticStyle: {
        "height": "36.5px"
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorRole) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorRole))]) : _vm._e()])]), _vm._v(" "), (!doctor.UseLicenseNumber) ? _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
    }) : _vm._e(), _vm._v(" "), (doctor.UseLicenseNumber) ? _c('div', {
      staticClass: "col-lg-8  col-md-8  col-sm-12  col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("License Number\n                                "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.LicenseNumber),
        expression: "doctor.LicenseNumber"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber
      },
      attrs: {
        "maxlength": "18",
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "text"
      },
      domProps: {
        "value": (doctor.LicenseNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "LicenseNumber", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (doctor.UseLicenseNumber) ? _c('div', {
      staticClass: "col-lg-4  col-md-4  col-sm-12  col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State\n                                "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.State),
        expression: "doctor.State"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorState
      },
      staticStyle: {
        "height": "36.5px"
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "State", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.State), function(value, key) {
      return _c('option', {
        domProps: {
          "value": value
        }
      }, [_vm._v(_vm._s(value))])
    }), 0), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorState) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorState))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('input', {
      staticClass: "form-check-input",
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          doctor.UseLicenseNumber = !doctor.UseLicenseNumber
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label"
    }, [_vm._v("Use License Number")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Doctor's First Name\n                        "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.FirstName),
        expression: "doctor.FirstName"
      }],
      staticClass: "form-control capitalize",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorFirstName
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "text"
      },
      domProps: {
        "value": (doctor.FirstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "FirstName", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorFirstName) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Doctor's Last Name\n                        "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.LastName),
        expression: "doctor.LastName"
      }],
      staticClass: "form-control capitalize",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorLastName
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "text"
      },
      domProps: {
        "value": (doctor.LastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "LastName", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLastName) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Suffix\n                        "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.Suffix),
        expression: "doctor.Suffix"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorSuffix
      },
      staticStyle: {
        "height": "36.5px"
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "Suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.Suffix), function(value, key) {
      return _c('option', {
        domProps: {
          "value": key
        }
      }, [_vm._v(_vm._s(key))])
    }), 0), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorSuffix) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorSuffix))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Doctor's Email Address*")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.EmailAddress),
        expression: "doctor.EmailAddress"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('email'),
        expression: "'email'"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress || _vm.errors.has('email')
      },
      attrs: {
        "name": "email",
        "type": "email",
        "data-vv-as": "email",
        "oninput": "this.value = this.value.toLowerCase()"
      },
      domProps: {
        "value": (doctor.EmailAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "EmailAddress", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('email') && !_vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress),
        expression: "errors.has('email') && !EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.Account.PrimaryContact.IsEyeDoctor && index != 0),
        expression: "Account.PrimaryContact.IsEyeDoctor && index != 0"
      }],
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Year Licensed")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.YearsInPractice),
        expression: "doctor.YearsInPractice"
      }],
      staticClass: "form-control",
      attrs: {
        "maxlength": "4",
        "type": "text"
      },
      domProps: {
        "value": (doctor.YearsInPractice)
      },
      on: {
        "keypress": function($event) {
          return _vm.G_NumberCheck(this.event)
        },
        "keyup": function($event) {
          return _vm.G_NumberOfYearsCheck(doctor, 'YearsInPractice')
        },
        "blur": function($event) {
          return _vm.CheckYearLicense(doctor.YearsInPractice)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "YearsInPractice", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errorMessage.year) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errorMessage.year))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "col-lg-12 offset-lg-5 col-md-12 col-sm-12 col-xs-12"
    }, [(_vm.Account.EyeDoctors.length > 1 && !(_vm.Account.PrimaryContact.IsEyeDoctor && index === 0)) ? _c('button', {
      staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-font-size-17",
      on: {
        "click": function($event) {
          return _vm.RemoveDoctor(index)
        }
      }
    }, [_vm._v("Delete ")]) : _vm._e()]), _c('hr')])])
  }), _vm._v(" "), (_vm.Account.EyeDoctors.length > 1) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }) : _vm._e()], 2), _vm._v(" "), (!_vm.Account.NoEyeDoctor) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "evf-invite col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-8 offset-xs-0 center"
  }, [_c('button', {
    staticClass: "btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-main-blue--hover g-font-size-16 g-rounded-10 g-px-25 g-mb-10 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.AddDoctor()
      }
    }
  }, [_vm._v("Add Another Doctor")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('small', [_vm._v("You will need to enter all the following information when placing an order")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3781fd82", module.exports)
  }
}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../static/assets/include/svg/svg-bg1.svg')",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container registation_content g-pt-50 g-pb-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "g-max-width-645 text-center mx-auto g-mb-0"
  }, [_c('h2', {
    staticClass: "h2 mb-3"
  }, [_vm._v("Changing Life through Lenses® " + _vm._s(new Date().getFullYear()))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Forecast Update")]), _vm._v(" "), _c('p', [_vm._v("\n             Please update your pledge/forecast for " + _vm._s(new Date().getFullYear()) + ". We understand it may\n             be difficult to predict how many you will serve. Please provide a\n             conservative estimate of how many charitable orders you anticipate\n             placing this year. Remember, you can change your forecast number\n             at any time on the My Account page.\n           ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('pledge', {
    attrs: {
      "Account": _vm.Account,
      "PledgeLabel": _vm.pledge,
      "PledgeHelpText": _vm.pledgeHelpText,
      "FormInputs": _vm.FormInputs,
      "OfficeLocationValidationResult": _vm.OfficeLocationValidationResult
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("End of Year Recap")]), _vm._v(" "), _c('p', [_vm._v("Please complete the following questions:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Serve walk ins and sporadic referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Serve walk ins and sporadic referrals in my office") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Serve walk ins and sporadic referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Serve walk ins and sporadic referrals in my office\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Host a vision event(s)",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Host a vision event(s)") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Host a vision event(s)",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Host a vision event(s)\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Partner with a local non profit or school to receive their referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Partner with a local non profit or school to receive their referrals in my office") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Partner with a local non profit or school to receive their referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Partner with a local non profit or school to receive their referrals in my office\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Volunteer at local clinics, health fairs, or vision events",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "Volunteer at local clinics, health fairs, or vision events") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Volunteer at local clinics, health fairs, or vision events",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                 Volunteer at local clinics, health fairs, or vision events\n                 "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastServices),
      expression: "forecastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "I’m not sure",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forecastServices) ? _vm._i(_vm.forecastServices, "I’m not sure") > -1 : (_vm.forecastServices)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forecastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "I’m not sure",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forecastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forecastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forecastServices = $$c
        }
      }
    }
  }), _vm._v("\n                   I’m not sure\n               ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("\n                   " + _vm._s(_vm.q1) + "\n                   ")]), _vm._v(" "), _c('p', [_vm._v("\n                   (Things to consider: Where, who, and when you served, did\n                   you find giving back had a positive impact for you or your\n                   organization)\n                 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1),
      expression: "1"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.UseCase),
      expression: "Account.UseCase"
    }],
    staticClass: "form-control no-arrow-updown",
    class: {
      error_field: false
    },
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.Account.UseCase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "UseCase", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("\n                   " + _vm._s(_vm.q2) + "\n                   ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1),
      expression: "1"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.FeedBack),
      expression: "Account.FeedBack"
    }],
    staticClass: "form-control no-arrow-updown",
    class: {
      error_field: false
    },
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.Account.FeedBack)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "FeedBack", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toBeContactedAsVolunteer),
      expression: "toBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.toBeContactedAsVolunteer) ? _vm._i(_vm.toBeContactedAsVolunteer, null) > -1 : (_vm.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toBeContactedAsVolunteer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toBeContactedAsVolunteer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toBeContactedAsVolunteer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like to be contacted if there are volunteer opportunities in my area.")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n             Thank you for all your hard work and for everything you do to help\n             those in need in your community!\n           ")]), _vm._v(" "), _c('p', [_vm._v("Together, we can keep Changing Life through Lenses.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "disabled": !(
        _vm.Account.PrimaryContact.OfficeLocation.NumberOfJobs > -1 &&
        (_vm.Account.UseCase.trim() != '' ? true : false)
      ),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitForecast()
      }
    }
  }, [_vm._v("\n                 Submit\n               ")])])])])])])]), _vm._v(" "), (_vm.showForecastingModal) ? _c('annual-forecasting-modal') : _vm._e(), _vm._v(" "), (!_vm.isLoadFinish) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-xs-12 col-sm-12 g-pb-20"
  }, [_c('p', [_vm._v("\n                While you may experience ongoing effects\n                 of the pandemic, we want to ensure you have the resources to\n                 support the vision care of your whole community. Essilor\n                 Vision Foundation and Changing Life through Lenses (CLTL)\n                 stands as your partner to help you maintain and increase your\n                 charitable work to provide glasses to those most in need.\n               ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("\n                   How do you plan on serving those patients?\n                   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group g-mb-0"
  }, [_c('h5', [_vm._v("Update your Volunteer Engagement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for being a part of Changing Life through Lenses' (CLTL) extraordinary community of charitable eye doctors, practices and non-profits. Occasionally, we may become aware of volunteer opportunities available in your area, such as:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Volunteering at a regional clinic to conduct vision exams")]), _vm._v(" "), _c('li', [_vm._v("Connecting with a local nonprofit or school requesting vision services")]), _vm._v(" "), _c('li', [_vm._v("Supporting an individual patient inquiring with us about vision services in your area")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-388f7ba8", module.exports)
  }
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.Close()
      }
    }
  }), _vm._v(" "), _c('br')])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-39df4564", module.exports)
  }
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-gray"
  }, [_vm._m(0), _vm._v(" "), _c('help-block')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-lg-between align-items-center"
  }, [_c('div', {
    staticClass: "col-md-6 g-mt-70 g-mb-0--md"
  }, [_c('img', {
    staticClass: "img-fluid u-shadow-v39 g-brd-around g-brd-10 g-brd-white rounded",
    attrs: {
      "src": __webpack_require__(357),
      "alt": "Image Description"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "g-mt-20 text-center"
  }, [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v("Help Page")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("We’re here to support you, whether that’s through hardware or knowledge.")])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ae7b380", module.exports)
  }
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [(_vm.FormInputs.IndividualLabels || _vm.FormInputs.BusinessLabels) ? _c('div', [_vm._v("\n          Association Information and Communication Preferences\n        ")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('div', [_vm._v("Communication Preferences")]) : _vm._e()])]), _vm._v(" "), (
    _vm.FormInputs.IndividualOrganization || _vm.FormInputs.BusinessOrganization
  ) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', [_vm._v(" Please select all of your professional affiliations. ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.CheckboxBusiness), function(value, key, index) {
    return (_vm.FormInputs.BusinessOrganization) ? _c('div', {
      key: index,
      staticClass: "col-lg-6 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.Organizations.List),
        expression: "Account.Organizations.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.Account.Organizations.List) ? _vm._i(_vm.Account.Organizations.List, key) > -1 : (_vm.Account.Organizations.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.Organizations.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.Organizations, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.Organizations, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.Organizations, "List", $$c)
          }
        }
      }
    }), _vm._v("\n              " + _vm._s(key) + "\n            ")])])]) : _vm._e()
  }), 0), _vm._v(" "), _vm._l((_vm.CheckboxIndividual), function(value, key) {
    return (_vm.FormInputs.IndividualOrganization) ? _c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.Organizations.List),
        expression: "Account.Organizations.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.Account.Organizations.List) ? _vm._i(_vm.Account.Organizations.List, key) > -1 : (_vm.Account.Organizations.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.Organizations.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.Organizations, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.Organizations, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.Organizations, "List", $$c)
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(key) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.Account.Organizations.List.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("\n          Please enter any other professional organizations you are associated\n          with separated by semicolon(;).\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Organizations.Others),
      expression: "Account.Organizations.Others"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.Organizations.Others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.Organizations, "Others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom"
  }, [(
    _vm.FormInputs.IndividualOrganization || _vm.FormInputs.BusinessOrganization
  ) ? _c('label', {
    staticClass: "label-heading"
  }, [_vm._v("\n        Communication Preferences\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bot"
  }, [_vm._v("Please confirm communication preferences.")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ToBeContactedAsVolunteer),
      expression: "Account.ToBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.ToBeContactedAsVolunteer) ? _vm._i(_vm.Account.ToBeContactedAsVolunteer, null) > -1 : (_vm.Account.ToBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.ToBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v("\n          I would like to be contacted if there are volunteer opportunities in\n          my area.\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ToReceiveNewsLetter),
      expression: "Account.ToReceiveNewsLetter"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.ToReceiveNewsLetter) ? _vm._i(_vm.Account.ToReceiveNewsLetter, null) > -1 : (_vm.Account.ToReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.ToReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "ToReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "ToReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "ToReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v("\n          I would like email updates from OneSight EssilorLuxottica Foundation.\n        ")])])])]), _vm._v(" "), (_vm.Account.Organizations.List.includes('Team Vision')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Addendum),
      expression: "Account.Addendum"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.Addendum) ? _vm._i(_vm.Account.Addendum, "Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.") > -1 : (_vm.Account.Addendum)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.Addendum,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "Addendum", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "Addendum", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "Addendum", $$c)
        }
      }
    }
  }), _vm._v("\n          Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Addendum),
      expression: "Account.Addendum"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.Addendum) ? _vm._i(_vm.Account.Addendum, "Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.") > -1 : (_vm.Account.Addendum)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.Addendum,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "Addendum", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "Addendum", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "Addendum", $$c)
        }
      }
    }
  }), _vm._v("\n          Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_c('div', [_vm._v("Team Vision Addendum *")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b2f0fac", module.exports)
  }
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoaded) ? _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(4), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Patient Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Examining Doctor:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.doctor.lastName) + ", " + _vm._s(_vm.doctor.firstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted Date:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Participant:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.accountType == 1 ? _vm.Account.primaryContact.firstName + ' ' + _vm.Account.primaryContact.lastName + ' ' + _vm.Account.primaryContact.suffix : _vm.Account.primaryContact.legalName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Participant Phone:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Participant Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Entry ID:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.id))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(10), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Patient Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Examining Doctor:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.doctor.lastName) + ", " + _vm._s(_vm.doctor.firstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted Date:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Participant:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.accountType == 1 ? _vm.Account.primaryContact.firstName + ' ' + _vm.Account.primaryContact.lastName + ' ' + _vm.Account.primaryContact.suffix : _vm.Account.primaryContact.legalName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Participant Phone:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Participant Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Entry ID:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.id))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(12), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    attrs: {
      "type": "button",
      "id": "btnPrint",
      "onclick": "javascript: window.print()",
      "value": "Print"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Exam Summary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Participant Copy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "customerLabel"
    }
  }, [_c('p', [_vm._v("Keep this half for your records.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Exam Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("This document is intended only for record keeping purposes and indicates that an exam was performed but no glasses were prescribed unless otherwise indicated below.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Patient/Exam Notes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Exam Summary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Patient Copy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "patientCopy"
    }
  }, [_c('p', [_vm._v("Keep this half for your records.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Exam Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("This document is intended only for record keeping purposes and indicates that an exam was performed but no glasses were prescribed unless otherwise indicated below.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Patient/Exam Notes")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3bfda0a7", module.exports)
  }
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Professional Information")]) : _c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Eye Doctor Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_vm._l((_vm.AccountView.eyeDoctors), function(doctorItem, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-10 col-md-10 col-sm-10 col-xs-10"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.FormInputs.EyeDoctorName),
        expression: "FormInputs.EyeDoctorName"
      }],
      staticClass: "row"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-12 col-sm-12 col-xs-12"
    }, [((doctorItem.suffix == 'N/A' || doctorItem.suffix == '')) ? _c('p', {
      staticClass: "account_p"
    }, [_vm._v(_vm._s(doctorItem.firstName + " " + doctorItem.lastName))]) : _c('p', {
      staticClass: "account_p"
    }, [_vm._v(_vm._s(doctorItem.firstName + " " + doctorItem.lastName + ", " + doctorItem.suffix))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [_c('p', {
      staticClass: "account_p"
    }, [_vm._v(_vm._s(doctorItem.npiNumber))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [(doctorItem.licenseNumber && doctorItem.state && doctorItem.useLicenseNumber == true) ? _c('p', {
      staticClass: "account_p"
    }, [_vm._v(_vm._s(_vm.IsEmpty(_vm.IsNull(doctorItem.licenseNumber)) + _vm.IsNull(doctorItem.state)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [(doctorItem.yearsInPractice) ? _c('p', {
      staticClass: "account_p"
    }, [_vm._v(_vm._s(doctorItem.yearsInPractice))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.FormInputs.EyeDoctorEmail),
        expression: "FormInputs.EyeDoctorEmail"
      }],
      staticClass: "row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [_c('p', {
      staticClass: "account_p"
    }, [_vm._v(_vm._s(doctorItem.emailAddress))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [(doctorItem.organizations) ? _c('ul', {
      staticClass: "eyeDoctorAssociation_info",
      staticStyle: {
        "list-style": "none",
        "padding-left": "0px"
      }
    }, [_vm._l((doctorItem.organizations.list), function(value, key) {
      return (value != 'Other') ? _c('li', [_vm._v(_vm._s(value))]) : _vm._e()
    }), _vm._v(" "), (doctorItem.organizations.others) ? _c('li', [_vm._v(_vm._s(doctorItem.organizations.others))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "account_p"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-12 col-xs-12 col-sm-12"
    }, [_c('button', {
      staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-mb-10 g-font-size-17",
      on: {
        "click": function($event) {
          return _vm.EditSection(index)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
      staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-font-size-17",
      on: {
        "click": function($event) {
          return _vm.ShowDeleteDoctorModal(index)
        }
      }
    }, [_vm._v("Delete")])])]), _vm._v(" "), (_vm.isOneDoctorRemain) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v("The account requires at least one doctor be associated")]) : _vm._e(), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ProfessionalInfo),
      expression: "FormInputs.ProfessionalInfo"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.npiNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [(_vm.AccountView.licenseNumber && _vm.AccountView.state && _vm.AccountEdit.useLicenseNumber == true) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.IsEmpty(_vm.IsNull(_vm.AccountView.licenseNumber)) + _vm.IsNull(_vm.AccountView.state)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [(_vm.AccountView.primaryContact.yearsInPractice) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.yearsInPractice))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.AccountView.organizations) ? _c('ul', {
    staticClass: "association_info"
  }, [_vm._l((_vm.AccountView.organizations.list), function(value, key) {
    return (value != 'Other') ? _c('li', [_vm._v(_vm._s(value))]) : _vm._e()
  }), _vm._v(" "), (_vm.AccountView.organizations.others) ? _c('li', [_vm._v(_vm._s(_vm.AccountView.organizations.others))]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.EditProfessional()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AddEyeDoctor),
      expression: "FormInputs.AddEyeDoctor"
    }],
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-200 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.ShowAddDoctorModal()
      }
    }
  }, [_vm._v("Add Another Doctor")])])], 2), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('edit-eye-doctor-info', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.EyeDoctorInformation),
      expression: "FormInputs.EyeDoctorInformation"
    }],
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "AccountView": _vm.AccountView,
      "eyeDoctorActive": _vm.eyeDoctorActive,
      "eyeDoctorActiveIndex": _vm.eyeDoctorActiveIndex,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "isFormLoading": _vm.isFormLoading,
      "EyeDoctorValidation": _vm.EyeDoctorValidation
    },
    on: {
      "modalClick": function($event) {
        return _vm.ShowModal()
      },
      "saveDoctorChanges": function($event) {
        return _vm.SaveAccount()
      },
      "npiIsDirty": function($event) {
        return _vm.ValidateNpiNumberEyeDoctor(_vm.eyeDoctorActiveIndex)
      }
    }
  }), _vm._v(" "), _c('edit-professional-info', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ProfessionalInfo),
      expression: "FormInputs.ProfessionalInfo"
    }],
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "AccountValidationResult": _vm.AccountValidationResult,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "modalClick": function($event) {
        return _vm.ShowModal()
      },
      "saveProfessional": function($event) {
        return _vm.SaveProfessionalInfo()
      },
      "npiIsDirty": function($event) {
        return _vm.ValidateNpiNumber()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isDeleteModalShown) ? _c('div', [_c('delete-modal', {
    attrs: {
      "AccountView": _vm.AccountView,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "isFormLoading": _vm.isFormLoading,
      "eyeDoctorActiveIndex": _vm.eyeDoctorActiveIndex
    },
    on: {
      "modalClose": function($event) {
        return _vm.ShowDeleteDoctorModal()
      },
      "delete": function($event) {
        return _vm.DeleteDoctor()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAddModalShown) ? _c('div', [_c('add-doctor', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "isFormLoading": _vm.isFormLoading,
      "eyeDoctorActiveIndex": _vm.eyeDoctorActiveIndex,
      "NewDoctor": _vm.NewDoctor,
      "NewDoctorValidationResult": _vm.NewDoctorValidationResult
    },
    on: {
      "modalClose": function($event) {
        return _vm.ShowAddDoctorModal()
      },
      "AddEyeDoctor": function($event) {
        return _vm.AddDoctorInfo()
      },
      "npiIsDirty": function($event) {
        return _vm.ValidateNpiNumberNewDoctor()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label capitalized-text"
  }, [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("NPI Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("License Number/State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Year Licensed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Doctor's Email Address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("NPI Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("License Number/State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Year Licensed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c623b0c", module.exports)
  }
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bg-img-hero",
    style: ({
      'background-image': 'url(' + _vm.colleague_bg + ')'
    })
  }, [_c('section', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "js-bg-video",
    attrs: {
      "data-hs-bgv-type": "youtube",
      "data-hs-bgv-id": "FxiskmF16gU",
      "data-hs-bgv-loop": "1"
    }
  }, [_c('div', {
    staticClass: "g-bg-cover g-bg-black-opacity-0_6--after g-pos-rel g-z-index-1"
  }, [_c('div', {
    staticClass: "container text-center g-pos-rel g-z-index-1 g-pt-20 g-pb-40"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "g-max-width-645 mx-auto"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EmailAddress),
      expression: "EmailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control g-brd-none g-font-size-16 g-rounded-30 g-px-30 g-py-14 g-mb-20",
    attrs: {
      "type": "text",
      "placeholder": "Enter Email Address",
      "data-vv-as": "email address"
    },
    domProps: {
      "value": (_vm.EmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.EmailAddress = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 g-mt-10"
  }, [_vm._v("\n                   \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 g-mt-10"
  }, [_c('button', {
    staticClass: "btn btn-block g-color-white g-color-main--hover g-bg-primary g-bg-white--hover g-rounded-30 g-py-13 g-font-size-18--md g-font-size-17",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.Referral('Colleague')
      }
    }
  }, [_vm._v("\n                    Invite a colleague\n                  ")])])])]), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask g-z-index-2",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md g-mt-100 g-z-index-10"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _vm._m(1)])])])])])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-mb-40"
  }, [_c('h1', {
    staticClass: "g-color-white g-font-size-60--lg"
  }, [_vm._v("Invite a colleague")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-white-opacity-0_8 g-font-size-20"
  }, [_vm._v("\n                The only way we can solve this problem is by all working together. Enter the email address of another office or a professional colleague, and we’ll send them an invite to sign up for Champions for Sight®!\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h5', {
    staticClass: "g-px-40 g-pb-20"
  }, [_vm._v("Thank you for sharing the program! "), _c('br'), _vm._v("Your colleague will receive an email to register.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f1866ef", module.exports)
  }
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('noscript', [_c('iframe', {
    staticStyle: {
      "display": "none",
      "visibility": "hidden"
    },
    attrs: {
      "src": "https://www.googletagmanager.com/ns.html?id=GTM-MKSJ39Q",
      "height": "0",
      "width": "0"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-417ef92c", module.exports)
  }
}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#efefef"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "g-color-black text-center g-pt-20"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center g-py-5"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4 g-mb-30 g-color-black"
  }, [_c('img', {
    staticClass: "contact-us-icon g-mb-10",
    attrs: {
      "src": __webpack_require__(361)
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "h5 g-font-weight-600 g-mb-5"
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-16"
  }, [_vm._v("support@onesight.org")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 g-mb-30 g-color-black"
  }, [_c('img', {
    staticClass: "contact-us-icon g-mb-10",
    attrs: {
      "src": __webpack_require__(360)
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "h5 g-font-weight-600 g-mb-5"
  }, [_vm._v("Address")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-16"
  }, [_vm._v("13455 Branchview Ln. "), _c('br'), _vm._v(" Dallas, TX 75234")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 g-mb-30 g-color-black"
  }, [_c('img', {
    staticClass: "contact-us-icon g-mb-10",
    attrs: {
      "src": __webpack_require__(362)
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "h5 g-font-weight-600 g-mb-5"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-16"
  }, [_vm._v("(866) 385-0447")])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42a8abd4", module.exports)
  }
}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    class: {
      'spinner-disabled': _vm.disabled
    }
  }, [_c('input', {
    ref: "input",
    staticClass: "form-control",
    class: {
      disabled: true
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "min": _vm.min,
      "step": _vm.step,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.displayValue
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": function($event) {
        return _vm.handleBlur($event.target.value)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.arrowUp.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.arrowDown.apply(null, arguments)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-button spinner-up",
    class: {
      'spinner-button-disabled': _vm.disabled
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.arrowUp
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up spinner-icon-up"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-button spinner-down",
    class: {
      'spinner-button-disabled': _vm.disabled
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.arrowDown
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down spinner-icon-down"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42db20d4", module.exports)
  }
}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Login Information")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [(_vm.LoginErrorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginErrorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "AccountEmailAddress"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.EmailAddress),
      expression: "LoginFormInputs.EmailAddress"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("New Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.emailAddress),
      expression: "LoginEdit.emailAddress"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountEmailAddress
    },
    attrs: {
      "type": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.LoginEdit.emailAddress)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "emailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountEmailAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.EmailAddressConfirm),
      expression: "LoginFormInputs.EmailAddressConfirm"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Confirm Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.emailAddressConfirm),
      expression: "LoginEdit.emailAddressConfirm"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountEmailAddressConfirm
    },
    attrs: {
      "type": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.LoginEdit.emailAddressConfirm)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateConfirmEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "emailAddressConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountEmailAddressConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountEmailAddressConfirm))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.NewPassword),
      expression: "LoginFormInputs.NewPassword"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.newPassword),
      expression: "LoginEdit.newPassword"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountPassword, error_field2: _vm.hasPasswordError
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.LoginEdit.newPassword)
    },
    on: {
      "keyup": function($event) {
        return _vm.CheckPasswordDigits();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "newPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountPassword))]) : (_vm.hasPasswordError && !_vm.LoginValidationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasPasswordErrorMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.NewPasswordConfirm),
      expression: "LoginFormInputs.NewPasswordConfirm"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Confirm New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.newPasswordConfirm),
      expression: "LoginEdit.newPasswordConfirm"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.AccountPasswordConfirm, error_field2: _vm.hasConfirmPasswordError
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.LoginEdit.newPasswordConfirm)
    },
    on: {
      "keyup": function($event) {
        return _vm.CheckConfirmPasswordDigits();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "newPasswordConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.AccountPasswordConfirm))]) : _vm._e(), _vm._v(" "), (_vm.hasConfirmPasswordError && !_vm.LoginValidationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasConfirmPasswordErrorMessage))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "background-color": "whitesmoke",
      "padding-top": "15px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.LoginFormInputs.Password),
      expression: "LoginFormInputs.Password"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LoginEdit.password),
      expression: "LoginEdit.password"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.LoginValidationResult.OldAccountPassword
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.LoginEdit.password)
    },
    on: {
      "keyup": function($event) {
        return _vm.CheckMatchCurrentPassword()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.LoginEdit, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.LoginValidationResult.OldAccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.LoginValidationResult.OldAccountPassword))]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v("Email Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v("Password:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v("Current Password*\n                    "), _c('span', {
    attrs: {
      "data-balloon": "To change your email or password enter your existing password in the Current Password field.",
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43df32a9", module.exports)
  }
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row g-mb-40 div-spacing-top"
  }, _vm._l((_vm.frameList), function(frame, key) {
    return _c('div', {
      key: key,
      staticClass: "col-lg-3 g-mb-30"
    }, [_c('article', [_c('div', {
      staticClass: "gray-border"
    }, [_c('swiper', {
      staticClass: "swiper-wrapper",
      attrs: {
        "options": frame.swiperOptionSingle
      }
    }, [_vm._l((frame.imageUrl), function(pic, index) {
      return _c('swiper-slide', {
        key: index
      }, [_c('div', {
        staticClass: "location_img swiper-slide",
        on: {
          "click": function($event) {
            return _vm.ShowFrameModal(frame.imageUrl, index)
          }
        }
      }, [(frame.isOutOfStock[index] || frame.isLowStock[index]) ? _c('div', {
        staticClass: "stock-banner"
      }, [_c('label', {
        staticClass: "stock-text"
      }, [_c('span', [_vm._v("Low Stock")])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "frame-pic-div",
        class: {
          'lowstock': frame.isLowStock[index], 'nostock': frame.isOutOfStock[index]
        }
      }, [_c('img', {
        staticClass: "img-fluid image-align-vert-hor",
        attrs: {
          "src": pic,
          "alt": "Loading image..."
        },
        on: {
          "error": function($event) {
            return _vm.ImageExists(pic, key, index)
          }
        }
      })])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "level3-gallery-prev swiper-button-prev",
      attrs: {
        "slot": "button-prev",
        "id": frame.idList.prevEl
      },
      slot: "button-prev"
    }), _vm._v(" "), _c('div', {
      staticClass: "level3-gallery-next swiper-button-next",
      attrs: {
        "slot": "button-next",
        "id": frame.idList.nextEl
      },
      slot: "button-next"
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "g-brd-x g-brd-gray-light-v3 g-bg-white gray-border"
    }, [_c('swiper', {
      staticClass: "swiper-wrapper",
      attrs: {
        "options": _vm.swiperOption
      }
    }, _vm._l((frame.imageUrl), function(pic, index) {
      return _c('swiper-slide', {
        key: index
      }, [_c('div', {
        staticClass: "location_img swiper-slide gray-border overflow-hidden"
      }, [(frame.isOutOfStock[index] || frame.isLowStock[index]) ? _c('div', {
        staticClass: "stock-banner-sm"
      }, [_c('label', {
        staticClass: "stock-text-sm"
      }, [_c('span', [_vm._v("Low Stock")])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "center frame-thumbnail-div",
        class: {
          'lowstock': frame.isLowStock[index], 'nostock': frame.isOutOfStock[index]
        }
      }, [_c('img', {
        staticClass: "img-fluid image-align-vert-hor",
        attrs: {
          "src": pic,
          "alt": "Loading image..."
        }
      })])])])
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "g-pa-25 gray-border frame-list-description1-height"
    }, [_c('label', {
      staticClass: "g-font-weight-600 frame-label"
    }, [_vm._v("Name:")]), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.name))]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 mb-1 frame-label"
    }, [_vm._v("Color: ")]), _vm._v(" "), _vm._l((frame.color), function(color, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(color)), (!(index == frame.color.length - 1)) ? _c('span', [_vm._v(", ")]) : _vm._e()])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Frame Type: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameType) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Measurements: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.eyeSize) + " - " + _vm._s(frame.dbl) + " - " + _vm._s(frame.templeLength))]), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
      staticClass: "g-pa-25 gray-border frame-list-description2-height"
    }, [_c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Manufacturer: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.manufacturer) + " ")]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Brand: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameBrand) + " ")])])])])
  }), 0), _vm._v(" "), (_vm.isModalShown) ? _c('frame-modal', {
    attrs: {
      "images": _vm.selectedImages,
      "imageIndex": _vm.imageIndex
    },
    on: {
      "close": function($event) {
        return _vm.ToggleModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44345592", module.exports)
  }
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isResendModalShown) ? _c('div', [(_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "margin-top": "150px"
    }
  }, [(_vm.ResetStatus) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Success!")]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("A new activation email has been sent to you. Please check your inbox.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "passwordReset-header"
  })])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4488876c", module.exports)
  }
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Login Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.emailAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.password))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.EditSection()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('edit-login-info', {
    attrs: {
      "LoginFormInputs": _vm.LoginFormInputs,
      "LoginValidationResult": _vm.LoginValidationResult,
      "LoginErrorMessage": _vm.LoginErrorMessage,
      "LoginEdit": _vm.LoginEdit
    },
    on: {
      "ValidateEmail": function($event) {
        return _vm.IsEmailAddressValid()
      },
      "confirmEmail": function($event) {
        return _vm.ValidateMatchEmail()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.SaveLoginInformation()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Email Address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Password")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45707c33", module.exports)
  }
}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDeleteModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-delete-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-xs-12 g-mb-10",
    staticStyle: {
      "padding": "10px 20px",
      "background-color": "whitesmoke"
    }
  }, [_c('div', _vm._l((_vm.AccountView.eyeDoctors), function(doctorItem, index) {
    return _c('div', [(index == _vm.doctorIndex) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.FormInputs.EyeDoctorName),
        expression: "FormInputs.EyeDoctorName"
      }],
      staticClass: "row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-12 col-sm-12 col-xs-12"
    }, [_c('p', {
      staticClass: "doctor_p"
    }, [_vm._v(_vm._s(doctorItem.firstName + " " + doctorItem.lastName + ", " + doctorItem.suffix))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [_c('p', {
      staticClass: "doctor_p"
    }, [_vm._v(_vm._s(doctorItem.npiNumber))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [(doctorItem.licenseNumber && doctorItem.state && doctorItem.useLicenseNumber == true) ? _c('p', {
      staticClass: "doctor_p"
    }, [_vm._v(_vm._s(_vm.IsEmpty(_vm.IsNull(doctorItem.licenseNumber)) + _vm.IsNull(doctorItem.state)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [(doctorItem.yearsInPractice) ? _c('p', {
      staticClass: "doctor_p"
    }, [_vm._v(_vm._s(doctorItem.yearsInPractice) + " years")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.FormInputs.EyeDoctorEmail),
        expression: "FormInputs.EyeDoctorEmail"
      }],
      staticClass: "row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
    }, [_c('p', {
      staticClass: "doctor_p"
    }, [_vm._v(_vm._s(doctorItem.emailAddress))])])]), _vm._v(" "), _vm._m(6, true)])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.DeleteDoctor()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("No")])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "doctor_title_msg"
  }, [_vm._v("Are you sure you want to delete this doctor's information from your account?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "doctor_label"
  }, [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "doctor_label"
  }, [_vm._v("NPI Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "doctor_label"
  }, [_vm._v("License Number/State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "doctor_label"
  }, [_vm._v("Years in Practice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "doctor_label"
  }, [_vm._v("Doctor's Email Address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "doctor_label"
  }, [_vm._v("Professional Associations")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "doctor_p"
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45e37ab2", module.exports)
  }
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Lab Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v("At this time, orders are being routed to designated labs. \n          Please check your order confirmation to find the mailing address of the lab for that order. \n          Check the Track Order page of the website for information about order status. Contact support if you have any questions.\n        ")])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46525952", module.exports)
  }
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.Order.jobType == 'FTC') ? _c('div', [_c('p', [_vm._v("If needed, keep this half for your records")])]) : _c('div', [_c('p', [_vm._v("If needed, keep this half for your records")])]), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(3), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.accountType == 1 ? _vm.Account.primaryContact.firstName + ' ' + _vm.Account.primaryContact.lastName + ' ' + _vm.Account.primaryContact.suffix : _vm.Account.primaryContact.legalName) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Order.shippingFullName) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.Order.shippingAddressLineOne) + " " + _vm._s(_vm.Order.shippingAddressLineTwo) + " " + _vm._s(_vm.Order.shippingCity) + " " + _vm._s(_vm.Order.shippingState) + " " + _vm._s(_vm.Order.shippingPostcode))]), _vm._v(" "), _c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reDistPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.distancePD))])]), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reNearPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.nearPD))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leNearPD))]) : _vm._e()])])])]), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('div', [_c('table', [_c('tbody', [_c('tr'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reocHeight))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leocHeight))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lens Information")]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Frame Information")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.jobTypeDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Manufacturer")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameManufacturer))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Lens Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensTypeDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Brand")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameBrand))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Design")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensDesignDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Name/Model")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameModel))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Material")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensMaterialDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Frame Type")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [(_vm.Order.jobType != 'UNC') ? _c('span', [_vm._v(_vm._s(_vm.Order.frameTypeDescription))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Treatment(s)")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, _vm._l((_vm.Order.lensTreatmentDescription), function(lensItem) {
    return _c('ul', [_c('li', [_vm._v(_vm._s(lensItem))])])
  }), 0)]), _vm._v(" "), _c('tr', [(_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Color")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameColor))]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Eye Size")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameEyeSize))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('table', [_c('tbody', [_vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('table', [_c('tbody', [_vm._m(8), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone #")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("(866) 385-0447"))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet) + " " + _vm._s(_vm.Order.orderLab.shippingCity) + " " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])])]), _vm._v(" "), (_vm.Order.jobType == 'FTC') ? _c('div', {
    staticClass: "container"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(11), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.accountType == 1 ? _vm.Account.primaryContact.firstName + ' ' + _vm.Account.primaryContact.lastName + ' ' + _vm.Account.primaryContact.suffix : _vm.Account.primaryContact.legalName) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Order.shippingFullName) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.Order.shippingAddressLineOne) + " " + _vm._s(_vm.Order.shippingAddressLineTwo) + " " + _vm._s(_vm.Order.shippingCity) + " " + _vm._s(_vm.Order.shippingState) + " " + _vm._s(_vm.Order.shippingPostcode))]), _vm._v(" "), _c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reDistPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.distancePD))])]), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reNearPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.nearPD))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leNearPD))]) : _vm._e()])])])]), _vm._v(" "), _c('div', [(_vm.Order.AdditionalRXFields) ? _c('table', [_c('tbody', [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reocHeight))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leocHeight))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(16), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.jobTypeDescription))]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameManufacturer))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Lens Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensTypeDescription))]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameBrand))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Design")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensDesignDescription))]), _vm._v(" "), _c('th', [_vm._v("Name/Model")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameModel))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Material")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensMaterialDescription))]), _vm._v(" "), _c('th', [_vm._v("Frame Type")]), _vm._v(" "), _c('td', [(_vm.Order.jobType != 'UNC') ? _c('span', [_vm._v(_vm._s(_vm.Order.frameTypeDescription))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Treatment(s)")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, _vm._l((_vm.Order.lensTreatmentDescription), function(lensItem) {
    return _c('ul', [_c('li', [_vm._v(_vm._s(lensItem))])])
  }), 0)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Color")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameColor))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Eye Size")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameEyeSize))])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "border": "5px dashed red"
    }
  }, [_c('tbody', [_vm._m(18), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone #")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("(866) 385-0447"))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet) + " " + _vm._s(_vm.Order.orderLab.shippingCity) + " " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    attrs: {
      "type": "button",
      "id": "btnPrint",
      "onclick": "javascript: window.print()",
      "value": "Print"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Order Summary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Participant Copy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Participant Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Prescription")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Sphere")]), _vm._v(" "), _c('th', [_vm._v("Cyl")]), _vm._v(" "), _c('th', [_vm._v("Axis")]), _vm._v(" "), _c('th', [_vm._v("Addition")]), _vm._v(" "), _c('th', [_vm._v("Seg. Height")]), _vm._v(" "), _c('th', [_vm._v("Dist PD")]), _vm._v(" "), _c('th', [_vm._v("Near PD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Horizontal Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("Vertical Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("OC Height")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title"
  }, [_vm._v("Dispensing Notes (Not Sent to Lab)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lab Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Order Summary - Lab Copy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Send this half with the frame to the lab within 1-2 business days."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Frames shipped to the wrong lab will be drastically delayed or lost.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Participant Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Prescription")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Sphere")]), _vm._v(" "), _c('th', [_vm._v("Cyl")]), _vm._v(" "), _c('th', [_vm._v("Axis")]), _vm._v(" "), _c('th', [_vm._v("Addition")]), _vm._v(" "), _c('th', [_vm._v("Seg. Height")]), _vm._v(" "), _c('th', [_vm._v("Dist PD")]), _vm._v(" "), _c('th', [_vm._v("Near PD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Additional RX Fields")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Horizontal Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("Vertical Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("OC Height")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lens Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Frame Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#eeeeee"
    }
  }, [_vm._v("Please do not add any additional order instructions or requests to this sheet. For special order requests, place the order again and check \"The lens options above do not meet the medical needs of this patient\".")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lab Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47870908", module.exports)
  }
}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6  g-py-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.color,
      "multiple": true,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": "Color",
      "selectLabel": " "
    },
    model: {
      value: (_vm.searchValues.Color),
      callback: function($$v) {
        _vm.$set(_vm.searchValues, "Color", $$v)
      },
      expression: "searchValues.Color"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6  g-py-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.frameType,
      "track-by": "code",
      "label": "name",
      "multiple": true,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": "Frame Type",
      "selectLabel": " "
    },
    model: {
      value: (_vm.SelectedFrameType),
      callback: function($$v) {
        _vm.SelectedFrameType = $$v
      },
      expression: "SelectedFrameType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-12 col-xs-12 form-inline"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-12 col-xs-12 center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 form-inline"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValues.MinRange),
      expression: "searchValues.MinRange"
    }],
    staticClass: "form-control max-width-number g-my-15",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.searchValues.MinRange)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.Search()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchValues, "MinRange", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mar-right-left-10"
  }, [_vm._v("To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValues.MaxRange),
      expression: "searchValues.MaxRange"
    }],
    staticClass: "form-control max-width-number g-my-15",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.searchValues.MaxRange)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.Search()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchValues, "MaxRange", $event.target.value)
      }
    }
  }), _vm._v(" "), ((_vm.searchValues.MinRange < 35 || _vm.searchValues.MaxRange < 35) || (_vm.searchValues.MinRange > 70 || _vm.searchValues.MaxRange > 70)) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("Eye size should be between 35 to 70")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-12 col-xs-12",
    staticStyle: {
      "background-color": ""
    }
  }, [_c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white text-uppercase g-rounded-10",
    attrs: {
      "disabled": _vm.searchValues.MinRange < 35 || _vm.searchValues.MaxRange < 35 || _vm.searchValues.MinRange > 70 || _vm.searchValues.MaxRange > 70
    },
    on: {
      "click": function($event) {
        return _vm.Search()
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn u-btn-primary text-uppercase g-rounded-10",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_vm._v("Reset")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eye-size-range-div"
  }, [_c('p', {
    staticClass: "g-font-size-14"
  }, [_vm._v("Eye Size Range")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-481bc472", module.exports)
  }
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-color": "#efefef",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container g-py-30"
  }, [_c('div', {
    staticClass: "g-max-width-700 text-center mx-auto g-mb-60"
  }, [_c('h2', {
    staticClass: "h1",
    attrs: {
      "id": "errorDiv"
    }
  }, [_vm._v("Resources")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("This page contains resources to help you engage in your community.  If you are looking for help using or navigating this website, check out the "), _c('a', {
    staticClass: "g-font-size-20 g-link-bold",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help page")]), _vm._v(".")])]), _vm._v(" "), _vm._l((_vm.cardItems), function(parentItem, parentIdx) {
    return (_vm.cardItems != null) ? _c('div', {
      staticClass: "card-group d-block d-md-flex g-mx-minus-4"
    }, _vm._l((parentItem), function(item, itemIdx) {
      return _c('div', {
        staticClass: "card g-brd-none g-mx-4 g-mb-8 u-shadow-v38"
      }, [(item.type === 'Card') ? _c('div', [_c('div', {
        staticClass: "card-body g-bg-white rounded g-pa-40"
      }, [(item.iconURL !== null) ? _c('img', {
        staticClass: "resource-page-icon g-mb-20",
        attrs: {
          "src": item.iconURL
        }
      }) : _vm._e(), _vm._v(" "), _c('h3', {
        staticClass: "h3"
      }, [(item.isNew) ? _c('strong', {
        staticStyle: {
          "color": "rgb(166, 29, 55)"
        }
      }, [_vm._v("New! ")]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "g-color-text-light-v1 g-font-size-20--md g-font-size-18"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.description)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "g-view-document g-px-40"
      }, [(!item.isModal && !item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
        attrs: {
          "href": item.linkURL,
          "target": "_blank"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (!item.isModal && item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
        on: {
          "click": function($event) {
            return _vm.RouterRedirect(item.linkURL)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.isModal) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
        on: {
          "click": function($event) {
            return _vm.ToggleJotForm(item.jotFormID)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.downloadURL != null) ? _c('a', {
        staticClass: "g-float-right g-color-main g-color-primary--hover",
        attrs: {
          "href": item.downloadURL,
          "target": "_blank",
          "download": "EVF Resource FIle"
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa fa-arrow-circle-down",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (item.type === 'List') ? _c('div', [_c('div', {
        staticClass: "card-body g-bg-white rounded"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-8"
      }, [_c('strong', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "g-color-text-light-v1"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.description)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-4 box"
      }, [_c('div', {
        staticClass: "row center-icon"
      }, [(!item.isModal && !item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover ",
        staticStyle: {
          "padding-left": "50px"
        },
        attrs: {
          "href": item.linkURL,
          "target": "_blank"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (!item.isModal && item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover  ",
        staticStyle: {
          "padding-left": "50px"
        },
        on: {
          "click": function($event) {
            return _vm.RouterRedirect(item.linkURL)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.isModal) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover ",
        staticStyle: {
          "padding-left": "50px"
        },
        on: {
          "click": function($event) {
            return _vm.ToggleJotForm(item.jotFormID)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.downloadURL != null) ? _c('a', {
        staticClass: "g-float-right g-color-main g-color-primary--hover",
        attrs: {
          "href": item.downloadURL,
          "target": "_blank",
          "download": "EVF Resource FIle"
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa fa-arrow-circle-down",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()])])])])]) : _vm._e()])
    }), 0) : _vm._e()
  }), _vm._v(" "), (_vm.showJotForm) ? _c('jotform-modal', {
    attrs: {
      "Account": _vm.Account,
      "formID": _vm.jotFormID
    },
    on: {
      "closeJotForm": _vm.ToggleJotForm
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a0502a4", module.exports)
  }
}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "signin-wrapper"
  }, [_c('div', {
    staticClass: "signin-container g-width-400"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeReview()
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "signin"
    }
  }, [_c('div', {
    staticClass: "u-shadow-v35 g-bg-white rounded g-px-20 g-py-20"
  }, [_c('div', {
    staticClass: "g-mb-20"
  }, [_c('label', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.EmailAddress),
      expression: "Account.EmailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control login_input g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12",
    attrs: {
      "name": "email",
      "oninput": "this.value = this.value.toLowerCase()",
      "type": "email",
      "data-vv-as": "email",
      "placeholder": "John@gmail.com"
    },
    domProps: {
      "value": (_vm.Account.EmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "EmailAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "g-mb-20"
  }, [_c('label', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Password),
      expression: "Account.Password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control login_input g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12",
    attrs: {
      "name": "password",
      "type": "password",
      "data-vv-as": "password",
      "placeholder": "**********"
    },
    domProps: {
      "value": (_vm.Account.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "Password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginfalse && !_vm.isForActivation),
      expression: "isLoginfalse && !isForActivation"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginfalse && _vm.isForActivation),
      expression: "isLoginfalse && isForActivation"
    }],
    staticClass: "error-message"
  }, [_vm._v("\n                        You need to activate your account using the activation link sent to your email. "), _c('a', {
    staticClass: "btn btn-default hover",
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": function($event) {
        return _vm.ShowResendModal()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to resend your activation email.\n                    ")]), _vm._v(" "), (_vm.isGenericError) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("An unexpected error has occurred. Please try again in a few minutes.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('a', {
    staticClass: "btn btn-default hover g-font-size-16",
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-font-size-16 rounded g-px-25 g-py-",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoginLoading
    }
  }, [_vm._v("Log In\n                        "), (_vm.isLoginLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "u-shadow-v35 g-bg-white rounded g-py-10 g-mt-20"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }, [_vm._v("Do not have an account?")]), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13",
    on: {
      "click": function($event) {
        return _vm.RedirectToSignUp()
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-25 g-py-13",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Demo')
      }
    }
  }, [_vm._v("View Demo")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  })])])])]), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('forgot-password', {
    on: {
      "clicked": function($event) {
        return _vm.ShowModal()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isResendModalShown) ? _c('div', [_c('resend-activation', {
    attrs: {
      "RequestEmail": _vm.Account.EmailAddress
    },
    on: {
      "clicked": function($event) {
        return _vm.ShowResendModal()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signin-header mb-3"
  }, [_c('h1', [_c('strong', [_vm._v("Login to "), _c('br'), _vm._v("Champions for Sight")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0"
  }, [_c('i', {
    staticClass: "icon-education-166 u-line-icon-pro"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0"
  }, [_c('i', {
    staticClass: "icon-finance-135 u-line-icon-pro"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bc74044", module.exports)
  }
}

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "max-height": "700px",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Professional Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountNpiNumber),
      expression: "FormInputs.AccountNpiNumber"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("zNPI Number"), (!_vm.AccountEdit.useLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.npiNumber),
      expression: "AccountEdit.npiNumber"
    }],
    staticClass: "form-control input_field",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.AccountEdit.npiNumber)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.ValidateNpiNumber()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit, "npiNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountNpiNumber))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.AccountHasNpiNumber),
      expression: "FormInputs.AccountHasNpiNumber"
    }],
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.useLicenseNumber),
      expression: "AccountEdit.useLicenseNumber"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountEdit.useLicenseNumber) ? _vm._i(_vm.AccountEdit.useLicenseNumber, "") > -1 : (_vm.AccountEdit.useLicenseNumber)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountEdit.useLicenseNumber,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountEdit, "useLicenseNumber", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountEdit, "useLicenseNumber", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountEdit, "useLicenseNumber", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("I don't have an NPI number")])])])])]), _vm._v(" "), (_vm.AccountEdit.useLicenseNumber == true) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("License Number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.licenseNumber),
      expression: "AccountEdit.licenseNumber"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.AccountValidationResult.AccountLicenseNumber
    },
    attrs: {
      "maxlength": "18",
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.licenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit, "licenseNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.AccountLicenseNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountLicenseNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.state),
      expression: "AccountEdit.state"
    }],
    staticClass: "form-control select_field",
    class: {
      error_field: _vm.AccountValidationResult.AccountState
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.AccountEdit, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.AccountValidationResult.AccountState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountState))]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Year Licensed")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.yearsInPractice),
      expression: "AccountEdit.primaryContact.yearsInPractice"
    }],
    staticClass: "form-control input_field",
    attrs: {
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.yearsInPractice)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.G_NumberOfYearsCheck(_vm.AccountEdit.primaryContact, 'yearsInPractice');
      },
      "blur": function($event) {
        return _vm.CheckYearLicense(_vm.AccountEdit.primaryContact.yearsInPractice)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact, "yearsInPractice", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errorMessage.year) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage.year))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.CheckboxIndividual), function(value, key) {
    return (_vm.FormInputs.IndividualOrganization) ? _c('div', {
      staticClass: "form-check"
    }, [(_vm.AccountEdit.organizations) ? _c('span', {
      staticClass: "form-check-label account_p"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.AccountEdit.organizations.list),
        expression: "AccountEdit.organizations.list"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.AccountEdit.organizations.list) ? _vm._i(_vm.AccountEdit.organizations.list, key) > -1 : (_vm.AccountEdit.organizations.list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.AccountEdit.organizations.list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.AccountEdit.organizations, "list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.AccountEdit.organizations, "list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.AccountEdit.organizations, "list", $$c)
          }
        }
      }
    }), _vm._v("\n                                          " + _vm._s(key) + "\n                                      ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.AccountEdit.organizations.list.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "account_p"
  }, [_vm._v("Please enter any other professional organizations you are associated with separated by semicolon(;).")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.organizations.others),
      expression: "AccountEdit.organizations.others"
    }],
    staticClass: "form-control input_field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.organizations.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.organizations, "others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.SaveInfo()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("NPI Number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("License Number/State:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Year Licensed:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations:")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bcc0a73", module.exports)
  }
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HelpPage"
  }, [_c('header-component'), _vm._v(" "), _c('help-article'), _vm._v(" "), _c('help-contact'), _vm._v(" "), _c('help-info'), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d01ded0", module.exports)
  }
}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 g-bg-main g-py-30 g-px-30 text-center g-rounded-15"
  }, [_c('p', {
    staticClass: "g-color-white"
  }, [_vm._v("Need to order your frame collection?")]), _vm._v(" "), _c('button', {
    staticClass: "btn u-btn-blue g-color-white g-rounded-10 g-px-15",
    on: {
      "click": function($event) {
        return _vm.ScrollBottom()
      }
    }
  }, [_vm._v("Click Here")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55316983", module.exports)
  }
}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Shipping Address")]) : _c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Location Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactIsMultiLocation),
      expression: "FormInputs.ContactIsMultiLocation"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Multi-Location Business")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Multi-Location Organization")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [(_vm.AccountView.primaryContact.isMultiLocation == true) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v("Yes")]) : _c('p', {
    staticClass: "account_p"
  }, [_vm._v("No")])])]), _vm._v(" "), (_vm.FormInputs.OfficeLocationName) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p capitalized-text"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p capitalized-text"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.streetAddress + ", " + _vm.IsEmpty(_vm.IsNull(_vm.AccountView.primaryContact.officeLocation.suite)) + " " + _vm.AccountView.primaryContact.officeLocation.city + ", " + _vm.AccountView.primaryContact.officeLocation.state + " " + _vm.AccountView.primaryContact.officeLocation.zip))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationPhoneNumber),
      expression: "FormInputs.OfficeLocationPhoneNumber"
    }],
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [(_vm.AccountView.primaryContact.officeLocation.countryCode) ? _c('span', [_vm._v("(")]) : _vm._e(), _vm._v(_vm._s((_vm.AccountView.primaryContact.officeLocation.countryCode || ""))), (_vm.AccountView.primaryContact.officeLocation.countryCode) ? _c('span', [_vm._v(")")]) : _vm._e(), _vm._v(" " + _vm._s((_vm.AccountView.primaryContact.officeLocation.areaCode || ""))), (_vm.AccountView.primaryContact.officeLocation.areaCode) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s((_vm.AccountView.primaryContact.officeLocation.phone || "")))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationEmailAddress),
      expression: "FormInputs.OfficeLocationEmailAddress"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Office Contact Email Address")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location Contact Email Address")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.emailAddress))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContact),
      expression: "FormInputs.OfficeLocationContact"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Office Contact")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location Contact")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.IsNull(_vm.AccountView.primaryContact.officeLocation.contactFirstName) + " " + _vm.IsNull(_vm.AccountView.primaryContact.officeLocation.contactLastName)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContactRole),
      expression: "FormInputs.OfficeLocationContactRole"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Role in Business")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Role in Organization")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [(_vm.AccountView.primaryContact.officeLocation.contactRole) ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.contactRoleDesc))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.EditSection()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('edit-location-info', {
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "OfficeLocationValidationResult": _vm.OfficeLocationValidationResult,
      "State": _vm.State,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "IsValidNPI": _vm.IsValidNPI,
      "IsAddressValidating": _vm.IsAddressValidating
    },
    on: {
      "addressCheck": function($event) {
        return _vm.ValidateAddress()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.SaveAccount()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Shipping Address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Phone Number")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55e85992", module.exports)
  }
}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordersubmit"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-my-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 center"
  }, [_c('p', {
    staticClass: "contract-header"
  }, [_vm._v("Congratulations")]), _vm._v(" "), _c('p', [_vm._v("Your frame collection order has successfully been placed!")]), _vm._v(" "), _c('p', [_vm._v("Your collection will arrive in 2 to 4 weeks.")]), _vm._v(" "), _c('p', [_vm._v("Your will receipt will be emailed to you.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Home')
      }
    }
  }, [_vm._v("Return Home")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Order')
      }
    }
  }, [_vm._v("Place New Order")])])])])])]), _vm._v(" "), (_vm.isBillingShown) ? _c('frame-shipping-billing', {
    on: {
      "close": function($event) {
        return _vm.ToggleBilling()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5761d19a", module.exports)
  }
}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content g-mt-170"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.Close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row g-my-20 g-mx-20"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15"
  }, [_c('label', [_vm._v("E-Order #:")]), _c('span', [_vm._v(" " + _vm._s(_vm.orderNumber))]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Status:")]), _c('span', [_vm._v(" " + _vm._s(_vm.visionWebOrderStatus))]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Last Updated:")]), _c('span', [_vm._v(" " + _vm._s(_vm.FormatDateToLocal(_vm.dateSubmitted)))]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.Close()
      }
    }
  }, [_vm._v("Close")])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-576ec926", module.exports)
  }
}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "nonprofit-modal-msg"
  }), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: " padding-left col-lg-11 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "no-margin-bot"
  }, [_vm._v("EVF launched the Changing Life through Lenses® (CLTL) Relief Fund to help support and expand the charitable efforts of doctors and nonprofits in response to the increasing need. CLTL participants who provide vision services to Eligible Patients between June 1 through December 31, 2021, can receive funds of up to $1,500.\n"), _c('b', [_c('router-link', {
    attrs: {
      "to": {
        name: 'CovidReliefRegistration'
      },
      "target": "_blank"
    }
  }, [_vm._v("Learn More ")])], 1), _c('br')]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom"
  }, [_c('label', {
    staticClass: "radio form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CovidReliefParticipantStatus),
      expression: "CovidReliefParticipantStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "yesiwant",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.CovidReliefParticipantStatus, "yes")
    },
    on: {
      "change": function($event) {
        _vm.CovidReliefParticipantStatus = "yes"
      }
    }
  }), _vm._v("\n                                        I AGREE and am interested in participating in CLTL Relief.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CovidReliefParticipantStatus),
      expression: "CovidReliefParticipantStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "nothanks",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.CovidReliefParticipantStatus, "no")
    },
    on: {
      "change": function($event) {
        _vm.CovidReliefParticipantStatus = "no"
      }
    }
  }), _vm._v("\n                                        I DISAGREE and am not interested in participating in CLTL Relief."), _c('br'), _vm._v(" "), ((_vm.CovidReliefParticipantStatus == 'no')) ? _c('small', [_vm._v(" No problem, if you change your mind, you can enroll later on the Resources page.")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CovidReliefParticipantStatus),
      expression: "CovidReliefParticipantStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "remindLater",
      "value": "remindLater"
    },
    domProps: {
      "checked": _vm._q(_vm.CovidReliefParticipantStatus, "remindLater")
    },
    on: {
      "change": function($event) {
        _vm.CovidReliefParticipantStatus = "remindLater"
      }
    }
  }), _vm._v("\n                                        I am not ready to decide right now, remind me later.                                        "), ((_vm.CovidReliefParticipantStatus == 'remindLater')) ? _c('small', [_c('br'), _vm._v(" No problem, we'll show you this screen again next time you login.")]) : _vm._e()]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p')])]), _vm._v(" "), (_vm.isFormLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "disabled": !(_vm.CovidReliefParticipantStatus.trim() != '' ? true : false),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS()
      }
    }
  }, [_vm._v("Submit")])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_c('div', [_vm._v("\nChanging Life through Lenses® Relief Fund (Limited Time Only!)\n                                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("                                    Select I AGREE and Submit below to complete your registration for Relief!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "g-font-size-18--md g-font-size-16"
  }, [_c('small', [_c('li', [_vm._v("Relief is intended to help support costs for vision services including identifying, qualifying and examining Eligible Patients that result in glasses ordered on changinglifethroughlenses.org; orders of second pairs for one Eligible Patient will not count for two patients")]), _vm._v(" "), _c('li', [_vm._v("Participant will not bill Medicare, Medicaid and other Federal health care programs or third party insurers for services supported by this Relief.")]), _vm._v(" "), _c('li', [_vm._v("Relief amount is based on vision services supporting (Tier 1 - $150): 2 or more, (Tier 2 - $900): 12 or more or (Tier 3 - $1,500): 20 or more Eligible Patients with payment contingent upon completion of survey and W9.")]), _vm._v(" "), _c('li', [_c('b', [_c('a', {
    attrs: {
      "href": "https://drive.google.com/file/d/1tR14hA3fqKN0fGNrCHlqf-SW_Kuk7gJg/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("Click here")])]), _vm._v(" for Terms and Conditions")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c78d360", module.exports)
  }
}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((_vm.Order.IsExtra == false) || (_vm.Order.isExtra == false)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Patient DOB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatDOB),
      expression: "Order.PatDOB"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderPatDOBAge
    },
    attrs: {
      "type": "text",
      "placeholder": "MM/DD/YYYY"
    },
    domProps: {
      "value": (_vm.Order.PatDOB)
    },
    on: {
      "keyup": function($event) {
        return _vm.ComputeAge(_vm.Order.PatDOB)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "PatDOB", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderPatDOBAge) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderPatDOBAge))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Age*")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.Age),
      expression: "Order.Age"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderAge
    },
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.Order.Age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "Age", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.ValidationResult.OrderAge) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderAge))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Patient Gender")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatGender),
      expression: "Order.PatGender"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "PatGender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Female"
    }
  }, [_vm._v("Female")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Patient Ethnicity")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatEthnicity),
      expression: "Order.PatEthnicity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "PatEthnicity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.Ethnicity), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])]), _vm._v(" "), ((_vm.Order.ShowExtraStudentFields == true)) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-check order-div padding-left"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Ever Worn Glasses? ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.EverWornGlasses),
      expression: "Order.EverWornGlasses"
    }],
    attrs: {
      "type": "radio",
      "name": "EverWornGlasses",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.EverWornGlasses, "Yes")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.Order, "EverWornGlasses", "Yes")
      }, function($event) {
        return _vm.ComputeFirstTimeWear(_vm.Order.EverWornGlasses)
      }]
    }
  }), _vm._v(" Yes")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.EverWornGlasses),
      expression: "Order.EverWornGlasses"
    }],
    attrs: {
      "type": "radio",
      "name": "EverWornGlasses",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.EverWornGlasses, "No")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.Order, "EverWornGlasses", "No")
      }, function($event) {
        return _vm.ComputeFirstTimeWear(_vm.Order.EverWornGlasses)
      }]
    }
  }), _vm._v(" No")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.EverWornGlasses),
      expression: "Order.EverWornGlasses"
    }],
    attrs: {
      "type": "radio",
      "name": "EverWornGlasses",
      "value": "Unsure"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.EverWornGlasses, "Unsure")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.Order, "EverWornGlasses", "Unsure")
      }, function($event) {
        return _vm.ComputeFirstTimeWear(_vm.Order.EverWornGlasses)
      }]
    }
  }), _vm._v(" Unsure")])])]) : _vm._e(), _vm._v(" "), (!_vm.Order.IsExamOnly && !_vm.Order.ShowExtraStudentFields) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-check order-div padding-left"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("First Time Glasses Wearer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatIsFirstTimeGlassesWearer),
      expression: "Order.PatIsFirstTimeGlassesWearer"
    }],
    attrs: {
      "type": "radio",
      "name": "PatIsFirstTimeGlassesWearer",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.PatIsFirstTimeGlassesWearer, "Yes")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "PatIsFirstTimeGlassesWearer", "Yes")
      }
    }
  }), _vm._v(" Yes")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatIsFirstTimeGlassesWearer),
      expression: "Order.PatIsFirstTimeGlassesWearer"
    }],
    attrs: {
      "type": "radio",
      "name": "PatIsFirstTimeGlassesWearer",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.PatIsFirstTimeGlassesWearer, "No")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "PatIsFirstTimeGlassesWearer", "No")
      }
    }
  }), _vm._v(" No")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatIsFirstTimeGlassesWearer),
      expression: "Order.PatIsFirstTimeGlassesWearer"
    }],
    attrs: {
      "type": "radio",
      "name": "PatIsFirstTimeGlassesWearer",
      "value": "Unsure"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.PatIsFirstTimeGlassesWearer, "Unsure")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "PatIsFirstTimeGlassesWearer", "Unsure")
      }
    }
  }), _vm._v(" Unsure")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-check order-div padding-left"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("First Time Eye Exam")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatIsFirstTimeEyeExam),
      expression: "Order.PatIsFirstTimeEyeExam"
    }],
    attrs: {
      "type": "radio",
      "name": "PatIsFirstTimeEyeExam",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.PatIsFirstTimeEyeExam, "Yes")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "PatIsFirstTimeEyeExam", "Yes")
      }
    }
  }), _vm._v(" Yes")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatIsFirstTimeEyeExam),
      expression: "Order.PatIsFirstTimeEyeExam"
    }],
    attrs: {
      "type": "radio",
      "name": "PatIsFirstTimeEyeExam",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.PatIsFirstTimeEyeExam, "No")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "PatIsFirstTimeEyeExam", "No")
      }
    }
  }), _vm._v(" No")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline form-check-label input-space-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatIsFirstTimeEyeExam),
      expression: "Order.PatIsFirstTimeEyeExam"
    }],
    attrs: {
      "type": "radio",
      "name": "PatIsFirstTimeEyeExam",
      "value": "Unsure"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.PatIsFirstTimeEyeExam, "Unsure")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "PatIsFirstTimeEyeExam", "Unsure")
      }
    }
  }), _vm._v(" Unsure")])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Patient Demographic\n        ")]), _vm._v(" "), _c('p', [_vm._v("Please enter as much of the following information as possible")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5dbec9e7", module.exports)
  }
}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HomePage"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "solid 1px whitesmoke",
      "height": "1px"
    }
  }), _vm._v(" "), _c('home-banner'), _vm._v(" "), _c('home-icons'), _vm._v(" "), _c('home-promo'), _vm._v(" "), _c('home-block'), _vm._v(" "), _c('home-story'), _vm._v(" "), (_vm.elementConfig.inviteColleagueShow || _vm.MasterAccountType == 'master') ? _c('home-invite') : _vm._e(), _vm._v(" "), _c('help-info'), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isCovidReliefModalFormShow) ? _c('div', [_c('covid-relief-modal-form', {
    on: {
      "CtlModalForm": function($event) {
        return _vm.CtlModalForm()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCovidReliefFeedbackResultModalShow) ? _c('div', [_c('covid-relief-feedback-result-modal', {
    attrs: {
      "crps": _vm.crps
    },
    on: {
      "CtlCovidReliefFeedbackResultModal": function($event) {
        return _vm.CtlCovidReliefFeedbackResultModal()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._v(".\n")], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f1a056e", module.exports)
  }
}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-margin order-div"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.JobType), function(jt, index) {
    return _c('div', {
      key: index,
      staticClass: "center",
      class: {
        'col-sm-4': _vm.JobType.length == 3, 'col-sm-6': _vm.JobType.length == 2
      }
    }, [_c('label', {
      staticClass: "g-font-size-20"
    }, [_vm._v(_vm._s(jt.description))]), _vm._v(" "), _c('div', {
      staticClass: "image-div",
      on: {
        "click": function($event) {
          return _vm.CheckVal(jt.type)
        }
      }
    }, [(_vm.Order.JobType != jt.type) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": jt.imageURL
      }
    }) : _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": jt.invertedImageURL
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Order.JobType),
        expression: "Order.JobType"
      }],
      attrs: {
        "type": "radio",
        "name": "frameJobtype"
      },
      domProps: {
        "value": jt.type,
        "checked": _vm._q(_vm.Order.JobType, jt.type)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.Order, "JobType", jt.type)
        }, function($event) {
          return _vm.CheckVal(jt.type)
        }]
      }
    })])
  }), _vm._v(" "), (_vm.ValidationResult.OrderJobType) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.ValidationResult.OrderJobType) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderJobType))]) : _vm._e()]) : _vm._e()], 2)]), _vm._v(" "), ((_vm.Order.JobType == 'FTC') || (_vm.Order.JobType == 'UNC')) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('p', [_vm._v("Please enter as much information as possible to assist the lab in correctly identifying the frame.")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Manufacturer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameManufacturer),
      expression: "Order.FrameManufacturer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "i.e. FGX"
    },
    domProps: {
      "value": (_vm.Order.FrameManufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameManufacturer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Brand")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameBrand),
      expression: "Order.FrameBrand"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "i.e. Lantis"
    },
    domProps: {
      "value": (_vm.Order.FrameBrand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameBrand", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameModel),
      expression: "Order.FrameModel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "i.e. Sidekick, L00015, or Strike/L00132"
    },
    domProps: {
      "value": (_vm.Order.FrameModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameModel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Frame Type"), ((_vm.Order.JobType == 'FTC')) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameType),
      expression: "Order.FrameType"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameType
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "FrameType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.FrameType), function(ft) {
    return _c('option', {
      domProps: {
        "value": ft.code
      }
    }, [_vm._v(_vm._s(ft.name))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderFrameType) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameType))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12 input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Color")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameColor),
      expression: "Order.FrameColor"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameColor
    },
    attrs: {
      "type": "text",
      "placeholder": "i.e. Tortoise, Red"
    },
    domProps: {
      "value": (_vm.Order.FrameColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameColor", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameColor) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameColor))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Eye Size"), (((_vm.Order.JobType == 'FTC' || _vm.Order.JobType == 'UNC') && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "small",
      "font-weight": "normal"
    }
  }, [_vm._v("(A-box)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameEyeSize),
      expression: "Order.FrameEyeSize"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameEyeSize
    },
    attrs: {
      "type": "number",
      "placeholder": "i.e. 50"
    },
    domProps: {
      "value": (_vm.Order.FrameEyeSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameEyeSize", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameEyeSize) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameEyeSize))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("DBL"), (((_vm.Order.JobType == 'UNC' || _vm.Order.JobType == 'FTC') && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameDBL),
      expression: "Order.FrameDBL"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameDBL
    },
    attrs: {
      "type": "number",
      "placeholder": "i.e. 15"
    },
    domProps: {
      "value": (_vm.Order.FrameDBL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameDBL", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameDBL) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameDBL))]) : _vm._e()])]), _vm._v(" "), ((_vm.Order.JobType == 'UNC')) ? _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("B-Box"), ((_vm.Order.JobType == 'UNC' && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameBBox),
      expression: "Order.FrameBBox"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameBBox
    },
    attrs: {
      "type": "number",
      "max": "30",
      "placeholder": "i.e. 25"
    },
    domProps: {
      "value": (_vm.Order.FrameBBox)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameBBox", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameBBox) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameBBox))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.Order.JobType == 'UNC')) ? _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("ED"), ((_vm.Order.JobType == 'UNC' && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameED),
      expression: "Order.FrameED"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameED
    },
    attrs: {
      "type": "number",
      "placeholder": "i.e. 50"
    },
    domProps: {
      "value": (_vm.Order.FrameED)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameED", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameED) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameED))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.Order.JobType == 'FTC')) ? _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Temple Length")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameTempleLength),
      expression: "Order.FrameTempleLength"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "i.e. 140"
    },
    domProps: {
      "value": (_vm.Order.FrameTempleLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameTempleLength", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12"
  }), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Frame Measurements:\n                  "), _c('span', {
    attrs: {
      "data-balloon": "Click this button to view how to find your measurements",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.ShowFrameSizeModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameCheckMeasurements),
      expression: "Order.FrameCheckMeasurements"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.Order.FrameCheckMeasurements,
      "checked": Array.isArray(_vm.Order.FrameCheckMeasurements) ? _vm._i(_vm.Order.FrameCheckMeasurements, _vm.Order.FrameCheckMeasurements) > -1 : (_vm.Order.FrameCheckMeasurements)
    },
    on: {
      "click": function($event) {
        return _vm.ClickNoFrameMeasurements()
      },
      "change": function($event) {
        var $$a = _vm.Order.FrameCheckMeasurements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.Order.FrameCheckMeasurements,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "FrameCheckMeasurements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "FrameCheckMeasurements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "FrameCheckMeasurements", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("I dont have frame measurements (may result in thicker lens)")])])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.JobType == 'LSF' && (this.framePageVisible == 'true' || _vm.MasterAccountType == 'master')) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group order-div order-div"
  }, [_c('label', [_vm._v("Select Your Frame*")]), _vm._v(" "), _c('multiselect', {
    class: {
      error_select: _vm.ValidationResult.OrderFrameId
    },
    attrs: {
      "custom-label": _vm.customLabel,
      "options": _vm.FrameAndLens,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "input": function($event) {
        return _vm.FrameAndLensValue(false)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', [_vm._v("Name/Model: " + _vm._s(props.option.name) + " - Color: " + _vm._s(props.option.color) + " - Eyesize: " + _vm._s(props.option.eyeSize) + " - Frame Type: " + _vm._s(props.option.frameType) + "  " + _vm._s(props.option.catalogId ? '- Catalog -' + _vm.ConvertToTitleCase(props.option.catalogId) : ''))]), _vm._v(" "), _c('span', {
          staticClass: "pull-right stock-text"
        }, [(props.option.isOutOfStock || props.option.isLowStock) ? _c('span', [_vm._v("Low Stock")]) : _vm._e()])]
      }
    }], null, false, 1012384014),
    model: {
      value: (_vm.CurrentFrameAndLens),
      callback: function($$v) {
        _vm.CurrentFrameAndLens = $$v
      },
      expression: "CurrentFrameAndLens"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderFrameId) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameId))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.CurrentFrameAndLens) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-11 col-md-11 col-sm-12 col-xs-12 v-"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "image-div-frame"
  }, [_c('img', {
    staticClass: "img-fluid image-icon",
    attrs: {
      "src": _vm.CurrentFrameAndLens.frontImageURL
    },
    on: {
      "error": function($event) {
        return _vm.ImageExists(_vm.CurrentFrameAndLens)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Model Name/#: " + _vm._s(_vm.CurrentFrameAndLens.name))]), _vm._v(" "), _c('p', [_vm._v("Color: " + _vm._s(_vm.CurrentFrameAndLens.color))]), _vm._v(" "), _c('p', [_vm._v("Measurements: " + _vm._s(_vm.CurrentFrameAndLens.eyeSize) + " - " + _vm._s(_vm.CurrentFrameAndLens.dbl) + " - " + _vm._s(_vm.CurrentFrameAndLens.templeLength))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Frame Type: " + _vm._s(_vm.CurrentFrameAndLens.frameType))]), _vm._v(" "), _c('p', [_vm._v("Manufacturer: " + _vm._s(_vm.CurrentFrameAndLens.manufacturer))]), _vm._v(" "), _c('p', [_vm._v("Brand: " + _vm._s(_vm.CurrentFrameAndLens.frameBrand))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(((_vm.Capping.frameLensCap - _vm.Capping.frameLensCount) <= _vm.Capping.frameLensThreshold) && (_vm.Capping.frameLensCount < _vm.Capping.frameLensCap) && (_vm.MasterAccountType != 'master') && _vm.Capping.isFrameLensCapOn) ? _c('p', {
    staticClass: "warning-text-color"
  }, [_vm._v("\n                    You have " + _vm._s(_vm.Capping.frameLensCap - _vm.Capping.frameLensCount) + " frame & lens orders remaining on your account. After that number is reached you will no longer be able to place frame & lens orders. For more information,\n                    "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.OpenHelpForm()
      }
    }
  }, [_vm._v("contact us.")])]) : _vm._e(), _vm._v(" "), ((_vm.Capping.frameLensCount >= _vm.Capping.frameLensCap) && (_vm.MasterAccountType != 'master') && _vm.Capping.isFrameLensCapOn) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n                    You have reached your Frame and Lens limit and are no longer able to submit these orders. For more information,\n                    "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.OpenHelpForm()
      }
    }
  }, [_vm._v("contact us.")])]) : _vm._e(), _vm._v(" "), ((_vm.Capping.frameLensCount < _vm.Capping.frameLensCap) && (_vm.MasterAccountType != 'master') && _vm.Capping.isFrameLensCapOn && _vm.isFrameLensServiceFee) ? _c('p', {
    staticClass: "lsf-payment"
  }, [_c('b', [_vm._v("Please Note:")]), _vm._v(" After you submit, you will be charged a service fee for this order.\n                ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseOOSModal()
      }
    }
  }), _vm._v(" "), (_vm.isFormLoading) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('page-loader')], 1) : _c('div', {
    staticClass: "g-mt-20 g-mx-20"
  }, [(_vm.suggestedFrameList.length == 0) ? _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("Out of Stock")]), _vm._v(" "), _c('p', [_vm._v("Sorry, this frame is out of stock. Please select another.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.CloseOOSModal()
      }
    }
  }, [_vm._v("Close")])])])])]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.suggestedFrameList), function(frame, key) {
    return _c('div', {
      key: key,
      staticClass: "col-lg-3 g-mb-30 g-py-5"
    }, [_c('article', [_c('div', {
      staticClass: "gray-border"
    }, [(frame.imageUrl != null || frame.imageUrl != 'NULL') ? _c('div', {
      staticClass: "location_img swiper-slide"
    }, [_c('div', {
      staticClass: "frame-pic-div",
      staticStyle: {
        "height": "150px"
      }
    }, [_c('img', {
      staticClass: "img-fluid image-align-vert-hor",
      attrs: {
        "src": frame.frontImageURL,
        "alt": "Image Description"
      },
      on: {
        "error": function($event) {
          return _vm.ImageExists(frame)
        }
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "g-pa-15 gray-border"
    }, [_c('label', {
      staticClass: "g-font-weight-600 frame-label"
    }, [_vm._v("Name:")]), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.name))]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 mb-1 frame-label"
    }, [_vm._v("Color: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(frame.color))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Frame Type: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameType) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Measurements: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.eyeSize) + " - " + _vm._s(frame.dbl) + " - " + _vm._s(frame.templeLength))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "g-pa-15 gray-border"
    }, [_c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Manufacturer: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.manufacturer) + " ")]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Brand: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameBrand) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
      on: {
        "click": function($event) {
          return _vm.SelectFrameSuggestion(frame)
        }
      }
    }, [_vm._v("SELECT")])])])])
  })], 2)])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isFrameSizeModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseFrameSizeModal()
      }
    }
  }), _vm._v(" "), (_vm.isFormLoading) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('page-loader')], 1) : _c('div', {
    staticClass: "g-mt-20 g-mx-20"
  }, [_c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h4', [_vm._v("How to find frame measurements")]), _vm._v(" "), _c('p', [_vm._v("Providing accurate frame measurements helps the lab determine the best lens for the frame. Most frames will have the measurements printed inside one of the temples. You may also use a PD Ruler to collect the measurements yourself.If you are not able to provide these measurements, we will select default values for you but this may result in a thicker lens.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("You may also use PDP Ruler to collect the measurement your self")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("If you are not able to provide these measurements, we will select default values for you but this may result in a thicker lens.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.CloseFrameSizeModal()
      }
    }
  }, [_vm._v("Close")])])])])])])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Frame Information\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("\n                    Please select the order type from the icons below.*\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("Out of Stock")]), _vm._v(" "), _c('p', [_vm._v("Sorry, the frame you selected is no longer available. Please select another frame from below, or click the X to return to the order.")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "max-width": "750px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": __webpack_require__(359),
      "alt": "Temple size"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "max-width": "750px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": __webpack_require__(358),
      "alt": "Frame Measurement"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5fca6f02", module.exports)
  }
}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.jotFormID) ? _c('iframe', {
    style: (("\n    min-width: 100%;\n    height:" + _vm.iframeHeight + "px;\n    border:none;")),
    attrs: {
      "id": _vm.jotFormElementID,
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "allow": "geolocation; microphone; camera",
      "src": ("https://form.jotform.com/" + _vm.jotFormID + "?" + _vm.prefillFields),
      "frameborder": "0",
      "scrolling": "no"
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-60bbd688", module.exports)
  }
}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.Account.IsCoveredUnderHIPAA) ? _c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n        Terms & Conditions and BAA\n      ")]) : _vm._e(), _vm._v(" "), (_vm.Account.IsCoveredUnderHIPAA) ? _c('p', {
    staticClass: "g-mb-0"
  }, [_c('small', [_vm._v("Please review and accept the below in connection with your\n          registration and participation in the OneSight EssilorLuxottica\n          Foundation's Champions for Sight® program: (i) Terms and Conditions\n          to the Changing Life through Lenses® Agreement (related to the\n          online charitable glasses and resources tool), (ii) Business\n          Associate Agreement (“BAA”) (collectively, the \"Champions for Sight®\n          Contract\"), and (iii) Terms and Conditions to the Grateful Patient™\n          Point of Sale Giving Agreement (related to the point of sale giving\n          campaign tool).")])]) : _vm._e(), _vm._v(" "), (!_vm.Account.IsCoveredUnderHIPAA) ? _c('p', {
    staticClass: "g-mb-0"
  }, [_vm._v("\n        Please review and accept the below Terms and Conditions or\n        "), _c('a', {
    staticClass: "g-font-size-18",
    attrs: {
      "href": "https://drive.google.com/open?id=1DcjwlGpVIiO25W09ai5eVpA8qt-ApTRN",
      "target": "_blank"
    }
  }, [_vm._v("click here")]), _vm._v("\n        to download a copy.\n        ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.TermAgreement),
      expression: "Account.TermAgreement"
    }],
    attrs: {
      "type": "radio",
      "value": "true",
      "name": "TermAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.TermAgreement, "true")
    },
    on: {
      "click": function($event) {
        return _vm.EnableTermAndAgreementSubmitBtn(4, false)
      },
      "change": function($event) {
        return _vm.$set(_vm.Account, "TermAgreement", "true")
      }
    }
  }), _vm._v("\n          I have read and AGREE to all of the above\n          "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.TermAgreement),
      expression: "Account.TermAgreement"
    }],
    attrs: {
      "type": "radio",
      "value": "false",
      "name": "TermAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.TermAgreement, "false")
    },
    on: {
      "click": function($event) {
        return _vm.EnableTermAndAgreementSubmitBtn(4, true)
      },
      "change": function($event) {
        return _vm.$set(_vm.Account, "TermAgreement", "false")
      }
    }
  }), _vm._v("\n          I DO NOT AGREE to all the above\n        ")])]), _vm._v(" "), (
    _vm.agreementOptions.termsAndCondition[4] &&
    _vm.Account.TermAgreement != null
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        You must select \"I Agree\" to submit the form. Please click\n        "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.ShowModalTAC()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us with questions\n        or concerns\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isModalShownTAC) ? _c('div', [_c('portal-form', {
    on: {
      "closeWufoo": function($event) {
        return _vm.CloseModal()
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 feed-back-div",
    attrs: {
      "hidden": ""
    }
  }, [_c('p', [_vm._v("\n        By selecting, “I DO NOT AGREE”, you will not be able to complete your\n        registration for a portal account. If you have any questions or\n        concerns, please send us an email below.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TermsEmail.Name),
      expression: "TermsEmail.Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.TermsEmail.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.TermsEmail, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TermsEmail.Email),
      expression: "TermsEmail.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.TermsEmail.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.TermsEmail, "Email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Please Enter Message Below*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TermsEmail.Message),
      expression: "TermsEmail.Message"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.TermsEmail.Message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.TermsEmail, "Message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 email_box_btn"
  }, [_c('button', {
    staticClass: "evf-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitEmail(1)
      }
    }
  }, [_vm._v("\n            Send\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Electronic Signature*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ParticipantResponsibilitiesSignature),
      expression: "Account.ParticipantResponsibilitiesSignature"
    }],
    staticClass: "form-control",
    class: {
      error_field:
        _vm.AccountValidationResult.AccountParticipantResponsibilitiesSignature,
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.ParticipantResponsibilitiesSignature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "ParticipantResponsibilitiesSignature", $event.target.value)
      }
    }
  }), _vm._v(" "), (
    _vm.AccountValidationResult.AccountParticipantResponsibilitiesSignature
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n          " + _vm._s(_vm.AccountValidationResult.AccountParticipantResponsibilitiesSignature) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Date*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ParticipantResponsibilitiesDate),
      expression: "Account.ParticipantResponsibilitiesDate"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.Account.ParticipantResponsibilitiesDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "ParticipantResponsibilitiesDate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    _vm.Account.IsCoveredUnderHIPAA == true ||
    _vm.Account.IsCoveredUnderHIPAA == null
  ) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.isModalShownBAA) ? _c('div', [_c('portal-form', {
    on: {
      "closeWufoo": function($event) {
        return _vm.CloseModal()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.agreementOptions.termsAndCondition[5] &&
    _vm.Account.BusinessAssociateAgreement != null
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        You must select \"I Agree\" to submit the form. Please click\n        "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.ShowModalBAA()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us with questions\n        or concerns\n      ")]) : _vm._e(), _vm._v(" "), (_vm.Account.BusinessAssociateAgreement == false) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 feed-back-div",
    attrs: {
      "hidden": ""
    }
  }, [_c('p', [_vm._v("\n          By selecting, “I DO NOT AGREE”, you will not be able to complete\n          your registration for a portal account. If you have any questions or\n          concerns, please send us an email below.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessEmail.Name),
      expression: "BusinessEmail.Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.BusinessEmail.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.BusinessEmail, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessEmail.Email),
      expression: "BusinessEmail.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.BusinessEmail.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.BusinessEmail, "Email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Please Enter Message Below*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessEmail.Message),
      expression: "BusinessEmail.Message"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.BusinessEmail.Message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.BusinessEmail, "Message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 email_box_btn"
  }, [_c('button', {
    staticClass: "evf-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitEmail(2)
      }
    }
  }, [_vm._v("\n              Send\n            ")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [(
    _vm.AccountValidationResult.AccountIsCoBrandAgreed ||
    _vm.AccountValidationResult.AccountIsElectronicLogAgreed ||
    _vm.AccountValidationResult.AccountIsLensesAgreementAgreed ||
    _vm.AccountValidationResult.AccountIsPatientChargeAgreed ||
    _vm.AccountValidationResult.AccountIsValidatePatientNeedAgreed
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        Please accept all agreements\n      ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-style"
  }, [_c('div', {
    staticClass: "terms-section"
  }, [_vm._v("\n          Changing Life through Lenses® Agreement\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-bottom": "4pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Changing Life through Lenses® Terms and Conditions")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Contract Documents and")]), _vm._v(" "), _c('strong', [_vm._v("Effective Date:")]), _vm._v(" These Changing Life through\n            Lenses® Terms and Conditions (\""), _c('strong', [_vm._v("Terms and Conditions")]), _vm._v("\") supplement and are made a part of the Changing Life through\n            Lenses® Agreement (\""), _c('strong', [_vm._v("Contract")]), _vm._v("\") by and between the\n            legal entity or individual identified as the participant\n            (“"), _c('strong', [_vm._v("Participant")]), _vm._v("”) on the Champions for Sight®\n            registration form (“"), _c('strong', [_vm._v("Registration Form")]), _vm._v("”) and\n            OneSight d/b/a OneSight EssilorLuxottica Foundation\n            (\""), _c('strong', [_vm._v("Foundation”")]), _vm._v("). The Contract consists of (i)\n            these Terms and Conditions, and (ii) if applicable, the Business\n            Associate Agreement (which is set forth on the Registration Form\n            if Participant is a covered entity"), _c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }), _c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt"
    }
  }, [_vm._v("under the ")]), _vm._v("Health\n            Insurance Portability and Accountability Act of 1996).  Your\n            use of the Changing Life through Lenses® online platform\n            (“"), _c('strong', [_vm._v("Portal")]), _vm._v("”) is also subject to the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])]), _vm._v("\n            and\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Privacy Policy")])])]), _vm._v("\n            posted on\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org")])])]), _vm._v("; provided, that in the event of any conflict between the\n            Contract and the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])]), _vm._v("\n            and/or\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Privacy Policy")])])]), _vm._v(", the provisions of the Contract shall prevail. Capitalized terms\n            used but not defined in these Terms and Conditions shall have the\n            meaning ascribed to them in the Registration Form.  If you\n            accept the Contract, the date on which you click the “Agree &\n            Submit” or similar button shall be the effective date of the\n            Contract (“"), _c('strong', [_vm._v("Effective Date")]), _vm._v("”).\n            "), _c('u', [_vm._v("BY CLICKING THE “SUBMIT” BUTTON, (i) YOU ARE BINDING\n              PARTICIPANT TO THE CONTRACT, THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("TERMS OF USE")])])]), _c('u', [_vm._v(", AND THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("PRIVACY POLICY")])])]), _c('u', [_vm._v(", AND (ii) IF PARTICIPANT IS A LEGAL ENTITY, YOU ARE\n              REPRESENTING AND WARRANTING THAT YOU ARE AUTHORIZED TO AGREE TO\n              THE CONTRACT, THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("TERMS OF USE")])])]), _c('u', [_vm._v(", AND THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("PRIVACY POLICY")])])]), _c('u', [_vm._v(" ON BEHALF OF PARTICIPANT")]), _vm._v("."), _c('u')]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Information:")]), _vm._v(" The Foundation is a\n            non-profit organization committed to eliminating poor vision and\n            its lifelong consequences and to providing underprivileged people\n            the opportunity to live a better life through better sight. The\n            Foundation works with nonprofit organizations and socially\n            responsible vision care providers across the United States to\n            provide in-kind donations of lenses and manufacturing of glasses\n            for use by Eligible Patients (the “"), _c('strong', [_vm._v("CLTL Program")]), _vm._v("”).  “"), _c('strong', [_vm._v("Eligible Patients")]), _vm._v("” are individuals\n            (i) living at or below the poverty line; (ii) who are not covered\n            by vision insurance for the pair of glasses to be provided in\n            connection with the Program; and (iii) who could not otherwise\n            afford vision services, as reasonably determined by Participant.\n            The Foundation has created the Portal to facilitate registration\n            and participation in the CLTL Program. Participant acknowledges\n            that the current focus of the CLTL Program is on youth and agrees\n            to use reasonable efforts to provide products supplied by the\n            Foundation (including lenses and/or frames) primarily to Eligible\n            Patients who are minors.  Participant further acknowledges\n            and agrees that, upon reasonable advance notice to Participant,\n            the Foundation may from time to time revise the definition of\n            Eligible Patients and the criteria for determining eligibility.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Materials:")]), _vm._v(" The Foundation will make\n            available to Participant educational resources and materials\n            describing how Participant may conduct and optimize its charitable\n            activities in connection with the CLTL Program (“"), _c('strong', [_vm._v("CLTL Program Educational Materials")]), _vm._v("”) and may make available to Participant certain assets or\n            materials to promote Participant’s involvement in the CLTL Program\n            (“"), _c('strong', [_vm._v("CLTL Program Promotional Materials")]), _vm._v("”) (CLTL\n            Program Educational Materials and CLTL Program Promotional\n            Materials, collectively “"), _c('strong', [_vm._v("CLTL Program Materials")]), _vm._v("”). Participant may make copies of CLTL Program Educational\n            Materials solely for use by Participant and Participant’s\n            employees in connection with the CLTL Program. Participant shall\n            not copy CLTL Program Promotional Materials without the\n            Foundation’s express written approval. If Participant has an\n            opportunity to promote the CLTL Program with CLTL Program\n            Promotional Materials, upon Participant’s request, the Foundation\n            will provide Participant with the Foundation logo lock up and\n            graphic standards to be used, subject to the Foundation’s prior\n            written approval in each instance. Participant shall use CLTL\n            Program Materials solely in connection with the CLTL Program.\n            Participant shall use CLTL Program Materials as is and shall not\n            modify CLTL Program Materials in any way without the express\n            written approval of the Foundation. Participant shall not delete,\n            obscure, or alter any disclosures or any copyright notice,\n            trademarks, or other proprietary rights notices affixed to or\n            contained in the CLTL Program Materials. Upon expiration or\n            termination of the Contract, Participant shall destroy or\n            immediately return to the Foundation all CLTL Program Materials in\n            Participant’s possession.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Lenses and Frames:")]), _vm._v(" The Foundation will endeavor\n            to provide Participant with fully fabricated lenses, subject to\n            such limitations on quantity as the Foundation may determine from\n            time to time in its sole discretion, as prescribed by the\n            Participant for Eligible Patients served through Participant’s\n            charitable activities. Lenses will be fabricated to meet the\n            prescription needs of each Eligible Patient, including single\n            vision and bifocals and the use of polycarbonate materials. Lenses\n            shall be fabricated by the Foundation’s suppliers and mounted in\n            frames provided on a frame-to-come basis by Participant (“"), _c('strong', [_vm._v("Participant Frames")]), _vm._v("”), unless Participant (i) specifies lenses only (without\n            mounting) or (ii) orders a complete pair of glasses through the\n            Portal, including frames supplied by the Foundation(“"), _c('strong', [_vm._v("Foundation Frames")]), _vm._v("”), if available, in which case the Foundation’s suppliers will\n            fabricate and mount the lenses in such Foundation Frames. If\n            Foundation Frames are available, the Foundation may, in its sole\n            discretion, charge Participant a service fee for complete orders\n            (lenses with Foundation Frames). In addition, a supply of\n            Foundation Frames may be available for a service fee in order to\n            provide sample selection for display or trial by Eligible\n            Patients.  Participant is responsible for shipping\n            Participant Frames to the Foundation’s designated supplier at\n            Participant’s own expense.  Shipments of lenses and frames\n            from the Foundation or its supplier to Participant will be at no\n            cost to Participant.  For clarity, the Foundation does not\n            guarantee that Foundation Frames will be available.  If\n            available, The Foundation does not guarantee that colors of\n            Foundation Frames as depicted online will be accurately displayed.\n            The Foundation does not warrant that the Foundation Frame product\n            descriptions are accurate, complete, reliable, current or\n            error-free.  The Foundation will not be liable for\n            typographical errors and reserves the right to refuse or cancel\n            any order or service in the event of a typographical error. The\n            Foundation, in its sole discretion, shall select suppliers of CLTL\n            Program products and services and Participant may not designate\n            suppliers of its choice.  The Foundation has the right to\n            reduce or limit the number of lenses and/or frames made available\n            under this Contract at any time for any reason.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Warranty Disclaimer: ")]), _vm._v("Participant Frames may be\n            lost or damaged during the fabrication of eyeglasses.\n            Participant’s use of Participant Frames is at Participant’s own\n            risk. The Foundation, its suppliers and service providers,\n            including any laboratory used by the Foundation, shall not be\n            liable for damage to the frame due to the fabrication and shipping\n            process or for lost frames. "), _c('strong', [_vm._v(" ")]), _c('strong', [_vm._v("THE PORTAL, ALL LENSES AND FRAMES, AND ALL RELATED SERVICES ARE\n              PROVIDED ON AN \"AS IS\" BASIS, WITH ALL FAULTS AND WITHOUT\n              WARRANTY OF ANY KIND.")]), _c('strong', [_vm._v("  ")]), _c('strong', [_vm._v("THE FOUNDATION HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND WITH\n              RESPECT TO THE PORTAL, THE LENSES AND FRAMES, AND RELATED\n              SERVICES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING THE\n              IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR\n              PURPOSE, QUIET ENJOYMENT, TITLE, AND NON-INFRINGEMENT, AND\n              WARRANTIES ARISING THROUGH COURSE OF DEALING OR USAGE OF\n              TRADE.")]), _c('strong', [_vm._v("  ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Additional Foundation Responsibilities:")]), _vm._v("\n            Participant agrees that the Foundation may, but is not obligated\n            to, list Participant as a CLTL Program participant on the\n            Foundation website in the same manner it lists other comparable\n            CLTL Program participants. The Foundation will submit to\n            Participant any requests for additional trademarks, copy or\n            content needed for individual events or media for the\n            Participant’s approval prior to publication.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Participant Responsibilities: ")]), _c('em', [_vm._v("In the event that Participant fails to satisfy one or more of\n              the below-referenced responsibilities, or any other Participant\n              obligation set forth in the Contract, the Foundation may, in its\n              sole discretion, offer to modify the terms of this Contract in\n              lieu of other recourse.")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees to promote the Foundation as a charitable\n            sponsor and to co-brand any marketing or promotional materials\n            prepared by Participant related to Participant’s charitable\n            services in connection with the CLTL Program, provided that\n            Participant agrees to submit to The Foundation Any such co-branded\n            materials, including copy or content for individual events or\n            media, for the Foundation’s written approval prior to publication\n            or other distribution. Participant will not use the Foundation\n            name, logo or other intellectual property without the prior\n            written approval of the Foundation.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees to use the CLTL Program, and any lenses,\n            frames, and related services ordered through the Portal or ordered\n            in connection with the CLTL Program solely for charitable vision\n            services to Eligible Patients and to validate patient eligibility\n            in accordance with criteria established by the Foundation from\n            time to time.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees that Participant will not charge Eligible\n            Patients for the lens product delivered; however, Participant may\n            charge Eligible Patients up to, but not to exceed, the actual cost\n            of the frame paid by Participant.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees to retain an Electronic Health Record (EHR) or\n            an electronic log containing, at a minimum, the following\n            information:")]), _c('strong', [_vm._v("  ")]), _c('strong', [_vm._v("for each Eligible Patient, the date of service, number/name of\n            patient examined, and how eligibility was validated; the number of\n            exams provided; the number of Eligible Patients who received\n            glasses; the number of glasses dispensed; and the number of\n            Eligible Patients receiving glasses for the first time. The\n            electronic log must be kept current and made available to the\n            Foundation as the Foundation may request from time to time during\n            the Term (as defined below) and for one year thereafter for audit\n            purposes and other treatment and health care operation purposes\n            further described in any applicable Business Associate Agreement.\n          ")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "8",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Marks:")]), _vm._v(" Participant acknowledges the Foundation’s\n            right, title, and interest in its trade names, trademark, trade\n            dress, logos, and other indicia of origin owned or licensed by the\n            Foundation (the “"), _c('strong', [_vm._v("the Foundation Marks")]), _vm._v("”).\n            Participant is authorized to use the Foundation Marks solely as\n            the Foundation Marks are incorporated into the CLTL Program\n            Materials or as otherwise approved by the Foundation in writing in\n            connection with the CLTL Program and shall not use the Foundation\n            Marks for any other purpose. Participant acknowledges and agrees\n            that the Foundation or its licensor, as applicable, retains all\n            ownership rights in the Foundation Marks and that the benefit of\n            use of the Foundation Marks hereunder, as well as all trademark\n            and other intellectual property rights stemming therefrom, shall\n            inure and belong solely to the Foundation or its licensor, as\n            applicable. Participant agrees to cease use of the Foundation\n            Marks immediately upon the Foundation’s request or termination of\n            this Contract. Participant will not attempt to obtain a copyright\n            or trademark in any artwork that contains or is derived from the\n            Foundation Marks without the Foundation’s prior written consent.\n            Participant grants to the Foundation a limited, non-exclusive\n            license to use the Participant name and logo, together with the\n            brand names, logos, and images otherwise provided or authorized by\n            Participant, (the “Participant Marks”) for the sole purpose of\n            promoting the CLTL Program and acknowledging Participant’s\n            participation in the CLTL Program; provided, however, that any\n            other use by the Foundation of intellectual property rights owned\n            by Participant requires Participant’s prior written authorization.\n            Upon request, Participant shall provide the Foundation with high\n            resolution images of Participant’s logo.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("No Endorsement:")]), _vm._v(" Participant shall in no way\n            suggest endorsement by the Foundation of Participant or\n            Participant’s products or services.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Permission to Link:")]), _vm._v(" During the Term, (i) the\n            Foundation grants Participant permission to provide a link from\n            Participant’s Web site to the Foundation’s Web site, which\n            permission the Foundation may withdraw at any time and for any\n            reason; and (ii) Participant grants the Foundation permission to\n            provide a link from the Foundation’s Web site to Participant’s Web\n            site, which permission Participant may withdraw at any time and\n            for any reason. Neither party shall have an obligation to provide\n            a link from its Web site to the Web site of the other party.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of the Foundation:")]), _vm._v("\n            The Foundation represents and warrants to Participant that it has\n            the right, power, and authority to enter into this Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of Participant:")]), _vm._v("\n            Participant represents and warrants to the Foundation that: (i) it\n            has the right, power, and authority to enter into this Contract;\n            (ii) it will comply with all applicable federal, state, and local\n            laws, statutes, ordinances, and regulations (collectively,\n            “"), _c('strong', [_vm._v("Laws")]), _vm._v("”) in connection with the CLTL Program and\n            this Contract, including Laws related to professional licensure\n            and the provision of vision care services; and (iii) any valid\n            lens prescription ordered before expiration date noted on the\n            prescription submitted by Participant have been prescribed by duly\n            licensed professionals.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Indemnity:")]), _vm._v(" Participant agrees to indemnify and\n            hold the Foundation, its suppliers, and each of their directors,\n            officers, employees, agents, representatives, and volunteers,\n            harmless from and against any and all costs, losses, and expenses,\n            including reasonable attorneys’ fees, that the Foundation may\n            incur by reason of any claims, actions, demands, or law suits\n            brought by a third party arising out of, or in connection with (i)\n            Participant’s negligence, recklessness, or intentional misconduct;\n            (ii) Participant’s performance or failure to perform pursuant to\n            this Contract, including breach of any provision of this Contract;\n            or (iii) Participant’s location(s), business, products, or\n            services, including any claims in the nature of product liability,\n            personal injury, or professional malpractice.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Term and Termination:")]), _vm._v(" This Contract shall\n            commence on the Effective Date and will continue until terminated\n            in accordance herein (the “"), _c('strong', [_vm._v("Term")]), _vm._v("”). Unless\n            otherwise mutually agreed by the parties, the Contract shall\n            automatically terminate upon the termination of any applicable\n            Business Associate Agreement. Either party may terminate this\n            Contract: (i) upon any material breach of the Contract by the\n            other party, if such breach is not remedied to the reasonable\n            satisfaction of the non-breaching party within fifteen (15) days\n            after the non-breaching party provides written notice of the\n            breach to the other party; (ii) immediately upon written notice to\n            the other party whenever the notifying party in its reasonable\n            discretion determines that the continuation of the Contract will\n            damage its reputation or good will; or (iii) upon fifteen (15)\n            days written notice for convenience. In addition, the Foundation\n            may terminate the Contract (i) immediately upon written notice to\n            Participant in the event the Foundation discontinues the CLTL\n            Program, or (ii) if the Foundation revises the Contract or any\n            portion thereof (including provisions of the Terms and Conditions\n            and/or, if applicable, the Business Associate Agreement) and\n            Participant does not agree to the revised Contract within the time\n            allowed by the Foundation.  Upon termination of this\n            Contract, Participant shall immediately (A) cease to use the CLTL\n            Program Materials and the Foundation Marks, (B) discontinue any\n            new orders (The Foundation will honor any orders for lenses or the\n            fabrication of lenses received prior to the effective date of\n            termination), (C) discontinue references in any manner to its\n            relationship with the Foundation, and (D) retain the electronic\n            audit log referenced in Section 7 above for one year following\n            termination of the Contract. For purposes of this Section 14,\n            Participant’s breach of any of Participant’s obligations set forth\n            in Section 7 above shall be deemed a material breach of this\n            Contract. The provisions of this Section shall not preclude the\n            parties from seeking any other remedies available to them under\n            this Contract and applicable law. The Sections regarding Warranty\n            Disclaimer, Indemnity, Governing Law and Venue, Limitation of\n            Liability, Notices, and Miscellaneous shall survive termination of\n            this Contract. In addition, any provision which would, by its\n            nature, survive the termination of this Contract, shall do so.\n          ")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "15",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Disputes; Governing Law and Venue:")]), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Any disputes between the parties related to the Contract, the\n                CLTL Program, or the Portal shall be governed by the “Disputes\n                with OneSight EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('strong', [_c('u', [_vm._v(", including, to the extent applicable, the Agreement to\n                Arbitrate set forth in the “Disputes with OneSight\n                EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('u', [_vm._v(".")]), _vm._v(" If and to the extent the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])]), _vm._v("\n            are determined not to apply to a dispute between the parties, (i)\n            this Contract shall be governed by and construed in accordance\n            with the laws of the state of Texas, without regard to principles\n            of conflict or choice of law; and (ii) any dispute arising out of\n            or in connection with this Contract shall be filed and heard in\n            the state or federal courts located in Dallas, Texas, and the\n            parties consent to the exclusive jurisdiction of such courts.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Relationship of Parties:")]), _vm._v(" The parties to this\n            Contract are not joint venturers, partners, agents, or\n            representatives of each other, are not authorized to act on each\n            other’s behalf, and have no legal relationship other than as\n            independent contracting parties to this Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Assignment:")]), _vm._v(" No party may assign this Contract, or\n            any rights or obligations hereunder, without the prior written\n            consent of the other party. Notwithstanding the foregoing, in the\n            event that any license agreement between the Foundation and its\n            licensor is terminated, the Foundation may, without Participant’s\n            consent, assign its rights and obligations with respect to any\n            sublicense granted hereunder to such licensor. Any attempt to\n            assign this Contract in contravention of this Section shall be\n            void and of no force and effect. This Contract is binding upon and\n            will inure to the benefit of the respective parties hereto and\n            their successors and permitted assigns.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Limitation of Liability:")]), _vm._v(" EXCEPT WITH RESPECT TO\n            INDEMNIFICATION OBLIGATIONS SET FORTH HEREIN, NEITHER PARTY SHALL\n            BE LIABLE TO THE OTHER FOR ANY (I) DIRECT DAMAGES, IN THE\n            AGGREGATE, IN EXCESS OF $100.00, OR (II) INDIRECT, SPECIAL,\n            CONSEQUENTIAL, INCIDENTAL, OR PUNITIVE DAMAGE WITH RESPECT TO ANY\n            CLAIM ARISING OUT OF THIS CONTRACT (INCLUDING ITS PERFORMANCE OR\n            BREACH OF THESE TERMS AND CONDITIONS) FOR ANY REASON.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Notices:")]), _vm._v(" All notices required or permitted to be\n            given hereunder shall be in writing and shall be sent by (i)\n            personal or courier delivery, (ii) electronic mail, or (iii) USPS\n            certified mail, postage prepaid, return receipt requested. All\n            notices to Participant shall be forwarded to Participant and/or\n            the Primary Contact designated by Participant at the principal\n            mailing address and/or email address provided for Participant when\n            completing the Registration Form, or to such other person or\n            address as Participant may designate in writing to the Foundation\n            for this purpose. All notices to the Foundation shall be forwarded\n            to OneSight EssilorLuxottica Foundation, 13515 N. Stemmons Fwy.,\n            Dallas, TX 75234, Attn: Partnerships (if notice is sent by mail or\n            personal or courier delivery) and/or to\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "mailto:info@onesight.org"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("support@onesight.org")])])]), _vm._v("\n            (if notice is sent by electronic mail), or to such other person or\n            address as the Foundation may designate in writing to Participant\n            for this purpose. In order for notice to the Foundation to be\n            effective, a copy of such notice must be sent to OneSight\n            EssilorLuxottica Foundation, Attn: General Counsel, at the\n            Foundation address designated above (if notice is sent by mail or\n            personal or courier delivery). Notices delivered hereunder shall\n            be effective when received or refused. Notwithstanding the\n            foregoing, (i) written approvals and authorizations required\n            hereunder may be provided facsimile, email, or other written\n            means; and (ii) the Foundation may notify Participant, including\n            notice of any change to the CLTL Program or the terms of the\n            Contract, by posting a notice on the Portal.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Entire Agreement:")]), _vm._v(" Except as expressly and\n            specifically provided in this Contract, this Contract supersedes\n            any prior understandings or oral agreements between the parties\n            regarding the subject matter hereof and constitutes the entire\n            understanding and agreement of such parties with respect to the\n            subject matter hereof.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Force Majeure:")]), _vm._v(" The obligations of any party under\n            this Contract will be suspended for the duration of any force\n            majeure applicable to that party. The term \"force majeure\" means\n            any cause not reasonably within the control of the party claiming\n            suspension, including an act of God, industrial disturbance,\n            supplier disruptions, war, riot, weather-related disaster,\n            earthquake and governmental action. The party claiming suspension\n            under this Section will take reasonable steps to resume\n            performance as soon as possible without incurring unreasonably\n            excessive costs.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Miscellaneous:")]), _vm._v(" The failure of a party at any time\n            to require performance of any provision of or resort to any remedy\n            provided under this Contract shall in no way affect the right of\n            that party to require performance or resort to a remedy at any\n            time thereafter, nor shall the waiver by a party of a breach be\n            deemed to be a waiver of any subsequent breach. A waiver shall not\n            be effective unless it is in writing and signed by the party\n            against whom the waiver is being enforced. If any term or\n            provision of this Contract is determined to be invalid, illegal,\n            or incapable of being enforced by any law, regulation, or public\n            policy,"), _c('span', {
    staticStyle: {
      "line-height": "115%",
      "font-family": "Aptos",
      "font-size": "10pt"
    }
  }), _vm._v("then such provision will be interpreted, construed, or reformed\n            to the extent reasonably required to render the same valid,\n            enforceable and consistent with the original intent underlying\n            such provision, and all other terms and provisions of this\n            Contract shall nevertheless remain in full force and effect.\n            Notwithstanding the foregoing, if any such modification causes a\n            material change in the obligations or rights of any party, upon\n            written notice from one party to the other of the adverse effect\n            thereof upon such notifying party, and then if the parties are not\n            able to mutually agree as to an amendment hereto, any party may\n            terminate this Contract upon thirty (30) days written notice to\n            the other parties.This Contract shall not be altered, amended, or\n            modified in any way except by (i) a written instrument dated\n            subsequent to the date of this Contract and signed on behalf of\n            the parties by their respective duly authorized representatives;\n            or (ii) a subsequent “clickwrap” agreement made available by the\n            Foundation on the Portal to which Participant has indicated\n            Participant’s assent by clicking an “I Agree” or “Submit” or\n            similar button. Section captions and headings are for are for\n            reference purposes only and shall not control or affect the\n            construction or interpretation of this Contract in any\n            respect.  In all cases, the use of \"includes/ing\" shall mean\n            \"includes/ing without limitation\".\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-bottom": "0pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
    staticClass: "terms-section mt-4"
  }, [_vm._v("Business Associate Agreement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12pt",
      "margin-bottom": "0pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("This HIPAA Business Associate Agreement (\"Agreement\") supplements\n            and is made a part of the Changing Life through Lenses® Agreement\n            (\"CLTL Contract\") by and between the legal entity or individual\n            identified as the participant on the Champions for Sight®\n            registration form (referred to herein as “Covered Entity\") and\n            OneSight d/b/a OneSight EssilorLuxottica Foundation (referred to\n            herein as \"Business Associate\"), and is effective as of the\n            Effective Date of the CLTL Contract between the parties, as\n            defined in the Changing Life through Lenses® Terms and\n            Conditions.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("RECITALS")])])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "disc"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", Business Associate provides certain services to health care\n              providers; and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", Business Associate has been retained by Covered Entity to\n              perform functions or activities that will require the Business\n              Associate to have access to or create, receive, maintain or\n              transmit Protected Health Information in relation to the Covered\n              Entity; and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", Pursuant to the Health Insurance Portability and\n              Accountability Act of 1996 (\"HIPAA\"), Covered Entity and\n              Business Associate desire to execute this Agreement to comply\n              with the terms of the Privacy Rule, the Security Rule and the\n              HITECH Act under the American Recovery and Reinvestment Act of\n              2009 (as defined below); and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", this Agreement has been drafted to incorporate the provisions\n              required by the final regulations issued by the Department of\n              Health and Human Services on January 25, 2013 implementing the\n              HITECH Act; and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS,")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("\n              Business Associate acts in the capacity of an independent\n              contractor in relation to the services provided to Covered\n              Entity under the CLTL Contract.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("NOW, THEREFORE")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", in consideration of the mutual covenants, terms and\n              conditions herein contained, the parties hereto agree as\n              follows:")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("1) DEFINITIONS")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("Terms used but not otherwise defined in the Agreement shall have\n            the same meaning as those terms in the Privacy Rule and Security\n            Rule.")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Breach\"")]), _vm._v(" shall have the meaning given to it\n            by 45 CFR Section 164.402.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Breach Notification Rule\"")]), _c('strong', [_vm._v(" ")]), _vm._v("shall mean the Standards for Breach\n            Notification for Unsecured Protected Health Information under\n            HIPAA that is codified at 45 CFR Parts 160 and 164,\n            subparts A and D.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Deidentified Data\"")]), _vm._v(" shall have the same\n            meaning as the term \"deidentified data\" in 45 CFR\n            Section 164.514.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Designated Record Set\"")]), _vm._v(" shall mean a group\n            of records maintained by or for a Covered Entity that is:\n            (i) the medical records and billing records about Individuals\n            maintained by or for a covered health care provider; (ii) the\n            enrollment, payment, claims adjudication, and case or medical\n            management record systems maintained by or for a health plan; or\n            (iii) used, in whole or in part, by or for the Covered Entity\n            to make decisions about Individuals. For purposes of this\n            definition, the term \"record\" means any item, collection, or\n            grouping of information that includes Protected Health Information\n            and is maintained, collected, used, or disseminated by or for a\n            Covered Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Health Care Operations\"")]), _vm._v(" shall have the same\n            meaning as the term \"Health Care Operations\" in 45 CFR\n            Section 164.501.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"HITECH Act\"")]), _vm._v(" shall mean the provisions of\n            Title XIII, Subtitle D of the American Recovery and\n            Reinvestment Act of 2009. Any reference to a section of the HITECH\n            Act shall also include any HITECH Regulations related thereto.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"HITECH Regulations\"")]), _vm._v(" shall mean any guidance\n            issued relating to the HITECH Act by the Department of Health and\n            Human Services, including the Breach Notification Rule.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Individual\"")]), _vm._v(" shall have the same meaning as\n            the term \"individual\" in 45 CFR Section 160.103 and\n            shall include a person who qualifies as a personal representative\n            in accordance with 45 CFR Section 164.502(g).\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Privacy Rule\"")]), _vm._v(" shall mean the Standards for\n            Privacy of Individually Identifiable Health Information that is\n            codified at 45 CFR Parts 160 and 164, subparts A\n            and E.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Protected Health Information\"")]), _vm._v(" or "), _c('strong', [_vm._v("\"PHI\"")]), _vm._v(" shall mean any\n            information, whether oral or recorded in any form or medium:\n            (i) that relates to the past, present or future physical or\n            mental condition of an individual; the provision of health care to\n            an individual; or the past, present or future payment for the\n            provision of health care to an individual; and (ii) that\n            identifies the individual or with respect to which there is a\n            reasonable basis to believe the information can be used to\n            identify the individual, and shall have the meaning given to such\n            term under 45 CFR Section 160.103. Protected Health\n            Information shall be limited to the information created or\n            received by Business Associate from or on behalf of Covered\n            Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Required By Law\"")]), _vm._v(" shall have the same\n            meaning as the term \"required by law\" in 45 CFR\n            Section 164.103.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Secretary\"")]), _vm._v(" shall mean the Secretary of the\n            Department of Health and Human Services or his or her designee.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Security Rule\"")]), _vm._v(" shall mean the Security\n            Standards for the Protection of Electronic Protected Health\n            Information under HIPAA that is codified at 45 CFR\n            Parts 160 and 164, subparts A and C.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Unsecured PHI\"")]), _vm._v(" shall mean Protected Health\n            Information that is not secured through the use of a technology or\n            methodology that renders such Protected Health Information\n            unusable, unreadable or indecipherable to unauthorized\n            individuals, as specified in guidance issued pursuant to\n            Section 13402(h) of the HITECH Act, including the Breach\n            Notification Rule.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("2) OBLIGATIONS AND ACTIVITIES OF BUSINESS ASSOCIATE")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Permitted Uses and Disclosures")]), _vm._v(". Business\n            Associate agrees to not use or disclose Protected Health\n            Information other than as permitted or required by this Agreement\n            or as Required By Law. Business Associate shall not use or\n            disclose Protected Health Information in any manner that violates\n            the Privacy Rule or the HITECH Act. To the extent required by the\n            Privacy Rule, Business Associate shall only request, use and/or\n            disclose the minimum amount of Protected Health Information\n            necessary to accomplish the purpose of the request, use and/or\n            disclosure. The determination of what constitutes the minimum\n            necessary amount of Protected Health Information shall be\n            determined in accordance with the provisions of the Privacy Rule.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Safeguards")]), _vm._v(". Business Associate agrees to use\n            administrative, physical and technical safeguards applicable to\n            the services provided under the CLTL Contract that reasonably and\n            appropriately protect the confidentiality, integrity and\n            availability of Protected Health Information, in electronic or any\n            other form, that it creates, receives, maintains or transmits\n            under this Agreement, in accordance with the Privacy Rule and the\n            Security Rule to prevent the use or disclosure of Protected Health\n            Information other than as provided for by this Agreement. Business\n            Associate shall fully comply with the Security Rule with regard to\n            electronic Protected Health Information.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Reporting of Improper Use or Disclosure")]), _vm._v(". Business\n            Associate agrees to report to the Covered Entity any use or\n            disclosure of the Protected Health Information not provided for by\n            this Agreement of which it becomes aware. Business Associate shall\n            also report any security incident of which it becomes aware to\n            Covered Entity. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Mitigation.")]), _vm._v(" Business Associate agrees to\n            mitigate, to the extent practicable, any harmful effect that is\n            known to Business Associate of a use or disclosure of Protected\n            Health Information by Business Associate in violation of the\n            requirements of this Agreement. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Agents and Subcontractors.")]), _vm._v(" Business\n            Associate agrees to require that any agents or subcontractors that\n            create, receive, maintain or transmit Protected Health Information\n            on behalf of Business Associate in relation to Covered Entity\n            agree in writing (in the form of a business associate contract) to\n            substantially similar restrictions, conditions and requirements\n            that apply through this Agreement to Business Associate with\n            respect to such information, including the implementation of\n            reasonable and appropriate measures for safeguarding Protected\n            Health Information. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Access to Individuals.")]), _vm._v(" To the extent\n            applicable, Business Associate agrees to provide access to\n            Protected Health Information in a Designated Record Set, to\n            Covered Entity or, as directed by Covered Entity, to an Individual\n            in order to meet the requirements under 45 CFR\n            Section 164.524. Further, if an Individual requests a copy of\n            Protected Health Information in a specific electronic format,\n            Business Associate shall comply with such request, if readily\n            producible, in accordance with the requirements of 45 CFR Section\n            164.524.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Amendments to Protected Health Information.")]), _vm._v(" To the extent applicable, Business Associate agrees to make\n            any reasonable amendment(s) to Protected Health Information in a\n            Designated Record Set that the Covered Entity directs or agrees to\n            pursuant to 45 CFR Section 164.526 at the request of Covered\n            Entity or an Individual.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Access to Internal Practices, Books and Records.")]), _vm._v(" Business Associate agrees to make internal practices, books\n            and records including policies and procedures and Protected Health\n            Information, relating to the use and disclosure of Protected\n            Health Information received from, or created or received by\n            Business Associate on behalf of, Covered Entity available to the\n            Secretary for purposes of the Secretary determining Covered\n            Entity's compliance with HIPAA.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Disclosure Documentation.")]), _vm._v(" Business Associate\n            agrees to document such disclosures of Protected Health\n            Information and information related to such disclosures as would\n            be required for Covered Entity to respond to a request by an\n            Individual for an accounting of disclosures of Protected Health\n            Information in accordance with 45 CFR Section 164.528.\n            Business Associate agrees to provide to Covered Entity or an\n            Individual information collected in accordance with this\n            subsection to permit Covered Entity to respond to a request by an\n            Individual for an accounting of disclosures of Protected Health\n            Information in accordance with 45 CFR Section 164.528.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Obligation Upon Breach of Unsecured PHI.")]), _c('strong', [_vm._v(" ")]), _vm._v("Upon Business Associate's discovery of a\n            Breach of Unsecured PHI, Business Associate shall provide notice\n            of the Breach to Covered Entity in accordance with the\n            requirements of 45 CFR 164.410. The content of such written notice\n            of the Breach shall comply with the requirements of 45 CFR\n            Section 164.410(c). Business Associate shall cooperate with\n            and coordinate an appropriate course of action with Covered\n            Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Delegated Obligations")]), _vm._v(". To the extent Business\n            Associate is to carry out one or more of Covered Entity’s\n            obligations under Subpart E of 45 CFR Part 164, Business Associate\n            agrees to comply with the requirements of Subpart E that apply to\n            Covered Entity in the performance of such obligations.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("3) PERMITTED USES BY BUSINESS ASSOCIATE")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Service Agreement.")]), _vm._v(" Except as otherwise\n            limited in this Agreement, Business Associate may use or disclose\n            Protected Health Information to perform functions, activities, or\n            services for, or on behalf of, Covered Entity as specified in the\n            CLTL Contract, provided that such use or disclosure would not\n            violate the Privacy Rule if done by Covered Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "margin-bottom": "12pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Other Permitted Usage.")]), _vm._v(" Except as otherwise\n            limited in this Agreement, Business Associate may use Protected\n            Health Information for the proper management and administration of\n            the Business Associate or to carry out the legal responsibilities\n            of the Business Associate. Business Associate may disclose\n            Protected Health Information for the proper management and\n            administration of the Business Associate if the disclosure is\n            Required by Law or Business Associate obtains reasonable\n            assurances from the person to whom the information is disclosed\n            that it will be held confidentially and used or further disclosed\n            only as Required by Law or for the purposes for which it was\n            disclosed to the person and the person notifies Business Associate\n            of any instances of which it is aware in which the confidentiality\n            of the information has been breached.  In addition, Business\n            Associate may use Protected Health Information to provide Data\n            Aggregation services as permitted by 45 CFR\n            Section 164.504(e)(2)(i)(B) and/or to create Limited Data\n            Sets as permitted by 45 CFR 164.514(e).\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-left": "36pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("The Business Associate’s activities will require access to\n            Protected Health Information to process prescriptions placed by\n            the Covered Entity pursuant to the CLTL Contract. Also, Business\n            Associate may also facilitate certain treatment activities (as\n            defined at 45 CFR 164.501) and perform certain health care\n            operation functions (as defined at 45 CFR 164.501), including\n            conducting certain audit functions, on behalf of the Covered\n            Entity.")]), _c('br'), _c('br'), _c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("Further, Covered Entity expressly agrees to provide Business\n            Associate with Protected Health Information, as requested by\n            Business Associate from time to time, so that Business Associate\n            may create a limited data set with such information that complies\n            with the requirements of 45 CFR 164.514(e). After creating the\n            limited data set, Business Associate will conduct research on the\n            limited data set, as allowed under 45 CFR 164.514(e)(3). The\n            Business Associate will not use or further disclose the limited\n            data set information in a manner that would violate the\n            requirements of the Privacy Rule. In relation to the limited data\n            set information maintained by Business Associate, Business\n            Associate will use appropriate safeguards to prevent use or\n            disclosure of the information other than as provided for by this\n            Agreement; report to the Covered Entity any use or disclosure of\n            the information not provided for by this Agreement of which it\n            becomes aware; ensure that any agents to whom it provides the\n            limited data set agree to the same restrictions and conditions\n            that apply to the limited data set recipient with respect to such\n            information; and not identify the information or contact the\n            individuals, in accordance with the requirements of 45 CFR\n            164.514(e)(4)(ii)(C).")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("4) OBLIGATIONS OF COVERED ENTITY")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Change in Privacy Practices.")]), _vm._v(" Covered Entity\n            shall notify Business Associate of any limitation(s) in its notice\n            of privacy practices of Covered Entity in accordance with 45 CFR\n            Section 164.520, to the extent that such limitation may affect\n            Business Associate's use or disclosure of Protected Health\n            Information. Additionally, Covered Entity shall notify Business\n            Associate of any limitation(s) or restriction(s) in its security\n            practices to the extent that such limitation may affect Business\n            Associate's use or disclosure of Protected Health Information.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("No Restrictions on the Use or Disclosure of Protected Health\n              Information.")]), _vm._v(" Covered Entity shall not agree to an Individual’s request\n            to restrict uses or discloses of Protected Health Information, to\n            the extent that such changes may affect Business Associate's\n            ability to perform the functions described in the CLTL Contract,\n            including this Agreement. Because of the charitable nature of the\n            services performed in relation to the Covered Entity’s patients\n            whose PHI is subject to this Agreement, 45 CFR 164.522(a)(1)(vi)\n            will not apply to the PHI of such patients since such patients are\n            not paying in full for services performed. Therefore, the Covered\n            Entity is allowed under 45 CFR 164.522(a)(1)(ii) to not agree, and\n            shall not agree, to any restriction requested by an Individual\n            whose PHI will be shared with Business Associate as part of the\n            services provided under the CLTL Contract. \n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("5) PERMISSIBLE REQUESTS BY COVERED ENTITY")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("\n            Covered Entity shall not request Business Associate to use or\n            disclose Protected Health Information in any manner that would not\n            be permissible under the Privacy Rule if done by Covered Entity.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("6) TERM AND TERMINATION")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Term.")]), _vm._v(" This Agreement will begin on the\n            Effective Date and will continue until terminated in accordance\n            herein.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Termination. ")]), _vm._v("In addition to the termination\n            rights set forth in the Terms and Conditions, a party may\n            terminate the Agreement as follows: \n            "), _c('ol', {
    staticStyle: {
      "margin-right": "0pt",
      "margin-left": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Termination for Cause.")]), _vm._v(" Upon Covered\n                Entity's knowledge of a material breach of this Agreement by\n                Business Associate, Covered Entity shall provide not less than\n                20 days written notice of its intent to terminate the\n                Agreement if Business Associate does not cure such material\n                breach no later than the end of the written notice period. If\n                Business Associate does not cure the breach within such time,\n                then Covered Entity may, in its sole discretion, immediately\n                terminate this Agreement.\n              ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Termination without Cause and Termination of the CLTL\n                  Contract. ")]), _vm._v("Either party may terminate this Agreement effective upon 15\n                days advance written notice to the other party given with or\n                without any reason if Business Associate no longer performs\n                services for Covered Entity requiring the use or disclosure of\n                Protected Health Information. This Agreement will immediately\n                terminate if the CLTL Contract terminates. The effective date\n                of such termination will be the same as the effective date\n                that the CLTL Contract terminates.\n              ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Effect of Termination.")]), _vm._v(" Unless otherwise\n                mutually agreed by the parties, the termination of this\n                Agreement for any reason shall automatically terminate the\n                CLTL Contract. The parties mutually agree in advance that\n                returning or destroying Protected Health Information upon\n                termination of this Agreement is infeasible. Therefore,\n                Business Associate shall extend the protections of this\n                Agreement to such Protected Health Information and limit\n                further uses and disclosures of such Protected Health\n                Information to those purposes that make the return or\n                destruction infeasible, for so long as Business Associate\n                maintains such Protected Health Information.\n              ")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("7) MISCELLANEOUS")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Regulatory References.")]), _vm._v(" Any reference in this\n            Agreement to a section in the Privacy Rule, Security Rule, Breach\n            Notification Rule or HITECH Act means the section as in effect or\n            as amended.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Amendment.")]), _vm._v(" The Parties agree to take such\n            action as is necessary to amend this Agreement from time to time\n            as is necessary for Covered Entity to comply with the requirements\n            of the Privacy Rule, Security Rule, the Breach Notification Rule\n            or any other requirements of the HITECH Act.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Survival.")]), _vm._v(" The respective rights and\n            obligations of Business Associate under Section 6.2.3 shall\n            survive the termination of this Agreement.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Interpretation; Conflict.")]), _vm._v(" Any ambiguity in\n            this Agreement shall be resolved to permit both parties to comply\n            with the Privacy Rule, Security Rule, the Breach Notification Rule\n            or any other requirements of the HITECH Act. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("No Third-Party Beneficiaries.")]), _vm._v(" Except as set\n            forth in this Agreement or as expressly provided for under HIPAA,\n            this Agreement is entered into by and among the parties hereto\n            solely for their benefit. The parties have not created or\n            established any third-party beneficiary status or rights in any\n            person or entity not a party hereto including any individual,\n            provider, subcontractor, or other third-party, and no such\n            third-party will have any right to enforce any right or enjoy any\n            benefit created or established under this Agreement.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Force Majeure.")]), _vm._v(" The obligations of any party\n            under this Agreement will be suspended for the duration of any\n            force majeure applicable to that party. The term \"force majeure\"\n            means any cause not reasonably within the control of the party\n            claiming suspension, including an act of God, industrial\n            disturbance, supplier disruptions, war, riot, weather-related\n            disaster, earthquake and governmental action. The party claiming\n            suspension under this Section will take reasonable steps to resume\n            performance as soon as possible without incurring unreasonably\n            excessive costs.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Entire Agreement.")]), _vm._v(" This Agreement including\n            any riders, attachments or amendments hereto, constitutes the\n            entire agreement among the parties with respect to the Privacy\n            Rule, the Security Rule, the Breach Notification Rule and any\n            other requirements of the HITECH Act. This Agreement supersedes\n            any prior agreement or understandings pertaining to HIPAA\n            obligations between the parties, whether oral or written.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Disputes; Choice of Law.")]), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Any disputes between the parties related to this Agreement\n                shall be governed by the “Disputes with OneSight\n                EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('strong', [_c('u', [_vm._v(", including, to the extent applicable, the Agreement to\n                Arbitrate set forth in the “Disputes with OneSight\n                EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('u', [_vm._v(".")]), _vm._v(" If and to the extent the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _vm._v("\n            are determined not to apply to a dispute between the parties, (i)\n            this Agreement shall be governed by and construed in accordance\n            with the laws of the state of Texas, without regard to principles\n            of conflict or choice of law; and (ii) any dispute arising out of\n            or in connection with this Agreement shall be filed and heard in\n            the state or federal courts located in Dallas, Texas, and the\n            parties consent to the exclusive jurisdiction of such courts.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Assignment and Delegation.")]), _vm._v(" No party may\n            assign this Agreement, or any rights or obligations hereunder,\n            without the prior written consent of the other party. Any attempt\n            to assign this Agreement in contravention of this Section shall be\n            void and of no force and effect. This Agreement is binding upon\n            and will inure to the benefit of the respective parties hereto and\n            their successors and permitted assigns.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Notices.")]), _vm._v(" Any notice required pursuant to\n            this Agreement shall comply with the requirements for notices as\n            set forth in the OneSight EssilorLuxottica Foundation Changing\n            Life through Lenses® Terms and Conditions that form part of the\n            CLTL Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Miscellaneous.")]), _vm._v(" The failure of a party at any time\n            to require performance of any provision of or resort to any remedy\n            provided under this Agreement shall in no way affect the right of\n            that party to require performance or resort to a remedy at any\n            time thereafter, nor shall the waiver by a party of a breach be\n            deemed to be a waiver of any subsequent breach. A waiver shall not\n            be effective unless it is in writing and signed by the party\n            against whom the waiver is being enforced. If any term or\n            provision of this Agreement is determined to be invalid, illegal,\n            or incapable of being enforced by any law, regulation, or public\n            policy, then such provision will be interpreted, construed or\n            reformed to the extent reasonably required to render the same\n            valid, enforceable and consistent with the original intent\n            underlying such provision, and all other terms and provisions of\n            this Agreement shall nevertheless remain in full force and effect.\n            Notwithstanding the foregoing, if any such modification causes a\n            material change in the obligations or rights of any party, upon\n            written notice from one party to the other of the adverse effect\n            thereof upon such notifying party, and then if the parties are not\n            able to mutually agree as to an amendment hereto, any party may\n            terminate this Agreement upon thirty (30) days written notice to\n            the other parties. This Agreement shall not be altered, amended or\n            modified in any way except by (i) a written instrument dated\n            subsequent to the date of this Agreement and signed on behalf of\n            the parties by their respective duly authorized representatives;\n            or (ii) a subsequent “clickwrap” agreement made available by the\n            Foundation on the OneSight EssilorLuxottica Foundation Changing\n            Life through Lenses® online platform to which Covered Entity has\n            indicated Covered Entity’s assent by clicking an “I Agree” or\n            “Submit” or similar button. Section captions and headings are for\n            are for reference purposes only and shall not control or affect\n            the construction or interpretation of this Agreement in any\n            respect. In all cases, the use of \"includes/ing\" shall mean\n            \"includes/ing without limitation\".\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "terms-section mt-5"
  }, [_vm._v("Grateful Patient™ Agreement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12pt",
      "margin-bottom": "4pt",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Grateful Patient™ Point of Sale Giving Campaign Terms and\n            Conditions")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Definitions; Effective Date. ")]), _vm._v("These Grateful\n            Patient™ Point of Sale Giving Terms and Conditions (“"), _c('strong', [_vm._v("Grateful Patient™ Terms and Conditions")]), _vm._v("”) supplement and are made part of the Grateful Patient™ ™ Point\n            of Sale Agreement (“"), _c('strong', [_vm._v("Grateful Patient™ Contract")]), _vm._v("”)\n            by and between the legal entity or individual identified as the\n            participant (“"), _c('strong', [_vm._v("Participant")]), _vm._v("”) on the Champions for\n            Sight registration form (“"), _c('strong', [_vm._v("Registration Form")]), _vm._v("”) and\n            these Terms and Conditions, and OneSight d/b/a OneSight\n            EssilorLuxottica Foundation (“"), _c('strong', [_vm._v("Foundation")]), _vm._v("”).\n            Capitalized terms used but not defined in these Grateful Patient™\n            Terms and Conditions shall have the meaning ascribed to them in\n            the Registration Form. If you accept this Grateful Patient™\n            Contract, the date on which you click the “Agree & Submit” or\n            similar button shall be the effective date of the Grateful\n            Patient™ Contract (“"), _c('strong', [_vm._v("Effective Date")]), _vm._v("”).\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Information.")]), _c('strong', [_vm._v(" ")]), _vm._v(" The\n            Foundation has created the Grateful Patient™ Program, a charitable\n            point of sale (“"), _c('strong', [_vm._v("POS")]), _vm._v("”) fundraising program (the\n            “"), _c('strong', [_vm._v("Grateful Patient™")]), _vm._v(" "), _c('strong', [_vm._v("Program")]), _vm._v("”) for\n            independent eyecare professionals and businesses. The purpose of\n            the Grateful Patient™ Program is to raise funds for the benefit of\n            The Foundation, whose mission is to eliminate poor vision in a\n            generation. Participant can elect to participate in the Grateful\n            Patient™ by making available to Participant’s customers at\n            Participant’s locations in the United States information enabling\n            customers to make a direct donation to the Foundation and/or the\n            option to make a donation to The Foundation during the POS\n            checkout process (“"), _c('strong', [_vm._v("POS Donations")]), _vm._v("”), as more fully\n            described in these Terms and Conditions. Except as otherwise\n            expressly provided herein, Participant shall be solely responsible\n            for all costs of operating the Grateful Patient™ Program,\n            including the costs of acquiring and maintaining any POS hardware\n            and software. Participant shall direct customer inquiries or\n            concerns regarding The Foundation or the Grateful Patient™ Program\n            to The Foundation at 1-866-385-0447.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Materials.")]), _c('strong', [_vm._v(" ")]), _vm._v(" "), _c('strong', [_vm._v("Participant agrees to print out and prominently display to its\n              customers a copy of The Foundation’s then-current disclosures\n              related to the solicitation of donations, which can be found at: ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org/disclosures"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org/disclosures")])])])]), _c('strong', [_vm._v(".")]), _vm._v(" In addition, upon Participant’s request, The\n            Foundation will provide Participant with a digital template of\n            promotional materials for purposes of publicizing the Grateful\n            Patient™ Program (\""), _c('strong', [_vm._v("Grateful Patient™ Program Materials")]), _vm._v("”). Participant shall be responsible for all costs of printing\n            Grateful Patient™ Program Materials supplied in digital formats.\n            From time to time, The Foundation may offer printed Grateful\n            Patient™ Program Materials. The Foundation may impose a fee for\n            printed Grateful Patient™ Program Materials and will inform\n            Participant of the amount of such fee prior to fulfilling\n            Participant’s request for Grateful Patient™ Program Materials.\n            Participant shall use Grateful Patient™ Program Materials solely\n            in connection with the Grateful Patient™ Program. Participant\n            shall not transfer the Grateful Patient™ Program Materials or its\n            right to use the Grateful Patient™ Program Materials to any third\n            party. Participant shall use Grateful Patient™ Program Materials\n            as is and shall not modify Grateful Patient™ Program Materials in\n            any way without the express written approval of The Foundation;\n            provided, however, that where Grateful Patient™ Program Materials\n            provide a space expressly for co-branding by Grateful Patient™\n            Program participants, Participant may add Participant’s business\n            logo to such space. Participant shall not delete, obscure, or\n            alter any disclosures or any copyright notice, trademarks, or\n            other proprietary rights notices affixed to or contained in the\n            Grateful Patient™ Program Materials. Upon termination of the\n            Grateful Patient™ Contract, Participant shall immediately cease\n            use of the Grateful Patient™ Program Materials and destroy all\n            Grateful Patient™ Program Materials in Participant’s possession.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("OneSight EssilorLuxottica Foundation Marks. ")]), _vm._v("Participant acknowledges The Foundation’s right, title and\n            interest in its trade names, trademark, trade dress, logos, and\n            other indicia of origin owned or licensed by The Foundation (the\n            “"), _c('strong', [_vm._v("Foundation Marks")]), _vm._v("”). Participant is authorized to\n            use non-exclusively the Foundation Marks solely as the Foundation\n            Marks are incorporated into the Grateful Patient™ Program\n            Materials and shall not use the Foundation Marks for any other\n            purpose.\n            "), _c('a', {
    attrs: {
      "name": "_Hlk173319593"
    }
  }, [_vm._v("Participant shall not transfer, sublicense, or assign its\n              rights to use the Grateful Patient™ Program Marks")]), _vm._v(". Participant acknowledges and agrees that The Foundation or its\n            licensor, as applicable, retains all ownership rights in and to\n            the Foundation Marks and that the benefit of use of the Foundation\n            Marks hereunder, as well as all trademark and other intellectual\n            property rights stemming therefrom, shall inure and belong solely\n            to The Foundation or its licensor, as applicable. Participant\n            agrees to cease use of the Foundation Marks immediately upon\n            termination of this Grateful Patient™ Contract or sooner upon The\n            Foundation’s request.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "margin-bottom": "8pt",
      "text-align": "justify",
      "line-height": "108%",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("POS Donations.")]), _vm._v(" In order to support participation\n            in the Grateful Patient™ Program, The Foundation has identified a\n            number of merchant providers/donation tactics to enable\n            Participant to accept POS Donations in the manner best suited to\n            Participant’s practice.  Depending on Participant’s chosen\n            merchant provider/donation tactic, Participant may incur fees,\n            charges and/or costs (collectively, “"), _c('strong', [_vm._v("POS Fees")]), _vm._v("”)\n            of participating in the Grateful Patient™ Program, including POS\n            Fees associated with credit card transactions processed in\n            connection with the Grateful Patient™ Program, including\n            processing fees, authorization fees, chargeback fees, or any other\n            related expenses. Unless otherwise expressly agreed by The\n            Foundation in writing, The Foundation shall not be responsible or\n            liable for any such POS Fees, and all such POS Fees shall be the\n            sole responsibility of Participant. This Section is not intended\n            to amend preexisting written agreements in which The Foundation\n            and Participant have agreed upon specific POS Fees. Participant\n            may either (a) if available, acquire from one or more suppliers\n            designated by The Foundation from time to time (each a “"), _c('strong', [_vm._v("Designated Supplier")]), _vm._v("”) specially configured equipment, software, and payment\n            processing services (collectively, “"), _c('strong', [_vm._v("Designated Supplier Equipment/Services")]), _vm._v("”) or (b) use Participant’s own POS system.\n            "), _c('strong', [_vm._v("The Foundation does not warrant or endorse Designated Suppliers\n              or Designated Supplier Equipment/Services and Participant’s use\n              of any Designated Supplier Equipment/Services shall be at\n              Participant’s own risk and subject to a separate agreement(s)\n              between Participant and one or more Designated\n              Suppliers.")]), _vm._v("\n            If Participant does not use Designated Supplier\n            Equipment/Services, Participant shall: (i) create a separate stock\n            keeping unit (“"), _c('strong', [_vm._v("SKU")]), _vm._v("”) to be used exclusively for\n            POS Donations, (ii) allow customers to make a donation at checkout\n            by any method of payment customarily accepted by Participant for\n            purchases (but excluding private or public insurance and\n            promotional coupons or offers); and (iii) issue a written receipt\n            to the customer indicating the donation SKU number, the fact that\n            the SKU represents a donation to OneSight EssilorLuxottica\n            Foundation, the amount of the donation, and the date of the\n            donation. With respect to all POS Donations collected by\n            Participant, Participant shall deposit and safely and securely\n            hold all such POS Donations as trustee for the sole benefit of The\n            Foundation until they are remitted to The Foundation as provided\n            in Section 6 (Payment) below; provided, that Participant shall not\n            be required to maintain a segregated bank account for such POS\n            Donations. The Foundation shall be the sole and exclusive owner of\n            all POS Donations. Participant shall not use the POS Donations\n            other than as described in this Grateful Patient™ Contract.\n            Participant shall not allow the POS Donations to be assigned,\n            alienated, pledged, encumbered or subjected to attachment,\n            garnishment, levy, execution or other legal or equitable process\n            by a third party.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Payment.")]), _c('strong', [_vm._v(" ")]), _vm._v("No later than\n            thirty (30) days after the end of each month, Participant will\n            remit to The Foundation 100% of the POS Donations collected by\n            Participant during such month; provided, however, that Participant\n            shall have no obligation to remit to The Foundation any POS\n            Donations that cannot be processed (e.g., returned checks, credit\n            card chargebacks, etc.) or that are remitted by Designated\n            Suppliers. Payments shall be made in U.S. Dollars by (i) check\n            payable to OneSight EssilorLuxottica Foundation and sent to The\n            Foundation,"), _c('strong'), _vm._v("P.O. Box 637509, Cincinnati, OH\n            45263-7509; or (ii) electronic fund transfer (EFT) at Fifth Third\n            Bank 38 Fountain Square Plaza – MD 1090U9 Cincinnati, OH 45263\n            Routing #042000314 Account #7028939465; or (iii) online credit\n            card payment at www.championsforsight.org/portal/resources or by\n            using the custom link provided by The Foundation for online\n            payments. Together with each payment, Participant shall provide to\n            The Foundation an accounting of all POS Donations collected by\n            Participant during the applicable\n            "), _c('a', {
    attrs: {
      "name": "_Hlk173322765"
    }
  }, [_vm._v("period but excluding POS Donations remitted by Designated\n              Suppliers")]), _vm._v(". Participant agrees that any tax credit or tax deduction accrues\n            to the original donor and not to Participant, which is acting as a\n            third-party conveyer of the donation. POS Donations may be used as\n            The Foundation deems appropriate, in its sole discretion, in\n            furtherance of The Foundation’s charitable mission.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Records. ")]), _vm._v("During the Term and for two (2) years\n            thereafter, Participant shall (i) maintain complete and accurate\n            books and records of all activities conducted in connection with\n            the Grateful Patient™ Program and the collection and payment of\n            all POS Donations, and (ii) allow The Foundation to inspect, copy,\n            and/or audit such books and records.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("No Endorsement.")]), _c('strong', [_vm._v(" ")]), _vm._v("Participant\n            shall in no way suggest endorsement by The Foundation of\n            Participant or Participant’s products or services.\n            "), _c('strong', [_vm._v("The Foundation does not warrant or endorse Designated Supplier\n              Equipment/Services and Participant’s use of any Designated\n              Supplier Equipment/Services shall be at Participant’s own\n              risk.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Permission to Link.")]), _c('strong', [_vm._v(" ")]), _vm._v("During\n            the Term, The Foundation grants Participant permission to provide\n            a link from Participant’s website to The Foundation’s website. The\n            Foundation reserves the right to withdraw such permission at any\n            time and for any reason.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of The Foundation")]), _vm._v(".\n            The Foundation represents and warrants to Participant that it: (i)\n            has the right, power and authority to enter into this Grateful\n            Patient™  Contract; (ii) possesses sufficient rights to\n            provide the Grateful Patient™  Program Materials to\n            Participant and authorize the Participant’s use of The Foundation\n            Marks and the Grateful Patient™ Program Materials as set forth\n            herein; and (iii) is a nonprofit organization in good standing and\n            qualified for tax-exempt status under Section 501(c)(3) of the\n            Internal Revenue Code.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of Participant")]), _vm._v(".\n            Participant represents and warrants to The Foundation that it: (i)\n            has the right, power and authority to enter into this Grateful\n            Patient™ Contract; and (ii) will comply with all applicable\n            federal, state, and local laws, statutes, and regulations\n            (collectively, “"), _c('strong', [_vm._v("Laws")]), _vm._v("”) in connection with the\n            Grateful Patient™ Program and this Grateful Patient™ Contract,\n            including any Laws governing charitable solicitations and\n            fundraising.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Indemnity")]), _vm._v(". Participant agrees to indemnify and\n            hold The Foundation its directors, officers, employees, agents,\n            and volunteers harmless from and against any and all costs, losses\n            or expenses, including reasonable attorneys’ fees, that The\n            Foundation may incur by reason of any claims, actions, demands, or\n            law suits brought by a third party arising out of or in connection\n            with (i) Participant’s negligence, recklessness, or intentional\n            misconduct; (ii) Participant’s performance or failure to perform\n            pursuant to this Grateful Patient™ Contract, including breach of\n            any provision of this Grateful Patient™ Contract; or (iii)\n            Participant’s location(s), business, products, or services,\n            including any claims in the nature of product liability, personal\n            injury, or professional malpractice.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Term and Termination. ")]), _vm._v("This Grateful Patient™\n            Contract shall commence on the Effective Date and continue until\n            terminated as provided herein (the “"), _c('strong', [_vm._v("Term")]), _vm._v("”).\n            Either party may terminate this Grateful Patient™ Contract: (i)\n            upon a material breach of the Grateful Patient™ Contract by the\n            other party, if such breach is not remedied to the reasonable\n            satisfaction of the non-breaching party within fifteen (15) days\n            after the non-breaching party provides written notice of the\n            breach to the other party; (ii) immediately upon written notice to\n            the other party whenever the notifying party in its reasonable\n            discretion determines that the continuation of the Grateful\n            Patient™ Contract will damage its reputation or good will; (iii)\n            upon fifteen (15) days written notice for convenience; or (iv)\n            immediately upon written notice to Participant in the event The\n            Foundation discontinues the Grateful Patient™ Program. Upon\n            termination of this Grateful Patient™ Contract, Participant shall\n            immediately convey to The Foundation all Grateful Patient™ Program\n            Donations collected but not yet paid to The Foundation, cease to\n            use the Grateful Patient™ Program Materials and The Foundation\n            Marks, and discontinue references in any manner to its\n            relationship with The Foundation. The provisions of this Section\n            shall not preclude the parties from seeking any other remedies\n            available to them under this Grateful Patient™ Contract and\n            applicable law. The Sections regarding Payment, Records,\n            Indemnity, Governing Law and Venue, Notices, and Miscellaneous\n            shall survive termination of this Grateful Patient™ Contract. In\n            addition, any provision which would, by its nature, survive the\n            termination of this Grateful Patient™ Contract, shall do so.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Dispute Resolution; Governing Law and Venue")]), _vm._v(". In the event of any dispute arising out of this Grateful\n            Patient™ Contract, the parties shall use good faith efforts to\n            resolve their differences amicably. In the event they are\n            unsuccessful, the parties agree not to commence litigation until\n            attempting to resolve their dispute through mediation. Any party\n            may initiate the mediation process with thirty (30) days’ prior\n            written notice to the other party. The dispute shall be submitted\n            to mediation in New York, New York. Costs of mediation shall be\n            borne equally by the parties.  Mediation of the dispute shall\n            be completed within fifteen (15) days of commencement, unless the\n            parties extend the time by mutual agreement or unless the mediator\n            declares the parties to be at an impasse. Notwithstanding the\n            above, in the event that either party believes that immediate\n            injunctive relief is required to protect its Marks or other\n            intellectual property rights, such party may invoke the immediate\n            powers of the appropriate court of law, subject to this Section\n            15, without the requirement to first mediate the dispute. This\n            Grateful Patient™ Contract shall be governed by and construed in\n            accordance with the laws of the state of New York, without regard\n            to conflicts of law principles. Any dispute arising out of or in\n            connection with this Grateful Patient™ Contract that is not\n            resolved under the dispute resolution provisions of this Section\n            15 shall be filed and heard in the state or federal courts located\n            in the State of New York, and each party consents to the exclusive\n            jurisdiction of such courts.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Relationship of Parties.")]), _c('strong', [_vm._v(" ")]), _vm._v("The parties to this Grateful Patient™\n            Contract are not joint venturers, partners, agents, nor\n            representatives of each other, are not authorized to act on each\n            other’s behalf, and have no legal relationship other than as\n            independent contracting parties to this Grateful Patient™\n            Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Assignment.")]), _c('strong', [_vm._v(" ")]), _vm._v("No party may\n            assign this Grateful Patient™ Contract, or any rights or\n            obligations hereunder, without the prior written consent of the\n            other party. Notwithstanding the foregoing, in the event that any\n            license agreement between The Foundation and its licensor is\n            terminated, The Foundation may, without Participant’s consent,\n            assign its rights and obligations with respect to any sublicense\n            granted hereunder to such licensor. Any attempt to assign this\n            Grateful Patient™ Contract in contravention of this Section shall\n            be void and of no force and effect.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Notices.")]), _c('strong', [_vm._v(" ")]), _vm._v("All notices\n            required or permitted to be given hereunder shall be in writing\n            and shall be sent by (i) personal delivery, (ii) reputable courier\n            service for prepaid overnight delivery, or (iii) USPS certified\n            mail, postage prepaid, return receipt requested. All notices to\n            Participant shall be forwarded to the contact person identified on\n            the Registration Form at the address listed for Participant on the\n            Registration Form or to such other person or address as\n            Participant may designate in writing to The Foundation for this\n            purpose. All notices to The Foundation shall be forwarded to\n            OneSight EssilorLuxottica Foundation, Attn: Giving Team, P.O. Box\n            637509, Cincinnati, OH 45263-7509 or to such other person or\n            address as The Foundation may designate in writing to Participant\n            for this purpose. In order for notice to The Foundation to be\n            effective, a copy of such notice must be sent to The Foundation,\n            Attn: General Counsel, at The Foundation address designated above.\n            Notices delivered hereunder shall be effective when received or\n            refused. Notwithstanding the foregoing, written approvals and\n            authorizations required hereunder may be provided by facsimile,\n            email, or other written means.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Entire Agreement.")]), _c('strong', [_vm._v(" ")]), _vm._v("This\n            Grateful Patient™ Contract supersedes any prior understandings or\n            oral agreements between the parties regarding the subject matter\n            hereof and constitutes the entire understanding and agreement of\n            such parties with respect to the subject matter hereof.\n            Notwithstanding the foregoing, your use of the OneSight\n            EssilorLuxottica Foundation website is also subject to the Terms\n            of Use ("), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org/terms-of-use"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org/terms-of-use")])])]), _vm._v(") and Privacy Policy ("), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org/privacy-policy"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org/privacy-policy")])])]), _vm._v(") posted on the Champions of Site website portal; provided, that\n            in the event of any conflict between this Grateful Patient™\n            Contract and the Terms of Use and/or Privacy Policy, the\n            provisions of this Grateful Patient™  Contract shall prevail.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Non-Exclusivity.")]), _c('strong', [_vm._v(" ")]), _vm._v("This\n            Grateful Patient™ Contract is a non-exclusive agreement which\n            reserves the rights of the parties to contract with third parties\n            for similar transactions.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "margin-bottom": "8pt",
      "text-align": "justify",
      "line-height": "108%"
    }
  }, [_c('strong', [_vm._v("Miscellaneous.")]), _c('strong', [_vm._v(" ")]), _vm._v("The failure\n            of any party at any time to require performance of any provision\n            of, or resort to any remedy provided under, this Grateful Patient™\n            Contract shall in no way affect the right of that party to require\n            performance or resort to a remedy at any time thereafter, nor\n            shall the waiver by any party of a breach be deemed to be a waiver\n            of any subsequent breach. A waiver shall not be effective unless\n            it is in writing and signed by the party against whom the waiver\n            is being enforced. If any term or provision of this Grateful\n            Patient™ Contract is determined to be invalid, illegal, or\n            incapable of being enforced by any law, regulation, or public\n            policy, all other terms and provisions of this Grateful Patient™\n            Contract shall nevertheless remain in full force and effect. This\n            Grateful Patient™ Contract shall not be altered, amended or\n            modified in any way except by a written instrument dated\n            subsequent to the date of this Grateful Patient™ Contract and\n            signed on behalf of the parties by their respective duly\n            authorized representatives. Section captions and headings are for\n            are for reference purposes only and shall not control or affect\n            the construction or interpretation of this Grateful Patient™\n            Contract in any respect. The word “including” means “including,\n            but not limited to.”\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    attrs: {
      "type": "I"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://files.championsforsight.org/CLTLTermsAndConditions1024.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n                Terms and Conditions to the Changing Life through Lenses®\n                Agreement\n              ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://files.championsforsight.org/BusinessAssociateAgreement1024.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n                Business Associate Agreement (BAA) ")]), _vm._v("(collectively, the \"Contract\")\n            ")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://files.championsforsight.org/GratefulPatients1024.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n                Terms and Conditions to Point of Sale Giving\n              ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62833713", module.exports)
  }
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isModalShown) ? _c('div', [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "z-index": "99999"
    },
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content loading-div"
  }, [_c('div', {
    staticClass: "modal-body center"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-63b63452", module.exports)
  }
}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Communication and Contract Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Account Communication Preferences")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountView.toBeContactedAsVolunteer),
      expression: "AccountView.toBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountView.toBeContactedAsVolunteer) ? _vm._i(_vm.AccountView.toBeContactedAsVolunteer, null) > -1 : (_vm.AccountView.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountView.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountView, "toBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountView, "toBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountView, "toBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like to be contacted if there are volunteer opportunities in my area.")])]), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountView.toReceiveNewsLetter),
      expression: "AccountView.toReceiveNewsLetter"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.AccountView.toReceiveNewsLetter) ? _vm._i(_vm.AccountView.toReceiveNewsLetter, null) > -1 : (_vm.AccountView.toReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.AccountView.toReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.AccountView, "toReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.AccountView, "toReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.AccountView, "toReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_vm._v("I would like email updates from OneSight EssilorLuxottica Foundation.")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Program Contract")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "account_p"
  }, [_c('a', {
    staticClass: "g-font-size-18 just-link",
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isContractLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v(" \n            to download a copy of your contract.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.EditSection()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('edit-communication-info', {
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "isFormLoading": _vm.isFormLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.SaveAccount()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a72fba0", module.exports)
  }
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Shipping Address")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.BusinessLabels) ? _c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("My Office Location Information")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("My Location Information")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('p', [_vm._v("Please enter your shipping address information")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels || _vm.FormInputs.BusinessLabels) ? _c('p', [_vm._v("Please enter the following information for your primary location")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.ContactIsMultiLocation),
      expression: "FormInputs.ContactIsMultiLocation"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Multi-Location Business:")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Multi-Location Organization:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.isMultiLocation),
      expression: "AccountEdit.primaryContact.isMultiLocation"
    }],
    attrs: {
      "type": "radio",
      "value": "true",
      "name": "IsMultilocation"
    },
    domProps: {
      "checked": _vm._q(_vm.AccountEdit.primaryContact.isMultiLocation, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.AccountEdit.primaryContact, "isMultiLocation", "true")
      }
    }
  }), _vm._v(" Yes\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.isMultiLocation),
      expression: "AccountEdit.primaryContact.isMultiLocation"
    }],
    attrs: {
      "type": "radio",
      "value": "false",
      "name": "IsMultilocation"
    },
    domProps: {
      "checked": _vm._q(_vm.AccountEdit.primaryContact.isMultiLocation, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.AccountEdit.primaryContact, "isMultiLocation", "false")
      }
    }
  }), _vm._v(" No\n                        ")])])])])]), _vm._v(" "), (_vm.FormInputs.OfficeLocationName && (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Office Location Name*")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Chapter Location Name*")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.name),
      expression: "AccountEdit.primaryContact.officeLocation.name"
    }],
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationName))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationStreetAddress),
      expression: "FormInputs.OfficeLocationStreetAddress"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Street Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.AccountEdit.primaryContact.officeLocation.streetAddress),
      expression: "AccountEdit.primaryContact.officeLocation.streetAddress",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationStreetAddress
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.streetAddress)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "streetAddress", $event.target.value)
      }, _vm.addressChanged]
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationStreetAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationStreetAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationSuite),
      expression: "FormInputs.OfficeLocationSuite"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suite")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.suite),
      expression: "AccountEdit.primaryContact.officeLocation.suite"
    }],
    staticClass: "form-control input_field input_field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.suite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "suite", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationCity),
      expression: "FormInputs.OfficeLocationCity"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.city),
      expression: "AccountEdit.primaryContact.officeLocation.city"
    }],
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationCity
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationCity) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationCity))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationState),
      expression: "FormInputs.OfficeLocationState"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.state),
      expression: "AccountEdit.primaryContact.officeLocation.state"
    }],
    staticClass: "form-control input_field select_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationState
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationState))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationZip),
      expression: "FormInputs.OfficeLocationZip"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Zip Code*")]), _vm._v(" "), (_vm.IsValidNPI) ? _c('span', [_c('i', {
    staticClass: "fa fa-check-circle check_icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.IsAddressValidating) ? _c('span', {
    staticClass: "loading_icon"
  }, [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.zip),
      expression: "AccountEdit.primaryContact.officeLocation.zip"
    }],
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationZip
    },
    attrs: {
      "maxlength": "5",
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.zip)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateAddress()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "zip", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationZip) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationZip))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationPhoneNumber),
      expression: "FormInputs.OfficeLocationPhoneNumber"
    }],
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone Number"), (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row div-phone"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.countryCode),
      expression: "AccountEdit.primaryContact.officeLocation.countryCode"
    }],
    ref: "office_number_1",
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.countryCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "countryCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-3 col-xs-4 sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.areaCode),
      expression: "AccountEdit.primaryContact.officeLocation.areaCode"
    }],
    ref: "office_number_2",
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.areaCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.NextField(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "areaCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4 md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.phone),
      expression: "AccountEdit.primaryContact.officeLocation.phone"
    }],
    ref: "office_number_3",
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.phone)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationPhoneNumber))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationEmailAddress && (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true)),
      expression: "FormInputs.OfficeLocationEmailAddress && (AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true)"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location Contact Email Address:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationEmailAddress),
      expression: "FormInputs.OfficeLocationEmailAddress"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Office Contact Email Address"), (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Location Contact Email Address"), (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.emailAddress),
      expression: "AccountEdit.primaryContact.officeLocation.emailAddress"
    }],
    staticClass: "form-control input_field input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationEmailAddress
    },
    attrs: {
      "type": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "emailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationEmailAddress))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContact && (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true)),
      expression: "FormInputs.OfficeLocationContact && (AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true)"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Office Contact:")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location Contact:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContactFirstName),
      expression: "FormInputs.OfficeLocationContactFirstName"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("First Name"), (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("First Name"), (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.contactFirstName),
      expression: "AccountEdit.primaryContact.officeLocation.contactFirstName"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationContactFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.contactFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "contactFirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationContactFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationContactFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContactLastName),
      expression: "FormInputs.OfficeLocationContactLastName"
    }],
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Last Name"), (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Last Name"), (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true) ? _c('span', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.contactLastName),
      expression: "AccountEdit.primaryContact.officeLocation.contactLastName"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationContactLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.contactLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "contactLastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationContactFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationContactLastName))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationContactRole && (_vm.AccountEdit.primaryContact.isMultiLocation == 'true' || _vm.AccountEdit.primaryContact.isMultiLocation == true)),
      expression: "FormInputs.OfficeLocationContactRole && (AccountEdit.primaryContact.isMultiLocation == 'true' || AccountEdit.primaryContact.isMultiLocation == true)"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', {
    staticClass: "account_label"
  }) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Role in Organization:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.FormInputs.BusinessLabels) ? _c('label', [_vm._v("Role in Business")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('label', [_vm._v("Role in Organization")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.contactRole),
      expression: "AccountEdit.primaryContact.officeLocation.contactRole"
    }],
    staticClass: "form-control select_field",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "contactRole", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l(((_vm.FormInputs.RoleBusiness ? _vm.RoleBusiness : _vm.RoleNonProfit)), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location Name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Shipping Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "This is an alternative email address. Your primary contact email address is your login email.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "This is an alternative email address. Your primary contact email address is your login email.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6acf0101", module.exports)
  }
}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v("General")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "g-font-size-20 mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-color-primary--hover g-font-size-20--md g-font-size-17 g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b64b8dd", module.exports)
  }
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-mt-minus-70",
    class: [{
      'container-fluid': this.framePageVisible == 'true'
    }, {
      'container-fluid': _vm.accountType != 'master'
    }, {
      'container': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(this.framePageVisible == 'true' || _vm.accountType == 'master') ? _c('div', {
    staticClass: "col-lg-1 col-div-0"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 g-mb-30 g-mb-20--lg",
    class: [{
      'col-lg-2 col-div-4': this.framePageVisible == 'true'
    }, {
      'col-lg-2 col-div-4': _vm.accountType == 'master'
    }, {
      'col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "_x31_"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5c26.7,0,50.4,12.9,65.2,32.9"
    }
  })])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 g-mb-30 g-mb-20--lg",
    class: [{
      'col-lg-2 col-div-4': this.framePageVisible == 'true'
    }, {
      'col-lg-2 col-div-4': _vm.accountType === 'master'
    }, {
      'col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType === 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5\n                c43,0,78.2,33.6,80.8,75.9"
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), (this.framePageVisible == 'true' || _vm.accountType == 'master') ? _c('div', {
    staticClass: "col-sm-6 col-lg-2 col-div-4 g-mb-30 g-mb-20--lg"
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5c44.7,0,81,36.3,81,81c0,21.3-8.2,40.6-21.6,55.1,55"
    }
  })]), _vm._v(" "), _vm._m(2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 g-mb-30 g-mb-20--lg",
    class: [{
      'col-lg-2 col-div-6': this.framePageVisible == 'true'
    }, {
      'col-lg-2 col-div-6': _vm.accountType == 'master'
    }, {
      'col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    class: [{
      'div-left': this.framePageVisible == 'true'
    }, {
      'div-left': _vm.accountType == 'master'
    }],
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resource')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "none",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5c44.7,0,81,36.3,81,81s-36.3,81-81,81c-26.3"
    }
  })]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "g-mb-30 g-mb-20--lg",
    class: [{
      'col-sm-12 col-lg-2 col-div-6': this.framePageVisible == 'true'
    }, {
      'col-sm-12 col-lg-2 col-div-6': _vm.accountType == 'master'
    }, {
      'col-sm-6 col-lg-3': this.framePageVisible == 'false'
    }]
  }, [_c('div', {
    staticClass: "g-py-10 g-icon-link",
    class: [{
      'div-right': this.framePageVisible == 'true'
    }, {
      'div-right': _vm.accountType == 'master'
    }],
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_c('div', {
    staticClass: "u-shadow-v37 rounded-circle g-pos-rel mx-auto",
    class: [{
      'g-width-200 g-height-200': this.framePageVisible == 'true'
    }, {
      'g-width-200 g-height-200': _vm.accountType == 'master'
    }, {
      'g-width-220 g-height-220': this.framePageVisible == 'false'
    }]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 187 187",
      "enable-background": "new 0 0 187 187",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "93.5",
      "cy": "93.5",
      "r": "93.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "#f0f2f8",
      "stroke-width": "7",
      "stroke-miterlimit": "10",
      "cx": "93.5",
      "cy": "93.5",
      "r": "81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "stroke": "var(--primary-color)",
      "stroke-width": "7",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "d": "M93.5,12.5\n                c44.7,0,81,36.3,81,81s-36.3,81-81,81c-26.3,0-49.7-12.6-64.5-32"
    }
  })]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), (this.framePageVisible == 'true' || _vm.accountType == 'master') ? _c('div', {
    staticClass: "col-lg-1 col-div-0"
  }) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("Patient Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("Track Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary nomargin"
  }, [_vm._v("Frame Collection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("Guides & Resources")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35"
  }, [_c('h4', {
    staticClass: "h2 g-font-primary"
  }, [_vm._v("FAQs")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bc54524", module.exports)
  }
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ResourcePage"
  }, [_c('header-component'), _vm._v(" "), _c('resource-services'), _vm._v(" "), _c('resource-suggest'), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c3e119d", module.exports)
  }
}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row g-mb-20"
  }, [_c('p', {
    staticClass: "g-mb-30 text-center g-font-size-18--md g-font-size-18 g-px-20"
  }, [_vm._v("Changing Life through Lenses® offers a few options to best accommodate how you engage in charity vision services. Select the account you would like to register for:")]), _vm._v(" "), _c('article', {
    staticClass: "col-md-4 g-mb-20  text-center",
    attrs: {
      "data-balloon": _vm.invAccountTooltip,
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    },
    on: {
      "click": function($event) {
        return _vm.ChooseFormType('Individual')
      }
    }
  }, [_c('div', {
    staticClass: "g-mb-15"
  }, [_c('img', {
    staticClass: "img-fluid registration-icon",
    attrs: {
      "src": _vm.individualIcon,
      "alt": "Individual Eye Doctor Account"
    },
    on: {
      "mouseover": function($event) {
        return _vm.HoverIndividual('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverIndividual('leave')
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "btn u-shadow-v39 g-color-white g-color-white--hover g-bg-main g-bg-primary--hover g-font-size-18--md g-font-size-17 g-rounded-30 g-px-35 g-py-8",
    on: {
      "click": function($event) {
        return _vm.ChooseFormType('Individual')
      },
      "mouseover": function($event) {
        return _vm.HoverIndividual('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverIndividual('leave')
      }
    }
  }, [_vm._v("Sign Up")])]), _vm._v(" "), _c('article', {
    staticClass: "col-md-4 g-mb-30 text-center",
    attrs: {
      "data-balloon": _vm.businessAccountTooltip,
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    },
    on: {
      "click": function($event) {
        return _vm.ChooseFormType('Business')
      }
    }
  }, [_c('div', {
    staticClass: "g-mb-15"
  }, [_c('img', {
    staticClass: "img-fluid registration-icon",
    attrs: {
      "src": _vm.practiceIcon,
      "alt": "Practice/Business Account"
    },
    on: {
      "mouseover": function($event) {
        return _vm.HoverPractice('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverPractice('leave')
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "btn u-shadow-v39 g-color-white g-color-white--hover g-bg-main g-bg-primary--hover g-font-size-18--md g-font-size-17 g-rounded-30 g-px-35 g-py-8",
    on: {
      "click": function($event) {
        return _vm.ChooseFormType('Business')
      },
      "mouseover": function($event) {
        return _vm.HoverPractice('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverPractice('leave')
      }
    }
  }, [_vm._v("Sign Up")])]), _vm._v(" "), _c('article', {
    staticClass: "col-md-4 g-mb-30 text-center",
    attrs: {
      "data-balloon": _vm.nonprofitAccountTooltip,
      "data-balloon-pos": "up",
      "data-balloon-length": "large"
    },
    on: {
      "click": function($event) {
        return _vm.ChooseFormType('NonProfit')
      }
    }
  }, [_c('div', {
    staticClass: "g-mb-15"
  }, [_c('img', {
    staticClass: "img-fluid registration-icon",
    attrs: {
      "src": _vm.nonProfitIcon,
      "alt": "Non-Profit Account"
    },
    on: {
      "mouseover": function($event) {
        return _vm.HoverNonProfit('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverNonProfit('leave')
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "btn u-shadow-v39 g-color-white g-color-white--hover g-bg-main g-bg-primary--hover g-font-size-18--md g-font-size-17 g-rounded-30 g-px-35 g-py-8",
    on: {
      "click": function($event) {
        return _vm.ChooseFormType('NonProfit')
      },
      "mouseover": function($event) {
        return _vm.HoverNonProfit('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverNonProfit('leave')
      }
    }
  }, [_vm._v("Sign Up")])])]), _vm._v(" "), _c('div', {
    staticClass: "account-section-divider"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "account-section-divider"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-mb-15"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Individual Eye Doctor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-mb-15"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Practice/Business")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-mb-15"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Non-Profit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row g-py-30 g-px-30"
  }, [_c('div', {
    staticClass: "g-max-width-645 text-center mx-auto mb-3"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Not sure which account to choose?")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20--md g-font-size-18"
  }, [_vm._v("Hover your mouse over the icons and read the additional descriptions.")])]), _vm._v(" "), _c('ul', {
    staticClass: "g-font-size-20--md g-font-size-16"
  }, [_c('li', [_vm._v("If you are an individual eye doctor who owns their own solo practice, it is recommended that you select a business account.")]), _vm._v(" "), _c('li', [_vm._v("You can be a part of a Practice/Business Account and still sign up for an Individual Account for all your private charitable work.")]), _vm._v(" "), _c('li', [_vm._v("Orders are routed through the OneSight EssilorLuxottica Foundation lab(s) and may not be completed by an existing lab relationship.")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e338215", module.exports)
  }
}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br')])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e8b0df4", module.exports)
  }
}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isModalShown) ? _c('div', [(_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content g-mt-170 g-z-index-1"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), (_vm.ResetForm) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-mb-10 g-pt-20"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "reset_info_label"
  }, [_vm._v("Enter Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestEmail),
      expression: "RequestEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control login_input",
    attrs: {
      "name": "email",
      "type": "email",
      "data-vv-as": "email address",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.RequestEmail)
    },
    on: {
      "keyup": function($event) {
        return _vm.ResetValidation()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), (!_vm.errors.first('email')) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center g-mt-20"
  }, [_c('button', {
    staticClass: "btn btn-default g-font-size-16 u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-font-size-17 g-rounded-10 g-px-25",
    on: {
      "click": function($event) {
        return _vm.ForgotPassword()
      }
    }
  }, [_vm._v("Email Password Reset")])])])]) : _vm._e(), _vm._v(" "), (_vm.ResetStatus) ? _c('div', [_c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Success!")]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("Please check your e-mail for authorization to reset your password.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-font-size-default g-rounded-10 g-px-25",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _vm._m(1)]) : _vm._e()])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Reset Your Password")]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("Enter your email address below and we'll email you a link to reset your password.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "passwordReset-header"
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71156e4e", module.exports)
  }
}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('frame-header'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container g-mt-10 g-mb-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-md-1 col-sm-12 col-xs-12 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white text-uppercase g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disabled": !_vm.Account.isFrameKitAllowed,
      "id": "PlaceOrder"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleFrameOrderForm('Order Frame Kit')
      }
    }
  }, [_vm._v("\n            Order Collection\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disabled": !_vm.Account.isFrameOrderingAllowed,
      "data-balloon": _vm.GetTooltip(_vm.Account.isFrameOrderingAllowed),
      "data-balloon-pos": "up"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleFrameOrderForm('Order Individual Frame')
      }
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v("Order Replacement")])]), _vm._v(" "), _c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "click": _vm.goToVirtualTryOn
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v("Virtual Try-On")])]), _vm._v(" "), (_vm.ShowDisplayCaseField) ? _c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disabled": !_vm.Account.isFrameOrderingAllowed,
      "data-balloon": _vm.GetTooltip(_vm.Account.isFrameOrderingAllowed),
      "data-balloon-pos": "up"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleFrameOrderForm('Order Display Case')
      }
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v("Order Display Case")])]) : _vm._e()]), _vm._v(" "), (!_vm.isFrameLoading) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('frame-filters', {
    attrs: {
      "searchValues": _vm.searchValues
    },
    on: {
      "clicked": _vm.GetFrames,
      "reset": function($event) {
        return _vm.Reset()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isFrameLoading) ? _c('page-loader') : _vm._e()], 1)]), _vm._v(" "), _vm._l((_vm.frameInformationList), function(frameInformation, index) {
    return (frameInformation.isEVFFrame && !_vm.isFrameLoading) ? _c('div', {
      key: index,
      staticClass: "container-fluid g-pb-40"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 text-center"
    }, [_c('frame-order-collection')], 1), _vm._v(" "), (frameInformation.frameList.length > 0) ? _c('div', {
      staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12"
    }, [_c('frame-list', {
      attrs: {
        "frameList": frameInformation.frameList
      }
    })], 1) : _c('div', {
      staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12 center div-spacing-top"
    }, [_c('p', {
      staticClass: "g-font-size-20 g-color-main"
    }, [_vm._v("\n            Your search returned no results\n          ")])]), _vm._v(" "), (!_vm.Account.isFrameKitAllowed) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('p', {
      staticClass: "error-message"
    }, [_vm._v("\n            You cannot place an order for a frame collection at this time\n          ")])]) : _vm._e()]), _vm._v(" "), (!_vm.isFrameLoading) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    })]) : _vm._e(), _vm._v(" "), (_vm.isFrameLoading) ? _c('page-loader') : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (
    _vm.frameInformationList.filter(function (a) { return !a.isEVFFrame; }).length > 0 &&
    !_vm.isFrameLoading
  ) ? _c('div', {
    staticClass: "container-fluid g-pb-40"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.showJotForm) ? _c('jotform-modal', {
    attrs: {
      "Account": _vm.Account,
      "formID": "220894492083058"
    },
    on: {
      "closeJotForm": _vm.CloseModal
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.frameInformationList.filter(
    function (a) { return !a.isEVFFrame; }
  )), function(frameInformation, index) {
    return (!frameInformation.isEVFFrame && !_vm.isFrameLoading) ? _c('div', {
      key: index,
      staticClass: "container-fluid g-pb-40"
    }, [_c('div', {
      staticClass: "row"
    }, [(index != 0) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
    }, [_c('hr')]) : _vm._e(), _vm._v(" "), (frameInformation.catalogName) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
    }, [_c('h2', [_vm._v(_vm._s(_vm.ConvertToTitleCase(frameInformation.catalogName)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 text-center"
    }), _vm._v(" "), (frameInformation.frameList.length > 0) ? _c('div', {
      staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12"
    }, [_c('frame-list', {
      attrs: {
        "frameList": frameInformation.frameList
      }
    })], 1) : _vm._e()])]) : _vm._e()
  })], 2), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isPlaceOrder) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('frame-shipping-billing', {
    attrs: {
      "Account": _vm.Account
    },
    on: {
      "exitModal": _vm.CloseModal
    }
  })], 1)])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('h2', [_vm._v("Frame Collection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', [_vm._v("\n            View the Champions for Sight® frame collection below. Once ordered, the collection will arrive in 2-3 weeks, and you can begin ordering complete pairs of glasses for eligible patients without the need to ship frames to the lab. \n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            ✨ New! Our Virtual Try-On tool lets patients see themselves in any of the 45 stylish frame styles — in real time and true to fit.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('h1', [_vm._v("Additional Frames")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("\n                These frames are not part of the Changing Life through Lenses™\n                frame collection, but are available for you to select as a\n                Frame and Lens order on the Order page. You cannot order a\n                frame collection for these\n                additional frames.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12"
  })])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72b93eda", module.exports)
  }
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "participant-information row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "bs-component",
    staticStyle: {
      "margin-bottom": "2px"
    },
    attrs: {
      "hidden": ""
    }
  }, [_c('label', [_vm._v("Search By:")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified input-group"
  }, [_c('button', {
    staticClass: "btn g-color-white text-uppercase g-rounded-5 mr-1",
    class: {
      'g-bg-main g-bg-main-blue--hover': _vm.isActiveClassName
    },
    on: {
      "click": function($event) {
        return _vm.clickSearchOption('name')
      }
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white text-uppercase g-rounded-5 mr-1",
    class: {
      'g-bg-main g-bg-main-blue--hover': _vm.isActiveClassId
    },
    on: {
      "click": function($event) {
        return _vm.clickSearchOption('id')
      }
    }
  }, [_vm._v("EVF-ID")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white text-uppercase g-rounded-5 mr-1",
    class: {
      'g-bg-main g-bg-main-blue--hover': _vm.isActiveClassEmail
    },
    on: {
      "click": function($event) {
        return _vm.clickSearchOption('email')
      }
    }
  }, [_vm._v("Email")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "input-group mb-3",
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeyword),
      expression: "searchKeyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search.."
    },
    domProps: {
      "value": (_vm.searchKeyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.Search(_vm.searchKeyword)
      },
      "focus": function($event) {
        return _vm.ViewResultsAgain()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.Search(_vm.searchKeyword)
      }
    }
  }, [_vm._v("Search "), _vm._m(1)])])])]), _vm._v(" "), (_vm.isDropDownShown) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-dropdown"
  }, [(_vm.isSearchResultLoaded && !_vm.noResults) ? _c('ul', {
    staticClass: "ul-dropdown"
  }, _vm._l((_vm.AccountList), function(al, index) {
    return _c('li', {
      staticClass: "list-hover",
      attrs: {
        "id": index
      },
      on: {
        "click": function($event) {
          return _vm.SelectAccount(al.salesforceId)
        }
      }
    }, [(al.accountType == 1) ? _c('span', {
      staticClass: "list-text"
    }, [_vm._v(_vm._s(al.primaryContact.firstName) + " " + _vm._s(al.primaryContact.lastName) + "; " + _vm._s(al.emailAddress) + "; EVF-ID: " + _vm._s(al.evfAccountNumber) + " SF ID: " + _vm._s(al.salesforceId))]) : _c('span', {
      staticClass: "list-text"
    }, [_vm._v(_vm._s(al.primaryContact.legalName) + "; " + _vm._s(al.emailAddress) + "; EVF-ID: " + _vm._s(al.evfAccountNumber) + " SF ID: " + _vm._s(al.salesforceId))])])
  }), 0) : (_vm.noResults && _vm.isSearchResultLoaded) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(3)])]) : _vm._e(), _vm._v(" "), (_vm.SelectedAccount) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [(!_vm.selectedAccountLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Participant Name:")]), _vm._v(" "), (_vm.SelectedAccount.accountType == 1) ? _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.SelectedAccount.primaryContact.firstName) + " " + _vm._s(_vm.SelectedAccount.primaryContact.lastName))]) : _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.SelectedAccount.primaryContact.legalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Participant Login Email:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.SelectedAccount.emailAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("EVF ID:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.SelectedAccount.evfAccountNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Salesforce ID:")]), _vm._v(" "), _c('a', {
    staticClass: "order-confirmation-description",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.OpenSalesForce(_vm.SelectedAccount.salesforceId)
      }
    }
  }, [_vm._v(_vm._s(_vm.SelectedAccount.salesforceId))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedAccountLoading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(4)]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Participant Account Information\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', [_vm._v("No results found")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-739a27fc", module.exports)
  }
}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _vm._m(0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "title": "Share a Success Story",
      "src": "https://www.jotform.com/form/200414758515049",
      "width": "100%",
      "height": "625",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7418f83e", module.exports)
  }
}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('p', {
    staticClass: "center contract-header"
  }, [_vm._v("Contract Update")]), _vm._v(" "), _c('p', {
    staticClass: "contract-description"
  }, [_vm._v("\n                Please review and accept the\n                following contract updates in order to\n                proceed with logging in to your account.\n                If you have any questions or concerns,\n                please "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("click here")]), _vm._v(" to contact us.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin-50"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.TermAgreement),
      expression: "Account.TermAgreement"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "true",
      "type": "radio",
      "name": "TermAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.TermAgreement, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Account, "TermAgreement", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label contract-description"
  }, [_vm._v("\n                   I have read and AGREE to the above Terms and Conditions\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.TermAgreement),
      expression: "Account.TermAgreement"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "false",
      "type": "radio",
      "name": "TermAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.TermAgreement, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Account, "TermAgreement", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label contract-description"
  }, [_vm._v("\n                  I DO NOT AGREE to the above Terms and Conditions\n                ")])]), _vm._v(" "), (_vm.Account.TermAgreement == 'false' || _vm.Account.TermAgreement == false) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("You must select \"I Agree\" to submit the form. Please click "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us with questions or concerns")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "contract-label"
  }, [_vm._v("Electronic Signature*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ParticipantResponsibilitiesSignature),
      expression: "Account.ParticipantResponsibilitiesSignature"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.ParticipantResponsibilitiesSignature
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.ParticipantResponsibilitiesSignature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "ParticipantResponsibilitiesSignature", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.ParticipantResponsibilitiesSignature) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.ParticipantResponsibilitiesSignature))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "contract-label"
  }, [_vm._v("Date*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessAssociateAgreementDate),
      expression: "BusinessAssociateAgreementDate"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.BusinessAssociateAgreementDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BusinessAssociateAgreementDate = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), (_vm.Account.AccountType != 'NonProfit' || (_vm.Account.AccountType == 'NonProfit' && (_vm.Account.IsCoveredUnderHIPAA == 'true' || _vm.Account.IsCoveredUnderHIPAA == true))) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.BusinessAssociateAgreement),
      expression: "Account.BusinessAssociateAgreement"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "true",
      "type": "radio",
      "name": "BusinessAssociateAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.BusinessAssociateAgreement, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Account, "BusinessAssociateAgreement", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label contract-description"
  }, [_vm._v("\n                    I have read and AGREE to the above Business Associate Agreement\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.BusinessAssociateAgreement),
      expression: "Account.BusinessAssociateAgreement"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "false",
      "type": "radio",
      "name": "BusinessAssociateAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.BusinessAssociateAgreement, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Account, "BusinessAssociateAgreement", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label contract-description"
  }, [_vm._v("\n                    I DO NOT AGREE to the above Business Associate Agreement\n                ")])]), _vm._v(" "), (_vm.Account.BusinessAssociateAgreement == 'false' || _vm.Account.BusinessAssociateAgreement == false) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("You must select \"I Agree\" to submit the form. Please click "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us with questions or concerns")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "contract-label"
  }, [_vm._v("Electronic Signature*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.BusinessAssociateAgreementSignature),
      expression: "Account.BusinessAssociateAgreementSignature"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.AccountValidationResult.BusinessAssociateAgreementSignature
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.BusinessAssociateAgreementSignature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "BusinessAssociateAgreementSignature", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.AccountValidationResult.BusinessAssociateAgreementSignature) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.BusinessAssociateAgreementSignature))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "contract-label"
  }, [_vm._v("Date*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessAssociateAgreementDate),
      expression: "BusinessAssociateAgreementDate"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.BusinessAssociateAgreementDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BusinessAssociateAgreementDate = $event.target.value
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center bottom-margin-50"
  }, [(_vm.Account.IsCoveredUnderHIPAA == 'true') ? _c('button', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10",
    attrs: {
      "type": "submit",
      "disabled": !_vm.Account.BusinessAssociateAgreementSignature || !_vm.Account.ParticipantResponsibilitiesSignature || (!_vm.Account.BusinessAssociateAgreement || _vm.Account.BusinessAssociateAgreement == 'false') || (!_vm.Account.TermAgreement || _vm.Account.TermAgreement == 'false')
    },
    on: {
      "click": function($event) {
        return _vm.UpdateContract()
      }
    }
  }, [_vm._v("Submit")]) : (_vm.Account.IsCoveredUnderHIPAA == 'false') ? _c('button', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10",
    attrs: {
      "type": "submit",
      "disabled": !_vm.Account.ParticipantResponsibilitiesSignature || (!_vm.Account.TermAgreement || _vm.Account.TermAgreement == 'false')
    },
    on: {
      "click": function($event) {
        return _vm.UpdateContract()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isContractModalShown) ? _c('contract-agreement-modal') : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8 offset-lg-2 bottom-margin-10"
  }, [_c('span', {
    staticClass: "contract-label"
  }, [_vm._v("Terms And Conditions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "contract-description"
  }, [_vm._v("Please review and accept the Terms and Conditions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8 offset-lg-2",
    staticStyle: {
      "border": "1px solid black",
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "terms-style"
  }, [_c('p', [_c('strong', [_vm._v("Essilor Vision Foundation Changing Life through Lenses® Terms and Conditions")])]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Contract Documents and")]), _vm._v(" "), _c('strong', [_vm._v("Effective Date:")]), _vm._v(" These Essilor Vision Foundation Changing Life through Lenses® Terms and Conditions (\""), _c('strong', [_vm._v("Terms and Conditions")]), _vm._v("\") supplement and are made a part of the Essilor Vision Foundation Changing Life through Lenses® Agreement (\""), _c('strong', [_vm._v("Contract")]), _vm._v("\") by and between the legal entity or individual identified as the participant (“"), _c('strong', [_vm._v("Participant")]), _vm._v("”) on the Essilor Vision Foundation Changing Life through Lenses® registration form (“"), _c('strong', [_vm._v("Registration Form")]), _vm._v("”) and Essilor Vision Foundation (\""), _c('strong', [_vm._v("EVF")]), _vm._v("”). The Contract consists of (i) these Terms and Conditions, and (ii) if applicable, the Business Associate Agreement (which is set forth on the Registration Form if Participant is a covered entity under the Health Insurance Portability and Accountability Act of 1996). Your use of the Changing Life through Lenses® online platform (“"), _c('strong', [_vm._v("Portal")]), _vm._v("”) is also subject to the "), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" posted on "), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org",
      "target": "_blank"
    }
  }, [_vm._v("www.evfusa.org")]), _vm._v("; provided, that in the event of any conflict between the Contract and the "), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and/or "), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(", the provisions of the Contract shall prevail. If you accept the Contract, the date on which you click the “Submit” button shall be the effective date of the Contract (“"), _c('strong', [_vm._v("Effective Date")]), _vm._v("”). "), _c('u', [_vm._v("BY CLICKING THE “SUBMIT” BUTTON, (i) YOU ARE BINDING PARTICIPANT TO THE CONTRACT, THE ")]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("TERMS OF USE")]), _c('u', [_vm._v(", AND THE ")]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("PRIVACY POLICY")]), _c('u', [_vm._v(", AND (ii) IF PARTICIPANT IS A LEGAL ENTITY, YOU ARE REPRESENTING AND WARRANTING THAT YOU ARE AUTHORIZED TO AGREE TO THE CONTRACT, THE ")]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions"
    }
  }, [_vm._v("TERMS OF USE")]), _c('u', [_vm._v(", AND THE ")]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("PRIVACY POLICY")]), _c('u', [_vm._v(" ON BEHALF OF PARTICIPANT")]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Program Information:")]), _vm._v(" EVF is a non-profit organization committed to eliminating poor vision and its lifelong consequences and to providing underprivileged people the opportunity to live a better life through better sight. EVF works with nonprofit organizations and socially responsible vision care providers across the United States to provide in-kind donations of lenses and manufacturing of glasses for use by Eligible Patients (the “"), _c('strong', [_vm._v("Program")]), _vm._v("”). “"), _c('strong', [_vm._v("Eligible Patients")]), _vm._v("” are individuals (i) living at or below the poverty line; (ii) who are not covered by vision insurance for the pair of glasses to be provided in connection with the Program; and (iii) who could not otherwise afford vision services, as reasonably determined by Participant. EVF has created the Portal to facilitate registration and participation in the Program. Participant acknowledges that the current focus of the Program is on youth and agrees to use reasonable efforts to provide products supplied by EVF (including lenses and/or frames) primarily to Eligible Patients who are minors. Participant further acknowledges and agrees that, upon reasonable advance notice to Participant, EVF may from time to time revise the definition of Eligible Patients and the criteria for determining eligibility.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Program Materials:")]), _vm._v(" EVF will make available to Participant educational resources and materials describing how Participant may conduct and optimize its charitable activities in connection with the Program (“"), _c('strong', [_vm._v("Program Educational Materials")]), _vm._v("”) and may make available to Participant certain assets or materials to promote Participant’s involvement in the Program (“"), _c('strong', [_vm._v("Program Promotional Materials")]), _vm._v("”) (Program Educational Materials and Program Promotional Materials, collectively “"), _c('strong', [_vm._v("Program Materials")]), _vm._v("”). Participant may make copies of Program Educational Materials solely for use by Participant and Participant’s employees in connection with the Program. Participant shall not copy Program Promotional Materials without EVF’s express written approval. If Participant has an opportunity to promote the Program with Program Promotional Materials, upon Participant’s request, EVF will provide Participant with the EVF logo lock up and graphic standards to be used, subject to EVF’s prior written approval in each instance. Participant shall use Program Materials solely in connection with the Program. Participant shall use Program Materials as is and shall not modify Program Materials in any way without the express written approval of EVF. Participant shall not delete, obscure, or alter any disclosures or any copyright notice, trademarks, or other proprietary rights notices affixed to or contained in the Program Materials. Upon expiration or termination of the Contract, Participant shall destroy or immediately return to EVF all Program Materials in Participant’s possession.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Lenses and Frames:")]), _vm._v(" EVF will endeavor to provide Participant with fully fabricated lenses, subject to such limitations on quantity as EVF may determine from time to time in its sole discretion, as prescribed by the Participant for Eligible Patients served through Participant’s charitable activities. Lenses will be fabricated to meet the prescription needs of each Eligible Patient, including single vision and bifocals and the use of polycarbonate materials. Lenses shall be fabricated by EVF’s suppliers and mounted in frames provided on a frame-to-come basis by Participant (“"), _c('strong', [_vm._v("Participant Frames")]), _vm._v("”), unless Participant (i) specifies lenses only (without mounting) or (ii) orders a complete pair of glasses through the Portal, including frames supplied by EVF (“"), _c('strong', [_vm._v("EVF Frames")]), _vm._v("”), if available, in which case EVF’s suppliers will fabricate and mount the lenses in such EVF Frames. If EVF Frames are available, EVF may, in its sole discretion, charge Participant a service fee for complete orders (lenses with EVF Frames). In addition, a supply of EVF Frames may be available for a service fee in order to provide sample selection for display or trial by Eligible Patients. Participant is responsible for shipping Participant Frames to EVF’s designated supplier at Participant’s own expense. Shipments of lenses and frames from EVF or its supplier to Participant will be at no cost to Participant. For clarity, EVF does not guarantee that EVF Frames will be available. If available, EVF does not guarantee that colors of EVF Frames as depicted online will be accurately displayed. EVF does not warrant that the EVF Frame product descriptions are accurate, complete, reliable, current or error-free. EVF will not be liable for typographical errors and reserves the right to refuse or cancel any order or service in the event of a typographical error. EVF, in its sole discretion, shall select suppliers of Program products and services and Participant may not designate suppliers of its choice. EVF has the right to reduce or limit the number of lenses and/or frames made available under this Contract at any time for any reason.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Warranty Disclaimer: ")]), _vm._v("Participant Frames may be lost or damaged during the fabrication of eyeglasses. Participant’s use of Participant Frames is at Participant’s own risk. EVF, its suppliers and service providers, including any laboratory used by EVF, shall not be liable for damage to the frame due to the fabrication and shipping process or for lost frames. "), _c('strong', [_vm._v(" THE PORTAL, ALL LENSES AND FRAMES, AND ALL RELATED SERVICES ")]), _c('strong', [_vm._v("ARE PROVIDED ON AN \"AS IS\" BASIS, WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND. EVF HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND WITH RESPECT TO THE PORTAL, THE LENSES AND FRAMES, AND RELATED SERVICES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT, TITLE, AND NON-INFRINGEMENT, AND WARRANTIES ARISING THROUGH COURSE OF DEALING OR USAGE OF TRADE. ")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Additional EVF Responsibilities:")]), _vm._v(" Participant agrees that EVF may, but is not obligated to, list Participant as a Program participant on the EVF website in the same manner it lists other comparable Program participants. EVF will submit to Participant any requests for additional trademarks, copy or content needed for individual events or media for the Participant’s approval prior to publication.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Participant Responsibilities: ")]), _c('em', [_vm._v("In the event that Participant fails to satisfy one or more of the below-referenced responsibilities, or any other Participant obligation set forth in the Contract, EVF may, in its sole discretion, offer to modify the terms of this Contract in lieu of other recourse.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Participant agrees to promote EVF as a charitable sponsor and to co-brand any marketing or promotional materials prepared by Participant related to Participant’s charitable services in connection with the Program, provided that Participant agrees to submit to EVF any such co-branded materials, including copy or content for individual events or media, for EVF’s written approval prior to publication or other distribution. Participant will not use the EVF name, logo or other intellectual property without the prior written approval of EVF.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Participant agrees to use the Program and any lenses, frames, and related services ordered through the Portal or ordered in connection with the Program solely for charitable vision services to Eligible Patients and to validate patient eligibility in accordance with criteria established by EVF from time to time.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Participant agrees that Participant will not charge Eligible Patients for the lens product delivered; however, Participant may charge Eligible Patients up to, but not to exceed, the actual cost of the frame paid by Participant. ")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Participant agrees to retain an electronic log containing, at a minimum, the following information: for each Eligible Patient, the date of service, number/name of patient examined, and how eligibility was validated; the number of exams provided; the number of Eligible Patients who received glasses; the number of glasses dispensed; and the number of Eligible Patients receiving glasses for the first time. The electronic log must be kept current and made available to EVF as EVF may request from time to time during the Term (as defined below) and for one year thereafter for audit purposes and other treatment and health care operation purposes further described in any applicable Business Associate Agreement. ")])])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Marks:")]), _vm._v(" Participant acknowledges EVF’s right, title, and interest in its trade names, trademark, trade dress, logos, and other indicia of origin owned or licensed by EVF (the “"), _c('strong', [_vm._v("EVF Marks")]), _vm._v("”). Participant is authorized to use the EVF Marks solely as the EVF Marks are incorporated into the Program Materials or as otherwise approved by EVF in writing in connection with the Program and shall not use the EVF Marks for any other purpose. Participant acknowledges and agrees that EVF or its licensor, as applicable, retains all ownership rights in the EVF Marks and that the benefit of use of the EVF Marks hereunder, as well as all trademark and other intellectual property rights stemming therefrom, shall inure and belong solely to EVF or its licensor, as applicable. Participant agrees to cease use of the EVF Marks immediately upon EVF’s request or termination of this Contract. Participant will not attempt to obtain a copyright or trademark in any artwork that contains or is derived from the EVF Marks without EVF’s prior written consent. Participant grants to EVF a limited, non-exclusive license to use the Participant name and logo, together with the brand names, logos, and images otherwise provided or authorized by Participant, (the “Participant Marks”) for the sole purpose of promoting the Program and acknowledging Participant’s participation in the Program; provided, however, that any other use by EVF of intellectual property rights owned by Participant requires Participant’s prior written authorization. Upon request, Participant shall provide EVF with high resolution images of Participant’s logo.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("No Endorsement:")]), _vm._v(" Participant shall in no way suggest endorsement by EVF of Participant or Participant’s products or services.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Permission to Link:")]), _vm._v(" During the Term, (i) EVF grants Participant permission to provide a link from Participant’s Web site to EVF’s Web site, which permission EVF may withdraw at any time and for any reason; and (ii) Participant grants EVF permission to provide a link from EVF’s Web site to Participant’s Web site, which permission Participant may withdraw at any time and for any reason. Neither party shall have an obligation to provide a link from its Web site to the Web site of the other party.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Representations and Warranties of EVF:")]), _vm._v(" EVF represents and warrants to Participant that it has the right, power, and authority to enter into this Contract.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Representations and Warranties of Participant:")]), _vm._v(" Participant represents and warrants to EVF that: (i) it has the right, power, and authority to enter into this Contract; (ii) it will comply with all applicable federal, state, and local laws, statutes, ordinances, and regulations (collectively, “"), _c('strong', [_vm._v("Laws")]), _vm._v("”) in connection with the Program and this Contract, including Laws related to professional licensure and the provision of vision care services; and (iii) any valid lens prescription ordered before expiration date noted on the prescription submitted by Participant have been prescribed by duly licensed professionals.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Indemnity:")]), _vm._v(" Participant agrees to indemnify and hold EVF, its suppliers, and each of their directors, officers, employees, agents, representatives, and volunteers, harmless from and against any and all costs, losses, and expenses, including reasonable attorneys’ fees, that EVF may incur by reason of any claims, actions, demands, or law suits brought by a third party arising out of, or in connection with (i) Participant’s negligence, recklessness, or intentional misconduct; (ii) Participant’s performance or failure to perform pursuant to this Contract, including breach of any provision of this Contract; or (iii) Participant’s location(s), business, products, or services, including any claims in the nature of product liability, personal injury, or professional malpractice.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Term and Termination:")]), _vm._v(" This Contract shall commence on the Effective Date and will continue until terminated in accordance herein (the “"), _c('strong', [_vm._v("Term")]), _vm._v("”). Unless otherwise mutually agreed by the parties, the Contract shall automatically terminate upon the termination of any applicable Business Associate Agreement. Either party may terminate this Contract: (i) upon any material breach of the Contract by the other party, if such breach is not remedied to the reasonable satisfaction of the non-breaching party within fifteen (15) days after the non-breaching party provides written notice of the breach to the other party; (ii) immediately upon written notice to the other party whenever the notifying party in its reasonable discretion determines that the continuation of the Contract will damage its reputation or good will; or (iii) upon fifteen (15) days written notice for convenience. In addition, EVF may terminate the Contract (i) immediately upon written notice to Participant in the event EVF discontinues the Program, or (ii) if EVF revises the Contract or any portion thereof (including provisions of the Terms and Conditions and/or, if applicable, the Business Associate Agreement) and Participant does not agree to the revised Contract within the time allowed by EVF. Upon termination of this Contract, Participant shall immediately (A) cease to use the Program Materials and the EVF Marks, (B) discontinue any new orders (EVF will honor any orders for lenses or the fabrication of lenses received prior to the effective date of termination), (C) discontinue references in any manner to its relationship with EVF, and (D) retain the electronic audit log referenced in Section 7 above for one year following termination of the Contract. For purposes of this Section 14, Participant’s breach of any of Participant’s obligations set forth in Section 7 above shall be deemed a material breach of this Contract. The provisions of this Section shall not preclude the parties from seeking any other remedies available to them under this Contract and applicable law. The Sections regarding Warranty Disclaimer, Indemnity, Governing Law and Venue, Limitation of Liability, Notices, and Miscellaneous shall survive termination of this Contract. In addition, any provision which would, by its nature, survive the termination of this Contract, shall do so.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Disputes; Governing Law and Venue:")]), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Any disputes between the parties related to the Contract, the Program, or the Portal shall be governed by the “Disputes with EVF” section of the ")])]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Terms of Use")])]), _c('strong', [_c('u', [_vm._v(", including, to the extent applicable, the Agreement to Arbitrate set forth in the “Disputes with EVF” section of the ")])]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Terms of Use")])]), _c('u', [_vm._v(".")]), _vm._v(" If and to the extent the "), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" are determined not to apply to a dispute between the parties, (i) this Contract shall be governed by and construed in accordance with the laws of the state of Texas, without regard to principles of conflict or choice of law; and (ii) any dispute arising out of or in connection with this Contract shall be filed and heard in the state or federal courts located in Dallas, Texas, and the parties consent to the exclusive jurisdiction of such courts.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Relationship of Parties:")]), _vm._v(" The parties to this Contract are not joint venturers, partners, agents, or representatives of each other, are not authorized to act on each other’s behalf, and have no legal relationship other than as independent contracting parties to this Contract.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Assignment:")]), _vm._v(" No party may assign this Contract, or any rights or obligations hereunder, without the prior written consent of the other party. Notwithstanding the foregoing, in the event that any license agreement between EVF and its licensor is terminated, EVF may, without Participant’s consent, assign its rights and obligations with respect to any sublicense granted hereunder to such licensor. Any attempt to assign this Contract in contravention of this Section shall be void and of no force and effect. This Contract is binding upon and will inure to the benefit of the respective parties hereto and their successors and permitted assigns.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Limitation of Liability:")]), _vm._v(" EXCEPT WITH RESPECT TO INDEMNIFICATION OBLIGATIONS SET FORTH HEREIN, NEITHER PARTY SHALL BE LIABLE TO THE OTHER FOR ANY (I) DIRECT DAMAGES, IN THE AGGREGATE, IN EXCESS OF $100.00, OR (II) INDIRECT, SPECIAL, CONSEQUENTIAL, INCIDENTAL, OR PUNITIVE DAMAGE WITH RESPECT TO ANY CLAIM ARISING OUT OF THIS CONTRACT (INCLUDING ITS PERFORMANCE OR BREACH OF THESE TERMS AND CONDITIONS) FOR ANY REASON.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Notices:")]), _vm._v(" All notices required or permitted to be given hereunder shall be in writing and shall be sent by (i) personal or courier delivery, (ii) electronic mail, or (iii) USPS certified mail, postage prepaid, return receipt requested. All notices to Participant shall be forwarded to Participant and/or the Primary Contact designated by Participant at the principal mailing address and/or email address provided for Participant when completing the Registration Form, or to such other person or address as Participant may designate in writing to EVF for this purpose. All notices to EVF shall be forwarded to Essilor Vision Foundation, 13515 N. Stemmons Fwy., Dallas, TX 75234, Attn: Partnerships (if notice is sent by mail or personal or courier delivery) and/or to "), _c('a', {
    attrs: {
      "href": "mailto:info@evfusa.org",
      "target": "_blank"
    }
  }, [_vm._v("support@onesight.org")]), _vm._v(" (if notice is sent by electronic mail), or to such other person or address as EVF may designate in writing to Participant for this purpose. In order for notice to EVF to be effective, a copy of such notice must be sent to Essilor Vision Foundation, Attn: General Counsel, at the EVF address designated above (if notice is sent by mail or personal or courier delivery). Notices delivered hereunder shall be effective when received or refused. Notwithstanding the foregoing, (i) written approvals and authorizations required hereunder may be provided facsimile, email, or other written means; and (ii) EVF may notify Participant, including notice of any change to the Program or the terms of the Contract, by posting a notice on the Portal.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Entire Agreement:")]), _vm._v(" Except as expressly and specifically provided in this Contract, this Contract supersedes any prior understandings or oral agreements between the parties regarding the subject matter hereof and constitutes the entire understanding and agreement of such parties with respect to the subject matter hereof.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Force Majeure:")]), _vm._v(" The obligations of any party under this Contract will be suspended for the duration of any force majeure applicable to that party. The term \"force majeure\" means any cause not reasonably within the control of the party claiming suspension, including an act of God, industrial disturbance, supplier disruptions, war, riot, weather-related disaster, earthquake and governmental action. The party claiming suspension under this Section will take reasonable steps to resume performance as soon as possible without incurring unreasonably excessive costs.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Miscellaneous:")]), _vm._v(" The failure of a party at any time to require performance of any provision of or resort to any remedy provided under this Contract shall in no way affect the right of that party to require performance or resort to a remedy at any time thereafter, nor shall the waiver by a party of a breach be deemed to be a waiver of any subsequent breach. A waiver shall not be effective unless it is in writing and signed by the party against whom the waiver is being enforced. If any term or provision of this Contract is determined to be invalid, illegal, or incapable of being enforced by any law, regulation, or public policy, then such provision will be interpreted, construed, or reformed to the extent reasonably required to render the same valid, enforceable and consistent with the original intent underlying such provision, and all other terms and provisions of this Contract shall nevertheless remain in full force and effect. Notwithstanding the foregoing, if any such modification causes a material change in the obligations or rights of any party, upon written notice from one party to the other of the adverse effect thereof upon such notifying party, and then if the parties are not able to mutually agree as to an amendment hereto, any party may terminate this Contract upon thirty (30) days written notice to the other parties.This Contract shall not be altered, amended, or modified in any way except by (i) a written instrument dated subsequent to the date of this Contract and signed on behalf of the parties by their respective duly authorized representatives; or (ii) a subsequent “clickwrap” agreement made available by EVF on the Portal to which Participant has indicated Participant’s assent by clicking an “I Agree” or “Submit” or similar button. Section captions and headings are for are for reference purposes only and shall not control or affect the construction or interpretation of this Contract in any respect. In all cases, the use of \"includes/ing\" shall mean \"includes/ing without limitation\".")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8 offset-lg-2 bottom-margin-10"
  }, [_c('span', {
    staticClass: "contract-label"
  }, [_vm._v("Business Associate Agreement")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "contract-description"
  }, [_vm._v("Please review and accept the terms of the updated Business Associate Agreement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8 offset-lg-2",
    staticStyle: {
      "border": "1px solid black",
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "terms-style"
  }, [_c('p', [_c('small', [_vm._v(" This HIPAA Business Associate Agreement (\"Agreement\") supplements and is made a part of the Essilor Vision Foundation (“EVF”) Changing Life through Lenses® Agreement (\"Contract\") by and between the legal entity or individual identified as the participant on the Essilor Vision Foundation Changing Life through Lenses® registration form (referred to herein as “Covered Entity\") and Essilor Vision Foundation (referred to herein as \"Business Associate\"), and is effective as of the Effective Date of the Contract between the parties, as defined in the Essilor Vision Foundation Changing Life through Lenses® Terms and Conditions.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("RECITALS")])]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("WHEREAS")]), _vm._v(", Business Associate provides certain services to health care providers; and")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("WHEREAS")]), _vm._v(", Business Associate has been retained by Covered Entity to perform functions or activities that will require the Business Associate to have access to or create, receive, maintain or transmit Protected Health Information in relation to the Covered Entity; and")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("WHEREAS")]), _vm._v(", Pursuant to the Health Insurance Portability and Accountability Act of 1996 (\"HIPAA\"), Covered Entity and Business Associate desire to execute this Agreement to comply with the terms of the Privacy Rule, the Security Rule and the HITECH Act under the American Recovery and Reinvestment Act of 2009 (as defined below); and")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("WHEREAS")]), _vm._v(", this Agreement has been drafted to incorporate the provisions required by the final regulations issued by the Department of Health and Human Services on January 25, 2013 implementing the HITECH Act; and")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("WHEREAS")]), _vm._v(", Business Associate acts in the capacity of an independent contractor in relation to the services provided to Covered Entity under the Contract.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("NOW, THEREFORE")]), _vm._v(", in consideration of the mutual covenants, terms and conditions herein contained, the parties hereto agree as follows:")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1) DEFINITIONS")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Terms used but not otherwise defined in the Agreement shall have the same meaning as those terms in the Privacy Rule and Security Rule.")])]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("\"Breach\"")]), _vm._v(" shall have the meaning given to it by 45 CFR Section 164.402.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Breach Notification Rule\" ")]), _vm._v("shall mean the Standards for Breach Notification for Unsecured Protected Health Information under HIPAA that is codified at 45 CFR Parts 160 and 164, subparts A and D.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Deidentified Data\"")]), _vm._v(" shall have the same meaning as the term \"deidentified data\" in 45 CFR Section 164.514.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Designated Record Set\"")]), _vm._v(" shall mean a group of records maintained by or for a Covered Entity that is: (i) the medical records and billing records about Individuals maintained by or for a covered health care provider; (ii) the enrollment, payment, claims adjudication, and case or medical management record systems maintained by or for a health plan; or (iii) used, in whole or in part, by or for the Covered Entity to make decisions about Individuals. For purposes of this definition, the term \"record\" means any item, collection, or grouping of information that includes Protected Health Information and is maintained, collected, used, or disseminated by or for a Covered Entity.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Health Care Operations\"")]), _vm._v(" shall have the same meaning as the term \"Health Care Operations\" in 45 CFR Section 164.501.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"HITECH Act\"")]), _vm._v(" shall mean the provisions of Title XIII, Subtitle D of the American Recovery and Reinvestment Act of 2009. Any reference to a section of the HITECH Act shall also include any HITECH Regulations related thereto.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"HITECH Regulations\"")]), _vm._v(" shall mean any guidance issued relating to the HITECH Act by the Department of Health and Human Services, including the Breach Notification Rule.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Individual\"")]), _vm._v(" shall have the same meaning as the term \"individual\" in 45 CFR Section 160.103 and shall include a person who qualifies as a personal representative in accordance with 45 CFR Section 164.502(g).")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Privacy Rule\"")]), _vm._v(" shall mean the Standards for Privacy of Individually Identifiable Health Information that is codified at 45 CFR Parts 160 and 164, subparts A and E.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Protected Health Information\"")]), _vm._v(" or "), _c('strong', [_vm._v("\"PHI\"")]), _vm._v(" shall mean any information, whether oral or recorded in any form or medium: (i) that relates to the past, present or future physical or mental condition of an individual; the provision of health care to an individual; or the past, present or future payment for the provision of health care to an individual; and (ii) that identifies the individual or with respect to which there is a reasonable basis to believe the information can be used to identify the individual, and shall have the meaning given to such term under 45 CFR Section 160.103. Protected Health Information shall be limited to the information created or received by Business Associate from or on behalf of Covered Entity.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Required By Law\"")]), _vm._v(" shall have the same meaning as the term \"required by law\" in 45 CFR Section 164.103.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Secretary\"")]), _vm._v(" shall mean the Secretary of the Department of Health and Human Services or his or her designee.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Security Rule\"")]), _vm._v(" shall mean the Security Standards for the Protection of Electronic Protected Health Information under HIPAA that is codified at 45 CFR Parts 160 and 164, subparts A and C.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("\"Unsecured PHI\"")]), _vm._v(" shall mean Protected Health Information that is not secured through the use of a technology or methodology that renders such Protected Health Information unusable, unreadable or indecipherable to unauthorized individuals, as specified in guidance issued pursuant to Section 13402(h) of the HITECH Act, including the Breach Notification Rule.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2) OBLIGATIONS AND ACTIVITIES OF BUSINESS ASSOCIATE")])]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Permitted Uses and Disclosures")]), _vm._v(". Business Associate agrees to not use or disclose Protected Health Information other than as permitted or required by this Agreement or as Required By Law. Business Associate shall not use or disclose Protected Health Information in any manner that violates the Privacy Rule or the HITECH Act. To the extent required by the Privacy Rule, Business Associate shall only request, use and/or disclose the minimum amount of Protected Health Information necessary to accomplish the purpose of the request, use and/or disclosure. The determination of what constitutes the minimum necessary amount of Protected Health Information shall be determined in accordance with the provisions of the Privacy Rule.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Safeguards")]), _vm._v(". Business Associate agrees to use administrative, physical and technical safeguards applicable to the services provided under the Contract that reasonably and appropriately protect the confidentiality, integrity and availability of Protected Health Information, in electronic or any other form, that it creates, receives, maintains or transmits under this Agreement, in accordance with the Privacy Rule and the Security Rule to prevent the use or disclosure of Protected Health Information other than as provided for by this Agreement. Business Associate shall fully comply with the Security Rule with regard to electronic Protected Health Information.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Reporting of Improper Use or Disclosure")]), _vm._v(". Business Associate agrees to report to the Covered Entity any use or disclosure of the Protected Health Information not provided for by this Agreement of which it becomes aware. Business Associate shall also report any security incident of which it becomes aware to Covered Entity. ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Mitigation.")]), _vm._v(" Business Associate agrees to mitigate, to the extent practicable, any harmful effect that is known to Business Associate of a use or disclosure of Protected Health Information by Business Associate in violation of the requirements of this Agreement. ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Agents and Subcontractors.")]), _vm._v(" Business Associate agrees to require that any agents or subcontractors that create, receive, maintain or transmit Protected Health Information on behalf of Business Associate in relation to Covered Entity agree in writing (in the form of a business associate contract) to substantially similar restrictions, conditions and requirements that apply through this Agreement to Business Associate with respect to such information, including the implementation of reasonable and appropriate measures for safeguarding Protected Health Information. ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Access to Individuals.")]), _vm._v(" To the extent applicable, Business Associate agrees to provide access to Protected Health Information in a Designated Record Set, to Covered Entity or, as directed by Covered Entity, to an Individual in order to meet the requirements under 45 CFR Section 164.524. Further, if an Individual requests a copy of Protected Health Information in a specific electronic format, Business Associate shall comply with such request, if readily producible, in accordance with the requirements of 45 CFR Section 164.524.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Amendments to Protected Health Information.")]), _vm._v(" To the extent applicable, Business Associate agrees to make any reasonable amendment(s) to Protected Health Information in a Designated Record Set that the Covered Entity directs or agrees to pursuant to 45 CFR Section 164.526 at the request of Covered Entity or an Individual.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Access to Internal Practices, Books and Records.")]), _vm._v(" Business Associate agrees to make internal practices, books and records including policies and procedures and Protected Health Information, relating to the use and disclosure of Protected Health Information received from, or created or received by Business Associate on behalf of, Covered Entity available to the Secretary for purposes of the Secretary determining Covered Entity's compliance with HIPAA.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Disclosure Documentation.")]), _vm._v(" Business Associate agrees to document such disclosures of Protected Health Information and information related to such disclosures as would be required for Covered Entity to respond to a request by an Individual for an accounting of disclosures of Protected Health Information in accordance with 45 CFR Section 164.528. Business Associate agrees to provide to Covered Entity or an Individual information collected in accordance with this subsection to permit Covered Entity to respond to a request by an Individual for an accounting of disclosures of Protected Health Information in accordance with 45 CFR Section 164.528.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Obligation Upon Breach of Unsecured PHI. ")]), _vm._v("Upon Business Associate's discovery of a Breach of Unsecured PHI, Business Associate shall provide notice of the Breach to Covered Entity in accordance with the requirements of 45 CFR 164.410. The content of such written notice of the Breach shall comply with the requirements of 45 CFR Section 164.410(c). Business Associate shall cooperate with and coordinate an appropriate course of action with Covered Entity.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Delegated Obligations")]), _vm._v(". To the extent Business Associate is to carry out one or more of Covered Entity’s obligations under Subpart E of 45 CFR Part 164, Business Associate agrees to comply with the requirements of Subpart E that apply to Covered Entity in the performance of such obligations.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("3) PERMITTED USES BY BUSINESS ASSOCIATE")])]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Service Agreement.")]), _vm._v(" Except as otherwise limited in this Agreement, Business Associate may use or disclose Protected Health Information to perform functions, activities, or services for, or on behalf of, Covered Entity as specified in the Contract, provided that such use or disclosure would not violate the Privacy Rule if done by Covered Entity.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Other Permitted Usage.")]), _vm._v(" Except as otherwise limited in this Agreement, Business Associate may use Protected Health Information for the proper management and administration of the Business Associate or to carry out the legal responsibilities of the Business Associate. Business Associate may disclose Protected Health Information for the proper management and administration of the Business Associate if the disclosure is Required by Law or Business Associate obtains reasonable assurances from the person to whom the information is disclosed that it will be held confidentially and used or further disclosed only as Required by Law or for the purposes for which it was disclosed to the person and the person notifies Business Associate of any instances of which it is aware in which the confidentiality of the information has been breached. In addition, Business Associate may use Protected Health Information to provide Data Aggregation services as permitted by 45 CFR Section 164.504(e)(2)(i)(B) and/or to create Limited Data Sets as permitted by 45 CFR 164.514(e).\n                "), _c('br'), _c('br'), _vm._v("The Business Associate’s activities will require access to Protected Health Information to process prescriptions placed by the Covered Entity pursuant to the Contract. Also, Business Associate may also facilitate certain treatment activities (as defined at 45 CFR 164.501) and perform certain health care operation functions (as defined at 45 CFR 164.501), including conducting certain audit functions, on behalf of the Covered Entity."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Further, Covered Entity expressly agrees to provide Business Associate with Protected Health Information, as requested by Business Associate from time to time, so that Business Associate may create a limited data set with such information that complies with the requirements of 45 CFR 164.514(e). After creating the limited data set, Business Associate will conduct research on the limited data set, as allowed under 45 CFR 164.514(e)(3). The Business Associate will not use or further disclose the limited data set information in a manner that would violate the requirements of the Privacy Rule. In relation to the limited data set information maintained by Business Associate, Business Associate will use appropriate safeguards to prevent use or disclosure of the information other than as provided for by this Agreement; report to the Covered Entity any use or disclosure of the information not provided for by this Agreement of which it becomes aware; ensure that any agents to whom it provides the limited data set agree to the same restrictions and conditions that apply to the limited data set recipient with respect to such information; and not identify the information or contact the individuals, in accordance with the requirements of 45 CFR 164.514(e)(4)(ii)(C).")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4) OBLIGATIONS OF COVERED ENTITY")])]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Change in Privacy Practices.")]), _vm._v(" Covered Entity shall notify Business Associate of any limitation(s) in its notice of privacy practices of Covered Entity in accordance with 45 CFR Section 164.520, to the extent that such limitation may affect Business Associate's use or disclosure of Protected Health Information. Additionally, Covered Entity shall notify Business Associate of any limitation(s) or restriction(s) in its security practices to the extent that such limitation may affect Business Associate's use or disclosure of Protected Health Information.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("No Restrictions on the Use or Disclosure of Protected Health Information.")]), _vm._v(" Covered Entity shall not agree to an Individual’s request to restrict uses or discloses of Protected Health Information, to the extent that such changes may affect Business Associate's ability to perform the functions described in the Contract, including this Agreement. Because of the charitable nature of the services performed in relation to the Covered Entity’s patients whose PHI is subject to this Agreement, 45 CFR 164.522(a)(1)(vi) will not apply to the PHI of such patients since such patients are not paying in full for services performed. Therefore, the Covered Entity is allowed under 45 CFR 164.522(a)(1)(ii) to not agree, and shall not agree, to any restriction requested by an Individual whose PHI will be shared with Business Associate as part of the services provided under the Contract. ")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("5) PERMISSIBLE REQUESTS BY COVERED ENTITY")])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Covered Entity shall not request Business Associate to use or disclose Protected Health Information in any manner that would not be permissible under the Privacy Rule if done by Covered Entity.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("6) TERM AND TERMINATION")])]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Term.")]), _vm._v(" This Agreement will begin on the Effective Date, and will continue until terminated in accordance herein.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Termination. ")]), _vm._v("In addition to the termination rights set forth in the Terms and Conditions, a party may terminate the Agreement as follows:")]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Termination for Cause.")]), _vm._v(" Upon Covered Entity's knowledge of a material breach of this Agreement by Business Associate, Covered Entity shall provide not less than 20 days written notice of its intent to terminate the Agreement if Business Associate does not cure such material breach no later than the end of the written notice period. If Business Associate does not cure the breach within such time, then Covered Entity may, in its sole discretion, immediately terminate this Agreement.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Termination without Cause and Termination of the Contract. ")]), _vm._v("Either party may terminate this Agreement effective upon 15 days advance written notice to the other party given with or without any reason if Business Associate no longer performs services for Covered Entity requiring the use or disclosure of Protected Health Information. This Agreement will immediately terminate if the Contract terminates. The effective date of such termination will be the same as the effective date that the Contract terminates.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Effect of Termination.")]), _vm._v(" Unless otherwise mutually agreed by the parties, the termination of this Agreement for any reason shall automatically terminate the Contract. The parties mutually agree in advance that returning or destroying Protected Health Information upon termination of this Agreement is infeasible. Therefore, Business Associate shall extend the protections of this Agreement to such Protected Health Information and limit further uses and disclosures of such Protected Health Information to those purposes that make the return or destruction infeasible, for so long as Business Associate maintains such Protected Health Information.")])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("7) MISCELLANEOUS")])]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Regulatory References.")]), _vm._v(" Any reference in this Agreement to a section in the Privacy Rule, Security Rule, Breach Notification Rule or HITECH Act means the section as in effect or as amended.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Amendment.")]), _vm._v(" The Parties agree to take such action as is necessary to amend this Agreement from time to time as is necessary for Covered Entity to comply with the requirements of the Privacy Rule, Security Rule, the Breach Notification Rule or any other requirements of the HITECH Act.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Survival.")]), _vm._v(" The respective rights and obligations of Business Associate under Section 6.2.3 shall survive the termination of this Agreement.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Interpretation; Conflict.")]), _vm._v(" Any ambiguity in this Agreement shall be resolved to permit both parties to comply with the Privacy Rule, Security Rule, the Breach Notification Rule or any other requirements of the HITECH Act. ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("No Third-Party Beneficiaries.")]), _vm._v(" Except as set forth in this Agreement or as expressly provided for under HIPAA, this Agreement is entered into by and among the parties hereto solely for their benefit. The parties have not created or established any third-party beneficiary status or rights in any person or entity not a party hereto including any individual, provider, subcontractor, or other third-party, and no such third-party will have any right to enforce any right or enjoy any benefit created or established under this Agreement.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Force Majeure.")]), _vm._v(" The obligations of any party under this Agreement will be suspended for the duration of any force majeure applicable to that party. The term \"force majeure\" means any cause not reasonably within the control of the party claiming suspension, including an act of God, industrial disturbance, supplier disruptions, war, riot, weather-related disaster, earthquake and governmental action. The party claiming suspension under this Section will take reasonable steps to resume performance as soon as possible without incurring unreasonably excessive costs.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Entire Agreement.")]), _vm._v(" This Agreement including any riders, attachments or amendments hereto, constitutes the entire agreement among the parties with respect to the Privacy Rule, the Security Rule, the Breach Notification Rule and any other requirements of the HITECH Act. This Agreement supersedes any prior agreement or understandings pertaining to HIPAA obligations between the parties, whether oral or written.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Disputes; Choice of Law.")]), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Any disputes between the parties related to this Agreement shall be governed by the “Disputes with EVF” section of the ")])]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Terms of Use")])]), _c('strong', [_c('u', [_vm._v(", including, to the extent applicable, the Agreement to Arbitrate set forth in the “Disputes with EVF” section of the ")])]), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Terms of Use")])]), _c('u', [_vm._v(".")]), _vm._v(" If and to the extent the "), _c('a', {
    attrs: {
      "href": "http://www.evfusa.org/terms-and-conditions",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Terms of Use")])]), _vm._v(" are determined not to apply to a dispute between the parties, (i) this Agreement shall be governed by and construed in accordance with the laws of the state of Texas, without regard to principles of conflict or choice of law; and (ii) any dispute arising out of or in connection with this Agreement shall be filed and heard in the state or federal courts located in Dallas, Texas, and the parties consent to the exclusive jurisdiction of such courts.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Assignment and Delegation.")]), _vm._v(" No party may assign this Agreement, or any rights or obligations hereunder, without the prior written consent of the other party. Any attempt to assign this Agreement in contravention of this Section shall be void and of no force and effect. This Agreement is binding upon and will inure to the benefit of the respective parties hereto and their successors and permitted assigns.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Notices.")]), _vm._v(" Any notice required pursuant to this Agreement shall comply with the requirements for notices as set forth in the Essilor Vision Foundation Changing Life through Lenses® Terms and Conditions that form part of the Contract.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Miscellaneous.")]), _vm._v(" The failure of a party at any time to require performance of any provision of or resort to any remedy provided under this Agreement shall in no way affect the right of that party to require performance or resort to a remedy at any time thereafter, nor shall the waiver by a party of a breach be deemed to be a waiver of any subsequent breach. A waiver shall not be effective unless it is in writing and signed by the party against whom the waiver is being enforced. If any term or provision of this Agreement is determined to be invalid, illegal, or incapable of being enforced by any law, regulation, or public policy, then such provision will be interpreted, construed or reformed to the extent reasonably required to render the same valid, enforceable and consistent with the original intent underlying such provision, and all other terms and provisions of this Agreement shall nevertheless remain in full force and effect. Notwithstanding the foregoing, if any such modification causes a material change in the obligations or rights of any party, upon written notice from one party to the other of the adverse effect thereof upon such notifying party, and then if the parties are not able to mutually agree as to an amendment hereto, any party may terminate this Agreement upon thirty (30) days written notice to the other parties.This Agreement shall not be altered, amended or modified in any way except by (i) a written instrument dated subsequent to the date of this Agreement and signed on behalf of the parties by their respective duly authorized representatives; or (ii) a subsequent “clickwrap” agreement made available by EVF on the Essilor Vision Foundation Changing Life through Lenses® online platform to which Covered Entity has indicated Covered Entity’s assent by clicking an “I Agree” or “Submit” or similar button. Section captions and headings are for are for reference purposes only and shall not control or affect the construction or interpretation of this Agreement in any respect. In all cases, the use of \"includes/ing\" shall mean \"includes/ing without limitation\".")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78c8cf99", module.exports)
  }
}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row div-spacing-top"
  }, [(_vm.isLoadingAddress) ? _c('loading-component') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.Order.ShippingUseDifferent && !_vm.$route.params.code) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.Account.accountType != '1') ? _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))]) : _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.streetAddress) + " " + _vm._s(_vm.Account.primaryContact.officeLocation.suite))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.city) + ", " + _vm._s(_vm.Account.primaryContact.officeLocation.state) + " " + _vm._s(_vm.Account.primaryContact.officeLocation.zip))]), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.Order.ShippingUseDifferent && _vm.$route.params.code) ? _c('div', [_c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingFullName))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingAddressLineOne))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingAddressLineTwo))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-order"
  }, [_vm._v(_vm._s(_vm.Order.ShippingCity) + ", " + _vm._s(_vm.Order.ShippingState) + " " + _vm._s(_vm.Order.ShippingPostcode))]), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingUseDifferent),
      expression: "Order.ShippingUseDifferent"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.ShippingUseDifferent) ? _vm._i(_vm.Order.ShippingUseDifferent, null) > -1 : (_vm.Order.ShippingUseDifferent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.ShippingUseDifferent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "ShippingUseDifferent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "ShippingUseDifferent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "ShippingUseDifferent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-check-label g-font-size-18"
  }, [_vm._v("Use a different shipping address for this order")])])]), _vm._v(" "), (_vm.Order.ShippingUseDifferent && _vm.MasterAccountType != 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Location Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingFullName),
      expression: "Order.ShippingFullName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingFullName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingFullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingFullName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.ValidationResult.OrderShippingFullName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingFullName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Street Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingAddressLineOne),
      expression: "Order.ShippingAddressLineOne"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingAddressLineOne
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingAddressLineOne)
    },
    on: {
      "change": _vm.addressChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingAddressLineOne", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderShippingAddressLineOne) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingAddressLineOne))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suite")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingSuite),
      expression: "Order.ShippingSuite"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingSuite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingSuite", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingCity),
      expression: "Order.ShippingCity"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingCity
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingCity", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderShippingCity) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingCity))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingState),
      expression: "Order.ShippingState"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingState
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "ShippingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderShippingState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingState))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [(_vm.Order.ShippingUseDifferent) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Zip*")]), _vm._v(" "), (_vm.isValidAddress) ? _c('span', [_c('i', {
    staticClass: "fa fa-check-circle check_icon"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ShippingPostCode),
      expression: "Order.ShippingPostCode"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderShippingPostCode
    },
    attrs: {
      "maxlength": "5",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ShippingPostCode)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "blur": function($event) {
        return _vm.ValidateAddress()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ShippingPostCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderShippingPostCode) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderShippingPostCode))]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Assigned Lab")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "deselectLabel": " ",
      "label": "name",
      "options": _vm.labList,
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    model: {
      value: (_vm.Order.OrderLab),
      callback: function($$v) {
        _vm.$set(_vm.Order, "OrderLab", $$v)
      },
      expression: "Order.OrderLab"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Special Instructions For Lab")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.SpecialLabInstructions),
      expression: "Order.SpecialLabInstructions"
    }],
    staticClass: "form-control",
    attrs: {
      "row": "3"
    },
    domProps: {
      "value": (_vm.Order.SpecialLabInstructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "SpecialLabInstructions", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Manifest Distance Acuity")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("RE/OD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReManifestAcuity),
      expression: "Order.ReManifestAcuity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "20/"
    },
    domProps: {
      "value": (_vm.Order.ReManifestAcuity)
    },
    on: {
      "keyup": function($event) {
        return _vm.acuityPrefixR()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReManifestAcuity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LE/OS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.LeManifestAcuity),
      expression: "Order.LeManifestAcuity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "20/"
    },
    domProps: {
      "value": (_vm.Order.LeManifestAcuity)
    },
    on: {
      "keyup": function($event) {
        return _vm.acuityPrefixL()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "LeManifestAcuity", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), ((!_vm.Order.IsExamOnly && _vm.Order.ShowExtraStudentFields == true)) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group center order-div"
  }, [_c('label', [_vm._v("Wearing Instructions")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Patient should wear glasses:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatWearingInstructions),
      expression: "Order.PatWearingInstructions"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "PatWearingInstructions", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FullTime"
    }
  }, [_vm._v("Full-time")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Distance"
    }
  }, [_vm._v("For distance only")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Near"
    }
  }, [_vm._v("For near vision only")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Patient/Order Notes (not sent to lab)")]), _vm._v(" "), _c('p', [_vm._v("This information is for your internal use only and will not be shared with the laboratory")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.DispenserNotes),
      expression: "Order.DispenserNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "row": "3"
    },
    domProps: {
      "value": (_vm.Order.DispenserNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "DispenserNotes", $event.target.value)
      }
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Additional Information\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Shipping Address:\n                    "), _c('span', {
    attrs: {
      "data-balloon": "This is the default shipping address for this account. To edit this address, go to the “My Account” page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79478096", module.exports)
  }
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "registration-success g-py-170"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "success-div"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.messageHeader) + "!")]), _vm._v(" "), (_vm.isSuccess) ? _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n                            You have successfully activated your account "), _c('br'), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("click here")]), _vm._v(" to go to the log in page.\n                        ")], 1) : _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n                            Invalid activation code. Please try again.\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "success-div"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-795b65f8", module.exports)
  }
}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OrderPage",
    attrs: {
      "id": "OrderPage"
    }
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    directives: [{
      name: "prevent-back",
      rawName: "v-prevent-back.vue-router-disable",
      modifiers: {
        "vue-router-disable": true
      }
    }],
    staticClass: "g-bg-gray"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.isLoadFinish && _vm.isVoucherLoadFinish && _vm.isAccountFinishLoading) ? _c('div', {
    staticClass: "row"
  }, [(_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2 g-pt-70 g-pb-100",
    staticStyle: {
      "background-color": "white",
      "padding": "50px",
      "border-radius": "10px",
      "box-shadow": "0 4px 8px rgba(0, 0, 0, 0.1)"
    }
  }, [_c('br'), _vm._v(" "), _c('p', {
    staticClass: "page-title"
  }, [_vm._v("Order Page")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSubmitFail),
      expression: "isSubmitFail"
    }],
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.isSubmitFail = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Please complete the form to proceed with the submission")])]), _vm._v(" "), (_vm.Order.ErrorMessage) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.Order.ErrorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.isThreshHoldShown) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.isThreshHoldShown = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("You have " + _vm._s(_vm.Capping.orderCap - _vm.Capping.orderCount) + " orders remaining on your account. After the number is reached you will no longer be able to place orders. For more information,\n                                          "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("contact us")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (_vm.isorderCapMet) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDivOrder",
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Attention!")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("You have reached your order limit and are no longer able to submit any orders. For more information,\n                                          "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("contact us")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), ((_vm.MasterAccountType == 'master') && _vm.$route.params.code) ? _c('div', {
    staticClass: "row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [(true) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [(true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Participant Name:")]), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName))]) : _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Participant Login Email:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("EVF ID:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confirmation-description"
  }, [_vm._v(_vm._s(_vm.Account.evfAccountNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "order-confirmation-label"
  }, [_vm._v("Salesforce ID:")]), _vm._v(" "), _c('a', {
    staticClass: "order-confirmation-description",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.Account.salesforceId))])])])]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.MasterAccountType == 'master' && !_vm.$route.params.code) ? _c('participant-account-information', {
    attrs: {
      "Order": _vm.Order
    },
    on: {
      "search": _vm.AccountValue
    }
  }) : _vm._e(), _vm._v(" "), _c('general-information', {
    attrs: {
      "Order": _vm.Order,
      "Account": _vm.Account,
      "Voucher": _vm.Voucher,
      "State": _vm.State,
      "ReferralOrgSelect": _vm.ReferralOrgSelect,
      "VoucherList": _vm.VoucherList,
      "Suffix": _vm.Suffix,
      "ValidationResult": _vm.ValidationResult
    }
  }), _vm._v(" "), (!_vm.MasterAccountType && _vm.$route.params.EditOrReuse != 1) ? _c('patient-information', {
    ref: "patient",
    attrs: {
      "Order": _vm.Order,
      "Ethnicity": _vm.Ethnicity,
      "ValidationResult": _vm.ValidationResult
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('order-information', {
    attrs: {
      "Order": _vm.Order,
      "ValidationResult": _vm.ValidationResult,
      "MasterAccountType": _vm.MasterAccountType,
      "PrismDirection": _vm.PrismDirection
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('frame-information', {
    attrs: {
      "Order": _vm.Order,
      "ValidationResult": _vm.ValidationResult,
      "Capping": _vm.Capping,
      "MasterAccountType": _vm.MasterAccountType,
      "isFrameLensServiceFee": _vm.Account.isFrameLensServiceFee,
      "Account": _vm.Account
    },
    on: {
      "help": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('additional-information', {
    attrs: {
      "Order": _vm.Order,
      "Account": _vm.Account,
      "State": _vm.State,
      "MasterAccountType": _vm.MasterAccountType,
      "ValidationResult": _vm.ValidationResult
    }
  }), _vm._v(" "), (!_vm.isorderCapMet && _vm.MasterAccountType != 'master' && _vm.Account.isStandardOrderServiceFee && _vm.Order.JobType != 'LSF') ? _c('p', {
    staticClass: "order-payment",
    staticStyle: {
      "background-color": "#d5e4ef7a"
    }
  }, [_vm._v("Please note: After you submit, you will be charged a service fee for this order.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row  text-center"
  }, [(!_vm.Order.IsExamOnly) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 g-mt-15"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'false', 'true')
      }
    }
  }, [_vm._v("Save as Pending Order")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 g-mt-15",
    class: {
      'col-lg-6 col-md-6': !_vm.Order.IsExamOnly, 'col-md-12 col-lg-12': _vm.Order.IsExamOnly
    }
  }, [(!_vm.Order.IsExamOnly && !_vm.Order.DoesNotMeetRequirements && _vm.AccountStatus != 'OrderHoldUnderReview' && !_vm.isorderCapMet && ((_vm.Capping.frameLensCount < _vm.Capping.frameLensCap && _vm.Order.JobType == 'LSF') || !_vm.Capping.isFrameLensCapOn)) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.Order.IsExamOnly) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitExamOnlyOrder()
      }
    }
  }, [_vm._v("Save")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.isorderCapMet) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.isorderCapMet && _vm.MasterAccountType == 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.Order.JobType == 'LSF' && (_vm.Capping.frameLensCount >= _vm.Capping.frameLensCap) && _vm.MasterAccountType != 'master' && _vm.Capping.isFrameLensCapOn) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.AccountStatus != 'OrderHoldUnderReview' && _vm.Order.JobType == 'LSF' && (_vm.Capping.frameLensCount < _vm.Capping.frameLensCap) && _vm.MasterAccountType == 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : ((!_vm.Order.DoesNotMeetRequirements && _vm.AccountStatus == 'OrderHoldUnderReview') || (_vm.Order.DoesNotMeetRequirements && _vm.AccountStatus == 'OrderHoldUnderReview')) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button",
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType == 'master' && _vm.$route.params.code && this.$route.params.EditOrReuse != 1) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'true')
      }
    }
  }, [_vm._v("Approve Special Order")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType == 'master' && _vm.$route.params.code && this.$route.params.EditOrReuse == 1) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'true')
      }
    }
  }, [_vm._v("Submit Special Order")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType != 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit for Approval")]) : (_vm.Order.DoesNotMeetRequirements == true && _vm.MasterAccountType != 'master') ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit for Approval")]) : _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('false', 'false', 'true', 'false')
      }
    }
  }, [_vm._v("Review and Submit Order")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2 g-pt-70 g-pb-100"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.isModalReviewShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog order-modal-size"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('order-review', {
    attrs: {
      "OrderReturn": _vm.OrderReturn,
      "Account": _vm.Account,
      "Voucher": _vm.Voucher
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 center"
  }, [(!_vm.Order.DoesNotMeetRequirements) ? _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'false')
      }
    }
  }, [_vm._v("Submit Order")]) : _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.ValidateOrder('true', 'true', 'false', 'false')
      }
    }
  }, [_vm._v("Submit Order")])])])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isSaveChangesModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseSaveChangesModal('stay')
      }
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center g-pb-10"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.CloseSaveChangesModal('leave')
      }
    }
  }, [_vm._v("Leave this page")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.CloseSaveChangesModal('stay')
      }
    }
  }, [_vm._v("Stay on this page")])])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isLoadFinish || !_vm.isVoucherLoadFinish || !_vm.isAccountFinishLoading) ? _c('div', {
    staticClass: "row g-pt-100"
  }, [_c('page-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isSubmitFinish) ? _c('loading-component') : _vm._e()], 1)]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n          Participant Account Information\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n                                          Order requested is not valid.\n                                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "order-review-page-title"
  }, [_vm._v("Order Review")]), _vm._v(" "), _c('p', {
    staticClass: "order-review-description",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Please review and confirm your order details before submitting.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-mt-30 g-mb-30"
  }, [_c('h5', [_vm._v("\n                                                                  Are you sure you want to leave this page? Your order information will not be saved.  To save the info, please select “Save as Pending Order” at the bottom of the page.\n                                                                  ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d935bee", module.exports)
  }
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v(_vm._s(_vm.section))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "g-font-size-20 mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-color-primary--hover g-font-size-20--md g-font-size-17 g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ea56e62", module.exports)
  }
}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v("Order")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-font-size-20--md g-font-size-17 g-color-primary--hover g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-869b70fa", module.exports)
  }
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-pos-rel",
    staticStyle: {
      "background-image": "url(/static/assets/include/svg/svg-bg-cfs.svg)",
      "background-size": "cover",
      "background-position": "center"
    }
  }, [_c('div', {
    staticClass: "container g-pos-rel g-z-index-1 g-py-70"
  }, [_c('div', {
    staticClass: "row align-items-lg-center g-mt-20"
  }, [_c('div', {
    staticClass: "col-lg-6 order-lg-2 g-mb-20"
  }, [_c('div', {
    staticClass: "g-pos-rel g-pl-15--lg"
  }, [_c('img', {
    staticClass: "img-fluid w-100 u-shadow-v19 g-brd-around g-brd-7 g-brd-secondary rounded",
    attrs: {
      "src": _vm.home_banner_img,
      "alt": "Image Description"
    }
  }), _vm._v(" "), (_vm.accountType == 'master') ? _c('div', {
    staticClass: "text-center g-mt-10"
  }, _vm._l((_vm.minorSponsorLogos), function(logo, index) {
    return _c('label', {
      key: index,
      staticClass: "minor-sponsor-h home"
    }, [_c('a', [_c('img', {
      staticClass: "min_sp_img",
      attrs: {
        "src": logo
      }
    })])])
  }), 0) : _c('div', {
    staticClass: "text-center g-mt-10"
  }, _vm._l((_vm.sponsors.minorLogos), function(logo, index) {
    return (logo != '') ? _c('label', {
      key: index,
      staticClass: "minor-sponsor-h home"
    }, [(_vm.sponsors.hyperLinkMinor[index] != '') ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.sponsors.hyperLinkMinor[index]
      }
    }, [_c('img', {
      staticClass: "min_sp_img",
      attrs: {
        "src": logo
      }
    })]) : _c('a', [_c('img', {
      staticClass: "min_sp_img",
      attrs: {
        "src": logo
      }
    })])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 order-lg-1"
  }, [(_vm.accountType != 'master') ? _c('div', {
    staticClass: "mb-5"
  }, [(_vm.sponsors.majorLogoLg == '') ? _c('span', {
    staticClass: "cltl-span"
  }, [_c('a', [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.cltl_logo_white
    }
  })])]) : (_vm.sponsors.hyperLinkMajor == '') ? _c('span', {
    staticClass: "cltl-span"
  }, [_c('a', [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.sponsors.majorLogoLg
    }
  })])]) : _c('span', {
    staticClass: "cltl-span"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.sponsors.hyperLinkMajor
    }
  }, [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.sponsors.majorLogoLg
    }
  })])]), _vm._v(" "), (this.sponsors.header != '') ? _c('h1', {
    staticClass: "g-font-size-25--md g-color-white mb-4 text-center"
  }, [_vm._v(_vm._s(this.sponsors.header))]) : _c('h1', {
    staticClass: "g-font-size-45--md g-color-white mb-4 text-center"
  }, [_vm._v("Champions for Sight®")]), _vm._v(" "), (this.sponsors.paragraph != '') ? _c('p', {
    staticClass: "g-color-white-opacity-0_7 g-font-size-20--md g-font-size-17 text-center"
  }, [_vm._v(_vm._s(this.sponsors.paragraph))]) : _c('p', {
    staticClass: "g-color-white-opacity-0_7 g-font-size-20--md g-font-size-17 text-center"
  }, [_vm._v("\r\n              Thank you for being a Champion for sight! Together, we’re helping the world see more and be more. Here you will find all the resources necessary to assist with charitable efforts in your community. \r\n            ")])]) : _c('div', {
    staticClass: "mb-5"
  }, [_c('span', {
    staticClass: "cltl-span"
  }, [_c('a', [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.cltl_logo_white
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "g-font-size-25--md g-color-white mb-4 text-center"
  }, [_vm._v("Champions for Sight®")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-white-opacity-0_7 g-font-size-20--md g-font-size-17"
  }, [_vm._v("Welcome!  Thank you for being a Champion of sight in your community.  We are excited to partner with you and provide you the resources you need to support your charitable work!")])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8b9e24dc", module.exports)
  }
}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container g-py-40",
    attrs: {
      "id": "contactDiv"
    }
  }, [_vm._m(0), _vm._v(" "), _c('jotform-embed', {
    attrs: {
      "jotFormID": "220555106034141"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "text-center g-mb-50"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Have a question or concern?  Please fill out the form below and we’ll get back to you soon.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97924f2c", module.exports)
  }
}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.val,
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, _vm.val) > -1 : (_vm.checked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.val,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }, _vm.onChange]
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9914409c", module.exports)
  }
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br')])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9cb56b4a", module.exports)
  }
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.Login()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row g-py-20 g-px-20"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.Login()
      }
    }
  }, [_vm._v("\n                  Proceed to Home Page "), (_vm.isLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e()])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "contract-label"
  }, [_vm._v("Thank you for updating your pledge/forecast.")]), _vm._v(" "), _c('p', {
    staticClass: "contract-description"
  }, [_vm._v("You can always update this information in your My Account Page.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9f8bd698", module.exports)
  }
}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br')])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a0f48872", module.exports)
  }
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HelpPage"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.legacySystemHTML)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "u-shadow-v35 g-bg-white rounded g-py-0 g-pb-35"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleBack('/')
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13",
    on: {
      "click": function($event) {
        return _vm.RedirectToSignUp()
      }
    }
  }, [_vm._v("Sign Up")])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container g-py-40",
    attrs: {
      "id": "contactDiv"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 pp_image g-px-0"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "0",
      "padding-bottom": "56.25%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "//www.youtube-nocookie.com/embed/b-_NCXXtLe4?showinfo=0&rel=0&modestbranding=1&autoplay=1&mute=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a1b8271c", module.exports)
  }
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bg-main"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    staticClass: "evf_logo",
    attrs: {
      "src": "/static/assets/img/logo/OSEL Foundation_white_vertical.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container g-py-15"
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section g-my-20"
  }, [(_vm.Account.accountType == 1) ? _c('h4', [_vm._v("INDIVIDUAL REGISTRATION DETAILS")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('h4', [_vm._v("PRACTICE/BUSINESS REGISTRATION DETAILS")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('h4', [_vm._v("NON-PROFIT REGISTRATION DETAILS")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('table', [_c('tbody', [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.Account.accountType == 1 && !_vm.Account.useLicenseNumber) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("NPI Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.npiNumber))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 1 && _vm.Account.useLicenseNumber) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("License Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.licenseNumber))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 1 || _vm.Account.accountType == 2) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant First Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.firstName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Last Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.lastName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Suffix")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.suffix))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Primary Contact First Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.firstName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Primary Contact Last Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.lastName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Suffix")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.suffix))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Phone Number")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.Account.primaryContact.countryCode) + ") " + _vm._s(_vm.Account.primaryContact.areaCode) + "-" + _vm._s(_vm.Account.primaryContact.phone))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Year Licensed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.yearsInPractice))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Business Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.businessTypeDesc))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Phone Number")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.Account.primaryContact.countryCode) + ") " + _vm._s(_vm.Account.primaryContact.areaCode) + "-" + _vm._s(_vm.Account.primaryContact.phone))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Legal Business Name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Phone Number")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.Account.primaryContact.countryCode) + ") " + _vm._s(_vm.Account.primaryContact.areaCode) + "-" + _vm._s(_vm.Account.primaryContact.phone))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Legal Organization Name (Participant)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Business Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.businessTypeDesc))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Role in Business")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.titleDesc))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Organization Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.businessTypeDesc))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Role in Organization")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.titleDesc))])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.Account.accountType == 1) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Shipping Information")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Office Location Information")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Chapter Location Information")]) : _vm._e()]), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Office Location Name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.name))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.streetAddress))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Suite")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.suite))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.city))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("State")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.state))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Zip Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.zip))])]), _vm._v(" "), ((_vm.Account.accountType == 2 || _vm.Account.accountType == 3) && !_vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.countryCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.areaCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.phoneNumber))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.countryCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.areaCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.phoneNumber))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.emailAddress))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Office Contact First Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.contactFirstName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Office Contact Last Name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.contactLastName))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Role in Business")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.contactRoleDesc))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Number of charitable orders this calendar year:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.numberOfJobs))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.january))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.february))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.march))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.april))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.may))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.june))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.july))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.august))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.september))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.october))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.november))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.december))])]), _vm._v(" "), (_vm.Account.accountType == 2 || _vm.Account.accountType == 3) ? _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Eye Doctor Information")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Account.eyeDoctors), function(item) {
    return (_vm.Account.accountType == 2 || _vm.Account.accountType == 3) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "6"
      }
    }, [_c('table', {
      staticStyle: {
        "margin-left": "0px",
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "caption"
    }, [_vm._v("NPI Number")]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v(_vm._s(item.npiNumber))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Doctor's First Name")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.firstName))]), _vm._v(" "), _c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Doctor's Last Name")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.lastName))]), _vm._v(" "), _c('td', {
      staticClass: "caption"
    }, [_vm._v("Suffix")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.suffix))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Doctor's Email Address")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.emailAddress))]), _vm._v(" "), _c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Year Licensed")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(item.yearsInPractice))])])])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [(_vm.Account.accountType == 1 || _vm.Account.accountType == 2) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Association Information and Communication Preferences")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Communication Preferences")]) : _vm._e()]), _vm._v(" "), (_vm.Account.accountType != 3) ? _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Professional Organizations")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, _vm._l((_vm.Account.organizations.list), function(orgItem) {
    return _c('ul', [_c('li', [_vm._v(_vm._s(orgItem))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Communication Preferences")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.toBeContactedAsVolunteer),
      expression: "Account.toBeContactedAsVolunteer"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.toBeContactedAsVolunteer) ? _vm._i(_vm.Account.toBeContactedAsVolunteer, null) > -1 : (_vm.Account.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "toBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "toBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "toBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v(" I would like to be contacted if there are volunteer opportunities in my area."), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.toReceiveNewsLetter),
      expression: "Account.toReceiveNewsLetter"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.toReceiveNewsLetter) ? _vm._i(_vm.Account.toReceiveNewsLetter, null) > -1 : (_vm.Account.toReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.toReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "toReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "toReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "toReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v(" I would like email updates from OneSight EssilorLuxottica Foundation.\n                            ")])]), _vm._v(" "), _c('tr', [(_vm.Account.isCoveredUnderHIPAA) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Terms & Conditions and BAA")]) : _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Participant Responsibilities Signature")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.participantResponsibilitiesSignature))]), _vm._v(" "), _c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date Signed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDate(_vm.Account.participantResponsibilitiesDate)))])]), _vm._v(" "), (_vm.Account.isCoveredUnderHIPAA) ? _c('tr', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.Account.isCoveredUnderHIPAA) ? _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Business Associate Agreement Signature")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.businessAssociateAgreementSignature))]), _vm._v(" "), _c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date Signed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDate(_vm.Account.businessAssociateAgreementDate)))])]) : _vm._e()], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('input', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-px-25 g-py-5",
    attrs: {
      "type": "button",
      "id": "btnPrint",
      "onclick": "javascript: window.print()",
      "value": "Print Form"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Username and Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Participant Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Jan")]), _vm._v(" "), _c('th', [_vm._v("Feb")]), _vm._v(" "), _c('th', [_vm._v("Mar")]), _vm._v(" "), _c('th', [_vm._v("Apr")]), _vm._v(" "), _c('th', [_vm._v("May")]), _vm._v(" "), _c('th', [_vm._v("Jun")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Jul")]), _vm._v(" "), _c('th', [_vm._v("Aug")]), _vm._v(" "), _c('th', [_vm._v("Sep")]), _vm._v(" "), _c('th', [_vm._v("Oct")]), _vm._v(" "), _c('th', [_vm._v("Nov")]), _vm._v(" "), _c('th', [_vm._v("Dec")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', [_vm._v("\n                                    This Agreement (“Contract”) consists of the following Terms and Conditions and referenced Business Associate Agreement. Please review and accept both documents in order to proceed with participation. If you have any questions, click here to contact us. "), _c('br')]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Terms and Conditions\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Please review and accept the below Terms and Conditions for both Changing Life Through Lenses and Customer Giving.\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('p', [_vm._v("\n                                        Lorem ipsum dolor sit amet, veniam numquam has te. No suas nonumes recusabo mea, est ut graeci definitiones. His ne melius vituperata scriptorem, cum paulo copiosae conclusionemque at. Facer inermis ius in, ad brute nominati referrentur vis. Dicat erant sit ex. Phaedrum imperdiet scribentur vix no, ad latine similique forensibus vel.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Dolore populo vivendum vis eu, mei quaestio liberavisse ex. Electram necessitatibus ut vel, quo at probatus oportere, molestie conclusionemque pri cu. Brute augue tincidunt vim id, ne munere fierent rationibus mei. Ut pro volutpat praesent qualisque, an iisque scripta intellegebat eam.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Mea ea nonumy labores lobortis, duo quaestio antiopam inimicus et. Ea natum solet iisque quo, prodesset mnesarchum ne vim. Sonet detraxit temporibus no has. Omnium blandit in vim, mea at omnium oblique.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Eum ea quidam oportere imperdiet, facer oportere vituperatoribus eu vix, mea ei iisque legendos hendrerit. Blandit comprehensam eu his, ad eros veniam ridens eum. Id odio lobortis elaboraret pro. Vix te fabulas partiendo.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Natum oportere et qui, vis graeco tincidunt instructior an, autem elitr noster per et. Mea eu mundi qualisque. Quo nemore nusquam vituperata et, mea ut abhorreant deseruisse, cu nostrud postulant dissentias qui. Postea tincidunt vel eu.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Ad eos alia inermis nominavi, eum nibh docendi definitionem no. Ius eu stet mucius nonumes, no mea facilis philosophia necessitatibus. Te eam vidit iisque legendos, vero meliore deserunt ius ea. An qui inimicus inciderint.\n                                    ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("Participant Responsibilities:")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Please review and select each of the following responsibilities (from the above Terms and Conditions) to confirm your agreement: Please note, you will not be able to submit the form if you do not click \"I Agree\" beneath each item.\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to co-brand and promote Essilor Vision Foundation as a charitable partner, specifically, but not limited to Essilor Vision Foundation logo included on Participant Program Materials and agrees to submit to Essilor Vision Foundation, any requests for additional trademarks, copy or content needed for individual events or media for Essilor Vision Foundation’s approval prior to publication\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to commit to the use of the ECP Portal and lenses for charitable vision services\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to validate the patient need through an indirect referral network or directly through vetting by the Participant which shall include: income below poverty level, lack of insurance and/or lack of lens benefit\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to ensure that no charge is accepted or marketed, specific to the lens product delivered; however, Participant is able to charge up to, but not to exceed, the cost of the frame when there is a cost associated with the frame\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to retain an electronic log outlining to whom Essilor Vision Foundation services were provided. Information may include, but is not limited to: date of service, number/name of patient examined with validation of need, number of exams, number of patients who received glasses, total number of glasses dispensed, and number of patients receiving glasses for the first time. The electronic log must be kept available during the term of the Contract for audit purposes and other treatment and health care operation purposes further described in the accompanying BAA, as Essilor Vision Foundation may request from time to time during the Term.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Business Associate Agreement\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Please review and accept the terms of the below Business Associate Agreement.\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('p', [_vm._v("\n                                        Lorem ipsum dolor sit amet, veniam numquam has te. No suas nonumes recusabo mea, est ut graeci definitiones. His ne melius vituperata scriptorem, cum paulo copiosae conclusionemque at. Facer inermis ius in, ad brute nominati referrentur vis. Dicat erant sit ex. Phaedrum imperdiet scribentur vix no, ad latine similique forensibus vel.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Dolore populo vivendum vis eu, mei quaestio liberavisse ex. Electram necessitatibus ut vel, quo at probatus oportere, molestie conclusionemque pri cu. Brute augue tincidunt vim id, ne munere fierent rationibus mei. Ut pro volutpat praesent qualisque, an iisque scripta intellegebat eam.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Mea ea nonumy labores lobortis, duo quaestio antiopam inimicus et. Ea natum solet iisque quo, prodesset mnesarchum ne vim. Sonet detraxit temporibus no has. Omnium blandit in vim, mea at omnium oblique.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Eum ea quidam oportere imperdiet, facer oportere vituperatoribus eu vix, mea ei iisque legendos hendrerit. Blandit comprehensam eu his, ad eros veniam ridens eum. Id odio lobortis elaboraret pro. Vix te fabulas partiendo.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Natum oportere et qui, vis graeco tincidunt instructior an, autem elitr noster per et. Mea eu mundi qualisque. Quo nemore nusquam vituperata et, mea ut abhorreant deseruisse, cu nostrud postulant dissentias qui. Postea tincidunt vel eu.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Ad eos alia inermis nominavi, eum nibh docendi definitionem no. Ius eu stet mucius nonumes, no mea facilis philosophia necessitatibus. Te eam vidit iisque legendos, vero meliore deserunt ius ea. An qui inimicus inciderint.\n                                    ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a68a028a", module.exports)
  }
}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('swiper', {
    staticClass: "swiper-wrapper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l((_vm.images), function(pic, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": pic,
        "alt": "Image Description"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "level3-gallery-prev swiper-button-prev",
    attrs: {
      "slot": "button-prev",
      "id": "prev-image"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "level3-gallery-next swiper-button-next",
    attrs: {
      "slot": "button-next",
      "id": "next-image"
    },
    slot: "button-next"
  })], 2)], 1)])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a8808438", module.exports)
  }
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [(_vm.isWufooLoading) ? _c('div', {
    staticClass: "text-center"
  }, [_c('page-loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.isWufooLoading) ? _c('div', [_c('iframe', {
    staticStyle: {
      "min-width": "100%",
      "height": "800px",
      "border": "none"
    },
    attrs: {
      "id": "JotFormIFrame-231234850054145",
      "title": "Suggestion Form",
      "onload": "window.parent.scrollTo(0,20)",
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "src": 'https://form.jotform.com/231234850054145?' +
        _vm.prefillFields,
      "frameborder": "0",
      "scrolling": "yes"
    }
  })]) : _vm._e()])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a88f1d00", module.exports)
  }
}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "registration-success g-py-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0"
  }, [_c('div', {
    staticClass: "success-div"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n              You have successfully submitted your registration form for the Changing Life through Lenses® program!\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v("\n              to download a copy of the contract for your records.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n              An email has been sent to the email address you provided with a link to activate your account.\n            ")])])])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-af87bed0", module.exports)
  }
}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md",
    staticStyle: {
      "max-width": "1140px"
    }
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg",
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row long-modal"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "1px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "min-width": "100%",
      "height": "800px",
      "border": "none"
    },
    attrs: {
      "id": _vm.jotFormElementID,
      "title": "Equipment Request Form",
      "onload": "window.parent.scrollTo(0,20)",
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "allow": "geolocation; microphone; camera",
      "src": 'https://form.jotform.com/' + _vm.formID + '?' + _vm.prefillFields,
      "frameborder": "0",
      "scrolling": "no"
    }
  })])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b61c92e0", module.exports)
  }
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), (_vm.isFormLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS('yes')
      }
    }
  }, [_vm._v("Pledge Today!")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS('remindLater')
      }
    }
  }, [_vm._v("Remind Me Later")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn bg-transparent text-danger g-font-size-16",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS('no')
      }
    }
  }, [_c('u', [_vm._v("Not Interested or Unable to Participate")])])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "nonprofit-modal-msg"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_c('div', [_vm._v("\nAdopt-a-School Today!\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: " padding-left col-lg-11 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {}, [_c('b', [_vm._v("Adopt-a-School")]), _vm._v(" and we’ll provide free glasses for kids in need! ")]), _vm._v(" "), _c('p', {}, [_vm._v("Millions of students don't have the glasses they need because their families cannot access or afford vision care.")]), _vm._v(" "), _c('p', {}, [_vm._v("To bridge this gap, the OneSight EssilorLuxottica Foundation encourages eye doctors to enroll in Changing Life through Lenses (CLTL) to access free glasses and Adopt-a-School to provide local students the vision care they deserve.")]), _vm._v(" "), _c('p', {}, [_vm._v("You can "), _c('b', [_vm._v("Adopt-a-School")]), _vm._v(" and support your community in 3 easy steps: ")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/CLTLDay/Step1.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Click "), _c('b', [_vm._v("Pledge Today!")]), _vm._v(" below and pledge to support a local school  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/CLTLDay/Step2.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Contact a local school in need using CLTL’s Adopt-a-School resources")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/CLTLDay/Step3.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Serve students with the support of CLTL’s free glasses")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {}, [_vm._v("CLTL's Adopt-a-School resources help you partner with schools by offering: email templates to contact the schools, talking points to speak with the nurses and customizable flyers for parent referrals\n        ")]), _vm._v(" "), _c('p', {}, [_c('i', [_vm._v("Doctors who sign up for Changing Life through Lenses may be invited to join a OneSight EssilorLuxottica Foundation vision clinic!")])]), _vm._v(" "), _c('p', {}, [_vm._v("Pledge today and help a student be more and see more!")])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ba05d75e", module.exports)
  }
}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Forecasting Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Pledged number of orders this year: "), _vm._m(0)]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location's pledged number of orders this year: "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-5 col-sm-4 col-xs-4"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationNumberOfJobs),
      expression: "FormInputs.OfficeLocationNumberOfJobs"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.numberOfJobs),
      expression: "AccountEdit.primaryContact.officeLocation.numberOfJobs"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationNumberOfJobs
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.numberOfJobs)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation, "numberOfJobs", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationNumberOfJobs) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationNumberOfJobs))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("\r\n              How do you plan on serving those patients?\r\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forcastServices),
      expression: "forcastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Serve walk ins and sporadic referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forcastServices) ? _vm._i(_vm.forcastServices, "Serve walk ins and sporadic referrals in my office") > -1 : (_vm.forcastServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.forcastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Serve walk ins and sporadic referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forcastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forcastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forcastServices = $$c
        }
      }, _vm.onChangeServices]
    }
  }), _vm._v("\r\n              Serve walk ins and sporadic referrals in my office\r\n              "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forcastServices),
      expression: "forcastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Host a vision event(s)",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forcastServices) ? _vm._i(_vm.forcastServices, "Host a vision event(s)") > -1 : (_vm.forcastServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.forcastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Host a vision event(s)",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forcastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forcastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forcastServices = $$c
        }
      }, _vm.onChangeServices]
    }
  }), _vm._v("\r\n              Host a vision event(s)\r\n              "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forcastServices),
      expression: "forcastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Partner with a local non profit or school to receive their referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forcastServices) ? _vm._i(_vm.forcastServices, "Partner with a local non profit or school to receive their referrals in my office") > -1 : (_vm.forcastServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.forcastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Partner with a local non profit or school to receive their referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forcastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forcastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forcastServices = $$c
        }
      }, _vm.onChangeServices]
    }
  }), _vm._v("\r\n              Partner with a local non profit or school to receive their referrals in my office\r\n              "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forcastServices),
      expression: "forcastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Volunteer at local clinics, health fairs, or vision events",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forcastServices) ? _vm._i(_vm.forcastServices, "Volunteer at local clinics, health fairs, or vision events") > -1 : (_vm.forcastServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.forcastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Volunteer at local clinics, health fairs, or vision events",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forcastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forcastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forcastServices = $$c
        }
      }, _vm.onChangeServices]
    }
  }), _vm._v("\r\n              Volunteer at local clinics, health fairs, or vision events\r\n              "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forcastServices),
      expression: "forcastServices"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "I’m not sure",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forcastServices) ? _vm._i(_vm.forcastServices, "I’m not sure") > -1 : (_vm.forcastServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.forcastServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "I’m not sure",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forcastServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forcastServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forcastServices = $$c
        }
      }, _vm.onChangeServices]
    }
  }), _vm._v("\r\n                I’m not sure\r\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100),
      expression: "AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100"
    }],
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100),
      expression: "AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100"
    }]
  }, [_vm._v("Due to the high pledge/forecast, please break out your estimate by month.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100),
      expression: "AccountEdit.primaryContact.officeLocation.numberOfJobs >= 100"
    }],
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.january),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.january"
    }],
    ref: "january_input",
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 1
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.january)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "january", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.february),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.february"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 2
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.february)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "february", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.march),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.march"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 3
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.march)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "march", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.april),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.april"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 4
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.april)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "april", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.may),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.may"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 5
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.may)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "may", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.june),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.june"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 6
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.june)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "june", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.july),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.july"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 7
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.july)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "july", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.august),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.august"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 8
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.august)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "august", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.september),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.september"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 9
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.september)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "september", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.october),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.october"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 10
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.october)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "october", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.november),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.november"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 11
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.november)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "november", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountEdit.primaryContact.officeLocation.jobs.december),
      expression: "AccountEdit.primaryContact.officeLocation.jobs.december"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 12
    },
    domProps: {
      "value": (_vm.AccountEdit.primaryContact.officeLocation.jobs.december)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.AccountEdit.primaryContact.officeLocation.jobs, "december", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0",
      "text-align": "right"
    }
  }, [_c('b', [_vm._v("Total: " + _vm._s(_vm.total))])])])]), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationJobs) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationJobs))]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Please provide your best estimate; this does not need to be exact.  You can modify this number from your “My Account” page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Please provide your best estimate; this does not need to be exact.  You can modify this number from your “My Account” page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Monthly Breakdown:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-mb-0",
    staticStyle: {
      "display": "block"
    }
  }, [_c('small', [_c('i', [_vm._v("If there is a difference, your monthly total will replace your pledged number of orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jan")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Feb")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Mar")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Apr")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("May")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jun")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jul")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Aug")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Sep")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Oct")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Nov")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dec")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bb077c72", module.exports)
  }
}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v("Frames")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-color-primary--hover g-font-size-20--md g-font-size-17 g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17 ",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bfe6b97e", module.exports)
  }
}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("Successfully Submitted for Approval!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Your order has been successfully submitted for approval.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Your order will be reviewed within the next 2-3 business days. \n        You will receive an email either with your order confirmation or \n        informing you that your order was not approved.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Please note, the overall turn time for this order will be increased.\n    ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c0ba344c", module.exports)
  }
}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": ""
    }
  }, [_c('div', {
    staticClass: "mx-auto g-mb-60 text-center"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Helpful Website Guides")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Below are resources to help you use and navigate the website to the fullest.")])]), _vm._v(" "), _c('div', {
    staticClass: "card-group d-block d-md-flex g-mx-minus-4"
  }, [_c('div', {
    staticClass: "card g-brd-none g-mx-4 g-mb-8 u-shadow-v38"
  }, [_c('div', {
    staticClass: "card-body g-bg-white rounded g-pa-40"
  }, [_c('img', {
    staticClass: "help-page-icon g-mb-20",
    attrs: {
      "src": __webpack_require__(363)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Order Guide")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-20--md g-font-size-18"
  }, [_vm._v("This document walks you through how to place an order from your prescription.")])]), _vm._v(" "), _c('div', {
    staticClass: "g-help-view-document"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
    attrs: {
      "href": "https://drive.google.com/file/d/1iHkl0Ne8l1Od0fqCDMkSzf_zPvJsj-M-/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("View Document"), _c('i', {
    staticClass: "g-font-size-13 ml-2 material-icons"
  }, [_vm._v("arrow_forward")])]), _vm._v(" "), _c('a', {
    staticClass: "g-float-right g-color-main g-color-primary--hover",
    attrs: {
      "href": "https://drive.google.com/uc?export=download&id=1iHkl0Ne8l1Od0fqCDMkSzf_zPvJsj-M-",
      "download": "EVF Portal Flyer",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card g-brd-none g-mx-4 g-mb-8 u-shadow-v38"
  }, [_c('div', {
    staticClass: "card-body g-bg-white rounded g-pa-40"
  }, [_c('img', {
    staticClass: "help-page-icon g-mb-20",
    attrs: {
      "src": __webpack_require__(364)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Track Order Guide")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-20--md g-font-size-18"
  }, [_vm._v("This guide demonstrates the features of the Track Order page.")])]), _vm._v(" "), _c('div', {
    staticClass: "g-help-view-document"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
    attrs: {
      "href": "https://drive.google.com/file/d/1hUdv9QbrIj_6Oga78F2yiNJ3decIybfS/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("View Document"), _c('i', {
    staticClass: "g-font-size-13 ml-2 material-icons"
  }, [_vm._v("arrow_forward")])]), _vm._v(" "), _c('a', {
    staticClass: "g-float-right g-color-main g-color-primary--hover",
    attrs: {
      "href": "https://drive.google.com/uc?export=download&id=1hUdv9QbrIj_6Oga78F2yiNJ3decIybfS",
      "download": "EVF Portal Flyer",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c0caeef8", module.exports)
  }
}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('header-component'), _vm._v(" "), (_vm.$route.params.type == 0) ? _c('div', {
    staticClass: "container registation_content g-pt-25 g-pb-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('account-type', {
    on: {
      "clicked": function($event) {
        return _vm.GetForm()
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.type != 0) ? _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg1.svg')",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container registation_content g-pt-50 g-pb-50"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-10 col-sm-12 col-xs-12",
    staticStyle: {
      "background-color": "white",
      "padding": "50px",
      "border-radius": "10px",
      "box-shadow": "0 4px 8px rgba(0, 0, 0, 0.1)"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSubmitFail),
      expression: "isSubmitFail"
    }],
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "errorDiv",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.isSubmitFail = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('strong', [_vm._v("Error!")]), _vm._v(" Please complete the form to proceed with\n            the submission\n          ")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "registration-authority"
  }, [_vm._v("\n              Required fields are denoted with an asterisk\n            ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "registration-authority"
  }, [_vm._v("\n              " + _vm._s(_vm.noteLabel) + "\n            ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('non-profit-organization-details', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult
    }
  }), _vm._v(" "), _c('username-and-password', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult
    },
    on: {
      "clicked": function($event) {
        return _vm.IsEmailAddressValid()
      },
      "confirm": function($event) {
        return _vm.ValidateConfirmEmail()
      }
    }
  }), _vm._v(" "), _c('participant-information', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "ContactValidationResult": _vm.ContactValidationResult,
      "BusinessTypeIndividual": _vm.BusinessTypeIndividual,
      "BusinessTypeBusiness": _vm.BusinessTypeBusiness,
      "BusinessTypeNonProfit": _vm.BusinessTypeNonProfit,
      "Suffix": _vm.Suffix,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "State": _vm.State
    },
    on: {
      "npiForBusiness": function($event) {
        return _vm.ValidateNpiNumberForBusinessType()
      },
      "npiIsDirty": function($event) {
        return _vm.ValidateNpiNumber()
      }
    }
  }), _vm._v(" "), _c('office-location-information', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "OfficeLocationValidationResult": _vm.OfficeLocationValidationResult,
      "State": _vm.State,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "IsValidNPI": _vm.IsValidNPI,
      "IsAddressValidating": _vm.IsAddressValidating
    },
    on: {
      "addressCheck": function($event) {
        return _vm.ValidateAddress()
      }
    }
  }), _vm._v(" "), _c('eye-doctor-information', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "EyeDoctorValidation": _vm.EyeDoctorValidation,
      "Suffix": _vm.Suffix,
      "State": _vm.State
    },
    on: {
      "npiIsDirtyBusiness": _vm.ValidateNpiNumberEyeDoctor
    }
  }), _vm._v(" "), _c('association-and-communication', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "CheckboxBusiness": _vm.CheckboxBusiness
    }
  }), _vm._v(" "), _c('TermAgreementAndBaa', {
    attrs: {
      "Account": _vm.Account,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "BusinessEmail": _vm.BusinessEmail,
      "TermsEmail": _vm.TermsEmail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-30"
  }, [_c('button', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10 g-font-size-18--md g-font-size-16",
    attrs: {
      "disabled": !_vm.EnablebCheck(),
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitForm()
      }
    }
  }, [_vm._v("\n                  Agree & Submit\n                ")])])], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-max-width-645 text-center mx-auto g-mb-0"
  }, [_c('h2', {
    staticClass: "h2 mb-3"
  }, [_vm._v("Registration Form")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-max-width-945 text-center mx-auto g-mb-0"
  }, [_c('h2', {
    staticClass: "h2 mb-3"
  }, [_vm._v("Registration Form")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n              Complete the information below to register for a Champions for Sight®\n              account. Upon submitting the form, you will be sent an email\n              confirmation with a link to activate your account. If you have\n              any questions or concerns, please email us at\n              "), _c('a', {
    staticClass: "g-font-size-18",
    attrs: {
      "href": "mailto:support@onesight.org",
      "target": "_blank"
    }
  }, [_vm._v("support@onesight.org")]), _vm._v(".\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "registration-authority"
  }, [_vm._v("\n              Nonprofit organizations, please "), _c('a', {
    attrs: {
      "href": "cltl.org"
    }
  }, [_vm._v("click here")]), _vm._v(" to register at "), _c('a', {
    attrs: {
      "href": "CLTL.org"
    }
  }, [_vm._v("CLTL.org")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c2a7ccca", module.exports)
  }
}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Forecasting Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [(_vm.FormInputs.IndividualLabels) ? _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Pledged number of orders this year")]) : _c('label', {
    staticClass: "account_label"
  }, [_vm._v("Location's pledged number of orders this year")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [(_vm.FormInputs.BusinessLabels || _vm.FormInputs.NonProfitLabels) ? _c('p') : _vm._e(), _vm._v(" "), (_vm.AccountView.primaryContact.officeLocation.numberOfJobs || _vm.AccountView.primaryContact.officeLocation.numberOfJobs == '0') ? _c('p', {
    staticClass: "account_p"
  }, [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.numberOfJobs + " " + _vm.orderDesc))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("How do you plan on serving those patients?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.forecastServices), function(service) {
    return _c('li', [_vm._v("\n            " + _vm._s(service) + "\n          ")])
  }), 0)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AccountView.primaryContact.officeLocation.numberOfJobs >= 100),
      expression: "AccountView.primaryContact.officeLocation.numberOfJobs >= 100"
    }],
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-3 col-xs-3"
  }, [_c('table', {
    staticClass: "forecasting_services"
  }, [_c('tr', [_c('td', [_vm._v("Jan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.january))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Feb")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.february))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mar")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.march))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Apr")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.april))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("May")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.may))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jun")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.june))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-3 col-xs-3"
  }, [_c('table', {
    staticClass: "forecasting_services"
  }, [_c('tr', [_c('td', [_vm._v("Jul")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.july))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Aug")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.august))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sept")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.september))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oct")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.october))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nov")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.november))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Dec")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AccountView.primaryContact.officeLocation.jobs.december))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "account_p"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.EditSection()
      }
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('edit-forecasting-info', {
    attrs: {
      "AccountEdit": _vm.AccountEdit,
      "ForcastServices": _vm.forecastServices,
      "FormInputs": _vm.FormInputs,
      "OfficeLocationValidationResult": _vm.OfficeLocationValidationResult
    },
    on: {
      "setUpdatedServices": _vm.SetUpdatedServices
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.SaveAccount()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7"
  }, [_c('ul')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Monthly Breakdown")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c362885e", module.exports)
  }
}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row g-py-20 g-px-20"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "contract-label"
  }, [_vm._v("Thank you for accepting the new contract!")]), _vm._v(" "), _c('p', {
    staticClass: "contract-description"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isContractLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e(), _vm._v("\n                                    to download a copy for your records.                                    ")]), _vm._v(" "), _c('p', {
    staticClass: "contract-description"
  }, [_vm._v("You can always view and download your current contract in your My Account Page")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.Login()
      }
    }
  }, [_vm._v("\n                                    Proceed to Home Page "), (_vm.isLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": __webpack_require__(6)
    }
  })]) : _vm._e()])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c4faeb78", module.exports)
  }
}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center",
    style: ({
      height: _vm.Height + 'px'
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.pageLoader_img
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.Message))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c511ae98", module.exports)
  }
}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-img-hero g-pos-rel",
    staticStyle: {
      "background-image": "url(/static/assets/include/svg/svg-bg-cfs.svg)"
    }
  }, [_c('div', {
    staticClass: "container g-pt-100"
  }, [_c('div', {
    staticClass: "row justify-content-lg-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 align-self-end"
  }, [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": _vm.charitable_outreach_img,
      "alt": "Image Description"
    }
  })])])]), _vm._v(" "), _c('svg', {
    staticClass: "g-pos-abs g-bottom-0",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 1921 183.5",
      "enable-background": "new 0 0 1921 183.5",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M0,183.5v-142c0,0,507,171,1171,58c0,0,497-93,750,84H0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.2",
      "fill": "#FFFFFF",
      "d": "M0,183V0c0,0,507,220.4,1171,74.7c0,0,497-119.9,750,108.3H0z"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 g-pt-50--lg"
  }, [_c('div', {
    staticClass: "mb-5"
  }, [_c('h1', {
    staticClass: "g-font-size-38 mb-4"
  }, [_vm._v("Enhance Your Charitable Outreach")]), _vm._v(" "), _c('p', {
    staticClass: "frame-heading-description"
  }, [_vm._v("\r\n              Champions for Sight® offers a frame collection kit for every account! \r\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "frame-heading-description"
  }, [_vm._v("\r\n              Request your frame collection kit, which includes samples of every style, for a nominal donation.\r\n            ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ca518934", module.exports)
  }
}

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fixed-header', {
    staticClass: "u-header",
    attrs: {
      "id": "js-header",
      "fixed": _vm.isFixed,
      "threshold": 50
    },
    on: {
      "update:fixed": function($event) {
        _vm.isFixed = $event
      }
    }
  }, [_c('div', {
    staticClass: "u-header__section temp-header",
    class: {
      header: _vm.isFixed
    }
  }, [_c('div', {
    staticClass: "g-bg-main main-header",
    class: {
      'is-collapse': _vm.isCollapse
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    staticClass: "evf_logo",
    class: {
      evf_logo_height: !_vm.isLogIn
    },
    attrs: {
      "src": __webpack_require__(365)
    }
  })]), _vm._v(" "), (_vm.accountType == 'master') ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [(_vm.isLogIn) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.cltl_logo_white
    }
  }) : _vm._e()]) : (_vm.sponsors != null) ? _c('span', [(_vm.sponsors.hyperLinkMajor != '') ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.sponsors.hyperLinkMajor
    }
  }, [(_vm.isLogIn && _vm.sponsors.majorLogo) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.sponsors.majorLogo
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sponsors.hyperLinkMajor == '') ? _c('a', {
    attrs: {
      "target": "_blank"
    }
  }, [(_vm.isLogIn && _vm.sponsors.majorLogo) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.sponsors.majorLogo
    }
  }) : _vm._e()]) : _vm._e()]) : _c('span', [_c('a', [(_vm.isLogIn && _vm.sponsors.majorLogo) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.sponsors.majorLogo
    }
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isLogIn) ? _c('div', {
    staticClass: "login-button-container"
  }, [_c('span', {
    staticClass: "g-px-10 g-color-white"
  }, [_vm._v("Already have an account?")]), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    on: {
      "click": _vm.redirectToLogin
    }
  }, [_vm._v("\n            Login\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hamburger-div",
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse
      }
    }
  }), _vm._v(" "), (_vm.isLogIn) ? _c('div', {
    staticClass: "collapse-button"
  }, [_c('span', {
    staticClass: "g-color-white",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isCollapse) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "nav-collapse"
  }, [(_vm.isLogIn) ? _c('ul', {
    staticClass: "navigation-bar-collapse"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Home')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        _vm.showOrderSubMenuOnMobile = !_vm.showOrderSubMenuOnMobile
      }
    }
  }, [_vm._v("Order")])]), _vm._v(" "), (_vm.showOrderSubMenuOnMobile) ? [_c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_vm._v("Patient Order")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_vm._v("Frame Collection")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_vm._v("Track Order")])])] : _vm._e(), _vm._v(" "), (
    this.framePageVisible == 'true' ||
    _vm.MasterAccountType == 'master'
  ) ? _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_vm._v("Frames")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resource')
      }
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('UserAccount')
      }
    }
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    attrs: {
      "href": "https://onesightus.donorsupport.co/page/practicechampions",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Donate")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.LogOut()
      }
    }
  }, [_vm._v("Log Out")])])], 2)]) : _vm._e(), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container g-py-15 nav-container"
  }, [(_vm.isLogIn) ? _c('ul', {
    staticClass: "navigation-bar"
  }, [_c('div', [_c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'home'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('PortalHome')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item order-dropdown list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'order'
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('ul', {
    staticClass: "order-sub-menu position-absolute bg-white list-unstyled px-4 py-2 mt-2"
  }, [_c('li', [_c('a', {
    staticClass: "u-link-v5 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_vm._v("Patient Order")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_vm._v("Frame Collection")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-font-size-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_vm._v("Track Order")])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'frame'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_vm._v("Frames")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'resource'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resource')
      }
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'my-account'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('UserAccount')
      }
    }
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'help'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    attrs: {
      "href": "https://onesightus.donorsupport.co/page/practicechampions",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Donate")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    on: {
      "click": function($event) {
        return _vm.LogOut()
      }
    }
  }, [_vm._v("Log Out")])])])]) : _vm._e()])], 1), _vm._v(" "), (
    _vm.AccountStatus == 'OrderHoldUnderReview' &&
    _vm.showTheNotificationAlert == 'false' &&
    _vm.activeCurrentPage == 'order'
  ) ? _c('div', {
    staticClass: "g-bg-main g-py-10"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "successDiv",
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("This account is unable to place orders at this time.")])])])]) : _vm._e(), _vm._v(" "), (_vm.showTheNotificationAlert == 'true') ? _c('div', {
    staticClass: "g-py-10"
  }, [_c('div', {
    staticClass: "col-lg-10 offset-lg-1"
  }, [(_vm.notificationMessage != 'null') ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible fade show",
    attrs: {
      "id": "successDiv",
      "role": "alert"
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert",
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.hideNotificationAlert()
      }
    }
  }, [_vm._v("×")]), _vm._v(_vm._s(_vm.notificationMessage) + "\n          ")]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "110px",
      "background": "#26304d !important"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cc0229ac", module.exports)
  }
}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-color": "#efefef",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container g-pt-60 g-pb-30"
  }, [_c('div', {
    staticClass: "row justify-content-lg-center align-items-md-center"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-7 g-mb-30"
  }, [_c('div', {
    staticClass: "media align-items-center g-pr-15--lg"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Don’t see the guide or resource you are looking for?")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" and suggest a new resource that would be helpful.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 col-lg-3 mx-auto g-mx-0--lg g-mb-30"
  }, [_c('a', {
    staticClass: "btn btn-block u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-25 g-py-13 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Submit a Suggestion")])])])]), _vm._v(" "), (_vm.isModalShown) ? _c('suggest-form', {
    on: {
      "closeWufoo": function($event) {
        return _vm.CloseModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d3bed8a4", module.exports)
  }
}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container text-center g-pt-70"
  }, [_c('h2', {
    staticClass: "h1 mb-3"
  }, [_vm._v("Looking for additional support?")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Check out these other programs from OneSight EssilorLuxottica Foundation to support your charitable work.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row g-mb-30 justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-6 g-mb-30 home-page-invite"
  }, [_c('a', {
    staticClass: "no-underline g-color-main g-color-primary--hover",
    attrs: {
      "href": "https://www.evfusa.org/get-involved/in-office-donation-campaigns/",
      "target": "_blank"
    },
    on: {
      "mouseover": function($event) {
        return _vm.HoverDonation('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverDonation('leave')
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid home-page-icon rounded-circle mx-auto g-mb-30 g-mt-30",
    attrs: {
      "src": _vm.donationIcon,
      "alt": "Image Description"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("In-Office Donation Campaign")])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-px-30--lg"
  }, [_c('p', {
    staticClass: "g-color-text-light-v1 mb-0 g-font-size-20"
  }, [_vm._v("Inspire patients and staff to adopt the cause of vision and raise funds.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dc468a4e", module.exports)
  }
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Your order has encountered the following error in submission:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2",
    staticStyle: {
      "border": "3px solid red",
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetails.errorMessage) + "\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n       Your error has been saved as a pending-error order\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        If you believe you know the cause of the error you may edit the order \n        and try submitting it again. If you're not sure, the support team has \n        been notified of the error and will review the order in the next 2-3 business days. \n        This order can also be edited or deleted from the Track Order page at any time.\n        If this is an urgent order, please click "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ShowHelpForm()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us.\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de89342e", module.exports)
  }
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container g-my-100"
  }, [_c('div', {
    staticClass: "reset_password_services"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0"
  }, [(_vm.IsCodeInvalid) ? _c('div', {
    staticClass: "reset-password-div"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Sorry!")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n                            Your reset password code is invalid.\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.IsCodeValid) ? _c('div', {
    staticClass: "reset-password-div"
  }, [(_vm.isFormLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('page-loader')], 1) : _c('div', [(!_vm.isSuccess) ? _c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Forgot Password")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n                                    Please enter your new password in the fields below.\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "reset_info_label"
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ResetNewPassword.Password),
      expression: "ResetNewPassword.Password"
    }],
    staticClass: "form-control login_input",
    class: {
      error_field: _vm.validationResult.AccountPassword, error_field2: _vm.hasPasswordError
    },
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.ResetNewPassword.Password)
    },
    on: {
      "keyup": function($event) {
        _vm.CheckPasswordDigits();
        _vm.CheckMatchPassword()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ResetNewPassword, "Password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.validationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.validationResult.AccountPassword))]) : (_vm.hasPasswordError && !_vm.validationResult.AccountPassword) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasPasswordErrorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "reset_info_label"
  }, [_vm._v("Confirm new password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ResetNewPassword.PasswordConfirm),
      expression: "ResetNewPassword.PasswordConfirm"
    }],
    staticClass: "form-control login_input",
    class: {
      error_field: _vm.validationResult.AccountPasswordConfirm, error_field2: _vm.hasConfirmPasswordError
    },
    attrs: {
      "name": "confirmPassword",
      "type": "password"
    },
    domProps: {
      "value": (_vm.ResetNewPassword.PasswordConfirm)
    },
    on: {
      "keyup": function($event) {
        _vm.CheckConfirmPasswordDigits();
        _vm.CheckMatchPassword()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ResetNewPassword, "PasswordConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.validationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.validationResult.AccountPasswordConfirm))]) : _vm._e(), _vm._v(" "), (_vm.hasConfirmPasswordError && !_vm.validationResult.AccountPasswordConfirm) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.hasConfirmPasswordErrorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13",
    on: {
      "click": function($event) {
        return _vm.ResetPassword()
      }
    }
  }, [_vm._v("Reset Password")])])])])]) : _c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Success!")]), _vm._v(" "), _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n                                You can now login to your account by using your new password!\n                                "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "g-font-size-20",
    on: {
      "click": function($event) {
        return _vm.RedirectHome()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to login.\n                              ")])])])]) : _vm._e()])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dfa88842", module.exports)
  }
}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal_program_content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-lg-between"
  }, [_c('div', {
    staticClass: "col-md-12 g-pt-50 g-pt-100--md g-pb-70"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12 pp_image g-px-0"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "0",
      "padding-bottom": "56.25%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://www.youtube-nocookie.com/embed/j03iJHt8q2A?si=RLQgQUuQpspJ0B-n&showinfo=0&rel=0&modestbranding=1&autoplay=1&mute=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12 second"
  }, [_c('div', {
    staticClass: "portal_info ml-md-4"
  }, [_c('div', {
    staticClass: "pp_benefit_content"
  }, [_c('p', {
    staticClass: "pp_title"
  }, [_vm._v("User Testimonial")]), _vm._v(" "), _c('div', {
    staticClass: "program_desc_container"
  }, [_c('p', {
    staticClass: "pp_description"
  }, [_vm._v("Hear from Dr. Kristin Reed about how the Champions for Sight® program has helped her make an impact in her community and her practice. ")]), _vm._v(" "), _c('p', {
    staticClass: "pp_description"
  }, [_vm._v("By participating in the program, you and your team can make a tangible difference in the lives of others!")])])])])])])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e42e8ece", module.exports)
  }
}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "1px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "min-width": "100%",
      "height": "800px",
      "border": "none"
    },
    attrs: {
      "id": "JotFormIFrame-201614063686050",
      "title": "Equipment Request Form",
      "onload": "window.parent.scrollTo(0,20)",
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "allow": "geolocation; microphone; camera",
      "src": 'https://form.jotform.com/201614063686050?' +
        _vm.prefillFields,
      "frameborder": "0",
      "scrolling": "yes"
    }
  })])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e622930a", module.exports)
  }
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.FormInputs) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationNumberOfJobs),
      expression: "FormInputs.OfficeLocationNumberOfJobs"
    }],
    staticClass: "form-group g-mb-0"
  }, [_c('label', [_vm._v(_vm._s(_vm.PledgeLabel) + " "), _c('span', {
    attrs: {
      "data-balloon": _vm.PledgeHelpText,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.OfficeLocationNumberOfJobs),
      expression: "FormInputs.OfficeLocationNumberOfJobs"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.NumberOfJobs),
      expression: "Account.PrimaryContact.OfficeLocation.NumberOfJobs"
    }],
    staticClass: "form-control no-arrow-updown",
    class: {
      error_field: _vm.OfficeLocationValidationResult.OfficeLocationNumberOfJobs
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.NumberOfJobs)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.G_NumberInputCheck(_vm.Account.PrimaryContact.OfficeLocation)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation, "NumberOfJobs", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationNumberOfJobs) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationNumberOfJobs))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Account.PrimaryContact.OfficeLocation.NumberOfJobs >= 100),
      expression: "Account.PrimaryContact.OfficeLocation.NumberOfJobs >= 100"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Due to the high pledge/forecast, please break out your estimate by month across the remainder of the year.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-bg"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.January),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.January"
    }],
    ref: "january_input",
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 1
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.January)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.January)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "January", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.February),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.February"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 2
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.February)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.February)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "February", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.March),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.March"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 3
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.March)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.March)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "March", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.April),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.April"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 4
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.April)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.April)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "April", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.May),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.May"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 5
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.May)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.May)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "May", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.June),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.June"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 6
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.June)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.June)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "June", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-bg"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.July),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.July"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 7
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.July)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.July)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "July", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.August),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.August"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 8
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.August)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.August)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "August", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.September),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.September"
    }],
    staticClass: "form-control  pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 9
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.September)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.September)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "September", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.October),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.October"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 10
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.October)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.October)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "October", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.November),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.November"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 11
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.November)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.November)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "November", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.PrimaryContact.OfficeLocation.Jobs.December),
      expression: "Account.PrimaryContact.OfficeLocation.Jobs.December"
    }],
    staticClass: "form-control pledge-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.currentMonth > 12
    },
    domProps: {
      "value": (_vm.Account.PrimaryContact.OfficeLocation.Jobs.December)
    },
    on: {
      "keyup": function($event) {
        return _vm.TotalJobs()
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(_vm.Account.PrimaryContact.OfficeLocation.Jobs.December)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.PrimaryContact.OfficeLocation.Jobs, "December", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-bg",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0",
      "text-align": "right"
    }
  }, [_c('b', [_vm._v("Total: " + _vm._s(_vm.total))])])])]), _vm._v(" "), (_vm.OfficeLocationValidationResult.OfficeLocationJobs) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.OfficeLocationValidationResult.OfficeLocationJobs))]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', [_c('small', [_vm._v("If there is a difference, your monthly total will replace your pledged number of orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jan")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Feb")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Mar")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Apr")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("May")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jun")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jul")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Aug")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Sep")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Oct")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Nov")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dec")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ec2ba3ca", module.exports)
  }
}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v("My Account")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-font-size-20--md g-font-size-17 g-color-primary--hover g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eeb279d4", module.exports)
  }
}

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isAddModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Add Eye Doctor Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("NPI Number\n                                    "), (!_vm.NewDoctor.useLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.npiNumber),
      expression: "NewDoctor.npiNumber"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorNpiNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.NewDoctor.npiNumber)
    },
    on: {
      "paste": function($event) {
        return _vm.pasteNpiNumber($event)
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event);
      },
      "keyup": function($event) {
        return _vm.ValidateNpiNumberEyeDoctor()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "npiNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorNpiNumber))]) : _vm._e(), _vm._v(" "), (_vm.invalidNpiNumberPaste) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("Sorry, only numeric NPI values can be pasted here.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.useLicenseNumber),
      expression: "NewDoctor.useLicenseNumber"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.NewDoctor.useLicenseNumber) ? _vm._i(_vm.NewDoctor.useLicenseNumber, "") > -1 : (_vm.NewDoctor.useLicenseNumber)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.NewDoctor.useLicenseNumber,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.NewDoctor, "useLicenseNumber", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.NewDoctor, "useLicenseNumber", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.NewDoctor, "useLicenseNumber", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Use License Number")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Relationship*\n                                          "), _c('span', {
    attrs: {
      "data-balloon": _vm.relationshipTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.Role),
      expression: "NewDoctor.Role"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorRole
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewDoctor, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorRole) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorRole))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.firstName),
      expression: "NewDoctor.firstName"
    }],
    staticClass: "form-control input_field capitalize",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.NewDoctor.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.lastName),
      expression: "NewDoctor.lastName"
    }],
    staticClass: "form-control input_field capitalize",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.NewDoctor.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suffix*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.suffix),
      expression: "NewDoctor.suffix"
    }],
    staticClass: "form-control select_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorSuffix
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewDoctor, "suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.Suffix), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorSuffix) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorSuffix))]) : _vm._e()])])])])]), _vm._v(" "), (_vm.NewDoctor.useLicenseNumber) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("License Number *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.licenseNumber),
      expression: "NewDoctor.licenseNumber"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorLicenseNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.NewDoctor.licenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "licenseNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorLicenseNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorLicenseNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.state),
      expression: "NewDoctor.state"
    }],
    staticClass: "form-control select_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorState
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewDoctor, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorState))]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Year Licensed")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.yearsInPractice),
      expression: "NewDoctor.yearsInPractice"
    }],
    staticClass: "form-control input_field",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.NewDoctor.yearsInPractice)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.G_NumberOfYearsCheck(_vm.NewDoctor, 'yearsInPractice')
      },
      "blur": function($event) {
        return _vm.CheckYearLicense(_vm.NewDoctor.yearsInPractice)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "yearsInPractice", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorYearsInPractice) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorYearsInPractice))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.emailAddress),
      expression: "NewDoctor.emailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorEmailAddress
    },
    attrs: {
      "name": "email",
      "type": "email",
      "data-vv-as": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.NewDoctor.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "emailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email') && !_vm.NewDoctorValidationResult.EyeDoctorEmailAddress),
      expression: "errors.has('email') && !NewDoctorValidationResult.EyeDoctorEmailAddress"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorEmailAddress))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.CheckboxIndividual), function(value, key) {
    return _c('div', {
      staticClass: "form-check"
    }, [_c('p', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.NewDoctor.organizations.list),
        expression: "NewDoctor.organizations.list"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.NewDoctor.organizations.list) ? _vm._i(_vm.NewDoctor.organizations.list, key) > -1 : (_vm.NewDoctor.organizations.list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.NewDoctor.organizations.list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.NewDoctor.organizations, "list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.NewDoctor.organizations, "list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.NewDoctor.organizations, "list", $$c)
          }
        }
      }
    }), _vm._v("\n                                          " + _vm._s(key) + "\n                                       ")])])
  }), _vm._v(" "), (_vm.NewDoctor.organizations.list.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Please enter any other professional organizations you are associated with separated by semicolon(;).")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.organizations.others),
      expression: "NewDoctor.organizations.others"
    }],
    staticClass: "form-control input_field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.NewDoctor.organizations.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor.organizations, "others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-mx-10 g-my-10 g-font-size-17 g-px-40",
    on: {
      "click": function($event) {
        return _vm.AddThisDoctor()
      }
    }
  }, [_vm._v("Add This Doctor")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-mx-10 g-my-10 g-font-size-17 g-px-40",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("NPI Number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("License Number/State:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Year Licensed:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Doctor's Email Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations:")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f4f619e0", module.exports)
  }
}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("build number: 5.5")]), _vm._v(" "), _c('p', [_vm._v("hotfix for adress")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f9558ce8", module.exports)
  }
}

/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("0a89109e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0279f276\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserAccount.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0279f276\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserAccount.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(332);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("3b129841", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1cca75d2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HomeBlock.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1cca75d2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HomeBlock.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(333);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("04b106dc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ce8a543\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderTrackingFilters.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ce8a543\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderTrackingFilters.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(334);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("6939ca50", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ec4fedc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FooterComponent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ec4fedc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FooterComponent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(335);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("17db9b8f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3bfda0a7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ExamSummary.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3bfda0a7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ExamSummary.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(336);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("77da5504", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-417ef92c\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-417ef92c\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(337);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("5b8a9cd4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42db20d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RxInput.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42db20d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RxInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(338);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("31fcc425", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47870908\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderSummary.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47870908\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderSummary.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(339);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("1780160e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4bc74044\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LogIn.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4bc74044\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LogIn.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(340);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("1b93e1cd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a68a028a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RegistrationSummary.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a68a028a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RegistrationSummary.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(341);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("ae8f9a00", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b61c92e0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JotformModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b61c92e0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JotformModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(342);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(12)("65f9f328", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cc0229ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HeaderComponent.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cc0229ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HeaderComponent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[278]);


// WEBPACK FOOTER //
// static/js/app.8a1134f8637419e26a1d.js